(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode("._unmatchedHeader_qcj19_1{opacity:.55}._wrapper_1lmim_1{margin-bottom:var(--dixa-size-spacer-300)}._wrapperBox_1lmim_4{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._wrapperBoxErrorBorder_1lmim_9{border-color:var(--dixa-typography-color-error)}")),document.head.appendChild(r)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { isRunningLocalPartnerApi as a0, getPartnerDevApiHeaders as o0, WidgetContextProvider as s0, makeExecuteQuery as l0, makeUseLazyQuery as c0, makeUseQuery as d0, makeUseMutation as u0, validateApiHostName as Hb, useTracking as _n, useWidgetContext as hn, hasDownstreamApiForbiddenError as Vm, hasDownstreamApiAuthorizationError as zm, DisplayErrors as Fn, useCopyWithDelay as or, defaultDateFormat as xt, displayAttributeValue as po, OAuthSettings as Lr, useWidgetSettingsMutations as ji, useWidgetSettingsQuery as wi, useRenderConditions as Ci, PartnerSettingsWrapper as Fi, handleWidgetSubmit as Ii, MisconfigurationBanner as Ei, WidgetSettingsFormFooter as Ti, useData as Um, PartnerHookFormSecretText as Mm, isDownstreamApiNotFoundError as m0, isDownstreamApiAuthorizationError as Wb, KlaviyoSubscribeSetting as p0, isDownstreamApiPermissionError as f0, capitalizeFirstCharacter as Gb, humanizeKey as h0, hasDownstreamApiTooManyRequestsError as y0, hasDownstreamApiPermissionError as Kb, PartnerHookFormBasicAuth as g0, hasDownstreamApiNotFoundError as vo, getCountryNameFromCountryCode as v0, IntegrationModal as Yb, useInboundOAuthContext as k0, getWidgetConfigurationByIdQuery as b0, createWidgetConfigurationMutation as x0, updateWidgetConfigurationMutation as _0, deleteWidgetConfigurationMutation as S0 } from "lib-integrations-partner-support";
export * from "lib-integrations-partner-support";
import Fe, { useMemo as Bn, useState as le, useEffect as He, useRef as ki, useCallback as ot, useReducer as N0, useLayoutEffect as j0, useContext as Bm, createContext as Qb, isValidElement as w0, createElement as C0, Fragment as F0 } from "react";
import { Text as P, FlexBox as b, Spinner as un, Icon as pe, Tooltip as We, List as Ye, Badge as An, Button as Gn, IconButton as nr, Switch as im, FieldLabel as I0, FieldWrapper as ln, InputText as Nr, InputSelectionList as ni, FormGrid as st, FormField as be, Tag as Pn, NavigationButton as Et, Select as wr, CollapseCard as mr, Box as et, Modal as Tt, ModalHead as $t, ModalBody as Dt, ModalFoot as At, Textarea as am, TagsInput as Ws, Image as la, Banner as Gs, Divider as qm, SelectionList as ut, FieldText as pr, FieldTextarea as E0, CopyToClipboardButton as T0, getSelectionListContext as $0, Avatar as Hm, Timestamp as D0, Attachment as R0, EmptyState as Ns, Table as Xn, Checkbox as cf, TextWithHighlight as O0, ErrorBoundaryContext as Jb, FieldSwitch as Xb } from "@dixa/lib-shared-habla";
import it from "classnames";
import { ApolloLink as Wm, Observable as Zb, ApolloClient as A0, InMemoryCache as P0, createHttpLink as L0, ApolloProvider as V0, useApolloClient as z0, ApolloConsumer as U0, NetworkStatus as er, isApolloError as ex, ApolloError as nx, gql as Ks, useQuery as M0, useMutation as df } from "@apollo/client";
import B0 from "cross-fetch";
import { config as fo } from "lib-shared-backend-config";
import Ln from "moment";
import "moment-timezone";
import { __rest as q0, __assign as yl } from "tslib";
import { useLocation as H0 } from "react-router-dom";
function Gm(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var $o = { exports: {} }, ya = {};
var uf;
function W0() {
  if (uf) return ya;
  uf = 1;
  var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return ya.Fragment = r, ya.jsx = s, ya.jsxs = s, ya;
}
var ga = {};
var mf;
function G0() {
  return mf || (mf = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        z("error", t, p);
      }
    }
    function z(t, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, A = v.getStackAddendum();
        A !== "" && (c += "%s", p = p.concat([A]));
        var L = p.map(function(F) {
          return String(F);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, I = !1, T = !1, U = !1, Q = !1, J;
    J = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === u || U || t === g || $ || I || T || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function X(t, c, p) {
      var v = t.displayName;
      if (v)
        return v;
      var A = c.displayName || c.name || "";
      return A !== "" ? p + "(" + A + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return X(t, t.render, "ForwardRef");
          case f:
            var v = t.displayName || null;
            return v !== null ? v : O(t.type) || "Memo";
          case h: {
            var A = t, L = A._payload, F = A._init;
            try {
              return O(F(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, ue, ce, fe, W, xe, Ie;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ve = console.log, ue = console.info, ce = console.warn, fe = console.error, W = console.group, xe = console.groupCollapsed, Ie = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: ue
            }),
            warn: q({}, t, {
              value: ce
            }),
            error: q({}, t, {
              value: fe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: xe
            }),
            groupEnd: q({}, t, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Me;
    function $e(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (A) {
            var v = A.stack.trim().match(/\n( *(at )?)/);
            Me = v && v[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var ze = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(t, c) {
      if (!t || ze)
        return "";
      {
        var p = Re.get(t);
        if (p !== void 0)
          return p;
      }
      var v;
      ze = !0;
      var A = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, qe();
      try {
        if (c) {
          var F = function() {
            throw Error();
          };
          if (Object.defineProperty(F.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(F, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(t, [], F);
          } else {
            try {
              F.call();
            } catch (ne) {
              v = ne;
            }
            t.call(F.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), G = j.length - 1, _ = te.length - 1; G >= 1 && _ >= 0 && j[G] !== te[_]; )
            _--;
          for (; G >= 1 && _ >= 0; G--, _--)
            if (j[G] !== te[_]) {
              if (G !== 1 || _ !== 1)
                do
                  if (G--, _--, _ < 0 || j[G] !== te[_]) {
                    var Z = `
` + j[G].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (G >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Oe.current = L, Be(), Error.prepareStackTrace = A;
      }
      var de = t ? t.displayName || t.name : "", Se = de ? $e(de) : "";
      return typeof t == "function" && Re.set(t, Se), Se;
    }
    function Ge(t, c, p) {
      return Ee(t, !1);
    }
    function Qe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function he(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Qe(t));
      if (typeof t == "string")
        return $e(t);
      switch (t) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ge(t.render);
          case f:
            return he(t.type, c, p);
          case h: {
            var v = t, A = v._payload, L = v._init;
            try {
              return he(L(A), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, De = {}, Le = w.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = he(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(t, c, p, v, A) {
      {
        var L = Function.call.bind(ge);
        for (var F in t)
          if (L(t, F)) {
            var j = void 0;
            try {
              if (typeof t[F] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + F + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[F] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[F](c, F, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (G) {
              j = G;
            }
            j && !(j instanceof Error) && (Ae(A), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, F, typeof j), Ae(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Ae(A), y("Failed %s type: %s", p, j.message), Ae(null));
          }
      }
    }
    var E = Array.isArray;
    function x(t) {
      return E(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var V = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, me, Ne;
    function nn(t) {
      if (ge.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function fn(t) {
      if (ge.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && V.current;
    }
    function cn(t, c) {
      {
        var p = function() {
          me || (me = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(t, c, p, v, A, L, F) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: F,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: A
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, v, A) {
      {
        var L, F = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), fn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c, A));
        for (L in c)
          ge.call(c, L) && !ie.hasOwnProperty(L) && (F[L] = c[L]);
        if (t && t.defaultProps) {
          var G = t.defaultProps;
          for (L in G)
            F[L] === void 0 && (F[L] = G[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && cn(F, _), te && pn(F, _);
        }
        return dn(t, j, te, A, v, V.current, F);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = he(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var t = O(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        t && t._owner && t._owner !== en.current && (v = " It was passed a child from " + O(t._owner.type) + "."), Pe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Pe(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var v = t[p];
            sn(v) && gn(v, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var A = N(t);
          if (typeof A == "function" && A !== t.entries)
            for (var L = A.call(t), F; !(F = L.next()).done; )
              sn(F.value) && gn(F.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          mn(p, t.props, "prop", v, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var A = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", A || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Pe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Pe(null);
            break;
          }
        }
        t.ref !== null && (Pe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Pe(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, v, A, L) {
      {
        var F = ae(t);
        if (!F) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var G;
          t === null ? G = "null" : x(t) ? G = "array" : t !== void 0 && t.$$typeof === n ? (G = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : G = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", G, j);
        }
        var _ = xn(t, c, p, A, L);
        if (_ == null)
          return _;
        if (F) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var de = 0; de < Z.length; de++)
                  Cn(Z[de], t);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, t);
        }
        if (ge.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, Se, $n, Se), Sn[Se + Ke] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    ga.Fragment = i, ga.jsx = Rn, ga.jsxs = Mn;
  })()), ga;
}
var pf;
function K0() {
  return pf || (pf = 1, process.env.NODE_ENV === "production" ? $o.exports = W0() : $o.exports = G0()), $o.exports;
}
var Ve = K0();
function tx(e, n) {
  return function() {
    return e.apply(n, arguments);
  };
}
const { toString: Y0 } = Object.prototype, { getPrototypeOf: Ys } = Object, { iterator: Qs, toStringTag: rx } = Symbol, Js = /* @__PURE__ */ ((e) => (n) => {
  const r = Y0.call(n);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Cr = (e) => (e = e.toLowerCase(), (n) => Js(n) === e), Xs = (e) => (n) => typeof n === e, { isArray: ca } = Array, ra = Xs("undefined");
function ko(e) {
  return e !== null && !ra(e) && e.constructor !== null && !ra(e.constructor) && Jt(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const ix = Cr("ArrayBuffer");
function Q0(e) {
  let n;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(e) : n = e && e.buffer && ix(e.buffer), n;
}
const J0 = Xs("string"), Jt = Xs("function"), ax = Xs("number"), bo = (e) => e !== null && typeof e == "object", X0 = (e) => e === !0 || e === !1, cs = (e) => {
  if (Js(e) !== "object")
    return !1;
  const n = Ys(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(rx in e) && !(Qs in e);
}, Z0 = (e) => {
  if (!bo(e) || ko(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, eN = Cr("Date"), nN = Cr("File"), tN = (e) => !!(e && typeof e.uri < "u"), rN = (e) => e && typeof e.getParts < "u", iN = Cr("Blob"), aN = Cr("FileList"), oN = (e) => bo(e) && Jt(e.pipe);
function sN() {
  return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
}
const ff = sN(), hf = typeof ff.FormData < "u" ? ff.FormData : void 0, lN = (e) => {
  if (!e) return !1;
  if (hf && e instanceof hf) return !0;
  const n = Ys(e);
  if (!n || n === Object.prototype || !Jt(e.append)) return !1;
  const r = Js(e);
  return r === "formdata" || // detect form-data instance
  r === "object" && Jt(e.toString) && e.toString() === "[object FormData]";
}, cN = Cr("URLSearchParams"), [dN, uN, mN, pN] = [
  "ReadableStream",
  "Request",
  "Response",
  "Headers"
].map(Cr), fN = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function xo(e, n, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let i, a;
  if (typeof e != "object" && (e = [e]), ca(e))
    for (i = 0, a = e.length; i < a; i++)
      n.call(null, e[i], i, e);
  else {
    if (ko(e))
      return;
    const o = r ? Object.getOwnPropertyNames(e) : Object.keys(e), s = o.length;
    let l;
    for (i = 0; i < s; i++)
      l = o[i], n.call(null, e[l], l, e);
  }
}
function ox(e, n) {
  if (ko(e))
    return null;
  n = n.toLowerCase();
  const r = Object.keys(e);
  let i = r.length, a;
  for (; i-- > 0; )
    if (a = r[i], n === a.toLowerCase())
      return a;
  return null;
}
const hi = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, sx = (e) => !ra(e) && e !== hi;
function om() {
  const { caseless: e, skipUndefined: n } = sx(this) && this || {}, r = {}, i = (a, o) => {
    if (o === "__proto__" || o === "constructor" || o === "prototype")
      return;
    const s = e && ox(r, o) || o;
    cs(r[s]) && cs(a) ? r[s] = om(r[s], a) : cs(a) ? r[s] = om({}, a) : ca(a) ? r[s] = a.slice() : (!n || !ra(a)) && (r[s] = a);
  };
  for (let a = 0, o = arguments.length; a < o; a++)
    arguments[a] && xo(arguments[a], i);
  return r;
}
const hN = (e, n, r, { allOwnKeys: i } = {}) => (xo(
  n,
  (a, o) => {
    r && Jt(a) ? Object.defineProperty(e, o, {
      value: tx(a, r),
      writable: !0,
      enumerable: !0,
      configurable: !0
    }) : Object.defineProperty(e, o, {
      value: a,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  },
  { allOwnKeys: i }
), e), yN = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), gN = (e, n, r, i) => {
  e.prototype = Object.create(n.prototype, i), Object.defineProperty(e.prototype, "constructor", {
    value: e,
    writable: !0,
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e, "super", {
    value: n.prototype
  }), r && Object.assign(e.prototype, r);
}, vN = (e, n, r, i) => {
  let a, o, s;
  const l = {};
  if (n = n || {}, e == null) return n;
  do {
    for (a = Object.getOwnPropertyNames(e), o = a.length; o-- > 0; )
      s = a[o], (!i || i(s, e, n)) && !l[s] && (n[s] = e[s], l[s] = !0);
    e = r !== !1 && Ys(e);
  } while (e && (!r || r(e, n)) && e !== Object.prototype);
  return n;
}, kN = (e, n, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= n.length;
  const i = e.indexOf(n, r);
  return i !== -1 && i === r;
}, bN = (e) => {
  if (!e) return null;
  if (ca(e)) return e;
  let n = e.length;
  if (!ax(n)) return null;
  const r = new Array(n);
  for (; n-- > 0; )
    r[n] = e[n];
  return r;
}, xN = /* @__PURE__ */ ((e) => (n) => e && n instanceof e)(typeof Uint8Array < "u" && Ys(Uint8Array)), _N = (e, n) => {
  const i = (e && e[Qs]).call(e);
  let a;
  for (; (a = i.next()) && !a.done; ) {
    const o = a.value;
    n.call(e, o[0], o[1]);
  }
}, SN = (e, n) => {
  let r;
  const i = [];
  for (; (r = e.exec(n)) !== null; )
    i.push(r);
  return i;
}, NN = Cr("HTMLFormElement"), jN = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(r, i, a) {
  return i.toUpperCase() + a;
}), yf = (({ hasOwnProperty: e }) => (n, r) => e.call(n, r))(Object.prototype), wN = Cr("RegExp"), lx = (e, n) => {
  const r = Object.getOwnPropertyDescriptors(e), i = {};
  xo(r, (a, o) => {
    let s;
    (s = n(a, o, e)) !== !1 && (i[o] = s || a);
  }), Object.defineProperties(e, i);
}, CN = (e) => {
  lx(e, (n, r) => {
    if (Jt(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const i = e[r];
    if (Jt(i)) {
      if (n.enumerable = !1, "writable" in n) {
        n.writable = !1;
        return;
      }
      n.set || (n.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, FN = (e, n) => {
  const r = {}, i = (a) => {
    a.forEach((o) => {
      r[o] = !0;
    });
  };
  return ca(e) ? i(e) : i(String(e).split(n)), r;
}, IN = () => {
}, EN = (e, n) => e != null && Number.isFinite(e = +e) ? e : n;
function TN(e) {
  return !!(e && Jt(e.append) && e[rx] === "FormData" && e[Qs]);
}
const $N = (e) => {
  const n = new Array(10), r = (i, a) => {
    if (bo(i)) {
      if (n.indexOf(i) >= 0)
        return;
      if (ko(i))
        return i;
      if (!("toJSON" in i)) {
        n[a] = i;
        const o = ca(i) ? [] : {};
        return xo(i, (s, l) => {
          const d = r(s, a + 1);
          !ra(d) && (o[l] = d);
        }), n[a] = void 0, o;
      }
    }
    return i;
  };
  return r(e, 0);
}, DN = Cr("AsyncFunction"), RN = (e) => e && (bo(e) || Jt(e)) && Jt(e.then) && Jt(e.catch), cx = ((e, n) => e ? setImmediate : n ? ((r, i) => (hi.addEventListener(
  "message",
  ({ source: a, data: o }) => {
    a === hi && o === r && i.length && i.shift()();
  },
  !1
), (a) => {
  i.push(a), hi.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(typeof setImmediate == "function", Jt(hi.postMessage)), ON = typeof queueMicrotask < "u" ? queueMicrotask.bind(hi) : typeof process < "u" && process.nextTick || cx, AN = (e) => e != null && Jt(e[Qs]), ke = {
  isArray: ca,
  isArrayBuffer: ix,
  isBuffer: ko,
  isFormData: lN,
  isArrayBufferView: Q0,
  isString: J0,
  isNumber: ax,
  isBoolean: X0,
  isObject: bo,
  isPlainObject: cs,
  isEmptyObject: Z0,
  isReadableStream: dN,
  isRequest: uN,
  isResponse: mN,
  isHeaders: pN,
  isUndefined: ra,
  isDate: eN,
  isFile: nN,
  isReactNativeBlob: tN,
  isReactNative: rN,
  isBlob: iN,
  isRegExp: wN,
  isFunction: Jt,
  isStream: oN,
  isURLSearchParams: cN,
  isTypedArray: xN,
  isFileList: aN,
  forEach: xo,
  merge: om,
  extend: hN,
  trim: fN,
  stripBOM: yN,
  inherits: gN,
  toFlatObject: vN,
  kindOf: Js,
  kindOfTest: Cr,
  endsWith: kN,
  toArray: bN,
  forEachEntry: _N,
  matchAll: SN,
  isHTMLForm: NN,
  hasOwnProperty: yf,
  hasOwnProp: yf,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: lx,
  freezeMethods: CN,
  toObjectSet: FN,
  toCamelCase: jN,
  noop: IN,
  toFiniteNumber: EN,
  findKey: ox,
  global: hi,
  isContextDefined: sx,
  isSpecCompliantForm: TN,
  toJSONObject: $N,
  isAsyncFn: DN,
  isThenable: RN,
  setImmediate: cx,
  asap: ON,
  isIterable: AN
};
let yn = class dx extends Error {
  static from(n, r, i, a, o, s) {
    const l = new dx(n.message, r || n.code, i, a, o);
    return l.cause = n, l.name = n.name, n.status != null && l.status == null && (l.status = n.status), s && Object.assign(l, s), l;
  }
  /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */
  constructor(n, r, i, a, o) {
    super(n), Object.defineProperty(this, "message", {
      value: n,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }), this.name = "AxiosError", this.isAxiosError = !0, r && (this.code = r), i && (this.config = i), a && (this.request = a), o && (this.response = o, this.status = o.status);
  }
  toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: ke.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
};
yn.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
yn.ERR_BAD_OPTION = "ERR_BAD_OPTION";
yn.ECONNABORTED = "ECONNABORTED";
yn.ETIMEDOUT = "ETIMEDOUT";
yn.ERR_NETWORK = "ERR_NETWORK";
yn.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
yn.ERR_DEPRECATED = "ERR_DEPRECATED";
yn.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
yn.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
yn.ERR_CANCELED = "ERR_CANCELED";
yn.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
yn.ERR_INVALID_URL = "ERR_INVALID_URL";
yn.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
const PN = null;
function sm(e) {
  return ke.isPlainObject(e) || ke.isArray(e);
}
function ux(e) {
  return ke.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function gl(e, n, r) {
  return e ? e.concat(n).map(function(a, o) {
    return a = ux(a), !r && o ? "[" + a + "]" : a;
  }).join(r ? "." : "") : n;
}
function LN(e) {
  return ke.isArray(e) && !e.some(sm);
}
const VN = ke.toFlatObject(ke, {}, null, function(n) {
  return /^is[A-Z]/.test(n);
});
function Zs(e, n, r) {
  if (!ke.isObject(e))
    throw new TypeError("target must be an object");
  n = n || new FormData(), r = ke.toFlatObject(
    r,
    {
      metaTokens: !0,
      dots: !1,
      indexes: !1
    },
    !1,
    function(N, w) {
      return !ke.isUndefined(w[N]);
    }
  );
  const i = r.metaTokens, a = r.visitor || f, o = r.dots, s = r.indexes, l = r.Blob || typeof Blob < "u" && Blob, d = r.maxDepth === void 0 ? 100 : r.maxDepth, m = l && ke.isSpecCompliantForm(n);
  if (!ke.isFunction(a))
    throw new TypeError("visitor must be a function");
  function u(S) {
    if (S === null) return "";
    if (ke.isDate(S))
      return S.toISOString();
    if (ke.isBoolean(S))
      return S.toString();
    if (!m && ke.isBlob(S))
      throw new yn("Blob is not supported. Use a Buffer instead.");
    return ke.isArrayBuffer(S) || ke.isTypedArray(S) ? m && typeof Blob == "function" ? new Blob([S]) : Buffer.from(S) : S;
  }
  function f(S, N, w) {
    let y = S;
    if (ke.isReactNative(n) && ke.isReactNativeBlob(S))
      return n.append(gl(w, N, o), u(S)), !1;
    if (S && !w && typeof S == "object") {
      if (ke.endsWith(N, "{}"))
        N = i ? N : N.slice(0, -2), S = JSON.stringify(S);
      else if (ke.isArray(S) && LN(S) || (ke.isFileList(S) || ke.endsWith(N, "[]")) && (y = ke.toArray(S)))
        return N = ux(N), y.forEach(function($, I) {
          !(ke.isUndefined($) || $ === null) && n.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? gl([N], I, o) : s === null ? N : N + "[]",
            u($)
          );
        }), !1;
    }
    return sm(S) ? !0 : (n.append(gl(w, N, o), u(S)), !1);
  }
  const h = [], g = Object.assign(VN, {
    defaultVisitor: f,
    convertValue: u,
    isVisitable: sm
  });
  function C(S, N, w = 0) {
    if (!ke.isUndefined(S)) {
      if (w > d)
        throw new yn(
          "Object is too deeply nested (" + w + " levels). Max depth: " + d,
          yn.ERR_FORM_DATA_DEPTH_EXCEEDED
        );
      if (h.indexOf(S) !== -1)
        throw Error("Circular reference detected in " + N.join("."));
      h.push(S), ke.forEach(S, function(z, $) {
        (!(ke.isUndefined(z) || z === null) && a.call(n, z, ke.isString($) ? $.trim() : $, N, g)) === !0 && C(z, N ? N.concat($) : [$], w + 1);
      }), h.pop();
    }
  }
  if (!ke.isObject(e))
    throw new TypeError("data must be an object");
  return C(e), n;
}
function gf(e) {
  const n = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20/g, function(i) {
    return n[i];
  });
}
function Km(e, n) {
  this._pairs = [], e && Zs(e, this, n);
}
const mx = Km.prototype;
mx.append = function(n, r) {
  this._pairs.push([n, r]);
};
mx.toString = function(n) {
  const r = n ? function(i) {
    return n.call(this, i, gf);
  } : gf;
  return this._pairs.map(function(a) {
    return r(a[0]) + "=" + r(a[1]);
  }, "").join("&");
};
function zN(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function px(e, n, r) {
  if (!n)
    return e;
  const i = r && r.encode || zN, a = ke.isFunction(r) ? {
    serialize: r
  } : r, o = a && a.serialize;
  let s;
  if (o ? s = o(n, a) : s = ke.isURLSearchParams(n) ? n.toString() : new Km(n, a).toString(i), s) {
    const l = e.indexOf("#");
    l !== -1 && (e = e.slice(0, l)), e += (e.indexOf("?") === -1 ? "?" : "&") + s;
  }
  return e;
}
class vf {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(n, r, i) {
    return this.handlers.push({
      fulfilled: n,
      rejected: r,
      synchronous: i ? i.synchronous : !1,
      runWhen: i ? i.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(n) {
    this.handlers[n] && (this.handlers[n] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(n) {
    ke.forEach(this.handlers, function(i) {
      i !== null && n(i);
    });
  }
}
const Ym = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1,
  legacyInterceptorReqResOrdering: !0
}, UN = typeof URLSearchParams < "u" ? URLSearchParams : Km, MN = typeof FormData < "u" ? FormData : null, BN = typeof Blob < "u" ? Blob : null, qN = {
  isBrowser: !0,
  classes: {
    URLSearchParams: UN,
    FormData: MN,
    Blob: BN
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Qm = typeof window < "u" && typeof document < "u", lm = typeof navigator == "object" && navigator || void 0, HN = Qm && (!lm || ["ReactNative", "NativeScript", "NS"].indexOf(lm.product) < 0), WN = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", GN = Qm && window.location.href || "http://localhost", KN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Qm,
  hasStandardBrowserEnv: HN,
  hasStandardBrowserWebWorkerEnv: WN,
  navigator: lm,
  origin: GN
}, Symbol.toStringTag, { value: "Module" })), Rt = {
  ...KN,
  ...qN
};
function YN(e, n) {
  return Zs(e, new Rt.classes.URLSearchParams(), {
    visitor: function(r, i, a, o) {
      return Rt.isNode && ke.isBuffer(r) ? (this.append(i, r.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    },
    ...n
  });
}
function QN(e) {
  return ke.matchAll(/\w+|\[(\w*)]/g, e).map((n) => n[0] === "[]" ? "" : n[1] || n[0]);
}
function JN(e) {
  const n = {}, r = Object.keys(e);
  let i;
  const a = r.length;
  let o;
  for (i = 0; i < a; i++)
    o = r[i], n[o] = e[o];
  return n;
}
function fx(e) {
  function n(r, i, a, o) {
    let s = r[o++];
    if (s === "__proto__") return !0;
    const l = Number.isFinite(+s), d = o >= r.length;
    return s = !s && ke.isArray(a) ? a.length : s, d ? (ke.hasOwnProp(a, s) ? a[s] = ke.isArray(a[s]) ? a[s].concat(i) : [a[s], i] : a[s] = i, !l) : ((!a[s] || !ke.isObject(a[s])) && (a[s] = []), n(r, i, a[s], o) && ke.isArray(a[s]) && (a[s] = JN(a[s])), !l);
  }
  if (ke.isFormData(e) && ke.isFunction(e.entries)) {
    const r = {};
    return ke.forEachEntry(e, (i, a) => {
      n(QN(i), a, r, 0);
    }), r;
  }
  return null;
}
const Pi = (e, n) => e != null && ke.hasOwnProp(e, n) ? e[n] : void 0;
function XN(e, n, r) {
  if (ke.isString(e))
    try {
      return (n || JSON.parse)(e), ke.trim(e);
    } catch (i) {
      if (i.name !== "SyntaxError")
        throw i;
    }
  return (r || JSON.stringify)(e);
}
const _o = {
  transitional: Ym,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [
    function(n, r) {
      const i = r.getContentType() || "", a = i.indexOf("application/json") > -1, o = ke.isObject(n);
      if (o && ke.isHTMLForm(n) && (n = new FormData(n)), ke.isFormData(n))
        return a ? JSON.stringify(fx(n)) : n;
      if (ke.isArrayBuffer(n) || ke.isBuffer(n) || ke.isStream(n) || ke.isFile(n) || ke.isBlob(n) || ke.isReadableStream(n))
        return n;
      if (ke.isArrayBufferView(n))
        return n.buffer;
      if (ke.isURLSearchParams(n))
        return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
      let l;
      if (o) {
        const d = Pi(this, "formSerializer");
        if (i.indexOf("application/x-www-form-urlencoded") > -1)
          return YN(n, d).toString();
        if ((l = ke.isFileList(n)) || i.indexOf("multipart/form-data") > -1) {
          const m = Pi(this, "env"), u = m && m.FormData;
          return Zs(
            l ? { "files[]": n } : n,
            u && new u(),
            d
          );
        }
      }
      return o || a ? (r.setContentType("application/json", !1), XN(n)) : n;
    }
  ],
  transformResponse: [
    function(n) {
      const r = Pi(this, "transitional") || _o.transitional, i = r && r.forcedJSONParsing, a = Pi(this, "responseType"), o = a === "json";
      if (ke.isResponse(n) || ke.isReadableStream(n))
        return n;
      if (n && ke.isString(n) && (i && !a || o)) {
        const l = !(r && r.silentJSONParsing) && o;
        try {
          return JSON.parse(n, Pi(this, "parseReviver"));
        } catch (d) {
          if (l)
            throw d.name === "SyntaxError" ? yn.from(d, yn.ERR_BAD_RESPONSE, this, null, Pi(this, "response")) : d;
        }
      }
      return n;
    }
  ],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Rt.classes.FormData,
    Blob: Rt.classes.Blob
  },
  validateStatus: function(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
ke.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  _o.headers[e] = {};
});
const ZN = ke.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), ej = (e) => {
  const n = {};
  let r, i, a;
  return e && e.split(`
`).forEach(function(s) {
    a = s.indexOf(":"), r = s.substring(0, a).trim().toLowerCase(), i = s.substring(a + 1).trim(), !(!r || n[r] && ZN[r]) && (r === "set-cookie" ? n[r] ? n[r].push(i) : n[r] = [i] : n[r] = n[r] ? n[r] + ", " + i : i);
  }), n;
}, kf = Symbol("internals"), nj = /[^\x09\x20-\x7E\x80-\xFF]/g;
function tj(e) {
  let n = 0, r = e.length;
  for (; n < r; ) {
    const i = e.charCodeAt(n);
    if (i !== 9 && i !== 32)
      break;
    n += 1;
  }
  for (; r > n; ) {
    const i = e.charCodeAt(r - 1);
    if (i !== 9 && i !== 32)
      break;
    r -= 1;
  }
  return n === 0 && r === e.length ? e : e.slice(n, r);
}
function va(e) {
  return e && String(e).trim().toLowerCase();
}
function rj(e) {
  return tj(e.replace(nj, ""));
}
function ds(e) {
  return e === !1 || e == null ? e : ke.isArray(e) ? e.map(ds) : rj(String(e));
}
function ij(e) {
  const n = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let i;
  for (; i = r.exec(e); )
    n[i[1]] = i[2];
  return n;
}
const aj = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function vl(e, n, r, i, a) {
  if (ke.isFunction(i))
    return i.call(this, n, r);
  if (a && (n = r), !!ke.isString(n)) {
    if (ke.isString(i))
      return n.indexOf(i) !== -1;
    if (ke.isRegExp(i))
      return i.test(n);
  }
}
function oj(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (n, r, i) => r.toUpperCase() + i);
}
function sj(e, n) {
  const r = ke.toCamelCase(" " + n);
  ["get", "set", "has"].forEach((i) => {
    Object.defineProperty(e, i + r, {
      value: function(a, o, s) {
        return this[i].call(this, n, a, o, s);
      },
      configurable: !0
    });
  });
}
let Xt = class {
  constructor(n) {
    n && this.set(n);
  }
  set(n, r, i) {
    const a = this;
    function o(l, d, m) {
      const u = va(d);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const f = ke.findKey(a, u);
      (!f || a[f] === void 0 || m === !0 || m === void 0 && a[f] !== !1) && (a[f || d] = ds(l));
    }
    const s = (l, d) => ke.forEach(l, (m, u) => o(m, u, d));
    if (ke.isPlainObject(n) || n instanceof this.constructor)
      s(n, r);
    else if (ke.isString(n) && (n = n.trim()) && !aj(n))
      s(ej(n), r);
    else if (ke.isObject(n) && ke.isIterable(n)) {
      let l = {}, d, m;
      for (const u of n) {
        if (!ke.isArray(u))
          throw TypeError("Object iterator must return a key-value pair");
        l[m = u[0]] = (d = l[m]) ? ke.isArray(d) ? [...d, u[1]] : [d, u[1]] : u[1];
      }
      s(l, r);
    } else
      n != null && o(r, n, i);
    return this;
  }
  get(n, r) {
    if (n = va(n), n) {
      const i = ke.findKey(this, n);
      if (i) {
        const a = this[i];
        if (!r)
          return a;
        if (r === !0)
          return ij(a);
        if (ke.isFunction(r))
          return r.call(this, a, i);
        if (ke.isRegExp(r))
          return r.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(n, r) {
    if (n = va(n), n) {
      const i = ke.findKey(this, n);
      return !!(i && this[i] !== void 0 && (!r || vl(this, this[i], i, r)));
    }
    return !1;
  }
  delete(n, r) {
    const i = this;
    let a = !1;
    function o(s) {
      if (s = va(s), s) {
        const l = ke.findKey(i, s);
        l && (!r || vl(i, i[l], l, r)) && (delete i[l], a = !0);
      }
    }
    return ke.isArray(n) ? n.forEach(o) : o(n), a;
  }
  clear(n) {
    const r = Object.keys(this);
    let i = r.length, a = !1;
    for (; i--; ) {
      const o = r[i];
      (!n || vl(this, this[o], o, n, !0)) && (delete this[o], a = !0);
    }
    return a;
  }
  normalize(n) {
    const r = this, i = {};
    return ke.forEach(this, (a, o) => {
      const s = ke.findKey(i, o);
      if (s) {
        r[s] = ds(a), delete r[o];
        return;
      }
      const l = n ? oj(o) : String(o).trim();
      l !== o && delete r[o], r[l] = ds(a), i[l] = !0;
    }), this;
  }
  concat(...n) {
    return this.constructor.concat(this, ...n);
  }
  toJSON(n) {
    const r = /* @__PURE__ */ Object.create(null);
    return ke.forEach(this, (i, a) => {
      i != null && i !== !1 && (r[a] = n && ke.isArray(i) ? i.join(", ") : i);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([n, r]) => n + ": " + r).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(n) {
    return n instanceof this ? n : new this(n);
  }
  static concat(n, ...r) {
    const i = new this(n);
    return r.forEach((a) => i.set(a)), i;
  }
  static accessor(n) {
    const i = (this[kf] = this[kf] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function o(s) {
      const l = va(s);
      i[l] || (sj(a, s), i[l] = !0);
    }
    return ke.isArray(n) ? n.forEach(o) : o(n), this;
  }
};
Xt.accessor([
  "Content-Type",
  "Content-Length",
  "Accept",
  "Accept-Encoding",
  "User-Agent",
  "Authorization"
]);
ke.reduceDescriptors(Xt.prototype, ({ value: e }, n) => {
  let r = n[0].toUpperCase() + n.slice(1);
  return {
    get: () => e,
    set(i) {
      this[r] = i;
    }
  };
});
ke.freezeMethods(Xt);
function kl(e, n) {
  const r = this || _o, i = n || r, a = Xt.from(i.headers);
  let o = i.data;
  return ke.forEach(e, function(l) {
    o = l.call(r, o, a.normalize(), n ? n.status : void 0);
  }), a.normalize(), o;
}
function hx(e) {
  return !!(e && e.__CANCEL__);
}
let So = class extends yn {
  /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */
  constructor(n, r, i) {
    super(n ?? "canceled", yn.ERR_CANCELED, r, i), this.name = "CanceledError", this.__CANCEL__ = !0;
  }
};
function yx(e, n, r) {
  const i = r.config.validateStatus;
  !r.status || !i || i(r.status) ? e(r) : n(
    new yn(
      "Request failed with status code " + r.status,
      [yn.ERR_BAD_REQUEST, yn.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
      r.config,
      r.request,
      r
    )
  );
}
function lj(e) {
  const n = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return n && n[1] || "";
}
function cj(e, n) {
  e = e || 10;
  const r = new Array(e), i = new Array(e);
  let a = 0, o = 0, s;
  return n = n !== void 0 ? n : 1e3, function(d) {
    const m = Date.now(), u = i[o];
    s || (s = m), r[a] = d, i[a] = m;
    let f = o, h = 0;
    for (; f !== a; )
      h += r[f++], f = f % e;
    if (a = (a + 1) % e, a === o && (o = (o + 1) % e), m - s < n)
      return;
    const g = u && m - u;
    return g ? Math.round(h * 1e3 / g) : void 0;
  };
}
function dj(e, n) {
  let r = 0, i = 1e3 / n, a, o;
  const s = (m, u = Date.now()) => {
    r = u, a = null, o && (clearTimeout(o), o = null), e(...m);
  };
  return [(...m) => {
    const u = Date.now(), f = u - r;
    f >= i ? s(m, u) : (a = m, o || (o = setTimeout(() => {
      o = null, s(a);
    }, i - f)));
  }, () => a && s(a)];
}
const js = (e, n, r = 3) => {
  let i = 0;
  const a = cj(50, 250);
  return dj((o) => {
    const s = o.loaded, l = o.lengthComputable ? o.total : void 0, d = l != null ? Math.min(s, l) : s, m = Math.max(0, d - i), u = a(m);
    i = Math.max(i, d);
    const f = {
      loaded: d,
      total: l,
      progress: l ? d / l : void 0,
      bytes: m,
      rate: u || void 0,
      estimated: u && l ? (l - d) / u : void 0,
      event: o,
      lengthComputable: l != null,
      [n ? "download" : "upload"]: !0
    };
    e(f);
  }, r);
}, bf = (e, n) => {
  const r = e != null;
  return [
    (i) => n[0]({
      lengthComputable: r,
      total: e,
      loaded: i
    }),
    n[1]
  ];
}, xf = (e) => (...n) => ke.asap(() => e(...n)), uj = Rt.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, n) => (r) => (r = new URL(r, Rt.origin), e.protocol === r.protocol && e.host === r.host && (n || e.port === r.port)))(
  new URL(Rt.origin),
  Rt.navigator && /(msie|trident)/i.test(Rt.navigator.userAgent)
) : () => !0, mj = Rt.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, n, r, i, a, o, s) {
      if (typeof document > "u") return;
      const l = [`${e}=${encodeURIComponent(n)}`];
      ke.isNumber(r) && l.push(`expires=${new Date(r).toUTCString()}`), ke.isString(i) && l.push(`path=${i}`), ke.isString(a) && l.push(`domain=${a}`), o === !0 && l.push("secure"), ke.isString(s) && l.push(`SameSite=${s}`), document.cookie = l.join("; ");
    },
    read(e) {
      if (typeof document > "u") return null;
      const n = document.cookie.match(new RegExp("(?:^|; )" + e + "=([^;]*)"));
      return n ? decodeURIComponent(n[1]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function pj(e) {
  return typeof e != "string" ? !1 : /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function fj(e, n) {
  return n ? e.replace(/\/?\/$/, "") + "/" + n.replace(/^\/+/, "") : e;
}
function gx(e, n, r) {
  let i = !pj(n);
  return e && (i || r === !1) ? fj(e, n) : n;
}
const _f = (e) => e instanceof Xt ? { ...e } : e;
function Ni(e, n) {
  n = n || {};
  const r = /* @__PURE__ */ Object.create(null);
  Object.defineProperty(r, "hasOwnProperty", {
    value: Object.prototype.hasOwnProperty,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
  function i(m, u, f, h) {
    return ke.isPlainObject(m) && ke.isPlainObject(u) ? ke.merge.call({ caseless: h }, m, u) : ke.isPlainObject(u) ? ke.merge({}, u) : ke.isArray(u) ? u.slice() : u;
  }
  function a(m, u, f, h) {
    if (ke.isUndefined(u)) {
      if (!ke.isUndefined(m))
        return i(void 0, m, f, h);
    } else return i(m, u, f, h);
  }
  function o(m, u) {
    if (!ke.isUndefined(u))
      return i(void 0, u);
  }
  function s(m, u) {
    if (ke.isUndefined(u)) {
      if (!ke.isUndefined(m))
        return i(void 0, m);
    } else return i(void 0, u);
  }
  function l(m, u, f) {
    if (ke.hasOwnProp(n, f))
      return i(m, u);
    if (ke.hasOwnProp(e, f))
      return i(void 0, m);
  }
  const d = {
    url: o,
    method: o,
    data: o,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    allowedSocketPaths: s,
    responseEncoding: s,
    validateStatus: l,
    headers: (m, u, f) => a(_f(m), _f(u), f, !0)
  };
  return ke.forEach(Object.keys({ ...e, ...n }), function(u) {
    if (u === "__proto__" || u === "constructor" || u === "prototype") return;
    const f = ke.hasOwnProp(d, u) ? d[u] : a, h = ke.hasOwnProp(e, u) ? e[u] : void 0, g = ke.hasOwnProp(n, u) ? n[u] : void 0, C = f(h, g, u);
    ke.isUndefined(C) && f !== l || (r[u] = C);
  }), r;
}
const vx = (e) => {
  const n = Ni({}, e), r = (h) => ke.hasOwnProp(n, h) ? n[h] : void 0, i = r("data");
  let a = r("withXSRFToken");
  const o = r("xsrfHeaderName"), s = r("xsrfCookieName");
  let l = r("headers");
  const d = r("auth"), m = r("baseURL"), u = r("allowAbsoluteUrls"), f = r("url");
  if (n.headers = l = Xt.from(l), n.url = px(
    gx(m, f, u),
    e.params,
    e.paramsSerializer
  ), d && l.set(
    "Authorization",
    "Basic " + btoa(
      (d.username || "") + ":" + (d.password ? unescape(encodeURIComponent(d.password)) : "")
    )
  ), ke.isFormData(i)) {
    if (Rt.hasStandardBrowserEnv || Rt.hasStandardBrowserWebWorkerEnv)
      l.setContentType(void 0);
    else if (ke.isFunction(i.getHeaders)) {
      const h = i.getHeaders(), g = ["content-type", "content-length"];
      Object.entries(h).forEach(([C, S]) => {
        g.includes(C.toLowerCase()) && l.set(C, S);
      });
    }
  }
  if (Rt.hasStandardBrowserEnv && (ke.isFunction(a) && (a = a(n)), a === !0 || a == null && uj(n.url))) {
    const g = o && s && mj.read(s);
    g && l.set(o, g);
  }
  return n;
}, hj = typeof XMLHttpRequest < "u", yj = hj && function(e) {
  return new Promise(function(r, i) {
    const a = vx(e);
    let o = a.data;
    const s = Xt.from(a.headers).normalize();
    let { responseType: l, onUploadProgress: d, onDownloadProgress: m } = a, u, f, h, g, C;
    function S() {
      g && g(), C && C(), a.cancelToken && a.cancelToken.unsubscribe(u), a.signal && a.signal.removeEventListener("abort", u);
    }
    let N = new XMLHttpRequest();
    N.open(a.method.toUpperCase(), a.url, !0), N.timeout = a.timeout;
    function w() {
      if (!N)
        return;
      const z = Xt.from(
        "getAllResponseHeaders" in N && N.getAllResponseHeaders()
      ), I = {
        data: !l || l === "text" || l === "json" ? N.responseText : N.response,
        status: N.status,
        statusText: N.statusText,
        headers: z,
        config: e,
        request: N
      };
      yx(
        function(U) {
          r(U), S();
        },
        function(U) {
          i(U), S();
        },
        I
      ), N = null;
    }
    "onloadend" in N ? N.onloadend = w : N.onreadystatechange = function() {
      !N || N.readyState !== 4 || N.status === 0 && !(N.responseURL && N.responseURL.indexOf("file:") === 0) || setTimeout(w);
    }, N.onabort = function() {
      N && (i(new yn("Request aborted", yn.ECONNABORTED, e, N)), N = null);
    }, N.onerror = function($) {
      const I = $ && $.message ? $.message : "Network Error", T = new yn(I, yn.ERR_NETWORK, e, N);
      T.event = $ || null, i(T), N = null;
    }, N.ontimeout = function() {
      let $ = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const I = a.transitional || Ym;
      a.timeoutErrorMessage && ($ = a.timeoutErrorMessage), i(
        new yn(
          $,
          I.clarifyTimeoutError ? yn.ETIMEDOUT : yn.ECONNABORTED,
          e,
          N
        )
      ), N = null;
    }, o === void 0 && s.setContentType(null), "setRequestHeader" in N && ke.forEach(s.toJSON(), function($, I) {
      N.setRequestHeader(I, $);
    }), ke.isUndefined(a.withCredentials) || (N.withCredentials = !!a.withCredentials), l && l !== "json" && (N.responseType = a.responseType), m && ([h, C] = js(m, !0), N.addEventListener("progress", h)), d && N.upload && ([f, g] = js(d), N.upload.addEventListener("progress", f), N.upload.addEventListener("loadend", g)), (a.cancelToken || a.signal) && (u = (z) => {
      N && (i(!z || z.type ? new So(null, e, N) : z), N.abort(), N = null);
    }, a.cancelToken && a.cancelToken.subscribe(u), a.signal && (a.signal.aborted ? u() : a.signal.addEventListener("abort", u)));
    const y = lj(a.url);
    if (y && Rt.protocols.indexOf(y) === -1) {
      i(
        new yn(
          "Unsupported protocol " + y + ":",
          yn.ERR_BAD_REQUEST,
          e
        )
      );
      return;
    }
    N.send(o || null);
  });
}, gj = (e, n) => {
  const { length: r } = e = e ? e.filter(Boolean) : [];
  if (n || r) {
    let i = new AbortController(), a;
    const o = function(m) {
      if (!a) {
        a = !0, l();
        const u = m instanceof Error ? m : this.reason;
        i.abort(
          u instanceof yn ? u : new So(u instanceof Error ? u.message : u)
        );
      }
    };
    let s = n && setTimeout(() => {
      s = null, o(new yn(`timeout of ${n}ms exceeded`, yn.ETIMEDOUT));
    }, n);
    const l = () => {
      e && (s && clearTimeout(s), s = null, e.forEach((m) => {
        m.unsubscribe ? m.unsubscribe(o) : m.removeEventListener("abort", o);
      }), e = null);
    };
    e.forEach((m) => m.addEventListener("abort", o));
    const { signal: d } = i;
    return d.unsubscribe = () => ke.asap(l), d;
  }
}, vj = function* (e, n) {
  let r = e.byteLength;
  if (r < n) {
    yield e;
    return;
  }
  let i = 0, a;
  for (; i < r; )
    a = i + n, yield e.slice(i, a), i = a;
}, kj = async function* (e, n) {
  for await (const r of bj(e))
    yield* vj(r, n);
}, bj = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const n = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: i } = await n.read();
      if (r)
        break;
      yield i;
    }
  } finally {
    await n.cancel();
  }
}, Sf = (e, n, r, i) => {
  const a = kj(e, n);
  let o = 0, s, l = (d) => {
    s || (s = !0, i && i(d));
  };
  return new ReadableStream(
    {
      async pull(d) {
        try {
          const { done: m, value: u } = await a.next();
          if (m) {
            l(), d.close();
            return;
          }
          let f = u.byteLength;
          if (r) {
            let h = o += f;
            r(h);
          }
          d.enqueue(new Uint8Array(u));
        } catch (m) {
          throw l(m), m;
        }
      },
      cancel(d) {
        return l(d), a.return();
      }
    },
    {
      highWaterMark: 2
    }
  );
}, Nf = 64 * 1024, { isFunction: Do } = ke, xj = (({ Request: e, Response: n }) => ({
  Request: e,
  Response: n
}))(ke.global), { ReadableStream: jf, TextEncoder: wf } = ke.global, Cf = (e, ...n) => {
  try {
    return !!e(...n);
  } catch {
    return !1;
  }
}, _j = (e) => {
  e = ke.merge.call(
    {
      skipUndefined: !0
    },
    xj,
    e
  );
  const { fetch: n, Request: r, Response: i } = e, a = n ? Do(n) : typeof fetch == "function", o = Do(r), s = Do(i);
  if (!a)
    return !1;
  const l = a && Do(jf), d = a && (typeof wf == "function" ? /* @__PURE__ */ ((C) => (S) => C.encode(S))(new wf()) : async (C) => new Uint8Array(await new r(C).arrayBuffer())), m = o && l && Cf(() => {
    let C = !1;
    const S = new r(Rt.origin, {
      body: new jf(),
      method: "POST",
      get duplex() {
        return C = !0, "half";
      }
    }), N = S.headers.has("Content-Type");
    return S.body != null && S.body.cancel(), C && !N;
  }), u = s && l && Cf(() => ke.isReadableStream(new i("").body)), f = {
    stream: u && ((C) => C.body)
  };
  a && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((C) => {
    !f[C] && (f[C] = (S, N) => {
      let w = S && S[C];
      if (w)
        return w.call(S);
      throw new yn(
        `Response type '${C}' is not supported`,
        yn.ERR_NOT_SUPPORT,
        N
      );
    });
  });
  const h = async (C) => {
    if (C == null)
      return 0;
    if (ke.isBlob(C))
      return C.size;
    if (ke.isSpecCompliantForm(C))
      return (await new r(Rt.origin, {
        method: "POST",
        body: C
      }).arrayBuffer()).byteLength;
    if (ke.isArrayBufferView(C) || ke.isArrayBuffer(C))
      return C.byteLength;
    if (ke.isURLSearchParams(C) && (C = C + ""), ke.isString(C))
      return (await d(C)).byteLength;
  }, g = async (C, S) => {
    const N = ke.toFiniteNumber(C.getContentLength());
    return N ?? h(S);
  };
  return async (C) => {
    let {
      url: S,
      method: N,
      data: w,
      signal: y,
      cancelToken: z,
      timeout: $,
      onDownloadProgress: I,
      onUploadProgress: T,
      responseType: U,
      headers: Q,
      withCredentials: J = "same-origin",
      fetchOptions: ae
    } = vx(C), X = n || fetch;
    U = U ? (U + "").toLowerCase() : "text";
    let B = gj(
      [y, z && z.toAbortSignal()],
      $
    ), O = null;
    const q = B && B.unsubscribe && (() => {
      B.unsubscribe();
    });
    let ee;
    try {
      if (T && m && N !== "get" && N !== "head" && (ee = await g(Q, w)) !== 0) {
        let xe = new r(S, {
          method: "POST",
          body: w,
          duplex: "half"
        }), Ie;
        if (ke.isFormData(w) && (Ie = xe.headers.get("content-type")) && Q.setContentType(Ie), xe.body) {
          const [K, qe] = bf(
            ee,
            js(xf(T))
          );
          w = Sf(xe.body, Nf, K, qe);
        }
      }
      ke.isString(J) || (J = J ? "include" : "omit");
      const ve = o && "credentials" in r.prototype;
      if (ke.isFormData(w)) {
        const xe = Q.getContentType();
        xe && /^multipart\/form-data/i.test(xe) && !/boundary=/i.test(xe) && Q.delete("content-type");
      }
      const ue = {
        ...ae,
        signal: B,
        method: N.toUpperCase(),
        headers: Q.normalize().toJSON(),
        body: w,
        duplex: "half",
        credentials: ve ? J : void 0
      };
      O = o && new r(S, ue);
      let ce = await (o ? X(O, ae) : X(S, ue));
      const fe = u && (U === "stream" || U === "response");
      if (u && (I || fe && q)) {
        const xe = {};
        ["status", "statusText", "headers"].forEach((Be) => {
          xe[Be] = ce[Be];
        });
        const Ie = ke.toFiniteNumber(ce.headers.get("content-length")), [K, qe] = I && bf(
          Ie,
          js(xf(I), !0)
        ) || [];
        ce = new i(
          Sf(ce.body, Nf, K, () => {
            qe && qe(), q && q();
          }),
          xe
        );
      }
      U = U || "text";
      let W = await f[ke.findKey(f, U) || "text"](
        ce,
        C
      );
      return !fe && q && q(), await new Promise((xe, Ie) => {
        yx(xe, Ie, {
          data: W,
          headers: Xt.from(ce.headers),
          status: ce.status,
          statusText: ce.statusText,
          config: C,
          request: O
        });
      });
    } catch (ve) {
      throw q && q(), ve && ve.name === "TypeError" && /Load failed|fetch/i.test(ve.message) ? Object.assign(
        new yn(
          "Network Error",
          yn.ERR_NETWORK,
          C,
          O,
          ve && ve.response
        ),
        {
          cause: ve.cause || ve
        }
      ) : yn.from(ve, ve && ve.code, C, O, ve && ve.response);
    }
  };
}, Sj = /* @__PURE__ */ new Map(), kx = (e) => {
  let n = e && e.env || {};
  const { fetch: r, Request: i, Response: a } = n, o = [i, a, r];
  let s = o.length, l = s, d, m, u = Sj;
  for (; l--; )
    d = o[l], m = u.get(d), m === void 0 && u.set(d, m = l ? /* @__PURE__ */ new Map() : _j(n)), u = m;
  return m;
};
kx();
const Jm = {
  http: PN,
  xhr: yj,
  fetch: {
    get: kx
  }
};
ke.forEach(Jm, (e, n) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: n });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: n });
  }
});
const Ff = (e) => `- ${e}`, Nj = (e) => ke.isFunction(e) || e === null || e === !1;
function jj(e, n) {
  e = ke.isArray(e) ? e : [e];
  const { length: r } = e;
  let i, a;
  const o = {};
  for (let s = 0; s < r; s++) {
    i = e[s];
    let l;
    if (a = i, !Nj(i) && (a = Jm[(l = String(i)).toLowerCase()], a === void 0))
      throw new yn(`Unknown adapter '${l}'`);
    if (a && (ke.isFunction(a) || (a = a.get(n))))
      break;
    o[l || "#" + s] = a;
  }
  if (!a) {
    const s = Object.entries(o).map(
      ([d, m]) => `adapter ${d} ` + (m === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let l = r ? s.length > 1 ? `since :
` + s.map(Ff).join(`
`) : " " + Ff(s[0]) : "as no adapter specified";
    throw new yn(
      "There is no suitable adapter to dispatch the request " + l,
      "ERR_NOT_SUPPORT"
    );
  }
  return a;
}
const bx = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: jj,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: Jm
};
function bl(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new So(null, e);
}
function If(e) {
  return bl(e), e.headers = Xt.from(e.headers), e.data = kl.call(e, e.transformRequest), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), bx.getAdapter(e.adapter || _o.adapter, e)(e).then(
    function(i) {
      return bl(e), i.data = kl.call(e, e.transformResponse, i), i.headers = Xt.from(i.headers), i;
    },
    function(i) {
      return hx(i) || (bl(e), i && i.response && (i.response.data = kl.call(
        e,
        e.transformResponse,
        i.response
      ), i.response.headers = Xt.from(i.response.headers))), Promise.reject(i);
    }
  );
}
const xx = "1.15.2", el = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, n) => {
  el[e] = function(i) {
    return typeof i === e || "a" + (n < 1 ? "n " : " ") + e;
  };
});
const Ef = {};
el.transitional = function(n, r, i) {
  function a(o, s) {
    return "[Axios v" + xx + "] Transitional option '" + o + "'" + s + (i ? ". " + i : "");
  }
  return (o, s, l) => {
    if (n === !1)
      throw new yn(
        a(s, " has been removed" + (r ? " in " + r : "")),
        yn.ERR_DEPRECATED
      );
    return r && !Ef[s] && (Ef[s] = !0, console.warn(
      a(
        s,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), n ? n(o, s, l) : !0;
  };
};
el.spelling = function(n) {
  return (r, i) => (console.warn(`${i} is likely a misspelling of ${n}`), !0);
};
function wj(e, n, r) {
  if (typeof e != "object")
    throw new yn("options must be an object", yn.ERR_BAD_OPTION_VALUE);
  const i = Object.keys(e);
  let a = i.length;
  for (; a-- > 0; ) {
    const o = i[a], s = Object.prototype.hasOwnProperty.call(n, o) ? n[o] : void 0;
    if (s) {
      const l = e[o], d = l === void 0 || s(l, o, e);
      if (d !== !0)
        throw new yn(
          "option " + o + " must be " + d,
          yn.ERR_BAD_OPTION_VALUE
        );
      continue;
    }
    if (r !== !0)
      throw new yn("Unknown option " + o, yn.ERR_BAD_OPTION);
  }
}
const us = {
  assertOptions: wj,
  validators: el
}, lr = us.validators;
let bi = class {
  constructor(n) {
    this.defaults = n || {}, this.interceptors = {
      request: new vf(),
      response: new vf()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(n, r) {
    try {
      return await this._request(n, r);
    } catch (i) {
      if (i instanceof Error) {
        let a = {};
        Error.captureStackTrace ? Error.captureStackTrace(a) : a = new Error();
        const o = (() => {
          if (!a.stack)
            return "";
          const s = a.stack.indexOf(`
`);
          return s === -1 ? "" : a.stack.slice(s + 1);
        })();
        try {
          if (!i.stack)
            i.stack = o;
          else if (o) {
            const s = o.indexOf(`
`), l = s === -1 ? -1 : o.indexOf(`
`, s + 1), d = l === -1 ? "" : o.slice(l + 1);
            String(i.stack).endsWith(d) || (i.stack += `
` + o);
          }
        } catch {
        }
      }
      throw i;
    }
  }
  _request(n, r) {
    typeof n == "string" ? (r = r || {}, r.url = n) : r = n || {}, r = Ni(this.defaults, r);
    const { transitional: i, paramsSerializer: a, headers: o } = r;
    i !== void 0 && us.assertOptions(
      i,
      {
        silentJSONParsing: lr.transitional(lr.boolean),
        forcedJSONParsing: lr.transitional(lr.boolean),
        clarifyTimeoutError: lr.transitional(lr.boolean),
        legacyInterceptorReqResOrdering: lr.transitional(lr.boolean)
      },
      !1
    ), a != null && (ke.isFunction(a) ? r.paramsSerializer = {
      serialize: a
    } : us.assertOptions(
      a,
      {
        encode: lr.function,
        serialize: lr.function
      },
      !0
    )), r.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? r.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : r.allowAbsoluteUrls = !0), us.assertOptions(
      r,
      {
        baseUrl: lr.spelling("baseURL"),
        withXsrfToken: lr.spelling("withXSRFToken")
      },
      !0
    ), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let s = o && ke.merge(o.common, o[r.method]);
    o && ke.forEach(["delete", "get", "head", "post", "put", "patch", "common"], (C) => {
      delete o[C];
    }), r.headers = Xt.concat(s, o);
    const l = [];
    let d = !0;
    this.interceptors.request.forEach(function(S) {
      if (typeof S.runWhen == "function" && S.runWhen(r) === !1)
        return;
      d = d && S.synchronous;
      const N = r.transitional || Ym;
      N && N.legacyInterceptorReqResOrdering ? l.unshift(S.fulfilled, S.rejected) : l.push(S.fulfilled, S.rejected);
    });
    const m = [];
    this.interceptors.response.forEach(function(S) {
      m.push(S.fulfilled, S.rejected);
    });
    let u, f = 0, h;
    if (!d) {
      const C = [If.bind(this), void 0];
      for (C.unshift(...l), C.push(...m), h = C.length, u = Promise.resolve(r); f < h; )
        u = u.then(C[f++], C[f++]);
      return u;
    }
    h = l.length;
    let g = r;
    for (; f < h; ) {
      const C = l[f++], S = l[f++];
      try {
        g = C(g);
      } catch (N) {
        S.call(this, N);
        break;
      }
    }
    try {
      u = If.call(this, g);
    } catch (C) {
      return Promise.reject(C);
    }
    for (f = 0, h = m.length; f < h; )
      u = u.then(m[f++], m[f++]);
    return u;
  }
  getUri(n) {
    n = Ni(this.defaults, n);
    const r = gx(n.baseURL, n.url, n.allowAbsoluteUrls);
    return px(r, n.params, n.paramsSerializer);
  }
};
ke.forEach(["delete", "get", "head", "options"], function(n) {
  bi.prototype[n] = function(r, i) {
    return this.request(
      Ni(i || {}, {
        method: n,
        url: r,
        data: (i || {}).data
      })
    );
  };
});
ke.forEach(["post", "put", "patch"], function(n) {
  function r(i) {
    return function(o, s, l) {
      return this.request(
        Ni(l || {}, {
          method: n,
          headers: i ? {
            "Content-Type": "multipart/form-data"
          } : {},
          url: o,
          data: s
        })
      );
    };
  }
  bi.prototype[n] = r(), bi.prototype[n + "Form"] = r(!0);
});
let Cj = class _x {
  constructor(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(o) {
      r = o;
    });
    const i = this;
    this.promise.then((a) => {
      if (!i._listeners) return;
      let o = i._listeners.length;
      for (; o-- > 0; )
        i._listeners[o](a);
      i._listeners = null;
    }), this.promise.then = (a) => {
      let o;
      const s = new Promise((l) => {
        i.subscribe(l), o = l;
      }).then(a);
      return s.cancel = function() {
        i.unsubscribe(o);
      }, s;
    }, n(function(o, s, l) {
      i.reason || (i.reason = new So(o, s, l), r(i.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(n) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(n);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const n = new AbortController(), r = (i) => {
      n.abort(i);
    };
    return this.subscribe(r), n.signal.unsubscribe = () => this.unsubscribe(r), n.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let n;
    return {
      token: new _x(function(a) {
        n = a;
      }),
      cancel: n
    };
  }
};
function Fj(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function Ij(e) {
  return ke.isObject(e) && e.isAxiosError === !0;
}
const cm = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(cm).forEach(([e, n]) => {
  cm[n] = e;
});
function Sx(e) {
  const n = new bi(e), r = tx(bi.prototype.request, n);
  return ke.extend(r, bi.prototype, n, { allOwnKeys: !0 }), ke.extend(r, n, null, { allOwnKeys: !0 }), r.create = function(a) {
    return Sx(Ni(e, a));
  }, r;
}
const ht = Sx(_o);
ht.Axios = bi;
ht.CanceledError = So;
ht.CancelToken = Cj;
ht.isCancel = hx;
ht.VERSION = xx;
ht.toFormData = Zs;
ht.AxiosError = yn;
ht.Cancel = ht.CanceledError;
ht.all = function(n) {
  return Promise.all(n);
};
ht.spread = Fj;
ht.isAxiosError = Ij;
ht.mergeConfig = Ni;
ht.AxiosHeaders = Xt;
ht.formToJSON = (e) => fx(ke.isHTMLForm(e) ? new FormData(e) : e);
ht.getAdapter = bx.getAdapter;
ht.HttpStatusCode = cm;
ht.default = ht;
const {
  Axios: AB,
  AxiosError: PB,
  CanceledError: LB,
  isCancel: VB,
  CancelToken: zB,
  VERSION: UB,
  all: MB,
  Cancel: BB,
  isAxiosError: Ej,
  spread: qB,
  toFormData: HB,
  AxiosHeaders: WB,
  HttpStatusCode: GB,
  formToJSON: KB,
  getAdapter: YB,
  mergeConfig: QB
} = ht;
class Tj {
  /** Checks whether the app is running as an electron application. */
  isElectron() {
    return window.electron ? !!window.electron : !!process?.versions?.electron || /electron/i.test(navigator.userAgent);
  }
  /**
   * Gets the electron version.
   *
   * version 0.0.0 represents a unsupported version
   */
  async getVersion() {
    return window.electron ? (await window.electron.getVersion()).split("-")[0] : "0.0.0";
  }
  /** Checks if the running Electron build is a standalone (non auto-updating windows version) */
  async isStandaloneBuild() {
    return window.electron?.isStandaloneBuild ? await window.electron.isStandaloneBuild() : null;
  }
  /** Checks if the running Electron build is installed from an windows MSI installer */
  async isMsiBuild() {
    return window.electron?.isMsiBuild ? await window.electron.isMsiBuild() : null;
  }
}
const Tf = new Tj();
function $j(e, n) {
  return $f(e), $f(n), e.localeCompare(n, void 0, {
    numeric: !0
  });
}
function $f(e) {
  if (e.split(".").length !== 3)
    throw Error(`The version '${e}' must be in the format 'x.x.x'.`);
}
const Dj = Object.prototype.toString;
function Rj(e, n) {
  return Dj.call(e) === `[object ${n}]`;
}
function Oj(e) {
  return Rj(e, "Object");
}
function Aj(e) {
  return !!(e && e.then && typeof e.then == "function");
}
const no = "8.36.0", Yr = globalThis;
function Xm(e, n, r) {
  const i = r || Yr, a = i.__SENTRY__ = i.__SENTRY__ || {}, o = a[no] = a[no] || {};
  return o[e] || (o[e] = n());
}
const Nx = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, Pj = "Sentry Logger ", Df = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], Rf = {};
function jx(e) {
  if (!("console" in Yr))
    return e();
  const n = Yr.console, r = {}, i = Object.keys(Rf);
  i.forEach((a) => {
    const o = Rf[a];
    r[a] = n[a], n[a] = o;
  });
  try {
    return e();
  } finally {
    i.forEach((a) => {
      n[a] = r[a];
    });
  }
}
function Lj() {
  let e = !1;
  const n = {
    enable: () => {
      e = !0;
    },
    disable: () => {
      e = !1;
    },
    isEnabled: () => e
  };
  return Nx ? Df.forEach((r) => {
    n[r] = (...i) => {
      e && jx(() => {
        Yr.console[r](`${Pj}[${r}]:`, ...i);
      });
    };
  }) : Df.forEach((r) => {
    n[r] = () => {
    };
  }), n;
}
const ms = Xm("logger", Lj);
function Vj(e, n, r) {
  try {
    Object.defineProperty(e, n, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: r,
      writable: !0,
      configurable: !0
    });
  } catch {
    Nx && ms.log(`Failed to add non-enumerable property "${n}" to object`, e);
  }
}
const wx = 1e3;
function Zm() {
  return Date.now() / wx;
}
function zj() {
  const { performance: e } = Yr;
  if (!e || !e.now)
    return Zm;
  const n = Date.now() - e.now(), r = e.timeOrigin == null ? n : e.timeOrigin;
  return () => (r + e.now()) / wx;
}
const Uj = zj();
(() => {
  const { performance: e } = Yr;
  if (!e || !e.now)
    return;
  const n = 3600 * 1e3, r = e.now(), i = Date.now(), a = e.timeOrigin ? Math.abs(e.timeOrigin + r - i) : n, o = a < n, s = e.timing && e.timing.navigationStart, d = typeof s == "number" ? Math.abs(s + r - i) : n, m = d < n;
  return o || m ? a <= d ? e.timeOrigin : s : i;
})();
function Xi() {
  const e = Yr, n = e.crypto || e.msCrypto;
  let r = () => Math.random() * 16;
  try {
    if (n && n.randomUUID)
      return n.randomUUID().replace(/-/g, "");
    n && n.getRandomValues && (r = () => {
      const i = new Uint8Array(1);
      return n.getRandomValues(i), i[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (i) => (
      // eslint-disable-next-line no-bitwise
      (i ^ (r() & 15) >> i / 4).toString(16)
    )
  );
}
function Of() {
  return {
    traceId: Xi(),
    spanId: Xi().substring(16)
  };
}
function ep() {
  return np(Yr), Yr;
}
function np(e) {
  const n = e.__SENTRY__ = e.__SENTRY__ || {};
  return n.version = n.version || no, n[no] = n[no] || {};
}
function Mj(e, n = {}) {
  if (n.user && (!e.ipAddress && n.user.ip_address && (e.ipAddress = n.user.ip_address), !e.did && !n.did && (e.did = n.user.id || n.user.email || n.user.username)), e.timestamp = n.timestamp || Uj(), n.abnormal_mechanism && (e.abnormal_mechanism = n.abnormal_mechanism), n.ignoreDuration && (e.ignoreDuration = n.ignoreDuration), n.sid && (e.sid = n.sid.length === 32 ? n.sid : Xi()), n.init !== void 0 && (e.init = n.init), !e.did && n.did && (e.did = `${n.did}`), typeof n.started == "number" && (e.started = n.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof n.duration == "number")
    e.duration = n.duration;
  else {
    const r = e.timestamp - e.started;
    e.duration = r >= 0 ? r : 0;
  }
  n.release && (e.release = n.release), n.environment && (e.environment = n.environment), !e.ipAddress && n.ipAddress && (e.ipAddress = n.ipAddress), !e.userAgent && n.userAgent && (e.userAgent = n.userAgent), typeof n.errors == "number" && (e.errors = n.errors), n.status && (e.status = n.status);
}
const dm = "_sentrySpan";
function Af(e, n) {
  n ? Vj(e, dm, n) : delete e[dm];
}
function Pf(e) {
  return e[dm];
}
const Bj = 100;
class tp {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = Of();
  }
  /**
   * @inheritDoc
   */
  clone() {
    const n = new tp();
    return n._breadcrumbs = [...this._breadcrumbs], n._tags = { ...this._tags }, n._extra = { ...this._extra }, n._contexts = { ...this._contexts }, n._user = this._user, n._level = this._level, n._session = this._session, n._transactionName = this._transactionName, n._fingerprint = this._fingerprint, n._eventProcessors = [...this._eventProcessors], n._requestSession = this._requestSession, n._attachments = [...this._attachments], n._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, n._propagationContext = { ...this._propagationContext }, n._client = this._client, n._lastEventId = this._lastEventId, Af(n, Pf(this)), n;
  }
  /**
   * @inheritDoc
   */
  setClient(n) {
    this._client = n;
  }
  /**
   * @inheritDoc
   */
  setLastEventId(n) {
    this._lastEventId = n;
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(n) {
    this._scopeListeners.push(n);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(n) {
    return this._eventProcessors.push(n), this;
  }
  /**
   * @inheritDoc
   */
  setUser(n) {
    return this._user = n || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && Mj(this._session, { user: n }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(n) {
    return this._requestSession = n, this;
  }
  /**
   * @inheritDoc
   */
  setTags(n) {
    return this._tags = {
      ...this._tags,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(n, r) {
    return this._tags = { ...this._tags, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(n) {
    return this._extra = {
      ...this._extra,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(n, r) {
    return this._extra = { ...this._extra, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(n) {
    return this._fingerprint = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(n) {
    return this._level = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(n) {
    return this._transactionName = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(n, r) {
    return r === null ? delete this._contexts[n] : this._contexts[n] = r, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSession(n) {
    return n ? this._session = n : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(n) {
    if (!n)
      return this;
    const r = typeof n == "function" ? n(this) : n, [i, a] = r instanceof ia ? [r.getScopeData(), r.getRequestSession()] : Oj(r) ? [n, n.requestSession] : [], { tags: o, extra: s, user: l, contexts: d, level: m, fingerprint: u = [], propagationContext: f } = i || {};
    return this._tags = { ...this._tags, ...o }, this._extra = { ...this._extra, ...s }, this._contexts = { ...this._contexts, ...d }, l && Object.keys(l).length && (this._user = l), m && (this._level = m), u.length && (this._fingerprint = u), f && (this._propagationContext = f), a && (this._requestSession = a), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, Af(this, void 0), this._attachments = [], this._propagationContext = Of(), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(n, r) {
    const i = typeof r == "number" ? r : Bj;
    if (i <= 0)
      return this;
    const a = {
      timestamp: Zm(),
      ...n
    }, o = this._breadcrumbs;
    return o.push(a), this._breadcrumbs = o.length > i ? o.slice(-i) : o, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(n) {
    return this._attachments.push(n), this;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: Pf(this)
    };
  }
  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(n) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...n }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(n) {
    return this._propagationContext = n, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */
  captureException(n, r) {
    const i = r && r.event_id ? r.event_id : Xi();
    if (!this._client)
      return ms.warn("No client configured on scope - will not capture exception!"), i;
    const a = new Error("Sentry syntheticException");
    return this._client.captureException(
      n,
      {
        originalException: n,
        syntheticException: a,
        ...r,
        event_id: i
      },
      this
    ), i;
  }
  /**
   * @inheritDoc
   */
  captureMessage(n, r, i) {
    const a = i && i.event_id ? i.event_id : Xi();
    if (!this._client)
      return ms.warn("No client configured on scope - will not capture message!"), a;
    const o = new Error(n);
    return this._client.captureMessage(
      n,
      r,
      {
        originalException: n,
        syntheticException: o,
        ...i,
        event_id: a
      },
      this
    ), a;
  }
  /**
   * @inheritDoc
   */
  captureEvent(n, r) {
    const i = r && r.event_id ? r.event_id : Xi();
    return this._client ? (this._client.captureEvent(n, { ...r, event_id: i }, this), i) : (ms.warn("No client configured on scope - will not capture event!"), i);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((n) => {
      n(this);
    }), this._notifyingListeners = !1);
  }
}
const ia = tp;
function qj() {
  return Xm("defaultCurrentScope", () => new ia());
}
function Hj() {
  return Xm("defaultIsolationScope", () => new ia());
}
class Wj {
  constructor(n, r) {
    let i;
    n ? i = n : i = new ia();
    let a;
    r ? a = r : a = new ia(), this._stack = [{ scope: i }], this._isolationScope = a;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(n) {
    const r = this._pushScope();
    let i;
    try {
      i = n(r);
    } catch (a) {
      throw this._popScope(), a;
    }
    return Aj(i) ? i.then(
      (a) => (this._popScope(), a),
      (a) => {
        throw this._popScope(), a;
      }
    ) : (this._popScope(), i);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const n = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: n
    }), n;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function aa() {
  const e = ep(), n = np(e);
  return n.stack = n.stack || new Wj(qj(), Hj());
}
function Gj(e) {
  return aa().withScope(e);
}
function Kj(e, n) {
  const r = aa();
  return r.withScope(() => (r.getStackTop().scope = e, n(e)));
}
function Lf(e) {
  return aa().withScope(() => e(aa().getIsolationScope()));
}
function Yj() {
  return {
    withIsolationScope: Lf,
    withScope: Gj,
    withSetScope: Kj,
    withSetIsolationScope: (e, n) => Lf(n),
    getCurrentScope: () => aa().getScope(),
    getIsolationScope: () => aa().getIsolationScope()
  };
}
function Cx(e) {
  const n = np(e);
  return n.acs ? n.acs : Yj();
}
function rp() {
  const e = ep();
  return Cx(e).getCurrentScope();
}
function Fx() {
  const e = ep();
  return Cx(e).getIsolationScope();
}
function Qj() {
  return rp().getClient();
}
function Jj(e) {
  if (e)
    return Xj(e) ? { captureContext: e } : ew(e) ? {
      captureContext: e
    } : e;
}
function Xj(e) {
  return e instanceof ia || typeof e == "function";
}
const Zj = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function ew(e) {
  return Object.keys(e).some((n) => Zj.includes(n));
}
function Vf(e, n) {
  return rp().captureException(e, Jj(n));
}
function nw(e, n) {
  const r = typeof n == "string" ? n : void 0, i = typeof n != "string" ? { captureContext: n } : void 0;
  return rp().captureMessage(e, r, i);
}
function tw(e, n) {
  Fx().setContext(e, n);
}
const rw = 100;
function mi(e, n) {
  const r = Qj(), i = Fx();
  if (!r) return;
  const { beforeBreadcrumb: a = null, maxBreadcrumbs: o = rw } = r.getOptions();
  if (o <= 0) return;
  const l = { timestamp: Zm(), ...e }, d = a ? jx(() => a(l, n)) : l;
  d !== null && (r.emit && r.emit("beforeAddBreadcrumb", d, n), i.addBreadcrumb(d, o));
}
var ho;
(function(e) {
  e.Unknown = "unknown", e.Core = "core", e.Routing = "routing-and-presence", e.Insights = "insights", e.Ecosystem = "ecosystem", e.Partners = "partners", e.Channels = "channels", e.Messaging = "messaging", e.Platform = "platform", e.AI = "ai", e.Conversations = "conversations", e.Automation = "automation";
})(ho || (ho = {}));
function Zi(e) {
  const n = e.split(".")[1];
  if (!n)
    throw Error("Invalid token");
  const r = n.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(Buffer.from(r, "base64").toString());
  } catch (i) {
    throw Error(`Failed to parse the JSON Web Token with the following error: ${i}`);
  }
}
const iw = fo.backendDomain ? {
  "backend-domain": fo.backendDomain
} : void 0;
function ps() {
  const e = new URLSearchParams({
    noToken: "true",
    ...iw
  }).toString();
  document.location.href = `${fo.url.logIn}?${e}`;
}
const xl = "authData", _l = 30, aw = 600, Sl = 5;
class ow {
  authData = null;
  /** The (server) time when the access token expires, in seconds. */
  accessTokenExpiresAt = 0;
  /**
   * The difference between client- and server-time, in seconds. Negative if
   * client is ahead of server, positive if server is ahead of client
   */
  clientServerTimeDiff = 0;
  /**
   * Returns an estimated server time (unix epoch in seconds) by adding the
   * client-server time difference to the current client time.
   *
   * The time-diff is stored whenever a new access token is saved.
   *
   * @returns {number} The estimated server time in seconds.
   */
  estimatedServerTime() {
    const n = Date.now() / 1e3;
    return this.clientServerTimeDiff >= Sl || this.clientServerTimeDiff <= -Sl ? Math.ceil(n + this.clientServerTimeDiff) : Math.ceil(n);
  }
  /**
   * Sets the auth data in localStorage.
   *
   * @param authData The auth data.
   */
  setAuthData(n) {
    this.authData = n;
    const i = Math.ceil(Date.now() / 1e3) + aw, a = Zi(n.access_token).exp;
    if (this.clientServerTimeDiff = a - i, process.env.NODE_ENV !== "test" && Math.abs(this.clientServerTimeDiff) > Sl) {
      const o = this.clientServerTimeDiff > 0 ? "behind" : "ahead";
      console.info(`Client time is ${o} by significant amount. (${Math.abs(this.clientServerTimeDiff)}s)`);
    }
    this.accessTokenExpiresAt = a, localStorage.setItem(xl, JSON.stringify(n));
  }
  /** Gets the auth data from memory or localStorage. */
  getAuthData() {
    if (this.authData)
      return this.authData;
    const n = localStorage.getItem(xl), r = n ? JSON.parse(n) : null;
    return this.validateAuthDataComplete(r) && (this.authData = r), r;
  }
  /** Removes the auth data from localStorage. */
  removeAuthData() {
    this.authData = null, localStorage.removeItem(xl);
  }
  getAccessToken() {
    return this.authData?.access_token || null;
  }
  getRefreshToken() {
    return this.authData?.refresh_token || null;
  }
  /**
   * Validates that the auth data is complete - i.e not fragmented.
   *
   * @param authData The auth data.
   */
  validateAuthDataComplete(n) {
    return n ? [
      "access_token",
      "refresh_token",
      "expires_in"
    ].every((i) => typeof n[i] < "u") : !1;
  }
  isAccessTokenExpired() {
    if (!this.getAccessToken())
      return !0;
    const r = this.accessTokenExpiresAt - _l;
    return this.estimatedServerTime() >= r;
  }
  isRefreshTokenExpired(n) {
    if (!n)
      return !0;
    const r = Zi(n), i = r.exp - _l;
    return !r || this.estimatedServerTime() >= i;
  }
  accessTokenExpiresInMs() {
    return (this.accessTokenExpiresAt - _l - this.estimatedServerTime()) * 1e3;
  }
}
const Nt = new ow();
async function sw(e) {
  const n = window.location.origin.replace(/^https?:\/\//, ""), r = ["localhost:8080", "uptrends-monitor"];
  if (!(!e.response || r.some((i) => n.includes(i)))) {
    try {
      const i = e.response.config.headers.Authorization ?? "", a = i ? i.toString()?.split("Basic ")[1] : "", o = a ? atob(a).split("token:")[1] : "", s = o ? Zi(o).exp : "None", l = await nl.getAuthData({ localStorageOnly: !0 }), d = Math.floor(Date.now() / 1e3), m = l?.access_token, u = l?.refresh_token, f = m ? Zi(m).exp : "None", h = u ? Zi(u).exp : "None", g = typeof s == "number" ? d - s : "Unknown", C = typeof f == "number" ? d - f : "Unknown", S = typeof h == "number" ? d - h : "Unknown", N = e.response.headers["x-dixa-rid"];
      tw("Expires", {
        currentTimestamp: d,
        accessTokenFromHeader: s,
        accessTokenFromHeaderDiff: g,
        accessTokenFromLocalStorage: f,
        accessTokenFromLocalStorageDiff: C,
        refreshTokenFromLocalStorage: h,
        refreshTokenFromLocalStorageDiff: S,
        xDixaRid: N,
        navigatorOnline: navigator.onLine
      });
    } catch (i) {
      console.error("Error adding Sentry error context", i);
    }
    nw("401 unauthorized interceptor", {
      level: "debug",
      tags: {
        team: ho.Platform,
        domain: n
      }
    });
  }
}
const Nl = /* @__PURE__ */ new Map(), lw = 3;
function cw(e) {
  e.interceptors.response.use((n) => (Nl.delete(n.config.url), n), (n) => {
    if (n.response) {
      const { status: r } = n.response;
      switch (r) {
        case um.Unauthorized:
          if (!nl.isRefreshTokenExpired() && n.config) {
            mi({
              category: "errorInterceptor",
              message: "Access token expired after request",
              level: "debug"
            });
            const i = Nl.get(n.config.url) ?? 0;
            if (console.log(`Retrying request (${i + 1}): ${n.config.url}`), i <= lw)
              return Nl.set(n.config.url, i + 1), e(n.config);
          }
          sw(n), console.error("401 unauthorized interceptor"), ps();
          break;
      }
    }
    return Promise.reject(n);
  });
}
const Ix = ht.create();
cw(Ix);
const Ur = console.log;
async function zf(e) {
  return new Promise((n) => setTimeout(n, e * 1e3));
}
class dw extends Error {
  constructor(n, r) {
    super(n, r);
  }
}
function uw(e = 0) {
  return Math.min(Math.round((Math.random() + 1) * Math.pow(1.5, e)), 30);
}
const mw = 5;
class pw {
  authDataPromise = null;
  retryCount = 0;
  async init(n) {
    const r = await this.refresh(n);
    if (r)
      Nt.setAuthData(r);
    else {
      const i = Nt.isRefreshTokenExpired(n) ? "expired" : "unknown";
      throw new dw("Failed to init refresh token", {
        cause: i
      });
    }
  }
  getDebugInfo() {
    const n = Nt.getAccessToken();
    if (!n)
      return {};
    const r = Zi(n), { exp: i } = r;
    return {
      expire: i ? new Date(i * 1e3).toISOString() : null,
      now: (/* @__PURE__ */ new Date()).toISOString()
    };
  }
  /**
   * Gets auth data from LocalStorage, or fetches new auth data if the current
   * token is expired or is about to expire.
   */
  async getAuthData({ localStorageOnly: n = !1 } = {}) {
    if (n)
      return Nt.getAuthData();
    if (this.authDataPromise)
      return await this.authDataPromise;
    const r = Nt.getAuthData();
    return r ? Nt.isAccessTokenExpired() ? (mi({
      category: "refreshToken",
      // Cannot include "token" in the message, as it will be redacted
      message: "expired or about to expire",
      level: "debug",
      data: this.getDebugInfo()
    }), this.authDataPromise = this.refresh(r.refresh_token).then((i) => (i && Nt.setAuthData(i), this.authDataPromise = null, i)), await this.authDataPromise) : r : null;
  }
  removeAuthData() {
    return Nt.removeAuthData();
  }
  validateAuthDataComplete(n) {
    return Nt.validateAuthDataComplete(n);
  }
  isAccessTokenExpired() {
    return Nt.isAccessTokenExpired();
  }
  isRefreshTokenExpired() {
    const n = Nt.getAuthData();
    return n ? Nt.isRefreshTokenExpired(n.refresh_token) : !0;
  }
  /** Checks whether refresh token is supported. */
  async isSupported() {
    if (!Tf.isElectron())
      return !0;
    const n = await Tf.getVersion();
    return $j(n, "3.7.0") === 1;
  }
  /**
   * Gets refreshed tokens from the API
   *
   * @param refreshToken The refresh token.
   * @param retriesLeft The number of retries left.
   */
  async refresh(n, r = mw) {
    try {
      return await Ix.post(`${fo.url.rest}/v2/login/refresh`, {
        refreshToken: n
      }).then((i) => (this.retryCount = 0, i.data.data));
    } catch (i) {
      return await this.handleRefreshError(i, n, r);
    }
  }
  async waitUntilOnline() {
    const n = navigator.onLine === !1;
    for (n && (Ur("AUTH", "Network connection offline - waiting..."), mi({
      category: "refreshToken",
      message: "Network connection offline - waiting...",
      level: "debug"
    })); navigator.onLine === !1; )
      await zf(5);
    n && (Ur("AUTH", "Network connection restored"), mi({
      category: "refreshToken",
      message: "Network connection restored",
      level: "debug"
    }));
  }
  async retryRefresh(n, r) {
    await this.waitUntilOnline(), this.retryCount++;
    const i = uw(this.retryCount);
    return Ur("AUTH", `Retrying in ${i} seconds`), await zf(i), await this.refresh(n, r);
  }
  async handleRefreshError(n, r, i) {
    if (Nt.isRefreshTokenExpired(r))
      return Ur("AUTH", "Refresh token expired"), mi({
        category: "refreshToken",
        message: "Refresh token expired",
        level: "debug"
      }), Nt.removeAuthData(), ps(), null;
    if (Ej(n)) {
      if (n.message === "timeout exceeded")
        return Ur("AUTH", "Timeout exceeded"), mi({
          category: "refreshToken",
          message: "Timeout exceeded",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.message === "Network Error")
        return Ur("AUTH", "Network error"), mi({
          category: "refreshToken",
          message: "Network error",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.response?.status === 401)
        return Ur("AUTH", "Refresh token invalid (401)"), Nt.removeAuthData(), ps(), null;
      Vf(n, {
        level: "error",
        tags: {
          team: ho.Platform,
          errorSource: "authManager.refresh"
        }
      });
    }
    return i <= 0 ? (Ur("AUTH", "Retries exhausted, logging out"), Vf(n, {
      level: "error",
      tags: {
        team: ho.Platform,
        errorSource: "authManager.refresh"
      }
    }), Nt.removeAuthData(), ps(), null) : (Ur("AUTH", `Retrying ${i} more times`), await this.retryRefresh(r, i - 1));
  }
  accessTokenExpiresInMs() {
    return Nt.accessTokenExpiresInMs();
  }
}
const nl = new pw();
var um;
(function(e) {
  e[e.BadRequest = 400] = "BadRequest", e[e.Unauthorized = 401] = "Unauthorized", e[e.Forbidden = 403] = "Forbidden", e[e.NotFound = 404] = "NotFound", e[e.Conflict = 409] = "Conflict", e[e.InternalServerError = 500] = "InternalServerError", e[e.BadGateway = 502] = "BadGateway", e[e.ServiceUnavailable = 503] = "ServiceUnavailable";
})(um || (um = {}));
const fw = new Wm((e, n) => new Zb((r) => {
  nl.getAuthData().then((i) => {
    const a = i?.access_token, o = e.getContext().headers;
    return e.setContext({
      ...o,
      headers: {
        Authorization: a ? `Bearer ${a}` : ""
      }
    }), n(e).subscribe(r);
  }).catch((i) => r.error(i));
})), hw = new Wm(
  (e, n) => new Zb((r) => {
    const i = e.getContext(), { headers: a, widgetId: o, widgetType: s, operationName: l } = i;
    nl.getAuthData().then((d) => (e.setContext({
      ...i,
      headers: {
        ...a,
        ...o && { "x-integration-widget-id": o },
        ...s && { "x-integration-widget-type": s },
        ...l && {
          "x-integration-widget-operation": l
        },
        ...a0(fo.url.partnerIntegrations) && d?.access_token && o0(d.access_token)
      }
    }), n(e).subscribe(r))).catch((d) => r.error(d));
  })
), yw = new AbortController(), Ex = (e) => new A0({
  queryDeduplication: !1,
  cache: new P0(),
  link: Wm.from([
    fw,
    hw,
    L0({
      uri: `${e}/graphql`,
      fetch: B0,
      fetchOptions: {
        mode: "cors",
        // The `AbortSignal` object instance is used to communicate with a
        // fetch request and abort it if desired via an `AbortController`.
        // This prevents abandoned abort errors spiral up to Sentry.
        signal: yw.signal
      }
    })
  ]),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    query: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    mutate: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    }
  }
}), gw = ({
  configuration: e,
  children: n
}) => {
  const r = Bn(
    () => Ex(e.baseUrl),
    [e.baseUrl]
  );
  return /* @__PURE__ */ Ve.jsx(V0, { client: r, children: n });
};
function vw() {
  try {
    return z0(), !0;
  } catch {
    return !1;
  }
}
const kw = ({
  configuration: e,
  children: n
}) => vw() ? n : /* @__PURE__ */ Ve.jsx(gw, { configuration: e, children: n }), bw = ({
  integrationId: e,
  type: n,
  showNotification: r,
  showModal: i,
  children: a
}) => /* @__PURE__ */ Ve.jsx(U0, { children: (o) => /* @__PURE__ */ Ve.jsx(
  s0,
  {
    value: {
      useMutation: u0(e, n),
      useQuery: d0(e, n),
      useLazyQuery: c0(e, n),
      executeQuery: l0(e, n, o),
      showNotification: r,
      showModal: i ?? (() => null)
    },
    children: a
  }
) }), Tx = ({
  integrationId: e,
  type: n,
  configuration: r,
  showNotification: i,
  showModal: a,
  children: o
}) => {
  const s = !!e && !!n;
  return /* @__PURE__ */ Ve.jsx(kw, { configuration: r, children: s ? /* @__PURE__ */ Ve.jsx(
    bw,
    {
      integrationId: e,
      type: n,
      showNotification: i,
      showModal: a,
      children: o
    }
  ) : o });
}, xw = "_unmatchedHeader_qcj19_1", _w = {
  unmatchedHeader: xw
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._copyIcon_1wjfs_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_1wjfs_53{padding:0;max-height:250px;overflow-y:auto;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_1wjfs_63{background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1wjfs_63:last-child:not(:only-child){border-bottom:none}._collapsible_1wjfs_72{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._collapsible_1wjfs_72:hover,._collapsibleIsOpen_1wjfs_80{border-color:var(--dixa-color-neutral-400)}._collapsibleHeader_1wjfs_83{cursor:pointer}._collapsibleIconTrue_1wjfs_86{color:var(--dixa-color-green-500)}._collapsibleIconFalse_1wjfs_89{color:var(--dixa-color-red-500)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var jl = { exports: {} }, ka = {}, Uf;
function Sw() {
  if (Uf) return ka;
  Uf = 1;
  var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return ka.Fragment = r, ka.jsx = s, ka.jsxs = s, ka;
}
var Ro = {}, Mf;
function Nw() {
  return Mf || (Mf = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        z("error", t, p);
      }
    }
    function z(t, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, A = v.getStackAddendum();
        A !== "" && (c += "%s", p = p.concat([A]));
        var L = p.map(function(F) {
          return String(F);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, I = !1, T = !1, U = !1, Q = !1, J;
    J = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === u || U || t === g || $ || I || T || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function X(t, c, p) {
      var v = t.displayName;
      if (v)
        return v;
      var A = c.displayName || c.name || "";
      return A !== "" ? p + "(" + A + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return X(t, t.render, "ForwardRef");
          case f:
            var v = t.displayName || null;
            return v !== null ? v : O(t.type) || "Memo";
          case h: {
            var A = t, L = A._payload, F = A._init;
            try {
              return O(F(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, ue, ce, fe, W, xe, Ie;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ve = console.log, ue = console.info, ce = console.warn, fe = console.error, W = console.group, xe = console.groupCollapsed, Ie = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: ue
            }),
            warn: q({}, t, {
              value: ce
            }),
            error: q({}, t, {
              value: fe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: xe
            }),
            groupEnd: q({}, t, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Me;
    function $e(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (A) {
            var v = A.stack.trim().match(/\n( *(at )?)/);
            Me = v && v[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var ze = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(t, c) {
      if (!t || ze)
        return "";
      {
        var p = Re.get(t);
        if (p !== void 0)
          return p;
      }
      var v;
      ze = !0;
      var A = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, qe();
      try {
        if (c) {
          var F = function() {
            throw Error();
          };
          if (Object.defineProperty(F.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(F, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(t, [], F);
          } else {
            try {
              F.call();
            } catch (ne) {
              v = ne;
            }
            t.call(F.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), G = j.length - 1, _ = te.length - 1; G >= 1 && _ >= 0 && j[G] !== te[_]; )
            _--;
          for (; G >= 1 && _ >= 0; G--, _--)
            if (j[G] !== te[_]) {
              if (G !== 1 || _ !== 1)
                do
                  if (G--, _--, _ < 0 || j[G] !== te[_]) {
                    var Z = `
` + j[G].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (G >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Oe.current = L, Be(), Error.prepareStackTrace = A;
      }
      var de = t ? t.displayName || t.name : "", Se = de ? $e(de) : "";
      return typeof t == "function" && Re.set(t, Se), Se;
    }
    function Ge(t, c, p) {
      return Ee(t, !1);
    }
    function Qe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function he(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Qe(t));
      if (typeof t == "string")
        return $e(t);
      switch (t) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ge(t.render);
          case f:
            return he(t.type, c, p);
          case h: {
            var v = t, A = v._payload, L = v._init;
            try {
              return he(L(A), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, De = {}, Le = w.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = he(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(t, c, p, v, A) {
      {
        var L = Function.call.bind(ge);
        for (var F in t)
          if (L(t, F)) {
            var j = void 0;
            try {
              if (typeof t[F] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + F + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[F] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[F](c, F, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (G) {
              j = G;
            }
            j && !(j instanceof Error) && (Ae(A), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, F, typeof j), Ae(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Ae(A), y("Failed %s type: %s", p, j.message), Ae(null));
          }
      }
    }
    var E = Array.isArray;
    function x(t) {
      return E(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var V = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, me, Ne;
    function nn(t) {
      if (ge.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function fn(t) {
      if (ge.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && V.current;
    }
    function cn(t, c) {
      {
        var p = function() {
          me || (me = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(t, c, p, v, A, L, F) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: F,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: A
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, v, A) {
      {
        var L, F = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), fn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ge.call(c, L) && !ie.hasOwnProperty(L) && (F[L] = c[L]);
        if (t && t.defaultProps) {
          var G = t.defaultProps;
          for (L in G)
            F[L] === void 0 && (F[L] = G[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && cn(F, _), te && pn(F, _);
        }
        return dn(t, j, te, A, v, V.current, F);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = he(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var t = O(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        t && t._owner && t._owner !== en.current && (v = " It was passed a child from " + O(t._owner.type) + "."), Pe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Pe(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var v = t[p];
            sn(v) && gn(v, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var A = N(t);
          if (typeof A == "function" && A !== t.entries)
            for (var L = A.call(t), F; !(F = L.next()).done; )
              sn(F.value) && gn(F.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          mn(p, t.props, "prop", v, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var A = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", A || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Pe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Pe(null);
            break;
          }
        }
        t.ref !== null && (Pe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Pe(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, v, A, L) {
      {
        var F = ae(t);
        if (!F) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var G;
          t === null ? G = "null" : x(t) ? G = "array" : t !== void 0 && t.$$typeof === n ? (G = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : G = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", G, j);
        }
        var _ = xn(t, c, p, A, L);
        if (_ == null)
          return _;
        if (F) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var de = 0; de < Z.length; de++)
                  Cn(Z[de], t);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, t);
        }
        if (ge.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, Se, $n, Se), Sn[Se + Ke] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Ro.Fragment = i, Ro.jsx = Rn, Ro.jsxs = Mn;
  })()), Ro;
}
var Bf;
function jw() {
  return Bf || (Bf = 1, process.env.NODE_ENV === "production" ? jl.exports = Sw() : jl.exports = Nw()), jl.exports;
}
var oe = jw();
const ww = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "exportUserDetails" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_ExportedUserDetails" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "users" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "braze_id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "dob" } }, { kind: "Field", name: { kind: "Name", value: "home_city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "language" } }, { kind: "Field", name: { kind: "Name", value: "time_zone" } }, { kind: "Field", name: { kind: "Name", value: "total_revenue" } }, { kind: "Field", name: { kind: "Name", value: "push_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "email_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "custom_attributes" } }, { kind: "Field", name: { kind: "Name", value: "apps" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "platform" } }, { kind: "Field", name: { kind: "Name", value: "version" } }, { kind: "Field", name: { kind: "Name", value: "sessions" } }, { kind: "Field", name: { kind: "Name", value: "first_used" } }, { kind: "Field", name: { kind: "Name", value: "last_used" } }] } }, { kind: "Field", name: { kind: "Name", value: "devices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "model" } }, { kind: "Field", name: { kind: "Name", value: "os" } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "idfv" } }, { kind: "Field", name: { kind: "Name", value: "idfa" } }, { kind: "Field", name: { kind: "Name", value: "google_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "roku_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "ad_tracking_enabled" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_events" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "purchases" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_BasicResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] } }] }, Cw = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_updateEmailSubscriptionStatus_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] }, Fw = {
  "\n  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {\n    Braze {\n      exportUserDetails(input: $input) {\n        ... on Braze_exportUserDetails_response {\n          ... on Braze_ExportedUserDetails {\n            message\n            users {\n              external_id\n              braze_id\n              created_at\n              email\n              first_name\n              last_name\n              dob\n              home_city\n              country\n              phone\n              language\n              time_zone\n              total_revenue\n              push_subscribe\n              email_subscribe\n              custom_attributes\n              apps {\n                name\n                platform\n                version\n                sessions\n                first_used\n                last_used\n              }\n              devices {\n                model\n                os\n                carrier\n                idfv\n                idfa\n                google_ad_id\n                roku_ad_id\n                ad_tracking_enabled\n              }\n              custom_events {\n                name\n                first\n                last\n                count\n              }\n              purchases {\n                name\n                first\n                last\n                count\n              }\n            }\n          }\n\n          ... on Braze_BasicResponse {\n            message\n          }\n        }\n      }\n    }\n  }\n": ww,
  "\n  mutation updateEmailSubscriptionStatus(\n    $input: Braze_updateEmailSubscriptionStatus_request_Input!\n  ) {\n    Braze {\n      updateEmailSubscriptionStatus(input: $input) {\n        message\n      }\n    }\n  }\n": Cw
};
function $x(e) {
  return Fw[e] ?? {};
}
const Iw = $x(
  /* GraphQL */
  `
  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {
    Braze {
      exportUserDetails(input: $input) {
        ... on Braze_exportUserDetails_response {
          ... on Braze_ExportedUserDetails {
            message
            users {
              external_id
              braze_id
              created_at
              email
              first_name
              last_name
              dob
              home_city
              country
              phone
              language
              time_zone
              total_revenue
              push_subscribe
              email_subscribe
              custom_attributes
              apps {
                name
                platform
                version
                sessions
                first_used
                last_used
              }
              devices {
                model
                os
                carrier
                idfv
                idfa
                google_ad_id
                roku_ad_id
                ad_tracking_enabled
              }
              custom_events {
                name
                first
                last
                count
              }
              purchases {
                name
                first
                last
                count
              }
            }
          }

          ... on Braze_BasicResponse {
            message
          }
        }
      }
    }
  }
`
), Ew = $x(
  /* GraphQL */
  `
  mutation updateEmailSubscriptionStatus(
    $input: Braze_updateEmailSubscriptionStatus_request_Input!
  ) {
    Braze {
      updateEmailSubscriptionStatus(input: $input) {
        message
      }
    }
  }
`
), Tw = "_copyIcon_1wjfs_48", $w = "_list_1wjfs_53", Dw = "_listItem_1wjfs_63", Rw = "_collapsible_1wjfs_72", Ow = "_collapsibleIsOpen_1wjfs_80", Aw = "_collapsibleHeader_1wjfs_83", Pw = "_collapsibleIconTrue_1wjfs_86", Lw = "_collapsibleIconFalse_1wjfs_89", On = {
  copyIcon: Tw,
  list: $w,
  listItem: Dw,
  collapsible: Rw,
  collapsibleIsOpen: Ow,
  collapsibleHeader: Aw,
  collapsibleIconTrue: Pw,
  collapsibleIconFalse: Lw
}, Vw = ({
  app: e,
  openByDefault: n
}) => {
  const [r, i] = le(n);
  if (!e)
    return null;
  const {
    name: a,
    platform: o,
    version: s,
    sessions: l,
    first_used: d,
    last_used: m
  } = e;
  return /* @__PURE__ */ oe.jsxs(
    b,
    {
      className: it(On.collapsible, {
        [On.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ oe.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: On.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "1", children: a }),
              /* @__PURE__ */ oe.jsx(
                nr,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ oe.jsxs(Ye, { className: On.list, children: [
          /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "3", children: "Platform" }),
            /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "5", color: "secondary", children: o })
          ] }) }),
          /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "3", children: "Version" }),
            /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "3", children: "Sessions" }),
            /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "3", children: "First used" }),
            /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "5", color: "secondary", children: Ln(d).format(xt) })
          ] }) }),
          /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "3", children: "Last used" }),
            /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "5", color: "secondary", children: Ln(m).format(xt) })
          ] }) })
        ] })
      ]
    }
  );
}, zw = ({ apps: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ oe.jsx(P.Heading, { variant: "heading-3", children: "Apps" }),
      n && /* @__PURE__ */ oe.jsx(An, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ oe.jsx(
      P.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no apps associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ oe.jsx(Vw, { app: r, openByDefault: i === 0 }, i))
  ] });
}, Uw = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_attributes: n } = e, r = !!n && Object.keys(n).length > 0;
  return /* @__PURE__ */ oe.jsx(oe.Fragment, { children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ oe.jsx(P.Heading, { variant: "heading-3", children: "Custom attributes" }),
    !r && /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom attributes available" }),
    r && /* @__PURE__ */ oe.jsx(Ye, { className: On.list, children: Object.entries(
      n
    ).map(([i, a], o) => (typeof a == "boolean" || typeof a == "string" || typeof a == "number") && /* @__PURE__ */ oe.jsx(
      Ye.Text,
      {
        variant: "dense",
        className: On.listItem,
        children: /* @__PURE__ */ oe.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "4", children: i }),
          po(a)
        ] })
      },
      o
    )) })
  ] }) });
}, Mw = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_events: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ oe.jsx(oe.Fragment, { children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ oe.jsx(P.Heading, { variant: "heading-3", children: "Custom events" }),
    !i && /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom events available" }),
    i && /* @__PURE__ */ oe.jsx(Ye, { className: On.list, children: r.map((a, o) => /* @__PURE__ */ oe.jsx(
      Ye.Text,
      {
        variant: "dense",
        className: On.listItem,
        children: /* @__PURE__ */ oe.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ oe.jsx(
            We,
            {
              content: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ oe.jsx(b, { children: `First ${Ln(a?.first).format(
                  xt
                )}` }),
                /* @__PURE__ */ oe.jsx(b, { children: `Last ${Ln(a?.last).format(
                  xt
                )}` })
              ] }),
              children: /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, ws = ({
  state: e,
  noTooltip: n = !1,
  isPush: r = !1
}) => {
  if (!e) return null;
  const i = e === "subscribed", a = e === "unsubscribed", o = () => i ? "exclamation" : a ? "close-circle-filled" : "check-circle-filled", s = () => i ? "neutral.500" : a ? "red.500" : "green.500", l = () => {
    const d = r ? "push notifications" : "emails";
    return i ? `Default case "subscribed": The user has neither unsubscribed nor explicitly opted-in to receive ${d}. This is the default subscription state when a user profile is created.` : a ? `Unsubscribed: The user has explicitly unsubscribed from receiving ${d}.` : `Opted in: The user has explicitly confirmed they want to receive ${d}.`;
  };
  return /* @__PURE__ */ oe.jsx(We, { content: n ? null : l(), children: /* @__PURE__ */ oe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ oe.jsx(pe, { size: 14, name: o(), color: s() }) }) });
}, Bw = "_wrapper_1xucg_1", qw = "_externalLink_1xucg_7", wl = {
  wrapper: Bw,
  externalLink: qw
}, Hw = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = or(), { isCopied: i, copy: a } = or(), { isCopied: o, copy: s } = or(), { isCopied: l, copy: d } = or(), { isCopied: m, copy: u } = or();
  if (!e)
    return null;
  const {
    external_id: f,
    braze_id: h,
    first_name: g,
    last_name: C,
    home_city: S,
    country: N,
    email: w,
    phone: y,
    dob: z,
    created_at: $,
    email_subscribe: I,
    push_subscribe: T
  } = e, U = 14, Q = `${g || ""} ${C || ""}`.trim() || "A customer has no name", J = `${S ? `${S} /` : ""} ${N || ""}`.trim(), ae = z ? Ln(z).isSame(Date.now(), "day") : !1;
  return /* @__PURE__ */ oe.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ oe.jsxs(b, { className: wl.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ oe.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: wl.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ oe.jsx(P.Heading, { variant: "heading-2", children: Q }),
          ae && /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    $ && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "4", children: Ln($).format(xt) })
    ] }),
    J && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(pe, { size: U, name: "map-pin" }),
        /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "4", children: J })
      ] }),
      /* @__PURE__ */ oe.jsx(We, { content: "Copy location", children: /* @__PURE__ */ oe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ oe.jsx(
        pe,
        {
          size: U,
          name: o ? "done" : "copy",
          onClick: () => s(J),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    w && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(pe, { size: U, name: "mail" }),
        /* @__PURE__ */ oe.jsx("span", { className: wl.externalLink, children: w })
      ] }),
      /* @__PURE__ */ oe.jsx(We, { content: "Copy email", children: /* @__PURE__ */ oe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ oe.jsx(
        pe,
        {
          size: U,
          name: n ? "done" : "copy",
          onClick: () => r(w),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    y && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(pe, { size: U, name: "phone" }),
        /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "4", children: y })
      ] }),
      /* @__PURE__ */ oe.jsx(We, { content: "Copy phone number", children: /* @__PURE__ */ oe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ oe.jsx(
        pe,
        {
          size: U,
          name: i ? "done" : "copy",
          onClick: () => a(y),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    h && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(pe, { size: U, name: "user" }),
        /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "4", children: "Braze ID" }),
        /* @__PURE__ */ oe.jsxs(P.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          h,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ oe.jsx(We, { content: "Copy Braze ID", children: /* @__PURE__ */ oe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ oe.jsx(
        pe,
        {
          size: U,
          name: l ? "done" : "copy",
          onClick: () => d(h),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    f && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(pe, { size: U, name: "tag" }),
        /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "4", children: "External ID" }),
        /* @__PURE__ */ oe.jsxs(P.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          f,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ oe.jsx(We, { content: "Copy External ID", children: /* @__PURE__ */ oe.jsx(b, { alignItems: "center", children: /* @__PURE__ */ oe.jsx(
        pe,
        {
          size: U,
          name: m ? "done" : "copy",
          onClick: () => u(f),
          className: On.copyIcon
        }
      ) }) })
    ] }),
    I && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(pe, { size: U, name: "sync" }),
        /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ oe.jsx(ws, { state: I })
    ] }),
    T && /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(pe, { size: U, name: "bell" }),
        /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "4", children: "Push notification subscription state" })
      ] }),
      /* @__PURE__ */ oe.jsx(ws, { isPush: !0, state: T })
    ] })
  ] }) });
}, Ww = ({
  device: e,
  openByDefault: n
}) => {
  const [r, i] = le(n);
  if (!e)
    return null;
  const a = 14, {
    model: o,
    os: s,
    carrier: l,
    ad_tracking_enabled: d,
    idfa: m,
    idfv: u,
    google_ad_id: f,
    roku_ad_id: h
  } = e;
  return /* @__PURE__ */ oe.jsxs(
    b,
    {
      className: it(On.collapsible, {
        [On.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ oe.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: On.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "1", children: o }),
              /* @__PURE__ */ oe.jsx(
                nr,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ oe.jsxs(Ye, { className: On.list, children: [
          /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "3", children: "OS" }),
            /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "3", children: "Carrier" }),
            /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "3", children: "Ad tracking enabled" }),
            /* @__PURE__ */ oe.jsx(
              pe,
              {
                size: a,
                className: it({
                  [On.collapsibleIconTrue]: d,
                  [On.collapsibleIconFalse]: !d
                }),
                name: d ? "check-circle-filled" : "close-circle-filled"
              }
            )
          ] }) }),
          /* @__PURE__ */ oe.jsx(We, { content: "The Apple Identifier for Vendor (iOS)", children: /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "3", children: "Braze device identifier" }),
                /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "5", color: "secondary", children: u })
              ]
            }
          ) }) }),
          /* @__PURE__ */ oe.jsx(We, { content: "For iOS", children: /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "3", children: "Identifier for Advertising" }),
                /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "5", color: "secondary", children: m })
              ]
            }
          ) }) }),
          /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "3", children: "Roku Advertising id" }),
                /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "5", color: "secondary", children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "3", children: "Google Play Advertising id" }),
                /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "5", color: "secondary", children: f })
              ]
            }
          ) })
        ] })
      ]
    }
  );
}, Gw = ({ devices: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ oe.jsx(P.Heading, { variant: "heading-3", children: "Devices" }),
      n && /* @__PURE__ */ oe.jsx(An, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ oe.jsx(
      P.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no devices associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ oe.jsx(Ww, { device: r, openByDefault: i === 0 }, i))
  ] });
}, ba = {
  optIn: {
    label: "Opt in",
    icon: "check-circle-filled",
    color: "var(--dixa-color-green-500)",
    tooltipContent: "Opt in to receive emails",
    parameter: "opted_in"
  },
  unsubscribe: {
    label: "Unsubscribe",
    icon: "close-circle-filled",
    color: "var(--dixa-color-red-500)",
    tooltipContent: "Unsubscribe from emails",
    parameter: "unsubscribed"
  }
}, Oo = ({
  email: e,
  updateTo: n,
  refetchCustomerDetails: r
}) => {
  const { track: i } = _n(), { useMutation: a } = hn(), [o, s] = le(!1), [l] = a(
    Ew,
    {
      onCompleted: (m) => {
        m?.Braze?.updateEmailSubscriptionStatus?.message === "success" && i(n === "optIn" ? "braze:email:subscription:opt-in:succeeded" : "braze:email:subscription:unsubscribe:succeeded");
      }
    }
  ), d = async () => {
    s(!0), await l({
      variables: {
        input: {
          email: e,
          // eslint-disable-next-line camelcase
          subscription_state: ba[n].parameter
        }
      }
    }), setTimeout(async () => {
      await r().finally(() => s(!1));
    }, 500);
  };
  return /* @__PURE__ */ oe.jsx(We, { content: ba[n].tooltipContent, children: /* @__PURE__ */ oe.jsx(
    Gn,
    {
      variant: "secondary",
      color: ba[n].color,
      isLoading: o,
      onClick: () => d(),
      "data-testid": "braze-subscription-button",
      children: /* @__PURE__ */ oe.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(
          ws,
          {
            noTooltip: !0,
            state: ba[n].parameter
          }
        ),
        ba[n].label
      ] })
    }
  ) });
}, Kw = ({
  customerDetails: e,
  showCustomerDetails: n,
  refetchCustomerDetails: r
}) => {
  if (!e)
    return null;
  const { email: i, email_subscribe: a } = e;
  if (!i)
    return null;
  const o = a === "subscribed", s = a === "unsubscribed", l = a === "opted_in";
  return /* @__PURE__ */ oe.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ oe.jsx(P.Heading, { variant: "heading-3", children: "Update Email subscription state" }),
    !n && /* @__PURE__ */ oe.jsx(Ye, { className: On.list, children: /* @__PURE__ */ oe.jsx(Ye.Text, { variant: "dense", className: On.listItem, children: /* @__PURE__ */ oe.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ oe.jsx(pe, { size: 14, name: "sync" }),
        /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ oe.jsx(ws, { state: a })
    ] }) }) }),
    /* @__PURE__ */ oe.jsxs(b, { gap: "200", alignItems: "center", children: [
      o && /* @__PURE__ */ oe.jsxs(oe.Fragment, { children: [
        /* @__PURE__ */ oe.jsx(
          Oo,
          {
            email: i,
            updateTo: "optIn",
            refetchCustomerDetails: r
          }
        ),
        /* @__PURE__ */ oe.jsx(
          Oo,
          {
            email: i,
            updateTo: "unsubscribe",
            refetchCustomerDetails: r
          }
        )
      ] }),
      s && /* @__PURE__ */ oe.jsx(
        Oo,
        {
          email: i,
          updateTo: "optIn",
          refetchCustomerDetails: r
        }
      ),
      l && /* @__PURE__ */ oe.jsx(
        Oo,
        {
          email: i,
          updateTo: "unsubscribe",
          refetchCustomerDetails: r
        }
      )
    ] })
  ] }) });
}, Yw = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { purchases: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ oe.jsx(oe.Fragment, { children: /* @__PURE__ */ oe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ oe.jsx(P.Heading, { variant: "heading-3", children: "Purchases" }),
    !i && /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No purchases available" }),
    i && /* @__PURE__ */ oe.jsx(Ye, { className: On.list, children: r.map((a, o) => /* @__PURE__ */ oe.jsx(
      Ye.Text,
      {
        variant: "dense",
        className: On.listItem,
        children: /* @__PURE__ */ oe.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ oe.jsx(
            We,
            {
              content: /* @__PURE__ */ oe.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ oe.jsx(b, { children: `First ${Ln(a?.first).format(
                  xt
                )}` }),
                /* @__PURE__ */ oe.jsx(b, { children: `Last ${Ln(a?.last).format(
                  xt
                )}` })
              ] }),
              children: /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ oe.jsx(P.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, Qw = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = _n(), { useMutation: i } = hn(), [a, o] = le(), [s, l] = le(!1), [d, m] = le(!1), u = e?.customer?.email, f = e?.customer?.phone_number, h = n.displayCustomerDetails ?? !1, g = n.updateEmailSubscriptionState ?? !1, C = n.displayCustomAttributes ?? !1, S = n.displayCustomEvents ?? !1, N = n.displayPuchases ?? !1, w = n.displayDevices ?? !1, y = n.displayApps ?? !1, z = !h && !g && !C && !S && !N, [$, { error: I }] = i(
    Iw,
    {
      onError: () => {
      },
      onCompleted: (U) => {
        const Q = U?.Braze?.exportUserDetails?.users?.[0];
        Q ? (o(Q), l(!1), r("braze:profile:received")) : (o(void 0), l(!0));
      }
    }
  ), T = async () => {
    u || f ? await $({
      variables: {
        input: {
          // Use the email if exists. Otherwise use the phone number. We decided
          // to not search for both together, because we receive a customer
          // entity for each input parameter and we only want one.
          /* eslint-disable camelcase */
          ...u ? { email_address: u } : { phone: f },
          fields_to_export: [
            "external_id",
            "braze_id",
            "created_at",
            "email",
            "first_name",
            "last_name",
            "dob",
            "home_city",
            "country",
            "phone",
            "language",
            "time_zone",
            "total_revenue",
            "push_subscribe",
            "email_subscribe",
            "custom_attributes",
            "custom_events",
            "purchases",
            "apps",
            "devices"
          ]
          /* eslint-enable camelcase */
        }
      }
    }) : l(!0);
  };
  if (He(() => {
    async function U() {
      m(!0), await T();
    }
    U().finally(() => m(!1));
  }, [u, f]), I) {
    const U = I.graphQLErrors;
    return Vm({ errors: U }) ? /* @__PURE__ */ oe.jsx(
      P.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API key used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : zm({ errors: U }) ? /* @__PURE__ */ oe.jsx(
      P.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Braze. Please contact your administrator."
      }
    ) : /* @__PURE__ */ oe.jsx(Fn, { error: I });
  }
  return d ? /* @__PURE__ */ oe.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ oe.jsx(un, {}) }) : z ? /* @__PURE__ */ oe.jsx(
    P.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : s ? /* @__PURE__ */ oe.jsx(
    P.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-customer-found",
      children: "No customer found with this email or phone number."
    }
  ) : /* @__PURE__ */ oe.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ oe.jsx(Hw, { customerDetails: a }),
        g && !!a && /* @__PURE__ */ oe.jsx(
          Kw,
          {
            customerDetails: a,
            showCustomerDetails: h,
            refetchCustomerDetails: async () => await T()
          }
        ),
        C && !!a && /* @__PURE__ */ oe.jsx(Uw, { customerDetails: a }),
        S && !!a && /* @__PURE__ */ oe.jsx(Mw, { customerDetails: a }),
        N && !!a && /* @__PURE__ */ oe.jsx(Yw, { customerDetails: a }),
        w && !!a && /* @__PURE__ */ oe.jsx(Gw, { devices: a?.devices }),
        y && !!a && /* @__PURE__ */ oe.jsx(zw, { apps: a?.apps })
      ]
    }
  );
}, Jw = [
  {
    key: "apiHostName",
    label: "API endpoint",
    placeholder: "REST API endpoint for your region, e.g. rest.iad-01.braze.com",
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => Hb(e)
  },
  {
    key: "brazeApiKey",
    label: "API key",
    placeholder: "Insert your API key",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "displayCustomerDetails",
    label: "Display customer details",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "updateEmailSubscriptionState",
    label: "Display the button to change the email subscription state",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayCustomAttributes",
    label: "Display a list of custom attributes",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayCustomEvents",
    label: "Display a list of custom events",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayPuchases",
    label: "Display a list of purchases",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayDevices",
    label: "Display customer devices",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayApps",
    label: "Display customer apps",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  }
];
function Xw() {
  var e = ki(!1), n = ot(function() {
    return e.current;
  }, []);
  return He(function() {
    return e.current = !0, function() {
      e.current = !1;
    };
  }, []), n;
}
var Zw = function(e) {
  e === void 0 && (e = {});
  var n = le(e), r = n[0], i = n[1], a = ot(function(o) {
    i(function(s) {
      return Object.assign({}, s, o instanceof Function ? o(s) : o);
    });
  }, []);
  return [r, a];
}, eC = function(e, n) {
  return typeof n == "boolean" ? n : !e;
}, qf = function(e) {
  return N0(eC, e);
}, Cl, Hf;
function nC() {
  return Hf || (Hf = 1, Cl = function() {
    var e = document.getSelection();
    if (!e.rangeCount)
      return function() {
      };
    for (var n = document.activeElement, r = [], i = 0; i < e.rangeCount; i++)
      r.push(e.getRangeAt(i));
    switch (n.tagName.toUpperCase()) {
      // .toUpperCase handles XHTML
      case "INPUT":
      case "TEXTAREA":
        n.blur();
        break;
      default:
        n = null;
        break;
    }
    return e.removeAllRanges(), function() {
      e.type === "Caret" && e.removeAllRanges(), e.rangeCount || r.forEach(function(a) {
        e.addRange(a);
      }), n && n.focus();
    };
  }), Cl;
}
var Fl, Wf;
function tC() {
  if (Wf) return Fl;
  Wf = 1;
  var e = nC(), n = {
    "text/plain": "Text",
    "text/html": "Url",
    default: "Text"
  }, r = "Copy to clipboard: #{key}, Enter";
  function i(o) {
    var s = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
    return o.replace(/#{\s*key\s*}/g, s);
  }
  function a(o, s) {
    var l, d, m, u, f, h, g = !1;
    s || (s = {}), l = s.debug || !1;
    try {
      m = e(), u = document.createRange(), f = document.getSelection(), h = document.createElement("span"), h.textContent = o, h.ariaHidden = "true", h.style.all = "unset", h.style.position = "fixed", h.style.top = 0, h.style.clip = "rect(0, 0, 0, 0)", h.style.whiteSpace = "pre", h.style.webkitUserSelect = "text", h.style.MozUserSelect = "text", h.style.msUserSelect = "text", h.style.userSelect = "text", h.addEventListener("copy", function(S) {
        if (S.stopPropagation(), s.format)
          if (S.preventDefault(), typeof S.clipboardData > "u") {
            l && console.warn("unable to use e.clipboardData"), l && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
            var N = n[s.format] || n.default;
            window.clipboardData.setData(N, o);
          } else
            S.clipboardData.clearData(), S.clipboardData.setData(s.format, o);
        s.onCopy && (S.preventDefault(), s.onCopy(S.clipboardData));
      }), document.body.appendChild(h), u.selectNodeContents(h), f.addRange(u);
      var C = document.execCommand("copy");
      if (!C)
        throw new Error("copy command was unsuccessful");
      g = !0;
    } catch (S) {
      l && console.error("unable to copy using execCommand: ", S), l && console.warn("trying IE specific stuff");
      try {
        window.clipboardData.setData(s.format || "text", o), s.onCopy && s.onCopy(window.clipboardData), g = !0;
      } catch (N) {
        l && console.error("unable to copy using clipboardData: ", N), l && console.error("falling back to prompt"), d = i("message" in s ? s.message : r), window.prompt(d, o);
      }
    } finally {
      f && (typeof f.removeRange == "function" ? f.removeRange(u) : f.removeAllRanges()), h && document.body.removeChild(h), m();
    }
    return g;
  }
  return Fl = a, Fl;
}
var rC = tC();
const iC = /* @__PURE__ */ Gm(rC);
var Dx = function() {
  var e = Xw(), n = Zw({
    value: void 0,
    error: void 0,
    noUserInteraction: !0
  }), r = n[0], i = n[1], a = ot(function(o) {
    if (e()) {
      var s, l;
      try {
        if (typeof o != "string" && typeof o != "number") {
          var d = new Error("Cannot copy typeof " + typeof o + " to clipboard, must be a string");
          process.env.NODE_ENV === "development" && console.error(d), i({
            value: o,
            error: d,
            noUserInteraction: !0
          });
          return;
        } else if (o === "") {
          var d = new Error("Cannot copy empty string to clipboard.");
          process.env.NODE_ENV === "development" && console.error(d), i({
            value: o,
            error: d,
            noUserInteraction: !0
          });
          return;
        }
        l = o.toString(), s = iC(l), i({
          value: l,
          error: void 0,
          noUserInteraction: s
        });
      } catch (m) {
        i({
          value: l,
          error: m,
          noUserInteraction: s
        });
      }
    }
  }, []);
  return [r, a];
};
function aC(e, n) {
  n === void 0 && (n = 0);
  var r = ki(!1), i = ki(), a = ki(e), o = ot(function() {
    return r.current;
  }, []), s = ot(function() {
    r.current = !1, i.current && clearTimeout(i.current), i.current = setTimeout(function() {
      r.current = !0, a.current();
    }, n);
  }, [n]), l = ot(function() {
    r.current = null, i.current && clearTimeout(i.current);
  }, []);
  return He(function() {
    a.current = e;
  }, [e]), He(function() {
    return s(), l;
  }, [n]), [o, l, s];
}
function $i(e, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = []);
  var i = aC(e, n), a = i[0], o = i[1], s = i[2];
  return He(s, r), [a, o];
}
var oC = function(e) {
  He(e, []);
}, sC = function(e, n) {
  var r = ki(function() {
  });
  He(function() {
    r.current = e;
  }), He(function() {
    if (n !== null) {
      var i = setInterval(function() {
        return r.current();
      }, n || 0);
      return function() {
        return clearInterval(i);
      };
    }
  }, [n]);
}, lC = function(e) {
  e === void 0 && (e = {});
  var n = le(e), r = n[0], i = n[1], a = Bn(function() {
    return {
      set: function(s, l) {
        i(function(d) {
          var m;
          return yl(yl({}, d), (m = {}, m[s] = l, m));
        });
      },
      setAll: function(s) {
        i(s);
      },
      remove: function(s) {
        i(function(l) {
          var d = l, m = s;
          d[m];
          var u = q0(d, [typeof m == "symbol" ? m : m + ""]);
          return u;
        });
      },
      reset: function() {
        return i(e);
      }
    };
  }, [i]), o = yl({ get: ot(function(s) {
    return r[s];
  }, [r]) }, a);
  return [r, o];
}, cC = function(e) {
  var n = ki(e);
  n.current = e, oC(function() {
    return function() {
      return n.current();
    };
  });
}, No = (e) => e.type === "checkbox", yi = (e) => e instanceof Date, Bt = (e) => e == null;
const Rx = (e) => typeof e == "object";
var mt = (e) => !Bt(e) && !Array.isArray(e) && Rx(e) && !yi(e), Ox = (e) => mt(e) && e.target ? No(e.target) ? e.target.checked : e.target.value : e, dC = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, Ax = (e, n) => e.has(dC(n)), uC = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return mt(n) && n.hasOwnProperty("isPrototypeOf");
}, ip = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Ct(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(ip && (e instanceof Blob || i)) && (r || mt(e)))
    if (n = r ? [] : {}, !r && !uC(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = Ct(e[a]));
  else
    return e;
  return n;
}
var tl = (e) => Array.isArray(e) ? e.filter(Boolean) : [], lt = (e) => e === void 0, Je = (e, n, r) => {
  if (!n || !mt(e))
    return r;
  const i = tl(n.split(/[,[\].]+?/)).reduce((a, o) => Bt(a) ? a : a[o], e);
  return lt(i) || i === e ? lt(e[n]) ? r : e[n] : i;
}, rr = (e) => typeof e == "boolean", ap = (e) => /^\w*$/.test(e), Px = (e) => tl(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Kn = (e, n, r) => {
  let i = -1;
  const a = ap(n) ? [n] : Px(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = mt(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const Cs = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, vr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Mr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, Lx = Fe.createContext(null), Vr = () => Fe.useContext(Lx), op = (e) => {
  const { children: n, ...r } = e;
  return Fe.createElement(Lx.Provider, { value: r }, n);
};
var Vx = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== vr.all && (n._proxyFormState[s] = !i || vr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function mC(e) {
  const n = Vr(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = Fe.useState(r._formState), d = Fe.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = Fe.useRef(a);
  return m.current = a, Fe.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), Fe.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), Fe.useMemo(() => Vx(s, r, d.current, !1), [s, r]);
}
var Dr = (e) => typeof e == "string", zx = (e, n, r, i, a) => Dr(e) ? (i && n.watch.add(e), Je(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Je(r, o))) : (i && (n.watchAll = !0), r);
function fs(e) {
  const n = Vr(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = Fe.useRef(i), d = Fe.useRef(a);
  l.current = i, Fe.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(zx(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = Fe.useState(r._getWatch(i, a));
  return Fe.useEffect(() => r._removeUnmounted()), m;
}
function sp(e) {
  const n = Vr(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = Ax(a._names.array, r), l = fs({
    control: a,
    name: r,
    defaultValue: Je(a._formValues, r, Je(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = mC({
    control: a,
    name: r,
    exact: !0
  }), m = Fe.useRef(e), u = Fe.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...rr(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Fe.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Je(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Je(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Je(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Je(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => Je(d.errors, r)
    }
  }), [d, r]), h = Fe.useCallback((N) => u.current.onChange({
    target: {
      value: Ox(N),
      name: r
    },
    type: Cs.CHANGE
  }), [r]), g = Fe.useCallback(() => u.current.onBlur({
    target: {
      value: Je(a._formValues, r),
      name: r
    },
    type: Cs.BLUR
  }), [r, a._formValues]), C = Fe.useCallback((N) => {
    const w = Je(a._fields, r);
    w && N && (w._f.ref = {
      focus: () => N.focus(),
      select: () => N.select(),
      setCustomValidity: (y) => N.setCustomValidity(y),
      reportValidity: () => N.reportValidity()
    });
  }, [a._fields, r]), S = Fe.useMemo(() => ({
    name: r,
    value: l,
    ...rr(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: g,
    ref: C
  }), [r, i, d.disabled, h, g, C, l]);
  return Fe.useEffect(() => {
    const N = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...rr(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const w = (y, z) => {
      const $ = Je(a._fields, y);
      $ && $._f && ($._f.mount = z);
    };
    if (w(r, !0), N) {
      const y = Ct(Je(a._options.defaultValues, r));
      Kn(a._defaultValues, r, y), lt(Je(a._formValues, r)) && Kn(a._formValues, r, y);
    }
    return !s && a.register(r), () => {
      (s ? N && !a._state.action : N) ? a.unregister(r) : w(r, !1);
    };
  }, [r, a, s, o]), Fe.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), Fe.useMemo(() => ({
    field: S,
    formState: d,
    fieldState: f
  }), [S, d, f]);
}
const Wt = (e) => e.render(sp(e));
var pC = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, to = (e) => Array.isArray(e) ? e : [e], Gf = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (a) => {
      for (const o of e)
        o.next && o.next(a);
    },
    subscribe: (a) => (e.push(a), {
      unsubscribe: () => {
        e = e.filter((o) => o !== a);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, mm = (e) => Bt(e) || !Rx(e);
function ti(e, n) {
  if (mm(e) || mm(n))
    return e === n;
  if (yi(e) && yi(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (yi(o) && yi(s) || mt(o) && mt(s) || Array.isArray(o) && Array.isArray(s) ? !ti(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var zt = (e) => mt(e) && !Object.keys(e).length, lp = (e) => e.type === "file", kr = (e) => typeof e == "function", Fs = (e) => {
  if (!ip)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, Ux = (e) => e.type === "select-multiple", cp = (e) => e.type === "radio", fC = (e) => cp(e) || No(e), Il = (e) => Fs(e) && e.isConnected;
function hC(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = lt(e) ? i++ : e[n[i++]];
  return e;
}
function yC(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !lt(e[n]))
      return !1;
  return !0;
}
function vt(e, n) {
  const r = Array.isArray(n) ? n : ap(n) ? [n] : Px(n), i = r.length === 1 ? e : hC(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (mt(i) && zt(i) || Array.isArray(i) && yC(i)) && vt(e, r.slice(0, -1)), e;
}
var Mx = (e) => {
  for (const n in e)
    if (kr(e[n]))
      return !0;
  return !1;
};
function Is(e, n = {}) {
  const r = Array.isArray(e);
  if (mt(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || mt(e[i]) && !Mx(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, Is(e[i], n[i])) : Bt(e[i]) || (n[i] = !0);
  return n;
}
function Bx(e, n, r) {
  const i = Array.isArray(e);
  if (mt(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || mt(e[a]) && !Mx(e[a]) ? lt(n) || mm(r[a]) ? r[a] = Array.isArray(e[a]) ? Is(e[a], []) : { ...Is(e[a]) } : Bx(e[a], Bt(n) ? {} : n[a], r[a]) : r[a] = !ti(e[a], n[a]);
  return r;
}
var xa = (e, n) => Bx(e, n, Is(n));
const Kf = {
  value: !1,
  isValid: !1
}, Yf = { value: !0, isValid: !0 };
var qx = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !lt(e[0].attributes.value) ? lt(e[0].value) || e[0].value === "" ? Yf : { value: e[0].value, isValid: !0 } : Yf
    ) : Kf;
  }
  return Kf;
}, Hx = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => lt(e) ? e : n ? e === "" ? NaN : e && +e : r && Dr(e) ? new Date(e) : i ? i(e) : e;
const Qf = {
  isValid: !1,
  value: null
};
var Wx = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, Qf) : Qf;
function Jf(e) {
  const n = e.ref;
  return lp(n) ? n.files : cp(n) ? Wx(e.refs).value : Ux(n) ? [...n.selectedOptions].map(({ value: r }) => r) : No(n) ? qx(e.refs).value : Hx(lt(n.value) ? e.ref.value : n.value, e);
}
var gC = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = Je(n, o);
    s && Kn(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, Es = (e) => e instanceof RegExp, _a = (e) => lt(e) ? e : Es(e) ? e.source : mt(e) ? Es(e.value) ? e.value.source : e.value : e, Xf = (e) => ({
  isOnSubmit: !e || e === vr.onSubmit,
  isOnBlur: e === vr.onBlur,
  isOnChange: e === vr.onChange,
  isOnAll: e === vr.all,
  isOnTouch: e === vr.onTouched
});
const Zf = "AsyncFunction";
var vC = (e) => !!e && !!e.validate && !!(kr(e.validate) && e.validate.constructor.name === Zf || mt(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === Zf)), kC = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), eh = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const ro = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = Je(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i)
          return !0;
        if (s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (ro(l, n))
          break;
      } else if (mt(l) && ro(l, n))
        break;
    }
  }
};
function nh(e, n, r) {
  const i = Je(e, r);
  if (i || ap(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Je(n, o), l = Je(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var bC = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return zt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || vr.all));
}, xC = (e, n, r) => !e || !n || e === n || to(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), _C = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, SC = (e, n) => !tl(Je(e, n)).length && vt(e, n), NC = (e, n, r) => {
  const i = to(Je(e, r));
  return Kn(i, "root", n[r]), Kn(e, r, i), e;
}, hs = (e) => Dr(e);
function th(e, n, r = "validate") {
  if (hs(e) || Array.isArray(e) && e.every(hs) || rr(e) && !e)
    return {
      type: r,
      message: hs(e) ? e : "",
      ref: n
    };
}
var Li = (e) => mt(e) && !Es(e) ? e : {
  value: e,
  message: ""
}, rh = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: g, validate: C, name: S, valueAsNumber: N, mount: w } = e._f, y = Je(r, S);
  if (!w || n.has(S))
    return {};
  const z = l ? l[0] : s, $ = (B) => {
    a && z.reportValidity && (z.setCustomValidity(rr(B) ? "" : B || ""), z.reportValidity());
  }, I = {}, T = cp(s), U = No(s), Q = T || U, J = (N || lp(s)) && lt(s.value) && lt(y) || Fs(s) && s.value === "" || y === "" || Array.isArray(y) && !y.length, ae = pC.bind(null, S, i, I), X = (B, O, q, ee = Mr.maxLength, ve = Mr.minLength) => {
    const ue = B ? O : q;
    I[S] = {
      type: B ? ee : ve,
      message: ue,
      ref: s,
      ...ae(B ? ee : ve, ue)
    };
  };
  if (o ? !Array.isArray(y) || !y.length : d && (!Q && (J || Bt(y)) || rr(y) && !y || U && !qx(l).isValid || T && !Wx(l).isValid)) {
    const { value: B, message: O } = hs(d) ? { value: !!d, message: d } : Li(d);
    if (B && (I[S] = {
      type: Mr.required,
      message: O,
      ref: z,
      ...ae(Mr.required, O)
    }, !i))
      return $(O), I;
  }
  if (!J && (!Bt(f) || !Bt(h))) {
    let B, O;
    const q = Li(h), ee = Li(f);
    if (!Bt(y) && !isNaN(y)) {
      const ve = s.valueAsNumber || y && +y;
      Bt(q.value) || (B = ve > q.value), Bt(ee.value) || (O = ve < ee.value);
    } else {
      const ve = s.valueAsDate || new Date(y), ue = (W) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + W), ce = s.type == "time", fe = s.type == "week";
      Dr(q.value) && y && (B = ce ? ue(y) > ue(q.value) : fe ? y > q.value : ve > new Date(q.value)), Dr(ee.value) && y && (O = ce ? ue(y) < ue(ee.value) : fe ? y < ee.value : ve < new Date(ee.value));
    }
    if ((B || O) && (X(!!B, q.message, ee.message, Mr.max, Mr.min), !i))
      return $(I[S].message), I;
  }
  if ((m || u) && !J && (Dr(y) || o && Array.isArray(y))) {
    const B = Li(m), O = Li(u), q = !Bt(B.value) && y.length > +B.value, ee = !Bt(O.value) && y.length < +O.value;
    if ((q || ee) && (X(q, B.message, O.message), !i))
      return $(I[S].message), I;
  }
  if (g && !J && Dr(y)) {
    const { value: B, message: O } = Li(g);
    if (Es(B) && !y.match(B) && (I[S] = {
      type: Mr.pattern,
      message: O,
      ref: s,
      ...ae(Mr.pattern, O)
    }, !i))
      return $(O), I;
  }
  if (C) {
    if (kr(C)) {
      const B = await C(y, r), O = th(B, z);
      if (O && (I[S] = {
        ...O,
        ...ae(Mr.validate, O.message)
      }, !i))
        return $(O.message), I;
    } else if (mt(C)) {
      let B = {};
      for (const O in C) {
        if (!zt(B) && !i)
          break;
        const q = th(await C[O](y, r), z, O);
        q && (B = {
          ...q,
          ...ae(O, q.message)
        }, $(q.message), i && (I[S] = B));
      }
      if (!zt(B) && (I[S] = {
        ref: z,
        ...B
      }, !i))
        return I;
    }
  }
  return $(!0), I;
};
const jC = {
  mode: vr.onSubmit,
  reValidateMode: vr.onChange,
  shouldFocusError: !0
};
function wC(e = {}) {
  let n = {
    ...jC,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: kr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = mt(n.defaultValues) || mt(n.values) ? Ct(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : Ct(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: Gf(),
    state: Gf()
  }, g = Xf(n.mode), C = Xf(n.reValidateMode), S = n.criteriaMode === vr.all, N = (x) => (D) => {
    clearTimeout(m), m = setTimeout(x, D);
  }, w = async (x) => {
    if (!n.disabled && (u.isValid || f.isValid || x)) {
      const D = n.resolver ? zt((await J()).errors) : await X(i, !0);
      D !== r.isValid && h.state.next({
        isValid: D
      });
    }
  }, y = (x, D) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((x || Array.from(l.mount)).forEach((H) => {
      H && (D ? Kn(r.validatingFields, H, D) : vt(r.validatingFields, H));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !zt(r.validatingFields)
    }));
  }, z = (x, D = [], H, Y, R = !0, V = !0) => {
    if (Y && H && !n.disabled) {
      if (s.action = !0, V && Array.isArray(Je(i, x))) {
        const ie = H(Je(i, x), Y.argA, Y.argB);
        R && Kn(i, x, ie);
      }
      if (V && Array.isArray(Je(r.errors, x))) {
        const ie = H(Je(r.errors, x), Y.argA, Y.argB);
        R && Kn(r.errors, x, ie), SC(r.errors, x);
      }
      if ((u.touchedFields || f.touchedFields) && V && Array.isArray(Je(r.touchedFields, x))) {
        const ie = H(Je(r.touchedFields, x), Y.argA, Y.argB);
        R && Kn(r.touchedFields, x, ie);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = xa(a, o)), h.state.next({
        name: x,
        isDirty: O(x, D),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Kn(o, x, D);
  }, $ = (x, D) => {
    Kn(r.errors, x, D), h.state.next({
      errors: r.errors
    });
  }, I = (x) => {
    r.errors = x, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, T = (x, D, H, Y) => {
    const R = Je(i, x);
    if (R) {
      const V = Je(o, x, lt(H) ? Je(a, x) : H);
      lt(V) || Y && Y.defaultChecked || D ? Kn(o, x, D ? V : Jf(R._f)) : ve(x, V), s.mount && w();
    }
  }, U = (x, D, H, Y, R) => {
    let V = !1, ie = !1;
    const me = {
      name: x
    };
    if (!n.disabled) {
      if (!H || Y) {
        (u.isDirty || f.isDirty) && (ie = r.isDirty, r.isDirty = me.isDirty = O(), V = ie !== me.isDirty);
        const Ne = ti(Je(a, x), D);
        ie = !!Je(r.dirtyFields, x), Ne ? vt(r.dirtyFields, x) : Kn(r.dirtyFields, x, !0), me.dirtyFields = r.dirtyFields, V = V || (u.dirtyFields || f.dirtyFields) && ie !== !Ne;
      }
      if (H) {
        const Ne = Je(r.touchedFields, x);
        Ne || (Kn(r.touchedFields, x, H), me.touchedFields = r.touchedFields, V = V || (u.touchedFields || f.touchedFields) && Ne !== H);
      }
      V && R && h.state.next(me);
    }
    return V ? me : {};
  }, Q = (x, D, H, Y) => {
    const R = Je(r.errors, x), V = (u.isValid || f.isValid) && rr(D) && r.isValid !== D;
    if (n.delayError && H ? (d = N(() => $(x, H)), d(n.delayError)) : (clearTimeout(m), d = null, H ? Kn(r.errors, x, H) : vt(r.errors, x)), (H ? !ti(R, H) : R) || !zt(Y) || V) {
      const ie = {
        ...Y,
        ...V && rr(D) ? { isValid: D } : {},
        errors: r.errors,
        name: x
      };
      r = {
        ...r,
        ...ie
      }, h.state.next(ie);
    }
  }, J = async (x) => {
    y(x, !0);
    const D = await n.resolver(o, n.context, gC(x || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return y(x), D;
  }, ae = async (x) => {
    const { errors: D } = await J(x);
    if (x)
      for (const H of x) {
        const Y = Je(D, H);
        Y ? Kn(r.errors, H, Y) : vt(r.errors, H);
      }
    else
      r.errors = D;
    return D;
  }, X = async (x, D, H = {
    valid: !0
  }) => {
    for (const Y in x) {
      const R = x[Y];
      if (R) {
        const { _f: V, ...ie } = R;
        if (V) {
          const me = l.array.has(V.name), Ne = R._f && vC(R._f);
          Ne && u.validatingFields && y([Y], !0);
          const nn = await rh(R, l.disabled, o, S, n.shouldUseNativeValidation && !D, me);
          if (Ne && u.validatingFields && y([Y]), nn[V.name] && (H.valid = !1, D))
            break;
          !D && (Je(nn, V.name) ? me ? NC(r.errors, nn, V.name) : Kn(r.errors, V.name, nn[V.name]) : vt(r.errors, V.name));
        }
        !zt(ie) && await X(ie, D, H);
      }
    }
    return H.valid;
  }, B = () => {
    for (const x of l.unMount) {
      const D = Je(i, x);
      D && (D._f.refs ? D._f.refs.every((H) => !Il(H)) : !Il(D._f.ref)) && ze(x);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, O = (x, D) => !n.disabled && (x && D && Kn(o, x, D), !ti(Ie(), a)), q = (x, D, H) => zx(x, l, {
    ...s.mount ? o : lt(D) ? a : Dr(x) ? { [x]: D } : D
  }, H, D), ee = (x) => tl(Je(s.mount ? o : a, x, n.shouldUnregister ? Je(a, x, []) : [])), ve = (x, D, H = {}) => {
    const Y = Je(i, x);
    let R = D;
    if (Y) {
      const V = Y._f;
      V && (!V.disabled && Kn(o, x, Hx(D, V)), R = Fs(V.ref) && Bt(D) ? "" : D, Ux(V.ref) ? [...V.ref.options].forEach((ie) => ie.selected = R.includes(ie.value)) : V.refs ? No(V.ref) ? V.refs.length > 1 ? V.refs.forEach((ie) => (!ie.defaultChecked || !ie.disabled) && (ie.checked = Array.isArray(R) ? !!R.find((me) => me === ie.value) : R === ie.value)) : V.refs[0] && (V.refs[0].checked = !!R) : V.refs.forEach((ie) => ie.checked = ie.value === R) : lp(V.ref) ? V.ref.value = "" : (V.ref.value = R, V.ref.type || h.state.next({
        name: x,
        values: Ct(o)
      })));
    }
    (H.shouldDirty || H.shouldTouch) && U(x, R, H.shouldTouch, H.shouldDirty, !0), H.shouldValidate && xe(x);
  }, ue = (x, D, H) => {
    for (const Y in D) {
      const R = D[Y], V = `${x}.${Y}`, ie = Je(i, V);
      (l.array.has(x) || mt(R) || ie && !ie._f) && !yi(R) ? ue(V, R, H) : ve(V, R, H);
    }
  }, ce = (x, D, H = {}) => {
    const Y = Je(i, x), R = l.array.has(x), V = Ct(D);
    Kn(o, x, V), R ? (h.array.next({
      name: x,
      values: Ct(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && H.shouldDirty && h.state.next({
      name: x,
      dirtyFields: xa(a, o),
      isDirty: O(x, V)
    })) : Y && !Y._f && !Bt(V) ? ue(x, V, H) : ve(x, V, H), eh(x, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? x : void 0,
      values: Ct(o)
    });
  }, fe = async (x) => {
    s.mount = !0;
    const D = x.target;
    let H = D.name, Y = !0;
    const R = Je(i, H), V = (ie) => {
      Y = Number.isNaN(ie) || yi(ie) && isNaN(ie.getTime()) || ti(ie, Je(o, H, ie));
    };
    if (R) {
      let ie, me;
      const Ne = D.type ? Jf(R._f) : Ox(x), nn = x.type === Cs.BLUR || x.type === Cs.FOCUS_OUT, fn = !kC(R._f) && !n.resolver && !Je(r.errors, H) && !R._f.deps || _C(nn, Je(r.touchedFields, H), r.isSubmitted, C, g), tn = eh(H, l, nn);
      Kn(o, H, Ne), nn ? (R._f.onBlur && R._f.onBlur(x), d && d(0)) : R._f.onChange && R._f.onChange(x);
      const cn = U(H, Ne, nn), pn = !zt(cn) || tn;
      if (!nn && h.state.next({
        name: H,
        type: x.type,
        values: Ct(o)
      }), fn)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? nn && w() : nn || w()), pn && h.state.next({ name: H, ...tn ? {} : cn });
      if (!nn && tn && h.state.next({ ...r }), n.resolver) {
        const { errors: dn } = await J([H]);
        if (V(Ne), Y) {
          const xn = nh(r.errors, i, H), en = nh(dn, i, xn.name || H);
          ie = en.error, H = en.name, me = zt(dn);
        }
      } else
        y([H], !0), ie = (await rh(R, l.disabled, o, S, n.shouldUseNativeValidation))[H], y([H]), V(Ne), Y && (ie ? me = !1 : (u.isValid || f.isValid) && (me = await X(i, !0)));
      Y && (R._f.deps && xe(R._f.deps), Q(H, me, ie, cn));
    }
  }, W = (x, D) => {
    if (Je(r.errors, D) && x.focus)
      return x.focus(), 1;
  }, xe = async (x, D = {}) => {
    let H, Y;
    const R = to(x);
    if (n.resolver) {
      const V = await ae(lt(x) ? x : R);
      H = zt(V), Y = x ? !R.some((ie) => Je(V, ie)) : H;
    } else x ? (Y = (await Promise.all(R.map(async (V) => {
      const ie = Je(i, V);
      return await X(ie && ie._f ? { [V]: ie } : ie);
    }))).every(Boolean), !(!Y && !r.isValid) && w()) : Y = H = await X(i);
    return h.state.next({
      ...!Dr(x) || (u.isValid || f.isValid) && H !== r.isValid ? {} : { name: x },
      ...n.resolver || !x ? { isValid: H } : {},
      errors: r.errors
    }), D.shouldFocus && !Y && ro(i, W, x ? R : l.mount), Y;
  }, Ie = (x) => {
    const D = {
      ...s.mount ? o : a
    };
    return lt(x) ? D : Dr(x) ? Je(D, x) : x.map((H) => Je(D, H));
  }, K = (x, D) => ({
    invalid: !!Je((D || r).errors, x),
    isDirty: !!Je((D || r).dirtyFields, x),
    error: Je((D || r).errors, x),
    isValidating: !!Je(r.validatingFields, x),
    isTouched: !!Je((D || r).touchedFields, x)
  }), qe = (x) => {
    x && to(x).forEach((D) => vt(r.errors, D)), h.state.next({
      errors: x ? r.errors : {}
    });
  }, Be = (x, D, H) => {
    const Y = (Je(i, x, { _f: {} })._f || {}).ref, R = Je(r.errors, x) || {}, { ref: V, message: ie, type: me, ...Ne } = R;
    Kn(r.errors, x, {
      ...Ne,
      ...D,
      ref: Y
    }), h.state.next({
      name: x,
      errors: r.errors,
      isValid: !1
    }), H && H.shouldFocus && Y && Y.focus && Y.focus();
  }, Oe = (x, D) => kr(x) ? h.state.subscribe({
    next: (H) => x(q(void 0, D), H)
  }) : q(x, D, !0), Me = (x) => h.state.subscribe({
    next: (D) => {
      xC(x.name, D.name, x.exact) && bC(D, x.formState || u, Ae, x.reRenderRoot) && x.callback({
        values: { ...o },
        ...r,
        ...D
      });
    }
  }).unsubscribe, $e = (x) => (s.mount = !0, f = {
    ...f,
    ...x.formState
  }, Me({
    ...x,
    formState: f
  })), ze = (x, D = {}) => {
    for (const H of x ? to(x) : l.mount)
      l.mount.delete(H), l.array.delete(H), D.keepValue || (vt(i, H), vt(o, H)), !D.keepError && vt(r.errors, H), !D.keepDirty && vt(r.dirtyFields, H), !D.keepTouched && vt(r.touchedFields, H), !D.keepIsValidating && vt(r.validatingFields, H), !n.shouldUnregister && !D.keepDefaultValue && vt(a, H);
    h.state.next({
      values: Ct(o)
    }), h.state.next({
      ...r,
      ...D.keepDirty ? { isDirty: O() } : {}
    }), !D.keepIsValid && w();
  }, Re = ({ disabled: x, name: D }) => {
    (rr(x) && s.mount || x || l.disabled.has(D)) && (x ? l.disabled.add(D) : l.disabled.delete(D));
  }, an = (x, D = {}) => {
    let H = Je(i, x);
    const Y = rr(D.disabled) || rr(n.disabled);
    return Kn(i, x, {
      ...H || {},
      _f: {
        ...H && H._f ? H._f : { ref: { name: x } },
        name: x,
        mount: !0,
        ...D
      }
    }), l.mount.add(x), H ? Re({
      disabled: rr(D.disabled) ? D.disabled : n.disabled,
      name: x
    }) : T(x, !0, D.value), {
      ...Y ? { disabled: D.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!D.required,
        min: _a(D.min),
        max: _a(D.max),
        minLength: _a(D.minLength),
        maxLength: _a(D.maxLength),
        pattern: _a(D.pattern)
      } : {},
      name: x,
      onChange: fe,
      onBlur: fe,
      ref: (R) => {
        if (R) {
          an(x, D), H = Je(i, x);
          const V = lt(R.value) && R.querySelectorAll && R.querySelectorAll("input,select,textarea")[0] || R, ie = fC(V), me = H._f.refs || [];
          if (ie ? me.find((Ne) => Ne === V) : V === H._f.ref)
            return;
          Kn(i, x, {
            _f: {
              ...H._f,
              ...ie ? {
                refs: [
                  ...me.filter(Il),
                  V,
                  ...Array.isArray(Je(a, x)) ? [{}] : []
                ],
                ref: { type: V.type, name: x }
              } : { ref: V }
            }
          }), T(x, !1, void 0, V);
        } else
          H = Je(i, x, {}), H._f && (H._f.mount = !1), (n.shouldUnregister || D.shouldUnregister) && !(Ax(l.array, x) && s.action) && l.unMount.add(x);
      }
    };
  }, Ee = () => n.shouldFocusError && ro(i, W, l.mount), Ge = (x) => {
    rr(x) && (h.state.next({ disabled: x }), ro(i, (D, H) => {
      const Y = Je(i, H);
      Y && (D.disabled = Y._f.disabled || x, Array.isArray(Y._f.refs) && Y._f.refs.forEach((R) => {
        R.disabled = Y._f.disabled || x;
      }));
    }, 0, !1));
  }, Qe = (x, D) => async (H) => {
    let Y;
    H && (H.preventDefault && H.preventDefault(), H.persist && H.persist());
    let R = Ct(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: V, values: ie } = await J();
      r.errors = V, R = ie;
    } else
      await X(i);
    if (l.disabled.size)
      for (const V of l.disabled)
        Kn(R, V, void 0);
    if (vt(r.errors, "root"), zt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await x(R, H);
      } catch (V) {
        Y = V;
      }
    } else
      D && await D({ ...r.errors }, H), Ee(), setTimeout(Ee);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: zt(r.errors) && !Y,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), Y)
      throw Y;
  }, he = (x, D = {}) => {
    Je(i, x) && (lt(D.defaultValue) ? ce(x, Ct(Je(a, x))) : (ce(x, D.defaultValue), Kn(a, x, Ct(D.defaultValue))), D.keepTouched || vt(r.touchedFields, x), D.keepDirty || (vt(r.dirtyFields, x), r.isDirty = D.defaultValue ? O(x, Ct(Je(a, x))) : O()), D.keepError || (vt(r.errors, x), u.isValid && w()), h.state.next({ ...r }));
  }, ge = (x, D = {}) => {
    const H = x ? Ct(x) : a, Y = Ct(H), R = zt(x), V = R ? a : Y;
    if (D.keepDefaultValues || (a = H), !D.keepValues) {
      if (D.keepDirtyValues) {
        const ie = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(xa(a, o))
        ]);
        for (const me of Array.from(ie))
          Je(r.dirtyFields, me) ? Kn(V, me, Je(o, me)) : ce(me, Je(V, me));
      } else {
        if (ip && lt(x))
          for (const ie of l.mount) {
            const me = Je(i, ie);
            if (me && me._f) {
              const Ne = Array.isArray(me._f.refs) ? me._f.refs[0] : me._f.ref;
              if (Fs(Ne)) {
                const nn = Ne.closest("form");
                if (nn) {
                  nn.reset();
                  break;
                }
              }
            }
          }
        for (const ie of l.mount)
          ce(ie, Je(V, ie));
      }
      o = Ct(V), h.array.next({
        values: { ...V }
      }), h.state.next({
        values: { ...V }
      });
    }
    l = {
      mount: D.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!D.keepIsValid || !!D.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: D.keepSubmitCount ? r.submitCount : 0,
      isDirty: R ? !1 : D.keepDirty ? r.isDirty : !!(D.keepDefaultValues && !ti(x, a)),
      isSubmitted: D.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: R ? {} : D.keepDirtyValues ? D.keepDefaultValues && o ? xa(a, o) : r.dirtyFields : D.keepDefaultValues && x ? xa(a, x) : D.keepDirty ? r.dirtyFields : {},
      touchedFields: D.keepTouched ? r.touchedFields : {},
      errors: D.keepErrors ? r.errors : {},
      isSubmitSuccessful: D.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, De = (x, D) => ge(kr(x) ? x(o) : x, D), Le = (x, D = {}) => {
    const H = Je(i, x), Y = H && H._f;
    if (Y) {
      const R = Y.refs ? Y.refs[0] : Y.ref;
      R.focus && (R.focus(), D.shouldSelect && kr(R.select) && R.select());
    }
  }, Ae = (x) => {
    r = {
      ...r,
      ...x
    };
  }, E = {
    control: {
      register: an,
      unregister: ze,
      getFieldState: K,
      handleSubmit: Qe,
      setError: Be,
      _subscribe: Me,
      _runSchema: J,
      _getWatch: q,
      _getDirty: O,
      _setValid: w,
      _setFieldArray: z,
      _setDisabledField: Re,
      _setErrors: I,
      _getFieldArray: ee,
      _reset: ge,
      _resetDefaultValues: () => kr(n.defaultValues) && n.defaultValues().then((x) => {
        De(x, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: B,
      _disableForm: Ge,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(x) {
        s = x;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(x) {
        l = x;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(x) {
        n = {
          ...n,
          ...x
        };
      }
    },
    subscribe: $e,
    trigger: xe,
    register: an,
    handleSubmit: Qe,
    watch: Oe,
    setValue: ce,
    getValues: Ie,
    reset: De,
    resetField: he,
    clearErrors: qe,
    unregister: ze,
    setError: Be,
    setFocus: Le,
    getFieldState: K
  };
  return {
    ...E,
    formControl: E
  };
}
function _t(e = {}) {
  const n = Fe.useRef(void 0), r = Fe.useRef(void 0), [i, a] = Fe.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: kr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: kr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : wC(e),
    formState: i
  }, e.formControl && e.defaultValues && !kr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, Fe.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), Fe.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Fe.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), Fe.useEffect(() => {
    e.values && !ti(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), Fe.useEffect(() => {
    e.errors && !zt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), Fe.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Fe.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = Vx(i, o), n.current;
}
var Ao = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Gx(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var El = { exports: {} }, Sa = {}, ih;
function CC() {
  if (ih) return Sa;
  ih = 1;
  var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return Sa.Fragment = r, Sa.jsx = s, Sa.jsxs = s, Sa;
}
var Po = {}, ah;
function FC() {
  return ah || (ah = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        z("error", t, p);
      }
    }
    function z(t, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, A = v.getStackAddendum();
        A !== "" && (c += "%s", p = p.concat([A]));
        var L = p.map(function(F) {
          return String(F);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, I = !1, T = !1, U = !1, Q = !1, J;
    J = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === u || U || t === g || $ || I || T || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function X(t, c, p) {
      var v = t.displayName;
      if (v)
        return v;
      var A = c.displayName || c.name || "";
      return A !== "" ? p + "(" + A + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return X(t, t.render, "ForwardRef");
          case f:
            var v = t.displayName || null;
            return v !== null ? v : O(t.type) || "Memo";
          case h: {
            var A = t, L = A._payload, F = A._init;
            try {
              return O(F(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, ue, ce, fe, W, xe, Ie;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ve = console.log, ue = console.info, ce = console.warn, fe = console.error, W = console.group, xe = console.groupCollapsed, Ie = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: ue
            }),
            warn: q({}, t, {
              value: ce
            }),
            error: q({}, t, {
              value: fe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: xe
            }),
            groupEnd: q({}, t, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Me;
    function $e(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (A) {
            var v = A.stack.trim().match(/\n( *(at )?)/);
            Me = v && v[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var ze = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(t, c) {
      if (!t || ze)
        return "";
      {
        var p = Re.get(t);
        if (p !== void 0)
          return p;
      }
      var v;
      ze = !0;
      var A = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, qe();
      try {
        if (c) {
          var F = function() {
            throw Error();
          };
          if (Object.defineProperty(F.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(F, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(t, [], F);
          } else {
            try {
              F.call();
            } catch (ne) {
              v = ne;
            }
            t.call(F.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), G = j.length - 1, _ = te.length - 1; G >= 1 && _ >= 0 && j[G] !== te[_]; )
            _--;
          for (; G >= 1 && _ >= 0; G--, _--)
            if (j[G] !== te[_]) {
              if (G !== 1 || _ !== 1)
                do
                  if (G--, _--, _ < 0 || j[G] !== te[_]) {
                    var Z = `
` + j[G].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (G >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Oe.current = L, Be(), Error.prepareStackTrace = A;
      }
      var de = t ? t.displayName || t.name : "", Se = de ? $e(de) : "";
      return typeof t == "function" && Re.set(t, Se), Se;
    }
    function Ge(t, c, p) {
      return Ee(t, !1);
    }
    function Qe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function he(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Qe(t));
      if (typeof t == "string")
        return $e(t);
      switch (t) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ge(t.render);
          case f:
            return he(t.type, c, p);
          case h: {
            var v = t, A = v._payload, L = v._init;
            try {
              return he(L(A), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, De = {}, Le = w.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = he(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(t, c, p, v, A) {
      {
        var L = Function.call.bind(ge);
        for (var F in t)
          if (L(t, F)) {
            var j = void 0;
            try {
              if (typeof t[F] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + F + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[F] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[F](c, F, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (G) {
              j = G;
            }
            j && !(j instanceof Error) && (Ae(A), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, F, typeof j), Ae(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Ae(A), y("Failed %s type: %s", p, j.message), Ae(null));
          }
      }
    }
    var E = Array.isArray;
    function x(t) {
      return E(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var V = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, me, Ne;
    function nn(t) {
      if (ge.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function fn(t) {
      if (ge.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && V.current;
    }
    function cn(t, c) {
      {
        var p = function() {
          me || (me = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(t, c, p, v, A, L, F) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: F,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: A
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, v, A) {
      {
        var L, F = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), fn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ge.call(c, L) && !ie.hasOwnProperty(L) && (F[L] = c[L]);
        if (t && t.defaultProps) {
          var G = t.defaultProps;
          for (L in G)
            F[L] === void 0 && (F[L] = G[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && cn(F, _), te && pn(F, _);
        }
        return dn(t, j, te, A, v, V.current, F);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = he(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var t = O(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        t && t._owner && t._owner !== en.current && (v = " It was passed a child from " + O(t._owner.type) + "."), Pe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Pe(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var v = t[p];
            sn(v) && gn(v, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var A = N(t);
          if (typeof A == "function" && A !== t.entries)
            for (var L = A.call(t), F; !(F = L.next()).done; )
              sn(F.value) && gn(F.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          mn(p, t.props, "prop", v, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var A = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", A || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Pe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Pe(null);
            break;
          }
        }
        t.ref !== null && (Pe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Pe(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, v, A, L) {
      {
        var F = ae(t);
        if (!F) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var G;
          t === null ? G = "null" : x(t) ? G = "array" : t !== void 0 && t.$$typeof === n ? (G = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : G = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", G, j);
        }
        var _ = xn(t, c, p, A, L);
        if (_ == null)
          return _;
        if (F) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var de = 0; de < Z.length; de++)
                  Cn(Z[de], t);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, t);
        }
        if (ge.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, Se, $n, Se), Sn[Se + Ke] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Po.Fragment = i, Po.jsx = Rn, Po.jsxs = Mn;
  })()), Po;
}
var oh;
function IC() {
  return oh || (oh = 1, process.env.NODE_ENV === "production" ? El.exports = CC() : El.exports = FC()), El.exports;
}
var xi = IC();
function EC(e) {
  return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var Tl, sh;
function ai() {
  if (sh) return Tl;
  sh = 1;
  var e = Array.isArray;
  return Tl = e, Tl;
}
var $l, lh;
function Kx() {
  if (lh) return $l;
  lh = 1;
  var e = typeof Ao == "object" && Ao && Ao.Object === Object && Ao;
  return $l = e, $l;
}
var Dl, ch;
function zr() {
  if (ch) return Dl;
  ch = 1;
  var e = Kx(), n = typeof self == "object" && self && self.Object === Object && self, r = e || n || Function("return this")();
  return Dl = r, Dl;
}
var Rl, dh;
function jo() {
  if (dh) return Rl;
  dh = 1;
  var e = zr(), n = e.Symbol;
  return Rl = n, Rl;
}
var Ol, uh;
function TC() {
  if (uh) return Ol;
  uh = 1;
  var e = jo(), n = Object.prototype, r = n.hasOwnProperty, i = n.toString, a = e ? e.toStringTag : void 0;
  function o(s) {
    var l = r.call(s, a), d = s[a];
    try {
      s[a] = void 0;
      var m = !0;
    } catch {
    }
    var u = i.call(s);
    return m && (l ? s[a] = d : delete s[a]), u;
  }
  return Ol = o, Ol;
}
var Al, mh;
function $C() {
  if (mh) return Al;
  mh = 1;
  var e = Object.prototype, n = e.toString;
  function r(i) {
    return n.call(i);
  }
  return Al = r, Al;
}
var Pl, ph;
function da() {
  if (ph) return Pl;
  ph = 1;
  var e = jo(), n = TC(), r = $C(), i = "[object Null]", a = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function s(l) {
    return l == null ? l === void 0 ? a : i : o && o in Object(l) ? n(l) : r(l);
  }
  return Pl = s, Pl;
}
var Ll, fh;
function Di() {
  if (fh) return Ll;
  fh = 1;
  function e(n) {
    return n != null && typeof n == "object";
  }
  return Ll = e, Ll;
}
var Vl, hh;
function dp() {
  if (hh) return Vl;
  hh = 1;
  var e = da(), n = Di(), r = "[object Symbol]";
  function i(a) {
    return typeof a == "symbol" || n(a) && e(a) == r;
  }
  return Vl = i, Vl;
}
var zl, yh;
function DC() {
  if (yh) return zl;
  yh = 1;
  var e = ai(), n = dp(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function a(o, s) {
    if (e(o))
      return !1;
    var l = typeof o;
    return l == "number" || l == "symbol" || l == "boolean" || o == null || n(o) ? !0 : i.test(o) || !r.test(o) || s != null && o in Object(s);
  }
  return zl = a, zl;
}
var Ul, gh;
function ua() {
  if (gh) return Ul;
  gh = 1;
  function e(n) {
    var r = typeof n;
    return n != null && (r == "object" || r == "function");
  }
  return Ul = e, Ul;
}
var Ml, vh;
function Yx() {
  if (vh) return Ml;
  vh = 1;
  var e = da(), n = ua(), r = "[object AsyncFunction]", i = "[object Function]", a = "[object GeneratorFunction]", o = "[object Proxy]";
  function s(l) {
    if (!n(l))
      return !1;
    var d = e(l);
    return d == i || d == a || d == r || d == o;
  }
  return Ml = s, Ml;
}
var Bl, kh;
function RC() {
  if (kh) return Bl;
  kh = 1;
  var e = zr(), n = e["__core-js_shared__"];
  return Bl = n, Bl;
}
var ql, bh;
function OC() {
  if (bh) return ql;
  bh = 1;
  var e = RC(), n = (function() {
    var i = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  })();
  function r(i) {
    return !!n && n in i;
  }
  return ql = r, ql;
}
var Hl, xh;
function Qx() {
  if (xh) return Hl;
  xh = 1;
  var e = Function.prototype, n = e.toString;
  function r(i) {
    if (i != null) {
      try {
        return n.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  return Hl = r, Hl;
}
var Wl, _h;
function AC() {
  if (_h) return Wl;
  _h = 1;
  var e = Yx(), n = OC(), r = ua(), i = Qx(), a = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, s = Function.prototype, l = Object.prototype, d = s.toString, m = l.hasOwnProperty, u = RegExp(
    "^" + d.call(m).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!r(h) || n(h))
      return !1;
    var g = e(h) ? u : o;
    return g.test(i(h));
  }
  return Wl = f, Wl;
}
var Gl, Sh;
function PC() {
  if (Sh) return Gl;
  Sh = 1;
  function e(n, r) {
    return n?.[r];
  }
  return Gl = e, Gl;
}
var Kl, Nh;
function Ri() {
  if (Nh) return Kl;
  Nh = 1;
  var e = AC(), n = PC();
  function r(i, a) {
    var o = n(i, a);
    return e(o) ? o : void 0;
  }
  return Kl = r, Kl;
}
var Yl, jh;
function rl() {
  if (jh) return Yl;
  jh = 1;
  var e = Ri(), n = e(Object, "create");
  return Yl = n, Yl;
}
var Ql, wh;
function LC() {
  if (wh) return Ql;
  wh = 1;
  var e = rl();
  function n() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Ql = n, Ql;
}
var Jl, Ch;
function VC() {
  if (Ch) return Jl;
  Ch = 1;
  function e(n) {
    var r = this.has(n) && delete this.__data__[n];
    return this.size -= r ? 1 : 0, r;
  }
  return Jl = e, Jl;
}
var Xl, Fh;
function zC() {
  if (Fh) return Xl;
  Fh = 1;
  var e = rl(), n = "__lodash_hash_undefined__", r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    var s = this.__data__;
    if (e) {
      var l = s[o];
      return l === n ? void 0 : l;
    }
    return i.call(s, o) ? s[o] : void 0;
  }
  return Xl = a, Xl;
}
var Zl, Ih;
function UC() {
  if (Ih) return Zl;
  Ih = 1;
  var e = rl(), n = Object.prototype, r = n.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    return e ? o[a] !== void 0 : r.call(o, a);
  }
  return Zl = i, Zl;
}
var ec, Eh;
function MC() {
  if (Eh) return ec;
  Eh = 1;
  var e = rl(), n = "__lodash_hash_undefined__";
  function r(i, a) {
    var o = this.__data__;
    return this.size += this.has(i) ? 0 : 1, o[i] = e && a === void 0 ? n : a, this;
  }
  return ec = r, ec;
}
var nc, Th;
function BC() {
  if (Th) return nc;
  Th = 1;
  var e = LC(), n = VC(), r = zC(), i = UC(), a = MC();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, nc = o, nc;
}
var tc, $h;
function qC() {
  if ($h) return tc;
  $h = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return tc = e, tc;
}
var rc, Dh;
function Jx() {
  if (Dh) return rc;
  Dh = 1;
  function e(n, r) {
    return n === r || n !== n && r !== r;
  }
  return rc = e, rc;
}
var ic, Rh;
function il() {
  if (Rh) return ic;
  Rh = 1;
  var e = Jx();
  function n(r, i) {
    for (var a = r.length; a--; )
      if (e(r[a][0], i))
        return a;
    return -1;
  }
  return ic = n, ic;
}
var ac, Oh;
function HC() {
  if (Oh) return ac;
  Oh = 1;
  var e = il(), n = Array.prototype, r = n.splice;
  function i(a) {
    var o = this.__data__, s = e(o, a);
    if (s < 0)
      return !1;
    var l = o.length - 1;
    return s == l ? o.pop() : r.call(o, s, 1), --this.size, !0;
  }
  return ac = i, ac;
}
var oc, Ah;
function WC() {
  if (Ah) return oc;
  Ah = 1;
  var e = il();
  function n(r) {
    var i = this.__data__, a = e(i, r);
    return a < 0 ? void 0 : i[a][1];
  }
  return oc = n, oc;
}
var sc, Ph;
function GC() {
  if (Ph) return sc;
  Ph = 1;
  var e = il();
  function n(r) {
    return e(this.__data__, r) > -1;
  }
  return sc = n, sc;
}
var lc, Lh;
function KC() {
  if (Lh) return lc;
  Lh = 1;
  var e = il();
  function n(r, i) {
    var a = this.__data__, o = e(a, r);
    return o < 0 ? (++this.size, a.push([r, i])) : a[o][1] = i, this;
  }
  return lc = n, lc;
}
var cc, Vh;
function al() {
  if (Vh) return cc;
  Vh = 1;
  var e = qC(), n = HC(), r = WC(), i = GC(), a = KC();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, cc = o, cc;
}
var dc, zh;
function up() {
  if (zh) return dc;
  zh = 1;
  var e = Ri(), n = zr(), r = e(n, "Map");
  return dc = r, dc;
}
var uc, Uh;
function YC() {
  if (Uh) return uc;
  Uh = 1;
  var e = BC(), n = al(), r = up();
  function i() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || n)(),
      string: new e()
    };
  }
  return uc = i, uc;
}
var mc, Mh;
function QC() {
  if (Mh) return mc;
  Mh = 1;
  function e(n) {
    var r = typeof n;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? n !== "__proto__" : n === null;
  }
  return mc = e, mc;
}
var pc, Bh;
function ol() {
  if (Bh) return pc;
  Bh = 1;
  var e = QC();
  function n(r, i) {
    var a = r.__data__;
    return e(i) ? a[typeof i == "string" ? "string" : "hash"] : a.map;
  }
  return pc = n, pc;
}
var fc, qh;
function JC() {
  if (qh) return fc;
  qh = 1;
  var e = ol();
  function n(r) {
    var i = e(this, r).delete(r);
    return this.size -= i ? 1 : 0, i;
  }
  return fc = n, fc;
}
var hc, Hh;
function XC() {
  if (Hh) return hc;
  Hh = 1;
  var e = ol();
  function n(r) {
    return e(this, r).get(r);
  }
  return hc = n, hc;
}
var yc, Wh;
function ZC() {
  if (Wh) return yc;
  Wh = 1;
  var e = ol();
  function n(r) {
    return e(this, r).has(r);
  }
  return yc = n, yc;
}
var gc, Gh;
function e1() {
  if (Gh) return gc;
  Gh = 1;
  var e = ol();
  function n(r, i) {
    var a = e(this, r), o = a.size;
    return a.set(r, i), this.size += a.size == o ? 0 : 1, this;
  }
  return gc = n, gc;
}
var vc, Kh;
function Xx() {
  if (Kh) return vc;
  Kh = 1;
  var e = YC(), n = JC(), r = XC(), i = ZC(), a = e1();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, vc = o, vc;
}
var kc, Yh;
function n1() {
  if (Yh) return kc;
  Yh = 1;
  var e = Xx(), n = "Expected a function";
  function r(i, a) {
    if (typeof i != "function" || a != null && typeof a != "function")
      throw new TypeError(n);
    var o = function() {
      var s = arguments, l = a ? a.apply(this, s) : s[0], d = o.cache;
      if (d.has(l))
        return d.get(l);
      var m = i.apply(this, s);
      return o.cache = d.set(l, m) || d, m;
    };
    return o.cache = new (r.Cache || e)(), o;
  }
  return r.Cache = e, kc = r, kc;
}
var bc, Qh;
function t1() {
  if (Qh) return bc;
  Qh = 1;
  var e = n1(), n = 500;
  function r(i) {
    var a = e(i, function(s) {
      return o.size === n && o.clear(), s;
    }), o = a.cache;
    return a;
  }
  return bc = r, bc;
}
var xc, Jh;
function r1() {
  if (Jh) return xc;
  Jh = 1;
  var e = t1(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, i = e(function(a) {
    var o = [];
    return a.charCodeAt(0) === 46 && o.push(""), a.replace(n, function(s, l, d, m) {
      o.push(d ? m.replace(r, "$1") : l || s);
    }), o;
  });
  return xc = i, xc;
}
var _c, Xh;
function Zx() {
  if (Xh) return _c;
  Xh = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = Array(a); ++i < a; )
      o[i] = r(n[i], i, n);
    return o;
  }
  return _c = e, _c;
}
var Sc, Zh;
function i1() {
  if (Zh) return Sc;
  Zh = 1;
  var e = jo(), n = Zx(), r = ai(), i = dp(), a = e ? e.prototype : void 0, o = a ? a.toString : void 0;
  function s(l) {
    if (typeof l == "string")
      return l;
    if (r(l))
      return n(l, s) + "";
    if (i(l))
      return o ? o.call(l) : "";
    var d = l + "";
    return d == "0" && 1 / l == -1 / 0 ? "-0" : d;
  }
  return Sc = s, Sc;
}
var Nc, ey;
function a1() {
  if (ey) return Nc;
  ey = 1;
  var e = i1();
  function n(r) {
    return r == null ? "" : e(r);
  }
  return Nc = n, Nc;
}
var jc, ny;
function ma() {
  if (ny) return jc;
  ny = 1;
  var e = ai(), n = DC(), r = r1(), i = a1();
  function a(o, s) {
    return e(o) ? o : n(o, s) ? [o] : r(i(o));
  }
  return jc = a, jc;
}
var wc, ty;
function sl() {
  if (ty) return wc;
  ty = 1;
  var e = dp();
  function n(r) {
    if (typeof r == "string" || e(r))
      return r;
    var i = r + "";
    return i == "0" && 1 / r == -1 / 0 ? "-0" : i;
  }
  return wc = n, wc;
}
var Cc, ry;
function e_() {
  if (ry) return Cc;
  ry = 1;
  var e = ma(), n = sl();
  function r(i, a) {
    a = e(a, i);
    for (var o = 0, s = a.length; i != null && o < s; )
      i = i[n(a[o++])];
    return o && o == s ? i : void 0;
  }
  return Cc = r, Cc;
}
var Fc, iy;
function n_() {
  if (iy) return Fc;
  iy = 1;
  var e = Ri(), n = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return Fc = n, Fc;
}
var Ic, ay;
function t_() {
  if (ay) return Ic;
  ay = 1;
  var e = n_();
  function n(r, i, a) {
    i == "__proto__" && e ? e(r, i, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[i] = a;
  }
  return Ic = n, Ic;
}
var Ec, oy;
function mp() {
  if (oy) return Ec;
  oy = 1;
  var e = t_(), n = Jx(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o, s, l) {
    var d = o[s];
    (!(i.call(o, s) && n(d, l)) || l === void 0 && !(s in o)) && e(o, s, l);
  }
  return Ec = a, Ec;
}
var Tc, sy;
function pp() {
  if (sy) return Tc;
  sy = 1;
  var e = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
  function r(i, a) {
    var o = typeof i;
    return a = a ?? e, !!a && (o == "number" || o != "symbol" && n.test(i)) && i > -1 && i % 1 == 0 && i < a;
  }
  return Tc = r, Tc;
}
var $c, ly;
function o1() {
  if (ly) return $c;
  ly = 1;
  var e = mp(), n = ma(), r = pp(), i = ua(), a = sl();
  function o(s, l, d, m) {
    if (!i(s))
      return s;
    l = n(l, s);
    for (var u = -1, f = l.length, h = f - 1, g = s; g != null && ++u < f; ) {
      var C = a(l[u]), S = d;
      if (C === "__proto__" || C === "constructor" || C === "prototype")
        return s;
      if (u != h) {
        var N = g[C];
        S = m ? m(N, C, g) : void 0, S === void 0 && (S = i(N) ? N : r(l[u + 1]) ? [] : {});
      }
      e(g, C, S), g = g[C];
    }
    return s;
  }
  return $c = o, $c;
}
var Dc, cy;
function s1() {
  if (cy) return Dc;
  cy = 1;
  var e = e_(), n = o1(), r = ma();
  function i(a, o, s) {
    for (var l = -1, d = o.length, m = {}; ++l < d; ) {
      var u = o[l], f = e(a, u);
      s(f, u) && n(m, r(u, a), f);
    }
    return m;
  }
  return Dc = i, Dc;
}
var Rc, dy;
function l1() {
  if (dy) return Rc;
  dy = 1;
  function e(n, r) {
    return n != null && r in Object(n);
  }
  return Rc = e, Rc;
}
var Oc, uy;
function c1() {
  if (uy) return Oc;
  uy = 1;
  var e = da(), n = Di(), r = "[object Arguments]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Oc = i, Oc;
}
var Ac, my;
function fp() {
  if (my) return Ac;
  my = 1;
  var e = c1(), n = Di(), r = Object.prototype, i = r.hasOwnProperty, a = r.propertyIsEnumerable, o = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(s) {
    return n(s) && i.call(s, "callee") && !a.call(s, "callee");
  };
  return Ac = o, Ac;
}
var Pc, py;
function hp() {
  if (py) return Pc;
  py = 1;
  var e = 9007199254740991;
  function n(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return Pc = n, Pc;
}
var Lc, fy;
function d1() {
  if (fy) return Lc;
  fy = 1;
  var e = ma(), n = fp(), r = ai(), i = pp(), a = hp(), o = sl();
  function s(l, d, m) {
    d = e(d, l);
    for (var u = -1, f = d.length, h = !1; ++u < f; ) {
      var g = o(d[u]);
      if (!(h = l != null && m(l, g)))
        break;
      l = l[g];
    }
    return h || ++u != f ? h : (f = l == null ? 0 : l.length, !!f && a(f) && i(g, f) && (r(l) || n(l)));
  }
  return Lc = s, Lc;
}
var Vc, hy;
function u1() {
  if (hy) return Vc;
  hy = 1;
  var e = l1(), n = d1();
  function r(i, a) {
    return i != null && n(i, a, e);
  }
  return Vc = r, Vc;
}
var zc, yy;
function m1() {
  if (yy) return zc;
  yy = 1;
  var e = s1(), n = u1();
  function r(i, a) {
    return e(i, a, function(o, s) {
      return n(i, s);
    });
  }
  return zc = r, zc;
}
var Uc, gy;
function yp() {
  if (gy) return Uc;
  gy = 1;
  function e(n, r) {
    for (var i = -1, a = r.length, o = n.length; ++i < a; )
      n[o + i] = r[i];
    return n;
  }
  return Uc = e, Uc;
}
var Mc, vy;
function p1() {
  if (vy) return Mc;
  vy = 1;
  var e = jo(), n = fp(), r = ai(), i = e ? e.isConcatSpreadable : void 0;
  function a(o) {
    return r(o) || n(o) || !!(i && o && o[i]);
  }
  return Mc = a, Mc;
}
var Bc, ky;
function f1() {
  if (ky) return Bc;
  ky = 1;
  var e = yp(), n = p1();
  function r(i, a, o, s, l) {
    var d = -1, m = i.length;
    for (o || (o = n), l || (l = []); ++d < m; ) {
      var u = i[d];
      a > 0 && o(u) ? a > 1 ? r(u, a - 1, o, s, l) : e(l, u) : s || (l[l.length] = u);
    }
    return l;
  }
  return Bc = r, Bc;
}
var qc, by;
function h1() {
  if (by) return qc;
  by = 1;
  var e = f1();
  function n(r) {
    var i = r == null ? 0 : r.length;
    return i ? e(r, 1) : [];
  }
  return qc = n, qc;
}
var Hc, xy;
function y1() {
  if (xy) return Hc;
  xy = 1;
  function e(n, r, i) {
    switch (i.length) {
      case 0:
        return n.call(r);
      case 1:
        return n.call(r, i[0]);
      case 2:
        return n.call(r, i[0], i[1]);
      case 3:
        return n.call(r, i[0], i[1], i[2]);
    }
    return n.apply(r, i);
  }
  return Hc = e, Hc;
}
var Wc, _y;
function g1() {
  if (_y) return Wc;
  _y = 1;
  var e = y1(), n = Math.max;
  function r(i, a, o) {
    return a = n(a === void 0 ? i.length - 1 : a, 0), function() {
      for (var s = arguments, l = -1, d = n(s.length - a, 0), m = Array(d); ++l < d; )
        m[l] = s[a + l];
      l = -1;
      for (var u = Array(a + 1); ++l < a; )
        u[l] = s[l];
      return u[a] = o(m), e(i, this, u);
    };
  }
  return Wc = r, Wc;
}
var Gc, Sy;
function v1() {
  if (Sy) return Gc;
  Sy = 1;
  function e(n) {
    return function() {
      return n;
    };
  }
  return Gc = e, Gc;
}
var Kc, Ny;
function r_() {
  if (Ny) return Kc;
  Ny = 1;
  function e(n) {
    return n;
  }
  return Kc = e, Kc;
}
var Yc, jy;
function k1() {
  if (jy) return Yc;
  jy = 1;
  var e = v1(), n = n_(), r = r_(), i = n ? function(a, o) {
    return n(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : r;
  return Yc = i, Yc;
}
var Qc, wy;
function b1() {
  if (wy) return Qc;
  wy = 1;
  var e = 800, n = 16, r = Date.now;
  function i(a) {
    var o = 0, s = 0;
    return function() {
      var l = r(), d = n - (l - s);
      if (s = l, d > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return a.apply(void 0, arguments);
    };
  }
  return Qc = i, Qc;
}
var Jc, Cy;
function x1() {
  if (Cy) return Jc;
  Cy = 1;
  var e = k1(), n = b1(), r = n(e);
  return Jc = r, Jc;
}
var Xc, Fy;
function i_() {
  if (Fy) return Xc;
  Fy = 1;
  var e = h1(), n = g1(), r = x1();
  function i(a) {
    return r(n(a, void 0, e), a + "");
  }
  return Xc = i, Xc;
}
var Zc, Iy;
function _1() {
  if (Iy) return Zc;
  Iy = 1;
  var e = m1(), n = i_(), r = n(function(i, a) {
    return i == null ? {} : e(i, a);
  });
  return Zc = r, Zc;
}
var S1 = _1();
const a_ = /* @__PURE__ */ Gx(S1), N1 = [
  "control",
  "defaultValue",
  "name",
  "rules",
  "shouldUnregister"
];
function o_(e) {
  const n = a_(e, N1);
  return {
    controller: sp(n),
    controllerProps: n
  };
}
const j1 = [
  "className",
  "description",
  "disabled",
  "helpIcon",
  "label",
  "noAlert",
  "noLabel",
  "style"
];
function s_(e) {
  const { controller: n, controllerProps: r } = o_(e), i = {
    ...a_(e, j1),
    required: EC(r.rules?.required),
    meta: {
      touched: n.fieldState.isTouched,
      error: n.fieldState.error?.message,
      success: e.meta?.success,
      warning: e.meta?.warning
    },
    labelFor: r.name,
    noLabel: e.noLabel,
    noAlert: e.noAlert
  };
  return {
    controller: n,
    controllerProps: r,
    fieldWrapperProps: i
  };
}
var ed, Ey;
function w1() {
  if (Ey) return ed;
  Ey = 1;
  var e = al();
  function n() {
    this.__data__ = new e(), this.size = 0;
  }
  return ed = n, ed;
}
var nd, Ty;
function C1() {
  if (Ty) return nd;
  Ty = 1;
  function e(n) {
    var r = this.__data__, i = r.delete(n);
    return this.size = r.size, i;
  }
  return nd = e, nd;
}
var td, $y;
function F1() {
  if ($y) return td;
  $y = 1;
  function e(n) {
    return this.__data__.get(n);
  }
  return td = e, td;
}
var rd, Dy;
function I1() {
  if (Dy) return rd;
  Dy = 1;
  function e(n) {
    return this.__data__.has(n);
  }
  return rd = e, rd;
}
var id, Ry;
function E1() {
  if (Ry) return id;
  Ry = 1;
  var e = al(), n = up(), r = Xx(), i = 200;
  function a(o, s) {
    var l = this.__data__;
    if (l instanceof e) {
      var d = l.__data__;
      if (!n || d.length < i - 1)
        return d.push([o, s]), this.size = ++l.size, this;
      l = this.__data__ = new r(d);
    }
    return l.set(o, s), this.size = l.size, this;
  }
  return id = a, id;
}
var ad, Oy;
function T1() {
  if (Oy) return ad;
  Oy = 1;
  var e = al(), n = w1(), r = C1(), i = F1(), a = I1(), o = E1();
  function s(l) {
    var d = this.__data__ = new e(l);
    this.size = d.size;
  }
  return s.prototype.clear = n, s.prototype.delete = r, s.prototype.get = i, s.prototype.has = a, s.prototype.set = o, ad = s, ad;
}
var od, Ay;
function $1() {
  if (Ay) return od;
  Ay = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length; ++i < a && r(n[i], i, n) !== !1; )
      ;
    return n;
  }
  return od = e, od;
}
var sd, Py;
function wo() {
  if (Py) return sd;
  Py = 1;
  var e = mp(), n = t_();
  function r(i, a, o, s) {
    var l = !o;
    o || (o = {});
    for (var d = -1, m = a.length; ++d < m; ) {
      var u = a[d], f = s ? s(o[u], i[u], u, o, i) : void 0;
      f === void 0 && (f = i[u]), l ? n(o, u, f) : e(o, u, f);
    }
    return o;
  }
  return sd = r, sd;
}
var ld, Ly;
function D1() {
  if (Ly) return ld;
  Ly = 1;
  function e(n, r) {
    for (var i = -1, a = Array(n); ++i < n; )
      a[i] = r(i);
    return a;
  }
  return ld = e, ld;
}
var ys = { exports: {} }, cd, Vy;
function R1() {
  if (Vy) return cd;
  Vy = 1;
  function e() {
    return !1;
  }
  return cd = e, cd;
}
ys.exports;
var zy;
function l_() {
  return zy || (zy = 1, (function(e, n) {
    var r = zr(), i = R1(), a = n && !n.nodeType && n, o = a && !0 && e && !e.nodeType && e, s = o && o.exports === a, l = s ? r.Buffer : void 0, d = l ? l.isBuffer : void 0, m = d || i;
    e.exports = m;
  })(ys, ys.exports)), ys.exports;
}
var dd, Uy;
function O1() {
  if (Uy) return dd;
  Uy = 1;
  var e = da(), n = hp(), r = Di(), i = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", s = "[object Date]", l = "[object Error]", d = "[object Function]", m = "[object Map]", u = "[object Number]", f = "[object Object]", h = "[object RegExp]", g = "[object Set]", C = "[object String]", S = "[object WeakMap]", N = "[object ArrayBuffer]", w = "[object DataView]", y = "[object Float32Array]", z = "[object Float64Array]", $ = "[object Int8Array]", I = "[object Int16Array]", T = "[object Int32Array]", U = "[object Uint8Array]", Q = "[object Uint8ClampedArray]", J = "[object Uint16Array]", ae = "[object Uint32Array]", X = {};
  X[y] = X[z] = X[$] = X[I] = X[T] = X[U] = X[Q] = X[J] = X[ae] = !0, X[i] = X[a] = X[N] = X[o] = X[w] = X[s] = X[l] = X[d] = X[m] = X[u] = X[f] = X[h] = X[g] = X[C] = X[S] = !1;
  function B(O) {
    return r(O) && n(O.length) && !!X[e(O)];
  }
  return dd = B, dd;
}
var ud, My;
function gp() {
  if (My) return ud;
  My = 1;
  function e(n) {
    return function(r) {
      return n(r);
    };
  }
  return ud = e, ud;
}
var gs = { exports: {} };
gs.exports;
var By;
function vp() {
  return By || (By = 1, (function(e, n) {
    var r = Kx(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o && r.process, l = (function() {
      try {
        var d = a && a.require && a.require("util").types;
        return d || s && s.binding && s.binding("util");
      } catch {
      }
    })();
    e.exports = l;
  })(gs, gs.exports)), gs.exports;
}
var md, qy;
function A1() {
  if (qy) return md;
  qy = 1;
  var e = O1(), n = gp(), r = vp(), i = r && r.isTypedArray, a = i ? n(i) : e;
  return md = a, md;
}
var pd, Hy;
function c_() {
  if (Hy) return pd;
  Hy = 1;
  var e = D1(), n = fp(), r = ai(), i = l_(), a = pp(), o = A1(), s = Object.prototype, l = s.hasOwnProperty;
  function d(m, u) {
    var f = r(m), h = !f && n(m), g = !f && !h && i(m), C = !f && !h && !g && o(m), S = f || h || g || C, N = S ? e(m.length, String) : [], w = N.length;
    for (var y in m)
      (u || l.call(m, y)) && !(S && // Safari 9 has enumerable `arguments.length` in strict mode.
      (y == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      g && (y == "offset" || y == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      C && (y == "buffer" || y == "byteLength" || y == "byteOffset") || // Skip index properties.
      a(y, w))) && N.push(y);
    return N;
  }
  return pd = d, pd;
}
var fd, Wy;
function kp() {
  if (Wy) return fd;
  Wy = 1;
  var e = Object.prototype;
  function n(r) {
    var i = r && r.constructor, a = typeof i == "function" && i.prototype || e;
    return r === a;
  }
  return fd = n, fd;
}
var hd, Gy;
function d_() {
  if (Gy) return hd;
  Gy = 1;
  function e(n, r) {
    return function(i) {
      return n(r(i));
    };
  }
  return hd = e, hd;
}
var yd, Ky;
function P1() {
  if (Ky) return yd;
  Ky = 1;
  var e = d_(), n = e(Object.keys, Object);
  return yd = n, yd;
}
var gd, Yy;
function L1() {
  if (Yy) return gd;
  Yy = 1;
  var e = kp(), n = P1(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    if (!e(o))
      return n(o);
    var s = [];
    for (var l in Object(o))
      i.call(o, l) && l != "constructor" && s.push(l);
    return s;
  }
  return gd = a, gd;
}
var vd, Qy;
function u_() {
  if (Qy) return vd;
  Qy = 1;
  var e = Yx(), n = hp();
  function r(i) {
    return i != null && n(i.length) && !e(i);
  }
  return vd = r, vd;
}
var kd, Jy;
function bp() {
  if (Jy) return kd;
  Jy = 1;
  var e = c_(), n = L1(), r = u_();
  function i(a) {
    return r(a) ? e(a) : n(a);
  }
  return kd = i, kd;
}
var bd, Xy;
function V1() {
  if (Xy) return bd;
  Xy = 1;
  var e = wo(), n = bp();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return bd = r, bd;
}
var xd, Zy;
function z1() {
  if (Zy) return xd;
  Zy = 1;
  function e(n) {
    var r = [];
    if (n != null)
      for (var i in Object(n))
        r.push(i);
    return r;
  }
  return xd = e, xd;
}
var _d, eg;
function U1() {
  if (eg) return _d;
  eg = 1;
  var e = ua(), n = kp(), r = z1(), i = Object.prototype, a = i.hasOwnProperty;
  function o(s) {
    if (!e(s))
      return r(s);
    var l = n(s), d = [];
    for (var m in s)
      m == "constructor" && (l || !a.call(s, m)) || d.push(m);
    return d;
  }
  return _d = o, _d;
}
var Sd, ng;
function xp() {
  if (ng) return Sd;
  ng = 1;
  var e = c_(), n = U1(), r = u_();
  function i(a) {
    return r(a) ? e(a, !0) : n(a);
  }
  return Sd = i, Sd;
}
var Nd, tg;
function M1() {
  if (tg) return Nd;
  tg = 1;
  var e = wo(), n = xp();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return Nd = r, Nd;
}
var vs = { exports: {} };
vs.exports;
var rg;
function B1() {
  return rg || (rg = 1, (function(e, n) {
    var r = zr(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? r.Buffer : void 0, l = s ? s.allocUnsafe : void 0;
    function d(m, u) {
      if (u)
        return m.slice();
      var f = m.length, h = l ? l(f) : new m.constructor(f);
      return m.copy(h), h;
    }
    e.exports = d;
  })(vs, vs.exports)), vs.exports;
}
var jd, ig;
function q1() {
  if (ig) return jd;
  ig = 1;
  function e(n, r) {
    var i = -1, a = n.length;
    for (r || (r = Array(a)); ++i < a; )
      r[i] = n[i];
    return r;
  }
  return jd = e, jd;
}
var wd, ag;
function H1() {
  if (ag) return wd;
  ag = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = 0, s = []; ++i < a; ) {
      var l = n[i];
      r(l, i, n) && (s[o++] = l);
    }
    return s;
  }
  return wd = e, wd;
}
var Cd, og;
function m_() {
  if (og) return Cd;
  og = 1;
  function e() {
    return [];
  }
  return Cd = e, Cd;
}
var Fd, sg;
function _p() {
  if (sg) return Fd;
  sg = 1;
  var e = H1(), n = m_(), r = Object.prototype, i = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, o = a ? function(s) {
    return s == null ? [] : (s = Object(s), e(a(s), function(l) {
      return i.call(s, l);
    }));
  } : n;
  return Fd = o, Fd;
}
var Id, lg;
function W1() {
  if (lg) return Id;
  lg = 1;
  var e = wo(), n = _p();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return Id = r, Id;
}
var Ed, cg;
function Sp() {
  if (cg) return Ed;
  cg = 1;
  var e = d_(), n = e(Object.getPrototypeOf, Object);
  return Ed = n, Ed;
}
var Td, dg;
function p_() {
  if (dg) return Td;
  dg = 1;
  var e = yp(), n = Sp(), r = _p(), i = m_(), a = Object.getOwnPropertySymbols, o = a ? function(s) {
    for (var l = []; s; )
      e(l, r(s)), s = n(s);
    return l;
  } : i;
  return Td = o, Td;
}
var $d, ug;
function G1() {
  if (ug) return $d;
  ug = 1;
  var e = wo(), n = p_();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return $d = r, $d;
}
var Dd, mg;
function f_() {
  if (mg) return Dd;
  mg = 1;
  var e = yp(), n = ai();
  function r(i, a, o) {
    var s = a(i);
    return n(i) ? s : e(s, o(i));
  }
  return Dd = r, Dd;
}
var Rd, pg;
function K1() {
  if (pg) return Rd;
  pg = 1;
  var e = f_(), n = _p(), r = bp();
  function i(a) {
    return e(a, r, n);
  }
  return Rd = i, Rd;
}
var Od, fg;
function h_() {
  if (fg) return Od;
  fg = 1;
  var e = f_(), n = p_(), r = xp();
  function i(a) {
    return e(a, r, n);
  }
  return Od = i, Od;
}
var Ad, hg;
function Y1() {
  if (hg) return Ad;
  hg = 1;
  var e = Ri(), n = zr(), r = e(n, "DataView");
  return Ad = r, Ad;
}
var Pd, yg;
function Q1() {
  if (yg) return Pd;
  yg = 1;
  var e = Ri(), n = zr(), r = e(n, "Promise");
  return Pd = r, Pd;
}
var Ld, gg;
function J1() {
  if (gg) return Ld;
  gg = 1;
  var e = Ri(), n = zr(), r = e(n, "Set");
  return Ld = r, Ld;
}
var Vd, vg;
function X1() {
  if (vg) return Vd;
  vg = 1;
  var e = Ri(), n = zr(), r = e(n, "WeakMap");
  return Vd = r, Vd;
}
var zd, kg;
function Np() {
  if (kg) return zd;
  kg = 1;
  var e = Y1(), n = up(), r = Q1(), i = J1(), a = X1(), o = da(), s = Qx(), l = "[object Map]", d = "[object Object]", m = "[object Promise]", u = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", g = s(e), C = s(n), S = s(r), N = s(i), w = s(a), y = o;
  return (e && y(new e(new ArrayBuffer(1))) != h || n && y(new n()) != l || r && y(r.resolve()) != m || i && y(new i()) != u || a && y(new a()) != f) && (y = function(z) {
    var $ = o(z), I = $ == d ? z.constructor : void 0, T = I ? s(I) : "";
    if (T)
      switch (T) {
        case g:
          return h;
        case C:
          return l;
        case S:
          return m;
        case N:
          return u;
        case w:
          return f;
      }
    return $;
  }), zd = y, zd;
}
var Ud, bg;
function Z1() {
  if (bg) return Ud;
  bg = 1;
  var e = Object.prototype, n = e.hasOwnProperty;
  function r(i) {
    var a = i.length, o = new i.constructor(a);
    return a && typeof i[0] == "string" && n.call(i, "index") && (o.index = i.index, o.input = i.input), o;
  }
  return Ud = r, Ud;
}
var Md, xg;
function eF() {
  if (xg) return Md;
  xg = 1;
  var e = zr(), n = e.Uint8Array;
  return Md = n, Md;
}
var Bd, _g;
function jp() {
  if (_g) return Bd;
  _g = 1;
  var e = eF();
  function n(r) {
    var i = new r.constructor(r.byteLength);
    return new e(i).set(new e(r)), i;
  }
  return Bd = n, Bd;
}
var qd, Sg;
function nF() {
  if (Sg) return qd;
  Sg = 1;
  var e = jp();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.byteLength);
  }
  return qd = n, qd;
}
var Hd, Ng;
function tF() {
  if (Ng) return Hd;
  Ng = 1;
  var e = /\w*$/;
  function n(r) {
    var i = new r.constructor(r.source, e.exec(r));
    return i.lastIndex = r.lastIndex, i;
  }
  return Hd = n, Hd;
}
var Wd, jg;
function rF() {
  if (jg) return Wd;
  jg = 1;
  var e = jo(), n = e ? e.prototype : void 0, r = n ? n.valueOf : void 0;
  function i(a) {
    return r ? Object(r.call(a)) : {};
  }
  return Wd = i, Wd;
}
var Gd, wg;
function iF() {
  if (wg) return Gd;
  wg = 1;
  var e = jp();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.length);
  }
  return Gd = n, Gd;
}
var Kd, Cg;
function aF() {
  if (Cg) return Kd;
  Cg = 1;
  var e = jp(), n = nF(), r = tF(), i = rF(), a = iF(), o = "[object Boolean]", s = "[object Date]", l = "[object Map]", d = "[object Number]", m = "[object RegExp]", u = "[object Set]", f = "[object String]", h = "[object Symbol]", g = "[object ArrayBuffer]", C = "[object DataView]", S = "[object Float32Array]", N = "[object Float64Array]", w = "[object Int8Array]", y = "[object Int16Array]", z = "[object Int32Array]", $ = "[object Uint8Array]", I = "[object Uint8ClampedArray]", T = "[object Uint16Array]", U = "[object Uint32Array]";
  function Q(J, ae, X) {
    var B = J.constructor;
    switch (ae) {
      case g:
        return e(J);
      case o:
      case s:
        return new B(+J);
      case C:
        return n(J, X);
      case S:
      case N:
      case w:
      case y:
      case z:
      case $:
      case I:
      case T:
      case U:
        return a(J, X);
      case l:
        return new B();
      case d:
      case f:
        return new B(J);
      case m:
        return r(J);
      case u:
        return new B();
      case h:
        return i(J);
    }
  }
  return Kd = Q, Kd;
}
var Yd, Fg;
function oF() {
  if (Fg) return Yd;
  Fg = 1;
  var e = ua(), n = Object.create, r = /* @__PURE__ */ (function() {
    function i() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (n)
        return n(a);
      i.prototype = a;
      var o = new i();
      return i.prototype = void 0, o;
    };
  })();
  return Yd = r, Yd;
}
var Qd, Ig;
function sF() {
  if (Ig) return Qd;
  Ig = 1;
  var e = oF(), n = Sp(), r = kp();
  function i(a) {
    return typeof a.constructor == "function" && !r(a) ? e(n(a)) : {};
  }
  return Qd = i, Qd;
}
var Jd, Eg;
function lF() {
  if (Eg) return Jd;
  Eg = 1;
  var e = Np(), n = Di(), r = "[object Map]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Jd = i, Jd;
}
var Xd, Tg;
function cF() {
  if (Tg) return Xd;
  Tg = 1;
  var e = lF(), n = gp(), r = vp(), i = r && r.isMap, a = i ? n(i) : e;
  return Xd = a, Xd;
}
var Zd, $g;
function dF() {
  if ($g) return Zd;
  $g = 1;
  var e = Np(), n = Di(), r = "[object Set]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Zd = i, Zd;
}
var eu, Dg;
function uF() {
  if (Dg) return eu;
  Dg = 1;
  var e = dF(), n = gp(), r = vp(), i = r && r.isSet, a = i ? n(i) : e;
  return eu = a, eu;
}
var nu, Rg;
function mF() {
  if (Rg) return nu;
  Rg = 1;
  var e = T1(), n = $1(), r = mp(), i = V1(), a = M1(), o = B1(), s = q1(), l = W1(), d = G1(), m = K1(), u = h_(), f = Np(), h = Z1(), g = aF(), C = sF(), S = ai(), N = l_(), w = cF(), y = ua(), z = uF(), $ = bp(), I = xp(), T = 1, U = 2, Q = 4, J = "[object Arguments]", ae = "[object Array]", X = "[object Boolean]", B = "[object Date]", O = "[object Error]", q = "[object Function]", ee = "[object GeneratorFunction]", ve = "[object Map]", ue = "[object Number]", ce = "[object Object]", fe = "[object RegExp]", W = "[object Set]", xe = "[object String]", Ie = "[object Symbol]", K = "[object WeakMap]", qe = "[object ArrayBuffer]", Be = "[object DataView]", Oe = "[object Float32Array]", Me = "[object Float64Array]", $e = "[object Int8Array]", ze = "[object Int16Array]", Re = "[object Int32Array]", an = "[object Uint8Array]", Ee = "[object Uint8ClampedArray]", Ge = "[object Uint16Array]", Qe = "[object Uint32Array]", he = {};
  he[J] = he[ae] = he[qe] = he[Be] = he[X] = he[B] = he[Oe] = he[Me] = he[$e] = he[ze] = he[Re] = he[ve] = he[ue] = he[ce] = he[fe] = he[W] = he[xe] = he[Ie] = he[an] = he[Ee] = he[Ge] = he[Qe] = !0, he[O] = he[q] = he[K] = !1;
  function ge(De, Le, Ae, mn, E, x) {
    var D, H = Le & T, Y = Le & U, R = Le & Q;
    if (Ae && (D = E ? Ae(De, mn, E, x) : Ae(De)), D !== void 0)
      return D;
    if (!y(De))
      return De;
    var V = S(De);
    if (V) {
      if (D = h(De), !H)
        return s(De, D);
    } else {
      var ie = f(De), me = ie == q || ie == ee;
      if (N(De))
        return o(De, H);
      if (ie == ce || ie == J || me && !E) {
        if (D = Y || me ? {} : C(De), !H)
          return Y ? d(De, a(D, De)) : l(De, i(D, De));
      } else {
        if (!he[ie])
          return E ? De : {};
        D = g(De, ie, H);
      }
    }
    x || (x = new e());
    var Ne = x.get(De);
    if (Ne)
      return Ne;
    x.set(De, D), z(De) ? De.forEach(function(tn) {
      D.add(ge(tn, Le, Ae, tn, De, x));
    }) : w(De) && De.forEach(function(tn, cn) {
      D.set(cn, ge(tn, Le, Ae, cn, De, x));
    });
    var nn = R ? Y ? u : m : Y ? I : $, fn = V ? void 0 : nn(De);
    return n(fn || De, function(tn, cn) {
      fn && (cn = tn, tn = De[cn]), r(D, cn, ge(tn, Le, Ae, cn, De, x));
    }), D;
  }
  return nu = ge, nu;
}
var tu, Og;
function pF() {
  if (Og) return tu;
  Og = 1;
  function e(n) {
    var r = n == null ? 0 : n.length;
    return r ? n[r - 1] : void 0;
  }
  return tu = e, tu;
}
var ru, Ag;
function fF() {
  if (Ag) return ru;
  Ag = 1;
  function e(n, r, i) {
    var a = -1, o = n.length;
    r < 0 && (r = -r > o ? 0 : o + r), i = i > o ? o : i, i < 0 && (i += o), o = r > i ? 0 : i - r >>> 0, r >>>= 0;
    for (var s = Array(o); ++a < o; )
      s[a] = n[a + r];
    return s;
  }
  return ru = e, ru;
}
var iu, Pg;
function hF() {
  if (Pg) return iu;
  Pg = 1;
  var e = e_(), n = fF();
  function r(i, a) {
    return a.length < 2 ? i : e(i, n(a, 0, -1));
  }
  return iu = r, iu;
}
var au, Lg;
function yF() {
  if (Lg) return au;
  Lg = 1;
  var e = ma(), n = pF(), r = hF(), i = sl(), a = Object.prototype, o = a.hasOwnProperty;
  function s(l, d) {
    d = e(d, l);
    var m = -1, u = d.length;
    if (!u)
      return !0;
    for (; ++m < u; ) {
      var f = i(d[m]);
      if (f === "__proto__" && !o.call(l, "__proto__") || (f === "constructor" || f === "prototype") && m < u - 1)
        return !1;
    }
    var h = r(l, d);
    return h == null || delete h[i(n(d))];
  }
  return au = s, au;
}
var ou, Vg;
function gF() {
  if (Vg) return ou;
  Vg = 1;
  var e = da(), n = Sp(), r = Di(), i = "[object Object]", a = Function.prototype, o = Object.prototype, s = a.toString, l = o.hasOwnProperty, d = s.call(Object);
  function m(u) {
    if (!r(u) || e(u) != i)
      return !1;
    var f = n(u);
    if (f === null)
      return !0;
    var h = l.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && s.call(h) == d;
  }
  return ou = m, ou;
}
var su, zg;
function vF() {
  if (zg) return su;
  zg = 1;
  var e = gF();
  function n(r) {
    return e(r) ? void 0 : r;
  }
  return su = n, su;
}
var lu, Ug;
function kF() {
  if (Ug) return lu;
  Ug = 1;
  var e = Zx(), n = mF(), r = yF(), i = ma(), a = wo(), o = vF(), s = i_(), l = h_(), d = 1, m = 2, u = 4, f = s(function(h, g) {
    var C = {};
    if (h == null)
      return C;
    var S = !1;
    g = e(g, function(w) {
      return w = i(w, h), S || (S = w.length > 1), w;
    }), a(h, l(h), C), S && (C = n(C, d | m | u, o));
    for (var N = g.length; N--; )
      r(C, g[N]);
    return C;
  });
  return lu = f, lu;
}
kF();
const jr = ({
  children: e,
  ...n
}) => {
  const { controller: r, controllerProps: i, fieldWrapperProps: a } = s_(n), {
    name: o,
    onBlur: s,
    onChange: l,
    ...d
  } = r.field;
  return /* @__PURE__ */ xi.jsx(ln, { ...a, children: /* @__PURE__ */ xi.jsx(
    ni,
    {
      ...n.componentProps,
      ...d,
      multiple: !1,
      value: d.value ? [d.value] : [],
      onBlur: (m) => {
        n.componentProps?.onBlur?.(m), s();
      },
      onChange: (m) => {
        n.componentProps?.onChange?.(m), l(m.selectedValues[0] ?? null);
      },
      id: i.name,
      "aria-disabled": a.disabled,
      disabled: a.disabled,
      "aria-required": a.required,
      required: a.required,
      status: ln.getStatus(a.meta),
      children: e
    }
  ) });
};
var bF = r_();
const xF = /* @__PURE__ */ Gx(bF), Jn = ({
  transformValue: e = xF,
  label: n,
  helpIcon: r,
  className: i,
  ...a
}) => {
  const {
    controller: { field: o },
    controllerProps: { name: s }
  } = o_(a);
  return /* @__PURE__ */ xi.jsxs(b, { gap: "200", alignItems: "center", className: i, children: [
    /* @__PURE__ */ xi.jsx(
      im,
      {
        ...o,
        id: s,
        checked: e(o.value),
        disabled: a.componentProps?.disabled,
        onChange: (l) => {
          a.componentProps?.onChange?.(l), o.onChange(e(l.target.checked));
        }
      }
    ),
    n && /* @__PURE__ */ xi.jsx(I0, { htmlFor: s, helpIcon: r, children: n })
  ] });
}, tt = (e) => {
  const { controller: n, controllerProps: r, fieldWrapperProps: i } = s_(e);
  return /* @__PURE__ */ xi.jsx(ln, { ...i, children: /* @__PURE__ */ xi.jsx(
    Nr,
    {
      ...e.componentProps,
      ...n.field,
      value: e.componentProps?.type === "number" && isNaN(n.field.value) ? "" : n.field.value ?? "",
      onBlur: (a) => {
        e.componentProps?.onBlur?.(a), n.field.onBlur();
      },
      onChange: (a) => {
        e.componentProps?.onChange?.(a), n.field.onChange(
          e.componentProps?.type === "number" ? a.target.valueAsNumber : a
        );
      },
      id: r.name,
      "aria-disabled": i.disabled,
      disabled: i.disabled,
      "aria-required": i.required,
      required: i.required,
      status: ln.getStatus(i.meta)
    }
  ) });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._contentWrapper_1vx3c_1{margin-bottom:var(--dixa-size-spacer-300)}._contentWrapperHeadline_1vx3c_4{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary);margin-bottom:var(--dixa-size-spacer-100)}._contentWrapperBody_1vx3c_11{max-height:75vh;overflow-y:auto}._contentWrapperAssigneeIcon_1vx3c_15{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle}._contentWrapperStatusTag_1vx3c_20{margin-right:var(--dixa-size-spacer-200)}._collapse_1bdjy_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_1bdjy_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_1bdjy_10>div>div>p{white-space:unset!important}._collapseHeader_1bdjy_10>div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_1bdjy_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderKey_1bdjy_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-700)}._collapseHeaderKeyIcon_1bdjy_36{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._collapseHeaderKeyLink_1bdjy_41{text-decoration:none}._collapseHeaderIcon_1bdjy_44{padding-top:.35em;margin-left:var(--dixa-size-spacer-100);vertical-align:text-bottom}._collapseHeaderTitle_1bdjy_49{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_1bdjy_57{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentButtonSpacer_1bdjy_60{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_1bdjy_63{color:var(--dixa-typography-color-link)}._result_1uaom_1{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_1uaom_1:hover,._result_1uaom_1:focus{background-color:var(--dixa-color-neutral-100)}._resultName_1uaom_21{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultItemIcon_1uaom_29{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._resultDescription_1uaom_34{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_1uaom_46{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_1uaom_55{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipName_1uaom_61{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_1uaom_66{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipTag_1uaom_71{width:fit-content;max-width:15em}._itemButton_3sxfy_1{border:none;padding:0}._result_3sxfy_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_3sxfy_6:hover,._result_3sxfy_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_3sxfy_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_3sxfy_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-normal)}._resultCheckIcon_3sxfy_38{height:var(--dixa-size-spacer-400)}._resultAssigneeIcon_3sxfy_41{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle;margin-right:var(--dixa-size-spacer-200)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_19v8w_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_19v8w_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300);text-align:center}._inputField_19v8w_15{text-align:center}._buttonLink_19v8w_19{color:var(--dixa-typography-color-link)}._noItemsFound_19v8w_23{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._createIssueButton_19v8w_28{min-height:38px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var cu = { exports: {} }, Na = {}, Mg;
function _F() {
  if (Mg) return Na;
  Mg = 1;
  var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return Na.Fragment = r, Na.jsx = s, Na.jsxs = s, Na;
}
var Lo = {}, Bg;
function SF() {
  return Bg || (Bg = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        z("error", t, p);
      }
    }
    function z(t, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, A = v.getStackAddendum();
        A !== "" && (c += "%s", p = p.concat([A]));
        var L = p.map(function(F) {
          return String(F);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, I = !1, T = !1, U = !1, Q = !1, J;
    J = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === u || U || t === g || $ || I || T || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function X(t, c, p) {
      var v = t.displayName;
      if (v)
        return v;
      var A = c.displayName || c.name || "";
      return A !== "" ? p + "(" + A + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return X(t, t.render, "ForwardRef");
          case f:
            var v = t.displayName || null;
            return v !== null ? v : O(t.type) || "Memo";
          case h: {
            var A = t, L = A._payload, F = A._init;
            try {
              return O(F(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, ue, ce, fe, W, xe, Ie;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ve = console.log, ue = console.info, ce = console.warn, fe = console.error, W = console.group, xe = console.groupCollapsed, Ie = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: ue
            }),
            warn: q({}, t, {
              value: ce
            }),
            error: q({}, t, {
              value: fe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: xe
            }),
            groupEnd: q({}, t, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Me;
    function $e(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (A) {
            var v = A.stack.trim().match(/\n( *(at )?)/);
            Me = v && v[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var ze = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(t, c) {
      if (!t || ze)
        return "";
      {
        var p = Re.get(t);
        if (p !== void 0)
          return p;
      }
      var v;
      ze = !0;
      var A = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, qe();
      try {
        if (c) {
          var F = function() {
            throw Error();
          };
          if (Object.defineProperty(F.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(F, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(t, [], F);
          } else {
            try {
              F.call();
            } catch (ne) {
              v = ne;
            }
            t.call(F.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), G = j.length - 1, _ = te.length - 1; G >= 1 && _ >= 0 && j[G] !== te[_]; )
            _--;
          for (; G >= 1 && _ >= 0; G--, _--)
            if (j[G] !== te[_]) {
              if (G !== 1 || _ !== 1)
                do
                  if (G--, _--, _ < 0 || j[G] !== te[_]) {
                    var Z = `
` + j[G].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (G >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Oe.current = L, Be(), Error.prepareStackTrace = A;
      }
      var de = t ? t.displayName || t.name : "", Se = de ? $e(de) : "";
      return typeof t == "function" && Re.set(t, Se), Se;
    }
    function Ge(t, c, p) {
      return Ee(t, !1);
    }
    function Qe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function he(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Qe(t));
      if (typeof t == "string")
        return $e(t);
      switch (t) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ge(t.render);
          case f:
            return he(t.type, c, p);
          case h: {
            var v = t, A = v._payload, L = v._init;
            try {
              return he(L(A), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, De = {}, Le = w.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = he(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(t, c, p, v, A) {
      {
        var L = Function.call.bind(ge);
        for (var F in t)
          if (L(t, F)) {
            var j = void 0;
            try {
              if (typeof t[F] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + F + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[F] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[F](c, F, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (G) {
              j = G;
            }
            j && !(j instanceof Error) && (Ae(A), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, F, typeof j), Ae(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Ae(A), y("Failed %s type: %s", p, j.message), Ae(null));
          }
      }
    }
    var E = Array.isArray;
    function x(t) {
      return E(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var V = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, me, Ne;
    function nn(t) {
      if (ge.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function fn(t) {
      if (ge.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && V.current;
    }
    function cn(t, c) {
      {
        var p = function() {
          me || (me = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(t, c, p, v, A, L, F) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: F,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: A
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, v, A) {
      {
        var L, F = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), fn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ge.call(c, L) && !ie.hasOwnProperty(L) && (F[L] = c[L]);
        if (t && t.defaultProps) {
          var G = t.defaultProps;
          for (L in G)
            F[L] === void 0 && (F[L] = G[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && cn(F, _), te && pn(F, _);
        }
        return dn(t, j, te, A, v, V.current, F);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = he(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var t = O(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        t && t._owner && t._owner !== en.current && (v = " It was passed a child from " + O(t._owner.type) + "."), Pe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Pe(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var v = t[p];
            sn(v) && gn(v, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var A = N(t);
          if (typeof A == "function" && A !== t.entries)
            for (var L = A.call(t), F; !(F = L.next()).done; )
              sn(F.value) && gn(F.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          mn(p, t.props, "prop", v, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var A = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", A || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Pe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Pe(null);
            break;
          }
        }
        t.ref !== null && (Pe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Pe(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, v, A, L) {
      {
        var F = ae(t);
        if (!F) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var G;
          t === null ? G = "null" : x(t) ? G = "array" : t !== void 0 && t.$$typeof === n ? (G = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : G = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", G, j);
        }
        var _ = xn(t, c, p, A, L);
        if (_ == null)
          return _;
        if (F) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var de = 0; de < Z.length; de++)
                  Cn(Z[de], t);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, t);
        }
        if (ge.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, Se, $n, Se), Sn[Se + Ke] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Lo.Fragment = i, Lo.jsx = Rn, Lo.jsxs = Mn;
  })()), Lo;
}
var qg;
function NF() {
  return qg || (qg = 1, process.env.NODE_ENV === "production" ? cu.exports = _F() : cu.exports = SF()), cu.exports;
}
var ye = NF();
const jF = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "IssueFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "issueState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, wF = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "PullRequestFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "prState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, CF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubOrganizationMembersByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "organization" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "login" }, value: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "members" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "login" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] } }] }, FF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createGithubIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "GitHub_CreateIssueInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, IF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubRepositoriesByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "REPOSITORY" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repositoryCount" } }, { kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Repository" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, EF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "issues" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "pullRequests" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "prQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] } }] }, TF = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, $F = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPullRequest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pullRequest" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "prNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, DF = {
  "\n  query getGithubOrganizationMembersByName(\n    $organizationQuery: String!\n    $usersQuery: String!\n    $maxResults: Int!\n  ) {\n    GitHub {\n      organization(login: $organizationQuery) {\n        teams(first: $maxResults) {\n          edges {\n            node {\n              id\n              name\n              members(first: $maxResults, query: $usersQuery) {\n                edges {\n                  node {\n                    id\n                    name\n                    login\n                    avatarUrl\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": CF,
  "\n  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {\n    GitHub {\n      createIssue(input: $input) {\n        issue {\n          id\n          number\n          repository {\n            name\n          }\n        }\n      }\n    }\n  }\n": FF,
  "\n  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {\n    GitHub {\n      search(query: $query, type: REPOSITORY, first: $maxResults) {\n        repositoryCount\n        edges {\n          node {\n            ... on GitHub_Repository {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": IF,
  "\n  fragment IssueFields on GitHub_Issue {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    issueState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": jF,
  "\n  fragment PullRequestFields on GitHub_PullRequest {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    prState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": wF,
  "\n  query searchItems(\n    $issueQuery: String!\n    $prQuery: String!\n    $maxIssueResults: Int\n    $maxPRResults: Int\n  ) {\n    GitHub {\n      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {\n        issueCount\n        nodes {\n          ... on GitHub_Issue {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {\n        issueCount\n        nodes {\n          ... on GitHub_PullRequest {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": EF,
  "\n  query getIssue(\n    $owner: String!\n    $repositoryName: String!\n    $issueNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        issue(number: $issueNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": TF,
  "\n  query getPullRequest(\n    $owner: String!\n    $repositoryName: String!\n    $prNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        pullRequest(number: $prNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": $F
};
function pa(e) {
  return DF[e] ?? {};
}
const RF = pa(
  /* GraphQL */
  `
  query searchItems(
    $issueQuery: String!
    $prQuery: String!
    $maxIssueResults: Int
    $maxPRResults: Int
  ) {
    GitHub {
      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {
        issueCount
        nodes {
          ... on GitHub_Issue {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {
        issueCount
        nodes {
          ... on GitHub_PullRequest {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
    }
  }
`
), OF = pa(
  /* GraphQL */
  `
  query getIssue(
    $owner: String!
    $repositoryName: String!
    $issueNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        issue(number: $issueNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), AF = pa(
  /* GraphQL */
  `
  query getPullRequest(
    $owner: String!
    $repositoryName: String!
    $prNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        pullRequest(number: $prNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), Hg = ({
  owner: e,
  repository: n,
  number: r
}) => `https://github.com/${e}/${n}/issues/${r}`, dr = ({
  owner: e,
  repository: n,
  number: r
}) => `${e}/${n} #${r}`, PF = ({
  number: e,
  repository: n
}) => ({
  number: e,
  repository: n.name,
  owner: n.owner.login
}), Wg = (e) => {
  switch (e) {
    case "ISSUE":
      return "issue";
    case "PR":
      return "pull request";
    default:
      return e;
  }
}, pm = (e, n, r) => e === "ISSUE" ? {
  OPEN: /* @__PURE__ */ ye.jsxs(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      height: "16",
      width: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ ye.jsx("path", { d: "M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" }),
        /* @__PURE__ */ ye.jsx("path", { d: "M8 0a8 8 0 100 16A8 8 0 008 0zM1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z" })
      ]
    }
  ),
  CLOSED: /* @__PURE__ */ ye.jsxs(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ ye.jsx("path", { d: "M11.28 6.78a.75.75 0 00-1.06-1.06L7.25 8.69 5.78 7.22a.75.75 0 00-1.06 1.06l2 2a.75.75 0 001.06 0l3.5-3.5z" }),
        /* @__PURE__ */ ye.jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "M16 8A8 8 0 110 8a8 8 0 0116 0zm-1.5 0a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"
          }
        )
      ]
    }
  )
}[n] : {
  OPEN: /* @__PURE__ */ ye.jsx(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ ye.jsx("path", { d: "M7.177 3.073L9.573.677A.25.25 0 0110 .854v4.792a.25.25 0 01-.427.177L7.177 3.427a.25.25 0 010-.354zM3.75 2.5a.75.75 0 100 1.5.75.75 0 000-1.5zm-2.25.75a2.25 2.25 0 113 2.122v5.256a2.251 2.251 0 11-1.5 0V5.372A2.25 2.25 0 011.5 3.25zM11 2.5h-1V4h1a1 1 0 011 1v5.628a2.251 2.251 0 101.5 0V5A2.5 2.5 0 0011 2.5zm1 10.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.75 12a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  ),
  MERGED: /* @__PURE__ */ ye.jsx(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ ye.jsx("path", { d: "M5 3.254V3.25v.005a.75.75 0 110-.005v.004zm.45 1.9a2.25 2.25 0 10-1.95.218v5.256a2.25 2.25 0 101.5 0V7.123A5.735 5.735 0 009.25 9h1.378a2.251 2.251 0 100-1.5H9.25a4.25 4.25 0 01-3.8-2.346zM12.75 9a.75.75 0 100-1.5.75.75 0 000 1.5zm-8.5 4.5a.75.75 0 100-1.5.75.75 0 000 1.5z" })
    }
  ),
  CLOSED: /* @__PURE__ */ ye.jsx(
    "svg",
    {
      className: r,
      fill: "#f85149",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ ye.jsx("path", { d: "M10.72 1.227a.75.75 0 011.06 0l.97.97.97-.97a.75.75 0 111.06 1.061l-.97.97.97.97a.75.75 0 01-1.06 1.06l-.97-.97-.97.97a.75.75 0 11-1.06-1.06l.97-.97-.97-.97a.75.75 0 010-1.06zM12.75 6.5a.75.75 0 00-.75.75v3.378a2.251 2.251 0 101.5 0V7.25a.75.75 0 00-.75-.75zm0 5.5a.75.75 0 100 1.5.75.75 0 000-1.5zM2.5 3.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.25 1a2.25 2.25 0 00-.75 4.372v5.256a2.251 2.251 0 101.5 0V5.372A2.25 2.25 0 003.25 1zm0 11a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  )
}[n];
function LF({
  conversationId: e,
  githubOrganization: n
}) {
  const r = {
    github: { issues: [], pullRequests: [] }
  }, [i, a] = le(
    []
  ), [o, s] = le([]), [l, d] = le([]), [m, u] = le([]), [f, h] = le(), { showNotification: g, showModal: C, executeQuery: S } = hn(), { track: N } = _n(), {
    loading: w,
    data: y,
    error: z,
    store: $
  } = Um(e ?? null), I = y?.github?.issues || [], T = y?.github?.pullRequests || [], [U, Q] = le(!1), [J, ae] = le();
  He(
    () => h(z || J || void 0),
    [z, J]
  ), He(
    () => {
      !w && (I?.length || T?.length) ? (a(I), s(T), B(I, T)) : (a([]), s([]), d([]), u([]));
    },
    // Only trigger when data is loaded, not when the loading status changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [y]
  );
  const X = async (fe, W) => {
    await $(fe).then(() => {
      g({
        icon: "check-circle-filled",
        severity: "success",
        title: W.success.title,
        text: W.success.text
      });
    }).catch((xe) => {
      g({
        title: W.error.title,
        text: `${W.error.text} ${xe.message && " (" + xe.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, B = (fe, W) => {
    if (!fe?.length && !W?.length) {
      d([]), u([]);
      return;
    }
    const xe = (fe || []).map(
      (qe) => S(OF, {
        owner: qe.owner,
        repositoryName: qe.repository,
        issueNumber: qe.number
      })
    ), Ie = (W || []).map(
      (qe) => S(AF, {
        owner: qe.owner,
        repositoryName: qe.repository,
        prNumber: qe.number
      })
    ), K = [...xe, ...Ie];
    Q(!0), Promise.all(K).then((qe) => {
      const Be = [], Oe = [];
      qe.forEach((Me) => {
        const $e = Me?.data?.GitHub;
        if (!$e) {
          d([]), u([]);
          return;
        }
        Object.keys($e).forEach((ze) => {
          if (ze.startsWith("repository")) {
            const Re = $e[ze];
            Object.keys(Re).forEach((an) => {
              const Ee = Re[an], Ge = {
                number: Ee?.number,
                owner: Ee?.repository?.owner?.login,
                repository: Ee?.repository?.name
              };
              an.startsWith("issue") && Be.push({
                ...Ee,
                type: "ISSUE",
                key: Ge
              }), an.startsWith("pullRequest") && Oe.push({
                ...Ee,
                type: "PR",
                key: Ge
              });
            });
          }
        });
      }), d(Be), u(Oe);
    }).catch(ae).finally(() => {
      Q(!1);
    });
  }, O = ({ key: fe, type: W }) => {
    N("github:link:issue:clicked", {
      githubOrganization: n
    });
    const xe = y && (I.length || T.length) ? y : r, Ie = W === "ISSUE" ? "issues" : "pullRequests";
    xe.github[Ie] = Array.from(
      new Set(xe.github[Ie]).add(fe)
    ), X(xe, {
      success: {
        title: "GitHub issue linked",
        text: `You linked the GitHub issue ${dr(
          fe
        )} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${dr(fe)} failed. Please try again.`
      }
    });
  }, q = async ({ key: fe, type: W }) => {
    N("github:link:issue:clicked", {
      githubOrganization: n
    });
    const xe = y && (I.length || T.length) ? y : r, Ie = W === "ISSUE" ? "issues" : "pullRequests";
    xe.github[Ie] = Array.from(
      new Set(xe.github[Ie]).add(fe)
    ), await $(xe).catch((K) => {
      g({
        title: "Linking failed",
        text: `Linking ${fe} failed. Please try again. ${K.message && " (" + K.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, ee = ({ key: fe, type: W }) => {
    N("github:unlink:issue:clicked", {
      githubOrganization: n
    });
    const xe = W === "ISSUE" ? "issue" : "pull request";
    C({
      headline: `Unlink ${xe} ${dr(fe)}?`,
      text: `You are about to unlink the ${xe} ${dr(
        fe
      )}. Do you want to proceed?`,
      confirmLabel: `Unlink GitHub ${xe}`,
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        const Ie = W === "ISSUE" ? "issues" : "pullRequests";
        if (!y)
          return;
        const K = {
          ...y,
          github: {
            ...y?.github,
            [Ie]: y?.github?.[Ie].filter(
              (qe) => qe.number !== fe.number || qe.owner !== fe.owner || qe.repository !== fe.repository
            )
          }
        };
        N("github:unlink:issue:confirmed", {
          githubOrganization: n
        }), X(K, {
          success: {
            title: `GitHub ${xe} unlinked`,
            text: `You unlinked the GitHub ${xe} ${dr(
              fe
            )}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${dr(fe)} failed.`
          }
        });
      },
      onCancel: () => {
        N("github:unlink:issue:canceled", {
          githubOrganization: n
        });
      }
    });
  }, ve = () => {
    N("github:unlink:all:clicked", {
      githubOrganization: n
    }), C({
      headline: "Unlink all GitHub issues/pull requests?",
      text: "You are about to unlink the all GitHub issues/pull requests from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues/pull requests",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        N("github:unlink:all:confirmed", {
          githubOrganization: n
        }), X(r, {
          success: {
            title: "Unlinking successful",
            text: "All GitHub issues/pull requests were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues/pull requests failed."
          }
        });
      },
      onCancel: () => {
        N("github:unlink:all:canceled", {
          githubOrganization: n
        });
      }
    });
  }, ue = I.filter(
    (fe) => !i?.includes(fe)
  ) || [], ce = T.filter(
    (fe) => !o?.includes(fe)
  ) || [];
  return {
    linkGithubItem: O,
    linkGithubItemQuietly: q,
    unlinkGithubItem: ee,
    loadGithubItems: B,
    removeDanglingGithubItemLinks: () => {
      const fe = {
        ...y,
        github: {
          ...y?.github,
          issues: I.filter(
            (W) => !ue.includes(W)
          ) || [],
          pullRequests: T.filter(
            (W) => !ce.includes(W)
          ) || []
        }
      };
      $(fe);
    },
    unlinkAllGithubItems: ve,
    isLoadingGithubItemLinks: w,
    danglingIssueLinks: ue,
    danglingPullRequestLinks: ce,
    isLoadingGithubItems: U,
    issues: l,
    pullRequests: m,
    error: f
  };
}
const VF = "_contentWrapper_1vx3c_1", zF = "_contentWrapperHeadline_1vx3c_4", UF = "_contentWrapperBody_1vx3c_11", MF = "_contentWrapperAssigneeIcon_1vx3c_15", BF = "_contentWrapperStatusTag_1vx3c_20", Br = {
  contentWrapper: VF,
  contentWrapperHeadline: zF,
  contentWrapperBody: UF,
  contentWrapperAssigneeIcon: MF,
  contentWrapperStatusTag: BF
}, y_ = ({
  description: e,
  assignees: n,
  labels: r
}) => /* @__PURE__ */ ye.jsxs(ye.Fragment, { children: [
  e && /* @__PURE__ */ ye.jsxs(et, { className: Br.contentWrapper, children: [
    /* @__PURE__ */ ye.jsx(et, { className: Br.contentWrapperHeadline, children: "Description" }),
    /* @__PURE__ */ ye.jsx(et, { className: Br.contentWrapperBody, children: e })
  ] }),
  n?.nodes && n.nodes.length > 0 && /* @__PURE__ */ ye.jsxs(et, { className: Br.contentWrapper, children: [
    /* @__PURE__ */ ye.jsx(et, { className: Br.contentWrapperHeadline, children: "Assignees" }),
    /* @__PURE__ */ ye.jsx(et, { className: Br.contentWrapperBody, children: n.nodes.map(
      (i) => i && /* @__PURE__ */ ye.jsxs(et, { margin: "100 0", children: [
        /* @__PURE__ */ ye.jsx(
          "img",
          {
            className: Br.contentWrapperAssigneeIcon,
            src: i.avatarUrl,
            alt: i.name || ""
          }
        ),
        " ",
        i.name
      ] }, i.name)
    ) })
  ] }),
  r?.nodes && r?.nodes.length > 0 && /* @__PURE__ */ ye.jsx(et, { className: Br.contentWrapper, children: r.nodes.map(
    (i) => i && /* @__PURE__ */ ye.jsx(
      Pn,
      {
        className: Br.contentWrapperStatusTag,
        children: i.name
      },
      i.name
    )
  ) })
] }), qF = "_collapse_1bdjy_1", HF = "_collapseHeader_1bdjy_10", WF = "_collapseHeaderKey_1bdjy_31", GF = "_collapseHeaderKeyIcon_1bdjy_36", KF = "_collapseHeaderKeyLink_1bdjy_41", YF = "_collapseHeaderIcon_1bdjy_44", QF = "_collapseHeaderTitle_1bdjy_49", JF = "_collapseContent_1bdjy_57", XF = "_collapseContentButtonSpacer_1bdjy_60", ZF = "_collapseContentButtonLink_1bdjy_63", Fr = {
  collapse: qF,
  collapseHeader: HF,
  collapseHeaderKey: WF,
  collapseHeaderKeyIcon: GF,
  collapseHeaderKeyLink: KF,
  collapseHeaderIcon: YF,
  collapseHeaderTitle: QF,
  collapseContent: JF,
  collapseContentButtonSpacer: XF,
  collapseContentButtonLink: ZF
}, eI = ({
  items: e,
  unlinkGithubItem: n,
  githubOrganization: r
}) => {
  const i = e.reduce(
    (d, m) => ({ ...d, [m.id]: !1 }),
    {}
  ), [a, o] = le(i), { track: s } = _n(), l = (d, m) => {
    o({ ...a, [d]: m });
  };
  return /* @__PURE__ */ ye.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((d) => {
    const {
      id: m,
      number: u,
      key: f,
      title: h,
      bodyText: g,
      repository: C,
      type: S,
      state: N,
      assignees: w,
      labels: y
    } = d, z = a[m];
    return /* @__PURE__ */ ye.jsxs(
      mr,
      {
        onToggle: () => l(m, !a[m]),
        isOpen: z,
        className: Fr.collapse,
        children: [
          /* @__PURE__ */ ye.jsx(mr.Header, { className: Fr.collapseHeader, children: /* @__PURE__ */ ye.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ ye.jsx(et, { children: /* @__PURE__ */ ye.jsxs(et, { as: "span", className: Fr.collapseHeaderKey, children: [
                  pm(
                    S,
                    N,
                    Fr.collapseHeaderKeyIcon
                  ),
                  /* @__PURE__ */ ye.jsxs(
                    "a",
                    {
                      href: Hg(f),
                      className: Fr.collapseHeaderKeyLink,
                      target: "_blank",
                      rel: "noreferrer",
                      onClick: ($) => {
                        $.stopPropagation();
                      },
                      children: [
                        dr(f),
                        /* @__PURE__ */ ye.jsx(
                          pe,
                          {
                            className: Fr.collapseHeaderIcon,
                            name: "external-link",
                            size: 16
                          }
                        )
                      ]
                    }
                  )
                ] }) }),
                /* @__PURE__ */ ye.jsx(et, { className: Fr.collapseHeaderTitle, children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ ye.jsx(mr.Content, { className: Fr.collapseContent, children: /* @__PURE__ */ ye.jsxs(b, { flexDirection: "column", margin: "0 0 200 0", children: [
            /* @__PURE__ */ ye.jsx(
              y_,
              {
                description: g,
                assignees: w,
                labels: y
              }
            ),
            /* @__PURE__ */ ye.jsxs(
              Gn,
              {
                icon: "link-slash",
                variant: "secondary",
                className: Fr.collapseContentButtonSpacer,
                onClick: () => n({
                  key: {
                    number: u,
                    owner: C?.owner.login,
                    repository: d.repository.name
                  },
                  type: S
                }),
                children: [
                  "Unlink ",
                  Wg(S)
                ]
              }
            ),
            /* @__PURE__ */ ye.jsxs(
              Et,
              {
                slotEnd: /* @__PURE__ */ ye.jsx(pe, { name: "external-link" }),
                variant: "tertiary",
                className: Fr.collapseContentButtonLink,
                navigate: () => {
                  s("github:view:link:clicked", {
                    githubOrganization: r
                  }), window.open(Hg(f), "_blank")?.focus();
                },
                children: [
                  "View ",
                  Wg(S),
                  " in GitHub"
                ]
              }
            )
          ] }) })
        ]
      },
      m
    );
  }) : /* @__PURE__ */ ye.jsx(ye.Fragment, {}) });
}, nI = "_result_1uaom_1", tI = "_resultName_1uaom_21", rI = "_resultItemIcon_1uaom_29", iI = "_resultDescription_1uaom_34", aI = "_resultLinkIcon_1uaom_46", oI = "_tooltip_1uaom_55", sI = "_tooltipName_1uaom_61", lI = "_tooltipTag_1uaom_71", qr = {
  result: nI,
  resultName: tI,
  resultItemIcon: rI,
  resultDescription: iI,
  resultLinkIcon: aI,
  tooltip: oI,
  tooltipName: sI,
  tooltipTag: lI
}, cI = ({
  item: e,
  onSelect: n
}) => {
  const { key: r, title: i, type: a, state: o, labels: s, bodyText: l, assignees: d } = e, [m, u] = le(!1);
  return /* @__PURE__ */ ye.jsx(
    We,
    {
      className: qr.tooltip,
      content: /* @__PURE__ */ ye.jsxs(b, { flexDirection: "column", justifyContent: "center", width: "100%", children: [
        /* @__PURE__ */ ye.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
            margin: "0 0 300 0",
            children: [
              /* @__PURE__ */ ye.jsxs(et, { as: "span", className: qr.tooltipName, children: [
                pm(a, o, qr.resultItemIcon),
                i
              ] }),
              /* @__PURE__ */ ye.jsx(Pn, { className: qr.tooltipTag, children: o })
            ]
          }
        ),
        /* @__PURE__ */ ye.jsx(
          y_,
          {
            description: l,
            assignees: d,
            labels: s
          }
        )
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ ye.jsxs(
        "button",
        {
          className: qr.result,
          type: "button",
          onClick: () => {
            n(e);
          },
          onMouseEnter: () => u(!0),
          onMouseLeave: () => u(!1),
          children: [
            /* @__PURE__ */ ye.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                width: "100%",
                style: {
                  width: m ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ ye.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ ye.jsxs(et, { as: "span", className: qr.resultName, children: [
                    pm(a, o, qr.resultItemIcon),
                    dr(r)
                  ] }) }),
                  /* @__PURE__ */ ye.jsx(et, { className: qr.resultDescription, children: i })
                ]
              }
            ),
            m && /* @__PURE__ */ ye.jsx(
              pe,
              {
                className: qr.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, dI = ({
  className: e,
  searched: n,
  githubOrganization: r
}) => /* @__PURE__ */ ye.jsx(
  Et,
  {
    slotEnd: /* @__PURE__ */ ye.jsx(pe, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `https://github.com/search?q=is:issue+org:${r}+${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching items on GitHub"
  }
), Ts = "[a-zA-z0-9_.-]+", g_ = "[0-9]+", uI = new RegExp(
  `(${Ts})/(${Ts})/(?:issues|pull)/(${g_})`,
  "i"
), Gg = new RegExp(`^${uI.source}$`), Kg = new RegExp(
  `https://github.com/(${Ts})/(${Ts})/(?:issues|pull)/(${g_})`,
  "i"
), mI = ({
  onSelectItem: e,
  githubOrganization: n,
  linkedIssues: r,
  linkedPullRequests: i
}) => {
  const a = Bn(() => r?.map((T) => T.id) || [], [r]), o = Bn(() => i?.map((T) => T.id) || [], [i]), [s, l] = le([]), { useLazyQuery: d } = hn(), [m, u] = le(), [f, { loading: h, error: g, data: C, networkStatus: S }] = d(RF, {
    notifyOnNetworkStatusChange: !0
  });
  $i(
    () => {
      !h && m && S === er.ready ? f({
        variables: {
          issueQuery: `${m} type:issue`,
          prQuery: `${m} type:pr`,
          maxIssueResults: 12,
          maxPRResults: 12
        }
      }) : l([]);
    },
    500,
    [m]
  ), He(() => {
    let T = C?.GitHub?.issues?.nodes || [], U = C?.GitHub?.pullRequests.nodes || [];
    a.length > 0 && (T = T.filter((Q) => !a.includes(Q.id))), o.length > 0 && (U = U.filter(
      (Q) => !o.includes(Q.id)
    )), l([
      ...T.map((Q) => ({
        ...Q,
        type: "ISSUE",
        key: {
          number: Q.number,
          owner: Q.repository.owner.login,
          repository: Q.repository.name
        }
      })),
      ...U.map((Q) => ({
        ...Q,
        type: "PR",
        key: {
          number: Q.number,
          owner: Q.repository.owner.login,
          repository: Q.repository.name
        }
      }))
    ]);
  }, [C, a, o]);
  function N(T) {
    const U = T?.trim();
    if (Gg.test(U)) {
      const [Q, J, ae, X] = U.match(Gg) || [];
      return J !== n ? void 0 : {
        owner: n,
        repository: ae,
        number: parseInt(X)
      };
    }
    if (Kg.test(U)) {
      const [Q, J, ae, X] = U.match(Kg) || [];
      return J !== n ? void 0 : {
        owner: n,
        repository: ae,
        number: parseInt(X)
      };
    }
  }
  const w = (T) => {
    e({
      key: PF(T),
      type: T.type
    }), u(void 0);
  }, y = (T) => {
    const U = N(T);
    u(
      U ? `org:${U.owner} repo:${U.repository} ${U.number}` : `org:${n} ${T}`
    );
  }, z = () => {
    u(void 0);
  }, $ = ({ className: T, searched: U }) => /* @__PURE__ */ ye.jsx(
    dI,
    {
      className: T,
      searched: U,
      githubOrganization: n
    }
  ), I = ({ item: T, onSelect: U }) => /* @__PURE__ */ ye.jsx(cI, { item: T, onSelect: U });
  return !h && g ? /* @__PURE__ */ ye.jsx(Fn, { error: g }) : /* @__PURE__ */ ye.jsx(
    wr,
    {
      items: s?.map((T) => ({ name: T.title, ...T })),
      loading: h,
      onSearch: y,
      onSelect: w,
      onClear: z,
      emptyMessage: m ? h ? "" : "No GitHub items found" : "Enter GitHub item key, link or search terms",
      suggestionComponent: $,
      itemComponent: I,
      placeholder: "Search GitHub items",
      searchable: !0,
      clearable: !0
    }
  );
}, pI = "_itemButton_3sxfy_1", fI = "_result_3sxfy_6", hI = "_resultName_3sxfy_30", yI = "_resultCheckIcon_3sxfy_38", gI = "_resultAssigneeIcon_3sxfy_41", ja = {
  itemButton: pI,
  result: fI,
  resultName: hI,
  resultCheckIcon: yI,
  resultAssigneeIcon: gI
}, v_ = ({
  item: e,
  checked: n = !1,
  onSelectItem: r
}) => /* @__PURE__ */ ye.jsx(
  b,
  {
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    "data-testid": "github-select-item-component",
    children: /* @__PURE__ */ ye.jsx(
      "button",
      {
        onClick: () => {
          r(e);
        },
        className: ja.itemButton,
        children: /* @__PURE__ */ ye.jsxs(b, { className: ja.result, flexDirection: "row", width: "100%", children: [
          e.iconUrl && /* @__PURE__ */ ye.jsx(et, { margin: "100 0", children: /* @__PURE__ */ ye.jsx(
            "img",
            {
              className: ja.resultAssigneeIcon,
              src: e.iconUrl,
              alt: e.name
            }
          ) }, e.name),
          /* @__PURE__ */ ye.jsx(et, { className: ja.resultName, children: e.name }),
          n && /* @__PURE__ */ ye.jsx(et, { className: ja.resultCheckIcon, children: /* @__PURE__ */ ye.jsx(pe, { name: "done" }) })
        ] })
      }
    )
  }
), vI = pa(
  /* GraphQL */
  `
  query getGithubOrganizationMembersByName(
    $organizationQuery: String!
    $usersQuery: String!
    $maxResults: Int!
  ) {
    GitHub {
      organization(login: $organizationQuery) {
        teams(first: $maxResults) {
          edges {
            node {
              id
              name
              members(first: $maxResults, query: $usersQuery) {
                edges {
                  node {
                    id
                    name
                    login
                    avatarUrl
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
), kI = ({
  githubOrganization: e,
  selectedItems: n,
  onChange: r,
  multiple: i = !1
}) => {
  const { useLazyQuery: a } = hn(), [o, s] = le([]), [l, d] = le(""), m = 2, [u, { loading: f, error: h, data: g, networkStatus: C }] = a(
    vI,
    {
      notifyOnNetworkStatusChange: !0
    }
  );
  return $i(
    () => {
      !f && l && l.length >= m && C === er.ready ? u({
        variables: {
          usersQuery: l,
          organizationQuery: e,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), He(() => {
    const S = g?.GitHub?.organization?.teams || { edges: [] }, N = [];
    S?.edges?.forEach((w) => {
      const y = w?.node?.members?.edges;
      (y?.length || 0) > 0 && y?.forEach((z) => {
        const $ = z?.node;
        $ && ($?.id && N.find((I) => I.id === $.id) || N.push($));
      });
    }), s(
      N.sort((w, y) => {
        const z = w.name?.toLowerCase() || w.login?.toLowerCase(), $ = y.name?.toLowerCase() || y.login?.toLowerCase();
        return z.localeCompare($, void 0, {
          sensitivity: "base"
        });
      })
    );
  }, [g]), !f && h ? /* @__PURE__ */ ye.jsx(Fn, { error: h }) : /* @__PURE__ */ ye.jsx(
    wr,
    {
      clearable: !0,
      searchable: !0,
      multiple: i,
      items: o?.map(({ id: S, name: N, login: w, avatarUrl: y }) => ({
        id: S,
        name: N || w,
        iconUrl: y
      })) || [],
      loading: f,
      onSearch: (S) => d(S),
      onChange: (S, N) => {
        const w = S.id;
        i ? (N && !n.find(
          (y) => y.id === w
        ) && n.push(S), N || (n = n.filter(
          (y) => y.id !== w
        ))) : n = N ? [S] : [], r(n);
      },
      onClear: () => d(""),
      selectedItems: n,
      emptyMessage: l ? f ? "" : "No user found" : "Search users",
      itemComponent: ({ item: S, onSelect: N, checked: w }) => /* @__PURE__ */ ye.jsx(
        v_,
        {
          item: S,
          checked: w,
          onSelectItem: N
        }
      ),
      placeholder: "Search GitHub users"
    }
  );
}, bI = ({
  field: e,
  value: n,
  onChange: r,
  githubOrganization: i
}) => {
  const { multiple: a, type: o } = e;
  switch (o) {
    case "any":
      return /* @__PURE__ */ ye.jsx(Nr, { onChange: r, value: n });
    case "array":
      return e?.allowedValues ? /* @__PURE__ */ ye.jsx(
        wr,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues.map(({ id: s, name: l, value: d }) => ({
            id: s,
            name: l || d
          }))
        }
      ) : /* @__PURE__ */ ye.jsx(
        Ws,
        {
          onChange: r,
          selectedTags: Array.isArray(n) ? n : []
        }
      );
    case "number":
      return /* @__PURE__ */ ye.jsx(Nr, { type: "number", onChange: r, value: n });
    case "option":
      return /* @__PURE__ */ ye.jsx(
        wr,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues?.map(
            ({ id: s, name: l, value: d }) => ({
              id: s,
              name: l || d
            })
          ) || []
        }
      );
    case "string":
      return /* @__PURE__ */ ye.jsx(Nr, { onChange: r, value: n || "" });
    case "textarea":
      return /* @__PURE__ */ ye.jsx(am, { onChange: r, value: n || "" });
    case "user":
      return /* @__PURE__ */ ye.jsx(
        kI,
        {
          githubOrganization: i,
          onChange: r,
          selectedItems: Array.isArray(n) ? n : [],
          multiple: a
        }
      );
    default:
      return /* @__PURE__ */ ye.jsx(ye.Fragment, { children: "Your organizations GitHub configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field." });
  }
}, xI = ({
  issueTypeFields: e,
  control: n,
  githubOrganization: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ ye.jsx(ye.Fragment, { children: e.filter(({ key: o }) => o !== "repository").map((o) => /* @__PURE__ */ ye.jsx(
  Wt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ ye.jsx(
      ln,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: bI({
          field: o,
          value: l,
          onChange: s,
          githubOrganization: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), _I = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => {
  const o = `${n}/${e.repository.name}/issues/${e.number}`;
  return /* @__PURE__ */ ye.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "400",
      "data-testid": "github-create-issue-success-message",
      children: [
        /* @__PURE__ */ ye.jsxs(P.Paragraph, { children: [
          "You can visit your new issue by following",
          " ",
          /* @__PURE__ */ ye.jsxs(P.ExternalLink, { href: o, target: "_blank", children: [
            "this link ",
            /* @__PURE__ */ ye.jsx(pe, { name: "external-link" })
          ] }),
          " ",
          "or copy it from the field below."
        ] }),
        /* @__PURE__ */ ye.jsx(ln, { label: "GitHub issue link", children: /* @__PURE__ */ ye.jsx(
          Nr,
          {
            readOnly: !0,
            value: o,
            suffix: {
              type: "button",
              button: {
                icon: r ? "done" : "copy",
                onClick: () => {
                  i(!0), a(o);
                }
              }
            }
          }
        ) })
      ]
    }
  );
}, SI = "_modalBody_1hk1o_1", NI = "_modalBodyFormFields_1hk1o_4", du = {
  modalBody: SI,
  modalBodyFormFields: NI
}, jI = pa(
  /* GraphQL */
  `
  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {
    GitHub {
      search(query: $query, type: REPOSITORY, first: $maxResults) {
        repositoryCount
        edges {
          node {
            ... on GitHub_Repository {
              id
              name
            }
          }
        }
      }
    }
  }
`
), wI = pa(
  /* GraphQL */
  `
  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {
    GitHub {
      createIssue(input: $input) {
        issue {
          id
          number
          repository {
            name
          }
        }
      }
    }
  }
`
), CI = [
  {
    key: "title",
    name: "Title",
    type: "string",
    required: !0
  },
  {
    key: "assignees",
    name: "Assignees",
    type: "user",
    required: !1,
    multiple: !0
  },
  {
    key: "body",
    name: "Description",
    type: "textarea",
    required: !1
  }
], FI = ({
  isOpen: e,
  onClose: n,
  linkGithubIssueQuietly: r,
  conversationContext: i,
  githubOrganization: a
}) => {
  const { showNotification: o, useLazyQuery: s, useMutation: l } = hn(), { track: d } = _n(), {
    control: m,
    handleSubmit: u,
    formState: { errors: f },
    reset: h,
    getValues: g
  } = _t(), [C, S] = le(""), [N, w] = le([]), [y, z] = le(), [$, I] = le(!1), [T, U] = le(!1), [Q, J] = Dx(), [
    ae,
    {
      loading: X,
      error: B,
      networkStatus: O
    }
  ] = s(jI, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (Ie) => {
      w(
        Ie.GitHub.search?.edges?.map((K) => K?.node)
      );
    },
    onError: () => {
      o({
        title: "Could not get repository list",
        text: "We could not fetch the list of your repositories. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), w([]);
    }
  });
  $i(
    () => {
      !X && C && O === er.ready ? ae({
        variables: {
          query: C,
          maxResults: 10
        }
      }) : w([]);
    },
    500,
    [C]
  );
  const [q, { error: ee }] = l(
    wI,
    {
      onError: (Ie) => {
        I(!1), o({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), console.warn("Error in createMutation", Ie);
      },
      onCompleted: (Ie) => {
        I(!1);
        const K = Ie.GitHub.createIssue?.issue;
        z(K), o({
          title: "Success",
          text: `GitHub issue '${K.number}' created`,
          icon: "check-circle-filled",
          severity: "success"
        }), r({
          owner: a,
          repository: K.repository.name,
          number: K.number
        });
      }
    }
  ), ve = (Ie) => {
    S(`org:${a} ${Ie}`);
  }, ue = (Ie, K) => {
    K(Ie), S("");
  }, ce = () => {
    S("");
  }, fe = (Ie) => {
    d("github:create:issue:confirmed", {
      githubOrganization: a
    }), I(!0), q({
      variables: {
        input: {
          repositoryId: Ie.repository.id,
          title: Ie.title,
          body: Ie.body,
          assigneeIds: Ie.assignees?.length > 0 ? Ie.assignees.map((K) => K.id) : void 0
        }
      }
    });
  };
  He(() => {
    const Ie = T ? window.setTimeout(() => U(!1), 2e3) : void 0;
    return () => window.clearTimeout(Ie);
  }, [T]);
  const W = () => {
    S(""), w([]), z(void 0), I(!1), U(!1);
  }, xe = () => {
    d("github:create:issue:canceled", {
      githubOrganization: a
    }), W(), h(), n();
  };
  return /* @__PURE__ */ ye.jsxs(
    Tt,
    {
      isOpen: e,
      "data-testid": "github-create-issue-modal",
      onClose: xe,
      children: [
        /* @__PURE__ */ ye.jsx(
          $t,
          {
            title: y ? "Issue creation successful" : "Create new GitHub issue",
            onClose: xe
          }
        ),
        /* @__PURE__ */ ye.jsxs(Dt, { className: du.modalBody, children: [
          !X && B && /* @__PURE__ */ ye.jsx(Fn, { error: B }),
          !$ && ee && /* @__PURE__ */ ye.jsx(Fn, { error: ee }),
          y ? /* @__PURE__ */ ye.jsx(
            _I,
            {
              createdIssue: y,
              issueBaseLink: `https://github.com/${a}`,
              issueLinkCopied: T,
              setIssueLinkCopied: U,
              copyToClipboard: J
            }
          ) : /* @__PURE__ */ ye.jsx(
            "form",
            {
              "data-testid": "github-create-issue-form",
              onSubmit: u(fe),
              children: /* @__PURE__ */ ye.jsxs(st, { children: [
                /* @__PURE__ */ ye.jsx(be, { children: /* @__PURE__ */ ye.jsx(ln, { label: "Repository", required: !0, children: /* @__PURE__ */ ye.jsx(
                  Wt,
                  {
                    control: m,
                    name: "repository",
                    rules: { required: "Please select a repository" },
                    render: ({ field: { onChange: Ie, value: K } }) => /* @__PURE__ */ ye.jsx(
                      wr,
                      {
                        className: du.modalBodyRepository,
                        searchable: !0,
                        clearable: !0,
                        loading: X,
                        onSearch: ve,
                        onSelect: (qe) => ue(qe, Ie),
                        onClear: ce,
                        selectedItems: [K],
                        placeholder: "Search GitHub repositories",
                        emptyMessage: B ? "No repositories found" : "No repositories available",
                        items: N || [],
                        itemComponent: ({ item: qe, onSelect: Be, checked: Oe }) => /* @__PURE__ */ ye.jsx(
                          v_,
                          {
                            item: qe,
                            checked: Oe,
                            onSelectItem: Be
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ ye.jsx(be, { className: du.modalBodyFormFields, children: /* @__PURE__ */ ye.jsx(
                  xI,
                  {
                    control: m,
                    errors: f,
                    getValues: g,
                    githubOrganization: a,
                    conversationContext: i,
                    issueTypeFields: CI
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ ye.jsx(
          At,
          {
            confirmOnClick: y ? xe : u(fe),
            confirmProps: {
              isLoading: $,
              loadingIndicator: /* @__PURE__ */ ye.jsx(un, { size: 16 })
            },
            confirmName: y ? "Close" : "Save",
            cancelOnClick: y ? void 0 : xe
          }
        )
      ]
    }
  );
}, II = "_wrapper_19v8w_1", EI = "_inputWrapper_19v8w_6", TI = "_buttonLink_19v8w_19", $I = "_noItemsFound_19v8w_23", DI = "_createIssueButton_19v8w_28", Vi = {
  wrapper: II,
  inputWrapper: EI,
  buttonLink: TI,
  noItemsFound: $I,
  createIssueButton: DI
}, RI = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = le(!1), { track: a } = _n(), o = n?.githubOrganization, s = !!n?.enableRemoveAllLinks, {
    linkGithubItem: l,
    linkGithubItemQuietly: d,
    unlinkGithubItem: m,
    loadGithubItems: u,
    removeDanglingGithubItemLinks: f,
    unlinkAllGithubItems: h,
    isLoadingGithubItemLinks: g,
    danglingIssueLinks: C,
    danglingPullRequestLinks: S,
    isLoadingGithubItems: N,
    issues: w,
    pullRequests: y,
    error: z
  } = LF({
    conversationId: e?.conversationId || null,
    githubOrganization: o
  }), $ = (J) => d({ key: J, type: "ISSUE" }), I = !(!!w?.length).valueOf() && !(!!y?.length).valueOf() && !(!!C?.length).valueOf() && !(!!S?.length).valueOf(), T = !g && !N && !!C?.length && !!S?.length && !!n?.showDanglingLinks, U = n?.enableCreateIssue, Q = !!w?.length || !!y?.length;
  return !N && z ? /* @__PURE__ */ ye.jsx(Fn, { error: z, retry: () => u() }) : /* @__PURE__ */ ye.jsxs(ye.Fragment, { children: [
    /* @__PURE__ */ ye.jsxs(b, { className: Vi.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ ye.jsxs(b, { className: Vi.inputWrapper, flexDirection: "column", children: [
        U && /* @__PURE__ */ ye.jsxs(ye.Fragment, { children: [
          /* @__PURE__ */ ye.jsx(
            Gn,
            {
              variant: "primary",
              onClick: () => {
                a("github:create:issue:clicked", {
                  githubOrganization: n?.githubOrganization
                }), i(!0);
              },
              className: Vi.createIssueButton,
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ ye.jsx("div", { className: Vi.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ ye.jsx(
          mI,
          {
            onSelectItem: l,
            githubOrganization: o,
            linkedIssues: w,
            linkedPullRequests: y
          }
        )
      ] }),
      N ? /* @__PURE__ */ ye.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ ye.jsx(un, { "data-testid": "github-widget-item-spinner" }) }) : Q ? /* @__PURE__ */ ye.jsx(
        eI,
        {
          items: [...w, ...y],
          unlinkGithubItem: m,
          githubOrganization: o
        }
      ) : /* @__PURE__ */ ye.jsx(P.Paragraph, { align: "center", className: Vi.noItemsFound, children: "No linked items found." }),
      T && /* @__PURE__ */ ye.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ ye.jsx(P.Heading, { variant: "heading-3", children: "Unresolved linked issues and/or pull requests" }),
            /* @__PURE__ */ ye.jsxs(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: [
              C.map((J) => /* @__PURE__ */ ye.jsx(
                Pn,
                {
                  onDelete: () => m({
                    key: J,
                    type: "ISSUE"
                  }),
                  children: dr(J)
                },
                dr(J)
              )),
              S.map((J) => /* @__PURE__ */ ye.jsx(
                Pn,
                {
                  onDelete: () => m({ key: J, type: "PR" }),
                  children: dr(J)
                },
                dr(J)
              ))
            ] }),
            /* @__PURE__ */ ye.jsx(
              Gn,
              {
                variant: "secondary",
                onClick: () => f(),
                icon: "link-slash",
                children: "Remove all"
              }
            )
          ]
        }
      ),
      s && Q && /* @__PURE__ */ ye.jsx(
        Gn,
        {
          variant: "secondary",
          disabled: I,
          onClick: h,
          children: "Remove all links"
        }
      ),
      /* @__PURE__ */ ye.jsx(
        Et,
        {
          slotEnd: /* @__PURE__ */ ye.jsx(pe, { name: "external-link" }),
          variant: "tertiary",
          className: Vi.buttonLink,
          navigate: () => {
            window.open(`https://github.com/${o}`, "_blank")?.focus();
          },
          children: "Open GitHub"
        }
      )
    ] }),
    /* @__PURE__ */ ye.jsx(
      FI,
      {
        isOpen: r,
        onClose: () => i(!1),
        linkGithubIssueQuietly: $,
        conversationContext: e,
        githubOrganization: o
      }
    )
  ] });
}, OI = [
  {
    key: "githubOrganization",
    label: "GitHub organization or user",
    placeholder: "Insert your GitHub organization or user name, e.g. dixahq",
    secret: !1,
    type: "input",
    required: !0
  },
  {
    key: "enableRemoveAllLinks",
    label: 'Enable the "Remove all links" button',
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    label: "Show unresolved links to GitHub items",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Lr
  }
], Yg = [
  {
    key: "githubOrganization",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "enableRemoveAllLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], si = "GITHUB", AI = {
  enabled: !1,
  name: "",
  githubOrganization: "",
  enableRemoveAllLinks: !1,
  showDanglingLinks: !1,
  enableCreateIssue: !0
}, PI = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = _t({
    mode: "onChange",
    defaultValues: AI
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: g,
    setMisconfigurationCause: C
  } = ji({
    integrationId: e,
    integrationType: si,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: S,
    error: N,
    isWidgetUnknown: w,
    refetch: y,
    widgetConfiguration: z
  } = wi({
    integrationId: e,
    fieldDefinitions: Yg,
    form: l,
    onMisconfigured: C
  }), { renderConditions: $, setRenderConditions: I, renderConditionsForSubmit: T } = Ci({
    integrationId: e,
    widgetConfiguration: z,
    renderConditionsEditor: o
  }), U = (J) => Ii(J, {
    fieldDefinitions: Yg,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: T
  }), Q = l.watch("name");
  return /* @__PURE__ */ ye.jsxs(
    Fi,
    {
      form: l,
      integrationId: e,
      onValidSubmit: U,
      error: N ?? h,
      onRetry: N ? y : void 0,
      isLoading: f || S,
      isWidgetUnknown: w,
      children: [
        g && /* @__PURE__ */ ye.jsx(Ei, { cause: g }),
        /* @__PURE__ */ ye.jsxs(st, { children: [
          /* @__PURE__ */ ye.jsx(be, { children: /* @__PURE__ */ ye.jsx(ln, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ ye.jsx(
            Jn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ye.jsx(be, { span: 3, children: /* @__PURE__ */ ye.jsx(
            tt,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ ye.jsx(be, { span: 3 }),
          /* @__PURE__ */ ye.jsx(be, { span: 3, children: /* @__PURE__ */ ye.jsx(
            tt,
            {
              name: "githubOrganization",
              label: "GitHub organization or user",
              control: l.control,
              rules: { required: "GitHub organization or user is required" },
              componentProps: {
                placeholder: "Insert your GitHub organization or user name, e.g. dixahq",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ ye.jsx(be, { span: 3 }),
          /* @__PURE__ */ ye.jsx(be, { span: 3, children: /* @__PURE__ */ ye.jsx(ln, { label: 'Enable the "Remove all links" button', children: /* @__PURE__ */ ye.jsx(
            Jn,
            {
              name: "enableRemoveAllLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ye.jsx(be, { span: 3 }),
          /* @__PURE__ */ ye.jsx(be, { span: 3, children: /* @__PURE__ */ ye.jsx(ln, { label: "Show unresolved links to GitHub items", children: /* @__PURE__ */ ye.jsx(
            Jn,
            {
              name: "showDanglingLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ye.jsx(be, { span: 3 }),
          /* @__PURE__ */ ye.jsx(be, { span: 3, children: /* @__PURE__ */ ye.jsx(ln, { label: 'Enable the "Create issue" button', children: /* @__PURE__ */ ye.jsx(
            Jn,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ye.jsx(be, { span: 3 }),
          !s && e && /* @__PURE__ */ ye.jsx(
            Lr,
            {
              configuration: n,
              integrationId: e,
              integrationType: si,
              label: "Authorize with OAuth"
            }
          ),
          o && $ !== null && /* @__PURE__ */ ye.jsx(be, { children: o({
            value: $,
            onChange: I,
            configurationKey: z?.id
          }) })
        ] }),
        /* @__PURE__ */ ye.jsx(
          Ti,
          {
            integrationType: si,
            integrationId: e,
            widgetName: Q,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ ye.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ ye.jsx(
                pe,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ ye.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ ye.jsxs(P.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  si,
                  " integration, all links between Dixa and ",
                  si,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ ye.jsxs(P.Paragraph, { children: [
                  "All data in ",
                  si,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ ye.jsxs(P.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  si,
                  " ",
                  'integration "',
                  Q,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_16pij_1{padding:0}._listItem_16pij_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_16pij_4:last-child{border-bottom:none}._listItemEdit_16pij_11{cursor:pointer}._clickableIcon_16pij_15{cursor:pointer;color:var(--dixa-typography-color-secondary)}._boxWrapper_89s7l_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._boxWrapper_89s7l_1:hover{border-color:var(--dixa-color-neutral-300)}._trackButton_89s7l_10{color:var(--dixa-typography-color-link)}._order_135ze_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_135ze_1:hover,._orderIsOpen_135ze_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_135ze_12{cursor:pointer}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var uu = { exports: {} }, wa = {}, Qg;
function LI() {
  if (Qg) return wa;
  Qg = 1;
  var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return wa.Fragment = r, wa.jsx = s, wa.jsxs = s, wa;
}
var Vo = {}, Jg;
function VI() {
  return Jg || (Jg = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        z("error", t, p);
      }
    }
    function z(t, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, A = v.getStackAddendum();
        A !== "" && (c += "%s", p = p.concat([A]));
        var L = p.map(function(F) {
          return String(F);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, I = !1, T = !1, U = !1, Q = !1, J;
    J = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === u || U || t === g || $ || I || T || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function X(t, c, p) {
      var v = t.displayName;
      if (v)
        return v;
      var A = c.displayName || c.name || "";
      return A !== "" ? p + "(" + A + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return X(t, t.render, "ForwardRef");
          case f:
            var v = t.displayName || null;
            return v !== null ? v : O(t.type) || "Memo";
          case h: {
            var A = t, L = A._payload, F = A._init;
            try {
              return O(F(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, ue, ce, fe, W, xe, Ie;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ve = console.log, ue = console.info, ce = console.warn, fe = console.error, W = console.group, xe = console.groupCollapsed, Ie = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: ue
            }),
            warn: q({}, t, {
              value: ce
            }),
            error: q({}, t, {
              value: fe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: xe
            }),
            groupEnd: q({}, t, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Me;
    function $e(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (A) {
            var v = A.stack.trim().match(/\n( *(at )?)/);
            Me = v && v[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var ze = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(t, c) {
      if (!t || ze)
        return "";
      {
        var p = Re.get(t);
        if (p !== void 0)
          return p;
      }
      var v;
      ze = !0;
      var A = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, qe();
      try {
        if (c) {
          var F = function() {
            throw Error();
          };
          if (Object.defineProperty(F.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(F, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(t, [], F);
          } else {
            try {
              F.call();
            } catch (ne) {
              v = ne;
            }
            t.call(F.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), G = j.length - 1, _ = te.length - 1; G >= 1 && _ >= 0 && j[G] !== te[_]; )
            _--;
          for (; G >= 1 && _ >= 0; G--, _--)
            if (j[G] !== te[_]) {
              if (G !== 1 || _ !== 1)
                do
                  if (G--, _--, _ < 0 || j[G] !== te[_]) {
                    var Z = `
` + j[G].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (G >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Oe.current = L, Be(), Error.prepareStackTrace = A;
      }
      var de = t ? t.displayName || t.name : "", Se = de ? $e(de) : "";
      return typeof t == "function" && Re.set(t, Se), Se;
    }
    function Ge(t, c, p) {
      return Ee(t, !1);
    }
    function Qe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function he(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Qe(t));
      if (typeof t == "string")
        return $e(t);
      switch (t) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ge(t.render);
          case f:
            return he(t.type, c, p);
          case h: {
            var v = t, A = v._payload, L = v._init;
            try {
              return he(L(A), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, De = {}, Le = w.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = he(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(t, c, p, v, A) {
      {
        var L = Function.call.bind(ge);
        for (var F in t)
          if (L(t, F)) {
            var j = void 0;
            try {
              if (typeof t[F] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + F + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[F] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[F](c, F, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (G) {
              j = G;
            }
            j && !(j instanceof Error) && (Ae(A), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, F, typeof j), Ae(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Ae(A), y("Failed %s type: %s", p, j.message), Ae(null));
          }
      }
    }
    var E = Array.isArray;
    function x(t) {
      return E(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var V = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, me, Ne;
    function nn(t) {
      if (ge.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function fn(t) {
      if (ge.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && V.current;
    }
    function cn(t, c) {
      {
        var p = function() {
          me || (me = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(t, c, p, v, A, L, F) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: F,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: A
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, v, A) {
      {
        var L, F = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), fn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ge.call(c, L) && !ie.hasOwnProperty(L) && (F[L] = c[L]);
        if (t && t.defaultProps) {
          var G = t.defaultProps;
          for (L in G)
            F[L] === void 0 && (F[L] = G[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && cn(F, _), te && pn(F, _);
        }
        return dn(t, j, te, A, v, V.current, F);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = he(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var t = O(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        t && t._owner && t._owner !== en.current && (v = " It was passed a child from " + O(t._owner.type) + "."), Pe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Pe(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var v = t[p];
            sn(v) && gn(v, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var A = N(t);
          if (typeof A == "function" && A !== t.entries)
            for (var L = A.call(t), F; !(F = L.next()).done; )
              sn(F.value) && gn(F.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          mn(p, t.props, "prop", v, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var A = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", A || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Pe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Pe(null);
            break;
          }
        }
        t.ref !== null && (Pe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Pe(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, v, A, L) {
      {
        var F = ae(t);
        if (!F) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var G;
          t === null ? G = "null" : x(t) ? G = "array" : t !== void 0 && t.$$typeof === n ? (G = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : G = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", G, j);
        }
        var _ = xn(t, c, p, A, L);
        if (_ == null)
          return _;
        if (F) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var de = 0; de < Z.length; de++)
                  Cn(Z[de], t);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, t);
        }
        if (ge.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, Se, $n, Se), Sn[Se + Ke] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Vo.Fragment = i, Vo.jsx = Rn, Vo.jsxs = Mn;
  })()), Vo;
}
var Xg;
function zI() {
  return Xg || (Xg = 1, process.env.NODE_ENV === "production" ? uu.exports = LI() : uu.exports = VI()), uu.exports;
}
var _e = zI(), Za = /* @__PURE__ */ ((e) => (e.Outbound = "OUTBOUND", e.Return = "RETURN", e.UnknownDirectionType = "UNKNOWN_DIRECTION_TYPE", e.Unspecified = "UNSPECIFIED", e))(Za || {}), pi = /* @__PURE__ */ ((e) => (e.Delivery = "DELIVERY", e.Instore = "INSTORE", e.Inwarehouse = "INWAREHOUSE", e.Mailbox = "MAILBOX", e.Pickup = "PICKUP", e.Unknown = "UNKNOWN", e))(pi || {}), Kt = /* @__PURE__ */ ((e) => (e.StepAwaitingSupplier = "STEP_AWAITING_SUPPLIER", e.StepConfirmedByMerchant = "STEP_CONFIRMED_BY_MERCHANT", e.StepDeliveredToConsumer = "STEP_DELIVERED_TO_CONSUMER", e.StepDeliveredToMerchant = "STEP_DELIVERED_TO_MERCHANT", e.StepDeliveredToPickupPoint = "STEP_DELIVERED_TO_PICKUP_POINT", e.StepLinehaulToCarrier = "STEP_LINEHAUL_TO_CARRIER", e.StepOnRoute = "STEP_ON_ROUTE", e.StepPreparedByMerchant = "STEP_PREPARED_BY_MERCHANT", e.StepReturnRequested = "STEP_RETURN_REQUESTED", e.StepSentBack = "STEP_SENT_BACK", e.StepSubmittedToCarrier = "STEP_SUBMITTED_TO_CARRIER", e.StepTerminated = "STEP_TERMINATED", e.StepUnknown = "STEP_UNKNOWN", e))(Kt || {});
const UI = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "locale" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Ingrid" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "DeliveryTracking_GetTrackingOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "locale" }, value: { kind: "Variable", name: { kind: "Name", value: "locale" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_GetTrackingOrdersResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "analytics_id" } }, { kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "preselected_parcel_index" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "site_name" } }, { kind: "Field", name: { kind: "Name", value: "tos_id" } }, { kind: "Field", name: { kind: "Name", value: "tracking_links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "cart" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_quantity" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_total_price" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "variant" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "size" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "prices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shipping_components" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "total" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "items_discount" } }, { kind: "Field", name: { kind: "Name", value: "items_price" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "shipping_discount" } }, { kind: "Field", name: { kind: "Name", value: "shipping_price" } }, { kind: "Field", name: { kind: "Name", value: "tax" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "parcels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alerts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "awaiting_supplier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "delivery_attempt_failed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed_from_carrier" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time_updated" } }, { kind: "Field", name: { kind: "Name", value: "linehaul" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "out_for_delivery" } }, { kind: "Field", name: { kind: "Name", value: "submission_delayed" } }] } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "carrier_fallback_enabled" } }, { kind: "Field", name: { kind: "Name", value: "carrier_link" } }, { kind: "Field", name: { kind: "Name", value: "carrier_logo_pattern" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_id" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_ref" } }, { kind: "Field", name: { kind: "Name", value: "delivery_type" } }, { kind: "Field", name: { kind: "Name", value: "direction_type" } }, { kind: "Field", name: { kind: "Name", value: "display_carrier_name" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "exceptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "status" } }] } }, { kind: "Field", name: { kind: "Name", value: "index" } }, { kind: "Field", name: { kind: "Name", value: "line_items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "location" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address_lines" } }, { kind: "Field", name: { kind: "Name", value: "apartment_number" } }, { kind: "Field", name: { kind: "Name", value: "attn" } }, { kind: "Field", name: { kind: "Name", value: "building_name" } }, { kind: "Field", name: { kind: "Name", value: "care_of" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "coordinates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lat" } }, { kind: "Field", name: { kind: "Name", value: "lng" } }] } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "door_code" } }, { kind: "Field", name: { kind: "Name", value: "floor_number" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "po_box_id" } }, { kind: "Field", name: { kind: "Name", value: "postal_code" } }, { kind: "Field", name: { kind: "Name", value: "region" } }, { kind: "Field", name: { kind: "Name", value: "street" } }, { kind: "Field", name: { kind: "Name", value: "street_number" } }, { kind: "Field", name: { kind: "Name", value: "subregion" } }] } }, { kind: "Field", name: { kind: "Name", value: "location_external_id" } }, { kind: "Field", name: { kind: "Name", value: "location_type" } }, { kind: "Field", name: { kind: "Name", value: "operational_hours" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "free_text" } }, { kind: "Field", name: { kind: "Name", value: "fri" } }, { kind: "Field", name: { kind: "Name", value: "mon" } }, { kind: "Field", name: { kind: "Name", value: "sat" } }, { kind: "Field", name: { kind: "Name", value: "sun" } }, { kind: "Field", name: { kind: "Name", value: "thu" } }, { kind: "Field", name: { kind: "Name", value: "tue" } }, { kind: "Field", name: { kind: "Name", value: "wed" } }] } }, { kind: "Field", name: { kind: "Name", value: "pickup_instructions" } }] } }, { kind: "Field", name: { kind: "Name", value: "progress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "step" } }, { kind: "Field", name: { kind: "Name", value: "time" } }] } }, { kind: "Field", name: { kind: "Name", value: "requested_shipping_method" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "tracking_link" } }, { kind: "Field", name: { kind: "Name", value: "tracking_number" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_Error" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "details" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, MI = {
  "\n  query getOrders($email: String!, $locale: String!) {\n    Ingrid {\n      DeliveryTracking_GetTrackingOrders(\n        email: $email\n        locale: $locale\n      ) {\n        ... on Ingrid_GetTrackingOrdersResponse {\n          orders {\n            analytics_id\n            external_id\n            preselected_parcel_index\n            sender_name\n            site_name\n            tos_id\n            tracking_links {\n              links {\n                type\n                url\n              }\n            }\n            items {\n              discount\n              image\n              name\n              price\n              quantity\n              sku\n              total_price\n            }\n            cart {\n              currency\n              items {\n                attributes\n                cancelled_quantity\n                cancelled_total_price\n                discount\n                image\n                name\n                price\n                quantity\n                sku\n                total_price\n                variant {\n                  color\n                  size\n                }\n              }\n              prices {\n                shipping_components {\n                  discount\n                  name\n                  price\n                }\n                total {\n                  discount\n                  items_discount\n                  items_price\n                  price\n                  shipping_discount\n                  shipping_price\n                  tax\n                }\n              }\n            }\n            parcels {\n              alerts {\n                created_at\n                type\n                awaiting_supplier {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                delivery_attempt_failed\n                delivery_delayed\n                delivery_delayed_from_carrier\n                estimated_delivery_time_updated\n                linehaul {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                out_for_delivery\n                submission_delayed\n              }\n              carrier\n              carrier_fallback_enabled\n              carrier_link\n              carrier_logo_pattern\n              carrier_product_id\n              carrier_product_ref\n              delivery_type\n              direction_type\n              display_carrier_name\n              estimated_delivery_time {\n                end\n                start\n              }\n              exceptions {\n                created_at\n                status\n              }\n              index\n              line_items {\n                currency\n                discount\n                image\n                name\n                price\n                properties\n                quantity\n                sku\n                total_price\n              }\n              location {\n                address {\n                  address_lines\n                  apartment_number\n                  attn\n                  building_name\n                  care_of\n                  city\n                  coordinates {\n                    lat\n                    lng\n                  }\n                  country\n                  door_code\n                  floor_number\n                  name\n                  po_box_id\n                  postal_code\n                  region\n                  street\n                  street_number\n                  subregion\n                }\n                location_external_id\n                location_type\n                operational_hours {\n                  free_text\n                  fri\n                  mon\n                  sat\n                  sun\n                  thu\n                  tue\n                  wed\n                }\n                pickup_instructions\n              }\n              progress {\n                estimated_time {\n                  end\n                  start\n                }\n                step\n                time\n              }\n              requested_shipping_method\n              sender_name\n              tracking_link\n              tracking_number\n            }\n          }\n        }\n\n        ... on Ingrid_Error {\n          code\n          details\n          message\n        }\n      }\n    }\n  }\n": UI
};
function BI(e) {
  return MI[e] ?? {};
}
const qI = BI(
  /* GraphQL */
  `
  query getOrders($email: String!, $locale: String!) {
    Ingrid {
      DeliveryTracking_GetTrackingOrders(
        email: $email
        locale: $locale
      ) {
        ... on Ingrid_GetTrackingOrdersResponse {
          orders {
            analytics_id
            external_id
            preselected_parcel_index
            sender_name
            site_name
            tos_id
            tracking_links {
              links {
                type
                url
              }
            }
            items {
              discount
              image
              name
              price
              quantity
              sku
              total_price
            }
            cart {
              currency
              items {
                attributes
                cancelled_quantity
                cancelled_total_price
                discount
                image
                name
                price
                quantity
                sku
                total_price
                variant {
                  color
                  size
                }
              }
              prices {
                shipping_components {
                  discount
                  name
                  price
                }
                total {
                  discount
                  items_discount
                  items_price
                  price
                  shipping_discount
                  shipping_price
                  tax
                }
              }
            }
            parcels {
              alerts {
                created_at
                type
                awaiting_supplier {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                delivery_attempt_failed
                delivery_delayed
                delivery_delayed_from_carrier
                estimated_delivery_time_updated
                linehaul {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                out_for_delivery
                submission_delayed
              }
              carrier
              carrier_fallback_enabled
              carrier_link
              carrier_logo_pattern
              carrier_product_id
              carrier_product_ref
              delivery_type
              direction_type
              display_carrier_name
              estimated_delivery_time {
                end
                start
              }
              exceptions {
                created_at
                status
              }
              index
              line_items {
                currency
                discount
                image
                name
                price
                properties
                quantity
                sku
                total_price
              }
              location {
                address {
                  address_lines
                  apartment_number
                  attn
                  building_name
                  care_of
                  city
                  coordinates {
                    lat
                    lng
                  }
                  country
                  door_code
                  floor_number
                  name
                  po_box_id
                  postal_code
                  region
                  street
                  street_number
                  subregion
                }
                location_external_id
                location_type
                operational_hours {
                  free_text
                  fri
                  mon
                  sat
                  sun
                  thu
                  tue
                  wed
                }
                pickup_instructions
              }
              progress {
                estimated_time {
                  end
                  start
                }
                step
                time
              }
              requested_shipping_method
              sender_name
              tracking_link
              tracking_number
            }
          }
        }

        ... on Ingrid_Error {
          code
          details
          message
        }
      }
    }
  }
`
), Zg = (e) => {
  if (!e) return "";
  try {
    return new Intl.DateTimeFormat(void 0, {
      dateStyle: "medium",
      timeStyle: "short"
    }).format(new Date(e));
  } catch {
    return e;
  }
}, k_ = (e, n) => {
  try {
    return new Intl.NumberFormat(void 0, {
      style: "currency",
      currency: n
    }).format(e);
  } catch {
    return e.toString();
  }
}, HI = "_listItem_16pij_4", WI = "_clickableIcon_16pij_15", yo = {
  listItem: HI,
  clickableIcon: WI
}, b_ = ({
  items: e,
  title: n,
  currency: r,
  openByDefault: i = !1
}) => {
  const [a, o] = le(i);
  return !e || e.length === 0 ? null : /* @__PURE__ */ _e.jsx(b, { gap: "100", flexDirection: "column", children: /* @__PURE__ */ _e.jsxs(b, { gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ _e.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ _e.jsx(pe, { size: 14, name: "list-ul", color: "blue.900" }),
      /* @__PURE__ */ _e.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ _e.jsxs(
        b,
        {
          gap: "100",
          flexDirection: "row",
          onClick: () => o(!a),
          className: yo.clickableIcon,
          alignItems: "center",
          children: [
            /* @__PURE__ */ _e.jsx(P.Paragraph, { variant: "3", children: n }),
            /* @__PURE__ */ _e.jsx(
              pe,
              {
                size: 14,
                name: a ? "angle-down" : "angle-right"
              }
            )
          ]
        }
      ) })
    ] }),
    a && /* @__PURE__ */ _e.jsx(Ye, { children: e.map((l, d) => {
      if (!l) return null;
      const { name: m, quantity: u, price: f, image: h, sku: g } = l, C = l.currency ?? r;
      return /* @__PURE__ */ _e.jsx(
        Ye.Item,
        {
          contentLeft: /* @__PURE__ */ _e.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ _e.jsx(P.Paragraph, { children: u }),
            /* @__PURE__ */ _e.jsx(P.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ _e.jsxs(b, { flexDirection: "column", gap: "050", children: [
            /* @__PURE__ */ _e.jsx(P.Paragraph, { variant: "4", children: m }),
            f != null && /* @__PURE__ */ _e.jsx(P.Paragraph, { variant: "4", color: "tertiary", children: k_(f / 100, C) })
          ] }),
          contentRight: h && /* @__PURE__ */ _e.jsx(la, { src: h, alt: m ?? "Product image" }),
          className: yo.listItem
        },
        `item-${d}-${g}`
      );
    }) })
  ] }) });
}, GI = "_boxWrapper_89s7l_1", KI = "_trackButton_89s7l_10", ev = {
  boxWrapper: GI,
  trackButton: KI
}, YI = {
  [Kt.StepUnknown]: "Unknown",
  [Kt.StepConfirmedByMerchant]: "Confirmed by merchant",
  [Kt.StepPreparedByMerchant]: "Prepared by merchant",
  [Kt.StepSubmittedToCarrier]: "Submitted to carrier",
  [Kt.StepLinehaulToCarrier]: "Linehaul to carrier",
  [Kt.StepOnRoute]: "On route",
  [Kt.StepDeliveredToPickupPoint]: "At pickup point",
  [Kt.StepDeliveredToConsumer]: "Delivered to customer",
  [Kt.StepDeliveredToMerchant]: "Returned to merchant",
  [Kt.StepReturnRequested]: "Return requested",
  [Kt.StepSentBack]: "Sent back",
  [Kt.StepTerminated]: "Terminated",
  [Kt.StepAwaitingSupplier]: "Awaiting supplier"
}, QI = {
  [pi.Delivery]: "Home delivery",
  [pi.Pickup]: "Pickup point",
  [pi.Instore]: "In-store pickup",
  [pi.Mailbox]: "Mailbox",
  [pi.Inwarehouse]: "Warehouse",
  [pi.Unknown]: "Unknown"
}, JI = {
  [Za.Outbound]: "From merchant to customer",
  [Za.Return]: "Return from customer to merchant",
  [Za.Unspecified]: "Unspecified",
  [Za.UnknownDirectionType]: "Unknown"
}, XI = (e) => e ? YI[e] ?? e : "", ZI = (e) => e ? QI[e] ?? e : "", eE = (e) => e ? JI[e] ?? e : "", nE = (e) => {
  if (!e) return null;
  const n = [e.street, e.street_number].filter(Boolean).join(" ");
  return [
    e.name,
    n,
    e.postal_code,
    e.city,
    e.country
  ].filter(Boolean).join(`
`);
}, tE = ({
  parcel: e
}) => {
  const { isCopied: n, copy: r } = or();
  if (!e)
    return null;
  const {
    carrier: i,
    progress: a,
    tracking_number: o,
    line_items: s,
    carrier_product_ref: l,
    carrier_link: d,
    display_carrier_name: m,
    delivery_type: u,
    direction_type: f,
    estimated_delivery_time: h
  } = e, g = m || l || i, C = a?.filter(($) => $?.time !== ""), S = XI(C?.[0]?.step), N = ZI(u), w = eE(f), y = nE(e.location?.address), z = 14;
  return /* @__PURE__ */ _e.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      padding: "250",
      className: ev.boxWrapper,
      children: [
        /* @__PURE__ */ _e.jsx(P.Heading, { variant: "heading-4", children: g }),
        /* @__PURE__ */ _e.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ _e.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ _e.jsx(
              pe,
              {
                size: z,
                name: "magnifying-glass-chart",
                color: "blue.900"
              }
            ),
            /* @__PURE__ */ _e.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ _e.jsx(P.Paragraph, { variant: "3", children: "Carrier tracking ID" }),
              /* @__PURE__ */ _e.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                !o && /* @__PURE__ */ _e.jsx(P.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                o && /* @__PURE__ */ _e.jsx(P.Paragraph, { variant: "4", color: "secondary", children: o })
              ] })
            ] })
          ] }),
          o && /* @__PURE__ */ _e.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ _e.jsx(We, { content: "Copy tracking ID", children: /* @__PURE__ */ _e.jsx(
            pe,
            {
              size: z,
              name: n ? "done" : "copy",
              className: yo.clickableIcon,
              onClick: () => r(o)
            }
          ) }) })
        ] }),
        S && /* @__PURE__ */ _e.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ _e.jsx(pe, { size: z, name: "chart-donut", color: "blue.900" }),
          /* @__PURE__ */ _e.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ _e.jsx(P.Paragraph, { variant: "3", children: "Status" }),
            /* @__PURE__ */ _e.jsx(P.Paragraph, { variant: "4", color: "secondary", children: S })
          ] })
        ] }),
        w && /* @__PURE__ */ _e.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ _e.jsx(pe, { size: z, name: "arrow-right", color: "blue.900" }),
          /* @__PURE__ */ _e.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ _e.jsx(P.Paragraph, { variant: "3", children: "Direction" }),
            /* @__PURE__ */ _e.jsx(P.Paragraph, { variant: "4", color: "secondary", children: w })
          ] })
        ] }),
        h && /* @__PURE__ */ _e.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ _e.jsx(pe, { size: z, name: "calendar", color: "blue.900" }),
          /* @__PURE__ */ _e.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ _e.jsx(P.Paragraph, { variant: "3", children: "Estimated delivery" }),
            /* @__PURE__ */ _e.jsxs(P.Paragraph, { variant: "4", color: "secondary", children: [
              Zg(h.start),
              " ",
              h.end && " until"
            ] }),
            h.end && /* @__PURE__ */ _e.jsx(P.Paragraph, { variant: "4", color: "secondary", children: Zg(h.end) })
          ] })
        ] }),
        u && /* @__PURE__ */ _e.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ _e.jsx(pe, { size: z, name: "info", color: "blue.900" }),
          /* @__PURE__ */ _e.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ _e.jsx(P.Paragraph, { variant: "3", children: "Delivery type" }),
            /* @__PURE__ */ _e.jsx(P.Paragraph, { variant: "4", color: "secondary", children: N })
          ] })
        ] }),
        y && /* @__PURE__ */ _e.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ _e.jsx(pe, { size: z, name: "map-pin", color: "blue.900" }),
          /* @__PURE__ */ _e.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ _e.jsx(P.Paragraph, { variant: "3", children: "Pickup location" }),
            /* @__PURE__ */ _e.jsx(P.Paragraph, { variant: "4", color: "secondary", children: y })
          ] })
        ] }),
        /* @__PURE__ */ _e.jsx(b_, { title: "Parcel items", items: s }),
        d && /* @__PURE__ */ _e.jsxs(
          Et,
          {
            variant: "secondary",
            className: ev.trackButton,
            navigate: () => window.open(d, "_blank")?.focus(),
            slotStart: /* @__PURE__ */ _e.jsx(pe, { name: "external-link" }),
            children: [
              "Track on ",
              g ?? "carrier",
              " website"
            ]
          }
        )
      ]
    }
  );
}, rE = "_order_135ze_1", iE = "_orderIsOpen_135ze_9", aE = "_orderHeader_135ze_12", mu = {
  order: rE,
  orderIsOpen: iE,
  orderHeader: aE
}, nv = "No order number found", oE = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = le(n), { isCopied: a, copy: o } = or(), { isCopied: s, copy: l } = or();
  if (!e)
    return null;
  const { cart: d, parcels: m, sender_name: u, tos_id: f } = e, h = e.external_id?.trim(), g = d?.currency || "", C = d?.prices?.total?.price ?? 0, S = k_(C / 100, g), N = 14, w = u && u.trim() !== "" ? u : "unknown sender";
  return /* @__PURE__ */ _e.jsxs(
    b,
    {
      className: it(mu.order, {
        [mu.orderIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ _e.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: mu.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ _e.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ _e.jsxs(P.Paragraph, { variant: "4", children: [
                  "From ",
                  w
                ] }),
                h ? /* @__PURE__ */ _e.jsx(P.Paragraph, { variant: "3", children: /* @__PURE__ */ _e.jsxs("span", { children: [
                  "#",
                  h
                ] }) }) : /* @__PURE__ */ _e.jsx(P.Paragraph, { variant: "4", color: "tertiary", children: nv })
              ] }),
              /* @__PURE__ */ _e.jsx(
                nr,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ _e.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ _e.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ _e.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ _e.jsx(pe, { size: N, name: "tag", color: "blue.900" }),
              /* @__PURE__ */ _e.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ _e.jsx(P.Paragraph, { variant: "3", children: "Order number" }),
                /* @__PURE__ */ _e.jsx(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: h ? /* @__PURE__ */ _e.jsx(P.Paragraph, { variant: "4", color: "secondary", children: h }) : /* @__PURE__ */ _e.jsx(P.Paragraph, { variant: "4", color: "tertiary", children: nv }) })
              ] })
            ] }),
            h && /* @__PURE__ */ _e.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ _e.jsx(We, { content: "Copy order number", children: /* @__PURE__ */ _e.jsx(
              pe,
              {
                size: N,
                name: s ? "done" : "copy",
                className: yo.clickableIcon,
                onClick: () => l(h)
              }
            ) }) })
          ] }),
          /* @__PURE__ */ _e.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ _e.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ _e.jsx(
                pe,
                {
                  size: N,
                  name: "magnifying-glass-chart",
                  color: "blue.900"
                }
              ),
              /* @__PURE__ */ _e.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ _e.jsx(P.Paragraph, { variant: "3", children: "Ingrid tracking ID" }),
                /* @__PURE__ */ _e.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                  !f && /* @__PURE__ */ _e.jsx(P.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                  f && /* @__PURE__ */ _e.jsx(P.Paragraph, { variant: "4", color: "secondary", children: f })
                ] })
              ] })
            ] }),
            f && /* @__PURE__ */ _e.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ _e.jsx(We, { content: "Copy tracking ID", children: /* @__PURE__ */ _e.jsx(
              pe,
              {
                size: N,
                name: a ? "done" : "copy",
                className: yo.clickableIcon,
                onClick: () => o(f)
              }
            ) }) })
          ] }),
          u && /* @__PURE__ */ _e.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ _e.jsx(pe, { size: 14, name: "user", color: "blue.900" }),
            /* @__PURE__ */ _e.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ _e.jsx(P.Paragraph, { variant: "3", children: "Sender" }),
              /* @__PURE__ */ _e.jsx(P.Paragraph, { variant: "4", children: u })
            ] })
          ] }),
          /* @__PURE__ */ _e.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ _e.jsx(pe, { size: 14, name: "chart-bar", color: "blue.900" }),
            /* @__PURE__ */ _e.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ _e.jsx(P.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ _e.jsx(P.Paragraph, { variant: "4", children: S })
            ] })
          ] }),
          /* @__PURE__ */ _e.jsx(
            b_,
            {
              openByDefault: !0,
              title: "Order items",
              items: d?.items?.map((y) => y),
              currency: d?.currency
            }
          ),
          m && /* @__PURE__ */ _e.jsxs(b, { gap: "200", flexDirection: "column", margin: "0 0 100 0", children: [
            /* @__PURE__ */ _e.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
              /* @__PURE__ */ _e.jsx(P.Heading, { variant: "heading-4", children: "Parcels" }),
              m.length > 0 && /* @__PURE__ */ _e.jsx(An, { variant: "success", size: "small", children: m.length })
            ] }),
            m.length === 0 && /* @__PURE__ */ _e.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No parcels here" }),
            m.map((y, z) => /* @__PURE__ */ _e.jsx(
              tE,
              {
                parcel: y
              },
              `parcel-${z}-${y?.tracking_number}`
            ))
          ] })
        ] })
      ]
    }
  );
}, sE = (e) => {
  const n = [], r = /* @__PURE__ */ new Map();
  for (const i of e) {
    if (!i?.external_id) {
      n.push(i);
      continue;
    }
    const a = r.get(i.external_id);
    if (a)
      a.parcels = [
        ...a.parcels ?? [],
        ...i.parcels ?? []
      ];
    else {
      const o = { ...i };
      r.set(i.external_id, o), n.push(o);
    }
  }
  return n;
}, tv = (e) => {
  let n = 1 / 0;
  for (const r of e?.parcels ?? [])
    for (const i of r?.progress ?? []) {
      if (!i?.time)
        continue;
      const a = new Date(i.time).getTime();
      !Number.isNaN(a) && a < n && (n = a);
    }
  return n === 1 / 0 ? -1 / 0 : n;
}, lE = (e) => [...e].sort(
  (n, r) => tv(r) - tv(n)
), cE = ({
  customerEmail: e
}) => {
  const { useQuery: n } = hn(), [r, i] = le([]), a = !e, { data: o, loading: s, error: l } = n(qI, {
    skip: a,
    variables: {
      email: e,
      locale: "en-GB"
    }
  }), d = !s && r.length > 0, m = l ? m0({
    error: l.graphQLErrors?.[0]
  }) : !1, u = l ? Wb({
    error: l.graphQLErrors?.[0]
  }) : !1;
  return He(() => {
    const f = o?.Ingrid?.DeliveryTracking_GetTrackingOrders;
    f?.orders && i(
      lE(
        sE(f.orders)
      )
    );
  }, [o?.Ingrid?.DeliveryTracking_GetTrackingOrders]), s ? /* @__PURE__ */ _e.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ _e.jsx(un, {}) }) : m || !d && !l ? /* @__PURE__ */ _e.jsx(P.Paragraph, { color: "tertiary", align: "center", children: "No orders to track" }) : u ? /* @__PURE__ */ _e.jsx(P.Paragraph, { color: "tertiary", align: "center", children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator." }) : l ? /* @__PURE__ */ _e.jsx(Fn, { error: l }) : /* @__PURE__ */ _e.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ _e.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ _e.jsx(P.Heading, { variant: "heading-3", children: "Orders" }),
      /* @__PURE__ */ _e.jsx(An, { variant: "success", size: "small", children: r.length })
    ] }),
    /* @__PURE__ */ _e.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ _e.jsx(b, { gap: "200", flexDirection: "column", children: r.map((f, h) => /* @__PURE__ */ _e.jsx(
      oE,
      {
        order: f,
        openByDefault: h === 0
      },
      `${h}-${f?.tos_id}`
    )) }) })
  ] });
}, dE = ({ conversationContext: e }) => {
  const n = e?.customer?.email;
  return /* @__PURE__ */ _e.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: /* @__PURE__ */ _e.jsx(cE, { customerEmail: n })
    }
  );
}, uE = [
  {
    key: "ingridUseStagingEnvironment",
    label: "Use Ingrid staging environment",
    required: !0,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "ingridSiteId",
    label: "Site ID",
    placeholder: "Site ID from Ingrid",
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "ingridApiToken",
    label: "API token",
    placeholder: "API token from Ingrid",
    required: !0,
    secret: !0,
    type: "input"
  }
], rv = [
  {
    key: "ingridUseStagingEnvironment",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "ingridSiteId",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "ingridApiToken",
    type: "string",
    secret: !0,
    defaultValue: ""
  }
], mE = {
  enabled: !1,
  name: "",
  ingridSiteId: "",
  ingridApiToken: "",
  ingridUseStagingEnvironment: !1
}, pE = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = _t({
    mode: "onChange",
    defaultValues: mE
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: g
  } = ji({
    integrationId: e,
    integrationType: "INGRID",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: C,
    error: S,
    isWidgetUnknown: N,
    refetch: w,
    widgetConfiguration: y
  } = wi({
    integrationId: e,
    fieldDefinitions: rv,
    form: s,
    onMisconfigured: g
  }), { renderConditions: z, setRenderConditions: $, renderConditionsForSubmit: I } = Ci({
    integrationId: e,
    widgetConfiguration: y,
    renderConditionsEditor: a
  }), T = (Q) => Ii(Q, {
    fieldDefinitions: rv,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: I
  }), U = s.watch("name");
  return /* @__PURE__ */ _e.jsxs(
    Fi,
    {
      form: s,
      integrationId: e,
      onValidSubmit: T,
      error: S ?? f,
      onRetry: S ? w : void 0,
      isLoading: u || C,
      isWidgetUnknown: N,
      children: [
        h && /* @__PURE__ */ _e.jsx(Ei, { cause: h }),
        /* @__PURE__ */ _e.jsxs(st, { children: [
          /* @__PURE__ */ _e.jsx(be, { children: /* @__PURE__ */ _e.jsx(ln, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ _e.jsx(
            Jn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ _e.jsx(be, { span: 3, children: /* @__PURE__ */ _e.jsx(
            tt,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ _e.jsx(be, { span: 3 }),
          /* @__PURE__ */ _e.jsx(be, { span: 3, children: /* @__PURE__ */ _e.jsx(ln, { label: "Use Ingrid staging environment", children: /* @__PURE__ */ _e.jsx(
            Jn,
            {
              name: "ingridUseStagingEnvironment",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ _e.jsx(be, { span: 3 }),
          /* @__PURE__ */ _e.jsx(be, { span: 3, children: /* @__PURE__ */ _e.jsx(
            tt,
            {
              name: "ingridSiteId",
              label: "Site ID",
              control: s.control,
              rules: { required: "Site ID is required" },
              componentProps: {
                placeholder: "Site ID from Ingrid",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ _e.jsx(be, { span: 3 }),
          /* @__PURE__ */ _e.jsx(be, { span: 3, children: /* @__PURE__ */ _e.jsx(
            Mm,
            {
              name: "ingridApiToken",
              label: "API token",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API token is required" },
              componentProps: {
                placeholder: "API token from Ingrid",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ _e.jsx(be, { span: 3 }),
          a && z !== null && /* @__PURE__ */ _e.jsx(be, { children: a({
            value: z,
            onChange: $,
            configurationKey: y?.id
          }) })
        ] }),
        /* @__PURE__ */ _e.jsx(
          Ti,
          {
            integrationType: "INGRID",
            integrationId: e,
            widgetName: U,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._jiraCode_h30p6_1{padding:2px 4px;font-size:100%;font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-primary);border-radius:4px}._jiraCodeInline_h30p6_8{background-color:var(--dixa-color-neutral-200)}._collapse_m2gjh_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_m2gjh_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_m2gjh_10>div>div>p{white-space:unset!important}._collapseHeader_m2gjh_10>div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_m2gjh_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderLink_m2gjh_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-link);text-decoration:none}._collapseHeaderLink_m2gjh_31:hover{text-decoration:underline}._collapseHeaderStatus_m2gjh_40{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-500);float:right}._collapseHeaderIcon_m2gjh_46{padding-top:.35em;transform:scale(1.4);margin-left:var(--dixa-size-spacer-100)}._collapseHeaderTitle_m2gjh_51{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_m2gjh_59{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentHeadline_m2gjh_62{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary)}._collapseContentButtonSpacer_m2gjh_68{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_m2gjh_71{color:var(--dixa-typography-color-link)}._collapseContentStatusTag_m2gjh_74{max-width:10em}._collapseContentDescription_m2gjh_77{max-height:75vh;overflow-y:auto}._result_axxxc_48{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_axxxc_48:hover,._result_axxxc_48:focus{background-color:var(--dixa-color-neutral-100)}._resultName_axxxc_68{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultNameIcon_axxxc_76{height:var(--dixa-typography-line-height-200);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._resultDescription_axxxc_81{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_axxxc_93{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_axxxc_102{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipContent_axxxc_108{display:flex;flex-direction:column;width:100%;max-height:60vh;max-height:60dvh}._tooltipName_axxxc_115{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_axxxc_120{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipDescription_axxxc_125{padding-top:.5em;width:100%;text-align:left;color:var(--dixa-typography-color-secondary);flex-grow:1;overflow-y:auto}._tooltipSummary_axxxc_133{padding-top:.5em;font-weight:var(--dixa-typography-weight-semibold)}._tooltipTag_axxxc_137{width:fit-content;max-width:15em}._itemButton_1hl53_1{border:none;padding:0}._result_1hl53_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_1hl53_6:hover,._result_1hl53_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_1hl53_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_1hl53_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultCheckIcon_1hl53_38{height:var(--dixa-size-spacer-400)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_1bylq_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_1bylq_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_1bylq_14{text-align:center}._inputSeparator_1bylq_18{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_1bylq_23{color:var(--dixa-typography-color-link)}._noIssuesFound_1bylq_27{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var pu = { exports: {} }, Ca = {}, iv;
function fE() {
  if (iv) return Ca;
  iv = 1;
  var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return Ca.Fragment = r, Ca.jsx = s, Ca.jsxs = s, Ca;
}
var zo = {}, av;
function hE() {
  return av || (av = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        z("error", t, p);
      }
    }
    function z(t, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, A = v.getStackAddendum();
        A !== "" && (c += "%s", p = p.concat([A]));
        var L = p.map(function(F) {
          return String(F);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, I = !1, T = !1, U = !1, Q = !1, J;
    J = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === u || U || t === g || $ || I || T || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function X(t, c, p) {
      var v = t.displayName;
      if (v)
        return v;
      var A = c.displayName || c.name || "";
      return A !== "" ? p + "(" + A + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return X(t, t.render, "ForwardRef");
          case f:
            var v = t.displayName || null;
            return v !== null ? v : O(t.type) || "Memo";
          case h: {
            var A = t, L = A._payload, F = A._init;
            try {
              return O(F(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, ue, ce, fe, W, xe, Ie;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ve = console.log, ue = console.info, ce = console.warn, fe = console.error, W = console.group, xe = console.groupCollapsed, Ie = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: ue
            }),
            warn: q({}, t, {
              value: ce
            }),
            error: q({}, t, {
              value: fe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: xe
            }),
            groupEnd: q({}, t, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Me;
    function $e(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (A) {
            var v = A.stack.trim().match(/\n( *(at )?)/);
            Me = v && v[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var ze = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(t, c) {
      if (!t || ze)
        return "";
      {
        var p = Re.get(t);
        if (p !== void 0)
          return p;
      }
      var v;
      ze = !0;
      var A = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, qe();
      try {
        if (c) {
          var F = function() {
            throw Error();
          };
          if (Object.defineProperty(F.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(F, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(t, [], F);
          } else {
            try {
              F.call();
            } catch (ne) {
              v = ne;
            }
            t.call(F.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), G = j.length - 1, _ = te.length - 1; G >= 1 && _ >= 0 && j[G] !== te[_]; )
            _--;
          for (; G >= 1 && _ >= 0; G--, _--)
            if (j[G] !== te[_]) {
              if (G !== 1 || _ !== 1)
                do
                  if (G--, _--, _ < 0 || j[G] !== te[_]) {
                    var Z = `
` + j[G].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (G >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Oe.current = L, Be(), Error.prepareStackTrace = A;
      }
      var de = t ? t.displayName || t.name : "", Se = de ? $e(de) : "";
      return typeof t == "function" && Re.set(t, Se), Se;
    }
    function Ge(t, c, p) {
      return Ee(t, !1);
    }
    function Qe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function he(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Qe(t));
      if (typeof t == "string")
        return $e(t);
      switch (t) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ge(t.render);
          case f:
            return he(t.type, c, p);
          case h: {
            var v = t, A = v._payload, L = v._init;
            try {
              return he(L(A), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, De = {}, Le = w.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = he(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(t, c, p, v, A) {
      {
        var L = Function.call.bind(ge);
        for (var F in t)
          if (L(t, F)) {
            var j = void 0;
            try {
              if (typeof t[F] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + F + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[F] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[F](c, F, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (G) {
              j = G;
            }
            j && !(j instanceof Error) && (Ae(A), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, F, typeof j), Ae(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Ae(A), y("Failed %s type: %s", p, j.message), Ae(null));
          }
      }
    }
    var E = Array.isArray;
    function x(t) {
      return E(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var V = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, me, Ne;
    function nn(t) {
      if (ge.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function fn(t) {
      if (ge.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && V.current;
    }
    function cn(t, c) {
      {
        var p = function() {
          me || (me = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(t, c, p, v, A, L, F) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: F,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: A
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, v, A) {
      {
        var L, F = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), fn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ge.call(c, L) && !ie.hasOwnProperty(L) && (F[L] = c[L]);
        if (t && t.defaultProps) {
          var G = t.defaultProps;
          for (L in G)
            F[L] === void 0 && (F[L] = G[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && cn(F, _), te && pn(F, _);
        }
        return dn(t, j, te, A, v, V.current, F);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = he(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var t = O(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        t && t._owner && t._owner !== en.current && (v = " It was passed a child from " + O(t._owner.type) + "."), Pe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Pe(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var v = t[p];
            sn(v) && gn(v, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var A = N(t);
          if (typeof A == "function" && A !== t.entries)
            for (var L = A.call(t), F; !(F = L.next()).done; )
              sn(F.value) && gn(F.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          mn(p, t.props, "prop", v, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var A = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", A || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Pe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Pe(null);
            break;
          }
        }
        t.ref !== null && (Pe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Pe(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, v, A, L) {
      {
        var F = ae(t);
        if (!F) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var G;
          t === null ? G = "null" : x(t) ? G = "array" : t !== void 0 && t.$$typeof === n ? (G = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : G = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", G, j);
        }
        var _ = xn(t, c, p, A, L);
        if (_ == null)
          return _;
        if (F) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var de = 0; de < Z.length; de++)
                  Cn(Z[de], t);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, t);
        }
        if (ge.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, Se, $n, Se), Sn[Se + Ke] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    zo.Fragment = i, zo.jsx = Rn, zo.jsxs = Mn;
  })()), zo;
}
var ov;
function yE() {
  return ov || (ov = 1, process.env.NODE_ENV === "production" ? pu.exports = fE() : pu.exports = hE()), pu.exports;
}
var se = yE();
const wp = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => wp(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, gE = "_jiraCode_h30p6_1", vE = "_jiraCodeInline_h30p6_8", fu = {
  jiraCode: gE,
  jiraCodeInline: vE
}, x_ = {
  default: (e, n) => n().every((r) => typeof r == "string") ? n().join(" ") : /* @__PURE__ */ se.jsx(se.Fragment, { children: n() }),
  nodes: {
    doc: (e, n) => /* @__PURE__ */ se.jsx("div", { children: n() }),
    paragraph: (e, n) => /* @__PURE__ */ se.jsx("p", { children: n() }),
    text: (e) => e.text || "",
    hardBreak: () => /* @__PURE__ */ se.jsx("br", {}),
    bulletList: (e, n) => /* @__PURE__ */ se.jsx("ul", { children: n() }),
    orderedList: (e, n) => /* @__PURE__ */ se.jsx("ol", { children: n() }),
    listItem: (e, n) => /* @__PURE__ */ se.jsx("li", { children: n() }),
    codeBlock: (e, n) => /* @__PURE__ */ se.jsx("pre", { children: /* @__PURE__ */ se.jsx("code", { className: fu.jiraCode, children: n() }) }),
    heading: (e, n) => {
      switch (e.attrs?.level) {
        // Not using headlines above level 3
        case 1:
          return /* @__PURE__ */ se.jsx("h3", { children: n() });
        case 2:
          return /* @__PURE__ */ se.jsx("h4", { children: n() });
        case 3:
          return /* @__PURE__ */ se.jsx("h5", { children: n() });
        case 4:
          return /* @__PURE__ */ se.jsx("h6", { children: n() });
        case 5:
          return /* @__PURE__ */ se.jsx("b", { children: n() });
        case 6:
          return /* @__PURE__ */ se.jsx("b", { children: n() });
        default:
          return /* @__PURE__ */ se.jsx("h4", { children: n() });
      }
    }
  },
  marks: {
    text: {
      em: (e, n) => /* @__PURE__ */ se.jsx("em", { children: n() }),
      strong: (e, n) => /* @__PURE__ */ se.jsx("b", { children: n() }),
      underline: (e, n) => /* @__PURE__ */ se.jsx("u", { children: n() }),
      link: (e, n) => /* @__PURE__ */ se.jsx("a", { href: e.attrs?.href || "", target: "_blank", rel: "noreferrer", children: n() }),
      code: (e, n) => /* @__PURE__ */ se.jsx("code", { className: it(fu.jiraCode, fu.jiraCodeInline), children: n() })
      // Removing color support for now.
      // textColor: (mark, next) => (
      // 	<span style={{ color: mark.attrs?.['color'] }}>{next()}</span>
      // ),
    }
  }
}, $s = ({
  iconUrl: e,
  className: n,
  width: r
}) => {
  const [i, a] = le(!1);
  return !e || i ? /* @__PURE__ */ se.jsx(pe, { size: r, name: "question", className: n }) : /* @__PURE__ */ se.jsx(
    "img",
    {
      src: e,
      width: r,
      className: n,
      onError: ({ currentTarget: o }) => {
        o.onerror = null, a(!0);
      }
    }
  );
}, kE = "_collapse_m2gjh_1", bE = "_collapseHeader_m2gjh_10", xE = "_collapseHeaderLink_m2gjh_31", _E = "_collapseHeaderStatus_m2gjh_40", SE = "_collapseHeaderTitle_m2gjh_51", NE = "_collapseContent_m2gjh_59", jE = "_collapseContentHeadline_m2gjh_62", wE = "_collapseContentButtonSpacer_m2gjh_68", CE = "_collapseContentButtonLink_m2gjh_71", FE = "_collapseContentStatusTag_m2gjh_74", IE = "_collapseContentDescription_m2gjh_77", gr = {
  collapse: kE,
  collapseHeader: bE,
  collapseHeaderLink: xE,
  collapseHeaderStatus: _E,
  collapseHeaderTitle: SE,
  collapseContent: NE,
  collapseContentHeadline: jE,
  collapseContentButtonSpacer: wE,
  collapseContentButtonLink: CE,
  collapseContentStatusTag: FE,
  collapseContentDescription: IE
}, __ = ({
  jiraInstanceUrl: e,
  avatarId: n,
  iconUrl: r
}) => n ? `${e}/rest/api/3/universal_avatar/view/type/issuetype/avatar/${n}?size=medium` : r, EE = ({
  issues: e,
  jiraInstanceUrl: n,
  unlinkIssue: r
}) => {
  const i = e.reduce(
    (d, m) => m?.id ? { ...d, [m.id]: !1 } : d,
    {}
  ), [a, o] = le(i), { track: s } = _n(), l = (d, m) => {
    o({ ...a, [d]: m });
  };
  return /* @__PURE__ */ se.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((d) => {
    const { summary: m, description: u, status: f, issuetype: h } = d?.fields || {}, g = __({
      avatarId: h?.avatarId,
      iconUrl: h?.iconUrl,
      jiraInstanceUrl: n
    }), C = !!(d?.id && a[d.id]);
    return /* @__PURE__ */ se.jsxs(
      mr,
      {
        onToggle: () => d?.id && l(d.id, !a[d.id]),
        isOpen: C,
        className: gr.collapse,
        children: [
          /* @__PURE__ */ se.jsx(mr.Header, { className: gr.collapseHeader, children: /* @__PURE__ */ se.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ se.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                  /* @__PURE__ */ se.jsxs(b, { alignItems: "center", gap: "200", children: [
                    /* @__PURE__ */ se.jsx($s, { width: 16, iconUrl: g }),
                    /* @__PURE__ */ se.jsx(
                      "a",
                      {
                        className: gr.collapseHeaderLink,
                        href: `${n}/browse/${d?.key}`,
                        target: "_blank",
                        rel: "noreferrer",
                        onClick: (S) => {
                          S.stopPropagation(), d?.key && s("jira:view:issue:clicked", {
                            jiraIssueKey: d.key,
                            jiraInstanceUrl: n
                          });
                        },
                        children: /* @__PURE__ */ se.jsxs(b, { alignItems: "center", gap: "200", children: [
                          d?.key,
                          /* @__PURE__ */ se.jsx(pe, { name: "external-link", size: 16 })
                        ] })
                      },
                      d?.key
                    )
                  ] }),
                  /* @__PURE__ */ se.jsx("span", { className: gr.collapseHeaderStatus, children: f?.name && /* @__PURE__ */ se.jsx(Pn, { className: gr.collapseContentStatusTag, children: f.name }) })
                ] }),
                /* @__PURE__ */ se.jsx("div", { className: gr.collapseHeaderTitle, children: m })
              ]
            }
          ) }),
          /* @__PURE__ */ se.jsx(mr.Content, { className: gr.collapseContent, children: /* @__PURE__ */ se.jsxs(b, { flexDirection: "column", gap: "250", margin: "0 0 200 0", children: [
            /* @__PURE__ */ se.jsx("div", { className: gr.collapseContentHeadline, children: "Description" }),
            /* @__PURE__ */ se.jsx(et, { className: gr.collapseContentDescription, children: u ? wp(u, x_) : "" }),
            /* @__PURE__ */ se.jsx(
              Gn,
              {
                icon: "link-slash",
                variant: "secondary",
                className: gr.collapseContentButtonSpacer,
                onClick: () => d?.key && r(d.key),
                children: "Unlink issue from Jira"
              }
            ),
            /* @__PURE__ */ se.jsx(
              Et,
              {
                slotEnd: /* @__PURE__ */ se.jsx(pe, { name: "external-link" }),
                variant: "tertiary",
                className: gr.collapseContentButtonLink,
                navigate: () => {
                  d?.key && (s("jira:view:issue:clicked", {
                    jiraIssueKey: d.key,
                    jiraInstanceUrl: n
                  }), window.open(
                    `${n}/browse/${d.key}`,
                    "_blank"
                  )?.focus());
                },
                children: "View issue in Jira"
              }
            )
          ] }) })
        ]
      },
      d?.id
    );
  }) : /* @__PURE__ */ se.jsx(se.Fragment, {}) });
}, TE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "title" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "url" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createOrUpdateRemoteIssueLink" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "application" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "name" }, value: { kind: "StringValue", value: "Dixa Conversations", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "StringValue", value: "com.dixa.conversations", block: !1 } }] } }, { kind: "ObjectField", name: { kind: "Name", value: "relationship" }, value: { kind: "StringValue", value: "dixa-backlink", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "object" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "title" } } }, { kind: "ObjectField", name: { kind: "Name", value: "url" }, value: { kind: "Variable", name: { kind: "Name", value: "url" } } }, { kind: "ObjectField", name: { kind: "Name", value: "icon" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "url16x16" }, value: { kind: "StringValue", value: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "StringValue", value: "Dixa", block: !1 } }] } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }] } }] } }] } }] }, $E = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removeBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "deleteRemoteIssueLinkByGlobalId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }] }] } }] } }] }, DE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Jira_IssueUpdateDetails_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_CreatedIssue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_ErrorCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorMessages" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "errors" } }] } }] } }] } }] } }] }, RE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAllProjects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, OE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCreateIssueMeta" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectKey" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCreateIssueMeta" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "projectKeys" }, value: { kind: "ListValue", values: [{ kind: "Variable", name: { kind: "Name", value: "projectKey" } }] } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "StringValue", value: "projects.issuetypes.fields", block: !1 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "issuetypes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "iconUrl" } }, { kind: "Field", name: { kind: "Name", value: "entityId" } }, { kind: "Field", name: { kind: "Name", value: "hierarchyLevel" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "scope" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalProperties" } }] } }, { kind: "Field", name: { kind: "Name", value: "expand" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "required" } }, { kind: "Field", name: { kind: "Name", value: "hasDefaultValue" } }, { kind: "Field", name: { kind: "Name", value: "schema" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "system" } }, { kind: "Field", name: { kind: "Name", value: "items" } }, { kind: "Field", name: { kind: "Name", value: "custom" } }, { kind: "Field", name: { kind: "Name", value: "customId" } }] } }, { kind: "Field", name: { kind: "Name", value: "allowedValues" } }, { kind: "Field", name: { kind: "Name", value: "defaultValue" } }, { kind: "Field", name: { kind: "Name", value: "operations" } }, { kind: "Field", name: { kind: "Name", value: "autoCompleteUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, AE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "jql" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "jql" }, value: { kind: "Variable", name: { kind: "Name", value: "jql" } } }, { kind: "Argument", name: { kind: "Name", value: "maxResults" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "fields" }, value: { kind: "ListValue", values: [{ kind: "StringValue", value: "summary", block: !1 }, { kind: "StringValue", value: "description", block: !1 }, { kind: "StringValue", value: "status", block: !1 }, { kind: "StringValue", value: "updated", block: !1 }, { kind: "StringValue", value: "issuetype", block: !1 }, { kind: "StringValue", value: "project", block: !1 }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "fields" } }] } }] } }] } }] } }] }, PE = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "findUsers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findUsers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountId" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "self" } }, { kind: "Field", name: { kind: "Name", value: "active" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, LE = {
  '\n  mutation createBacklink(\n    $issueKey: String!\n    $title: String!\n    $url: String!\n    $globalId: String!\n  ) {\n    Jira {\n      createOrUpdateRemoteIssueLink(\n        issueIdOrKey: $issueKey\n        input: {\n          globalId: $globalId\n          application: {\n            name: "Dixa Conversations"\n            type: "com.dixa.conversations"\n          }\n          relationship: "dixa-backlink"\n          object: {\n            title: $title\n            url: $url\n            icon: {\n              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"\n              title: "Dixa"\n            }\n          }\n        }\n      ) {\n        __typename\n      }\n    }\n  }\n': TE,
  "\n  mutation removeBacklink($issueKey: String!, $globalId: String!) {\n    Jira {\n      deleteRemoteIssueLinkByGlobalId(\n        issueIdOrKey: $issueKey\n        globalId: $globalId\n      )\n    }\n  }\n": $E,
  "\n  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {\n    Jira {\n      createIssue(input: $input) {\n        ... on Jira_CreatedIssue {\n          id\n          key\n        }\n        ... on Jira_ErrorCollection {\n          errorMessages\n          status\n          errors\n        }\n      }\n    }\n  }\n": DE,
  "\n  query jira {\n    Jira {\n      getAllProjects {\n        id\n        key\n        name\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": RE,
  '\n  query getCreateIssueMeta($projectKey: String) {\n    Jira {\n      getCreateIssueMeta(\n        projectKeys: [$projectKey]\n        expand: "projects.issuetypes.fields"\n      ) {\n        projects {\n          id\n          key\n          name\n          issuetypes {\n            id\n            name\n            iconUrl\n            entityId\n            hierarchyLevel\n            subtask\n            scope {\n              type\n              project {\n                id\n                key\n                name\n              }\n              additionalProperties\n            }\n            expand\n            subtask\n            description\n            fields {\n              additionalProperties {\n                key\n                value {\n                  key\n                  name\n                  required\n                  hasDefaultValue\n                  schema {\n                    type\n                    system\n                    items\n                    custom\n                    customId\n                  }\n                  allowedValues\n                  defaultValue\n                  operations\n                  autoCompleteUrl\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n': OE,
  '\n  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {\n    Jira {\n      searchAndReconsileIssuesUsingJql(\n        jql: $jql\n        maxResults: $maxResults\n        fields: [\n          "summary"\n          "description"\n          "status"\n          "updated"\n          "issuetype"\n          "project"\n        ]\n      ) {\n        issues {\n          id\n          key\n          fields\n        }\n      }\n    }\n  }\n': AE,
  "\n  query findUsers($query: String) {\n    Jira {\n      findUsers(query: $query) {\n        accountId\n        displayName\n        self\n        active\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": PE
};
function Oi(e) {
  return LE[e] ?? {};
}
const S_ = Oi(
  /* GraphQL */
  `
  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {
    Jira {
      searchAndReconsileIssuesUsingJql(
        jql: $jql
        maxResults: $maxResults
        fields: [
          "summary"
          "description"
          "status"
          "updated"
          "issuetype"
          "project"
        ]
      ) {
        issues {
          id
          key
          fields
        }
      }
    }
  }
`
), VE = Oi(
  /* GraphQL */
  `
  mutation createBacklink(
    $issueKey: String!
    $title: String!
    $url: String!
    $globalId: String!
  ) {
    Jira {
      createOrUpdateRemoteIssueLink(
        issueIdOrKey: $issueKey
        input: {
          globalId: $globalId
          application: {
            name: "Dixa Conversations"
            type: "com.dixa.conversations"
          }
          relationship: "dixa-backlink"
          object: {
            title: $title
            url: $url
            icon: {
              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"
              title: "Dixa"
            }
          }
        }
      ) {
        __typename
      }
    }
  }
`
), zE = Oi(
  /* GraphQL */
  `
  mutation removeBacklink($issueKey: String!, $globalId: String!) {
    Jira {
      deleteRemoteIssueLinkByGlobalId(
        issueIdOrKey: $issueKey
        globalId: $globalId
      )
    }
  }
`
), UE = Oi(
  /* GraphQL */
  `
  query jira {
    Jira {
      getAllProjects {
        id
        key
        name
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), ME = Oi(
  /* GraphQL */
  `
  query getCreateIssueMeta($projectKey: String) {
    Jira {
      getCreateIssueMeta(
        projectKeys: [$projectKey]
        expand: "projects.issuetypes.fields"
      ) {
        projects {
          id
          key
          name
          issuetypes {
            id
            name
            iconUrl
            entityId
            hierarchyLevel
            subtask
            scope {
              type
              project {
                id
                key
                name
              }
              additionalProperties
            }
            expand
            subtask
            description
            fields {
              additionalProperties {
                key
                value {
                  key
                  name
                  required
                  hasDefaultValue
                  schema {
                    type
                    system
                    items
                    custom
                    customId
                  }
                  allowedValues
                  defaultValue
                  operations
                  autoCompleteUrl
                }
              }
            }
          }
        }
      }
    }
  }
`
), BE = Oi(
  /* GraphQL */
  `
  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {
    Jira {
      createIssue(input: $input) {
        ... on Jira_CreatedIssue {
          id
          key
        }
        ... on Jira_ErrorCollection {
          errorMessages
          status
          errors
        }
      }
    }
  }
`
), qE = Oi(
  /* GraphQL */
  `
  query findUsers($query: String) {
    Jira {
      findUsers(query: $query) {
        accountId
        displayName
        self
        active
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), Cp = new RegExp("[a-zA-Z0-9_]{2,}-[0-9]+"), HE = new RegExp(`^${Cp.source}$`), WE = new RegExp(`/${Cp.source}$`), sv = new RegExp(
  `.+?[&?]selectedIssue=(${Cp.source})[&?]?.*`
);
function N_(e, n) {
  const r = { jira: { issues: [] } }, [i, a] = le([]), [o, s] = le([]), [l, d] = le(), { track: m } = _n(), { showNotification: u, showModal: f, useLazyQuery: h, useMutation: g } = hn(), {
    loading: C,
    data: S,
    error: N,
    store: w
  } = Um(e ?? null), [
    y,
    { loading: z, error: $, data: I }
  ] = h(S_, {
    notifyOnNetworkStatusChange: !0
  });
  He(() => {
    const ce = I?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    ce?.length && (s(ce), a(ce.map((fe) => fe?.key).filter(Boolean)));
  }, [I]), He(
    () => d(N || $ || void 0),
    [N, $]
  ), He(
    () => {
      C || B();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [S?.jira?.issues, C]
  );
  const T = async (ce, fe) => {
    await w(ce).then(() => {
      u({
        icon: "check-circle-filled",
        severity: "success",
        title: fe.success.title,
        text: fe.success.text
      });
    }).catch((W) => {
      u({
        title: fe.error.title,
        text: `${fe.error.text} ${W.message && " (" + W.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, [U] = g(VE, {
    onError: (ce) => {
      u({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to create a link back from the issue to the conversation. Please create it manually in Jira.
				${ce.message && " (" + ce.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), Q = (ce, fe) => {
    const W = window.location.href, xe = fe ? W.replace(
      e?.toString() ?? "",
      fe?.toString()
    ) : W, Ie = fe ? `# ${fe}` : `# ${e}`;
    U({
      variables: {
        issueKey: ce,
        title: Ie,
        url: xe,
        globalId: `system=${xe}`
      }
    });
  }, [J] = g(zE, {
    onError: (ce) => {
      u({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to remove a link back from the issue to the conversation. Please remove it manually from Jira.
					${ce.message && " (" + ce.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), ae = (ce) => {
    const fe = window.location.href;
    J({
      variables: {
        issueKey: ce,
        globalId: `system=${fe}`
      }
    });
  }, X = (ce) => ({
    jiraInstanceUrl: n,
    jiraIssueKey: ce
  }), B = () => {
    S && S.jira?.issues?.length > 0 ? y({
      variables: {
        jql: `key in (${S?.jira?.issues.join(",")})`,
        maxResults: 15
      }
    }) : s([]);
  }, O = async (ce, fe) => {
    m("jira:issue:link:clicked", X(ce));
    const W = S?.jira?.issues ? S : r;
    W.jira.issues = Array.from(
      new Set(W.jira.issues).add(ce)
    ), await w(W, fe?.toString()).then(() => Q(ce, fe)).catch((xe) => {
      u({
        title: "Linking failed",
        text: `Linking ${ce} failed. Please try again. ${xe.message && " (" + xe.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, q = (ce) => {
    m("jira:issue:link:clicked", X(ce));
    const fe = S?.jira?.issues ? S : r;
    fe.jira.issues = Array.from(
      new Set(fe.jira.issues).add(ce)
    ), T(fe, {
      success: {
        title: "Jira issue linked",
        text: `You linked the Jira issue ${ce} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${ce} failed. Please try again.`
      }
    }).then(() => Q(ce));
  }, ee = (ce) => {
    m("jira:issue:unlink:clicked", X(ce)), f({
      headline: `Unlink issue ${ce}?`,
      text: `You are about to unlink the issue ${ce}. Do you want to proceed?`,
      confirmLabel: "Unlink Jira issue",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink:confirmed", X(ce));
        const fe = {
          ...S,
          jira: {
            ...S?.jira,
            issues: S?.jira?.issues.filter((W) => W !== ce) || []
          }
        };
        T(fe, {
          success: {
            title: "Jira issue unlinked",
            text: `You unlinked the Jira issue ${ce}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${ce} failed.`
          }
        }).then(() => ae(ce));
      },
      onCancel: () => m("jira:issue:unlink:cancelled", X(ce))
    });
  }, ve = () => {
    m("jira:issue:unlink-all:clicked", { jiraInstanceUrl: n }), f({
      headline: "Unlink all Jira issues?",
      text: "You are about to unlink the all Jira issues from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink-all:confirmed", { jiraInstanceUrl: n }), o?.forEach((ce) => ce?.key && ae(ce.key)), T(r, {
          success: {
            title: "Unlinking successful",
            text: "All Jira issues were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues failed."
          }
        });
      },
      onCancel: () => m("jira:issue:unlink-all:cancelled", { jiraInstanceUrl: n })
    });
  }, ue = S?.jira?.issues?.filter(
    (ce) => !i?.includes(ce)
  ) || [];
  return {
    linkIssue: q,
    linkIssueQuietly: O,
    unlinkIssue: ee,
    loadIssues: B,
    removeDanglingIssueLinks: () => {
      m("jira:issue:unlink-all-dangling:clicked", {
        jiraInstanceUrl: n
      });
      const ce = {
        ...S,
        jira: {
          ...S?.jira,
          issues: S?.jira?.issues.filter(
            (fe) => !ue.includes(fe)
          ) || []
        }
      };
      w(ce);
    },
    unlinkAllIssues: ve,
    maybeExtractIssueKey: (ce) => {
      const fe = ce.replace(/\s/g, "");
      if (HE.test(fe))
        return fe;
      if (sv.test(ce))
        return ce.match(sv)?.[1];
      if (ce.startsWith(n) && WE.test(ce))
        return ce.substring(ce.lastIndexOf("/") + 1);
    },
    isLoadingIssueLinks: C,
    danglingIssueLinks: ue,
    isLoadingIssues: z,
    issues: o,
    error: l
  };
}
function GE(e = !1, n) {
  const [r, i] = le(e);
  return He(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copyToClipboard: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const KE = "_result_axxxc_48", YE = "_resultName_axxxc_68", QE = "_resultNameIcon_axxxc_76", JE = "_resultDescription_axxxc_81", XE = "_resultLinkIcon_axxxc_93", ZE = "_tooltip_axxxc_102", eT = "_tooltipContent_axxxc_108", nT = "_tooltipName_axxxc_115", tT = "_tooltipNameIcon_axxxc_120", rT = "_tooltipDescription_axxxc_125", iT = "_tooltipSummary_axxxc_133", aT = "_tooltipTag_axxxc_137", cr = {
  result: KE,
  resultName: YE,
  resultNameIcon: QE,
  resultDescription: JE,
  resultLinkIcon: XE,
  tooltip: ZE,
  tooltipContent: eT,
  tooltipName: nT,
  tooltipNameIcon: tT,
  tooltipDescription: rT,
  tooltipSummary: iT,
  tooltipTag: aT
}, oT = ({
  item: e,
  jiraInstanceUrl: n,
  onSelect: r,
  disableTooltip: i = !1,
  ...a
}) => {
  const { issuetype: o, name: s, status: l, text: d, description: m } = e, [u, f] = le(!1), h = __({
    avatarId: o?.avatarId,
    iconUrl: o?.iconUrl,
    jiraInstanceUrl: n
  });
  return /* @__PURE__ */ se.jsx(
    We,
    {
      disabled: i,
      className: cr.tooltip,
      content: /* @__PURE__ */ se.jsxs("div", { className: cr.tooltipContent, children: [
        /* @__PURE__ */ se.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            children: [
              /* @__PURE__ */ se.jsxs("span", { className: cr.tooltipName, children: [
                /* @__PURE__ */ se.jsx(
                  $s,
                  {
                    width: 16,
                    iconUrl: h,
                    className: cr.tooltipNameIcon
                  }
                ),
                " ",
                s
              ] }),
              /* @__PURE__ */ se.jsx(Pn, { className: cr.tooltipTag, children: l.name })
            ]
          }
        ),
        m && /* @__PURE__ */ se.jsx("div", { className: cr.tooltipSummary, children: m }),
        d && /* @__PURE__ */ se.jsx("div", { className: cr.tooltipDescription, children: d })
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ se.jsxs(
        "button",
        {
          ...a,
          className: cr.result,
          type: "button",
          onClick: () => {
            r(e);
          },
          onMouseEnter: () => f(!0),
          onMouseLeave: () => f(!1),
          children: [
            /* @__PURE__ */ se.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                style: {
                  width: u ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ se.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ se.jsxs("span", { className: cr.resultName, children: [
                    /* @__PURE__ */ se.jsx(
                      $s,
                      {
                        width: 16,
                        iconUrl: h,
                        className: cr.resultNameIcon
                      }
                    ),
                    " ",
                    s
                  ] }) }),
                  m && /* @__PURE__ */ se.jsx("div", { className: cr.resultDescription, children: m })
                ]
              }
            ),
            u && /* @__PURE__ */ se.jsx(
              pe,
              {
                className: cr.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, sT = ({
  className: e,
  searched: n,
  jiraInstanceUrl: r
}) => /* @__PURE__ */ se.jsx(
  Et,
  {
    slotEnd: /* @__PURE__ */ se.jsx(pe, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `${r}/secure/QuickSearch.jspa?searchString=${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching issues in Jira"
  }
), lT = ({
  onSelectIssue: e,
  jiraInstanceUrl: n,
  filterByProjectKey: r,
  disableTooltip: i
}) => {
  const { useLazyQuery: a } = hn(), [o, s] = le([]), [l, d] = le(""), [m, { loading: u, error: f, data: h, networkStatus: g }] = a(S_, {
    notifyOnNetworkStatusChange: !0
  }), { maybeExtractIssueKey: C } = N_(null, n);
  $i(
    () => {
      !u && l && g === er.ready ? m({
        variables: {
          jql: l,
          maxResults: 25
        }
      }) : s([]);
    },
    500,
    [l]
  ), He(() => {
    const $ = h?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    s(
      $.map((I) => ({
        id: I?.key ?? "",
        name: I?.key ?? "",
        description: I?.fields.summary,
        status: I?.fields.status,
        issuetype: I?.fields.issuetype,
        text: I?.fields.description ? wp(I?.fields.description, x_) : /* @__PURE__ */ se.jsx(se.Fragment, {})
      }))
    );
  }, [h]);
  const S = ($) => {
    e($.id), d("");
  }, N = ($) => {
    const I = $.trim(), T = C(I);
    if (T) {
      const U = T.replaceAll("[-_|]", "\\\\$0");
      d(`key = '${U}'`);
    } else I !== "" && d(
      `text ~ '${I}'${r ? " and project = " + r : ""}`
    );
  }, w = () => {
    d("");
  }, y = ($) => /* @__PURE__ */ se.jsx(sT, { ...$, jiraInstanceUrl: n }), z = ($) => /* @__PURE__ */ se.jsx(
    oT,
    {
      ...$,
      jiraInstanceUrl: n,
      disableTooltip: i
    }
  );
  return !u && f ? /* @__PURE__ */ se.jsx(Fn, { error: f }) : /* @__PURE__ */ se.jsx(
    wr,
    {
      items: o,
      loading: u,
      onSearch: N,
      onSelect: S,
      onClear: w,
      emptyMessage: l ? u ? "" : "No Jira Issues found" : "Enter Jira issue key, link or search terms",
      suggestionComponent: y,
      itemComponent: z,
      placeholder: "Search and link existing issue",
      searchable: !0,
      clearable: !0
    }
  );
}, cT = ({
  field: e,
  value: n,
  onChange: r
}) => {
  const [i, a] = le(n ? [n] : []), o = (s, l) => {
    a(
      l ? [...i, s] : i.filter(({ id: d }) => d !== s.id)
    );
  };
  return He(() => {
    r(i);
  }, [i]), /* @__PURE__ */ se.jsx(
    wr,
    {
      multiple: !0,
      onChange: o,
      selectedItems: i,
      items: e?.allowedValues?.map(
        ({ id: s, name: l, value: d }) => ({
          id: s,
          name: l || d
        })
      )
    }
  );
}, dT = "_itemButton_1hl53_1", uT = "_result_1hl53_6", mT = "_resultIcon_1hl53_26", pT = "_resultName_1hl53_30", fT = "_resultCheckIcon_1hl53_38", Fa = {
  itemButton: dT,
  result: uT,
  resultIcon: mT,
  resultName: pT,
  resultCheckIcon: fT
}, fm = ({
  item: e,
  checked: n = !1,
  onSelectItem: r,
  jiraInstanceUrl: i
}) => {
  const a = (s) => {
    const l = s.indexOf("/rest/api/");
    return l >= 0 ? `${i}${s?.substring(l)}` : s;
  };
  let o = e?.iconUrl || e?.avatarUrls?._24x24 || null;
  return o && (o = o?.startsWith("https://api.atlassian.com/ex/") ? a(o) : o), /* @__PURE__ */ se.jsx(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      width: "100%",
      "data-testid": "jira-select-item-component",
      children: /* @__PURE__ */ se.jsx(
        "button",
        {
          onClick: () => {
            r(e);
          },
          className: Fa.itemButton,
          children: /* @__PURE__ */ se.jsxs(b, { className: Fa.result, flexDirection: "row", width: "100%", children: [
            /* @__PURE__ */ se.jsx(
              $s,
              {
                width: 36,
                iconUrl: o || "",
                className: Fa.resultIcon
              }
            ),
            /* @__PURE__ */ se.jsx(et, { className: Fa.resultName, children: e.name }),
            n && /* @__PURE__ */ se.jsx(et, { className: Fa.resultCheckIcon, children: /* @__PURE__ */ se.jsx(pe, { name: "done" }) })
          ] })
        }
      )
    }
  );
}, hT = ({
  selectedItems: e,
  agentEmail: n,
  onSelect: r,
  jiraInstanceUrl: i
}) => {
  const { useLazyQuery: a } = hn(), [o, s] = le([]), [l, d] = le(), m = 2, [u, { loading: f, error: h, data: g, networkStatus: C }] = a(qE, {
    notifyOnNetworkStatusChange: !0
  });
  return $i(
    () => {
      !f && l && l.length >= m && C === er.ready ? u({
        variables: {
          query: l,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), He(() => {
    n && u({
      variables: {
        query: n,
        maxResults: 1
      }
    }).then((S) => {
      if (S?.data?.Jira.findUsers?.length === 1) {
        const N = S?.data?.Jira?.findUsers[0];
        r(N.accountId), s([
          {
            id: N.accountId,
            name: N.displayName
          }
        ]);
      }
    });
  }, []), He(() => {
    const S = g?.Jira?.findUsers || [];
    s(
      S.filter(({ active: N }) => N).map(({ accountId: N, displayName: w, avatarUrls: y, active: z }) => ({
        id: N,
        name: w,
        avatarUrls: y,
        active: z
      }))
    );
  }, [g]), !f && h ? /* @__PURE__ */ se.jsx(Fn, { error: h }) : /* @__PURE__ */ se.jsx(
    wr,
    {
      clearable: !0,
      searchable: !0,
      items: o,
      loading: f,
      onSearch: (S) => d(S),
      onSelect: r,
      onClear: () => d(void 0),
      selectedItems: e,
      emptyMessage: l ? f ? "" : "No user found" : "Enter keyword to search for user",
      itemComponent: ({ item: S, onSelect: N, checked: w }) => /* @__PURE__ */ se.jsx(
        fm,
        {
          item: S,
          checked: w,
          onSelectItem: N,
          jiraInstanceUrl: i
        }
      ),
      placeholder: "Search Jira users"
    }
  );
}, lv = ({
  field: e
}) => {
  const [n, r] = le(!1), [i, a] = Dx();
  return He(() => {
    const o = n ? window.setTimeout(() => r(!1), 2e3) : void 0;
    return () => window.clearTimeout(o);
  }, [n]), /* @__PURE__ */ se.jsxs(b, { alignItems: "center", gap: "400", justifyContent: "space-between", children: [
    /* @__PURE__ */ se.jsx(b, { children: /* @__PURE__ */ se.jsx(pe, { size: 24, name: "exclamation-triangle-filled", color: "red.500" }) }),
    /* @__PURE__ */ se.jsx(P.Paragraph, { children: "Your organizations Jira configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field. Please, attach a copy of the field details when contacting us. You can use the copy button to do so." }),
    /* @__PURE__ */ se.jsx(We, { content: n ? "Copied" : "Copy field details", children: /* @__PURE__ */ se.jsx(
      nr,
      {
        variant: "secondary",
        icon: n ? "done" : "copy",
        onClick: () => {
          a(JSON.stringify(e, null, 2)), r(!0);
        }
      }
    ) })
  ] });
}, yT = ({
  field: e,
  onChange: n,
  value: r,
  conversationContext: i,
  jiraInstanceUrl: a
}) => {
  const { type: o, system: s } = e.schema;
  if (["array", "option", "priority"].includes(o) && (!e?.allowedValues || e.allowedValues.length === 0))
    return /* @__PURE__ */ se.jsx(lv, { field: e });
  switch (o) {
    case "issuelink":
    case "environment":
    case "any":
      return /* @__PURE__ */ se.jsx(Nr, { onChange: n, value: r });
    case "string":
      return s === "description" ? /* @__PURE__ */ se.jsx(am, { onChange: n, value: r }) : /* @__PURE__ */ se.jsx(Nr, { onChange: n, value: r });
    case "textarea":
      return /* @__PURE__ */ se.jsx(am, { onChange: n, value: r });
    case "number":
      return /* @__PURE__ */ se.jsx(Nr, { type: "number", onChange: n, value: r });
    case "user":
      return /* @__PURE__ */ se.jsx(
        hT,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          agentEmail: e.key === "reporter" && i?.agent?.email || void 0,
          jiraInstanceUrl: a
        }
      );
    case "option":
    case "priority":
      return /* @__PURE__ */ se.jsx(
        wr,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          items: e?.allowedValues?.map(
            ({ id: l, name: d, value: m }) => ({
              id: l,
              name: d || m
            })
          ) || []
        }
      );
    case "array":
      return /* @__PURE__ */ se.jsx(cT, { field: e, value: r, onChange: n });
    default:
      return /* @__PURE__ */ se.jsx(lv, { field: e });
  }
}, gT = ["description", "reporter", "summary"], vT = ({
  issueTypeFields: e,
  control: n,
  jiraInstanceUrl: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ se.jsx(se.Fragment, { children: e.filter(({ key: o }) => o !== "project" && o !== "issuetype").filter(
  ({ key: o, required: s }) => s || gT.includes(o)
).map((o) => /* @__PURE__ */ se.jsx(
  Wt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ se.jsx(
      ln,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: yT({
          field: o,
          onChange: s,
          value: l,
          conversationContext: i,
          jiraInstanceUrl: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), kT = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => /* @__PURE__ */ se.jsxs(
  b,
  {
    flexDirection: "column",
    gap: "400",
    "data-testid": "jira-create-issue-success-message",
    children: [
      /* @__PURE__ */ se.jsxs(P.Paragraph, { children: [
        "You can visit your new issue by following",
        " ",
        /* @__PURE__ */ se.jsxs(
          P.ExternalLink,
          {
            href: `${n}/${e.key}`,
            target: "_blank",
            children: [
              "this link ",
              /* @__PURE__ */ se.jsx(pe, { name: "external-link" })
            ]
          }
        ),
        " ",
        "or copy it from the field below."
      ] }),
      /* @__PURE__ */ se.jsx(ln, { label: "Jira issue link", children: /* @__PURE__ */ se.jsx(
        Nr,
        {
          readOnly: !0,
          value: `${n}/${e.key}`,
          suffix: {
            type: "button",
            button: {
              icon: r ? "done" : "copy",
              onClick: () => {
                i(!0), a(`${n}/${e.key}`);
              }
            }
          }
        }
      ) })
    ]
  }
), bT = "_modalBody_1hk1o_1", xT = "_modalBodyFormFields_1hk1o_4", cv = {
  modalBody: bT,
  modalBodyFormFields: xT
}, _T = (e) => ({
  version: 1,
  type: "doc",
  content: e?.trim()?.split(`
`).filter((n) => n !== "").map((n) => ({
    type: "paragraph",
    content: [
      {
        type: "text",
        text: n
      }
    ]
  }))
}), ST = (e) => e?.custom?.split(":")?.[1] || null, NT = (e, n) => {
  if (e.startsWith("customfield_")) {
    const r = n.find((i) => i.key === e)?.schema;
    if (r)
      return r;
  }
  return null;
}, jT = (e, n) => {
  const r = ["environment", "textarea", "description"];
  return {
    fields: {
      ...Object.entries(e).reduce((i, [a, o]) => {
        if (!o || o === "")
          return delete e[a], i;
        const s = NT(a, n), l = ST(s) ?? a;
        return r.includes(l) ? i[a] = _T(o) : s?.type === "number" ? i[a] = parseInt(o) : i[a] = o, i;
      }, {}),
      summary: e.summary,
      project: { id: e.project.id },
      issuetype: { id: e.issuetype.id },
      ...e?.parent && { parent: { key: e.parent } },
      ...e?.reporter && {
        reporter: { id: e.reporter?.id ?? e.reporter }
      },
      ...e?.assignee && {
        assignee: { id: e.assignee?.id ?? e.assignee }
      }
    }
  };
}, wT = ({
  isOpen: e,
  onClose: n,
  linkIssueQuietly: r,
  conversationContext: i,
  jiraInstanceUrl: a,
  hasSortIssueTypeByLabelEnabled: o
}) => {
  const s = { project: void 0, issuetype: void 0 }, [l, d] = le([]), [m, u] = le(), [f, h] = le(0), [g, C] = le([]), [S, N] = le([]), [w, y] = le(!1), [z, $] = le(!1), [I, T] = le({}), { track: U } = _n(), { isCopied: Q, copyToClipboard: J } = GE(), ae = Bn(() => i?.conversationId, [e]), { useMutation: X, useLazyQuery: B, showNotification: O } = hn(), {
    control: q,
    handleSubmit: ee,
    formState: { errors: ve },
    reset: ue,
    setValue: ce,
    getValues: fe
  } = _t({
    defaultValues: s
  }), W = S.length > 0, xe = `${a}/browse`, Ie = Object.keys(I).length > 0, [K, { loading: qe, error: Be }] = B(UE, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (ge) => {
      d(ge.Jira.getAllProjects);
    },
    onError: (ge) => {
      O({
        title: "Could not get project list",
        text: "We could not fetch the list of your projects. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error response when fetching projects", ge), d([]);
    }
  }), [
    Oe,
    { loading: Me, error: $e }
  ] = B(ME, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (ge) => {
      h(0);
      const De = ge?.Jira?.getCreateIssueMeta?.projects[0];
      if (De) {
        const Le = De?.issuetypes.filter(
          ({ subtask: Ae }) => !Ae
        );
        C(Le || []), ce(
          "issuetype",
          Le.length > 0 ? Le[0] : void 0
        );
      } else
        O({
          title: "Could not get issue-type list",
          text: "It seems that there are no issue-types for this project or you might not have the necessary access rights to view them.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), C([]), N([]);
    },
    onError: (ge) => {
      O({
        title: "Could not get issue list",
        text: "We could not fetch the list of issue-types for this project. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error in getCreateIssueMeta", ge), C([]), N([]), h(0);
    }
  }), [ze, { error: Re }] = X(
    BE,
    {
      onError: () => {
        y(!1), O({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), U("jira:issue:create:failed", { jiraInstanceUrl: a });
      },
      onCompleted: (ge) => {
        if (y(!1), ge?.Jira && "key" in ge.Jira.createIssue)
          u(ge?.Jira?.createIssue), O({
            title: "Success",
            text: `Jira issue '${ge.Jira.createIssue.key}' created`,
            icon: "check-circle-filled",
            severity: "success"
          }), U("jira:issue:create:succeeded", {
            jiraInstanceUrl: a,
            jiraIssueKey: ge.Jira.createIssue.key
          }), ae && r(
            ge.Jira.createIssue.key,
            ae
          );
        else if ("errorMessages" in ge.Jira.createIssue || "errors" in ge.Jira.createIssue) {
          const De = ge?.Jira?.createIssue?.errors;
          console.warn("There was a problem creating a Jira issue.", De), O({
            title: "Creation was not successful",
            text: "Something went wrong. Please get in contact with Dixa.",
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
        }
      }
    }
  ), an = (ge) => {
    y(!0), T({}), ze({
      variables: {
        input: jT(ge, S)
      }
    });
  };
  He(() => {
    if (e)
      try {
        K();
      } catch (ge) {
        console.warn("Error when fetching initial projects", ge);
      }
  }, [e]), He(() => {
    const ge = z ? window.setTimeout(() => $(!1), 2e3) : void 0;
    return () => window.clearTimeout(ge);
  }, [z]), He(() => {
    if (g?.length > 0) {
      ce("issuetype", g[f]);
      const ge = g[f]?.fields?.additionalProperties;
      if (ge?.length > 0) {
        const De = ge.map(
          ({ value: E }) => E
        ), Le = (o ? De.sort(({ name: E }, { name: x }) => E.localeCompare(x)) : De).sort(
          ({ required: E }, { required: x }) => Number(x) - Number(E)
        ), { project: Ae, issuetype: mn } = fe();
        ue({ project: Ae, issuetype: mn }), N(Le);
      }
    } else
      N([]), ce("issuetype", void 0);
  }, [g, ce, f]), He(() => {
    if (Re && ex(Re)) {
      if (Re?.graphQLErrors?.length > 0) {
        const { graphQLErrors: ge } = Re, De = ge[0].extensions?.integration?.responseBody;
        try {
          const Le = JSON.parse(De);
          if (Le?.errors) {
            const Ae = Object.keys(Le.errors).reduce(
              (mn, E) => ({
                ...mn,
                [E]: {
                  type: "required",
                  message: Le.errors[E],
                  ref: {
                    name: E
                  }
                }
              }),
              {}
            );
            T(Ae);
          }
        } catch {
        }
      }
    } else
      T({});
  }, [Re]);
  const Ee = () => {
    d([]), N([]), C([]), u(void 0), h(0), y(!1), T({});
  }, Ge = () => {
    Ee(), ue(s), n();
  }, Qe = (ge) => {
    ge && Oe({
      variables: {
        projectKey: ge
      }
    });
  }, he = (ge) => {
    const De = g.map((Le) => Le.id).indexOf(ge);
    h(De ?? 0);
  };
  return /* @__PURE__ */ se.jsxs(
    Tt,
    {
      isOpen: e,
      "data-testid": "jira-create-issue-modal",
      onClose: Ge,
      children: [
        /* @__PURE__ */ se.jsx(
          $t,
          {
            title: m ? "Issue creation successful" : "Create new Jira issue",
            onClose: Ge
          }
        ),
        /* @__PURE__ */ se.jsxs(Dt, { className: cv.modalBody, children: [
          !qe && Be && /* @__PURE__ */ se.jsx(Fn, { error: Be, retry: K }),
          !Me && $e && /* @__PURE__ */ se.jsx(
            Fn,
            {
              error: $e,
              retry: Oe
            }
          ),
          !w && Ie && /* @__PURE__ */ se.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ se.jsx(
            Gs,
            {
              variant: "warning",
              description: /* @__PURE__ */ se.jsxs(
                b,
                {
                  gap: "300",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  children: [
                    /* @__PURE__ */ se.jsx(P.Paragraph, { variant: "4", children: "The form contains input validation errors. Please correct them and try again to save. If your inputs seem fine, please contact our support team and provide the form schema to debug further." }),
                    /* @__PURE__ */ se.jsx(
                      Gn,
                      {
                        icon: Q ? "done" : "copy",
                        variant: "secondary",
                        onClick: () => J(JSON.stringify(S, null, 2)),
                        children: "Copy form schema"
                      }
                    )
                  ]
                }
              )
            }
          ) }),
          m ? /* @__PURE__ */ se.jsx(
            kT,
            {
              createdIssue: m,
              issueBaseLink: xe,
              issueLinkCopied: z,
              setIssueLinkCopied: $,
              copyToClipboard: J
            }
          ) : /* @__PURE__ */ se.jsx(
            "form",
            {
              "data-testid": "jira-create-issue-form",
              onSubmit: ee(an),
              children: /* @__PURE__ */ se.jsxs(st, { children: [
                /* @__PURE__ */ se.jsx(be, { span: 3, children: /* @__PURE__ */ se.jsx(ln, { label: "Project", required: !0, children: /* @__PURE__ */ se.jsx(
                  Wt,
                  {
                    control: q,
                    name: "project",
                    rules: { required: "Please select a project" },
                    render: ({ field: { onChange: ge, value: De } }) => /* @__PURE__ */ se.jsx(
                      wr,
                      {
                        searchable: !0,
                        loading: qe,
                        onSelect: (Le) => {
                          Qe(Le.key), ge(Le);
                        },
                        selectedItems: [De],
                        placeholder: "Select Jira project",
                        emptyMessage: Be ? "No projects found" : "No projects available",
                        items: l || [],
                        itemComponent: ({ item: Le, onSelect: Ae, checked: mn }) => /* @__PURE__ */ se.jsx(
                          fm,
                          {
                            item: Le,
                            checked: mn,
                            onSelectItem: Ae,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ se.jsx(be, { span: 3, children: /* @__PURE__ */ se.jsx(ln, { label: "Issue type", required: !0, children: /* @__PURE__ */ se.jsx(
                  Wt,
                  {
                    control: q,
                    name: "issuetype",
                    rules: { required: "Please select an issue type" },
                    render: ({ field: { onChange: ge, value: De } }) => /* @__PURE__ */ se.jsx(
                      wr,
                      {
                        disabled: g.length === 0,
                        loading: Me,
                        onSelect: (Le) => {
                          he(Le.id), ge(Le);
                        },
                        selectedItems: [De],
                        placeholder: g.length > 0 ? "Select Jira issue type" : "",
                        emptyMessage: $e ? "No issues found" : "No issues available",
                        items: g,
                        itemComponent: ({ item: Le, onSelect: Ae, checked: mn }) => /* @__PURE__ */ se.jsx(
                          fm,
                          {
                            item: Le,
                            checked: mn,
                            onSelectItem: Ae,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                W && // Wrapping all dynamic input fields inside one `FormField`
                // which can handle the overflow scrolling in case we get many
                // input fields in the form
                /* @__PURE__ */ se.jsx(be, { className: cv.modalBodyFormFields, children: /* @__PURE__ */ se.jsx(
                  vT,
                  {
                    control: q,
                    errors: { ...ve, ...I },
                    getValues: fe,
                    conversationContext: i,
                    jiraInstanceUrl: a,
                    issueTypeFields: S
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ se.jsx(
          At,
          {
            confirmOnClick: m ? Ge : ee(an),
            confirmProps: {
              disabled: !W,
              isLoading: w,
              loadingIndicator: /* @__PURE__ */ se.jsx(un, { size: 16 })
            },
            confirmName: m ? "Close" : "Save",
            cancelOnClick: m ? void 0 : Ge
          }
        )
      ]
    }
  );
}, CT = (e) => {
  if (!e) return "";
  const n = "https://", r = (e.startsWith(n) ? e.slice(n.length) : e).split("/")[0];
  return `${n}${r}`;
}, j_ = (e) => {
  if (!e?.trim())
    return "Please add a value";
  const n = "https://";
  if (e.startsWith(" ") || e.endsWith(" "))
    return "Please remove any empty spaces before or after the URL";
  const r = e.startsWith(n);
  if (r) {
    const i = e.slice(n.length).split("/");
    if (i.length > 1) {
      const a = r ? n.length + i[0].length : i[0].length;
      return i.length === 2 && i[1] === "" ? "Please remove the trailing slash `/`" : `Please remove the trailing path \`${e.slice(a)}\``;
    }
  } else
    return e.includes("://") ? `The protocol \`${e.substring(
      0,
      e.indexOf("://") + 3
    )}\` is not supported` : `Please add \`${n}\` as protocol`;
}, FT = "_wrapper_1bylq_1", IT = "_inputWrapper_1bylq_6", ET = "_inputSeparator_1bylq_18", TT = "_buttonLink_1bylq_23", $T = "_noIssuesFound_1bylq_27", Ia = {
  wrapper: FT,
  inputWrapper: IT,
  inputSeparator: ET,
  buttonLink: TT,
  noIssuesFound: $T
}, DT = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = _n(), i = CT(n?.jiraSiteUrl), [a, o] = le(!1), s = !!e?.conversationId, {
    linkIssue: l,
    linkIssueQuietly: d,
    unlinkIssue: m,
    unlinkAllIssues: u,
    loadIssues: f,
    removeDanglingIssueLinks: h,
    danglingIssueLinks: g,
    isLoadingIssueLinks: C,
    isLoadingIssues: S,
    issues: N,
    error: w
  } = N_(
    s ? e.conversationId : null,
    i
  ), y = !!n?.enableCreateIssue, z = !!n?.enableSortIssueTypeByLabel, $ = !!(N?.length || g?.length), I = !!n?.enableRemoveAllLinks && $, T = !C && !S && g?.length > 0 && !!n?.showDanglingLinks;
  return !S && w ? /* @__PURE__ */ se.jsx(Fn, { error: w, retry: () => f() }) : /* @__PURE__ */ se.jsxs(se.Fragment, { children: [
    /* @__PURE__ */ se.jsxs(b, { className: Ia.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ se.jsxs(b, { className: Ia.inputWrapper, flexDirection: "column", children: [
        y && /* @__PURE__ */ se.jsxs(se.Fragment, { children: [
          /* @__PURE__ */ se.jsx(
            Gn,
            {
              variant: "primary",
              onClick: () => o(!0),
              style: {
                minHeight: "38px"
              },
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ se.jsx("div", { className: Ia.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ se.jsx(
          lT,
          {
            onSelectIssue: l,
            jiraInstanceUrl: i
          }
        )
      ] }),
      S ? /* @__PURE__ */ se.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ se.jsx(un, { "data-testid": "jira-widget-issue-spinner" }) }) : N?.length ? /* @__PURE__ */ se.jsx(
        EE,
        {
          issues: N,
          jiraInstanceUrl: i,
          unlinkIssue: m
        }
      ) : /* @__PURE__ */ se.jsx(P.Paragraph, { align: "center", className: Ia.noIssuesFound, children: "No linked issues found" }),
      I && N?.length > 0 && /* @__PURE__ */ se.jsx(
        Gn,
        {
          variant: "secondary",
          disabled: !N?.length && !g?.length,
          onClick: u,
          children: "Unlink all issues"
        }
      ),
      T && /* @__PURE__ */ se.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ se.jsx(P.Heading, { variant: "heading-3", children: "Unresolved linked issues" }),
            /* @__PURE__ */ se.jsx(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: g.map((U) => /* @__PURE__ */ se.jsx(Pn, { onDelete: () => m(U), children: U }, U)) }),
            /* @__PURE__ */ se.jsx(
              Gn,
              {
                variant: "secondary",
                onClick: () => h(),
                icon: "link-slash",
                children: "Remove all unresolved issues"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ se.jsx(
        Et,
        {
          slotEnd: /* @__PURE__ */ se.jsx(pe, { name: "external-link" }),
          variant: "tertiary",
          className: Ia.buttonLink,
          navigate: () => {
            r("jira:view:jira:clicked", { jiraInstanceUrl: i }), window.open(i, "_blank")?.focus();
          },
          children: "Open Jira"
        }
      )
    ] }),
    a && /* @__PURE__ */ se.jsx(
      wT,
      {
        isOpen: a,
        onClose: () => o(!1),
        linkIssueQuietly: d,
        conversationContext: e,
        jiraInstanceUrl: i,
        hasSortIssueTypeByLabelEnabled: z
      }
    )
  ] });
}, dv = [
  {
    key: "jiraSiteUrl",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "enableRemoveAllLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "enableSortIssueTypeByLabel",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  }
], RT = (e) => {
  const n = j_(e);
  return typeof n == "string" ? n : !0;
}, li = "JIRA", OT = {
  enabled: !1,
  name: "",
  jiraSiteUrl: "",
  enableRemoveAllLinks: !1,
  showDanglingLinks: !1,
  enableCreateIssue: !0,
  enableSortIssueTypeByLabel: !1
}, AT = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = _t({
    mode: "onChange",
    defaultValues: OT
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: g,
    setMisconfigurationCause: C
  } = ji({
    integrationId: e,
    integrationType: li,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: S,
    error: N,
    isWidgetUnknown: w,
    refetch: y,
    widgetConfiguration: z
  } = wi({
    integrationId: e,
    fieldDefinitions: dv,
    form: l,
    onMisconfigured: C
  }), { renderConditions: $, setRenderConditions: I, renderConditionsForSubmit: T } = Ci({
    integrationId: e,
    widgetConfiguration: z,
    renderConditionsEditor: o
  }), U = (J) => Ii(J, {
    fieldDefinitions: dv,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: T
  }), Q = l.watch("name");
  return /* @__PURE__ */ se.jsxs(
    Fi,
    {
      form: l,
      integrationId: e,
      onValidSubmit: U,
      error: N ?? h,
      onRetry: N ? y : void 0,
      isLoading: f || S,
      isWidgetUnknown: w,
      children: [
        g && /* @__PURE__ */ se.jsx(Ei, { cause: g }),
        /* @__PURE__ */ se.jsxs(st, { children: [
          /* @__PURE__ */ se.jsx(be, { children: /* @__PURE__ */ se.jsx(ln, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ se.jsx(
            Jn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ se.jsx(be, { span: 3, children: /* @__PURE__ */ se.jsx(
            tt,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ se.jsx(be, { span: 3 }),
          /* @__PURE__ */ se.jsx(be, { span: 3, children: /* @__PURE__ */ se.jsx(
            tt,
            {
              name: "jiraSiteUrl",
              label: "Jira site URL",
              control: l.control,
              rules: {
                validate: (J) => RT(J)
              },
              componentProps: {
                placeholder: 'Insert your Jira site URL, e.g. "https://your-site.atlassian.net/"',
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ se.jsx(be, { span: 3 }),
          /* @__PURE__ */ se.jsx(be, { span: 3, children: /* @__PURE__ */ se.jsx(ln, { label: 'Enable the "Remove all links" button', children: /* @__PURE__ */ se.jsx(
            Jn,
            {
              name: "enableRemoveAllLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ se.jsx(be, { span: 3 }),
          /* @__PURE__ */ se.jsx(be, { span: 3, children: /* @__PURE__ */ se.jsx(ln, { label: "Show unresolved links to Jira issues", children: /* @__PURE__ */ se.jsx(
            Jn,
            {
              name: "showDanglingLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ se.jsx(be, { span: 3 }),
          /* @__PURE__ */ se.jsx(be, { span: 3, children: /* @__PURE__ */ se.jsx(ln, { label: 'Enable the "Create issue" button', children: /* @__PURE__ */ se.jsx(
            Jn,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ se.jsx(be, { span: 3 }),
          /* @__PURE__ */ se.jsx(be, { span: 3, children: /* @__PURE__ */ se.jsx(ln, { label: "Enable to sort the issue types by label", children: /* @__PURE__ */ se.jsx(
            Jn,
            {
              name: "enableSortIssueTypeByLabel",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ se.jsx(be, { span: 3 }),
          !s && e && /* @__PURE__ */ se.jsx(
            Lr,
            {
              configuration: n,
              integrationId: e,
              integrationType: li,
              label: "Authorize with OAuth"
            }
          ),
          o && $ !== null && /* @__PURE__ */ se.jsx(be, { children: o({
            value: $,
            onChange: I,
            configurationKey: z?.id
          }) })
        ] }),
        /* @__PURE__ */ se.jsx(
          Ti,
          {
            integrationType: li,
            integrationId: e,
            widgetName: Q,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ se.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ se.jsx(
                pe,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ se.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ se.jsxs(P.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  li,
                  " integration, all links between Dixa and ",
                  li,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ se.jsxs(P.Paragraph, { children: [
                  "All data in ",
                  li,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ se.jsxs(P.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  li,
                  " ",
                  'integration "',
                  Q,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
}, uv = [
  {
    key: "jiraSiteUrl",
    label: "Jira site URL",
    placeholder: 'Insert your Jira site URL, e.g. "https://your-site.atlassian.net/"',
    secret: !1,
    type: "input",
    required: !0,
    customValidation: (e) => j_(e),
    defaultValue: ""
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Lr
  },
  {
    key: "enableRemoveAllLinks",
    label: 'Enable the "Remove all links" button',
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    label: "Show unresolved links to Jira issues",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableSortIssueTypeByLabel",
    label: "Enable to sort the issue types by label",
    secret: !1,
    type: "switch",
    defaultValue: !1
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._notificationText_1polx_1{color:var(--dixa-color-neutral-500)}._message_1vrar_48{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}._message_1vrar_48:hover,._messageIsOpen_1vrar_56{border-color:var(--dixa-color-neutral-400)}._messageHeader_1vrar_59{cursor:pointer}._messageUnattended_1vrar_62{text-decoration:line-through}._messageLabel_1vrar_65{color:var(--dixa-typography-color-secondary)}._messageText_1vrar_68{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:hidden;overflow-y:auto;overflow-x:auto}._messageText_1vrar_68::-webkit-scrollbar{width:7px;height:7px}._messageText_1vrar_68::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-200)}._messageText_1vrar_68::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:5px}._list_ld0hf_1{padding:0}._listItem_ld0hf_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ld0hf_4:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._subscriptionError_1qhhx_1{color:var(--dixa-typography-color-error);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var hu = { exports: {} }, Ea = {}, mv;
function PT() {
  if (mv) return Ea;
  mv = 1;
  var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return Ea.Fragment = r, Ea.jsx = s, Ea.jsxs = s, Ea;
}
var Uo = {}, pv;
function LT() {
  return pv || (pv = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        z("error", t, p);
      }
    }
    function z(t, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, A = v.getStackAddendum();
        A !== "" && (c += "%s", p = p.concat([A]));
        var L = p.map(function(F) {
          return String(F);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, I = !1, T = !1, U = !1, Q = !1, J;
    J = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === u || U || t === g || $ || I || T || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function X(t, c, p) {
      var v = t.displayName;
      if (v)
        return v;
      var A = c.displayName || c.name || "";
      return A !== "" ? p + "(" + A + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return X(t, t.render, "ForwardRef");
          case f:
            var v = t.displayName || null;
            return v !== null ? v : O(t.type) || "Memo";
          case h: {
            var A = t, L = A._payload, F = A._init;
            try {
              return O(F(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, ue, ce, fe, W, xe, Ie;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ve = console.log, ue = console.info, ce = console.warn, fe = console.error, W = console.group, xe = console.groupCollapsed, Ie = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: ue
            }),
            warn: q({}, t, {
              value: ce
            }),
            error: q({}, t, {
              value: fe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: xe
            }),
            groupEnd: q({}, t, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Me;
    function $e(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (A) {
            var v = A.stack.trim().match(/\n( *(at )?)/);
            Me = v && v[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var ze = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(t, c) {
      if (!t || ze)
        return "";
      {
        var p = Re.get(t);
        if (p !== void 0)
          return p;
      }
      var v;
      ze = !0;
      var A = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, qe();
      try {
        if (c) {
          var F = function() {
            throw Error();
          };
          if (Object.defineProperty(F.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(F, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(t, [], F);
          } else {
            try {
              F.call();
            } catch (ne) {
              v = ne;
            }
            t.call(F.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), G = j.length - 1, _ = te.length - 1; G >= 1 && _ >= 0 && j[G] !== te[_]; )
            _--;
          for (; G >= 1 && _ >= 0; G--, _--)
            if (j[G] !== te[_]) {
              if (G !== 1 || _ !== 1)
                do
                  if (G--, _--, _ < 0 || j[G] !== te[_]) {
                    var Z = `
` + j[G].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (G >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Oe.current = L, Be(), Error.prepareStackTrace = A;
      }
      var de = t ? t.displayName || t.name : "", Se = de ? $e(de) : "";
      return typeof t == "function" && Re.set(t, Se), Se;
    }
    function Ge(t, c, p) {
      return Ee(t, !1);
    }
    function Qe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function he(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Qe(t));
      if (typeof t == "string")
        return $e(t);
      switch (t) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ge(t.render);
          case f:
            return he(t.type, c, p);
          case h: {
            var v = t, A = v._payload, L = v._init;
            try {
              return he(L(A), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, De = {}, Le = w.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = he(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(t, c, p, v, A) {
      {
        var L = Function.call.bind(ge);
        for (var F in t)
          if (L(t, F)) {
            var j = void 0;
            try {
              if (typeof t[F] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + F + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[F] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[F](c, F, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (G) {
              j = G;
            }
            j && !(j instanceof Error) && (Ae(A), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, F, typeof j), Ae(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Ae(A), y("Failed %s type: %s", p, j.message), Ae(null));
          }
      }
    }
    var E = Array.isArray;
    function x(t) {
      return E(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var V = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, me, Ne;
    function nn(t) {
      if (ge.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function fn(t) {
      if (ge.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && V.current;
    }
    function cn(t, c) {
      {
        var p = function() {
          me || (me = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(t, c, p, v, A, L, F) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: F,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: A
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, v, A) {
      {
        var L, F = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), fn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ge.call(c, L) && !ie.hasOwnProperty(L) && (F[L] = c[L]);
        if (t && t.defaultProps) {
          var G = t.defaultProps;
          for (L in G)
            F[L] === void 0 && (F[L] = G[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && cn(F, _), te && pn(F, _);
        }
        return dn(t, j, te, A, v, V.current, F);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = he(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var t = O(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        t && t._owner && t._owner !== en.current && (v = " It was passed a child from " + O(t._owner.type) + "."), Pe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Pe(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var v = t[p];
            sn(v) && gn(v, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var A = N(t);
          if (typeof A == "function" && A !== t.entries)
            for (var L = A.call(t), F; !(F = L.next()).done; )
              sn(F.value) && gn(F.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          mn(p, t.props, "prop", v, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var A = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", A || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Pe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Pe(null);
            break;
          }
        }
        t.ref !== null && (Pe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Pe(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, v, A, L) {
      {
        var F = ae(t);
        if (!F) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var G;
          t === null ? G = "null" : x(t) ? G = "array" : t !== void 0 && t.$$typeof === n ? (G = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : G = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", G, j);
        }
        var _ = xn(t, c, p, A, L);
        if (_ == null)
          return _;
        if (F) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var de = 0; de < Z.length; de++)
                  Cn(Z[de], t);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, t);
        }
        if (ge.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, Se, $n, Se), Sn[Se + Ke] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Uo.Fragment = i, Uo.jsx = Rn, Uo.jsxs = Mn;
  })()), Uo;
}
var fv;
function VT() {
  return fv || (fv = 1, process.env.NODE_ENV === "production" ? hu.exports = PT() : hu.exports = LT()), hu.exports;
}
var Ce = VT();
function zT({
  query: e,
  options: n,
  delayMs: r
}) {
  const { useLazyQuery: i } = hn(), [a, o] = le([]), [s] = i(e, n), [l, d] = le(
    []
  );
  return He(() => () => {
    l.forEach((m) => window.clearTimeout(m));
  }, []), [async (m) => {
    const u = [];
    for (const [f, h] of m.entries()) {
      f !== 0 && await new Promise((C) => {
        const S = setTimeout(C, r);
        d([...l, S]);
      });
      const g = await s({
        variables: h
      });
      u.push(g);
    }
    o(u);
  }, a];
}
var w_ = /* @__PURE__ */ ((e) => (e.List = "list", e))(w_ || {}), hm = /* @__PURE__ */ ((e) => (e.Profile = "profile", e))(hm || {}), ym = /* @__PURE__ */ ((e) => (e.Subscribed = "SUBSCRIBED", e))(ym || {}), gm = /* @__PURE__ */ ((e) => (e.Unsubscribed = "UNSUBSCRIBED", e))(gm || {});
const UT = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, MT = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, BT = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }] }, qT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "subscribeProfileToChannel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "relationships" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bulk_subscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_create_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }, { kind: "ObjectField", name: { kind: "Name", value: "relationships" }, value: { kind: "Variable", name: { kind: "Name", value: "relationships" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, HT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "unsubscribeProfileByContact" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bulk_unsubscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_delete_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, WT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getEvents" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "pageSize" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_PositiveInt" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "receivedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "openedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "clickedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "bouncedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "receivedSms" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, GT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getFlowMessage" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "messageId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_flow_message" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "messageId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetFlowMessageEncodedResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "definition" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_FlowEmail" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "preview_text" } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, KT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getMetrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_metrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetMetricResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, YT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileByFilter" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hasEmail" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hasPhoneNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "profileByEmail" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "hasEmail" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "profileByPhoneNumber" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "hasPhoneNumber" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, QT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }, { kind: "EnumValue", value: "properties" }, { kind: "EnumValue", value: "predictive_analytics" }] } }, { kind: "Argument", name: { kind: "Name", value: "additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }, { kind: "EnumValue", value: "predictive_analytics" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "predictive_analytics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "average_order_value" } }, { kind: "Field", name: { kind: "Name", value: "churn_probability" } }, { kind: "Field", name: { kind: "Name", value: "predicted_clv" } }, { kind: "Field", name: { kind: "Name", value: "historic_clv" } }, { kind: "Field", name: { kind: "Name", value: "total_clv" } }, { kind: "Field", name: { kind: "Name", value: "historic_number_of_orders" } }, { kind: "Field", name: { kind: "Name", value: "predicted_number_of_orders" } }, { kind: "Field", name: { kind: "Name", value: "average_days_between_orders" } }, { kind: "Field", name: { kind: "Name", value: "expected_date_of_next_order" } }, { kind: "Field", name: { kind: "Name", value: "ranked_channel_affinity" } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, JT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getListsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_lists_for_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetListResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, XT = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getSegmentsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_segments_for_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetSegmentResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, ZT = {
  "\n  fragment ClientErrorResponseFragment on Klaviyo_ClientError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": UT,
  "\n  fragment ServerErrorResponseFragment on Klaviyo_ServerError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": MT,
  "\n  mutation subscribeProfileToChannel(\n    $attributes: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input!\n    $relationships: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input!\n  ) {\n    Klaviyo {\n      bulk_subscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_create_job\n            attributes: $attributes\n            relationships: $relationships\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": qT,
  "\n  mutation unsubscribeProfileByContact(\n    $attributes: Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input!\n  ) {\n    Klaviyo {\n      bulk_unsubscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_delete_job\n            attributes: $attributes\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": HT,
  "\n  fragment GetEventResponseFragment on Klaviyo_GetEventResponseCollectionCompoundDocument {\n    data {\n      id\n      type\n      attributes {\n        timestamp\n        event_properties\n      }\n    }\n  }\n": BT,
  "\n  query getEvents(\n    $receivedEmailEventsFilter: String!\n    $openedEmailEventsFilter: String!\n    $clickedEmailEventsFilter: String!\n    $bouncedEmailEventsFilter: String!\n    $receivedSmsEventsFilter: String!\n    $pageSize: Klaviyo_PositiveInt!\n  ) {\n    Klaviyo {\n      receivedEmail: get_events(\n        filter: $receivedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      openedEmail: get_events(\n        filter: $openedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      clickedEmail: get_events(\n        filter: $clickedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      bouncedEmail: get_events(\n        filter: $bouncedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      receivedSms: get_events(\n        filter: $receivedSmsEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": WT,
  "\n  query getFlowMessage($messageId: String!) {\n    Klaviyo {\n      get_flow_message(id: $messageId) {\n        ... on Klaviyo_GetFlowMessageEncodedResponseCompoundDocument {\n          data {\n            id\n            type\n            attributes {\n              definition {\n                ... on Klaviyo_FlowEmail {\n                  preview_text\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": GT,
  "\n  query getMetrics {\n    Klaviyo {\n      get_metrics {\n        ... on Klaviyo_GetMetricResponseCollectionCompoundDocument {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": KT,
  "\n  query getProfileByFilter(\n    $emailFilter: String\n    $phoneNumberFilter: String\n    $hasEmail: Boolean!\n    $hasPhoneNumber: Boolean!\n  ) {\n    Klaviyo {\n      profileByEmail: get_profiles(\n        filter: $emailFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasEmail) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      profileByPhoneNumber: get_profiles(\n        filter: $phoneNumberFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasPhoneNumber) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": YT,
  "\n  query getProfileById($profileId: String!) {\n    Klaviyo {\n      get_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          properties\n          predictive_analytics\n        ]\n        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          predictive_analytics\n        ]\n      ) {\n        ... on Klaviyo_GetProfileResponseCompoundDocument {\n          data {\n            attributes {\n              subscriptions {\n                email {\n                  marketing {\n                    consent\n                  }\n                }\n                sms {\n                  marketing {\n                    consent\n                  }\n                }\n              }\n              properties\n              predictive_analytics {\n                average_order_value\n                churn_probability\n                predicted_clv\n                historic_clv\n                total_clv\n                historic_number_of_orders\n                predicted_number_of_orders\n                average_days_between_orders\n                expected_date_of_next_order\n                ranked_channel_affinity\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": QT,
  "\n  query getListsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_lists_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetListResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": JT,
  "\n  query getSegmentsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_segments_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetSegmentResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": XT
};
function Qr(e) {
  return ZT[e] ?? {};
}
const e$ = Qr(
  /* GraphQL */
  `
  query getEvents(
    $receivedEmailEventsFilter: String!
    $openedEmailEventsFilter: String!
    $clickedEmailEventsFilter: String!
    $bouncedEmailEventsFilter: String!
    $receivedSmsEventsFilter: String!
    $pageSize: Klaviyo_PositiveInt!
  ) {
    Klaviyo {
      receivedEmail: get_events(
        filter: $receivedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      openedEmail: get_events(
        filter: $openedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      clickedEmail: get_events(
        filter: $clickedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      bouncedEmail: get_events(
        filter: $bouncedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      receivedSms: get_events(
        filter: $receivedSmsEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), n$ = Qr(
  /* GraphQL */
  `
  query getFlowMessage($messageId: String!) {
    Klaviyo {
      get_flow_message(id: $messageId) {
        ... on Klaviyo_GetFlowMessageEncodedResponseCompoundDocument {
          data {
            id
            type
            attributes {
              definition {
                ... on Klaviyo_FlowEmail {
                  preview_text
                }
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), t$ = Qr(
  /* GraphQL */
  `
  query getMetrics {
    Klaviyo {
      get_metrics {
        ... on Klaviyo_GetMetricResponseCollectionCompoundDocument {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), r$ = Qr(
  /* GraphQL */
  `
  query getProfileByFilter(
    $emailFilter: String
    $phoneNumberFilter: String
    $hasEmail: Boolean!
    $hasPhoneNumber: Boolean!
  ) {
    Klaviyo {
      profileByEmail: get_profiles(
        filter: $emailFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) @include(if: $hasEmail) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      profileByPhoneNumber: get_profiles(
        filter: $phoneNumberFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) @include(if: $hasPhoneNumber) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), i$ = Qr(
  /* GraphQL */
  `
  query getProfileById($profileId: String!) {
    Klaviyo {
      get_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [
          subscriptions
          properties
          predictive_analytics
        ]
        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [
          subscriptions
          predictive_analytics
        ]
      ) {
        ... on Klaviyo_GetProfileResponseCompoundDocument {
          data {
            attributes {
              subscriptions {
                email {
                  marketing {
                    consent
                  }
                }
                sms {
                  marketing {
                    consent
                  }
                }
              }
              properties
              predictive_analytics {
                average_order_value
                churn_probability
                predicted_clv
                historic_clv
                total_clv
                historic_number_of_orders
                predicted_number_of_orders
                average_days_between_orders
                expected_date_of_next_order
                ranked_channel_affinity
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), a$ = Qr(
  /* GraphQL */
  `
  query getListsByProfileId($profileId: String!) {
    Klaviyo {
      get_lists_for_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetListResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), o$ = Qr(
  /* GraphQL */
  `
  query getSegmentsByProfileId($profileId: String!) {
    Klaviyo {
      get_segments_for_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetSegmentResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), s$ = Qr(
  /* GraphQL */
  `
  mutation subscribeProfileToChannel(
    $attributes: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input!
    $relationships: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input!
  ) {
    Klaviyo {
      bulk_subscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_create_job
            attributes: $attributes
            relationships: $relationships
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), l$ = Qr(
  /* GraphQL */
  `
  mutation unsubscribeProfileByContact(
    $attributes: Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input!
  ) {
    Klaviyo {
      bulk_unsubscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_delete_job
            attributes: $attributes
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
);
function vm(e) {
  return e?.attributes?.event_properties?.$flow !== void 0;
}
function hv(e) {
  return vm(e) && e?.attributes?.event_properties?.$message;
}
function c$(e) {
  return e?.attributes?.event_properties?.["Bounce Type"] !== void 0;
}
function yv(e) {
  const n = e?.attributes?.timestamp;
  if (n)
    return n;
}
function d$(e) {
  return e.Klaviyo?.get_metrics?.__typename === "Klaviyo_GetMetricResponseCollectionCompoundDocument" && e.Klaviyo.get_metrics.data || [];
}
function u$(e) {
  return (e?.Klaviyo?.receivedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function m$(e) {
  return (e?.Klaviyo?.receivedSms?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedSms.data || [])?.map((n) => ({
    ...n,
    eventType: "SMS"
  }));
}
function p$(e) {
  return (e?.Klaviyo?.openedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.openedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function f$(e) {
  return (e?.Klaviyo?.clickedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.clickedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function h$(e) {
  return (e?.Klaviyo?.bouncedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.bouncedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function gv(e) {
  return e?.Klaviyo?.get_flow_message?.__typename === "Klaviyo_GetFlowMessageEncodedResponseCompoundDocument" && e.Klaviyo.get_flow_message.data || void 0;
}
function y$(e) {
  return e?.attributes?.definition?.__typename === "Klaviyo_FlowEmail" && e.attributes.definition.preview_text || void 0;
}
function g$(e) {
  try {
    return JSON.parse(JSON.stringify(e));
  } catch {
    return console.error(`Could not make a copy of ${JSON.stringify(e)}`), {};
  }
}
const v$ = (e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
function k$(e) {
  return e?.data?.attributes?.subscriptions?.email?.marketing?.consent === "SUBSCRIBED";
}
function b$(e) {
  return e?.data?.attributes?.subscriptions?.sms?.marketing?.consent === "SUBSCRIBED";
}
function x$({
  profileId: e,
  noOfMessagesToShow: n
}) {
  const { useLazyQuery: r, useQuery: i } = hn(), { track: a } = _n(), [o, s] = le(null), [l, d] = le(
    null
  ), [m, u] = le(null), [f, h] = le(null), [g, C] = le(
    null
  ), [S, N] = le([]), {
    data: w,
    error: y,
    loading: z,
    networkStatus: $
  } = i(t$, {
    /*
    	Since metrics should rarely be changed, query once when the client initializes
    	and then read from the cache for the subsequent queries.
    */
    fetchPolicy: "network-only",
    // Used for first execution
    nextFetchPolicy: "cache-first",
    // Used for subsequent executions
    notifyOnNetworkStatusChange: !0
  }), [
    I,
    {
      data: T,
      error: U,
      loading: Q,
      networkStatus: J
    }
  ] = r(e$, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return He(() => {
    if (w && !z && $ === er.ready) {
      const ae = d$(w);
      s(
        ae.find((X) => X?.attributes?.name === "Received Email")?.id || null
      ), d(
        ae.find((X) => X?.attributes?.name === "Opened Email")?.id || null
      ), u(
        ae.find((X) => X?.attributes?.name === "Clicked Email")?.id || null
      ), h(
        ae.find((X) => X?.attributes?.name === "Bounced Email")?.id || null
      ), C(
        ae.find((X) => X?.attributes?.name === "Received SMS")?.id || null
      );
    } else
      s(null), d(null), u(null), h(null), C(null);
  }, [w]), He(() => {
    o && l && m && f && g && !Q && J === er.ready ? I({
      variables: {
        receivedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${o}")`,
        openedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${l}")`,
        clickedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${m}")`,
        bouncedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${f}")`,
        receivedSmsEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${g}")`,
        pageSize: n
      }
    }) : N([]);
  }, [
    o,
    l,
    m,
    f,
    g
  ]), He(() => {
    if (!Q && T) {
      const ae = u$(T), X = p$(
        T
      ).map(
        (ue) => ue?.attributes?.event_properties.$message
      ), B = f$(
        T
      ).map(
        (ue) => ue?.attributes?.event_properties.$message
      );
      ae.forEach((ue) => {
        const ce = ue.attributes?.event_properties.$message;
        ue.opened = X.includes(ce), ue.clicked = B.includes(ce);
      });
      const O = m$(T), q = h$(T), ee = [
        ...ae,
        ...q,
        ...O
      ].sort((ue, ce) => {
        const fe = yv(ue), W = yv(ce);
        return fe == null && W == null ? 0 : fe == null ? 1 : W == null ? -1 : W - fe;
      }).slice(0, n);
      N(ee);
      const ve = ee.map((ue) => ue.id);
      a("klaviyo:messages:received", {
        emailsReceived: ae.filter(
          (ue) => ve.includes(ue.id)
        ).length,
        emailsBounced: q.filter(
          (ue) => ve.includes(ue.id)
        ).length,
        smsReceived: O.filter(
          (ue) => ve.includes(ue.id)
        ).length,
        total: ve.length
      });
    } else
      N([]);
  }, [Q, T]), Bn(
    () => ({
      receivedMessages: S,
      isLoading: z || Q,
      error: y || U
    }),
    [
      S,
      z,
      Q,
      y,
      U
    ]
  );
}
function _$({ profileId: e }) {
  const { useQuery: n } = hn(), [r, i] = le(), [a, o] = le(), {
    data: s,
    error: l,
    loading: d,
    refetch: m
  } = n(i$, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    variables: {
      profileId: e
    }
  });
  He(() => {
    l && o(l);
  }, [l]), He(() => {
    !d && s && i(s.Klaviyo.get_profile);
  }, [d, s]);
  const u = async () => {
    const f = await m();
    f.error ? o(f.error) : f.data && i(
      f.data.Klaviyo.get_profile
    );
  };
  return Bn(
    () => ({
      profile: r,
      refetchProfile: u,
      isLoading: d,
      error: a
    }),
    // No need to add `refetchProfile` as a dependency here
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r, d, a]
  );
}
function S$({
  email: e,
  phoneNumber: n
}) {
  const { track: r } = _n(), { useLazyQuery: i } = hn(), [a, o] = le(), [s, l] = le(), [
    d,
    { data: m, error: u, loading: f }
  ] = i(r$, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  He(() => {
    if (!f && m) {
      const g = m.Klaviyo?.profileByEmail?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByEmail || void 0, C = m.Klaviyo?.profileByPhoneNumber?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByPhoneNumber || void 0;
      h(g, C);
    }
  }, [f, m]);
  const h = (g, C) => {
    const S = g?.data?.length === 1 && g.data[0]?.id || void 0, N = C?.data?.length === 1 && C.data[0]?.id || void 0, w = S || N, y = !S || !N || S === N;
    if (w && y) {
      o(S || N), r("klaviyo:profile:received", { hasProfile: !0 });
      return;
    }
    o(void 0), r("klaviyo:profile:received", { hasProfile: !1 }), y || l(
      new Error(
        `Two different profiles were retrieved from Klaviyo for the email ${e} (profile ID ${S}) and phone number ${n} (profile ID ${N}).`
      )
    );
  };
  return Bn(
    () => ({
      profileId: a,
      getProfileId: d,
      isLoading: f,
      error: u || s
    }),
    [a, d, f, u, s]
  );
}
const vv = 800, N$ = {
  min: 800,
  // 0.8 seconds
  max: 1200
  // 1.2 seconds
}, j$ = 3, w$ = 1.5, C$ = ({
  query: e,
  delay: n,
  delayRange: r,
  maxCount: i = j$,
  useDelayRange: a = !1
}) => {
  const o = (U) => Math.floor(Math.random() * (U.max - U.min) + U.min), [s, l] = le(0), [d, m] = le(n || vv), [u, f] = le(r || N$), [h, g] = le(!1), [C, S] = le(!1), N = a || !!r, w = N ? o(u) : n || vv, [y, z] = le(w);
  sC(
    async () => {
      const U = s + 1, Q = w$ ** U;
      l(U), z(
        (N ? o(u) : d) * Q
      ), await e().then(() => {
        S(!0), T();
      });
    },
    h ? y : null
  ), cC(() => T());
  const $ = ot(() => {
    l(0), z(w);
  }, [w]), I = ot(
    (U = {}) => {
      const { delay: Q, delayRange: J } = U;
      S(!1), $(), J && (f(J), z(o(J))), Q && (m(Q), z(Q)), g(!0);
    },
    [$]
  ), T = ot(() => {
    g(!1), $();
  }, [$]);
  return He(() => {
    s >= i && T();
  }, [s, i, T]), Bn(
    () => ({ isRunning: h, isSuccessful: C, start: I, stop: T }),
    [h, C, I, T]
  );
}, F$ = (e) => {
  const n = e.graphQLErrors[0]?.extensions.integration?.responseHeaders?.["retry-after"];
  return n ? parseInt(n, 10) : void 0;
}, I$ = (e) => ({
  min: e * 1e3,
  max: e * 1e3 + 500
});
function E$({
  profileId: e,
  query: n
}) {
  const { useQuery: r } = hn(), [i, a] = le(), [o, s] = le(), {
    data: l,
    error: d,
    loading: m,
    refetch: u,
    networkStatus: f
  } = r(
    n === "lists" ? a$ : o$,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0,
      variables: {
        profileId: e
      }
    }
  ), {
    isRunning: h,
    start: g,
    stop: C
  } = C$({
    query: u,
    useDelayRange: !0
  }), S = m || h;
  return He(() => {
    if (d)
      if (y0({
        errors: d.graphQLErrors
      })) {
        if (!h) {
          const N = F$(d);
          g({
            ...N && {
              delayRange: I$(N)
            }
          });
        }
      } else
        s(d);
  }, [d]), He(() => {
    if (!m && l?.Klaviyo) {
      let N = {}, w = {};
      n === "lists" && (N = l?.Klaviyo?.get_lists_for_profile), n === "segments" && (w = l?.Klaviyo?.get_segments_for_profile), (N?.data || w?.data) && (C(), a(
        (n === "lists" ? N?.data : w?.data)?.map((y) => ({
          ...y,
          type: n === "lists" ? "list" : "segment"
        }))
      ));
    }
  }, [m, l]), Bn(
    () => ({
      listsOrSegments: i,
      refetchListOrSegments: g,
      isLoading: S,
      error: o,
      networkStatus: f
    }),
    [i, S, o, f, g]
  );
}
const T$ = "_notificationText_1polx_1", Fp = {
  notificationText: T$
}, ll = ({ error: e }) => {
  const { track: n } = _n();
  let r = e;
  if (ex(e)) {
    const i = e.graphQLErrors, a = i.length === 1 && Wb({ error: i[0] }), o = i.length === 1 && f0({ error: i[0] });
    if (a)
      n("klaviyo:profile:failed", { reason: "Invalid access token" }), r = new Error(
        "It was not possible to retrieve data from Klaviyo due to an access issue. Please contact your administrator."
      );
    else if (o)
      n("klaviyo:profile:failed", { reason: "Insufficient permissions" }), r = new Error(
        "You don't have enough permissions to see Klaviyo profile data for this conversation. This is typically due to a misconfiguration of the Klaviyo integration."
      );
    else
      return n("klaviyo:profile:failed", { reason: "Unexpected error" }), /* @__PURE__ */ Ce.jsx(Fn, { error: e });
  }
  return /* @__PURE__ */ Ce.jsx(b, { margin: "0 0 300", children: /* @__PURE__ */ Ce.jsx(
    Ye.Item,
    {
      contentLeft: /* @__PURE__ */ Ce.jsx(pe, { color: "red.500", size: 20, name: "exclamation-triangle-filled" }),
      titleSecondary: r.message,
      title: "Unable to show Klaviyo profile data",
      variant: "dense"
    }
  ) });
}, $$ = "_message_1vrar_48", D$ = "_messageIsOpen_1vrar_56", R$ = "_messageHeader_1vrar_59", O$ = "_messageLabel_1vrar_65", A$ = "_messageText_1vrar_68", ea = {
  message: $$,
  messageIsOpen: D$,
  messageHeader: R$,
  messageLabel: O$,
  messageText: A$
}, P$ = ({ event: e, isLoadingPreview: n }) => {
  const r = e?.attributes?.event_properties, i = e.flowMessage && y$(e.flowMessage);
  return /* @__PURE__ */ Ce.jsxs(Ce.Fragment, { children: [
    /* @__PURE__ */ Ce.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
      /* @__PURE__ */ Ce.jsx(P.Paragraph, { variant: "4", className: ea.messageLabel, children: "Campaign name" }),
      /* @__PURE__ */ Ce.jsx(P.Paragraph, { children: r["Campaign Name"] })
    ] }),
    n ? /* @__PURE__ */ Ce.jsx(b, { justifyContent: "center", margin: "100", children: /* @__PURE__ */ Ce.jsx(un, { size: 22 }) }) : i && i.length > 0 && /* @__PURE__ */ Ce.jsxs(
      b,
      {
        flexDirection: "column",
        justifyContent: "space-between",
        gap: "100",
        children: [
          /* @__PURE__ */ Ce.jsx(b, { children: /* @__PURE__ */ Ce.jsx(
            P.Paragraph,
            {
              variant: "4",
              className: ea.messageLabel,
              children: "Preview text"
            }
          ) }),
          /* @__PURE__ */ Ce.jsx(P.Paragraph, { variant: "4", className: ea.messageText, children: i })
        ]
      }
    )
  ] });
}, L$ = ({ event: e }) => {
  const n = e?.attributes?.event_properties;
  return /* @__PURE__ */ Ce.jsx(Ce.Fragment, { children: /* @__PURE__ */ Ce.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
    /* @__PURE__ */ Ce.jsx(b, { children: /* @__PURE__ */ Ce.jsx(P.Heading, { variant: "heading-4", children: "Message" }) }),
    /* @__PURE__ */ Ce.jsx(b, { children: n?.extra?.["Message Body"] })
  ] }) });
}, V$ = ({
  event: e,
  isLoadingPreview: n,
  openByDefault: r
}) => {
  const [i, a] = le(r), { attributes: o, eventType: s } = e, l = o?.datetime, d = o?.timestamp, m = "DD MMM YYYY @ HH:mm", u = Bn(
    () => () => l ? Ln(l).format(m) : d ? Ln.unix(d).format(m) : null,
    [d, l]
  )(), f = s === "EMAIL", h = s === "SMS", g = f && e.opened, C = f && e.clicked, S = f && o?.event_properties.Subject, N = h && o?.event_properties["Message Name"], w = f ? "mail" : "sms";
  return /* @__PURE__ */ Ce.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      className: it(ea.message, {
        [ea.messageIsOpen]: i
      }),
      children: [
        /* @__PURE__ */ Ce.jsxs(
          b,
          {
            alignItems: "center",
            justifyContent: "space-between",
            className: ea.messageHeader,
            onClick: () => a(!i),
            children: [
              /* @__PURE__ */ Ce.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ Ce.jsxs(b, { gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ Ce.jsx(pe, { size: 16, name: w }),
                  " ",
                  v$(s),
                  u && /* @__PURE__ */ Ce.jsx(An, { size: "small", variant: "info", children: u })
                ] }),
                S && S,
                N && N
              ] }),
              /* @__PURE__ */ Ce.jsx(
                nr,
                {
                  variant: "tertiary",
                  icon: i ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        i && /* @__PURE__ */ Ce.jsxs(b, { flexDirection: "column", gap: "300", children: [
          /* @__PURE__ */ Ce.jsx(qm, {}),
          c$(e) && /* @__PURE__ */ Ce.jsx(b, { children: /* @__PURE__ */ Ce.jsx(An, { size: "medium", variant: "error", children: "Bounced" }) }),
          f && /* @__PURE__ */ Ce.jsxs(Ce.Fragment, { children: [
            /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
              /* @__PURE__ */ Ce.jsx(Pn, { children: /* @__PURE__ */ Ce.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ Ce.jsx(
                  pe,
                  {
                    size: 16,
                    color: g ? "green.400" : "red.400",
                    name: g ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Opened"
              ] }) }),
              /* @__PURE__ */ Ce.jsx(Pn, { children: /* @__PURE__ */ Ce.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ Ce.jsx(
                  pe,
                  {
                    size: 16,
                    color: C ? "green.400" : "red.400",
                    name: C ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Clicked"
              ] }) })
            ] }),
            /* @__PURE__ */ Ce.jsx(P$, { event: e, isLoadingPreview: n })
          ] }),
          h && /* @__PURE__ */ Ce.jsx(L$, { event: e })
        ] })
      ]
    }
  );
}, z$ = {
  /*
  	Compiler needs this casting so as not to complain that the string literal 'no-cache'
  	is actually of type "FetchPolicy", which type is defined as one of many string values,
  	including 'no-cache'.
  */
  fetchPolicy: "no-cache",
  notifyOnNetworkStatusChange: !0
}, U$ = ({
  profileId: e,
  noOfMessagesToShow: n
}) => {
  const [r, i] = le(!1), {
    receivedMessages: a,
    isLoading: o,
    error: s
  } = x$({
    profileId: e,
    noOfMessagesToShow: n
  }), [l, d] = zT({
    query: n$,
    options: z$,
    delayMs: 1e3
  }), [m, u] = le([]);
  He(() => {
    if (a.length > 0) {
      u(a);
      const h = a.filter((g) => vm(g)).map((g) => hv(g));
      h.length > 0 && (i(!0), l(
        h.map((g) => ({
          messageId: g
        }))
      ).finally(() => i(!1)));
    }
  }, [a]), He(() => {
    d.length > 0 && u(
      a?.map((h) => {
        if (h.eventType === "EMAIL" && vm(h) && !h.flowMessage) {
          const g = hv(h), C = d.find((N) => (N.data && gv(N.data))?.id === g), S = C?.data && gv(C.data);
          if (S)
            return {
              ...g$(h),
              flowMessage: S
            };
        }
        return h;
      })
    );
  }, [d]);
  const f = [];
  return s && f.push(s), d.length > 0 && f.push(
    ...d.map((h) => h.error).filter((h) => h)
  ), f && f.length > 0 ? /* @__PURE__ */ Ce.jsx(Ce.Fragment, { children: f.map((h, g) => h.graphQLErrors ? /* @__PURE__ */ Ce.jsx(
    Fn,
    {
      error: h
    },
    `lastMessagesError${g}`
  ) : /* @__PURE__ */ Ce.jsx(
    ll,
    {
      error: h
    },
    `lastMessagesError${g}`
  )) }) : /* @__PURE__ */ Ce.jsxs(Ce.Fragment, { children: [
    /* @__PURE__ */ Ce.jsx(P.Heading, { variant: "heading-3", children: "Messages" }),
    o ? /* @__PURE__ */ Ce.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ Ce.jsx(un, {}) }) : /* @__PURE__ */ Ce.jsx(Ce.Fragment, { children: m?.length > 0 ? /* @__PURE__ */ Ce.jsx(b, { gap: "200", flexDirection: "column", children: m.map((h, g) => /* @__PURE__ */ Ce.jsx(
      V$,
      {
        event: h,
        isLoadingPreview: r,
        openByDefault: g === 0
      },
      h.id
    )) }) : /* @__PURE__ */ Ce.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200",
        className: Fp.notificationText,
        children: "No messages found for the profile"
      }
    ) })
  ] });
}, M$ = "_list_ld0hf_1", B$ = "_listItem_ld0hf_4", Kr = {
  list: M$,
  listItem: B$
}, q$ = ({
  profile: e
}) => {
  const n = e?.data?.attributes?.properties, r = Object.entries(
    n ?? {}
  ).filter(([a, o]) => a !== "__typename" && o != null), i = r.length > 0;
  return /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ce.jsx(P.Heading, { variant: "heading-3", children: "Custom properties" }),
    !i && /* @__PURE__ */ Ce.jsx(P.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom properties available" }),
    i && /* @__PURE__ */ Ce.jsx(Ye, { className: Kr.list, children: r.map(([a, o]) => typeof o == "boolean" || typeof o == "string" || typeof o == "number" || Array.isArray(o) && o.every((s) => typeof s == "string") ? /* @__PURE__ */ Ce.jsx(Ye.Text, { variant: "dense", className: Kr.listItem, children: /* @__PURE__ */ Ce.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: "200",
        children: [
          /* @__PURE__ */ Ce.jsx(P.Paragraph, { variant: "4", children: h0(a) }),
          /* @__PURE__ */ Ce.jsx(
            b,
            {
              style: { flex: 1, minWidth: 0 },
              justifyContent: "flex-end",
              children: po(o)
            }
          )
        ]
      }
    ) }, a) : null) })
  ] });
}, kv = ({
  profileId: e,
  type: n
}) => {
  const [r, i] = le(!1), {
    listsOrSegments: a,
    error: o,
    isLoading: s,
    networkStatus: l,
    refetchListOrSegments: d
  } = E$({ profileId: e, query: n });
  He(() => {
    l === 4 && i(!0);
  }, [l]);
  const m = () => {
    a || d();
  }, u = a || [];
  return o ? /* @__PURE__ */ Ce.jsx(ll, { error: o }) : s ? /* @__PURE__ */ Ce.jsx(Ye.Text, { variant: "dense", className: Kr.listItem, children: /* @__PURE__ */ Ce.jsx(un, { size: 14 }) }, "loading") : u.length > 0 ? /* @__PURE__ */ Ce.jsx(Ce.Fragment, { children: u.map(
    ({ attributes: f, type: h }, g) => /* @__PURE__ */ Ce.jsx(Ye.Text, { variant: "dense", className: Kr.listItem, children: /* @__PURE__ */ Ce.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ Ce.jsx(P.Paragraph, { variant: "4", children: f?.name }),
      !!h && /* @__PURE__ */ Ce.jsx(Pn, { children: Gb(h) })
    ] }) }, g)
  ) }) : r && !a ? /* @__PURE__ */ Ce.jsx(Ye.Text, { variant: "dense", className: Kr.listItem, children: /* @__PURE__ */ Ce.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ Ce.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ Ce.jsx(pe, { name: "exclamation-triangle-filled", color: "red" }),
      /* @__PURE__ */ Ce.jsxs(P.Paragraph, { variant: "4", color: "red.500", children: [
        n === "lists" ? "Lists" : "Segments",
        " could not be loaded"
      ] })
    ] }),
    /* @__PURE__ */ Ce.jsx(We, { content: "Refresh lists and segments", children: /* @__PURE__ */ Ce.jsx(Gn, { icon: "sync", variant: "secondary", onClick: () => m(), children: "Retry" }) })
  ] }) }, "refetch") : /* @__PURE__ */ Ce.jsx(Ye.Text, { variant: "dense", className: Kr.listItem, children: /* @__PURE__ */ Ce.jsx(b, { justifyContent: "space-between", alignItems: "center", children: /* @__PURE__ */ Ce.jsx(P.Paragraph, { variant: "4", subdued: !0, children: /* @__PURE__ */ Ce.jsx("i", { children: `No ${n === "lists" ? "lists" : "segments"} available` }) }) }) }, "refetch");
}, H$ = 0.7, W$ = 0.3, G$ = (e) => e >= H$ ? { variant: "error", label: "High risk" } : e >= W$ ? { variant: "warning", label: "Medium risk" } : { variant: "success", label: "Low risk" }, K$ = (e) => /* @__PURE__ */ Ce.jsx(P.Paragraph, { as: "span", variant: "4", children: e.toFixed(2) }), Y$ = (e) => {
  const n = G$(e);
  return /* @__PURE__ */ Ce.jsxs(b, { alignItems: "center", gap: "100", children: [
    /* @__PURE__ */ Ce.jsx(An, { size: "small", variant: n.variant, children: n.label }),
    /* @__PURE__ */ Ce.jsx(P.Paragraph, { as: "span", variant: "4", children: `${(e * 100).toFixed(1)}%` })
  ] });
}, Q$ = (e) => {
  const n = e?.data?.attributes?.predictive_analytics ?? null;
  if (!n)
    return [];
  const r = [
    ["Average order value", n.average_order_value],
    ["Historic lifetime value", n.historic_clv],
    ["Predicted lifetime value", n.predicted_clv],
    ["Total lifetime value", n.total_clv]
  ], i = [
    ["Historic orders", n.historic_number_of_orders],
    ["Predicted orders", n.predicted_number_of_orders],
    [
      "Average days between orders",
      n.average_days_between_orders
    ],
    ["Expected next order", n.expected_date_of_next_order]
  ], a = n.churn_probability, o = n.ranked_channel_affinity?.filter(Boolean) ?? null;
  return [
    ...r.flatMap(
      ([s, l]) => l ? [{ label: s, content: K$(l) }] : []
    ),
    ...i.flatMap(
      ([s, l]) => l ? [{ label: s, content: po(l) }] : []
    ),
    ...a ? [
      {
        label: "Churn probability",
        content: Y$(a)
      }
    ] : [],
    ...o?.length ? [
      {
        label: "Channel affinity",
        content: po(o)
      }
    ] : []
  ];
}, J$ = ({
  profile: e
}) => {
  const n = Q$(e);
  return /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ce.jsx(P.Heading, { variant: "heading-3", children: "Predictive analytics" }),
    n.length === 0 && /* @__PURE__ */ Ce.jsx(P.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No predictive analytics available" }),
    n.length > 0 && /* @__PURE__ */ Ce.jsx(Ye, { className: Kr.list, children: n.map(({ label: r, content: i }) => /* @__PURE__ */ Ce.jsx(Ye.Text, { variant: "dense", className: Kr.listItem, children: /* @__PURE__ */ Ce.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        gap: "200",
        children: [
          /* @__PURE__ */ Ce.jsx(P.Paragraph, { as: "span", variant: "4", children: r }),
          i
        ]
      }
    ) }, r)) })
  ] });
}, X$ = "_tagHover_kzbzk_1", Z$ = "_channelUnsubscribed_kzbzk_6", bv = {
  tagHover: X$,
  channelUnsubscribed: Z$
}, xv = ({
  isSubscribed: e,
  isLoading: n,
  channelName: r,
  channelIcon: i,
  hasReSubscriptionFeature: a,
  handleAction: o
}) => {
  const s = e ? "Unsubscribe" : "Subscribe", l = !e && !a;
  return /* @__PURE__ */ Ce.jsx(
    We,
    {
      content: l ? "You have to select a resubscription list in the settings." : s,
      children: /* @__PURE__ */ Ce.jsx(
        Pn,
        {
          className: bv.tagHover,
          color: e ? "green.500" : "neutral.200",
          children: /* @__PURE__ */ Ce.jsxs(
            b,
            {
              "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
              gap: "200",
              alignItems: "center",
              className: it({
                [bv.channelUnsubscribed]: !e || l
              }),
              onClick: () => {
                l || o();
              },
              children: [
                n ? /* @__PURE__ */ Ce.jsx(un, { size: 16 }) : /* @__PURE__ */ Ce.jsx(pe, { size: 16, name: i }),
                r
              ]
            }
          )
        }
      )
    }
  );
}, eD = "_subscriptionError_1qhhx_1", nD = {
  subscriptionError: eD
}, tD = ({
  subscriptionListId: e,
  profile: n,
  email: r,
  phoneNumber: i,
  profileId: a,
  refetchProfile: o
}) => {
  const [s, l] = le(!1), [d, m] = le(!1), [u, f] = le(), { track: h } = _n(), [g, C] = lC({
    channel: null,
    request: null
  }), S = k$(n), N = b$(n), w = !!e, { useMutation: y } = hn(), [z] = y(
    s$
  ), [$] = y(
    l$
  ), I = (Q) => {
    h("klaviyo:profile:subscribe:clicked", { channel: Q }), C.setAll({
      channel: Q,
      request: "subscribed"
    }), ((J) => z({
      variables: {
        attributes: {
          // eslint-disable-next-line camelcase
          custom_source: "Dixa integration",
          profiles: {
            data: [
              {
                type: hm.Profile,
                id: a,
                attributes: {
                  email: r,
                  // eslint-disable-next-line camelcase
                  ...i ? { phone_number: i } : {},
                  subscriptions: {
                    ...J === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: ym.Subscribed
                        }
                      }
                    },
                    ...J === "SMS" && {
                      sms: {
                        marketing: {
                          consent: ym.Subscribed
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        },
        relationships: {
          list: {
            data: {
              type: w_.List,
              id: e
            }
          }
        }
      }
    }))(Q).then(
      (J) => U({
        channel: Q,
        mutationResponse: J,
        isSubscriptionRequest: !0
      })
    ).catch(
      (J) => U({
        channel: Q,
        mutationErrorResponse: J,
        isSubscriptionRequest: !0
      })
    );
  }, T = (Q) => {
    h("klaviyo:profile:unsubscribe:clicked", { channel: Q }), C.setAll({
      channel: Q,
      request: "unsubscribed"
    }), $({
      variables: {
        attributes: {
          profiles: {
            data: [
              {
                type: hm.Profile,
                attributes: {
                  ...Q === "EMAIL" ? { email: r } : {},
                  // eslint-disable-next-line camelcase
                  ...Q === "SMS" ? { phone_number: i } : {},
                  subscriptions: {
                    ...Q === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: gm.Unsubscribed
                        }
                      }
                    },
                    ...Q === "SMS" && {
                      sms: {
                        marketing: {
                          consent: gm.Unsubscribed
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        }
      }
    }).then(
      (J) => U({
        channel: Q,
        mutationResponse: J,
        isSubscriptionRequest: !1
      })
    ).catch(
      (J) => U({
        channel: Q,
        mutationErrorResponse: J,
        isSubscriptionRequest: !1
      })
    );
  }, U = async ({
    channel: Q,
    mutationResponse: J,
    mutationErrorResponse: ae,
    isSubscriptionRequest: X
  }) => {
    const B = ae?.networkError, O = B ? B?.statusCode : NaN, q = J?.errors, ee = !!q && Kb({
      errors: q
    });
    O === 202 ? (h(
      X ? "klaviyo:profile:subscribe:succeeded" : "klaviyo:profile:unsubscribe:succeeded",
      { channel: Q }
    ), await o()) : ee ? (h(
      X ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: Q,
        reason: "Insufficient permissions"
      }
    ), f(
      `Request failed with a permission error. Could not ${X ? "opt-in" : "opt-out"}.`
    )) : (h(
      X ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: Q,
        reason: B?.message || "Unexpected error"
      }
    ), f(
      `Request failed. Could not ${X ? "opt-in" : "opt-out"}.`
    )), m(!1), l(!1);
  };
  return He(() => {
    if (g.request === "subscribed") {
      const Q = `This subscription might be a double opt-in. The customer needs to check if they received a confirmation ${g.channel === "EMAIL" ? "email" : "sms"} to give consent.`;
      g.channel === "EMAIL" && !s && n?.data?.attributes?.subscriptions?.email?.marketing?.consent !== "SUBSCRIBED" && (f(Q), C.reset()), g.channel === "SMS" && !d && n?.data?.attributes?.subscriptions?.sms?.marketing?.consent !== "SUBSCRIBED" && (f(Q), C.reset());
    }
  }, [
    n?.data?.attributes?.subscriptions?.email?.marketing?.consent,
    n?.data?.attributes?.subscriptions?.sms?.marketing?.consent,
    s,
    d
  ]), /* @__PURE__ */ Ce.jsx(
    b,
    {
      "data-testid": "subscription-channels",
      gap: "200",
      flexDirection: "column",
      children: /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ Ce.jsx(P.Heading, { variant: "heading-3", children: "Subscription channels" }),
        /* @__PURE__ */ Ce.jsxs(b, { gap: "100", flexDirection: "row", children: [
          /* @__PURE__ */ Ce.jsx(
            xv,
            {
              "data-testid": "subscription-channels-email-button",
              isLoading: s,
              isSubscribed: S,
              channelName: "Email",
              channelIcon: "mail",
              hasReSubscriptionFeature: w,
              handleAction: () => {
                l(!0), f(void 0), S ? T("EMAIL") : I("EMAIL");
              }
            }
          ),
          /* @__PURE__ */ Ce.jsx(
            xv,
            {
              "data-testid": "subscription-channels-sms-button",
              isLoading: d,
              isSubscribed: N,
              channelName: "Sms",
              channelIcon: "sms",
              hasReSubscriptionFeature: w,
              handleAction: () => {
                m(!0), f(void 0), N ? T("SMS") : I("SMS");
              }
            }
          )
        ] }),
        u && /* @__PURE__ */ Ce.jsx(b, { className: nD.subscriptionError, children: u })
      ] })
    }
  );
}, rD = ({
  profileId: e,
  email: n,
  phoneNumber: r,
  showProfileLists: i,
  showProfileSegments: a,
  showSubscriptions: o,
  showCustomProperties: s,
  showPredictiveAnalytics: l,
  noOfMessagesToShow: d,
  subscriptionListId: m
}) => {
  const {
    profile: u,
    error: f,
    isLoading: h,
    refetchProfile: g
  } = _$({ profileId: e });
  return f ? /* @__PURE__ */ Ce.jsx(ll, { error: f }) : h ? /* @__PURE__ */ Ce.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ Ce.jsx(un, {}) }) : !u && !h ? /* @__PURE__ */ Ce.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200",
      className: Fp.notificationText,
      children: "No Klaviyo profile data found"
    }
  ) : /* @__PURE__ */ Ce.jsxs(b, { flexDirection: "column", gap: "300", margin: "200 0 300", children: [
    (i || a) && /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ Ce.jsx(P.Heading, { variant: "heading-3", children: "Lists & Segments" }),
      /* @__PURE__ */ Ce.jsxs(Ye, { className: Kr.list, children: [
        i && /* @__PURE__ */ Ce.jsx(kv, { profileId: e, type: "lists" }),
        a && /* @__PURE__ */ Ce.jsx(
          kv,
          {
            profileId: e,
            type: "segments"
          }
        )
      ] })
    ] }),
    u && e && o && /* @__PURE__ */ Ce.jsx(
      tD,
      {
        profile: u,
        profileId: e,
        subscriptionListId: m,
        refetchProfile: g,
        email: n,
        phoneNumber: r
      }
    ),
    u && l && /* @__PURE__ */ Ce.jsx(J$, { profile: u }),
    u && s && /* @__PURE__ */ Ce.jsx(q$, { profile: u }),
    /* @__PURE__ */ Ce.jsx(
      U$,
      {
        profileId: e,
        noOfMessagesToShow: d
      }
    )
  ] });
}, iD = ({
  conversationContext: e,
  settings: n
}) => {
  const r = e.customer?.email || void 0, i = e.customer?.phone_number || void 0, a = n?.showProfileLists, o = n?.showProfileSegments, s = n?.showSubscriptions, l = n?.showCustomProperties, d = n?.showPredictiveAnalytics, m = Number(n?.noOfMessagesToShow), u = n?.subscriptionListId, {
    profileId: f,
    getProfileId: h,
    isLoading: g,
    error: C
  } = S$({ email: r, phoneNumber: i });
  return j0(() => {
    (r || i) && h({
      variables: {
        emailFilter: r ? `equals(email,"${r}")` : void 0,
        phoneNumberFilter: i ? `equals(phone_number,"${i}")` : void 0,
        hasEmail: !!r,
        hasPhoneNumber: !!i
      }
    });
  }, [r, i]), !r && !i ? /* @__PURE__ */ Ce.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: "The customer does not have an email nor a phone number" }) : g ? /* @__PURE__ */ Ce.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ Ce.jsx(un, {}) }) : C ? /* @__PURE__ */ Ce.jsx(ll, { error: C }) : f ? /* @__PURE__ */ Ce.jsx(
    rD,
    {
      profileId: f,
      email: r,
      phoneNumber: i,
      showProfileLists: a,
      showProfileSegments: o,
      showSubscriptions: s,
      showCustomProperties: l,
      showPredictiveAnalytics: d,
      noOfMessagesToShow: m,
      subscriptionListId: u
    }
  ) : /* @__PURE__ */ Ce.jsx(
    b,
    {
      justifyContent: "center",
      margin: "0 0 300 0",
      className: Fp.notificationText,
      children: "No profile ID found"
    }
  );
}, aD = [
  {
    key: "showProfileLists",
    label: "Show Klaviyo lists for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showProfileSegments",
    label: "Show Klaviyo segments for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showSubscriptions",
    label: "Show subscription channels for Klaviyo messages",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showCustomProperties",
    label: "Show custom properties for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showPredictiveAnalytics",
    label: "Show predictive analytics for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "subscriptionListId",
    label: "Activate re-/subscription list selection",
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "subscriptionListComponent",
    label: "Select a list to subscribe to",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: p0
  },
  {
    key: "noOfMessagesToShow",
    label: "Choose how many messages to show",
    required: !0,
    secret: !1,
    type: "select",
    defaultValue: "5",
    selectItems: [
      { value: "3", label: "The three latest messages" },
      { value: "4", label: "The four latest messages" },
      { value: "5", label: "The five latest messages" }
    ]
  }
], oD = [
  /**
   * The store ID will be fetched through the OAuth flow, so there's no real
   * reason to show it
   */
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Lr
  }
], sD = [
  {
    key: "klaviyoApiKey",
    label: "API key",
    placeholder: "API key from Klaviyo",
    required: !0,
    secret: !0,
    type: "input"
  }
];
function lD(e, n) {
  const r = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (r.padRight ? " " : "") + "," + (r.padLeft === !1 ? "" : " ")
  ).trim();
}
const cD = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, dD = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, uD = {};
function _v(e, n) {
  return (uD.jsx ? dD : cD).test(e);
}
const mD = /[ \t\n\f\r]/g;
function pD(e) {
  return typeof e == "object" ? e.type === "text" ? Sv(e.value) : !1 : Sv(e);
}
function Sv(e) {
  return e.replace(mD, "") === "";
}
class Co {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(n, r, i) {
    this.property = n, this.normal = r, i && (this.space = i);
  }
}
Co.prototype.property = {};
Co.prototype.normal = {};
Co.prototype.space = null;
function C_(e, n) {
  const r = {}, i = {};
  let a = -1;
  for (; ++a < e.length; )
    Object.assign(r, e[a].property), Object.assign(i, e[a].normal);
  return new Co(r, i, n);
}
function km(e) {
  return e.toLowerCase();
}
class hr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(n, r) {
    this.property = n, this.attribute = r;
  }
}
hr.prototype.space = null;
hr.prototype.boolean = !1;
hr.prototype.booleanish = !1;
hr.prototype.overloadedBoolean = !1;
hr.prototype.number = !1;
hr.prototype.commaSeparated = !1;
hr.prototype.spaceSeparated = !1;
hr.prototype.commaOrSpaceSeparated = !1;
hr.prototype.mustUseProperty = !1;
hr.prototype.defined = !1;
let fD = 0;
const In = Ai(), yt = Ai(), F_ = Ai(), Ue = Ai(), Zn = Ai(), na = Ai(), tr = Ai();
function Ai() {
  return 2 ** ++fD;
}
const bm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: In,
  booleanish: yt,
  commaOrSpaceSeparated: tr,
  commaSeparated: na,
  number: Ue,
  overloadedBoolean: F_,
  spaceSeparated: Zn
}, Symbol.toStringTag, { value: "Module" })), yu = Object.keys(bm);
class Ip extends hr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(n, r, i, a) {
    let o = -1;
    if (super(n, r), Nv(this, "space", a), typeof i == "number")
      for (; ++o < yu.length; ) {
        const s = yu[o];
        Nv(this, yu[o], (i & bm[s]) === bm[s]);
      }
  }
}
Ip.prototype.defined = !0;
function Nv(e, n, r) {
  r && (e[n] = r);
}
const hD = {}.hasOwnProperty;
function fa(e) {
  const n = {}, r = {};
  let i;
  for (i in e.properties)
    if (hD.call(e.properties, i)) {
      const a = e.properties[i], o = new Ip(
        i,
        e.transform(e.attributes || {}, i),
        a,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(i) && (o.mustUseProperty = !0), n[i] = o, r[km(i)] = i, r[km(o.attribute)] = i;
    }
  return new Co(n, r, e.space);
}
const I_ = fa({
  space: "xlink",
  transform(e, n) {
    return "xlink:" + n.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), E_ = fa({
  space: "xml",
  transform(e, n) {
    return "xml:" + n.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function T_(e, n) {
  return n in e ? e[n] : n;
}
function $_(e, n) {
  return T_(e, n.toLowerCase());
}
const D_ = fa({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: $_,
  properties: { xmlns: null, xmlnsXLink: null }
}), R_ = fa({
  transform(e, n) {
    return n === "role" ? n : "aria-" + n.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: yt,
    ariaAutoComplete: null,
    ariaBusy: yt,
    ariaChecked: yt,
    ariaColCount: Ue,
    ariaColIndex: Ue,
    ariaColSpan: Ue,
    ariaControls: Zn,
    ariaCurrent: null,
    ariaDescribedBy: Zn,
    ariaDetails: null,
    ariaDisabled: yt,
    ariaDropEffect: Zn,
    ariaErrorMessage: null,
    ariaExpanded: yt,
    ariaFlowTo: Zn,
    ariaGrabbed: yt,
    ariaHasPopup: null,
    ariaHidden: yt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: Zn,
    ariaLevel: Ue,
    ariaLive: null,
    ariaModal: yt,
    ariaMultiLine: yt,
    ariaMultiSelectable: yt,
    ariaOrientation: null,
    ariaOwns: Zn,
    ariaPlaceholder: null,
    ariaPosInSet: Ue,
    ariaPressed: yt,
    ariaReadOnly: yt,
    ariaRelevant: null,
    ariaRequired: yt,
    ariaRoleDescription: Zn,
    ariaRowCount: Ue,
    ariaRowIndex: Ue,
    ariaRowSpan: Ue,
    ariaSelected: yt,
    ariaSetSize: Ue,
    ariaSort: null,
    ariaValueMax: Ue,
    ariaValueMin: Ue,
    ariaValueNow: Ue,
    ariaValueText: null,
    role: null
  }
}), yD = fa({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: $_,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: na,
    acceptCharset: Zn,
    accessKey: Zn,
    action: null,
    allow: null,
    allowFullScreen: In,
    allowPaymentRequest: In,
    allowUserMedia: In,
    alt: null,
    as: null,
    async: In,
    autoCapitalize: null,
    autoComplete: Zn,
    autoFocus: In,
    autoPlay: In,
    blocking: Zn,
    capture: null,
    charSet: null,
    checked: In,
    cite: null,
    className: Zn,
    cols: Ue,
    colSpan: null,
    content: null,
    contentEditable: yt,
    controls: In,
    controlsList: Zn,
    coords: Ue | na,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: In,
    defer: In,
    dir: null,
    dirName: null,
    disabled: In,
    download: F_,
    draggable: yt,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: In,
    formTarget: null,
    headers: Zn,
    height: Ue,
    hidden: In,
    high: Ue,
    href: null,
    hrefLang: null,
    htmlFor: Zn,
    httpEquiv: Zn,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: In,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: In,
    itemId: null,
    itemProp: Zn,
    itemRef: Zn,
    itemScope: In,
    itemType: Zn,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: In,
    low: Ue,
    manifest: null,
    max: null,
    maxLength: Ue,
    media: null,
    method: null,
    min: null,
    minLength: Ue,
    multiple: In,
    muted: In,
    name: null,
    nonce: null,
    noModule: In,
    noValidate: In,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: In,
    optimum: Ue,
    pattern: null,
    ping: Zn,
    placeholder: null,
    playsInline: In,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: In,
    referrerPolicy: null,
    rel: Zn,
    required: In,
    reversed: In,
    rows: Ue,
    rowSpan: Ue,
    sandbox: Zn,
    scope: null,
    scoped: In,
    seamless: In,
    selected: In,
    shadowRootClonable: In,
    shadowRootDelegatesFocus: In,
    shadowRootMode: null,
    shape: null,
    size: Ue,
    sizes: null,
    slot: null,
    span: Ue,
    spellCheck: yt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: Ue,
    step: null,
    style: null,
    tabIndex: Ue,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: In,
    useMap: null,
    value: yt,
    width: Ue,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: Zn,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: Ue,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: Ue,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: In,
    // Lists. Use CSS to reduce space between items instead
    declare: In,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: Ue,
    // `<img>` and `<object>`
    leftMargin: Ue,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: Ue,
    // `<body>`
    marginWidth: Ue,
    // `<body>`
    noResize: In,
    // `<frame>`
    noHref: In,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: In,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: In,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: Ue,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: yt,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: Ue,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: Ue,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: In,
    disableRemotePlayback: In,
    prefix: null,
    property: null,
    results: Ue,
    security: null,
    unselectable: null
  }
}), gD = fa({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: T_,
  properties: {
    about: tr,
    accentHeight: Ue,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: Ue,
    amplitude: Ue,
    arabicForm: null,
    ascent: Ue,
    attributeName: null,
    attributeType: null,
    azimuth: Ue,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: Ue,
    by: null,
    calcMode: null,
    capHeight: Ue,
    className: Zn,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: Ue,
    diffuseConstant: Ue,
    direction: null,
    display: null,
    dur: null,
    divisor: Ue,
    dominantBaseline: null,
    download: In,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: Ue,
    enableBackground: null,
    end: null,
    event: null,
    exponent: Ue,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: Ue,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: na,
    g2: na,
    glyphName: na,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: Ue,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: Ue,
    horizOriginX: Ue,
    horizOriginY: Ue,
    id: null,
    ideographic: Ue,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: Ue,
    k: Ue,
    k1: Ue,
    k2: Ue,
    k3: Ue,
    k4: Ue,
    kernelMatrix: tr,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: Ue,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: Ue,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: Ue,
    overlineThickness: Ue,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: Ue,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: Zn,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: Ue,
    pointsAtY: Ue,
    pointsAtZ: Ue,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: tr,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: tr,
    rev: tr,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: tr,
    requiredFeatures: tr,
    requiredFonts: tr,
    requiredFormats: tr,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: Ue,
    specularExponent: Ue,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: Ue,
    strikethroughThickness: Ue,
    string: null,
    stroke: null,
    strokeDashArray: tr,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: Ue,
    strokeOpacity: Ue,
    strokeWidth: null,
    style: null,
    surfaceScale: Ue,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: tr,
    tabIndex: Ue,
    tableValues: null,
    target: null,
    targetX: Ue,
    targetY: Ue,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: tr,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: Ue,
    underlineThickness: Ue,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: Ue,
    values: null,
    vAlphabetic: Ue,
    vMathematical: Ue,
    vectorEffect: null,
    vHanging: Ue,
    vIdeographic: Ue,
    version: null,
    vertAdvY: Ue,
    vertOriginX: Ue,
    vertOriginY: Ue,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: Ue,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), vD = /^data[-\w.:]+$/i, jv = /-[a-z]/g, kD = /[A-Z]/g;
function bD(e, n) {
  const r = km(n);
  let i = n, a = hr;
  if (r in e.normal)
    return e.property[e.normal[r]];
  if (r.length > 4 && r.slice(0, 4) === "data" && vD.test(n)) {
    if (n.charAt(4) === "-") {
      const o = n.slice(5).replace(jv, _D);
      i = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = n.slice(4);
      if (!jv.test(o)) {
        let s = o.replace(kD, xD);
        s.charAt(0) !== "-" && (s = "-" + s), n = "data" + s;
      }
    }
    a = Ip;
  }
  return new a(i, n);
}
function xD(e) {
  return "-" + e.toLowerCase();
}
function _D(e) {
  return e.charAt(1).toUpperCase();
}
const SD = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, ND = C_([E_, I_, D_, R_, yD], "html"), Ep = C_([E_, I_, D_, R_, gD], "svg");
function jD(e) {
  return e.join(" ").trim();
}
var zi = {}, gu, wv;
function wD() {
  if (wv) return gu;
  wv = 1;
  var e = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, n = /\n/g, r = /^\s*/, i = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, a = /^:\s*/, o = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, s = /^[;\s]*/, l = /^\s+|\s+$/g, d = `
`, m = "/", u = "*", f = "", h = "comment", g = "declaration";
  gu = function(S, N) {
    if (typeof S != "string")
      throw new TypeError("First argument must be a string");
    if (!S) return [];
    N = N || {};
    var w = 1, y = 1;
    function z(O) {
      var q = O.match(n);
      q && (w += q.length);
      var ee = O.lastIndexOf(d);
      y = ~ee ? O.length - ee : y + O.length;
    }
    function $() {
      var O = { line: w, column: y };
      return function(q) {
        return q.position = new I(O), Q(), q;
      };
    }
    function I(O) {
      this.start = O, this.end = { line: w, column: y }, this.source = N.source;
    }
    I.prototype.content = S;
    function T(O) {
      var q = new Error(
        N.source + ":" + w + ":" + y + ": " + O
      );
      if (q.reason = O, q.filename = N.source, q.line = w, q.column = y, q.source = S, !N.silent) throw q;
    }
    function U(O) {
      var q = O.exec(S);
      if (q) {
        var ee = q[0];
        return z(ee), S = S.slice(ee.length), q;
      }
    }
    function Q() {
      U(r);
    }
    function J(O) {
      var q;
      for (O = O || []; q = ae(); )
        q !== !1 && O.push(q);
      return O;
    }
    function ae() {
      var O = $();
      if (!(m != S.charAt(0) || u != S.charAt(1))) {
        for (var q = 2; f != S.charAt(q) && (u != S.charAt(q) || m != S.charAt(q + 1)); )
          ++q;
        if (q += 2, f === S.charAt(q - 1))
          return T("End of comment missing");
        var ee = S.slice(2, q - 2);
        return y += 2, z(ee), S = S.slice(q), y += 2, O({
          type: h,
          comment: ee
        });
      }
    }
    function X() {
      var O = $(), q = U(i);
      if (q) {
        if (ae(), !U(a)) return T("property missing ':'");
        var ee = U(o), ve = O({
          type: g,
          property: C(q[0].replace(e, f)),
          value: ee ? C(ee[0].replace(e, f)) : f
        });
        return U(s), ve;
      }
    }
    function B() {
      var O = [];
      J(O);
      for (var q; q = X(); )
        q !== !1 && (O.push(q), J(O));
      return O;
    }
    return Q(), B();
  };
  function C(S) {
    return S ? S.replace(l, f) : f;
  }
  return gu;
}
var Cv;
function CD() {
  if (Cv) return zi;
  Cv = 1;
  var e = zi && zi.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(zi, "__esModule", { value: !0 }), zi.default = r;
  var n = e(wD());
  function r(i, a) {
    var o = null;
    if (!i || typeof i != "string")
      return o;
    var s = (0, n.default)(i), l = typeof a == "function";
    return s.forEach(function(d) {
      if (d.type === "declaration") {
        var m = d.property, u = d.value;
        l ? a(m, u, d) : u && (o = o || {}, o[m] = u);
      }
    }), o;
  }
  return zi;
}
var FD = CD();
const Fv = /* @__PURE__ */ Gm(FD), ID = Fv.default || Fv, O_ = A_("end"), Tp = A_("start");
function A_(e) {
  return n;
  function n(r) {
    const i = r && r.position && r.position[e] || {};
    if (typeof i.line == "number" && i.line > 0 && typeof i.column == "number" && i.column > 0)
      return {
        line: i.line,
        column: i.column,
        offset: typeof i.offset == "number" && i.offset > -1 ? i.offset : void 0
      };
  }
}
function ED(e) {
  const n = Tp(e), r = O_(e);
  if (n && r)
    return { start: n, end: r };
}
function io(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? Iv(e.position) : "start" in e || "end" in e ? Iv(e) : "line" in e || "column" in e ? xm(e) : "";
}
function xm(e) {
  return Ev(e && e.line) + ":" + Ev(e && e.column);
}
function Iv(e) {
  return xm(e && e.start) + "-" + xm(e && e.end);
}
function Ev(e) {
  return e && typeof e == "number" ? e : 1;
}
class Pt extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(n, r, i) {
    super(), typeof r == "string" && (i = r, r = void 0);
    let a = "", o = {}, s = !1;
    if (r && ("line" in r && "column" in r ? o = { place: r } : "start" in r && "end" in r ? o = { place: r } : "type" in r ? o = {
      ancestors: [r],
      place: r.position
    } : o = { ...r }), typeof n == "string" ? a = n : !o.cause && n && (s = !0, a = n.message, o.cause = n), !o.ruleId && !o.source && typeof i == "string") {
      const d = i.indexOf(":");
      d === -1 ? o.ruleId = i : (o.source = i.slice(0, d), o.ruleId = i.slice(d + 1));
    }
    if (!o.place && o.ancestors && o.ancestors) {
      const d = o.ancestors[o.ancestors.length - 1];
      d && (o.place = d.position);
    }
    const l = o.place && "start" in o.place ? o.place.start : o.place;
    this.ancestors = o.ancestors || void 0, this.cause = o.cause || void 0, this.column = l ? l.column : void 0, this.fatal = void 0, this.file, this.message = a, this.line = l ? l.line : void 0, this.name = io(o.place) || "1:1", this.place = o.place || void 0, this.reason = this.message, this.ruleId = o.ruleId || void 0, this.source = o.source || void 0, this.stack = s && o.cause && typeof o.cause.stack == "string" ? o.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
Pt.prototype.file = "";
Pt.prototype.name = "";
Pt.prototype.reason = "";
Pt.prototype.message = "";
Pt.prototype.stack = "";
Pt.prototype.column = void 0;
Pt.prototype.line = void 0;
Pt.prototype.ancestors = void 0;
Pt.prototype.cause = void 0;
Pt.prototype.fatal = void 0;
Pt.prototype.place = void 0;
Pt.prototype.ruleId = void 0;
Pt.prototype.source = void 0;
const $p = {}.hasOwnProperty, TD = /* @__PURE__ */ new Map(), $D = /[A-Z]/g, DD = /-([a-z])/g, RD = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), OD = /* @__PURE__ */ new Set(["td", "th"]), P_ = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function AD(e, n) {
  if (!n || n.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const r = n.filePath || void 0;
  let i;
  if (n.development) {
    if (typeof n.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    i = qD(r, n.jsxDEV);
  } else {
    if (typeof n.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof n.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    i = BD(r, n.jsx, n.jsxs);
  }
  const a = {
    Fragment: n.Fragment,
    ancestors: [],
    components: n.components || {},
    create: i,
    elementAttributeNameCase: n.elementAttributeNameCase || "react",
    evaluater: n.createEvaluater ? n.createEvaluater() : void 0,
    filePath: r,
    ignoreInvalidStyle: n.ignoreInvalidStyle || !1,
    passKeys: n.passKeys !== !1,
    passNode: n.passNode || !1,
    schema: n.space === "svg" ? Ep : ND,
    stylePropertyNameCase: n.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: n.tableCellAlignToStyle !== !1
  }, o = L_(a, e, void 0);
  return o && typeof o != "string" ? o : a.create(
    e,
    a.Fragment,
    { children: o || void 0 },
    void 0
  );
}
function L_(e, n, r) {
  if (n.type === "element")
    return PD(e, n, r);
  if (n.type === "mdxFlowExpression" || n.type === "mdxTextExpression")
    return LD(e, n);
  if (n.type === "mdxJsxFlowElement" || n.type === "mdxJsxTextElement")
    return zD(e, n, r);
  if (n.type === "mdxjsEsm")
    return VD(e, n);
  if (n.type === "root")
    return UD(e, n, r);
  if (n.type === "text")
    return MD(e, n);
}
function PD(e, n, r) {
  const i = e.schema;
  let a = i;
  n.tagName.toLowerCase() === "svg" && i.space === "html" && (a = Ep, e.schema = a), e.ancestors.push(n);
  const o = z_(e, n.tagName, !1), s = HD(e, n);
  let l = Rp(e, n);
  return RD.has(n.tagName) && (l = l.filter(function(d) {
    return typeof d == "string" ? !pD(d) : !0;
  })), V_(e, s, o, n), Dp(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function LD(e, n) {
  if (n.data && n.data.estree && e.evaluater) {
    const i = n.data.estree.body[0];
    return i.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(i.expression);
  }
  go(e, n.position);
}
function VD(e, n) {
  if (n.data && n.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(n.data.estree)
    );
  go(e, n.position);
}
function zD(e, n, r) {
  const i = e.schema;
  let a = i;
  n.name === "svg" && i.space === "html" && (a = Ep, e.schema = a), e.ancestors.push(n);
  const o = n.name === null ? e.Fragment : z_(e, n.name, !0), s = WD(e, n), l = Rp(e, n);
  return V_(e, s, o, n), Dp(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function UD(e, n, r) {
  const i = {};
  return Dp(i, Rp(e, n)), e.create(n, e.Fragment, i, r);
}
function MD(e, n) {
  return n.value;
}
function V_(e, n, r, i) {
  typeof r != "string" && r !== e.Fragment && e.passNode && (n.node = i);
}
function Dp(e, n) {
  if (n.length > 0) {
    const r = n.length > 1 ? n : n[0];
    r && (e.children = r);
  }
}
function BD(e, n, r) {
  return i;
  function i(a, o, s, l) {
    const m = Array.isArray(s.children) ? r : n;
    return l ? m(o, s, l) : m(o, s);
  }
}
function qD(e, n) {
  return r;
  function r(i, a, o, s) {
    const l = Array.isArray(o.children), d = Tp(i);
    return n(
      a,
      o,
      s,
      l,
      {
        columnNumber: d ? d.column - 1 : void 0,
        fileName: e,
        lineNumber: d ? d.line : void 0
      },
      void 0
    );
  }
}
function HD(e, n) {
  const r = {};
  let i, a;
  for (a in n.properties)
    if (a !== "children" && $p.call(n.properties, a)) {
      const o = GD(e, a, n.properties[a]);
      if (o) {
        const [s, l] = o;
        e.tableCellAlignToStyle && s === "align" && typeof l == "string" && OD.has(n.tagName) ? i = l : r[s] = l;
      }
    }
  if (i) {
    const o = (
      /** @type {Style} */
      r.style || (r.style = {})
    );
    o[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = i;
  }
  return r;
}
function WD(e, n) {
  const r = {};
  for (const i of n.attributes)
    if (i.type === "mdxJsxExpressionAttribute")
      if (i.data && i.data.estree && e.evaluater) {
        const o = i.data.estree.body[0];
        o.type;
        const s = o.expression;
        s.type;
        const l = s.properties[0];
        l.type, Object.assign(
          r,
          e.evaluater.evaluateExpression(l.argument)
        );
      } else
        go(e, n.position);
    else {
      const a = i.name;
      let o;
      if (i.value && typeof i.value == "object")
        if (i.value.data && i.value.data.estree && e.evaluater) {
          const l = i.value.data.estree.body[0];
          l.type, o = e.evaluater.evaluateExpression(l.expression);
        } else
          go(e, n.position);
      else
        o = i.value === null ? !0 : i.value;
      r[a] = /** @type {Props[keyof Props]} */
      o;
    }
  return r;
}
function Rp(e, n) {
  const r = [];
  let i = -1;
  const a = e.passKeys ? /* @__PURE__ */ new Map() : TD;
  for (; ++i < n.children.length; ) {
    const o = n.children[i];
    let s;
    if (e.passKeys) {
      const d = o.type === "element" ? o.tagName : o.type === "mdxJsxFlowElement" || o.type === "mdxJsxTextElement" ? o.name : void 0;
      if (d) {
        const m = a.get(d) || 0;
        s = d + "-" + m, a.set(d, m + 1);
      }
    }
    const l = L_(e, o, s);
    l !== void 0 && r.push(l);
  }
  return r;
}
function GD(e, n, r) {
  const i = bD(e.schema, n);
  if (!(r == null || typeof r == "number" && Number.isNaN(r))) {
    if (Array.isArray(r) && (r = i.commaSeparated ? lD(r) : jD(r)), i.property === "style") {
      let a = typeof r == "object" ? r : KD(e, String(r));
      return e.stylePropertyNameCase === "css" && (a = YD(a)), ["style", a];
    }
    return [
      e.elementAttributeNameCase === "react" && i.space ? SD[i.property] || i.property : i.attribute,
      r
    ];
  }
}
function KD(e, n) {
  const r = {};
  try {
    ID(n, i);
  } catch (a) {
    if (!e.ignoreInvalidStyle) {
      const o = (
        /** @type {Error} */
        a
      ), s = new Pt("Cannot parse `style` attribute", {
        ancestors: e.ancestors,
        cause: o,
        ruleId: "style",
        source: "hast-util-to-jsx-runtime"
      });
      throw s.file = e.filePath || void 0, s.url = P_ + "#cannot-parse-style-attribute", s;
    }
  }
  return r;
  function i(a, o) {
    let s = a;
    s.slice(0, 2) !== "--" && (s.slice(0, 4) === "-ms-" && (s = "ms-" + s.slice(4)), s = s.replace(DD, JD)), r[s] = o;
  }
}
function z_(e, n, r) {
  let i;
  if (!r)
    i = { type: "Literal", value: n };
  else if (n.includes(".")) {
    const a = n.split(".");
    let o = -1, s;
    for (; ++o < a.length; ) {
      const l = _v(a[o]) ? { type: "Identifier", name: a[o] } : { type: "Literal", value: a[o] };
      s = s ? {
        type: "MemberExpression",
        object: s,
        property: l,
        computed: !!(o && l.type === "Literal"),
        optional: !1
      } : l;
    }
    i = s;
  } else
    i = _v(n) && !/^[a-z]/.test(n) ? { type: "Identifier", name: n } : { type: "Literal", value: n };
  if (i.type === "Literal") {
    const a = (
      /** @type {keyof JSX.IntrinsicElements} */
      i.value
    );
    return $p.call(e.components, a) ? e.components[a] : a;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(i);
  go(e);
}
function go(e, n) {
  const r = new Pt(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: n,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw r.file = e.filePath || void 0, r.url = P_ + "#cannot-handle-mdx-estrees-without-createevaluater", r;
}
function YD(e) {
  const n = {};
  let r;
  for (r in e)
    $p.call(e, r) && (n[QD(r)] = e[r]);
  return n;
}
function QD(e) {
  let n = e.replace($D, XD);
  return n.slice(0, 3) === "ms-" && (n = "-" + n), n;
}
function JD(e, n) {
  return n.toUpperCase();
}
function XD(e) {
  return "-" + e.toLowerCase();
}
const vu = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, ZD = {};
function eR(e, n) {
  const r = ZD, i = typeof r.includeImageAlt == "boolean" ? r.includeImageAlt : !0, a = typeof r.includeHtml == "boolean" ? r.includeHtml : !0;
  return U_(e, i, a);
}
function U_(e, n, r) {
  if (nR(e)) {
    if ("value" in e)
      return e.type === "html" && !r ? "" : e.value;
    if (n && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return Tv(e.children, n, r);
  }
  return Array.isArray(e) ? Tv(e, n, r) : "";
}
function Tv(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; )
    i[a] = U_(e[a], n, r);
  return i.join("");
}
function nR(e) {
  return !!(e && typeof e == "object");
}
const $v = document.createElement("i");
function Op(e) {
  const n = "&" + e + ";";
  $v.innerHTML = n;
  const r = $v.textContent;
  return r.charCodeAt(r.length - 1) === 59 && e !== "semi" || r === n ? !1 : r;
}
function Pr(e, n, r, i) {
  const a = e.length;
  let o = 0, s;
  if (n < 0 ? n = -n > a ? 0 : a + n : n = n > a ? a : n, r = r > 0 ? r : 0, i.length < 1e4)
    s = Array.from(i), s.unshift(n, r), e.splice(...s);
  else
    for (r && e.splice(n, r); o < i.length; )
      s = i.slice(o, o + 1e4), s.unshift(n, 0), e.splice(...s), o += 1e4, n += 1e4;
}
function ur(e, n) {
  return e.length > 0 ? (Pr(e, e.length, 0, n), e) : n;
}
const Dv = {}.hasOwnProperty;
function tR(e) {
  const n = {};
  let r = -1;
  for (; ++r < e.length; )
    rR(n, e[r]);
  return n;
}
function rR(e, n) {
  let r;
  for (r in n) {
    const a = (Dv.call(e, r) ? e[r] : void 0) || (e[r] = {}), o = n[r];
    let s;
    if (o)
      for (s in o) {
        Dv.call(a, s) || (a[s] = []);
        const l = o[s];
        iR(
          // @ts-expect-error Looks like a list.
          a[s],
          Array.isArray(l) ? l : l ? [l] : []
        );
      }
  }
}
function iR(e, n) {
  let r = -1;
  const i = [];
  for (; ++r < n.length; )
    (n[r].add === "after" ? e : i).push(n[r]);
  Pr(e, 0, 0, i);
}
function M_(e, n) {
  const r = Number.parseInt(e, n);
  return (
    // C0 except for HT, LF, FF, CR, space.
    r < 9 || r === 11 || r > 13 && r < 32 || // Control character (DEL) of C0, and C1 controls.
    r > 126 && r < 160 || // Lone high surrogates and low surrogates.
    r > 55295 && r < 57344 || // Noncharacters.
    r > 64975 && r < 65008 || /* eslint-disable no-bitwise */
    (r & 65535) === 65535 || (r & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    r > 1114111 ? "�" : String.fromCodePoint(r)
  );
}
function ta(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const Tr = oi(/[A-Za-z]/), sr = oi(/[\dA-Za-z]/), aR = oi(/[#-'*+\--9=?A-Z^-~]/);
function _m(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const Sm = oi(/\d/), oR = oi(/[\dA-Fa-f]/), sR = oi(/[!-/:-@[-`{-~]/);
function bn(e) {
  return e !== null && e < -2;
}
function Zt(e) {
  return e !== null && (e < 0 || e === 32);
}
function zn(e) {
  return e === -2 || e === -1 || e === 32;
}
const lR = oi(new RegExp("\\p{P}|\\p{S}", "u")), cR = oi(/\s/);
function oi(e) {
  return n;
  function n(r) {
    return r !== null && r > -1 && e.test(String.fromCharCode(r));
  }
}
function ha(e) {
  const n = [];
  let r = -1, i = 0, a = 0;
  for (; ++r < e.length; ) {
    const o = e.charCodeAt(r);
    let s = "";
    if (o === 37 && sr(e.charCodeAt(r + 1)) && sr(e.charCodeAt(r + 2)))
      a = 2;
    else if (o < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(o)) || (s = String.fromCharCode(o));
    else if (o > 55295 && o < 57344) {
      const l = e.charCodeAt(r + 1);
      o < 56320 && l > 56319 && l < 57344 ? (s = String.fromCharCode(o, l), a = 1) : s = "�";
    } else
      s = String.fromCharCode(o);
    s && (n.push(e.slice(i, r), encodeURIComponent(s)), i = r + a + 1, s = ""), a && (r += a, a = 0);
  }
  return n.join("") + e.slice(i);
}
function nt(e, n, r, i) {
  const a = i ? i - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return s;
  function s(d) {
    return zn(d) ? (e.enter(r), l(d)) : n(d);
  }
  function l(d) {
    return zn(d) && o++ < a ? (e.consume(d), l) : (e.exit(r), n(d));
  }
}
const dR = {
  tokenize: uR
};
function uR(e) {
  const n = e.attempt(this.parser.constructs.contentInitial, i, a);
  let r;
  return n;
  function i(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), nt(e, n, "linePrefix");
  }
  function a(l) {
    return e.enter("paragraph"), o(l);
  }
  function o(l) {
    const d = e.enter("chunkText", {
      contentType: "text",
      previous: r
    });
    return r && (r.next = d), r = d, s(l);
  }
  function s(l) {
    if (l === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(l);
      return;
    }
    return bn(l) ? (e.consume(l), e.exit("chunkText"), o) : (e.consume(l), s);
  }
}
const mR = {
  tokenize: pR
}, Rv = {
  tokenize: fR
};
function pR(e) {
  const n = this, r = [];
  let i = 0, a, o, s;
  return l;
  function l(z) {
    if (i < r.length) {
      const $ = r[i];
      return n.containerState = $[1], e.attempt($[0].continuation, d, m)(z);
    }
    return m(z);
  }
  function d(z) {
    if (i++, n.containerState._closeFlow) {
      n.containerState._closeFlow = void 0, a && y();
      const $ = n.events.length;
      let I = $, T;
      for (; I--; )
        if (n.events[I][0] === "exit" && n.events[I][1].type === "chunkFlow") {
          T = n.events[I][1].end;
          break;
        }
      w(i);
      let U = $;
      for (; U < n.events.length; )
        n.events[U][1].end = {
          ...T
        }, U++;
      return Pr(n.events, I + 1, 0, n.events.slice($)), n.events.length = U, m(z);
    }
    return l(z);
  }
  function m(z) {
    if (i === r.length) {
      if (!a)
        return h(z);
      if (a.currentConstruct && a.currentConstruct.concrete)
        return C(z);
      n.interrupt = !!(a.currentConstruct && !a._gfmTableDynamicInterruptHack);
    }
    return n.containerState = {}, e.check(Rv, u, f)(z);
  }
  function u(z) {
    return a && y(), w(i), h(z);
  }
  function f(z) {
    return n.parser.lazy[n.now().line] = i !== r.length, s = n.now().offset, C(z);
  }
  function h(z) {
    return n.containerState = {}, e.attempt(Rv, g, C)(z);
  }
  function g(z) {
    return i++, r.push([n.currentConstruct, n.containerState]), h(z);
  }
  function C(z) {
    if (z === null) {
      a && y(), w(0), e.consume(z);
      return;
    }
    return a = a || n.parser.flow(n.now()), e.enter("chunkFlow", {
      _tokenizer: a,
      contentType: "flow",
      previous: o
    }), S(z);
  }
  function S(z) {
    if (z === null) {
      N(e.exit("chunkFlow"), !0), w(0), e.consume(z);
      return;
    }
    return bn(z) ? (e.consume(z), N(e.exit("chunkFlow")), i = 0, n.interrupt = void 0, l) : (e.consume(z), S);
  }
  function N(z, $) {
    const I = n.sliceStream(z);
    if ($ && I.push(null), z.previous = o, o && (o.next = z), o = z, a.defineSkip(z.start), a.write(I), n.parser.lazy[z.start.line]) {
      let T = a.events.length;
      for (; T--; )
        if (
          // The token starts before the line ending…
          a.events[T][1].start.offset < s && // …and either is not ended yet…
          (!a.events[T][1].end || // …or ends after it.
          a.events[T][1].end.offset > s)
        )
          return;
      const U = n.events.length;
      let Q = U, J, ae;
      for (; Q--; )
        if (n.events[Q][0] === "exit" && n.events[Q][1].type === "chunkFlow") {
          if (J) {
            ae = n.events[Q][1].end;
            break;
          }
          J = !0;
        }
      for (w(i), T = U; T < n.events.length; )
        n.events[T][1].end = {
          ...ae
        }, T++;
      Pr(n.events, Q + 1, 0, n.events.slice(U)), n.events.length = T;
    }
  }
  function w(z) {
    let $ = r.length;
    for (; $-- > z; ) {
      const I = r[$];
      n.containerState = I[1], I[0].exit.call(n, e);
    }
    r.length = z;
  }
  function y() {
    a.write([null]), o = void 0, a = void 0, n.containerState._closeFlow = void 0;
  }
}
function fR(e, n, r) {
  return nt(e, e.attempt(this.parser.constructs.document, n, r), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function Ov(e) {
  if (e === null || Zt(e) || cR(e))
    return 1;
  if (lR(e))
    return 2;
}
function Ap(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; ) {
    const o = e[a].resolveAll;
    o && !i.includes(o) && (n = o(n, r), i.push(o));
  }
  return n;
}
const Nm = {
  name: "attention",
  resolveAll: hR,
  tokenize: yR
};
function hR(e, n) {
  let r = -1, i, a, o, s, l, d, m, u;
  for (; ++r < e.length; )
    if (e[r][0] === "enter" && e[r][1].type === "attentionSequence" && e[r][1]._close) {
      for (i = r; i--; )
        if (e[i][0] === "exit" && e[i][1].type === "attentionSequence" && e[i][1]._open && // If the markers are the same:
        n.sliceSerialize(e[i][1]).charCodeAt(0) === n.sliceSerialize(e[r][1]).charCodeAt(0)) {
          if ((e[i][1]._close || e[r][1]._open) && (e[r][1].end.offset - e[r][1].start.offset) % 3 && !((e[i][1].end.offset - e[i][1].start.offset + e[r][1].end.offset - e[r][1].start.offset) % 3))
            continue;
          d = e[i][1].end.offset - e[i][1].start.offset > 1 && e[r][1].end.offset - e[r][1].start.offset > 1 ? 2 : 1;
          const f = {
            ...e[i][1].end
          }, h = {
            ...e[r][1].start
          };
          Av(f, -d), Av(h, d), s = {
            type: d > 1 ? "strongSequence" : "emphasisSequence",
            start: f,
            end: {
              ...e[i][1].end
            }
          }, l = {
            type: d > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[r][1].start
            },
            end: h
          }, o = {
            type: d > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[i][1].end
            },
            end: {
              ...e[r][1].start
            }
          }, a = {
            type: d > 1 ? "strong" : "emphasis",
            start: {
              ...s.start
            },
            end: {
              ...l.end
            }
          }, e[i][1].end = {
            ...s.start
          }, e[r][1].start = {
            ...l.end
          }, m = [], e[i][1].end.offset - e[i][1].start.offset && (m = ur(m, [["enter", e[i][1], n], ["exit", e[i][1], n]])), m = ur(m, [["enter", a, n], ["enter", s, n], ["exit", s, n], ["enter", o, n]]), m = ur(m, Ap(n.parser.constructs.insideSpan.null, e.slice(i + 1, r), n)), m = ur(m, [["exit", o, n], ["enter", l, n], ["exit", l, n], ["exit", a, n]]), e[r][1].end.offset - e[r][1].start.offset ? (u = 2, m = ur(m, [["enter", e[r][1], n], ["exit", e[r][1], n]])) : u = 0, Pr(e, i - 1, r - i + 3, m), r = i + m.length - u - 2;
          break;
        }
    }
  for (r = -1; ++r < e.length; )
    e[r][1].type === "attentionSequence" && (e[r][1].type = "data");
  return e;
}
function yR(e, n) {
  const r = this.parser.constructs.attentionMarkers.null, i = this.previous, a = Ov(i);
  let o;
  return s;
  function s(d) {
    return o = d, e.enter("attentionSequence"), l(d);
  }
  function l(d) {
    if (d === o)
      return e.consume(d), l;
    const m = e.exit("attentionSequence"), u = Ov(d), f = !u || u === 2 && a || r.includes(d), h = !a || a === 2 && u || r.includes(i);
    return m._open = !!(o === 42 ? f : f && (a || !h)), m._close = !!(o === 42 ? h : h && (u || !f)), n(d);
  }
}
function Av(e, n) {
  e.column += n, e.offset += n, e._bufferIndex += n;
}
const gR = {
  name: "autolink",
  tokenize: vR
};
function vR(e, n, r) {
  let i = 0;
  return a;
  function a(g) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(g), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), o;
  }
  function o(g) {
    return Tr(g) ? (e.consume(g), s) : g === 64 ? r(g) : m(g);
  }
  function s(g) {
    return g === 43 || g === 45 || g === 46 || sr(g) ? (i = 1, l(g)) : m(g);
  }
  function l(g) {
    return g === 58 ? (e.consume(g), i = 0, d) : (g === 43 || g === 45 || g === 46 || sr(g)) && i++ < 32 ? (e.consume(g), l) : (i = 0, m(g));
  }
  function d(g) {
    return g === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(g), e.exit("autolinkMarker"), e.exit("autolink"), n) : g === null || g === 32 || g === 60 || _m(g) ? r(g) : (e.consume(g), d);
  }
  function m(g) {
    return g === 64 ? (e.consume(g), u) : aR(g) ? (e.consume(g), m) : r(g);
  }
  function u(g) {
    return sr(g) ? f(g) : r(g);
  }
  function f(g) {
    return g === 46 ? (e.consume(g), i = 0, u) : g === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(g), e.exit("autolinkMarker"), e.exit("autolink"), n) : h(g);
  }
  function h(g) {
    if ((g === 45 || sr(g)) && i++ < 63) {
      const C = g === 45 ? h : f;
      return e.consume(g), C;
    }
    return r(g);
  }
}
const cl = {
  partial: !0,
  tokenize: kR
};
function kR(e, n, r) {
  return i;
  function i(o) {
    return zn(o) ? nt(e, a, "linePrefix")(o) : a(o);
  }
  function a(o) {
    return o === null || bn(o) ? n(o) : r(o);
  }
}
const B_ = {
  continuation: {
    tokenize: xR
  },
  exit: _R,
  name: "blockQuote",
  tokenize: bR
};
function bR(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    if (s === 62) {
      const l = i.containerState;
      return l.open || (e.enter("blockQuote", {
        _container: !0
      }), l.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(s), e.exit("blockQuoteMarker"), o;
    }
    return r(s);
  }
  function o(s) {
    return zn(s) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(s), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), n) : (e.exit("blockQuotePrefix"), n(s));
  }
}
function xR(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return zn(s) ? nt(e, o, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s) : o(s);
  }
  function o(s) {
    return e.attempt(B_, n, r)(s);
  }
}
function _R(e) {
  e.exit("blockQuote");
}
const q_ = {
  name: "characterEscape",
  tokenize: SR
};
function SR(e, n, r) {
  return i;
  function i(o) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(o), e.exit("escapeMarker"), a;
  }
  function a(o) {
    return sR(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), n) : r(o);
  }
}
const H_ = {
  name: "characterReference",
  tokenize: NR
};
function NR(e, n, r) {
  const i = this;
  let a = 0, o, s;
  return l;
  function l(f) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), d;
  }
  function d(f) {
    return f === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(f), e.exit("characterReferenceMarkerNumeric"), m) : (e.enter("characterReferenceValue"), o = 31, s = sr, u(f));
  }
  function m(f) {
    return f === 88 || f === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(f), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), o = 6, s = oR, u) : (e.enter("characterReferenceValue"), o = 7, s = Sm, u(f));
  }
  function u(f) {
    if (f === 59 && a) {
      const h = e.exit("characterReferenceValue");
      return s === sr && !Op(i.sliceSerialize(h)) ? r(f) : (e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), e.exit("characterReference"), n);
    }
    return s(f) && a++ < o ? (e.consume(f), u) : r(f);
  }
}
const Pv = {
  partial: !0,
  tokenize: wR
}, Lv = {
  concrete: !0,
  name: "codeFenced",
  tokenize: jR
};
function jR(e, n, r) {
  const i = this, a = {
    partial: !0,
    tokenize: I
  };
  let o = 0, s = 0, l;
  return d;
  function d(T) {
    return m(T);
  }
  function m(T) {
    const U = i.events[i.events.length - 1];
    return o = U && U[1].type === "linePrefix" ? U[2].sliceSerialize(U[1], !0).length : 0, l = T, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), u(T);
  }
  function u(T) {
    return T === l ? (s++, e.consume(T), u) : s < 3 ? r(T) : (e.exit("codeFencedFenceSequence"), zn(T) ? nt(e, f, "whitespace")(T) : f(T));
  }
  function f(T) {
    return T === null || bn(T) ? (e.exit("codeFencedFence"), i.interrupt ? n(T) : e.check(Pv, S, $)(T)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), h(T));
  }
  function h(T) {
    return T === null || bn(T) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), f(T)) : zn(T) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), nt(e, g, "whitespace")(T)) : T === 96 && T === l ? r(T) : (e.consume(T), h);
  }
  function g(T) {
    return T === null || bn(T) ? f(T) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), C(T));
  }
  function C(T) {
    return T === null || bn(T) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), f(T)) : T === 96 && T === l ? r(T) : (e.consume(T), C);
  }
  function S(T) {
    return e.attempt(a, $, N)(T);
  }
  function N(T) {
    return e.enter("lineEnding"), e.consume(T), e.exit("lineEnding"), w;
  }
  function w(T) {
    return o > 0 && zn(T) ? nt(e, y, "linePrefix", o + 1)(T) : y(T);
  }
  function y(T) {
    return T === null || bn(T) ? e.check(Pv, S, $)(T) : (e.enter("codeFlowValue"), z(T));
  }
  function z(T) {
    return T === null || bn(T) ? (e.exit("codeFlowValue"), y(T)) : (e.consume(T), z);
  }
  function $(T) {
    return e.exit("codeFenced"), n(T);
  }
  function I(T, U, Q) {
    let J = 0;
    return ae;
    function ae(ee) {
      return T.enter("lineEnding"), T.consume(ee), T.exit("lineEnding"), X;
    }
    function X(ee) {
      return T.enter("codeFencedFence"), zn(ee) ? nt(T, B, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(ee) : B(ee);
    }
    function B(ee) {
      return ee === l ? (T.enter("codeFencedFenceSequence"), O(ee)) : Q(ee);
    }
    function O(ee) {
      return ee === l ? (J++, T.consume(ee), O) : J >= s ? (T.exit("codeFencedFenceSequence"), zn(ee) ? nt(T, q, "whitespace")(ee) : q(ee)) : Q(ee);
    }
    function q(ee) {
      return ee === null || bn(ee) ? (T.exit("codeFencedFence"), U(ee)) : Q(ee);
    }
  }
}
function wR(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return s === null ? r(s) : (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
const ku = {
  name: "codeIndented",
  tokenize: FR
}, CR = {
  partial: !0,
  tokenize: IR
};
function FR(e, n, r) {
  const i = this;
  return a;
  function a(m) {
    return e.enter("codeIndented"), nt(e, o, "linePrefix", 5)(m);
  }
  function o(m) {
    const u = i.events[i.events.length - 1];
    return u && u[1].type === "linePrefix" && u[2].sliceSerialize(u[1], !0).length >= 4 ? s(m) : r(m);
  }
  function s(m) {
    return m === null ? d(m) : bn(m) ? e.attempt(CR, s, d)(m) : (e.enter("codeFlowValue"), l(m));
  }
  function l(m) {
    return m === null || bn(m) ? (e.exit("codeFlowValue"), s(m)) : (e.consume(m), l);
  }
  function d(m) {
    return e.exit("codeIndented"), n(m);
  }
}
function IR(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return i.parser.lazy[i.now().line] ? r(s) : bn(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), a) : nt(e, o, "linePrefix", 5)(s);
  }
  function o(s) {
    const l = i.events[i.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : bn(s) ? a(s) : r(s);
  }
}
const ER = {
  name: "codeText",
  previous: $R,
  resolve: TR,
  tokenize: DR
};
function TR(e) {
  let n = e.length - 4, r = 3, i, a;
  if ((e[r][1].type === "lineEnding" || e[r][1].type === "space") && (e[n][1].type === "lineEnding" || e[n][1].type === "space")) {
    for (i = r; ++i < n; )
      if (e[i][1].type === "codeTextData") {
        e[r][1].type = "codeTextPadding", e[n][1].type = "codeTextPadding", r += 2, n -= 2;
        break;
      }
  }
  for (i = r - 1, n++; ++i <= n; )
    a === void 0 ? i !== n && e[i][1].type !== "lineEnding" && (a = i) : (i === n || e[i][1].type === "lineEnding") && (e[a][1].type = "codeTextData", i !== a + 2 && (e[a][1].end = e[i - 1][1].end, e.splice(a + 2, i - a - 2), n -= i - a - 2, i = a + 2), a = void 0);
  return e;
}
function $R(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function DR(e, n, r) {
  let i = 0, a, o;
  return s;
  function s(f) {
    return e.enter("codeText"), e.enter("codeTextSequence"), l(f);
  }
  function l(f) {
    return f === 96 ? (e.consume(f), i++, l) : (e.exit("codeTextSequence"), d(f));
  }
  function d(f) {
    return f === null ? r(f) : f === 32 ? (e.enter("space"), e.consume(f), e.exit("space"), d) : f === 96 ? (o = e.enter("codeTextSequence"), a = 0, u(f)) : bn(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), d) : (e.enter("codeTextData"), m(f));
  }
  function m(f) {
    return f === null || f === 32 || f === 96 || bn(f) ? (e.exit("codeTextData"), d(f)) : (e.consume(f), m);
  }
  function u(f) {
    return f === 96 ? (e.consume(f), a++, u) : a === i ? (e.exit("codeTextSequence"), e.exit("codeText"), n(f)) : (o.type = "codeTextData", m(f));
  }
}
class RR {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(n) {
    this.left = n ? [...n] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(n) {
    if (n < 0 || n >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + n + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return n < this.left.length ? this.left[n] : this.right[this.right.length - n + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(n, r) {
    const i = r ?? Number.POSITIVE_INFINITY;
    return i < this.left.length ? this.left.slice(n, i) : n > this.left.length ? this.right.slice(this.right.length - i + this.left.length, this.right.length - n + this.left.length).reverse() : this.left.slice(n).concat(this.right.slice(this.right.length - i + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(n, r, i) {
    const a = r || 0;
    this.setCursor(Math.trunc(n));
    const o = this.right.splice(this.right.length - a, Number.POSITIVE_INFINITY);
    return i && Ta(this.left, i), o.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(n) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(n);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(n) {
    this.setCursor(Number.POSITIVE_INFINITY), Ta(this.left, n);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(n) {
    this.setCursor(0), this.right.push(n);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(n) {
    this.setCursor(0), Ta(this.right, n.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(n) {
    if (!(n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0))
      if (n < this.left.length) {
        const r = this.left.splice(n, Number.POSITIVE_INFINITY);
        Ta(this.right, r.reverse());
      } else {
        const r = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
        Ta(this.left, r.reverse());
      }
  }
}
function Ta(e, n) {
  let r = 0;
  if (n.length < 1e4)
    e.push(...n);
  else
    for (; r < n.length; )
      e.push(...n.slice(r, r + 1e4)), r += 1e4;
}
function W_(e) {
  const n = {};
  let r = -1, i, a, o, s, l, d, m;
  const u = new RR(e);
  for (; ++r < u.length; ) {
    for (; r in n; )
      r = n[r];
    if (i = u.get(r), r && i[1].type === "chunkFlow" && u.get(r - 1)[1].type === "listItemPrefix" && (d = i[1]._tokenizer.events, o = 0, o < d.length && d[o][1].type === "lineEndingBlank" && (o += 2), o < d.length && d[o][1].type === "content"))
      for (; ++o < d.length && d[o][1].type !== "content"; )
        d[o][1].type === "chunkText" && (d[o][1]._isInFirstContentOfListItem = !0, o++);
    if (i[0] === "enter")
      i[1].contentType && (Object.assign(n, OR(u, r)), r = n[r], m = !0);
    else if (i[1]._container) {
      for (o = r, a = void 0; o-- && (s = u.get(o), s[1].type === "lineEnding" || s[1].type === "lineEndingBlank"); )
        s[0] === "enter" && (a && (u.get(a)[1].type = "lineEndingBlank"), s[1].type = "lineEnding", a = o);
      a && (i[1].end = {
        ...u.get(a)[1].start
      }, l = u.slice(a, r), l.unshift(i), u.splice(a, r - a + 1, l));
    }
  }
  return Pr(e, 0, Number.POSITIVE_INFINITY, u.slice(0)), !m;
}
function OR(e, n) {
  const r = e.get(n)[1], i = e.get(n)[2];
  let a = n - 1;
  const o = [], s = r._tokenizer || i.parser[r.contentType](r.start), l = s.events, d = [], m = {};
  let u, f, h = -1, g = r, C = 0, S = 0;
  const N = [S];
  for (; g; ) {
    for (; e.get(++a)[1] !== g; )
      ;
    o.push(a), g._tokenizer || (u = i.sliceStream(g), g.next || u.push(null), f && s.defineSkip(g.start), g._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = !0), s.write(u), g._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = void 0)), f = g, g = g.next;
  }
  for (g = r; ++h < l.length; )
    // Find a void token that includes a break.
    l[h][0] === "exit" && l[h - 1][0] === "enter" && l[h][1].type === l[h - 1][1].type && l[h][1].start.line !== l[h][1].end.line && (S = h + 1, N.push(S), g._tokenizer = void 0, g.previous = void 0, g = g.next);
  for (s.events = [], g ? (g._tokenizer = void 0, g.previous = void 0) : N.pop(), h = N.length; h--; ) {
    const w = l.slice(N[h], N[h + 1]), y = o.pop();
    d.push([y, y + w.length - 1]), e.splice(y, 2, w);
  }
  for (d.reverse(), h = -1; ++h < d.length; )
    m[C + d[h][0]] = C + d[h][1], C += d[h][1] - d[h][0] - 1;
  return m;
}
const AR = {
  resolve: LR,
  tokenize: VR
}, PR = {
  partial: !0,
  tokenize: zR
};
function LR(e) {
  return W_(e), e;
}
function VR(e, n) {
  let r;
  return i;
  function i(l) {
    return e.enter("content"), r = e.enter("chunkContent", {
      contentType: "content"
    }), a(l);
  }
  function a(l) {
    return l === null ? o(l) : bn(l) ? e.check(PR, s, o)(l) : (e.consume(l), a);
  }
  function o(l) {
    return e.exit("chunkContent"), e.exit("content"), n(l);
  }
  function s(l) {
    return e.consume(l), e.exit("chunkContent"), r.next = e.enter("chunkContent", {
      contentType: "content",
      previous: r
    }), r = r.next, a;
  }
}
function zR(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), nt(e, o, "linePrefix");
  }
  function o(s) {
    if (s === null || bn(s))
      return r(s);
    const l = i.events[i.events.length - 1];
    return !i.parser.constructs.disable.null.includes("codeIndented") && l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : e.interrupt(i.parser.constructs.flow, r, n)(s);
  }
}
function G_(e, n, r, i, a, o, s, l, d) {
  const m = d || Number.POSITIVE_INFINITY;
  let u = 0;
  return f;
  function f(w) {
    return w === 60 ? (e.enter(i), e.enter(a), e.enter(o), e.consume(w), e.exit(o), h) : w === null || w === 32 || w === 41 || _m(w) ? r(w) : (e.enter(i), e.enter(s), e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), S(w));
  }
  function h(w) {
    return w === 62 ? (e.enter(o), e.consume(w), e.exit(o), e.exit(a), e.exit(i), n) : (e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), g(w));
  }
  function g(w) {
    return w === 62 ? (e.exit("chunkString"), e.exit(l), h(w)) : w === null || w === 60 || bn(w) ? r(w) : (e.consume(w), w === 92 ? C : g);
  }
  function C(w) {
    return w === 60 || w === 62 || w === 92 ? (e.consume(w), g) : g(w);
  }
  function S(w) {
    return !u && (w === null || w === 41 || Zt(w)) ? (e.exit("chunkString"), e.exit(l), e.exit(s), e.exit(i), n(w)) : u < m && w === 40 ? (e.consume(w), u++, S) : w === 41 ? (e.consume(w), u--, S) : w === null || w === 32 || w === 40 || _m(w) ? r(w) : (e.consume(w), w === 92 ? N : S);
  }
  function N(w) {
    return w === 40 || w === 41 || w === 92 ? (e.consume(w), S) : S(w);
  }
}
function K_(e, n, r, i, a, o) {
  const s = this;
  let l = 0, d;
  return m;
  function m(g) {
    return e.enter(i), e.enter(a), e.consume(g), e.exit(a), e.enter(o), u;
  }
  function u(g) {
    return l > 999 || g === null || g === 91 || g === 93 && !d || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    g === 94 && !l && "_hiddenFootnoteSupport" in s.parser.constructs ? r(g) : g === 93 ? (e.exit(o), e.enter(a), e.consume(g), e.exit(a), e.exit(i), n) : bn(g) ? (e.enter("lineEnding"), e.consume(g), e.exit("lineEnding"), u) : (e.enter("chunkString", {
      contentType: "string"
    }), f(g));
  }
  function f(g) {
    return g === null || g === 91 || g === 93 || bn(g) || l++ > 999 ? (e.exit("chunkString"), u(g)) : (e.consume(g), d || (d = !zn(g)), g === 92 ? h : f);
  }
  function h(g) {
    return g === 91 || g === 92 || g === 93 ? (e.consume(g), l++, f) : f(g);
  }
}
function Y_(e, n, r, i, a, o) {
  let s;
  return l;
  function l(h) {
    return h === 34 || h === 39 || h === 40 ? (e.enter(i), e.enter(a), e.consume(h), e.exit(a), s = h === 40 ? 41 : h, d) : r(h);
  }
  function d(h) {
    return h === s ? (e.enter(a), e.consume(h), e.exit(a), e.exit(i), n) : (e.enter(o), m(h));
  }
  function m(h) {
    return h === s ? (e.exit(o), d(s)) : h === null ? r(h) : bn(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), nt(e, m, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), u(h));
  }
  function u(h) {
    return h === s || h === null || bn(h) ? (e.exit("chunkString"), m(h)) : (e.consume(h), h === 92 ? f : u);
  }
  function f(h) {
    return h === s || h === 92 ? (e.consume(h), u) : u(h);
  }
}
function ao(e, n) {
  let r;
  return i;
  function i(a) {
    return bn(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), r = !0, i) : zn(a) ? nt(e, i, r ? "linePrefix" : "lineSuffix")(a) : n(a);
  }
}
const UR = {
  name: "definition",
  tokenize: BR
}, MR = {
  partial: !0,
  tokenize: qR
};
function BR(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(g) {
    return e.enter("definition"), s(g);
  }
  function s(g) {
    return K_.call(
      i,
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(g);
  }
  function l(g) {
    return a = ta(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1)), g === 58 ? (e.enter("definitionMarker"), e.consume(g), e.exit("definitionMarker"), d) : r(g);
  }
  function d(g) {
    return Zt(g) ? ao(e, m)(g) : m(g);
  }
  function m(g) {
    return G_(
      e,
      u,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(g);
  }
  function u(g) {
    return e.attempt(MR, f, f)(g);
  }
  function f(g) {
    return zn(g) ? nt(e, h, "whitespace")(g) : h(g);
  }
  function h(g) {
    return g === null || bn(g) ? (e.exit("definition"), i.parser.defined.push(a), n(g)) : r(g);
  }
}
function qR(e, n, r) {
  return i;
  function i(l) {
    return Zt(l) ? ao(e, a)(l) : r(l);
  }
  function a(l) {
    return Y_(e, o, r, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(l);
  }
  function o(l) {
    return zn(l) ? nt(e, s, "whitespace")(l) : s(l);
  }
  function s(l) {
    return l === null || bn(l) ? n(l) : r(l);
  }
}
const HR = {
  name: "hardBreakEscape",
  tokenize: WR
};
function WR(e, n, r) {
  return i;
  function i(o) {
    return e.enter("hardBreakEscape"), e.consume(o), a;
  }
  function a(o) {
    return bn(o) ? (e.exit("hardBreakEscape"), n(o)) : r(o);
  }
}
const GR = {
  name: "headingAtx",
  resolve: KR,
  tokenize: YR
};
function KR(e, n) {
  let r = e.length - 2, i = 3, a, o;
  return e[i][1].type === "whitespace" && (i += 2), r - 2 > i && e[r][1].type === "whitespace" && (r -= 2), e[r][1].type === "atxHeadingSequence" && (i === r - 1 || r - 4 > i && e[r - 2][1].type === "whitespace") && (r -= i + 1 === r ? 2 : 4), r > i && (a = {
    type: "atxHeadingText",
    start: e[i][1].start,
    end: e[r][1].end
  }, o = {
    type: "chunkText",
    start: e[i][1].start,
    end: e[r][1].end,
    contentType: "text"
  }, Pr(e, i, r - i + 1, [["enter", a, n], ["enter", o, n], ["exit", o, n], ["exit", a, n]])), e;
}
function YR(e, n, r) {
  let i = 0;
  return a;
  function a(u) {
    return e.enter("atxHeading"), o(u);
  }
  function o(u) {
    return e.enter("atxHeadingSequence"), s(u);
  }
  function s(u) {
    return u === 35 && i++ < 6 ? (e.consume(u), s) : u === null || Zt(u) ? (e.exit("atxHeadingSequence"), l(u)) : r(u);
  }
  function l(u) {
    return u === 35 ? (e.enter("atxHeadingSequence"), d(u)) : u === null || bn(u) ? (e.exit("atxHeading"), n(u)) : zn(u) ? nt(e, l, "whitespace")(u) : (e.enter("atxHeadingText"), m(u));
  }
  function d(u) {
    return u === 35 ? (e.consume(u), d) : (e.exit("atxHeadingSequence"), l(u));
  }
  function m(u) {
    return u === null || u === 35 || Zt(u) ? (e.exit("atxHeadingText"), l(u)) : (e.consume(u), m);
  }
}
const QR = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], Vv = ["pre", "script", "style", "textarea"], JR = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: eO,
  tokenize: nO
}, XR = {
  partial: !0,
  tokenize: rO
}, ZR = {
  partial: !0,
  tokenize: tO
};
function eO(e) {
  let n = e.length;
  for (; n-- && !(e[n][0] === "enter" && e[n][1].type === "htmlFlow"); )
    ;
  return n > 1 && e[n - 2][1].type === "linePrefix" && (e[n][1].start = e[n - 2][1].start, e[n + 1][1].start = e[n - 2][1].start, e.splice(n - 2, 2)), e;
}
function nO(e, n, r) {
  const i = this;
  let a, o, s, l, d;
  return m;
  function m(K) {
    return u(K);
  }
  function u(K) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(K), f;
  }
  function f(K) {
    return K === 33 ? (e.consume(K), h) : K === 47 ? (e.consume(K), o = !0, S) : K === 63 ? (e.consume(K), a = 3, i.interrupt ? n : W) : Tr(K) ? (e.consume(K), s = String.fromCharCode(K), N) : r(K);
  }
  function h(K) {
    return K === 45 ? (e.consume(K), a = 2, g) : K === 91 ? (e.consume(K), a = 5, l = 0, C) : Tr(K) ? (e.consume(K), a = 4, i.interrupt ? n : W) : r(K);
  }
  function g(K) {
    return K === 45 ? (e.consume(K), i.interrupt ? n : W) : r(K);
  }
  function C(K) {
    const qe = "CDATA[";
    return K === qe.charCodeAt(l++) ? (e.consume(K), l === qe.length ? i.interrupt ? n : B : C) : r(K);
  }
  function S(K) {
    return Tr(K) ? (e.consume(K), s = String.fromCharCode(K), N) : r(K);
  }
  function N(K) {
    if (K === null || K === 47 || K === 62 || Zt(K)) {
      const qe = K === 47, Be = s.toLowerCase();
      return !qe && !o && Vv.includes(Be) ? (a = 1, i.interrupt ? n(K) : B(K)) : QR.includes(s.toLowerCase()) ? (a = 6, qe ? (e.consume(K), w) : i.interrupt ? n(K) : B(K)) : (a = 7, i.interrupt && !i.parser.lazy[i.now().line] ? r(K) : o ? y(K) : z(K));
    }
    return K === 45 || sr(K) ? (e.consume(K), s += String.fromCharCode(K), N) : r(K);
  }
  function w(K) {
    return K === 62 ? (e.consume(K), i.interrupt ? n : B) : r(K);
  }
  function y(K) {
    return zn(K) ? (e.consume(K), y) : ae(K);
  }
  function z(K) {
    return K === 47 ? (e.consume(K), ae) : K === 58 || K === 95 || Tr(K) ? (e.consume(K), $) : zn(K) ? (e.consume(K), z) : ae(K);
  }
  function $(K) {
    return K === 45 || K === 46 || K === 58 || K === 95 || sr(K) ? (e.consume(K), $) : I(K);
  }
  function I(K) {
    return K === 61 ? (e.consume(K), T) : zn(K) ? (e.consume(K), I) : z(K);
  }
  function T(K) {
    return K === null || K === 60 || K === 61 || K === 62 || K === 96 ? r(K) : K === 34 || K === 39 ? (e.consume(K), d = K, U) : zn(K) ? (e.consume(K), T) : Q(K);
  }
  function U(K) {
    return K === d ? (e.consume(K), d = null, J) : K === null || bn(K) ? r(K) : (e.consume(K), U);
  }
  function Q(K) {
    return K === null || K === 34 || K === 39 || K === 47 || K === 60 || K === 61 || K === 62 || K === 96 || Zt(K) ? I(K) : (e.consume(K), Q);
  }
  function J(K) {
    return K === 47 || K === 62 || zn(K) ? z(K) : r(K);
  }
  function ae(K) {
    return K === 62 ? (e.consume(K), X) : r(K);
  }
  function X(K) {
    return K === null || bn(K) ? B(K) : zn(K) ? (e.consume(K), X) : r(K);
  }
  function B(K) {
    return K === 45 && a === 2 ? (e.consume(K), ve) : K === 60 && a === 1 ? (e.consume(K), ue) : K === 62 && a === 4 ? (e.consume(K), xe) : K === 63 && a === 3 ? (e.consume(K), W) : K === 93 && a === 5 ? (e.consume(K), fe) : bn(K) && (a === 6 || a === 7) ? (e.exit("htmlFlowData"), e.check(XR, Ie, O)(K)) : K === null || bn(K) ? (e.exit("htmlFlowData"), O(K)) : (e.consume(K), B);
  }
  function O(K) {
    return e.check(ZR, q, Ie)(K);
  }
  function q(K) {
    return e.enter("lineEnding"), e.consume(K), e.exit("lineEnding"), ee;
  }
  function ee(K) {
    return K === null || bn(K) ? O(K) : (e.enter("htmlFlowData"), B(K));
  }
  function ve(K) {
    return K === 45 ? (e.consume(K), W) : B(K);
  }
  function ue(K) {
    return K === 47 ? (e.consume(K), s = "", ce) : B(K);
  }
  function ce(K) {
    if (K === 62) {
      const qe = s.toLowerCase();
      return Vv.includes(qe) ? (e.consume(K), xe) : B(K);
    }
    return Tr(K) && s.length < 8 ? (e.consume(K), s += String.fromCharCode(K), ce) : B(K);
  }
  function fe(K) {
    return K === 93 ? (e.consume(K), W) : B(K);
  }
  function W(K) {
    return K === 62 ? (e.consume(K), xe) : K === 45 && a === 2 ? (e.consume(K), W) : B(K);
  }
  function xe(K) {
    return K === null || bn(K) ? (e.exit("htmlFlowData"), Ie(K)) : (e.consume(K), xe);
  }
  function Ie(K) {
    return e.exit("htmlFlow"), n(K);
  }
}
function tO(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return bn(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o) : r(s);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
function rO(e, n, r) {
  return i;
  function i(a) {
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), e.attempt(cl, n, r);
  }
}
const iO = {
  name: "htmlText",
  tokenize: aO
};
function aO(e, n, r) {
  const i = this;
  let a, o, s;
  return l;
  function l(W) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(W), d;
  }
  function d(W) {
    return W === 33 ? (e.consume(W), m) : W === 47 ? (e.consume(W), I) : W === 63 ? (e.consume(W), z) : Tr(W) ? (e.consume(W), Q) : r(W);
  }
  function m(W) {
    return W === 45 ? (e.consume(W), u) : W === 91 ? (e.consume(W), o = 0, C) : Tr(W) ? (e.consume(W), y) : r(W);
  }
  function u(W) {
    return W === 45 ? (e.consume(W), g) : r(W);
  }
  function f(W) {
    return W === null ? r(W) : W === 45 ? (e.consume(W), h) : bn(W) ? (s = f, ue(W)) : (e.consume(W), f);
  }
  function h(W) {
    return W === 45 ? (e.consume(W), g) : f(W);
  }
  function g(W) {
    return W === 62 ? ve(W) : W === 45 ? h(W) : f(W);
  }
  function C(W) {
    const xe = "CDATA[";
    return W === xe.charCodeAt(o++) ? (e.consume(W), o === xe.length ? S : C) : r(W);
  }
  function S(W) {
    return W === null ? r(W) : W === 93 ? (e.consume(W), N) : bn(W) ? (s = S, ue(W)) : (e.consume(W), S);
  }
  function N(W) {
    return W === 93 ? (e.consume(W), w) : S(W);
  }
  function w(W) {
    return W === 62 ? ve(W) : W === 93 ? (e.consume(W), w) : S(W);
  }
  function y(W) {
    return W === null || W === 62 ? ve(W) : bn(W) ? (s = y, ue(W)) : (e.consume(W), y);
  }
  function z(W) {
    return W === null ? r(W) : W === 63 ? (e.consume(W), $) : bn(W) ? (s = z, ue(W)) : (e.consume(W), z);
  }
  function $(W) {
    return W === 62 ? ve(W) : z(W);
  }
  function I(W) {
    return Tr(W) ? (e.consume(W), T) : r(W);
  }
  function T(W) {
    return W === 45 || sr(W) ? (e.consume(W), T) : U(W);
  }
  function U(W) {
    return bn(W) ? (s = U, ue(W)) : zn(W) ? (e.consume(W), U) : ve(W);
  }
  function Q(W) {
    return W === 45 || sr(W) ? (e.consume(W), Q) : W === 47 || W === 62 || Zt(W) ? J(W) : r(W);
  }
  function J(W) {
    return W === 47 ? (e.consume(W), ve) : W === 58 || W === 95 || Tr(W) ? (e.consume(W), ae) : bn(W) ? (s = J, ue(W)) : zn(W) ? (e.consume(W), J) : ve(W);
  }
  function ae(W) {
    return W === 45 || W === 46 || W === 58 || W === 95 || sr(W) ? (e.consume(W), ae) : X(W);
  }
  function X(W) {
    return W === 61 ? (e.consume(W), B) : bn(W) ? (s = X, ue(W)) : zn(W) ? (e.consume(W), X) : J(W);
  }
  function B(W) {
    return W === null || W === 60 || W === 61 || W === 62 || W === 96 ? r(W) : W === 34 || W === 39 ? (e.consume(W), a = W, O) : bn(W) ? (s = B, ue(W)) : zn(W) ? (e.consume(W), B) : (e.consume(W), q);
  }
  function O(W) {
    return W === a ? (e.consume(W), a = void 0, ee) : W === null ? r(W) : bn(W) ? (s = O, ue(W)) : (e.consume(W), O);
  }
  function q(W) {
    return W === null || W === 34 || W === 39 || W === 60 || W === 61 || W === 96 ? r(W) : W === 47 || W === 62 || Zt(W) ? J(W) : (e.consume(W), q);
  }
  function ee(W) {
    return W === 47 || W === 62 || Zt(W) ? J(W) : r(W);
  }
  function ve(W) {
    return W === 62 ? (e.consume(W), e.exit("htmlTextData"), e.exit("htmlText"), n) : r(W);
  }
  function ue(W) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(W), e.exit("lineEnding"), ce;
  }
  function ce(W) {
    return zn(W) ? nt(e, fe, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(W) : fe(W);
  }
  function fe(W) {
    return e.enter("htmlTextData"), s(W);
  }
}
const Pp = {
  name: "labelEnd",
  resolveAll: cO,
  resolveTo: dO,
  tokenize: uO
}, oO = {
  tokenize: mO
}, sO = {
  tokenize: pO
}, lO = {
  tokenize: fO
};
function cO(e) {
  let n = -1;
  const r = [];
  for (; ++n < e.length; ) {
    const i = e[n][1];
    if (r.push(e[n]), i.type === "labelImage" || i.type === "labelLink" || i.type === "labelEnd") {
      const a = i.type === "labelImage" ? 4 : 2;
      i.type = "data", n += a;
    }
  }
  return e.length !== r.length && Pr(e, 0, e.length, r), e;
}
function dO(e, n) {
  let r = e.length, i = 0, a, o, s, l;
  for (; r--; )
    if (a = e[r][1], o) {
      if (a.type === "link" || a.type === "labelLink" && a._inactive)
        break;
      e[r][0] === "enter" && a.type === "labelLink" && (a._inactive = !0);
    } else if (s) {
      if (e[r][0] === "enter" && (a.type === "labelImage" || a.type === "labelLink") && !a._balanced && (o = r, a.type !== "labelLink")) {
        i = 2;
        break;
      }
    } else a.type === "labelEnd" && (s = r);
  const d = {
    type: e[o][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, m = {
    type: "label",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[s][1].end
    }
  }, u = {
    type: "labelText",
    start: {
      ...e[o + i + 2][1].end
    },
    end: {
      ...e[s - 2][1].start
    }
  };
  return l = [["enter", d, n], ["enter", m, n]], l = ur(l, e.slice(o + 1, o + i + 3)), l = ur(l, [["enter", u, n]]), l = ur(l, Ap(n.parser.constructs.insideSpan.null, e.slice(o + i + 4, s - 3), n)), l = ur(l, [["exit", u, n], e[s - 2], e[s - 1], ["exit", m, n]]), l = ur(l, e.slice(s + 1)), l = ur(l, [["exit", d, n]]), Pr(e, o, e.length, l), e;
}
function uO(e, n, r) {
  const i = this;
  let a = i.events.length, o, s;
  for (; a--; )
    if ((i.events[a][1].type === "labelImage" || i.events[a][1].type === "labelLink") && !i.events[a][1]._balanced) {
      o = i.events[a][1];
      break;
    }
  return l;
  function l(h) {
    return o ? o._inactive ? f(h) : (s = i.parser.defined.includes(ta(i.sliceSerialize({
      start: o.end,
      end: i.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(h), e.exit("labelMarker"), e.exit("labelEnd"), d) : r(h);
  }
  function d(h) {
    return h === 40 ? e.attempt(oO, u, s ? u : f)(h) : h === 91 ? e.attempt(sO, u, s ? m : f)(h) : s ? u(h) : f(h);
  }
  function m(h) {
    return e.attempt(lO, u, f)(h);
  }
  function u(h) {
    return n(h);
  }
  function f(h) {
    return o._balanced = !0, r(h);
  }
}
function mO(e, n, r) {
  return i;
  function i(f) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), a;
  }
  function a(f) {
    return Zt(f) ? ao(e, o)(f) : o(f);
  }
  function o(f) {
    return f === 41 ? u(f) : G_(e, s, l, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(f);
  }
  function s(f) {
    return Zt(f) ? ao(e, d)(f) : u(f);
  }
  function l(f) {
    return r(f);
  }
  function d(f) {
    return f === 34 || f === 39 || f === 40 ? Y_(e, m, r, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(f) : u(f);
  }
  function m(f) {
    return Zt(f) ? ao(e, u)(f) : u(f);
  }
  function u(f) {
    return f === 41 ? (e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), e.exit("resource"), n) : r(f);
  }
}
function pO(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return K_.call(i, e, o, s, "reference", "referenceMarker", "referenceString")(l);
  }
  function o(l) {
    return i.parser.defined.includes(ta(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1))) ? n(l) : r(l);
  }
  function s(l) {
    return r(l);
  }
}
function fO(e, n, r) {
  return i;
  function i(o) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), a;
  }
  function a(o) {
    return o === 93 ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), n) : r(o);
  }
}
const hO = {
  name: "labelStartImage",
  resolveAll: Pp.resolveAll,
  tokenize: yO
};
function yO(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(l), e.exit("labelImageMarker"), o;
  }
  function o(l) {
    return l === 91 ? (e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelImage"), s) : r(l);
  }
  function s(l) {
    return l === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(l) : n(l);
  }
}
const gO = {
  name: "labelStartLink",
  resolveAll: Pp.resolveAll,
  tokenize: vO
};
function vO(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelLink"), o;
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(s) : n(s);
  }
}
const bu = {
  name: "lineEnding",
  tokenize: kO
};
function kO(e, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), nt(e, n, "linePrefix");
  }
}
const ks = {
  name: "thematicBreak",
  tokenize: bO
};
function bO(e, n, r) {
  let i = 0, a;
  return o;
  function o(m) {
    return e.enter("thematicBreak"), s(m);
  }
  function s(m) {
    return a = m, l(m);
  }
  function l(m) {
    return m === a ? (e.enter("thematicBreakSequence"), d(m)) : i >= 3 && (m === null || bn(m)) ? (e.exit("thematicBreak"), n(m)) : r(m);
  }
  function d(m) {
    return m === a ? (e.consume(m), i++, d) : (e.exit("thematicBreakSequence"), zn(m) ? nt(e, l, "whitespace")(m) : l(m));
  }
}
const Yt = {
  continuation: {
    tokenize: NO
  },
  exit: wO,
  name: "list",
  tokenize: SO
}, xO = {
  partial: !0,
  tokenize: CO
}, _O = {
  partial: !0,
  tokenize: jO
};
function SO(e, n, r) {
  const i = this, a = i.events[i.events.length - 1];
  let o = a && a[1].type === "linePrefix" ? a[2].sliceSerialize(a[1], !0).length : 0, s = 0;
  return l;
  function l(g) {
    const C = i.containerState.type || (g === 42 || g === 43 || g === 45 ? "listUnordered" : "listOrdered");
    if (C === "listUnordered" ? !i.containerState.marker || g === i.containerState.marker : Sm(g)) {
      if (i.containerState.type || (i.containerState.type = C, e.enter(C, {
        _container: !0
      })), C === "listUnordered")
        return e.enter("listItemPrefix"), g === 42 || g === 45 ? e.check(ks, r, m)(g) : m(g);
      if (!i.interrupt || g === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), d(g);
    }
    return r(g);
  }
  function d(g) {
    return Sm(g) && ++s < 10 ? (e.consume(g), d) : (!i.interrupt || s < 2) && (i.containerState.marker ? g === i.containerState.marker : g === 41 || g === 46) ? (e.exit("listItemValue"), m(g)) : r(g);
  }
  function m(g) {
    return e.enter("listItemMarker"), e.consume(g), e.exit("listItemMarker"), i.containerState.marker = i.containerState.marker || g, e.check(
      cl,
      // Can’t be empty when interrupting.
      i.interrupt ? r : u,
      e.attempt(xO, h, f)
    );
  }
  function u(g) {
    return i.containerState.initialBlankLine = !0, o++, h(g);
  }
  function f(g) {
    return zn(g) ? (e.enter("listItemPrefixWhitespace"), e.consume(g), e.exit("listItemPrefixWhitespace"), h) : r(g);
  }
  function h(g) {
    return i.containerState.size = o + i.sliceSerialize(e.exit("listItemPrefix"), !0).length, n(g);
  }
}
function NO(e, n, r) {
  const i = this;
  return i.containerState._closeFlow = void 0, e.check(cl, a, o);
  function a(l) {
    return i.containerState.furtherBlankLines = i.containerState.furtherBlankLines || i.containerState.initialBlankLine, nt(e, n, "listItemIndent", i.containerState.size + 1)(l);
  }
  function o(l) {
    return i.containerState.furtherBlankLines || !zn(l) ? (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, s(l)) : (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, e.attempt(_O, n, s)(l));
  }
  function s(l) {
    return i.containerState._closeFlow = !0, i.interrupt = void 0, nt(e, e.attempt(Yt, n, r), "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(l);
  }
}
function jO(e, n, r) {
  const i = this;
  return nt(e, a, "listItemIndent", i.containerState.size + 1);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return s && s[1].type === "listItemIndent" && s[2].sliceSerialize(s[1], !0).length === i.containerState.size ? n(o) : r(o);
  }
}
function wO(e) {
  e.exit(this.containerState.type);
}
function CO(e, n, r) {
  const i = this;
  return nt(e, a, "listItemPrefixWhitespace", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return !zn(o) && s && s[1].type === "listItemPrefixWhitespace" ? n(o) : r(o);
  }
}
const zv = {
  name: "setextUnderline",
  resolveTo: FO,
  tokenize: IO
};
function FO(e, n) {
  let r = e.length, i, a, o;
  for (; r--; )
    if (e[r][0] === "enter") {
      if (e[r][1].type === "content") {
        i = r;
        break;
      }
      e[r][1].type === "paragraph" && (a = r);
    } else
      e[r][1].type === "content" && e.splice(r, 1), !o && e[r][1].type === "definition" && (o = r);
  const s = {
    type: "setextHeading",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[a][1].type = "setextHeadingText", o ? (e.splice(a, 0, ["enter", s, n]), e.splice(o + 1, 0, ["exit", e[i][1], n]), e[i][1].end = {
    ...e[o][1].end
  }) : e[i][1] = s, e.push(["exit", s, n]), e;
}
function IO(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(m) {
    let u = i.events.length, f;
    for (; u--; )
      if (i.events[u][1].type !== "lineEnding" && i.events[u][1].type !== "linePrefix" && i.events[u][1].type !== "content") {
        f = i.events[u][1].type === "paragraph";
        break;
      }
    return !i.parser.lazy[i.now().line] && (i.interrupt || f) ? (e.enter("setextHeadingLine"), a = m, s(m)) : r(m);
  }
  function s(m) {
    return e.enter("setextHeadingLineSequence"), l(m);
  }
  function l(m) {
    return m === a ? (e.consume(m), l) : (e.exit("setextHeadingLineSequence"), zn(m) ? nt(e, d, "lineSuffix")(m) : d(m));
  }
  function d(m) {
    return m === null || bn(m) ? (e.exit("setextHeadingLine"), n(m)) : r(m);
  }
}
const EO = {
  tokenize: TO
};
function TO(e) {
  const n = this, r = e.attempt(
    // Try to parse a blank line.
    cl,
    i,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, a, nt(e, e.attempt(this.parser.constructs.flow, a, e.attempt(AR, a)), "linePrefix"))
  );
  return r;
  function i(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), n.currentConstruct = void 0, r;
  }
  function a(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), n.currentConstruct = void 0, r;
  }
}
const $O = {
  resolveAll: J_()
}, DO = Q_("string"), RO = Q_("text");
function Q_(e) {
  return {
    resolveAll: J_(e === "text" ? OO : void 0),
    tokenize: n
  };
  function n(r) {
    const i = this, a = this.parser.constructs[e], o = r.attempt(a, s, l);
    return s;
    function s(u) {
      return m(u) ? o(u) : l(u);
    }
    function l(u) {
      if (u === null) {
        r.consume(u);
        return;
      }
      return r.enter("data"), r.consume(u), d;
    }
    function d(u) {
      return m(u) ? (r.exit("data"), o(u)) : (r.consume(u), d);
    }
    function m(u) {
      if (u === null)
        return !0;
      const f = a[u];
      let h = -1;
      if (f)
        for (; ++h < f.length; ) {
          const g = f[h];
          if (!g.previous || g.previous.call(i, i.previous))
            return !0;
        }
      return !1;
    }
  }
}
function J_(e) {
  return n;
  function n(r, i) {
    let a = -1, o;
    for (; ++a <= r.length; )
      o === void 0 ? r[a] && r[a][1].type === "data" && (o = a, a++) : (!r[a] || r[a][1].type !== "data") && (a !== o + 2 && (r[o][1].end = r[a - 1][1].end, r.splice(o + 2, a - o - 2), a = o + 2), o = void 0);
    return e ? e(r, i) : r;
  }
}
function OO(e, n) {
  let r = 0;
  for (; ++r <= e.length; )
    if ((r === e.length || e[r][1].type === "lineEnding") && e[r - 1][1].type === "data") {
      const i = e[r - 1][1], a = n.sliceStream(i);
      let o = a.length, s = -1, l = 0, d;
      for (; o--; ) {
        const m = a[o];
        if (typeof m == "string") {
          for (s = m.length; m.charCodeAt(s - 1) === 32; )
            l++, s--;
          if (s) break;
          s = -1;
        } else if (m === -2)
          d = !0, l++;
        else if (m !== -1) {
          o++;
          break;
        }
      }
      if (l) {
        const m = {
          type: r === e.length || d || l < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: o ? s : i.start._bufferIndex + s,
            _index: i.start._index + o,
            line: i.end.line,
            column: i.end.column - l,
            offset: i.end.offset - l
          },
          end: {
            ...i.end
          }
        };
        i.end = {
          ...m.start
        }, i.start.offset === i.end.offset ? Object.assign(i, m) : (e.splice(r, 0, ["enter", m, n], ["exit", m, n]), r += 2);
      }
      r++;
    }
  return e;
}
const AO = {
  42: Yt,
  43: Yt,
  45: Yt,
  48: Yt,
  49: Yt,
  50: Yt,
  51: Yt,
  52: Yt,
  53: Yt,
  54: Yt,
  55: Yt,
  56: Yt,
  57: Yt,
  62: B_
}, PO = {
  91: UR
}, LO = {
  [-2]: ku,
  [-1]: ku,
  32: ku
}, VO = {
  35: GR,
  42: ks,
  45: [zv, ks],
  60: JR,
  61: zv,
  95: ks,
  96: Lv,
  126: Lv
}, zO = {
  38: H_,
  92: q_
}, UO = {
  [-5]: bu,
  [-4]: bu,
  [-3]: bu,
  33: hO,
  38: H_,
  42: Nm,
  60: [gR, iO],
  91: gO,
  92: [HR, q_],
  93: Pp,
  95: Nm,
  96: ER
}, MO = {
  null: [Nm, $O]
}, BO = {
  null: [42, 95]
}, qO = {
  null: []
}, HO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: BO,
  contentInitial: PO,
  disable: qO,
  document: AO,
  flow: VO,
  flowInitial: LO,
  insideSpan: MO,
  string: zO,
  text: UO
}, Symbol.toStringTag, { value: "Module" }));
function WO(e, n, r) {
  let i = {
    _bufferIndex: -1,
    _index: 0,
    line: r && r.line || 1,
    column: r && r.column || 1,
    offset: r && r.offset || 0
  };
  const a = {}, o = [];
  let s = [], l = [];
  const d = {
    attempt: U(I),
    check: U(T),
    consume: y,
    enter: z,
    exit: $,
    interrupt: U(T, {
      interrupt: !0
    })
  }, m = {
    code: null,
    containerState: {},
    defineSkip: S,
    events: [],
    now: C,
    parser: e,
    previous: null,
    sliceSerialize: h,
    sliceStream: g,
    write: f
  };
  let u = n.tokenize.call(m, d);
  return n.resolveAll && o.push(n), m;
  function f(X) {
    return s = ur(s, X), N(), s[s.length - 1] !== null ? [] : (Q(n, 0), m.events = Ap(o, m.events, m), m.events);
  }
  function h(X, B) {
    return KO(g(X), B);
  }
  function g(X) {
    return GO(s, X);
  }
  function C() {
    const {
      _bufferIndex: X,
      _index: B,
      line: O,
      column: q,
      offset: ee
    } = i;
    return {
      _bufferIndex: X,
      _index: B,
      line: O,
      column: q,
      offset: ee
    };
  }
  function S(X) {
    a[X.line] = X.column, ae();
  }
  function N() {
    let X;
    for (; i._index < s.length; ) {
      const B = s[i._index];
      if (typeof B == "string")
        for (X = i._index, i._bufferIndex < 0 && (i._bufferIndex = 0); i._index === X && i._bufferIndex < B.length; )
          w(B.charCodeAt(i._bufferIndex));
      else
        w(B);
    }
  }
  function w(X) {
    u = u(X);
  }
  function y(X) {
    bn(X) ? (i.line++, i.column = 1, i.offset += X === -3 ? 2 : 1, ae()) : X !== -1 && (i.column++, i.offset++), i._bufferIndex < 0 ? i._index++ : (i._bufferIndex++, i._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    s[i._index].length && (i._bufferIndex = -1, i._index++)), m.previous = X;
  }
  function z(X, B) {
    const O = B || {};
    return O.type = X, O.start = C(), m.events.push(["enter", O, m]), l.push(O), O;
  }
  function $(X) {
    const B = l.pop();
    return B.end = C(), m.events.push(["exit", B, m]), B;
  }
  function I(X, B) {
    Q(X, B.from);
  }
  function T(X, B) {
    B.restore();
  }
  function U(X, B) {
    return O;
    function O(q, ee, ve) {
      let ue, ce, fe, W;
      return Array.isArray(q) ? (
        /* c8 ignore next 1 */
        Ie(q)
      ) : "tokenize" in q ? (
        // Looks like a construct.
        Ie([
          /** @type {Construct} */
          q
        ])
      ) : xe(q);
      function xe(Oe) {
        return Me;
        function Me($e) {
          const ze = $e !== null && Oe[$e], Re = $e !== null && Oe.null, an = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(ze) ? ze : ze ? [ze] : [],
            ...Array.isArray(Re) ? Re : Re ? [Re] : []
          ];
          return Ie(an)($e);
        }
      }
      function Ie(Oe) {
        return ue = Oe, ce = 0, Oe.length === 0 ? ve : K(Oe[ce]);
      }
      function K(Oe) {
        return Me;
        function Me($e) {
          return W = J(), fe = Oe, Oe.partial || (m.currentConstruct = Oe), Oe.name && m.parser.constructs.disable.null.includes(Oe.name) ? Be() : Oe.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            B ? Object.assign(Object.create(m), B) : m,
            d,
            qe,
            Be
          )($e);
        }
      }
      function qe(Oe) {
        return X(fe, W), ee;
      }
      function Be(Oe) {
        return W.restore(), ++ce < ue.length ? K(ue[ce]) : ve;
      }
    }
  }
  function Q(X, B) {
    X.resolveAll && !o.includes(X) && o.push(X), X.resolve && Pr(m.events, B, m.events.length - B, X.resolve(m.events.slice(B), m)), X.resolveTo && (m.events = X.resolveTo(m.events, m));
  }
  function J() {
    const X = C(), B = m.previous, O = m.currentConstruct, q = m.events.length, ee = Array.from(l);
    return {
      from: q,
      restore: ve
    };
    function ve() {
      i = X, m.previous = B, m.currentConstruct = O, m.events.length = q, l = ee, ae();
    }
  }
  function ae() {
    i.line in a && i.column < 2 && (i.column = a[i.line], i.offset += a[i.line] - 1);
  }
}
function GO(e, n) {
  const r = n.start._index, i = n.start._bufferIndex, a = n.end._index, o = n.end._bufferIndex;
  let s;
  if (r === a)
    s = [e[r].slice(i, o)];
  else {
    if (s = e.slice(r, a), i > -1) {
      const l = s[0];
      typeof l == "string" ? s[0] = l.slice(i) : s.shift();
    }
    o > 0 && s.push(e[a].slice(0, o));
  }
  return s;
}
function KO(e, n) {
  let r = -1;
  const i = [];
  let a;
  for (; ++r < e.length; ) {
    const o = e[r];
    let s;
    if (typeof o == "string")
      s = o;
    else switch (o) {
      case -5: {
        s = "\r";
        break;
      }
      case -4: {
        s = `
`;
        break;
      }
      case -3: {
        s = `\r
`;
        break;
      }
      case -2: {
        s = n ? " " : "	";
        break;
      }
      case -1: {
        if (!n && a) continue;
        s = " ";
        break;
      }
      default:
        s = String.fromCharCode(o);
    }
    a = o === -2, i.push(s);
  }
  return i.join("");
}
function YO(e) {
  const i = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      tR([HO, ...(e || {}).extensions || []])
    ),
    content: a(dR),
    defined: [],
    document: a(mR),
    flow: a(EO),
    lazy: {},
    string: a(DO),
    text: a(RO)
  };
  return i;
  function a(o) {
    return s;
    function s(l) {
      return WO(i, o, l);
    }
  }
}
function QO(e) {
  for (; !W_(e); )
    ;
  return e;
}
const Uv = /[\0\t\n\r]/g;
function JO() {
  let e = 1, n = "", r = !0, i;
  return a;
  function a(o, s, l) {
    const d = [];
    let m, u, f, h, g;
    for (o = n + (typeof o == "string" ? o.toString() : new TextDecoder(s || void 0).decode(o)), f = 0, n = "", r && (o.charCodeAt(0) === 65279 && f++, r = void 0); f < o.length; ) {
      if (Uv.lastIndex = f, m = Uv.exec(o), h = m && m.index !== void 0 ? m.index : o.length, g = o.charCodeAt(h), !m) {
        n = o.slice(f);
        break;
      }
      if (g === 10 && f === h && i)
        d.push(-3), i = void 0;
      else
        switch (i && (d.push(-5), i = void 0), f < h && (d.push(o.slice(f, h)), e += h - f), g) {
          case 0: {
            d.push(65533), e++;
            break;
          }
          case 9: {
            for (u = Math.ceil(e / 4) * 4, d.push(-2); e++ < u; ) d.push(-1);
            break;
          }
          case 10: {
            d.push(-4), e = 1;
            break;
          }
          default:
            i = !0, e = 1;
        }
      f = h + 1;
    }
    return l && (i && d.push(-5), n && d.push(n), d.push(null)), d;
  }
}
const XO = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function ZO(e) {
  return e.replace(XO, eA);
}
function eA(e, n, r) {
  if (n)
    return n;
  if (r.charCodeAt(0) === 35) {
    const a = r.charCodeAt(1), o = a === 120 || a === 88;
    return M_(r.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return Op(r) || e;
}
const X_ = {}.hasOwnProperty;
function nA(e, n, r) {
  return typeof n != "string" && (r = n, n = void 0), tA(r)(QO(YO(r).document().write(JO()(e, n, !0))));
}
function tA(e) {
  const n = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: o(Ae),
      autolinkProtocol: J,
      autolinkEmail: J,
      atxHeading: o(he),
      blockQuote: o(Re),
      characterEscape: J,
      characterReference: J,
      codeFenced: o(an),
      codeFencedFenceInfo: s,
      codeFencedFenceMeta: s,
      codeIndented: o(an, s),
      codeText: o(Ee, s),
      codeTextData: J,
      data: J,
      codeFlowValue: J,
      definition: o(Ge),
      definitionDestinationString: s,
      definitionLabelString: s,
      definitionTitleString: s,
      emphasis: o(Qe),
      hardBreakEscape: o(ge),
      hardBreakTrailing: o(ge),
      htmlFlow: o(De, s),
      htmlFlowData: J,
      htmlText: o(De, s),
      htmlTextData: J,
      image: o(Le),
      label: s,
      link: o(Ae),
      listItem: o(E),
      listItemValue: h,
      listOrdered: o(mn, f),
      listUnordered: o(mn),
      paragraph: o(x),
      reference: K,
      referenceString: s,
      resourceDestinationString: s,
      resourceTitleString: s,
      setextHeading: o(he),
      strong: o(D),
      thematicBreak: o(Y)
    },
    exit: {
      atxHeading: d(),
      atxHeadingSequence: I,
      autolink: d(),
      autolinkEmail: ze,
      autolinkProtocol: $e,
      blockQuote: d(),
      characterEscapeValue: ae,
      characterReferenceMarkerHexadecimal: Be,
      characterReferenceMarkerNumeric: Be,
      characterReferenceValue: Oe,
      characterReference: Me,
      codeFenced: d(N),
      codeFencedFence: S,
      codeFencedFenceInfo: g,
      codeFencedFenceMeta: C,
      codeFlowValue: ae,
      codeIndented: d(w),
      codeText: d(ee),
      codeTextData: ae,
      data: ae,
      definition: d(),
      definitionDestinationString: $,
      definitionLabelString: y,
      definitionTitleString: z,
      emphasis: d(),
      hardBreakEscape: d(B),
      hardBreakTrailing: d(B),
      htmlFlow: d(O),
      htmlFlowData: ae,
      htmlText: d(q),
      htmlTextData: ae,
      image: d(ue),
      label: fe,
      labelText: ce,
      lineEnding: X,
      link: d(ve),
      listItem: d(),
      listOrdered: d(),
      listUnordered: d(),
      paragraph: d(),
      referenceString: qe,
      resourceDestinationString: W,
      resourceTitleString: xe,
      resource: Ie,
      setextHeading: d(Q),
      setextHeadingLineSequence: U,
      setextHeadingText: T,
      strong: d(),
      thematicBreak: d()
    }
  };
  Z_(n, (e || {}).mdastExtensions || []);
  const r = {};
  return i;
  function i(R) {
    let V = {
      type: "root",
      children: []
    };
    const ie = {
      stack: [V],
      tokenStack: [],
      config: n,
      enter: l,
      exit: m,
      buffer: s,
      resume: u,
      data: r
    }, me = [];
    let Ne = -1;
    for (; ++Ne < R.length; )
      if (R[Ne][1].type === "listOrdered" || R[Ne][1].type === "listUnordered")
        if (R[Ne][0] === "enter")
          me.push(Ne);
        else {
          const nn = me.pop();
          Ne = a(R, nn, Ne);
        }
    for (Ne = -1; ++Ne < R.length; ) {
      const nn = n[R[Ne][0]];
      X_.call(nn, R[Ne][1].type) && nn[R[Ne][1].type].call(Object.assign({
        sliceSerialize: R[Ne][2].sliceSerialize
      }, ie), R[Ne][1]);
    }
    if (ie.tokenStack.length > 0) {
      const nn = ie.tokenStack[ie.tokenStack.length - 1];
      (nn[1] || Mv).call(ie, void 0, nn[0]);
    }
    for (V.position = {
      start: Zr(R.length > 0 ? R[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: Zr(R.length > 0 ? R[R.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, Ne = -1; ++Ne < n.transforms.length; )
      V = n.transforms[Ne](V) || V;
    return V;
  }
  function a(R, V, ie) {
    let me = V - 1, Ne = -1, nn = !1, fn, tn, cn, pn;
    for (; ++me <= ie; ) {
      const dn = R[me];
      switch (dn[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          dn[0] === "enter" ? Ne++ : Ne--, pn = void 0;
          break;
        }
        case "lineEndingBlank": {
          dn[0] === "enter" && (fn && !pn && !Ne && !cn && (cn = me), pn = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          pn = void 0;
      }
      if (!Ne && dn[0] === "enter" && dn[1].type === "listItemPrefix" || Ne === -1 && dn[0] === "exit" && (dn[1].type === "listUnordered" || dn[1].type === "listOrdered")) {
        if (fn) {
          let xn = me;
          for (tn = void 0; xn--; ) {
            const en = R[xn];
            if (en[1].type === "lineEnding" || en[1].type === "lineEndingBlank") {
              if (en[0] === "exit") continue;
              tn && (R[tn][1].type = "lineEndingBlank", nn = !0), en[1].type = "lineEnding", tn = xn;
            } else if (!(en[1].type === "linePrefix" || en[1].type === "blockQuotePrefix" || en[1].type === "blockQuotePrefixWhitespace" || en[1].type === "blockQuoteMarker" || en[1].type === "listItemIndent")) break;
          }
          cn && (!tn || cn < tn) && (fn._spread = !0), fn.end = Object.assign({}, tn ? R[tn][1].start : dn[1].end), R.splice(tn || me, 0, ["exit", fn, dn[2]]), me++, ie++;
        }
        if (dn[1].type === "listItemPrefix") {
          const xn = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, dn[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          fn = xn, R.splice(me, 0, ["enter", xn, dn[2]]), me++, ie++, cn = void 0, pn = !0;
        }
      }
    }
    return R[V][1]._spread = nn, ie;
  }
  function o(R, V) {
    return ie;
    function ie(me) {
      l.call(this, R(me), me), V && V.call(this, me);
    }
  }
  function s() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function l(R, V, ie) {
    this.stack[this.stack.length - 1].children.push(R), this.stack.push(R), this.tokenStack.push([V, ie || void 0]), R.position = {
      start: Zr(V.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function d(R) {
    return V;
    function V(ie) {
      R && R.call(this, ie), m.call(this, ie);
    }
  }
  function m(R, V) {
    const ie = this.stack.pop(), me = this.tokenStack.pop();
    if (me)
      me[0].type !== R.type && (V ? V.call(this, R, me[0]) : (me[1] || Mv).call(this, R, me[0]));
    else throw new Error("Cannot close `" + R.type + "` (" + io({
      start: R.start,
      end: R.end
    }) + "): it’s not open");
    ie.position.end = Zr(R.end);
  }
  function u() {
    return eR(this.stack.pop());
  }
  function f() {
    this.data.expectingFirstListItemValue = !0;
  }
  function h(R) {
    if (this.data.expectingFirstListItemValue) {
      const V = this.stack[this.stack.length - 2];
      V.start = Number.parseInt(this.sliceSerialize(R), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function g() {
    const R = this.resume(), V = this.stack[this.stack.length - 1];
    V.lang = R;
  }
  function C() {
    const R = this.resume(), V = this.stack[this.stack.length - 1];
    V.meta = R;
  }
  function S() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function N() {
    const R = this.resume(), V = this.stack[this.stack.length - 1];
    V.value = R.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function w() {
    const R = this.resume(), V = this.stack[this.stack.length - 1];
    V.value = R.replace(/(\r?\n|\r)$/g, "");
  }
  function y(R) {
    const V = this.resume(), ie = this.stack[this.stack.length - 1];
    ie.label = V, ie.identifier = ta(this.sliceSerialize(R)).toLowerCase();
  }
  function z() {
    const R = this.resume(), V = this.stack[this.stack.length - 1];
    V.title = R;
  }
  function $() {
    const R = this.resume(), V = this.stack[this.stack.length - 1];
    V.url = R;
  }
  function I(R) {
    const V = this.stack[this.stack.length - 1];
    if (!V.depth) {
      const ie = this.sliceSerialize(R).length;
      V.depth = ie;
    }
  }
  function T() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function U(R) {
    const V = this.stack[this.stack.length - 1];
    V.depth = this.sliceSerialize(R).codePointAt(0) === 61 ? 1 : 2;
  }
  function Q() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function J(R) {
    const ie = this.stack[this.stack.length - 1].children;
    let me = ie[ie.length - 1];
    (!me || me.type !== "text") && (me = H(), me.position = {
      start: Zr(R.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, ie.push(me)), this.stack.push(me);
  }
  function ae(R) {
    const V = this.stack.pop();
    V.value += this.sliceSerialize(R), V.position.end = Zr(R.end);
  }
  function X(R) {
    const V = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const ie = V.children[V.children.length - 1];
      ie.position.end = Zr(R.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && n.canContainEols.includes(V.type) && (J.call(this, R), ae.call(this, R));
  }
  function B() {
    this.data.atHardBreak = !0;
  }
  function O() {
    const R = this.resume(), V = this.stack[this.stack.length - 1];
    V.value = R;
  }
  function q() {
    const R = this.resume(), V = this.stack[this.stack.length - 1];
    V.value = R;
  }
  function ee() {
    const R = this.resume(), V = this.stack[this.stack.length - 1];
    V.value = R;
  }
  function ve() {
    const R = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const V = this.data.referenceType || "shortcut";
      R.type += "Reference", R.referenceType = V, delete R.url, delete R.title;
    } else
      delete R.identifier, delete R.label;
    this.data.referenceType = void 0;
  }
  function ue() {
    const R = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const V = this.data.referenceType || "shortcut";
      R.type += "Reference", R.referenceType = V, delete R.url, delete R.title;
    } else
      delete R.identifier, delete R.label;
    this.data.referenceType = void 0;
  }
  function ce(R) {
    const V = this.sliceSerialize(R), ie = this.stack[this.stack.length - 2];
    ie.label = ZO(V), ie.identifier = ta(V).toLowerCase();
  }
  function fe() {
    const R = this.stack[this.stack.length - 1], V = this.resume(), ie = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, ie.type === "link") {
      const me = R.children;
      ie.children = me;
    } else
      ie.alt = V;
  }
  function W() {
    const R = this.resume(), V = this.stack[this.stack.length - 1];
    V.url = R;
  }
  function xe() {
    const R = this.resume(), V = this.stack[this.stack.length - 1];
    V.title = R;
  }
  function Ie() {
    this.data.inReference = void 0;
  }
  function K() {
    this.data.referenceType = "collapsed";
  }
  function qe(R) {
    const V = this.resume(), ie = this.stack[this.stack.length - 1];
    ie.label = V, ie.identifier = ta(this.sliceSerialize(R)).toLowerCase(), this.data.referenceType = "full";
  }
  function Be(R) {
    this.data.characterReferenceType = R.type;
  }
  function Oe(R) {
    const V = this.sliceSerialize(R), ie = this.data.characterReferenceType;
    let me;
    ie ? (me = M_(V, ie === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : me = Op(V);
    const Ne = this.stack[this.stack.length - 1];
    Ne.value += me;
  }
  function Me(R) {
    const V = this.stack.pop();
    V.position.end = Zr(R.end);
  }
  function $e(R) {
    ae.call(this, R);
    const V = this.stack[this.stack.length - 1];
    V.url = this.sliceSerialize(R);
  }
  function ze(R) {
    ae.call(this, R);
    const V = this.stack[this.stack.length - 1];
    V.url = "mailto:" + this.sliceSerialize(R);
  }
  function Re() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function an() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function Ee() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function Ge() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function Qe() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function he() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function ge() {
    return {
      type: "break"
    };
  }
  function De() {
    return {
      type: "html",
      value: ""
    };
  }
  function Le() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Ae() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function mn(R) {
    return {
      type: "list",
      ordered: R.type === "listOrdered",
      start: null,
      spread: R._spread,
      children: []
    };
  }
  function E(R) {
    return {
      type: "listItem",
      spread: R._spread,
      checked: null,
      children: []
    };
  }
  function x() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function D() {
    return {
      type: "strong",
      children: []
    };
  }
  function H() {
    return {
      type: "text",
      value: ""
    };
  }
  function Y() {
    return {
      type: "thematicBreak"
    };
  }
}
function Zr(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function Z_(e, n) {
  let r = -1;
  for (; ++r < n.length; ) {
    const i = n[r];
    Array.isArray(i) ? Z_(e, i) : rA(e, i);
  }
}
function rA(e, n) {
  let r;
  for (r in n)
    if (X_.call(n, r))
      switch (r) {
        case "canContainEols": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "transforms": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "enter":
        case "exit": {
          const i = n[r];
          i && Object.assign(e[r], i);
          break;
        }
      }
}
function Mv(e, n) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + io({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + n.type + "`, " + io({
    start: n.start,
    end: n.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + n.type + "`, " + io({
    start: n.start,
    end: n.end
  }) + ") is still open");
}
function iA(e) {
  const n = this;
  n.parser = r;
  function r(i) {
    return nA(i, {
      ...n.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: n.data("micromarkExtensions") || [],
      mdastExtensions: n.data("fromMarkdownExtensions") || []
    });
  }
}
function aA(e, n) {
  const r = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(n), !0)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function oA(e, n) {
  const r = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(n, r), [e.applyData(n, r), { type: "text", value: `
` }];
}
function sA(e, n) {
  const r = n.value ? n.value + `
` : "", i = {}, a = n.lang ? n.lang.split(/\s+/) : [];
  a.length > 0 && (i.className = ["language-" + a[0]]);
  let o = {
    type: "element",
    tagName: "code",
    properties: i,
    children: [{ type: "text", value: r }]
  };
  return n.meta && (o.data = { meta: n.meta }), e.patch(n, o), o = e.applyData(n, o), o = { type: "element", tagName: "pre", properties: {}, children: [o] }, e.patch(n, o), o;
}
function lA(e, n) {
  const r = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function cA(e, n) {
  const r = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function dA(e, n) {
  const r = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", i = String(n.identifier).toUpperCase(), a = ha(i.toLowerCase()), o = e.footnoteOrder.indexOf(i);
  let s, l = e.footnoteCounts.get(i);
  l === void 0 ? (l = 0, e.footnoteOrder.push(i), s = e.footnoteOrder.length) : s = o + 1, l += 1, e.footnoteCounts.set(i, l);
  const d = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + r + "fn-" + a,
      id: r + "fnref-" + a + (l > 1 ? "-" + l : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(s) }]
  };
  e.patch(n, d);
  const m = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [d]
  };
  return e.patch(n, m), e.applyData(n, m);
}
function uA(e, n) {
  const r = {
    type: "element",
    tagName: "h" + n.depth,
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function mA(e, n) {
  if (e.options.allowDangerousHtml) {
    const r = { type: "raw", value: n.value };
    return e.patch(n, r), e.applyData(n, r);
  }
}
function eS(e, n) {
  const r = n.referenceType;
  let i = "]";
  if (r === "collapsed" ? i += "[]" : r === "full" && (i += "[" + (n.label || n.identifier) + "]"), n.type === "imageReference")
    return [{ type: "text", value: "![" + n.alt + i }];
  const a = e.all(n), o = a[0];
  o && o.type === "text" ? o.value = "[" + o.value : a.unshift({ type: "text", value: "[" });
  const s = a[a.length - 1];
  return s && s.type === "text" ? s.value += i : a.push({ type: "text", value: i }), a;
}
function pA(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return eS(e, n);
  const a = { src: ha(i.url || ""), alt: n.alt };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = { type: "element", tagName: "img", properties: a, children: [] };
  return e.patch(n, o), e.applyData(n, o);
}
function fA(e, n) {
  const r = { src: ha(n.url) };
  n.alt !== null && n.alt !== void 0 && (r.alt = n.alt), n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = { type: "element", tagName: "img", properties: r, children: [] };
  return e.patch(n, i), e.applyData(n, i);
}
function hA(e, n) {
  const r = { type: "text", value: n.value.replace(/\r?\n|\r/g, " ") };
  e.patch(n, r);
  const i = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [r]
  };
  return e.patch(n, i), e.applyData(n, i);
}
function yA(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return eS(e, n);
  const a = { href: ha(i.url || "") };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = {
    type: "element",
    tagName: "a",
    properties: a,
    children: e.all(n)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function gA(e, n) {
  const r = { href: ha(n.url) };
  n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: r,
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function vA(e, n, r) {
  const i = e.all(n), a = r ? kA(r) : nS(n), o = {}, s = [];
  if (typeof n.checked == "boolean") {
    const u = i[0];
    let f;
    u && u.type === "element" && u.tagName === "p" ? f = u : (f = { type: "element", tagName: "p", properties: {}, children: [] }, i.unshift(f)), f.children.length > 0 && f.children.unshift({ type: "text", value: " " }), f.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: n.checked, disabled: !0 },
      children: []
    }), o.className = ["task-list-item"];
  }
  let l = -1;
  for (; ++l < i.length; ) {
    const u = i[l];
    (a || l !== 0 || u.type !== "element" || u.tagName !== "p") && s.push({ type: "text", value: `
` }), u.type === "element" && u.tagName === "p" && !a ? s.push(...u.children) : s.push(u);
  }
  const d = i[i.length - 1];
  d && (a || d.type !== "element" || d.tagName !== "p") && s.push({ type: "text", value: `
` });
  const m = { type: "element", tagName: "li", properties: o, children: s };
  return e.patch(n, m), e.applyData(n, m);
}
function kA(e) {
  let n = !1;
  if (e.type === "list") {
    n = e.spread || !1;
    const r = e.children;
    let i = -1;
    for (; !n && ++i < r.length; )
      n = nS(r[i]);
  }
  return n;
}
function nS(e) {
  const n = e.spread;
  return n ?? e.children.length > 1;
}
function bA(e, n) {
  const r = {}, i = e.all(n);
  let a = -1;
  for (typeof n.start == "number" && n.start !== 1 && (r.start = n.start); ++a < i.length; ) {
    const s = i[a];
    if (s.type === "element" && s.tagName === "li" && s.properties && Array.isArray(s.properties.className) && s.properties.className.includes("task-list-item")) {
      r.className = ["contains-task-list"];
      break;
    }
  }
  const o = {
    type: "element",
    tagName: n.ordered ? "ol" : "ul",
    properties: r,
    children: e.wrap(i, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function xA(e, n) {
  const r = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function _A(e, n) {
  const r = { type: "root", children: e.wrap(e.all(n)) };
  return e.patch(n, r), e.applyData(n, r);
}
function SA(e, n) {
  const r = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function NA(e, n) {
  const r = e.all(n), i = r.shift(), a = [];
  if (i) {
    const s = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([i], !0)
    };
    e.patch(n.children[0], s), a.push(s);
  }
  if (r.length > 0) {
    const s = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(r, !0)
    }, l = Tp(n.children[1]), d = O_(n.children[n.children.length - 1]);
    l && d && (s.position = { start: l, end: d }), a.push(s);
  }
  const o = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(a, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function jA(e, n, r) {
  const i = r ? r.children : void 0, o = (i ? i.indexOf(n) : 1) === 0 ? "th" : "td", s = r && r.type === "table" ? r.align : void 0, l = s ? s.length : n.children.length;
  let d = -1;
  const m = [];
  for (; ++d < l; ) {
    const f = n.children[d], h = {}, g = s ? s[d] : void 0;
    g && (h.align = g);
    let C = { type: "element", tagName: o, properties: h, children: [] };
    f && (C.children = e.all(f), e.patch(f, C), C = e.applyData(f, C)), m.push(C);
  }
  const u = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(m, !0)
  };
  return e.patch(n, u), e.applyData(n, u);
}
function wA(e, n) {
  const r = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
const Bv = 9, qv = 32;
function CA(e) {
  const n = String(e), r = /\r?\n|\r/g;
  let i = r.exec(n), a = 0;
  const o = [];
  for (; i; )
    o.push(
      Hv(n.slice(a, i.index), a > 0, !0),
      i[0]
    ), a = i.index + i[0].length, i = r.exec(n);
  return o.push(Hv(n.slice(a), a > 0, !1)), o.join("");
}
function Hv(e, n, r) {
  let i = 0, a = e.length;
  if (n) {
    let o = e.codePointAt(i);
    for (; o === Bv || o === qv; )
      i++, o = e.codePointAt(i);
  }
  if (r) {
    let o = e.codePointAt(a - 1);
    for (; o === Bv || o === qv; )
      a--, o = e.codePointAt(a - 1);
  }
  return a > i ? e.slice(i, a) : "";
}
function FA(e, n) {
  const r = { type: "text", value: CA(String(n.value)) };
  return e.patch(n, r), e.applyData(n, r);
}
function IA(e, n) {
  const r = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(n, r), e.applyData(n, r);
}
const EA = {
  blockquote: aA,
  break: oA,
  code: sA,
  delete: lA,
  emphasis: cA,
  footnoteReference: dA,
  heading: uA,
  html: mA,
  imageReference: pA,
  image: fA,
  inlineCode: hA,
  linkReference: yA,
  link: gA,
  listItem: vA,
  list: bA,
  paragraph: xA,
  // @ts-expect-error: root is different, but hard to type.
  root: _A,
  strong: SA,
  table: NA,
  tableCell: wA,
  tableRow: jA,
  text: FA,
  thematicBreak: IA,
  toml: Mo,
  yaml: Mo,
  definition: Mo,
  footnoteDefinition: Mo
};
function Mo() {
}
const tS = -1, dl = 0, Ds = 1, Rs = 2, Lp = 3, Vp = 4, zp = 5, Up = 6, rS = 7, iS = 8, Wv = typeof self == "object" ? self : globalThis, TA = (e, n) => {
  const r = (a, o) => (e.set(o, a), a), i = (a) => {
    if (e.has(a))
      return e.get(a);
    const [o, s] = n[a];
    switch (o) {
      case dl:
      case tS:
        return r(s, a);
      case Ds: {
        const l = r([], a);
        for (const d of s)
          l.push(i(d));
        return l;
      }
      case Rs: {
        const l = r({}, a);
        for (const [d, m] of s)
          l[i(d)] = i(m);
        return l;
      }
      case Lp:
        return r(new Date(s), a);
      case Vp: {
        const { source: l, flags: d } = s;
        return r(new RegExp(l, d), a);
      }
      case zp: {
        const l = r(/* @__PURE__ */ new Map(), a);
        for (const [d, m] of s)
          l.set(i(d), i(m));
        return l;
      }
      case Up: {
        const l = r(/* @__PURE__ */ new Set(), a);
        for (const d of s)
          l.add(i(d));
        return l;
      }
      case rS: {
        const { name: l, message: d } = s;
        return r(new Wv[l](d), a);
      }
      case iS:
        return r(BigInt(s), a);
      case "BigInt":
        return r(Object(BigInt(s)), a);
    }
    return r(new Wv[o](s), a);
  };
  return i;
}, Gv = (e) => TA(/* @__PURE__ */ new Map(), e)(0), Ui = "", { toString: $A } = {}, { keys: DA } = Object, $a = (e) => {
  const n = typeof e;
  if (n !== "object" || !e)
    return [dl, n];
  const r = $A.call(e).slice(8, -1);
  switch (r) {
    case "Array":
      return [Ds, Ui];
    case "Object":
      return [Rs, Ui];
    case "Date":
      return [Lp, Ui];
    case "RegExp":
      return [Vp, Ui];
    case "Map":
      return [zp, Ui];
    case "Set":
      return [Up, Ui];
  }
  return r.includes("Array") ? [Ds, r] : r.includes("Error") ? [rS, r] : [Rs, r];
}, Bo = ([e, n]) => e === dl && (n === "function" || n === "symbol"), RA = (e, n, r, i) => {
  const a = (s, l) => {
    const d = i.push(s) - 1;
    return r.set(l, d), d;
  }, o = (s) => {
    if (r.has(s))
      return r.get(s);
    let [l, d] = $a(s);
    switch (l) {
      case dl: {
        let u = s;
        switch (d) {
          case "bigint":
            l = iS, u = s.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + d);
            u = null;
            break;
          case "undefined":
            return a([tS], s);
        }
        return a([l, u], s);
      }
      case Ds: {
        if (d)
          return a([d, [...s]], s);
        const u = [], f = a([l, u], s);
        for (const h of s)
          u.push(o(h));
        return f;
      }
      case Rs: {
        if (d)
          switch (d) {
            case "BigInt":
              return a([d, s.toString()], s);
            case "Boolean":
            case "Number":
            case "String":
              return a([d, s.valueOf()], s);
          }
        if (n && "toJSON" in s)
          return o(s.toJSON());
        const u = [], f = a([l, u], s);
        for (const h of DA(s))
          (e || !Bo($a(s[h]))) && u.push([o(h), o(s[h])]);
        return f;
      }
      case Lp:
        return a([l, s.toISOString()], s);
      case Vp: {
        const { source: u, flags: f } = s;
        return a([l, { source: u, flags: f }], s);
      }
      case zp: {
        const u = [], f = a([l, u], s);
        for (const [h, g] of s)
          (e || !(Bo($a(h)) || Bo($a(g)))) && u.push([o(h), o(g)]);
        return f;
      }
      case Up: {
        const u = [], f = a([l, u], s);
        for (const h of s)
          (e || !Bo($a(h))) && u.push(o(h));
        return f;
      }
    }
    const { message: m } = s;
    return a([l, { name: d, message: m }], s);
  };
  return o;
}, Kv = (e, { json: n, lossy: r } = {}) => {
  const i = [];
  return RA(!(n || r), !!n, /* @__PURE__ */ new Map(), i)(e), i;
}, Os = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, n) => n && ("json" in n || "lossy" in n) ? Gv(Kv(e, n)) : structuredClone(e)
) : (e, n) => Gv(Kv(e, n));
function OA(e, n) {
  const r = [{ type: "text", value: "↩" }];
  return n > 1 && r.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(n) }]
  }), r;
}
function AA(e, n) {
  return "Back to reference " + (e + 1) + (n > 1 ? "-" + n : "");
}
function PA(e) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = e.options.footnoteBackContent || OA, i = e.options.footnoteBackLabel || AA, a = e.options.footnoteLabel || "Footnotes", o = e.options.footnoteLabelTagName || "h2", s = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, l = [];
  let d = -1;
  for (; ++d < e.footnoteOrder.length; ) {
    const m = e.footnoteById.get(
      e.footnoteOrder[d]
    );
    if (!m)
      continue;
    const u = e.all(m), f = String(m.identifier).toUpperCase(), h = ha(f.toLowerCase());
    let g = 0;
    const C = [], S = e.footnoteCounts.get(f);
    for (; S !== void 0 && ++g <= S; ) {
      C.length > 0 && C.push({ type: "text", value: " " });
      let y = typeof r == "string" ? r : r(d, g);
      typeof y == "string" && (y = { type: "text", value: y }), C.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + n + "fnref-" + h + (g > 1 ? "-" + g : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof i == "string" ? i : i(d, g),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(y) ? y : [y]
      });
    }
    const N = u[u.length - 1];
    if (N && N.type === "element" && N.tagName === "p") {
      const y = N.children[N.children.length - 1];
      y && y.type === "text" ? y.value += " " : N.children.push({ type: "text", value: " " }), N.children.push(...C);
    } else
      u.push(...C);
    const w = {
      type: "element",
      tagName: "li",
      properties: { id: n + "fn-" + h },
      children: e.wrap(u, !0)
    };
    e.patch(m, w), l.push(w);
  }
  if (l.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: o,
          properties: {
            ...Os(s),
            id: "footnote-label"
          },
          children: [{ type: "text", value: a }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(l, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const aS = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  (function(e) {
    if (e == null)
      return UA;
    if (typeof e == "function")
      return ul(e);
    if (typeof e == "object")
      return Array.isArray(e) ? LA(e) : VA(e);
    if (typeof e == "string")
      return zA(e);
    throw new Error("Expected function, string, or object as test");
  })
);
function LA(e) {
  const n = [];
  let r = -1;
  for (; ++r < e.length; )
    n[r] = aS(e[r]);
  return ul(i);
  function i(...a) {
    let o = -1;
    for (; ++o < n.length; )
      if (n[o].apply(this, a)) return !0;
    return !1;
  }
}
function VA(e) {
  const n = (
    /** @type {Record<string, unknown>} */
    e
  );
  return ul(r);
  function r(i) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      i
    );
    let o;
    for (o in e)
      if (a[o] !== n[o]) return !1;
    return !0;
  }
}
function zA(e) {
  return ul(n);
  function n(r) {
    return r && r.type === e;
  }
}
function ul(e) {
  return n;
  function n(r, i, a) {
    return !!(MA(r) && e.call(
      this,
      r,
      typeof i == "number" ? i : void 0,
      a || void 0
    ));
  }
}
function UA() {
  return !0;
}
function MA(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const oS = [], BA = !0, Yv = !1, qA = "skip";
function HA(e, n, r, i) {
  let a;
  typeof n == "function" && typeof r != "function" ? (i = r, r = n) : a = n;
  const o = aS(a), s = i ? -1 : 1;
  l(e, void 0, [])();
  function l(d, m, u) {
    const f = (
      /** @type {Record<string, unknown>} */
      d && typeof d == "object" ? d : {}
    );
    if (typeof f.type == "string") {
      const g = (
        // `hast`
        typeof f.tagName == "string" ? f.tagName : (
          // `xast`
          typeof f.name == "string" ? f.name : void 0
        )
      );
      Object.defineProperty(h, "name", {
        value: "node (" + (d.type + (g ? "<" + g + ">" : "")) + ")"
      });
    }
    return h;
    function h() {
      let g = oS, C, S, N;
      if ((!n || o(d, m, u[u.length - 1] || void 0)) && (g = WA(r(d, u)), g[0] === Yv))
        return g;
      if ("children" in d && d.children) {
        const w = (
          /** @type {UnistParent} */
          d
        );
        if (w.children && g[0] !== qA)
          for (S = (i ? w.children.length : -1) + s, N = u.concat(w); S > -1 && S < w.children.length; ) {
            const y = w.children[S];
            if (C = l(y, S, N)(), C[0] === Yv)
              return C;
            S = typeof C[1] == "number" ? C[1] : S + s;
          }
      }
      return g;
    }
  }
}
function WA(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [BA, e] : e == null ? oS : [e];
}
function sS(e, n, r, i) {
  let a, o, s;
  typeof n == "function" && typeof r != "function" ? (o = void 0, s = n, a = r) : (o = n, s = r, a = i), HA(e, o, l, a);
  function l(d, m) {
    const u = m[m.length - 1], f = u ? u.children.indexOf(d) : void 0;
    return s(d, f, u);
  }
}
const jm = {}.hasOwnProperty, GA = {};
function KA(e, n) {
  const r = n || GA, i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), s = { ...EA, ...r.handlers }, l = {
    all: m,
    applyData: QA,
    definitionById: i,
    footnoteById: a,
    footnoteCounts: o,
    footnoteOrder: [],
    handlers: s,
    one: d,
    options: r,
    patch: YA,
    wrap: XA
  };
  return sS(e, function(u) {
    if (u.type === "definition" || u.type === "footnoteDefinition") {
      const f = u.type === "definition" ? i : a, h = String(u.identifier).toUpperCase();
      f.has(h) || f.set(h, u);
    }
  }), l;
  function d(u, f) {
    const h = u.type, g = l.handlers[h];
    if (jm.call(l.handlers, h) && g)
      return g(l, u, f);
    if (l.options.passThrough && l.options.passThrough.includes(h)) {
      if ("children" in u) {
        const { children: S, ...N } = u, w = Os(N);
        return w.children = l.all(u), w;
      }
      return Os(u);
    }
    return (l.options.unknownHandler || JA)(l, u, f);
  }
  function m(u) {
    const f = [];
    if ("children" in u) {
      const h = u.children;
      let g = -1;
      for (; ++g < h.length; ) {
        const C = l.one(h[g], u);
        if (C) {
          if (g && h[g - 1].type === "break" && (!Array.isArray(C) && C.type === "text" && (C.value = Qv(C.value)), !Array.isArray(C) && C.type === "element")) {
            const S = C.children[0];
            S && S.type === "text" && (S.value = Qv(S.value));
          }
          Array.isArray(C) ? f.push(...C) : f.push(C);
        }
      }
    }
    return f;
  }
}
function YA(e, n) {
  e.position && (n.position = ED(e));
}
function QA(e, n) {
  let r = n;
  if (e && e.data) {
    const i = e.data.hName, a = e.data.hChildren, o = e.data.hProperties;
    if (typeof i == "string")
      if (r.type === "element")
        r.tagName = i;
      else {
        const s = "children" in r ? r.children : [r];
        r = { type: "element", tagName: i, properties: {}, children: s };
      }
    r.type === "element" && o && Object.assign(r.properties, Os(o)), "children" in r && r.children && a !== null && a !== void 0 && (r.children = a);
  }
  return r;
}
function JA(e, n) {
  const r = n.data || {}, i = "value" in n && !(jm.call(r, "hProperties") || jm.call(r, "hChildren")) ? { type: "text", value: n.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function XA(e, n) {
  const r = [];
  let i = -1;
  for (n && r.push({ type: "text", value: `
` }); ++i < e.length; )
    i && r.push({ type: "text", value: `
` }), r.push(e[i]);
  return n && e.length > 0 && r.push({ type: "text", value: `
` }), r;
}
function Qv(e) {
  let n = 0, r = e.charCodeAt(n);
  for (; r === 9 || r === 32; )
    n++, r = e.charCodeAt(n);
  return e.slice(n);
}
function Jv(e, n) {
  const r = KA(e, n), i = r.one(e, void 0), a = PA(r), o = Array.isArray(i) ? { type: "root", children: i } : i || { type: "root", children: [] };
  return a && o.children.push({ type: "text", value: `
` }, a), o;
}
function ZA(e, n) {
  return e && "run" in e ? async function(r, i) {
    const a = (
      /** @type {HastRoot} */
      Jv(r, { file: i, ...n })
    );
    await e.run(a, i);
  } : function(r, i) {
    return (
      /** @type {HastRoot} */
      Jv(r, { file: i, ...e || n })
    );
  };
}
function Xv(e) {
  if (e)
    throw e;
}
var xu, Zv;
function eP() {
  if (Zv) return xu;
  Zv = 1;
  var e = Object.prototype.hasOwnProperty, n = Object.prototype.toString, r = Object.defineProperty, i = Object.getOwnPropertyDescriptor, a = function(m) {
    return typeof Array.isArray == "function" ? Array.isArray(m) : n.call(m) === "[object Array]";
  }, o = function(m) {
    if (!m || n.call(m) !== "[object Object]")
      return !1;
    var u = e.call(m, "constructor"), f = m.constructor && m.constructor.prototype && e.call(m.constructor.prototype, "isPrototypeOf");
    if (m.constructor && !u && !f)
      return !1;
    var h;
    for (h in m)
      ;
    return typeof h > "u" || e.call(m, h);
  }, s = function(m, u) {
    r && u.name === "__proto__" ? r(m, u.name, {
      enumerable: !0,
      configurable: !0,
      value: u.newValue,
      writable: !0
    }) : m[u.name] = u.newValue;
  }, l = function(m, u) {
    if (u === "__proto__")
      if (e.call(m, u)) {
        if (i)
          return i(m, u).value;
      } else return;
    return m[u];
  };
  return xu = function d() {
    var m, u, f, h, g, C, S = arguments[0], N = 1, w = arguments.length, y = !1;
    for (typeof S == "boolean" && (y = S, S = arguments[1] || {}, N = 2), (S == null || typeof S != "object" && typeof S != "function") && (S = {}); N < w; ++N)
      if (m = arguments[N], m != null)
        for (u in m)
          f = l(S, u), h = l(m, u), S !== h && (y && h && (o(h) || (g = a(h))) ? (g ? (g = !1, C = f && a(f) ? f : []) : C = f && o(f) ? f : {}, s(S, { name: u, newValue: d(y, C, h) })) : typeof h < "u" && s(S, { name: u, newValue: h }));
    return S;
  }, xu;
}
var nP = eP();
const _u = /* @__PURE__ */ Gm(nP);
function wm(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const n = Object.getPrototypeOf(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function tP() {
  const e = [], n = { run: r, use: i };
  return n;
  function r(...a) {
    let o = -1;
    const s = a.pop();
    if (typeof s != "function")
      throw new TypeError("Expected function as last argument, not " + s);
    l(null, ...a);
    function l(d, ...m) {
      const u = e[++o];
      let f = -1;
      if (d) {
        s(d);
        return;
      }
      for (; ++f < a.length; )
        (m[f] === null || m[f] === void 0) && (m[f] = a[f]);
      a = m, u ? rP(u, l)(...m) : s(null, ...m);
    }
  }
  function i(a) {
    if (typeof a != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + a
      );
    return e.push(a), n;
  }
}
function rP(e, n) {
  let r;
  return i;
  function i(...s) {
    const l = e.length > s.length;
    let d;
    l && s.push(a);
    try {
      d = e.apply(this, s);
    } catch (m) {
      const u = (
        /** @type {Error} */
        m
      );
      if (l && r)
        throw u;
      return a(u);
    }
    l || (d instanceof Promise ? d.then(o, a) : d instanceof Error ? a(d) : o(d));
  }
  function a(s, ...l) {
    r || (r = !0, n(s, ...l));
  }
  function o(s) {
    a(null, s);
  }
}
const Ir = { basename: iP, dirname: aP, extname: oP, join: sP, sep: "/" };
function iP(e, n) {
  if (n !== void 0 && typeof n != "string")
    throw new TypeError('"ext" argument must be a string');
  Fo(e);
  let r = 0, i = -1, a = e.length, o;
  if (n === void 0 || n.length === 0 || n.length > e.length) {
    for (; a--; )
      if (e.codePointAt(a) === 47) {
        if (o) {
          r = a + 1;
          break;
        }
      } else i < 0 && (o = !0, i = a + 1);
    return i < 0 ? "" : e.slice(r, i);
  }
  if (n === e)
    return "";
  let s = -1, l = n.length - 1;
  for (; a--; )
    if (e.codePointAt(a) === 47) {
      if (o) {
        r = a + 1;
        break;
      }
    } else
      s < 0 && (o = !0, s = a + 1), l > -1 && (e.codePointAt(a) === n.codePointAt(l--) ? l < 0 && (i = a) : (l = -1, i = s));
  return r === i ? i = s : i < 0 && (i = e.length), e.slice(r, i);
}
function aP(e) {
  if (Fo(e), e.length === 0)
    return ".";
  let n = -1, r = e.length, i;
  for (; --r; )
    if (e.codePointAt(r) === 47) {
      if (i) {
        n = r;
        break;
      }
    } else i || (i = !0);
  return n < 0 ? e.codePointAt(0) === 47 ? "/" : "." : n === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, n);
}
function oP(e) {
  Fo(e);
  let n = e.length, r = -1, i = 0, a = -1, o = 0, s;
  for (; n--; ) {
    const l = e.codePointAt(n);
    if (l === 47) {
      if (s) {
        i = n + 1;
        break;
      }
      continue;
    }
    r < 0 && (s = !0, r = n + 1), l === 46 ? a < 0 ? a = n : o !== 1 && (o = 1) : a > -1 && (o = -1);
  }
  return a < 0 || r < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && a === r - 1 && a === i + 1 ? "" : e.slice(a, r);
}
function sP(...e) {
  let n = -1, r;
  for (; ++n < e.length; )
    Fo(e[n]), e[n] && (r = r === void 0 ? e[n] : r + "/" + e[n]);
  return r === void 0 ? "." : lP(r);
}
function lP(e) {
  Fo(e);
  const n = e.codePointAt(0) === 47;
  let r = cP(e, !n);
  return r.length === 0 && !n && (r = "."), r.length > 0 && e.codePointAt(e.length - 1) === 47 && (r += "/"), n ? "/" + r : r;
}
function cP(e, n) {
  let r = "", i = 0, a = -1, o = 0, s = -1, l, d;
  for (; ++s <= e.length; ) {
    if (s < e.length)
      l = e.codePointAt(s);
    else {
      if (l === 47)
        break;
      l = 47;
    }
    if (l === 47) {
      if (!(a === s - 1 || o === 1)) if (a !== s - 1 && o === 2) {
        if (r.length < 2 || i !== 2 || r.codePointAt(r.length - 1) !== 46 || r.codePointAt(r.length - 2) !== 46) {
          if (r.length > 2) {
            if (d = r.lastIndexOf("/"), d !== r.length - 1) {
              d < 0 ? (r = "", i = 0) : (r = r.slice(0, d), i = r.length - 1 - r.lastIndexOf("/")), a = s, o = 0;
              continue;
            }
          } else if (r.length > 0) {
            r = "", i = 0, a = s, o = 0;
            continue;
          }
        }
        n && (r = r.length > 0 ? r + "/.." : "..", i = 2);
      } else
        r.length > 0 ? r += "/" + e.slice(a + 1, s) : r = e.slice(a + 1, s), i = s - a - 1;
      a = s, o = 0;
    } else l === 46 && o > -1 ? o++ : o = -1;
  }
  return r;
}
function Fo(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const dP = { cwd: uP };
function uP() {
  return "/";
}
function Cm(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function mP(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!Cm(e)) {
    const n = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw n.code = "ERR_INVALID_ARG_TYPE", n;
  }
  if (e.protocol !== "file:") {
    const n = new TypeError("The URL must be of scheme file");
    throw n.code = "ERR_INVALID_URL_SCHEME", n;
  }
  return pP(e);
}
function pP(e) {
  if (e.hostname !== "") {
    const i = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw i.code = "ERR_INVALID_FILE_URL_HOST", i;
  }
  const n = e.pathname;
  let r = -1;
  for (; ++r < n.length; )
    if (n.codePointAt(r) === 37 && n.codePointAt(r + 1) === 50) {
      const i = n.codePointAt(r + 2);
      if (i === 70 || i === 102) {
        const a = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw a.code = "ERR_INVALID_FILE_URL_PATH", a;
      }
    }
  return decodeURIComponent(n);
}
const Su = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class lS {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(n) {
    let r;
    n ? Cm(n) ? r = { path: n } : typeof n == "string" || fP(n) ? r = { value: n } : r = n : r = {}, this.cwd = "cwd" in r ? "" : dP.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let i = -1;
    for (; ++i < Su.length; ) {
      const o = Su[i];
      o in r && r[o] !== void 0 && r[o] !== null && (this[o] = o === "history" ? [...r[o]] : r[o]);
    }
    let a;
    for (a in r)
      Su.includes(a) || (this[a] = r[a]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? Ir.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(n) {
    ju(n, "basename"), Nu(n, "basename"), this.path = Ir.join(this.dirname || "", n);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? Ir.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(n) {
    ek(this.basename, "dirname"), this.path = Ir.join(n || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? Ir.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(n) {
    if (Nu(n, "extname"), ek(this.dirname, "extname"), n) {
      if (n.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (n.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = Ir.join(this.dirname, this.stem + (n || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(n) {
    Cm(n) && (n = mP(n)), ju(n, "path"), this.path !== n && this.history.push(n);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? Ir.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(n) {
    ju(n, "stem"), Nu(n, "stem"), this.path = Ir.join(this.dirname || "", n + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(n, r, i) {
    const a = this.message(n, r, i);
    throw a.fatal = !0, a;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(n, r, i) {
    const a = this.message(n, r, i);
    return a.fatal = void 0, a;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(n, r, i) {
    const a = new Pt(
      // @ts-expect-error: the overloads are fine.
      n,
      r,
      i
    );
    return this.path && (a.name = this.path + ":" + a.name, a.file = this.path), a.fatal = !1, this.messages.push(a), a;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(n) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(n || void 0).decode(this.value);
  }
}
function Nu(e, n) {
  if (e && e.includes(Ir.sep))
    throw new Error(
      "`" + n + "` cannot be a path: did not expect `" + Ir.sep + "`"
    );
}
function ju(e, n) {
  if (!e)
    throw new Error("`" + n + "` cannot be empty");
}
function ek(e, n) {
  if (!e)
    throw new Error("Setting `" + n + "` requires `path` to be set too");
}
function fP(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const hP = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(e) {
    const i = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), a = i[e], o = function() {
      return a.apply(o, arguments);
    };
    return Object.setPrototypeOf(o, i), o;
  })
), yP = {}.hasOwnProperty;
class Mp extends hP {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = tP();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const n = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new Mp()
    );
    let r = -1;
    for (; ++r < this.attachers.length; ) {
      const i = this.attachers[r];
      n.use(...i);
    }
    return n.data(_u(!0, {}, this.namespace)), n;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(n, r) {
    return typeof n == "string" ? arguments.length === 2 ? (Fu("data", this.frozen), this.namespace[n] = r, this) : yP.call(this.namespace, n) && this.namespace[n] || void 0 : n ? (Fu("data", this.frozen), this.namespace = n, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const n = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [r, ...i] = this.attachers[this.freezeIndex];
      if (i[0] === !1)
        continue;
      i[0] === !0 && (i[0] = void 0);
      const a = r.call(n, ...i);
      typeof a == "function" && this.transformers.use(a);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(n) {
    this.freeze();
    const r = qo(n), i = this.parser || this.Parser;
    return wu("parse", i), i(String(r), r);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(n, r) {
    const i = this;
    return this.freeze(), wu("process", this.parser || this.Parser), Cu("process", this.compiler || this.Compiler), r ? a(void 0, r) : new Promise(a);
    function a(o, s) {
      const l = qo(n), d = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        i.parse(l)
      );
      i.run(d, l, function(u, f, h) {
        if (u || !f || !h)
          return m(u);
        const g = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          f
        ), C = i.stringify(g, h);
        kP(C) ? h.value = C : h.result = C, m(
          u,
          /** @type {VFileWithOutput<CompileResult>} */
          h
        );
      });
      function m(u, f) {
        u || !f ? s(u) : o ? o(f) : r(void 0, f);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(n) {
    let r = !1, i;
    return this.freeze(), wu("processSync", this.parser || this.Parser), Cu("processSync", this.compiler || this.Compiler), this.process(n, a), tk("processSync", "process", r), i;
    function a(o, s) {
      r = !0, Xv(o), i = s;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(n, r, i) {
    nk(n), this.freeze();
    const a = this.transformers;
    return !i && typeof r == "function" && (i = r, r = void 0), i ? o(void 0, i) : new Promise(o);
    function o(s, l) {
      const d = qo(r);
      a.run(n, d, m);
      function m(u, f, h) {
        const g = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          f || n
        );
        u ? l(u) : s ? s(g) : i(void 0, g, h);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(n, r) {
    let i = !1, a;
    return this.run(n, r, o), tk("runSync", "run", i), a;
    function o(s, l) {
      Xv(s), a = l, i = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(n, r) {
    this.freeze();
    const i = qo(r), a = this.compiler || this.Compiler;
    return Cu("stringify", a), nk(n), a(n, i);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(n, ...r) {
    const i = this.attachers, a = this.namespace;
    if (Fu("use", this.frozen), n != null) if (typeof n == "function")
      d(n, r);
    else if (typeof n == "object")
      Array.isArray(n) ? l(n) : s(n);
    else
      throw new TypeError("Expected usable value, not `" + n + "`");
    return this;
    function o(m) {
      if (typeof m == "function")
        d(m, []);
      else if (typeof m == "object")
        if (Array.isArray(m)) {
          const [u, ...f] = (
            /** @type {PluginTuple<Array<unknown>>} */
            m
          );
          d(u, f);
        } else
          s(m);
      else
        throw new TypeError("Expected usable value, not `" + m + "`");
    }
    function s(m) {
      if (!("plugins" in m) && !("settings" in m))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      l(m.plugins), m.settings && (a.settings = _u(!0, a.settings, m.settings));
    }
    function l(m) {
      let u = -1;
      if (m != null) if (Array.isArray(m))
        for (; ++u < m.length; ) {
          const f = m[u];
          o(f);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + m + "`");
    }
    function d(m, u) {
      let f = -1, h = -1;
      for (; ++f < i.length; )
        if (i[f][0] === m) {
          h = f;
          break;
        }
      if (h === -1)
        i.push([m, ...u]);
      else if (u.length > 0) {
        let [g, ...C] = u;
        const S = i[h][1];
        wm(S) && wm(g) && (g = _u(!0, S, g)), i[h] = [m, g, ...C];
      }
    }
  }
}
const gP = new Mp().freeze();
function wu(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function Cu(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function Fu(e, n) {
  if (n)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function nk(e) {
  if (!wm(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function tk(e, n, r) {
  if (!r)
    throw new Error(
      "`" + e + "` finished async. Use `" + n + "` instead"
    );
}
function qo(e) {
  return vP(e) ? e : new lS(e);
}
function vP(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function kP(e) {
  return typeof e == "string" || bP(e);
}
function bP(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const xP = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", rk = [], ik = { allowDangerousHtml: !0 }, _P = /^(https?|ircs?|mailto|xmpp)$/i, SP = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function NP(e) {
  const n = e.allowedElements, r = e.allowElement, i = e.children || "", a = e.className, o = e.components, s = e.disallowedElements, l = e.rehypePlugins || rk, d = e.remarkPlugins || rk, m = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...ik } : ik, u = e.skipHtml, f = e.unwrapDisallowed, h = e.urlTransform || jP, g = gP().use(iA).use(d).use(ZA, m).use(l), C = new lS();
  typeof i == "string" && (C.value = i);
  for (const y of SP)
    Object.hasOwn(e, y.from) && ("" + y.from + (y.to ? "use `" + y.to + "` instead" : "remove it") + xP + y.id, void 0);
  const S = g.parse(C);
  let N = g.runSync(S, C);
  return a && (N = {
    type: "element",
    tagName: "div",
    properties: { className: a },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      N.type === "root" ? N.children : [N]
    )
  }), sS(N, w), AD(N, {
    Fragment: Ve.Fragment,
    components: o,
    ignoreInvalidStyle: !0,
    jsx: Ve.jsx,
    jsxs: Ve.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function w(y, z, $) {
    if (y.type === "raw" && $ && typeof z == "number")
      return u ? $.children.splice(z, 1) : $.children[z] = { type: "text", value: y.value }, z;
    if (y.type === "element") {
      let I;
      for (I in vu)
        if (Object.hasOwn(vu, I) && Object.hasOwn(y.properties, I)) {
          const T = y.properties[I], U = vu[I];
          (U === null || U.includes(y.tagName)) && (y.properties[I] = h(String(T || ""), I, y));
        }
    }
    if (y.type === "element") {
      let I = n ? !n.includes(y.tagName) : s ? s.includes(y.tagName) : !1;
      if (!I && r && typeof z == "number" && (I = !r(y, z, $)), I && $ && typeof z == "number")
        return f && y.children ? $.children.splice(z, 1, ...y.children) : $.children.splice(z, 1), z;
    }
  }
}
function jP(e) {
  const n = e.indexOf(":"), r = e.indexOf("?"), i = e.indexOf("#"), a = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    n < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    a > -1 && n > a || r > -1 && n > r || i > -1 && n > i || // It is a protocol, it should be allowed.
    _P.test(e.slice(0, n)) ? e : ""
  );
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('._issueAvatar_kc0sw_1{margin:var(--dixa-size-spacer-100) 0}._issueAvatar_kc0sw_1 h2{font-weight:var(--dixa-typography-weight-normal);align-items:center;display:flex}._issueField_kc0sw_9{font-weight:var(--dixa-typography-weight-normal)}._issueDescription_kc0sw_12{font-weight:var(--dixa-typography-weight-normal);color:var(--dixa-color-neutral-800);padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._issueDescription_kc0sw_12 p{margin:unset}._wrapper_e0qj3_1{width:400px;padding:0 0 var(--dixa-size-spacer-200) 0;max-height:400px;overflow:hidden;position:relative}._wrapper_e0qj3_1 ._description_e0qj3_8{color:var(--dixa-color-neutral-600)}._wrapper_e0qj3_1:after{width:100%;height:var(--dixa-size-spacer-400);content:"";position:absolute;bottom:0;left:0;background:linear-gradient(0deg,#fff,#ffffffbc 19%,#ffffff8a 34%,#ffffff61 47%,#ffffff47 56.5%,#ffffff31 65%,#ffffff20 73%,#ffffff13 80.2%,#ffffff0b 86.1%,#ffffff05 91%,#ffffff02 95.2%,#ffffff01 98.2%,#fff0)}._resultTitle_e0qj3_21{text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(--dixa-color-neutral-600)}._resultTooltipTitle_e0qj3_28{margin-bottom:var(--dixa-size-spacer-200)}._resultLinkIcon_e0qj3_31{position:absolute;right:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-000);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);color:var(--dixa-color-neutral-500)}._loader_13xpk_1{width:100%;display:flex;padding:var(--dixa-size-spacer-200);justify-content:center}._dropdown_13xpk_8{max-height:300px;overflow-y:scroll}._loadMore_13xpk_13{cursor:pointer}._loadMore_13xpk_13:hover{background-color:var(--dixa-color-neutral-100)}._loadMore_13xpk_13:hover p{color:var(--dixa-color-purple-600)}._loadMore_13xpk_13 p{color:var(--dixa-color-purple-500)}._collapse_su0f9_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8{padding:var(--dixa-size-spacer-250);width:100%;box-sizing:border-box;background-color:transparent;gap:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8>div:first-of-type{padding:0!important;padding-right:var(--dixa-size-spacer-300);width:100%}._collapseHeader_su0f9_8>div>div:first-of-type{padding:0!important;width:100%}._collapseHeader_su0f9_8 p>div:first-of-type{justify-content:space-between}._collapseHeader_su0f9_8>div>div>p{white-space:unset!important;margin:0}._collapseContent_su0f9_31{padding:0 var(--dixa-size-spacer-250) var(--dixa-size-spacer-250) var(--dixa-size-spacer-250)}._url_su0f9_35{align-items:center;display:flex;flex-direction:row;gap:var(--dixa-size-spacer-100);color:var(--dixa-color-purple-500);font-weight:var(--dixa-typography-weight-semibold);cursor:pointer;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200)}._empty_su0f9_47 p{color:var(--dixa-color-neutral-400)}._externalLink_su0f9_51{color:var(--dixa-typography-color-link)}._emptyState_su0f9_55{font-weight:var(--dixa-typography-weight-normal)}._modalBody_iv3ua_1{width:600px}._error_iv3ua_5{border:var(--dixa-size-border-100) solid var(--dixa-typography-color-error)}._emptyState_iv3ua_9{padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200) var(--dixa-size-spacer-200)}._emptyState_iv3ua_9 p{color:var(--dixa-color-neutral-400)}._dropdown_iv3ua_16{max-height:300px;overflow-y:scroll}._modalWrapper_4kh9u_1{min-width:600px;position:relative}._copyButton_4kh9u_6{height:var(--dixa-size-spacer-500);width:var(--dixa-size-spacer-500)}._copyButton_4kh9u_6 button{background-color:var(--dixa-color-neutral-100);border-radius:0 var(--dixa-size-border-radius-100) var(--dixa-size-border-radius-100) 0}._copyWrapper_4kh9u_15{box-sizing:border-box}._copyWrapper_4kh9u_15:focus-within{border-radius:var(--dixa-size-border-radius-100);outline:solid var(--dixa-size-border-100) var(--dixa-color-purple-500);box-shadow:0 0 0 3px var(--dixa-color-purple-300)}._copyField_4kh9u_24{cursor:pointer;min-width:62ch;height:var(--dixa-size-spacer-500);border-radius:var(--dixa-size-border-radius-100) 0 0 var(--dixa-size-border-radius-100);border:none}._copyField_4kh9u_24:hover{border:none}._copyField_4kh9u_24:focus-within{box-shadow:none;border:none;outline:none}._copyField_4kh9u_24 input{color:var(--dixa-color-neutral-800);background-color:var(--dixa-color-neutral-100);cursor:pointer;border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-right:none}._externalLink_4kh9u_47{display:flex;align-items:center}._externalLinkIcon_4kh9u_52{align-self:center}._textWrapper_4kh9u_56{display:flex;gap:var(--dixa-size-spacer-100)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Iu = { exports: {} }, Da = {}, ak;
function wP() {
  if (ak) return Da;
  ak = 1;
  var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return Da.Fragment = r, Da.jsx = s, Da.jsxs = s, Da;
}
var Ho = {}, ok;
function CP() {
  return ok || (ok = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        z("error", t, p);
      }
    }
    function z(t, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, A = v.getStackAddendum();
        A !== "" && (c += "%s", p = p.concat([A]));
        var L = p.map(function(F) {
          return String(F);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, I = !1, T = !1, U = !1, Q = !1, J;
    J = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === u || U || t === g || $ || I || T || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function X(t, c, p) {
      var v = t.displayName;
      if (v)
        return v;
      var A = c.displayName || c.name || "";
      return A !== "" ? p + "(" + A + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return X(t, t.render, "ForwardRef");
          case f:
            var v = t.displayName || null;
            return v !== null ? v : O(t.type) || "Memo";
          case h: {
            var A = t, L = A._payload, F = A._init;
            try {
              return O(F(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, ue, ce, fe, W, xe, Ie;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ve = console.log, ue = console.info, ce = console.warn, fe = console.error, W = console.group, xe = console.groupCollapsed, Ie = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: ue
            }),
            warn: q({}, t, {
              value: ce
            }),
            error: q({}, t, {
              value: fe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: xe
            }),
            groupEnd: q({}, t, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Me;
    function $e(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (A) {
            var v = A.stack.trim().match(/\n( *(at )?)/);
            Me = v && v[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var ze = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(t, c) {
      if (!t || ze)
        return "";
      {
        var p = Re.get(t);
        if (p !== void 0)
          return p;
      }
      var v;
      ze = !0;
      var A = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, qe();
      try {
        if (c) {
          var F = function() {
            throw Error();
          };
          if (Object.defineProperty(F.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(F, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(t, [], F);
          } else {
            try {
              F.call();
            } catch (ne) {
              v = ne;
            }
            t.call(F.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), G = j.length - 1, _ = te.length - 1; G >= 1 && _ >= 0 && j[G] !== te[_]; )
            _--;
          for (; G >= 1 && _ >= 0; G--, _--)
            if (j[G] !== te[_]) {
              if (G !== 1 || _ !== 1)
                do
                  if (G--, _--, _ < 0 || j[G] !== te[_]) {
                    var Z = `
` + j[G].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (G >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Oe.current = L, Be(), Error.prepareStackTrace = A;
      }
      var de = t ? t.displayName || t.name : "", Se = de ? $e(de) : "";
      return typeof t == "function" && Re.set(t, Se), Se;
    }
    function Ge(t, c, p) {
      return Ee(t, !1);
    }
    function Qe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function he(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Qe(t));
      if (typeof t == "string")
        return $e(t);
      switch (t) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ge(t.render);
          case f:
            return he(t.type, c, p);
          case h: {
            var v = t, A = v._payload, L = v._init;
            try {
              return he(L(A), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, De = {}, Le = w.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = he(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(t, c, p, v, A) {
      {
        var L = Function.call.bind(ge);
        for (var F in t)
          if (L(t, F)) {
            var j = void 0;
            try {
              if (typeof t[F] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + F + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[F] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[F](c, F, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (G) {
              j = G;
            }
            j && !(j instanceof Error) && (Ae(A), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, F, typeof j), Ae(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Ae(A), y("Failed %s type: %s", p, j.message), Ae(null));
          }
      }
    }
    var E = Array.isArray;
    function x(t) {
      return E(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var V = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, me, Ne;
    function nn(t) {
      if (ge.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function fn(t) {
      if (ge.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && V.current;
    }
    function cn(t, c) {
      {
        var p = function() {
          me || (me = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(t, c, p, v, A, L, F) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: F,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: A
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, v, A) {
      {
        var L, F = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), fn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ge.call(c, L) && !ie.hasOwnProperty(L) && (F[L] = c[L]);
        if (t && t.defaultProps) {
          var G = t.defaultProps;
          for (L in G)
            F[L] === void 0 && (F[L] = G[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && cn(F, _), te && pn(F, _);
        }
        return dn(t, j, te, A, v, V.current, F);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = he(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var t = O(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        t && t._owner && t._owner !== en.current && (v = " It was passed a child from " + O(t._owner.type) + "."), Pe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Pe(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var v = t[p];
            sn(v) && gn(v, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var A = N(t);
          if (typeof A == "function" && A !== t.entries)
            for (var L = A.call(t), F; !(F = L.next()).done; )
              sn(F.value) && gn(F.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          mn(p, t.props, "prop", v, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var A = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", A || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Pe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Pe(null);
            break;
          }
        }
        t.ref !== null && (Pe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Pe(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, v, A, L) {
      {
        var F = ae(t);
        if (!F) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var G;
          t === null ? G = "null" : x(t) ? G = "array" : t !== void 0 && t.$$typeof === n ? (G = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : G = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", G, j);
        }
        var _ = xn(t, c, p, A, L);
        if (_ == null)
          return _;
        if (F) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var de = 0; de < Z.length; de++)
                  Cn(Z[de], t);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, t);
        }
        if (ge.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, Se, $n, Se), Sn[Se + Ke] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Ho.Fragment = i, Ho.jsx = Rn, Ho.jsxs = Mn;
  })()), Ho;
}
var sk;
function FP() {
  return sk || (sk = 1, process.env.NODE_ENV === "production" ? Iu.exports = wP() : Iu.exports = CP()), Iu.exports;
}
var re = FP();
const IP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "statusId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "priority" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } } }, { kind: "ObjectField", name: { kind: "Name", value: "description" }, value: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } } }, { kind: "ObjectField", name: { kind: "Name", value: "teamId" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "projectId" }, value: { kind: "Variable", name: { kind: "Name", value: "projectId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "stateId" }, value: { kind: "Variable", name: { kind: "Name", value: "statusId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "priority" }, value: { kind: "Variable", name: { kind: "Name", value: "priority" } } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "success" } }, { kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] }, EP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "staticData" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "issuePriorityValues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "label" } }] } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] }, TP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "teamData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "team" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "states" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "templates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "templateData" } }] } }] } }] } }] } }] } }] } }] }, $P = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "after" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchIssues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }, { kind: "Argument", name: { kind: "Name", value: "after" }, value: { kind: "Variable", name: { kind: "Name", value: "after" } } }, { kind: "Argument", name: { kind: "Name", value: "term" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "pageInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hasNextPage" } }, { kind: "Field", name: { kind: "Name", value: "endCursor" } }] } }] } }] } }] } }] }, DP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchLinkedIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } }, type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "id" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "in" }, value: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, RP = {
  "\n  mutation createIssue(\n    $issueTitle: String!\n    $issueDescription: String\n    $teamId: String!\n    $projectId: String\n    $statusId: String\n    $priority: Int\n  ) {\n    Linear {\n      issueCreate(\n        input: {\n          title: $issueTitle\n          description: $issueDescription\n          teamId: $teamId\n          projectId: $projectId\n          stateId: $statusId\n          priority: $priority\n        }\n      ) {\n        success\n        issue {\n          id\n          title\n          identifier\n          url\n        }\n      }\n    }\n  }\n": IP,
  "\n  query staticData {\n    Linear {\n      teams {\n        edges {\n          node {\n            id\n            name\n            organization {\n              urlKey\n            }\n          }\n        }\n      }\n      issuePriorityValues {\n        priority\n        label\n      }\n      organization {\n        urlKey\n      }\n    }\n  }\n": EP,
  "\n  query teamData($teamId: String!) {\n    Linear {\n      team(id: $teamId) {\n        projects {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        states {\n          edges {\n            node {\n              id\n              name\n              type\n              color\n            }\n          }\n        }\n        templates {\n          edges {\n            node {\n              id\n              name\n              type\n              templateData\n            }\n          }\n        }\n      }\n    }\n  }\n": TP,
  "\n  query searchIssues($issueQuery: String! $after: String, $first: Int ) {\n    Linear {\n      searchIssues(\n        first:$first\n        after:$after\n        term: $issueQuery\n      ) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n  }\n": $P,
  "\n  query searchLinkedIssues($linkedIssues: [ID!]) {\n    Linear {\n      issues(filter: { id: { in: $linkedIssues } }) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": DP
};
function Io(e) {
  return RP[e] ?? {};
}
const OP = Io(
  /* GraphQL */
  `
  query searchIssues($issueQuery: String! $after: String, $first: Int ) {
    Linear {
      searchIssues(
        first:$first
        after:$after
        term: $issueQuery
      ) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`
), AP = Io(
  /* GraphQL */
  `
  query searchLinkedIssues($linkedIssues: [ID!]) {
    Linear {
      issues(filter: { id: { in: $linkedIssues } }) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
      }
    }
  }
`
), Wo = ({
  title: e,
  children: n
}) => /* @__PURE__ */ re.jsxs(b, { flexDirection: "column", gap: "100", children: [
  /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "5", color: "neutral.500", children: e }),
  n
] }), PP = "_issueAvatar_kc0sw_1", LP = "_issueField_kc0sw_9", VP = "_issueDescription_kc0sw_12", Go = {
  issueAvatar: PP,
  issueField: LP,
  issueDescription: VP
}, cS = ({ issue: e }) => /* @__PURE__ */ re.jsxs(re.Fragment, { children: [
  /* @__PURE__ */ re.jsx(Wo, { title: "Assignee", children: /* @__PURE__ */ re.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "row",
      alignContent: "center",
      className: Go.issueAvatar,
      children: [
        /* @__PURE__ */ re.jsx(
          Hm,
          {
            size: "24",
            user: e.assignee ? {
              name: e.assignee.name || null,
              // eslint-disable-next-line camelcase
              avatar_url: e.assignee.avatarUrl || null,
              email: e.assignee.email
            } : void 0
          }
        ),
        /* @__PURE__ */ re.jsx(P.Heading, { variant: "heading-4", children: e.assignee ? e.assignee.name : "Unassigned" })
      ]
    }
  ) }),
  e.team?.name && /* @__PURE__ */ re.jsx(Wo, { title: "Team", children: /* @__PURE__ */ re.jsx(
    P.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: Go.issueField,
      children: e.team.name
    }
  ) }),
  e.project?.name && /* @__PURE__ */ re.jsx(Wo, { title: "Project", children: /* @__PURE__ */ re.jsx(
    P.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: Go.issueField,
      children: e.project.name
    }
  ) }),
  /* @__PURE__ */ re.jsx(Wo, { title: "Description", children: /* @__PURE__ */ re.jsx(NP, { className: Go.issueDescription, children: e.description }) })
] }), zP = /* @__PURE__ */ re.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "No Priority",
    "data-testid": "noPriorityIcon",
    children: [
      /* @__PURE__ */ re.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 5 7)" }),
      /* @__PURE__ */ re.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 8 7)" }),
      /* @__PURE__ */ re.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 11 7)" })
    ]
  }
), UP = /* @__PURE__ */ re.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Low Priority",
    children: [
      /* @__PURE__ */ re.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ re.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1", fillOpacity: "0.4" }),
      /* @__PURE__ */ re.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), MP = /* @__PURE__ */ re.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Medium Priority",
    children: [
      /* @__PURE__ */ re.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ re.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ re.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), BP = /* @__PURE__ */ re.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "High Priority",
    children: [
      /* @__PURE__ */ re.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ re.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ re.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1" })
    ]
  }
), qP = /* @__PURE__ */ re.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "-1 -1 15 15",
    "aria-label": "Urgent Priority",
    fill: "var(--dixa-color-orange-400)",
    children: /* @__PURE__ */ re.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 0a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V2a2 2 0 00-2-2H2zm3.914 3h1.738L7.5 8.602H6.07L5.914 3zm1.809 7.164a.95.95 0 01-.938.938.934.934 0 110-1.867c.5 0 .934.417.938.93z"
      }
    )
  }
), dS = {
  0: zP,
  1: qP,
  2: BP,
  3: MP,
  4: UP
}, HP = (e) => e in dS, As = ({ priority: e }) => HP(e) ? dS[e] : /* @__PURE__ */ re.jsx(Pn, { "data-testid": "defaultPriorityTag", children: e }), WP = (e, n) => /* @__PURE__ */ re.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    "data-testid": "defaultStatusIcon",
    children: /* @__PURE__ */ re.jsx(
      "path",
      {
        d: "M13.9408 7.91426L11.9576 7.65557C11.9855 7.4419 12 7.22314 12 7C12 6.77686 11.9855 6.5581 11.9576 6.34443L13.9408 6.08573C13.9799 6.38496 14 6.69013 14 7C14 7.30987 13.9799 7.61504 13.9408 7.91426ZM13.4688 4.32049C13.2328 3.7514 12.9239 3.22019 12.5538 2.73851L10.968 3.95716C11.2328 4.30185 11.4533 4.68119 11.6214 5.08659L13.4688 4.32049ZM11.2615 1.4462L10.0428 3.03204C9.69815 2.76716 9.31881 2.54673 8.91341 2.37862L9.67951 0.531163C10.2486 0.767153 10.7798 1.07605 11.2615 1.4462ZM7.91426 0.0591659L7.65557 2.04237C7.4419 2.01449 7.22314 2 7 2C6.77686 2 6.5581 2.01449 6.34443 2.04237L6.08574 0.059166C6.38496 0.0201343 6.69013 0 7 0C7.30987 0 7.61504 0.0201343 7.91426 0.0591659ZM4.32049 0.531164L5.08659 2.37862C4.68119 2.54673 4.30185 2.76716 3.95716 3.03204L2.73851 1.4462C3.22019 1.07605 3.7514 0.767153 4.32049 0.531164ZM1.4462 2.73851L3.03204 3.95716C2.76716 4.30185 2.54673 4.68119 2.37862 5.08659L0.531164 4.32049C0.767153 3.7514 1.07605 3.22019 1.4462 2.73851ZM0.0591659 6.08574C0.0201343 6.38496 0 6.69013 0 7C0 7.30987 0.0201343 7.61504 0.059166 7.91426L2.04237 7.65557C2.01449 7.4419 2 7.22314 2 7C2 6.77686 2.01449 6.5581 2.04237 6.34443L0.0591659 6.08574ZM0.531164 9.67951L2.37862 8.91341C2.54673 9.31881 2.76716 9.69815 3.03204 10.0428L1.4462 11.2615C1.07605 10.7798 0.767153 10.2486 0.531164 9.67951ZM2.73851 12.5538L3.95716 10.968C4.30185 11.2328 4.68119 11.4533 5.08659 11.6214L4.32049 13.4688C3.7514 13.2328 3.22019 12.9239 2.73851 12.5538ZM6.08574 13.9408L6.34443 11.9576C6.5581 11.9855 6.77686 12 7 12C7.22314 12 7.4419 11.9855 7.65557 11.9576L7.91427 13.9408C7.61504 13.9799 7.30987 14 7 14C6.69013 14 6.38496 13.9799 6.08574 13.9408ZM9.67951 13.4688L8.91341 11.6214C9.31881 11.4533 9.69815 11.2328 10.0428 10.968L11.2615 12.5538C10.7798 12.9239 10.2486 13.2328 9.67951 13.4688ZM12.5538 11.2615L10.968 10.0428C11.2328 9.69815 11.4533 9.31881 11.6214 8.91341L13.4688 9.67951C13.2328 10.2486 12.924 10.7798 12.5538 11.2615Z",
        stroke: "none"
      }
    )
  }
), GP = (e, n) => /* @__PURE__ */ re.jsxs(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    "aria-label": n,
    "data-testid": "unstartedStatusIcon",
    children: [
      /* @__PURE__ */ re.jsx(
        "rect",
        {
          x: "1",
          y: "1",
          width: "12",
          height: "12",
          rx: "6",
          stroke: e,
          strokeWidth: "2",
          fill: "none"
        }
      ),
      /* @__PURE__ */ re.jsx(
        "path",
        {
          fill: e,
          stroke: "none",
          d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 0 z",
          transform: "translate(3.5,3.5)"
        }
      )
    ]
  }
), KP = (e, n) => /* @__PURE__ */ re.jsxs("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", "aria-label": n, children: [
  /* @__PURE__ */ re.jsx(
    "rect",
    {
      x: "1",
      y: "1",
      width: "12",
      height: "12",
      rx: "6",
      stroke: e,
      strokeWidth: "2",
      fill: "none"
    }
  ),
  /* @__PURE__ */ re.jsx(
    "path",
    {
      fill: e,
      stroke: "none",
      d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 7 z",
      transform: "translate(3.5,3.5)"
    }
  )
] }), YP = (e, n) => /* @__PURE__ */ re.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ re.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), QP = (e, n) => /* @__PURE__ */ re.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ re.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM5.03033 3.96967C4.73744 3.67678 4.26256 3.67678 3.96967 3.96967C3.67678 4.26256 3.67678 4.73744 3.96967 5.03033L5.93934 7L3.96967 8.96967C3.67678 9.26256 3.67678 9.73744 3.96967 10.0303C4.26256 10.3232 4.73744 10.3232 5.03033 10.0303L7 8.06066L8.96967 10.0303C9.26256 10.3232 9.73744 10.3232 10.0303 10.0303C10.3232 9.73744 10.3232 9.26256 10.0303 8.96967L8.06066 7L10.0303 5.03033C10.3232 4.73744 10.3232 4.26256 10.0303 3.96967C9.73744 3.67678 9.26256 3.67678 8.96967 3.96967L7 5.93934L5.03033 3.96967Z",
        stroke: "none"
      }
    )
  }
), JP = (e, n) => /* @__PURE__ */ re.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ re.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), Fm = {
  backlog: (e, n) => WP(e, n),
  unstarted: (e, n) => GP(e, n),
  started: (e, n) => KP(e, n),
  done: (e, n) => YP(e, n),
  canceled: (e, n) => QP(e, n),
  completed: (e, n) => JP(e, n)
}, XP = (e) => e in Fm, Ps = ({
  type: e = "backlog",
  color: n = "var(--dixa-color-neutral-400)",
  name: r = "linear-backlog-icon"
}) => XP(e) ? Fm[e](n, r) : Fm.backlog(
  "var(--dixa-color-neutral-400)",
  "linear-backlog-icon"
), ZP = "_wrapper_e0qj3_1", e2 = "_resultTitle_e0qj3_21", n2 = "_resultTooltipTitle_e0qj3_28", t2 = "_resultLinkIcon_e0qj3_31", Ra = {
  wrapper: ZP,
  resultTitle: e2,
  resultTooltipTitle: n2,
  resultLinkIcon: t2
}, r2 = ({
  issue: e
}) => {
  const [n, r] = le(!1), {
    list: { isDisabled: i },
    item: { onSelect: a }
  } = Bm($0()), o = ot(
    (s) => {
      i || a({
        value: e,
        meta: {
          target: s?.target,
          event: s || void 0
        }
      });
    },
    [i, a, e]
  );
  return /* @__PURE__ */ re.jsx(
    We,
    {
      wrap: "none",
      side: "left",
      content: /* @__PURE__ */ re.jsxs(b, { flexDirection: "column", gap: "300", className: Ra.wrapper, children: [
        /* @__PURE__ */ re.jsxs(b, { flexDirection: "row", justifyContent: "space-between", gap: "300", children: [
          /* @__PURE__ */ re.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ re.jsx(
              Ps,
              {
                type: e.state.type,
                name: e.state.name,
                color: e.state.color
              }
            ),
            /* @__PURE__ */ re.jsx(P.Heading, { variant: "heading-3", children: e.identifier }),
            /* @__PURE__ */ re.jsx(As, { priority: e.priority })
          ] }),
          /* @__PURE__ */ re.jsx(Pn, { children: e.state.name })
        ] }),
        /* @__PURE__ */ re.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ re.jsx(
            P.Heading,
            {
              variant: "heading-3",
              className: Ra.resultTooltipTitle,
              children: e.title
            }
          ),
          /* @__PURE__ */ re.jsx(cS, { issue: e })
        ] })
      ] }),
      light: !0,
      children: /* @__PURE__ */ re.jsx(
        ut.Item,
        {
          value: e,
          noFixedSelectionStateSpace: !0,
          className: Ra.result,
          onMouseEnter: () => r(!0),
          onMouseLeave: () => r(!1),
          "data-testid": "selectionListItemWrapper",
          onClick: o,
          children: /* @__PURE__ */ re.jsxs(
            b,
            {
              flexDirection: "column",
              style: {
                width: n ? "calc(100% - 32px)" : "100%"
              },
              children: [
                /* @__PURE__ */ re.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ re.jsx(
                    Ps,
                    {
                      type: e.state.type,
                      color: e.state.color,
                      name: e.state.name
                    }
                  ),
                  /* @__PURE__ */ re.jsx(P.Heading, { variant: "heading-3", children: e.identifier }),
                  /* @__PURE__ */ re.jsx(As, { priority: e.priority })
                ] }),
                /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "4", className: Ra.resultTitle, children: e.title }),
                n && /* @__PURE__ */ re.jsx(
                  pe,
                  {
                    className: Ra.resultLinkIcon,
                    name: "plus",
                    size: 32
                  }
                )
              ]
            }
          )
        },
        e.id
      )
    }
  );
}, i2 = "_loader_13xpk_1", a2 = "_dropdown_13xpk_8", o2 = "_loadMore_13xpk_13", Eu = {
  loader: i2,
  dropdown: a2,
  loadMore: o2
}, s2 = ({
  handleSelect: e,
  linkedIssues: n
}) => {
  const [r, i] = le(), [a, o] = le([]), [s, l] = le(""), [d, m] = le(!1), { useLazyQuery: u } = hn(), [f, { data: h, loading: g, networkStatus: C }] = u(
    OP,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0
    }
  );
  $i(
    () => {
      !g && s !== "" && C === er.ready ? f({
        variables: {
          issueQuery: s,
          first: 8
        }
      }) : o([]);
    },
    500,
    [s]
  ), He(() => {
    g || o([]);
  }, [s]), He(() => {
    if (h && Object.keys(h).length > 0) {
      const N = h.Linear.searchIssues.edges.map(
        ({ node: $ }) => $
      ), w = a.filter(
        ($) => !n.find((I) => I.id === $.id)
      ), y = w.filter(
        ($) => !N.find(
          (I) => I.id === $.id
        )
      ), z = N.filter(
        ($) => !n.find((I) => I.id === $.id)
      );
      n.length > 0 ? o(
        d ? [...y, ...z] : z
      ) : h?.Linear?.searchIssues?.edges && o(
        d ? [...w, ...N] : N
      ), h.Linear.searchIssues.pageInfo.hasNextPage && m(!1), i(h.Linear.searchIssues?.pageInfo);
    }
  }, [h, n]);
  const S = () => {
    !g && s !== "" && C === er.ready ? (m(!0), f({
      variables: {
        issueQuery: s,
        first: 8,
        after: r?.endCursor
      }
    })) : o([]);
  };
  return /* @__PURE__ */ re.jsx(b, { flexDirection: "column", gap: "200", "data-testid": "searchBarWrapper", children: /* @__PURE__ */ re.jsxs(
    ni,
    {
      "data-testid": "searchBarComponent",
      clearable: !0,
      getItemTitleByValue: (N) => N?.title,
      onChange: (N) => e(N.selectedValues[0]),
      dropdownProps: { className: Eu.dropdown },
      filter: {
        value: s,
        onChange: (N) => {
          const w = N.target.value;
          l(w);
        }
      },
      placeholder: "Search Linear issues",
      children: [
        a?.map((N) => /* @__PURE__ */ re.jsx(r2, { issue: N }, N.id)),
        r?.hasNextPage && !g && s !== "" && a.length && /* @__PURE__ */ re.jsx(
          b,
          {
            gap: "100",
            justifyContent: "center",
            padding: "200",
            alignItems: "center",
            onClick: () => S(),
            className: Eu.loadMore,
            children: /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "3", children: "Load more ..." })
          }
        ),
        g && s !== "" && /* @__PURE__ */ re.jsx(b, { justifyContent: "center", className: Eu.loader, children: /* @__PURE__ */ re.jsx(un, { size: 24 }) }),
        s === "" && a.length === 0 && /* @__PURE__ */ re.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "3", color: "neutral.400", children: "Enter issue title or description" })
          }
        ),
        a.length === 0 && s !== "" && !g && /* @__PURE__ */ re.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ re.jsx(P.Paragraph, { variant: "3", color: "neutral.400", children: "No Linear issues found" })
          }
        )
      ]
    }
  ) });
}, l2 = "_collapse_su0f9_1", c2 = "_collapseHeader_su0f9_8", d2 = "_collapseContent_su0f9_31", u2 = "_url_su0f9_35", m2 = "_externalLink_su0f9_51", p2 = "_emptyState_su0f9_55", ei = {
  collapse: l2,
  collapseHeader: c2,
  collapseContent: d2,
  url: u2,
  externalLink: m2,
  emptyState: p2
}, f2 = ({
  linkedIssues: e,
  isLoading: n,
  handleUnlinkIssue: r,
  showUnlinkAllModal: i,
  showUnlinkAllButton: a,
  organizationUrl: o
}) => {
  const s = e.reduce(
    (u, f) => ({ ...u, [f.id]: !1 }),
    {}
  ), [l, d] = le(s), { track: m } = _n();
  return n ? /* @__PURE__ */ re.jsx(
    b,
    {
      flexDirection: "column",
      margin: "0 0 400 0",
      justifyContent: "center",
      alignItems: "center",
      children: /* @__PURE__ */ re.jsx(un, { size: 24 })
    }
  ) : e.length === 0 ? /* @__PURE__ */ re.jsxs(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      margin: "0 0 300 0",
      gap: "300",
      children: [
        /* @__PURE__ */ re.jsx(
          P.Paragraph,
          {
            align: "center",
            variant: "3",
            color: "neutral.400",
            className: ei.emptyState,
            children: "No linked issues found"
          }
        ),
        /* @__PURE__ */ re.jsx(
          Et,
          {
            slotEnd: /* @__PURE__ */ re.jsx(pe, { name: "external-link" }),
            variant: "tertiary",
            className: ei.externalLink,
            navigate: () => window.open(
              `https://linear.app/${e[0]?.team?.organization.urlKey ?? ""}`,
              "_blank"
            )?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  ) : /* @__PURE__ */ re.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "250",
      margin: "0 0 400 0",
      "data-testid": "linkedIssueWrapper",
      children: [
        e.map((u) => {
          const f = l[u.id];
          return /* @__PURE__ */ re.jsxs(
            mr,
            {
              "data-testid": "collapseCard",
              onToggle: () => d({ ...l, [u.id]: !l[u.id] }),
              isOpen: f,
              className: ei.collapse,
              children: [
                /* @__PURE__ */ re.jsx(mr.Header, { className: ei.collapseHeader, children: /* @__PURE__ */ re.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  /* @__PURE__ */ re.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                    /* @__PURE__ */ re.jsxs(b, { gap: "100", alignItems: "center", children: [
                      /* @__PURE__ */ re.jsx(We, { content: /* @__PURE__ */ re.jsx(b, { children: u.state.name }), children: /* @__PURE__ */ re.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ re.jsx(
                        Ps,
                        {
                          type: u.state.type,
                          color: u.state.color,
                          name: u.state.name
                        }
                      ) }) }),
                      /* @__PURE__ */ re.jsxs(
                        P.ExternalLink,
                        {
                          className: ei.url,
                          href: u.url,
                          target: "_blank",
                          rel: "noreferrer",
                          children: [
                            u.identifier,
                            /* @__PURE__ */ re.jsx(pe, { name: "external-link" })
                          ]
                        }
                      ),
                      /* @__PURE__ */ re.jsx(We, { content: /* @__PURE__ */ re.jsx(b, { children: u.priorityLabel }), children: /* @__PURE__ */ re.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ re.jsx(As, { priority: u.priority }) }) })
                    ] }),
                    /* @__PURE__ */ re.jsx(Pn, { children: u.state.name })
                  ] }),
                  u.title
                ] }) }),
                /* @__PURE__ */ re.jsx(mr.Content, { className: ei.collapseContent, children: /* @__PURE__ */ re.jsxs(b, { flexDirection: "column", gap: "300", children: [
                  u?.labels && u?.labels?.edges?.length > 0 && /* @__PURE__ */ re.jsx(
                    b,
                    {
                      flexDirection: "row",
                      gap: "200",
                      alignItems: "center",
                      flexWrap: "wrap",
                      children: u.labels?.edges.map((h) => /* @__PURE__ */ re.jsx(Pn, { color: h.node.color, children: h.node.name }, h.node.id))
                    }
                  ),
                  /* @__PURE__ */ re.jsx(cS, { issue: u }),
                  /* @__PURE__ */ re.jsx(
                    Gn,
                    {
                      slotStart: /* @__PURE__ */ re.jsx(pe, { name: "link-slash" }),
                      variant: "secondary",
                      onClick: () => r(u.id),
                      style: { marginTop: "var(--dixa-size-spacer-200)" },
                      children: "Unlink issue from Linear"
                    }
                  ),
                  /* @__PURE__ */ re.jsxs(
                    Et,
                    {
                      slotEnd: /* @__PURE__ */ re.jsx(pe, { name: "external-link" }),
                      variant: "tertiary",
                      className: ei.externalLink,
                      onClick: () => {
                        m("linear:open:issue:clicked", {
                          linearInstanceUrl: o,
                          linearIssueKey: u.id
                        });
                      },
                      navigate: () => window.open(u.url, "_blank")?.focus(),
                      children: [
                        "View ",
                        u.identifier,
                        " in Linear"
                      ]
                    }
                  )
                ] }) })
              ]
            },
            u.id
          );
        }),
        e.length > 1 && a && /* @__PURE__ */ re.jsx(
          Gn,
          {
            slotStart: /* @__PURE__ */ re.jsx(pe, { name: "link-slash" }),
            variant: "secondary",
            onClick: () => i(!0),
            children: "Unlink all issues"
          }
        ),
        /* @__PURE__ */ re.jsx(
          Et,
          {
            slotEnd: /* @__PURE__ */ re.jsx(pe, { name: "external-link" }),
            variant: "tertiary",
            className: ei.externalLink,
            onClick: () => {
              m("linear:open:linear:clicked", {
                // we check against empty linkedIssues earlier in the code.
                // function is using item at index 0 since all teams belong in the same organization/workspace,
                linearInstanceUrl: o,
                linearIssueKey: e[0].id
              });
            },
            disabled: !o,
            navigate: () => window.open(o, "_blank")?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  );
}, h2 = {
  default: (e, n) => (n() ?? []).join(""),
  nodes: {
    doc: (e, n) => (n() ?? []).join(""),
    heading: (e, n) => `
${"#".repeat(
      parseInt(e.attrs?.level) || 1
    )} ${n()}

`,
    bullet_list: (e, n) => `
` + n().map((r) => `- ${r}`).join(""),
    ordered_list: (e, n) => `
` + n().map((r) => `1. ${r}`).join(""),
    // We're not emitting list items from the listItem formatter but from the
    // ordered/bullet list nodes above, as markdown does not encapsulate list items
    //listItem: (_node, children) => '- ' + children(),
    paragraph: (e, n) => n().join("") + `
`,
    text: (e) => e.text ?? "",
    hard_break: () => `
`,
    blockquote: (e, n) => `> ${n().join("")}
`,
    code_block: (e, n) => "\n```" + (e.attrs?.language || "") + `
` + n() + "\n```\n"
  },
  marks: {
    text: {
      strong: (e, n) => `**${n()}**`,
      strike: (e, n) => `~~${n()}~~`,
      subsup: (e, n) => {
        switch (e.attrs?.type) {
          case "sub":
            return `<sub>${n()}</sub>`;
          case "sup":
            return `<sup>${n()}</sup>`;
          default:
            return n();
        }
      },
      underline: (e, n) => `<u>${n()}</u>`,
      em: (e, n) => `*${n()}*`,
      link: (e, n) => `[${n()}](${e.attrs?.href})`,
      code: (e, n) => `\`${n()}\``
    }
  }
}, uS = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => uS(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, y2 = "_modalBody_iv3ua_1", g2 = "_error_iv3ua_5", v2 = "_dropdown_iv3ua_16", Mi = {
  modalBody: y2,
  error: g2,
  dropdown: v2
}, k2 = Io(
  /* GraphQL */
  `
  mutation createIssue(
    $issueTitle: String!
    $issueDescription: String
    $teamId: String!
    $projectId: String
    $statusId: String
    $priority: Int
  ) {
    Linear {
      issueCreate(
        input: {
          title: $issueTitle
          description: $issueDescription
          teamId: $teamId
          projectId: $projectId
          stateId: $statusId
          priority: $priority
        }
      ) {
        success
        issue {
          id
          title
          identifier
          url
        }
      }
    }
  }
`
), b2 = Io(
  /* GraphQL */
  `
  query staticData {
    Linear {
      teams {
        edges {
          node {
            id
            name
            organization {
              urlKey
            }
          }
        }
      }
      issuePriorityValues {
        priority
        label
      }
      organization {
        urlKey
      }
    }
  }
`
), x2 = Io(
  /* GraphQL */
  `
  query teamData($teamId: String!) {
    Linear {
      team(id: $teamId) {
        projects {
          edges {
            node {
              id
              name
            }
          }
        }
        states {
          edges {
            node {
              id
              name
              type
              color
            }
          }
        }
        templates {
          edges {
            node {
              id
              name
              type
              templateData
            }
          }
        }
      }
    }
  }
`
), _2 = ({
  setCreatedIssue: e,
  isCreateIssueModalOpen: n,
  setIsCreateIssueModalOpen: r,
  setIsCreationSuccessfulModalOpen: i,
  addToLinkedIssueIds: a,
  organizationUrl: o,
  setOrganizationUrl: s
}) => {
  const { useLazyQuery: l, showNotification: d } = hn(), { control: m, handleSubmit: u, reset: f } = _t(), [h, g] = le([]), [C, S] = le(), [N, w] = le([]), [y, z] = le(), [$, I] = le([]), [T, U] = le(), [Q, J] = le([]), [ae, X] = le(), [B, O] = le([]), [q, ee] = le(), [ve, ue] = le(!1), { useMutation: ce } = hn(), { track: fe } = _n(), [W, { loading: xe }] = ce(
    k2,
    {
      onError: () => {
        ue(!1), d({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (Ee) => {
        const Ge = {
          identifier: Ee.Linear?.issueCreate?.issue?.identifier,
          url: Ee.Linear?.issueCreate?.issue?.url
        };
        Ee.Linear && Ee.Linear?.issueCreate?.issue?.id && (a(Ee.Linear?.issueCreate?.issue?.id), ze(Ge), ue(!1), d({
          title: "Issue was created and linked to the conversation",
          text: `Issue ${Ee.Linear.issueCreate.issue.identifier} was created and added to the active conversation`,
          icon: "exclamation-triangle-filled",
          severity: "success"
        }), fe("linear:create:new:issue:confirmed", {
          linearInstanceUrl: o
        }));
      }
    }
  ), [
    Ie,
    { data: K, loading: qe, error: Be }
  ] = l(b2, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => d({
      title: "Error while fetching team ID",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (Ee) => {
      const Ge = Ee.Linear.teams.edges.map(
        ({ node: Qe }) => Qe
      );
      g(Ge), J(Ee.Linear.issuePriorityValues), s(`${T2}${Ee.Linear.organization.urlKey}`);
    }
  }), [Oe, { data: Me, loading: $e }] = l(x2, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => d({
      title: "Error while fetching team projects",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (Ee) => {
      const Ge = Ee?.Linear?.team?.projects?.edges?.map(
        ({ node: ge }) => ge
      );
      w(Ge);
      const Qe = Ee?.Linear?.team?.states?.edges?.map(
        ({ node: ge }) => ge
      );
      I(Qe);
      const he = Ee?.Linear?.team?.templates?.edges?.map(
        ({ node: ge }) => ge
      );
      O(
        he.filter(
          (ge) => ge.type === "issue"
        )
      );
    }
  }), ze = (Ee) => {
    r(!1), z(void 0), S(void 0), U(void 0), X(void 0), ee(void 0), Ee && (e(Ee), i(!0)), f({
      title: "",
      description: "",
      projectId: "",
      teamId: "",
      statusId: "",
      priority: void 0
    });
  }, Re = (Ee) => {
    K && !qe && (W({
      variables: {
        issueTitle: Ee.title,
        issueDescription: Ee?.description,
        teamId: Ee.team.id,
        projectId: Ee?.project?.id,
        statusId: Ee?.status?.id,
        priority: Ee?.priority?.priority
      }
    }), ue(!0));
  };
  He(() => {
    n && Ie();
  }, [n]);
  const an = () => {
    fe("linear:create:new:issue:cancelled", {
      linearInstanceUrl: o
    });
  };
  return /* @__PURE__ */ re.jsxs(
    Tt,
    {
      isOpen: n,
      onClose: () => {
        an(), ze();
      },
      children: [
        /* @__PURE__ */ re.jsx(
          $t,
          {
            title: "Create new Linear issue",
            onClose: () => {
              an(), ze();
            }
          }
        ),
        /* @__PURE__ */ re.jsx(
          Dt,
          {
            className: Mi.modalBody,
            "data-testid": "createIssueModalBody",
            children: Be ? /* @__PURE__ */ re.jsx(Fn, { error: Be }) : /* @__PURE__ */ re.jsx("form", { onSubmit: u(Re), id: "issueCreationForm", children: /* @__PURE__ */ re.jsxs(st, { children: [
              /* @__PURE__ */ re.jsx(be, { span: 3, children: /* @__PURE__ */ re.jsx(
                Wt,
                {
                  control: m,
                  name: "team",
                  rules: {
                    required: "Team is required"
                  },
                  render: ({
                    field: { value: Ee, onChange: Ge },
                    fieldState: { error: Qe }
                  }) => /* @__PURE__ */ re.jsx(
                    ln,
                    {
                      required: !0,
                      label: "Team",
                      meta: {
                        error: Qe?.message ?? null
                      },
                      children: /* @__PURE__ */ re.jsx(
                        ni,
                        {
                          dropdownProps: { className: Mi.dropdown },
                          placeholder: "Select Linear team",
                          className: it({ [Mi.error]: Qe }),
                          getItemTitleByValue: (he) => he?.name,
                          onChange: (he) => {
                            z(void 0), U(void 0), X(void 0), ee(void 0), S(he.selectedValues[0]), Oe({
                              variables: { teamId: he.selectedValues[0].id }
                            }), Ge(he.selectedValues[0]);
                          },
                          value: C ? [Ee] : void 0,
                          children: h?.map((he) => /* @__PURE__ */ re.jsx(
                            ut.Item,
                            {
                              value: he,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ re.jsx(P.Paragraph, { children: he.name })
                            },
                            he.id
                          ))
                        }
                      )
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ re.jsx(be, { span: 3, children: /* @__PURE__ */ re.jsx(
                Wt,
                {
                  control: m,
                  name: "project",
                  render: ({ field: { value: Ee, onChange: Ge } }) => {
                    const Qe = $e ? [{ name: "Loading projects...", id: "" }] : void 0;
                    return /* @__PURE__ */ re.jsx(ln, { label: "Project", children: /* @__PURE__ */ re.jsx(
                      ni,
                      {
                        dropdownProps: { className: Mi.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (he) => he?.name,
                        disabled: C === void 0,
                        placeholder: C ? "Select Linear project" : "Select a Team first",
                        onChange: (he) => {
                          z(he.selectedValues[0]), Ge(he.selectedValues[0]);
                        },
                        value: y ? [Ee] : Qe,
                        children: /* @__PURE__ */ re.jsxs(re.Fragment, { children: [
                          $e && /* @__PURE__ */ re.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ re.jsx(un, { size: 24 })
                            }
                          ),
                          Me && !$e && N.map((he) => /* @__PURE__ */ re.jsx(
                            ut.Item,
                            {
                              value: he,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ re.jsx(P.Paragraph, { children: he.name })
                            },
                            he.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ re.jsx(be, { span: 6, children: /* @__PURE__ */ re.jsx(ln, { label: "Template", children: /* @__PURE__ */ re.jsx(
                ni,
                {
                  clearable: !0,
                  dropdownProps: { className: Mi.dropdown },
                  disabled: !C || $e,
                  placeholder: C ? "Select template" : "Select a Team first",
                  getItemTitleByValue: (Ee) => Ee?.name,
                  onChange: (Ee) => {
                    if (Ee.selectedValues.length > 0) {
                      ee(Ee.selectedValues[0]);
                      const Ge = JSON.parse(
                        Ee.selectedValues[0].templateData
                      ), Qe = Q.filter(
                        (Le) => Le.priority === Ge.priority
                      );
                      X(
                        Qe ? Qe[0] : void 0
                      );
                      const he = $.filter(
                        (Le) => Le.id === Ge.stateId
                      );
                      U(
                        he ? he[0] : void 0
                      );
                      const ge = N.filter(
                        (Le) => Le.id === Ge.projectId
                      );
                      z(
                        ge ? ge[0] : void 0
                      );
                      const De = Ge.description;
                      f({
                        title: Ge?.title,
                        priority: Qe[0],
                        status: he[0],
                        project: ge[0],
                        description: De ? uS(De, h2) : "",
                        team: C
                      });
                    } else
                      f({
                        title: "",
                        description: "",
                        team: C
                      }), z(void 0), X(void 0), U(void 0), ee(void 0);
                  },
                  value: q ? [q] : void 0,
                  children: B?.map((Ee) => /* @__PURE__ */ re.jsx(
                    ut.Item,
                    {
                      value: Ee,
                      noFixedSelectionStateSpace: !0,
                      children: /* @__PURE__ */ re.jsx(P.Paragraph, { children: Ee.name })
                    },
                    Ee.id
                  ))
                }
              ) }) }),
              /* @__PURE__ */ re.jsx(be, { span: 6, children: /* @__PURE__ */ re.jsx(
                Wt,
                {
                  control: m,
                  name: "title",
                  rules: {
                    required: "Title field is required",
                    minLength: 2
                  },
                  render: ({
                    field: { onChange: Ee, value: Ge },
                    fieldState: { error: Qe }
                  }) => /* @__PURE__ */ re.jsx(
                    pr,
                    {
                      required: !0,
                      label: "Title",
                      placeholder: "Insert issue title here",
                      input: {
                        name: "issueTitle",
                        value: Ge || "",
                        onChange: Ee
                      },
                      meta: {
                        error: Qe?.message ?? null
                      }
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ re.jsx(be, { span: 3, children: /* @__PURE__ */ re.jsx(
                Wt,
                {
                  control: m,
                  name: "status",
                  render: ({ field: { value: Ee, onChange: Ge } }) => {
                    const Qe = $e ? [
                      {
                        name: "Loading statuses...",
                        id: "",
                        type: "",
                        color: ""
                      }
                    ] : void 0;
                    return /* @__PURE__ */ re.jsx(ln, { label: "Status", children: /* @__PURE__ */ re.jsx(
                      ni,
                      {
                        dropdownProps: { className: Mi.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (he) => he?.name,
                        disabled: C === void 0,
                        placeholder: C ? "Select Issue status" : "Select a Team first",
                        onChange: (he) => {
                          U(he.selectedValues[0]), Ge(he.selectedValues[0]);
                        },
                        value: T ? [Ee] : Qe,
                        children: /* @__PURE__ */ re.jsxs(re.Fragment, { children: [
                          $e && /* @__PURE__ */ re.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ re.jsx(un, { size: 24 })
                            }
                          ),
                          Me && !$e && $.map((he) => /* @__PURE__ */ re.jsx(
                            ut.Item,
                            {
                              value: he,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ re.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ re.jsx(
                                      Ps,
                                      {
                                        type: he.type,
                                        color: he.color,
                                        name: he.name
                                      }
                                    ),
                                    /* @__PURE__ */ re.jsx(P.Paragraph, { children: he.name })
                                  ]
                                }
                              )
                            },
                            he.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ re.jsx(be, { span: 3, children: /* @__PURE__ */ re.jsx(
                Wt,
                {
                  control: m,
                  name: "priority",
                  render: ({ field: { value: Ee, onChange: Ge } }) => {
                    const Qe = qe ? [
                      {
                        label: "Loading Priorities...",
                        priority: 0
                      }
                    ] : void 0;
                    return /* @__PURE__ */ re.jsx(ln, { label: "Priority", children: /* @__PURE__ */ re.jsx(
                      ni,
                      {
                        clearable: !0,
                        getItemTitleByValue: (he) => he?.label,
                        disabled: C === void 0,
                        placeholder: C ? "Select Issue priority" : "Select a Team first",
                        onChange: (he) => {
                          X(he.selectedValues[0]), Ge(he.selectedValues[0]);
                        },
                        value: ae ? [Ee] : Qe,
                        children: /* @__PURE__ */ re.jsxs(re.Fragment, { children: [
                          $e && /* @__PURE__ */ re.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ re.jsx(un, { size: 24 })
                            }
                          ),
                          K && !qe && Q.map((he) => /* @__PURE__ */ re.jsx(
                            ut.Item,
                            {
                              value: he,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ re.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ re.jsx(
                                      As,
                                      {
                                        priority: he.priority
                                      }
                                    ),
                                    /* @__PURE__ */ re.jsx(P.Paragraph, { children: he.label })
                                  ]
                                }
                              )
                            },
                            he.priority
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ re.jsx(be, { children: /* @__PURE__ */ re.jsx(
                Wt,
                {
                  control: m,
                  name: "description",
                  render: ({
                    field: { onChange: Ee, value: Ge },
                    fieldState: { error: Qe }
                  }) => /* @__PURE__ */ re.jsx(
                    E0,
                    {
                      label: "Description",
                      placeholder: "Insert Issue description here",
                      input: {
                        name: "description",
                        value: Ge || "",
                        onChange: Ee
                      },
                      meta: {
                        error: Qe?.message ?? null
                      }
                    }
                  )
                }
              ) })
            ] }) })
          }
        ),
        /* @__PURE__ */ re.jsx(
          At,
          {
            confirmOnClick: u(Re),
            confirmProps: {
              disabled: xe || !K,
              isLoading: ve || qe || $e,
              loadingIndicator: /* @__PURE__ */ re.jsx(un, { size: 16 })
            },
            confirmName: "Save",
            cancelOnClick: () => {
              an(), ze();
            }
          }
        )
      ]
    }
  );
}, S2 = "_modalWrapper_4kh9u_1", N2 = "_copyButton_4kh9u_6", j2 = "_copyWrapper_4kh9u_15", w2 = "_copyField_4kh9u_24", C2 = "_externalLink_4kh9u_47", F2 = "_externalLinkIcon_4kh9u_52", I2 = "_textWrapper_4kh9u_56", ci = {
  modalWrapper: S2,
  copyButton: N2,
  copyWrapper: j2,
  copyField: w2,
  externalLink: C2,
  externalLinkIcon: F2,
  textWrapper: I2
}, E2 = ({
  isCreationSuccessfulModalOpen: e,
  createdIssueData: n,
  setIsCreationSuccessfulModalOpen: r
}) => /* @__PURE__ */ re.jsxs(
  Tt,
  {
    isOpen: !!n && e,
    className: ci.modalWrapper,
    onClose: () => r(!1),
    children: [
      /* @__PURE__ */ re.jsx(
        $t,
        {
          title: "Issue creation successful",
          onClose: () => r(!1)
        }
      ),
      /* @__PURE__ */ re.jsx(Dt, { children: /* @__PURE__ */ re.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          "data-testid": "creationSuccessfulModal",
          children: [
            /* @__PURE__ */ re.jsxs(P.Paragraph, { className: ci.textWrapper, children: [
              `You can visit issue ${n?.identifier} by following `,
              " ",
              /* @__PURE__ */ re.jsxs(
                P.ExternalLink,
                {
                  href: n?.url,
                  target: "_blank",
                  className: ci.externalLink,
                  children: [
                    "this link",
                    " ",
                    /* @__PURE__ */ re.jsx(pe, { name: "external-link", className: ci.externalLinkIcon })
                  ]
                }
              ),
              "or copy it from the field below."
            ] }),
            /* @__PURE__ */ re.jsx(ln, { label: "Linear issue link", children: /* @__PURE__ */ re.jsxs(
              b,
              {
                flexDirection: "row",
                alignItems: "center",
                "data-testid": "copyInputField",
                className: ci.copyWrapper,
                children: [
                  /* @__PURE__ */ re.jsx(
                    Nr,
                    {
                      readOnly: !0,
                      value: n?.url,
                      className: ci.copyField
                    }
                  ),
                  /* @__PURE__ */ re.jsx(
                    T0,
                    {
                      className: ci.copyButton,
                      textToCopy: n?.url || "",
                      clickedProps: {
                        icon: "check-circle-filled"
                      }
                    }
                  )
                ]
              }
            ) })
          ]
        }
      ) }),
      /* @__PURE__ */ re.jsx(
        At,
        {
          cancelOnClick: () => r(!1),
          cancelProps: { variant: "primary" },
          cancelName: "Close"
        }
      )
    ]
  }
), T2 = "https://linear.app/", $2 = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = le([]), [a, o] = le([]), [s, l] = le(!1), [d, m] = le(!1), [u, f] = le(!1), [h, g] = le(), { useLazyQuery: C } = hn(), [S, N] = le(""), w = n?.enableCreateIssue, y = !!n?.enableUnlinkAll, { track: z } = _n(), {
    loading: $,
    data: I,
    error: T,
    store: U
  } = Um(e?.conversationId ?? null), [
    Q,
    {
      data: J,
      loading: ae,
      networkStatus: X,
      error: B
    }
  ] = C(AP, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  He(() => {
    !$ && !T && I && I?.linear?.issues?.length > 0 ? (o(I.linear.issues), Q({
      variables: {
        linkedIssues: I.linear.issues
      }
    })) : !$ && !T && (i([]), o([]));
  }, [I, $, T]), He(() => {
    J && J?.Linear && !ae && X === er.ready && Object.keys(J).length > 0 && i(J.Linear.issues?.edges?.map(({ node: ue }) => ue));
  }, [J, ae, X]);
  const O = (ue) => {
    ue && ue?.team?.organization?.urlKey && z("linear:link:issue:clicked", {
      linearInstanceUrl: S,
      linearIssueKey: ue.id
    });
    const ce = (fe) => fe.id === ue?.id;
    r.some((fe) => fe && ce(fe)) || (I && a.length === 0 && o([]), U({
      linear: {
        issues: [...a, ue.id]
      }
    }));
  }, q = (ue) => {
    const ce = I?.linear.issues.filter((fe) => fe !== ue) || [];
    z("linear:unlink:issue:clicked", {
      linearInstanceUrl: S,
      linearIssueKey: ue
    }), i(r.filter(({ id: fe }) => fe !== ue)), o(ce), U({
      linear: {
        issues: ce
      }
    });
  }, ee = () => {
    l(!1), i([]), o([]), U({
      linear: {
        issues: []
      }
    });
  }, ve = $ || ae || !I && !T || (I?.linear?.issues?.length ?? 0) > 0 && r.length === 0;
  return !$ && !ae && (B || T) ? /* @__PURE__ */ re.jsx(Fn, { error: B || T }) : /* @__PURE__ */ re.jsxs(b, { flexDirection: "column", gap: "300", children: [
    /* @__PURE__ */ re.jsxs(
      Tt,
      {
        isOpen: s,
        onClose: () => l(!1),
        children: [
          /* @__PURE__ */ re.jsx(
            $t,
            {
              title: "Unlink all Linear issues?",
              onClose: () => l(!1)
            }
          ),
          /* @__PURE__ */ re.jsx(Dt, { "data-testid": "unlinkAllIssuesModalBody", children: "You are about to unlink all Linear issues from the conversation. Do you want to proceed?" }),
          /* @__PURE__ */ re.jsx(
            At,
            {
              confirmOnClick: () => ee(),
              confirmName: "Unlink all",
              cancelOnClick: () => l(!1)
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ re.jsx(
      _2,
      {
        isCreateIssueModalOpen: d,
        setIsCreateIssueModalOpen: (ue) => m(ue),
        setIsCreationSuccessfulModalOpen: (ue) => f(ue),
        addToLinkedIssueIds: (ue) => {
          U({
            linear: {
              issues: [...a, ue]
            }
          });
        },
        setCreatedIssue: (ue) => g(ue),
        organizationUrl: S,
        setOrganizationUrl: (ue) => N(ue)
      }
    ),
    /* @__PURE__ */ re.jsx(
      E2,
      {
        isCreationSuccessfulModalOpen: u,
        setIsCreationSuccessfulModalOpen: (ue) => f(ue),
        createdIssueData: h
      }
    ),
    /* @__PURE__ */ re.jsxs(
      b,
      {
        flexDirection: "column",
        background: "neutral.100",
        padding: "300",
        borderRadius: "100",
        gap: "250",
        children: [
          w && /* @__PURE__ */ re.jsxs(re.Fragment, { children: [
            /* @__PURE__ */ re.jsx(
              Gn,
              {
                variant: "primary",
                onClick: () => {
                  z("linear:create:new:issue:clicked", {
                    linearInstanceUrl: S
                  }), m(!0);
                },
                style: { minHeight: "38px" },
                children: "Create new issue"
              }
            ),
            /* @__PURE__ */ re.jsx(P.Paragraph, { color: "neutral.600", align: "center", children: "or" })
          ] }),
          /* @__PURE__ */ re.jsx(s2, { handleSelect: O, linkedIssues: r })
        ]
      }
    ),
    /* @__PURE__ */ re.jsx(
      f2,
      {
        linkedIssues: r,
        isLoading: ve,
        handleUnlinkIssue: q,
        showUnlinkAllModal: (ue) => l(ue),
        showUnlinkAllButton: y,
        organizationUrl: S
      }
    )
  ] });
}, D2 = [
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableUnlinkAll",
    label: 'Enable the "Unlink all" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Lr
  }
], lk = [
  {
    key: "enableCreateIssue",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "enableUnlinkAll",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], di = "LINEAR", R2 = {
  enabled: !1,
  name: "",
  enableCreateIssue: !0,
  enableUnlinkAll: !0
}, O2 = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = _t({
    mode: "onChange",
    defaultValues: R2
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: g,
    setMisconfigurationCause: C
  } = ji({
    integrationId: e,
    integrationType: di,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: S,
    error: N,
    isWidgetUnknown: w,
    refetch: y,
    widgetConfiguration: z
  } = wi({
    integrationId: e,
    fieldDefinitions: lk,
    form: l,
    onMisconfigured: C
  }), { renderConditions: $, setRenderConditions: I, renderConditionsForSubmit: T } = Ci({
    integrationId: e,
    widgetConfiguration: z,
    renderConditionsEditor: o
  }), U = (J) => Ii(J, {
    fieldDefinitions: lk,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: T
  }), Q = l.watch("name");
  return /* @__PURE__ */ re.jsxs(
    Fi,
    {
      form: l,
      integrationId: e,
      onValidSubmit: U,
      error: N ?? h,
      onRetry: N ? y : void 0,
      isLoading: f || S,
      isWidgetUnknown: w,
      children: [
        g && /* @__PURE__ */ re.jsx(Ei, { cause: g }),
        /* @__PURE__ */ re.jsxs(st, { children: [
          /* @__PURE__ */ re.jsx(be, { children: /* @__PURE__ */ re.jsx(ln, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ re.jsx(
            Jn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(be, { span: 3, children: /* @__PURE__ */ re.jsx(
            tt,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ re.jsx(be, { span: 3 }),
          /* @__PURE__ */ re.jsx(be, { span: 3, children: /* @__PURE__ */ re.jsx(ln, { label: 'Enable the "Create issue" button', children: /* @__PURE__ */ re.jsx(
            Jn,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(be, { span: 3 }),
          /* @__PURE__ */ re.jsx(be, { span: 3, children: /* @__PURE__ */ re.jsx(ln, { label: 'Enable the "Unlink all" button', children: /* @__PURE__ */ re.jsx(
            Jn,
            {
              name: "enableUnlinkAll",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ re.jsx(be, { span: 3 }),
          !s && e && /* @__PURE__ */ re.jsx(
            Lr,
            {
              configuration: n,
              integrationId: e,
              integrationType: di,
              label: "Authorize with OAuth"
            }
          ),
          o && $ !== null && /* @__PURE__ */ re.jsx(be, { children: o({
            value: $,
            onChange: I,
            configurationKey: z?.id
          }) })
        ] }),
        /* @__PURE__ */ re.jsx(
          Ti,
          {
            integrationType: di,
            integrationId: e,
            widgetName: Q,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ re.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ re.jsx(
                pe,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ re.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ re.jsxs(P.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  di,
                  " integration, all links between Dixa and ",
                  di,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ re.jsxs(P.Paragraph, { children: [
                  "All data in ",
                  di,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ re.jsxs(P.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  di,
                  " ",
                  'integration "',
                  Q,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._wrapper_27vny_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_27vny_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._copyIcon_27vny_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._labelText_1q5b5_1{color:var(--dixa-typography-color-secondary)}._list_1q5b5_5{padding:0}._listItem_1q5b5_8{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1q5b5_8:last-child{border-bottom:none}._listItemEdit_1q5b5_15{cursor:pointer}._notificationText_1q5b5_19{color:var(--dixa-color-neutral-500)}._modalBody_1clhs_1{width:400px}._reward_1wxia_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1wxia_1:hover{border-color:var(--dixa-color-neutral-400)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Tu = { exports: {} }, Oa = {}, ck;
function A2() {
  if (ck) return Oa;
  ck = 1;
  var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return Oa.Fragment = r, Oa.jsx = s, Oa.jsxs = s, Oa;
}
var Ko = {}, dk;
function P2() {
  return dk || (dk = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        z("error", t, p);
      }
    }
    function z(t, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, A = v.getStackAddendum();
        A !== "" && (c += "%s", p = p.concat([A]));
        var L = p.map(function(F) {
          return String(F);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, I = !1, T = !1, U = !1, Q = !1, J;
    J = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === u || U || t === g || $ || I || T || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function X(t, c, p) {
      var v = t.displayName;
      if (v)
        return v;
      var A = c.displayName || c.name || "";
      return A !== "" ? p + "(" + A + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return X(t, t.render, "ForwardRef");
          case f:
            var v = t.displayName || null;
            return v !== null ? v : O(t.type) || "Memo";
          case h: {
            var A = t, L = A._payload, F = A._init;
            try {
              return O(F(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, ue, ce, fe, W, xe, Ie;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ve = console.log, ue = console.info, ce = console.warn, fe = console.error, W = console.group, xe = console.groupCollapsed, Ie = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: ue
            }),
            warn: q({}, t, {
              value: ce
            }),
            error: q({}, t, {
              value: fe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: xe
            }),
            groupEnd: q({}, t, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Me;
    function $e(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (A) {
            var v = A.stack.trim().match(/\n( *(at )?)/);
            Me = v && v[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var ze = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(t, c) {
      if (!t || ze)
        return "";
      {
        var p = Re.get(t);
        if (p !== void 0)
          return p;
      }
      var v;
      ze = !0;
      var A = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, qe();
      try {
        if (c) {
          var F = function() {
            throw Error();
          };
          if (Object.defineProperty(F.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(F, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(t, [], F);
          } else {
            try {
              F.call();
            } catch (ne) {
              v = ne;
            }
            t.call(F.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), G = j.length - 1, _ = te.length - 1; G >= 1 && _ >= 0 && j[G] !== te[_]; )
            _--;
          for (; G >= 1 && _ >= 0; G--, _--)
            if (j[G] !== te[_]) {
              if (G !== 1 || _ !== 1)
                do
                  if (G--, _--, _ < 0 || j[G] !== te[_]) {
                    var Z = `
` + j[G].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (G >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Oe.current = L, Be(), Error.prepareStackTrace = A;
      }
      var de = t ? t.displayName || t.name : "", Se = de ? $e(de) : "";
      return typeof t == "function" && Re.set(t, Se), Se;
    }
    function Ge(t, c, p) {
      return Ee(t, !1);
    }
    function Qe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function he(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Qe(t));
      if (typeof t == "string")
        return $e(t);
      switch (t) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ge(t.render);
          case f:
            return he(t.type, c, p);
          case h: {
            var v = t, A = v._payload, L = v._init;
            try {
              return he(L(A), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, De = {}, Le = w.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = he(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(t, c, p, v, A) {
      {
        var L = Function.call.bind(ge);
        for (var F in t)
          if (L(t, F)) {
            var j = void 0;
            try {
              if (typeof t[F] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + F + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[F] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[F](c, F, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (G) {
              j = G;
            }
            j && !(j instanceof Error) && (Ae(A), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, F, typeof j), Ae(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Ae(A), y("Failed %s type: %s", p, j.message), Ae(null));
          }
      }
    }
    var E = Array.isArray;
    function x(t) {
      return E(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var V = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, me, Ne;
    function nn(t) {
      if (ge.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function fn(t) {
      if (ge.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && V.current;
    }
    function cn(t, c) {
      {
        var p = function() {
          me || (me = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(t, c, p, v, A, L, F) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: F,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: A
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, v, A) {
      {
        var L, F = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), fn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ge.call(c, L) && !ie.hasOwnProperty(L) && (F[L] = c[L]);
        if (t && t.defaultProps) {
          var G = t.defaultProps;
          for (L in G)
            F[L] === void 0 && (F[L] = G[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && cn(F, _), te && pn(F, _);
        }
        return dn(t, j, te, A, v, V.current, F);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = he(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var t = O(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        t && t._owner && t._owner !== en.current && (v = " It was passed a child from " + O(t._owner.type) + "."), Pe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Pe(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var v = t[p];
            sn(v) && gn(v, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var A = N(t);
          if (typeof A == "function" && A !== t.entries)
            for (var L = A.call(t), F; !(F = L.next()).done; )
              sn(F.value) && gn(F.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          mn(p, t.props, "prop", v, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var A = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", A || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Pe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Pe(null);
            break;
          }
        }
        t.ref !== null && (Pe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Pe(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, v, A, L) {
      {
        var F = ae(t);
        if (!F) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var G;
          t === null ? G = "null" : x(t) ? G = "array" : t !== void 0 && t.$$typeof === n ? (G = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : G = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", G, j);
        }
        var _ = xn(t, c, p, A, L);
        if (_ == null)
          return _;
        if (F) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var de = 0; de < Z.length; de++)
                  Cn(Z[de], t);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, t);
        }
        if (ge.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, Se, $n, Se), Sn[Se + Ke] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Ko.Fragment = i, Ko.jsx = Rn, Ko.jsxs = Mn;
  })()), Ko;
}
var uk;
function L2() {
  return uk || (uk = 1, process.env.NODE_ENV === "production" ? Tu.exports = A2() : Tu.exports = P2()), Tu.exports;
}
var we = L2();
const V2 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, z2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "addPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UpdateCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UpdateCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, U2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "removeCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RemoveCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "RemoveCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, M2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "points_approved" } }, { kind: "Field", name: { kind: "Name", value: "points_pending" } }, { kind: "Field", name: { kind: "Name", value: "points_spent" } }, { kind: "Field", name: { kind: "Name", value: "rewards_claimed" } }, { kind: "Field", name: { kind: "Name", value: "birthday" } }, { kind: "Field", name: { kind: "Name", value: "guest" } }, { kind: "Field", name: { kind: "Name", value: "blocked" } }, { kind: "Field", name: { kind: "Name", value: "enrolled" } }, { kind: "Field", name: { kind: "Name", value: "enrolled_at" } }, { kind: "Field", name: { kind: "Name", value: "referral_id" } }, { kind: "Field", name: { kind: "Name", value: "referred_by" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }] } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier_membership" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "started_at" } }, { kind: "Field", name: { kind: "Name", value: "expires_at" } }, { kind: "Field", name: { kind: "Name", value: "manual" } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "position" } }, { kind: "Field", name: { kind: "Name", value: "default" } }, { kind: "Field", name: { kind: "Name", value: "hidden" } }, { kind: "Field", name: { kind: "Name", value: "lower_bound" } }, { kind: "Field", name: { kind: "Name", value: "upper_bound" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "insights_segment" } }, { kind: "Field", name: { kind: "Name", value: "referral_url" } }, { kind: "Field", name: { kind: "Name", value: "metadata" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopify_source_url" } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }] } }] } }] } }] } }] } }] } }] } }] }, B2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getRewards" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAvailableRewards" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getAvailableRewards_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Rewards" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "rewards" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "site_id" } }, { kind: "Field", name: { kind: "Name", value: "target_site" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "content" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "point_cost" } }] } }] } }, { kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, q2 = {
  "\n  fragment BadRequest on LoyaltyLion_BadRequest {\n    message\n  }\n  fragment Unauthorized on LoyaltyLion_Unauthorized {\n    message\n  }\n  fragment Forbidden on LoyaltyLion_Forbidden {\n    message\n  }\n  fragment NotFound on LoyaltyLion_NotFound {\n    message\n  }\n  fragment UnprocessableEntity on LoyaltyLion_UnprocessableEntity {\n    message\n  }\n  fragment ServerError on LoyaltyLion_ServerError {\n    message\n  }\n\n  fragment UpdateCustomersPointsResponse on LoyaltyLion_updateCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n\n  fragment RemoveCustomersPointsResponse on LoyaltyLion_removeCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n": V2,
  "\n  mutation addPoints(\n    $merchantId: String!\n    $input: LoyaltyLion_updateCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      updateCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_updateCustomersPoints_response {\n          ...UpdateCustomersPointsResponse\n        }\n      }\n    }\n  }\n": z2,
  "\n  mutation removePoints(\n    $merchantId: String!\n    $input: LoyaltyLion_removeCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      removeCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_removeCustomersPoints_response {\n          ...RemoveCustomersPointsResponse\n        }\n      }\n    }\n  }\n": U2,
  "\n  query getCustomers($email: String!) {\n    LoyaltyLion {\n      getCustomers(email: $email) {\n        ... on LoyaltyLion_getCustomers_response {\n          ... on LoyaltyLion_Customers {\n            customers {\n              id\n              merchant_id\n              email\n              points_approved\n              points_pending\n              points_spent\n              rewards_claimed\n              birthday\n              guest\n              blocked\n              enrolled\n              enrolled_at\n              referral_id\n              referred_by {\n                id\n                merchant_id\n              }\n              loyalty_tier_membership {\n                started_at\n                expires_at\n                manual\n                loyalty_tier {\n                  id\n                  name\n                  position\n                  default\n                  hidden\n                  lower_bound\n                  upper_bound\n                }\n              }\n              insights_segment\n              referral_url\n              metadata {\n                shopify_source_url\n              }\n              properties {\n                name\n                first_name\n                last_name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": M2,
  "\n  query getRewards($merchantId: String!) {\n    LoyaltyLion {\n      getAvailableRewards(merchant_id: $merchantId) {\n        ... on LoyaltyLion_getAvailableRewards_response {\n          ... on LoyaltyLion_Rewards {\n            rewards {\n              id\n              title\n              description\n              site_id\n              target_site {\n                id\n                name\n                url\n              }\n              content\n              kind\n              point_cost\n            }\n          }\n          ...BadRequest\n          ...Unauthorized\n          ...Forbidden\n          ...NotFound\n          ...ServerError\n        }\n      }\n    }\n  }\n": B2
};
function ml(e) {
  return q2[e] ?? {};
}
const H2 = ml(
  /* GraphQL */
  `
  query getCustomers($email: String!) {
    LoyaltyLion {
      getCustomers(email: $email) {
        ... on LoyaltyLion_getCustomers_response {
          ... on LoyaltyLion_Customers {
            customers {
              id
              merchant_id
              email
              points_approved
              points_pending
              points_spent
              rewards_claimed
              birthday
              guest
              blocked
              enrolled
              enrolled_at
              referral_id
              referred_by {
                id
                merchant_id
              }
              loyalty_tier_membership {
                started_at
                expires_at
                manual
                loyalty_tier {
                  id
                  name
                  position
                  default
                  hidden
                  lower_bound
                  upper_bound
                }
              }
              insights_segment
              referral_url
              metadata {
                shopify_source_url
              }
              properties {
                name
                first_name
                last_name
              }
            }
          }
        }
      }
    }
  }
`
), W2 = ml(
  /* GraphQL */
  `
  query getRewards($merchantId: String!) {
    LoyaltyLion {
      getAvailableRewards(merchant_id: $merchantId) {
        ... on LoyaltyLion_getAvailableRewards_response {
          ... on LoyaltyLion_Rewards {
            rewards {
              id
              title
              description
              site_id
              target_site {
                id
                name
                url
              }
              content
              kind
              point_cost
            }
          }
          ...BadRequest
          ...Unauthorized
          ...Forbidden
          ...NotFound
          ...ServerError
        }
      }
    }
  }
`
), G2 = ml(
  /* GraphQL */
  `
  mutation addPoints(
    $merchantId: String!
    $input: LoyaltyLion_updateCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      updateCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_updateCustomersPoints_response {
          ...UpdateCustomersPointsResponse
        }
      }
    }
  }
`
), K2 = ml(
  /* GraphQL */
  `
  mutation removePoints(
    $merchantId: String!
    $input: LoyaltyLion_removeCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      removeCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_removeCustomersPoints_response {
          ...RemoveCustomersPointsResponse
        }
      }
    }
  }
`
);
function $u(e = !1, n) {
  const [r, i] = le(e);
  return He(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const Y2 = "_wrapper_27vny_1", Q2 = "_copyIcon_27vny_12", Aa = {
  wrapper: Y2,
  copyIcon: Q2
}, J2 = ({
  customer: e
}) => {
  const { isCopied: n, copy: r } = $u(), { isCopied: i, copy: a } = $u(), { isCopied: o, copy: s } = $u();
  if (!e)
    return null;
  const l = 14, {
    email: d,
    properties: m,
    metadata: u,
    birthday: f,
    created_at: h,
    enrolled: g,
    enrolled_at: C,
    referral_url: S
  } = e, N = f ? Ln(f).isSame(Date.now(), "day") : !1, { name: w, first_name: y, last_name: z } = m ?? {}, $ = w ?? (`${y} ${z}`.trim() || "A customer has no name"), I = u?.shopify_source_url ? u.shopify_source_url.startsWith("https://") ? u.shopify_source_url : `https://${u.shopify_source_url}` : "";
  return /* @__PURE__ */ we.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ we.jsxs(b, { className: Aa.wrapper, gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ we.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: Aa.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ we.jsx(P.Heading, { variant: "heading-2", children: $ }),
          N && /* @__PURE__ */ we.jsx(P.Paragraph, { variant: "4", color: "primary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    h && /* @__PURE__ */ we.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ we.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "Member since" }),
      /* @__PURE__ */ we.jsx(P.Paragraph, { variant: "4", color: "secondary", children: Ln(h).format("DD MMM YYYY @ HH:mm") })
    ] }),
    g && /* @__PURE__ */ we.jsx(b, { gap: "200", children: /* @__PURE__ */ we.jsxs(P.Paragraph, { variant: "4", color: "secondary", children: [
      "Enrolled since ",
      Ln(C).format("DD MMM YYYY @ HH:mm")
    ] }) }),
    /* @__PURE__ */ we.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ we.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ we.jsx(pe, { size: l, name: "mail" }),
        /* @__PURE__ */ we.jsx(P.ExternalLink, { href: `mailto:${d}`, children: d })
      ] }),
      /* @__PURE__ */ we.jsx(We, { content: n ? "Copied" : "Copy", children: /* @__PURE__ */ we.jsx(
        pe,
        {
          size: l,
          name: n ? "done" : "copy",
          onClick: () => r(d),
          className: Aa.copyIcon
        }
      ) })
    ] }),
    I && /* @__PURE__ */ we.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ we.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ we.jsx(pe, { size: l, name: "link" }),
        /* @__PURE__ */ we.jsx(We, { content: "Shopify shop", children: /* @__PURE__ */ we.jsx(
          P.ExternalLink,
          {
            href: I,
            target: "_blank",
            rel: "noreferrer",
            children: I.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ we.jsx(We, { content: i ? "Copied" : "Copy", children: /* @__PURE__ */ we.jsx(
        pe,
        {
          size: l,
          name: i ? "done" : "copy",
          onClick: () => a(I),
          className: Aa.copyIcon
        }
      ) })
    ] }),
    S && /* @__PURE__ */ we.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ we.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ we.jsx(pe, { size: l, name: "external-link" }),
        /* @__PURE__ */ we.jsx(We, { content: "Referral link", children: /* @__PURE__ */ we.jsx(
          P.ExternalLink,
          {
            href: S,
            target: "_blank",
            rel: "noreferrer",
            children: S.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ we.jsx(We, { content: o ? "Copied" : "Copy", children: /* @__PURE__ */ we.jsx(
        pe,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(S),
          className: Aa.copyIcon
        }
      ) })
    ] })
  ] }) });
}, X2 = "_list_1q5b5_5", Z2 = "_listItem_1q5b5_8", eL = "_listItemEdit_1q5b5_15", nL = "_notificationText_1q5b5_19", oa = {
  list: X2,
  listItem: Z2,
  listItemEdit: eL,
  notificationText: nL
}, tL = "_modalBody_1clhs_1", rL = {
  modalBody: tL
}, iL = ({
  isOpen: e,
  points: n,
  merchantId: r,
  onClose: i,
  refetchCustomerData: a
}) => {
  const { useMutation: o, showNotification: s } = hn(), { track: l } = _n(), [d, m] = le(n), [u, f] = le(""), [h, g] = le(), [C, { loading: S }] = o(
    G2,
    {
      onCompleted: () => {
        s({
          title: "Success",
          text: "Added points successfully",
          icon: "check-circle-filled",
          severity: "success"
        }), l("loyaltylion:add:points:succeeded"), X();
      }
    }
  ), [N, { loading: w }] = o(K2), y = S || w, z = !!h, $ = n === d ? "Change the value to update the points" : "", I = isNaN(d), T = I ? "Points can not be empty" : "", U = d > n && d - n > 1e6, Q = U ? "Points can not exceed 1,000,000" : "", J = () => {
    if (!r) {
      g(["Merchant information is missing."]), d > n ? l("loyaltylion:add:points:failed") : d < n && l("loyaltylion:remove:points:failed");
      return;
    }
    d > n && C({
      variables: {
        input: {
          points: d - n,
          reason: u
        },
        merchantId: r
      }
    }).catch((B) => {
      const O = B?.networkError;
      (O ? O?.statusCode : NaN) === 201 ? (l("loyaltylion:add:points:succeeded"), s({
        title: "Success",
        text: "Added points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), X()) : (l("loyaltylion:add:points:failed"), g(["Failed to add points, try again later."]));
    }), d < n && N({
      variables: {
        input: {
          points: n - d,
          reason: u
        },
        merchantId: r
      }
    }).then((B) => {
      B.data?.LoyaltyLion?.removeCustomersPoints?.__typename === "LoyaltyLion_Void_container" ? (l("loyaltylion:remove:points:succeeded"), s({
        title: "Success",
        text: "Removed points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), X()) : "errors" in B && (l("loyaltylion:remove:points:failed"), g(
        B.errors?.map((O) => O.message) ?? [
          "Failed to remove points, try again later."
        ]
      ));
    }).catch(() => {
      l("loyaltylion:remove:points:failed"), g(["Failed to remove points, try again later."]);
    });
  }, ae = () => {
    I && m(n), f(""), i();
  }, X = () => {
    a(), ae();
  };
  return /* @__PURE__ */ we.jsxs(
    Tt,
    {
      isOpen: e,
      onClose: ae,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ we.jsx($t, { title: "Change points", onClose: ae }),
        /* @__PURE__ */ we.jsxs(Dt, { className: rL.modalBody, children: [
          /* @__PURE__ */ we.jsxs(st, { children: [
            /* @__PURE__ */ we.jsx(be, { span: 6, children: /* @__PURE__ */ we.jsx(
              pr,
              {
                required: !0,
                label: "New points",
                type: "number",
                placeholder: "Insert new points",
                min: 0,
                max: 1e5,
                meta: {
                  error: Q || T,
                  warning: $
                },
                input: {
                  name: "points",
                  value: d.toString(),
                  onChange: (B) => m(B?.target.valueAsNumber ?? 0)
                },
                "data-testid": "points-input"
              }
            ) }),
            /* @__PURE__ */ we.jsx(be, { span: 6, children: /* @__PURE__ */ we.jsx(
              pr,
              {
                label: "Reason",
                placeholder: "Insert an optional reason",
                input: {
                  name: "reason",
                  value: u,
                  onChange: (B) => f(B?.target.value ?? "")
                }
              }
            ) })
          ] }),
          !y && z && /* @__PURE__ */ we.jsx(b, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ we.jsx(Ye, { children: h?.map((B, O) => /* @__PURE__ */ we.jsx(
            Ye.Item,
            {
              variant: "dense",
              title: B,
              contentLeft: /* @__PURE__ */ we.jsx(
                pe,
                {
                  color: "red.500",
                  size: 16,
                  name: "exclamation-triangle-filled"
                }
              )
            },
            O
          )) }) })
        ] }),
        /* @__PURE__ */ we.jsx(
          At,
          {
            confirmName: "Save",
            confirmOnClick: () => J(),
            confirmProps: {
              isLoading: y,
              disabled: I || U || n === d,
              loadingIndicator: /* @__PURE__ */ we.jsx(un, { size: 16 })
            },
            cancelOnClick: ae
          }
        )
      ]
    }
  );
}, aL = ({
  label: e,
  points: n,
  setIsModalOpen: r
}) => {
  const i = n > 0 ? "green.500" : "neutral.400", a = n > 0 ? "warning" : "secondary", o = 10;
  return /* @__PURE__ */ we.jsx(Ye.Text, { variant: "dense", className: oa.listItem, children: /* @__PURE__ */ we.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ we.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ we.jsx(pe, { color: i, size: o, name: "star-full" }),
      /* @__PURE__ */ we.jsx(P.Paragraph, { variant: "4", children: e })
    ] }),
    /* @__PURE__ */ we.jsxs(b, { gap: "200", alignItems: "center", children: [
      r && /* @__PURE__ */ we.jsx(We, { content: "Edit points", children: /* @__PURE__ */ we.jsx(
        pe,
        {
          name: "pen",
          size: o,
          "aria-label": "Edit points",
          className: oa.listItemEdit,
          onClick: () => r(!0)
        }
      ) }),
      /* @__PURE__ */ we.jsx(An, { size: "small", variant: a, children: n })
    ] })
  ] }) });
}, oL = ({
  customer: e,
  refetchCustomerData: n
}) => {
  const [r, i] = le(!1);
  if (!e)
    return null;
  const {
    merchant_id: a,
    points_approved: o,
    points_pending: s,
    points_spent: l,
    rewards_claimed: d
  } = e, m = [
    {
      id: "pointsApproved",
      label: "Points approved",
      points: o ?? 0,
      setIsModalOpen: i
    },
    {
      id: "pointsPending",
      label: "Points pending",
      points: s ?? 0
    },
    {
      id: "pointsSpent",
      label: "Points spent",
      points: l ?? 0
    },
    {
      id: "rewardClaimed",
      label: "Rewards claimed",
      points: d ?? 0
    }
  ];
  return /* @__PURE__ */ we.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ we.jsx(P.Heading, { variant: "heading-3", children: "Points balance" }),
    /* @__PURE__ */ we.jsx(Ye, { className: oa.list, children: m.map(({ id: u, points: f, label: h, setIsModalOpen: g }) => /* @__PURE__ */ we.jsx(
      aL,
      {
        points: f,
        label: h,
        setIsModalOpen: g
      },
      u
    )) }),
    /* @__PURE__ */ we.jsx(
      iL,
      {
        isOpen: r,
        points: o,
        merchantId: a,
        onClose: () => i(!1),
        refetchCustomerData: n
      }
    )
  ] });
}, sL = "_reward_1wxia_1", lL = {
  reward: sL
}, cL = ({ reward: e }) => {
  const {
    title: n,
    point_cost: r,
    target_site: i,
    description: a
  } = e, o = i?.name, s = i?.url;
  return /* @__PURE__ */ we.jsx(b, { gap: "100", flexDirection: "column", className: lL.reward, children: /* @__PURE__ */ we.jsx(We, { content: a ?? "No description", children: /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ we.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ we.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ we.jsx(pe, { name: "star", size: 12, color: "neutral.500" }),
        n
      ] }),
      /* @__PURE__ */ we.jsxs(An, { size: "small", variant: "info", children: [
        r ?? 0,
        " points"
      ] })
    ] }),
    o && s && /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ we.jsx(pe, { size: 14, name: "external-link" }),
      /* @__PURE__ */ we.jsx(
        P.ExternalLink,
        {
          href: s,
          target: "_blank",
          rel: "noreferrer",
          children: o
        }
      )
    ] })
  ] }) }) });
}, dL = ({ customer: e }) => {
  const { useQuery: n } = hn(), [r, i] = le(), { merchant_id: a } = e, {
    loading: o,
    error: s,
    data: l
  } = n(W2, {
    skip: !a,
    variables: {
      merchantId: a
    }
  });
  if (He(() => {
    if (l?.LoyaltyLion) {
      const d = l.LoyaltyLion?.getAvailableRewards?.rewards;
      d && i(d);
    }
  }, [l]), s) {
    const d = s.graphQLErrors;
    return vo({ errors: d }) ? /* @__PURE__ */ we.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: oa.notificationText,
        children: "No rewards found"
      }
    ) : Kb({ errors: d }) ? /* @__PURE__ */ we.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: oa.notificationText,
        children: "You don't have permissions to view rewards"
      }
    ) : /* @__PURE__ */ we.jsx(Fn, { error: s });
  }
  return /* @__PURE__ */ we.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ we.jsx(P.Heading, { variant: "heading-3", children: "Available rewards" }),
    o ? /* @__PURE__ */ we.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ we.jsx(un, {}) }) : /* @__PURE__ */ we.jsx(b, { gap: "200", flexDirection: "column", children: r?.map((d) => /* @__PURE__ */ we.jsx(cL, { reward: d }, d.id)) })
  ] });
}, uL = ({ customer: e }) => {
  const { blocked: n, guest: r, insights_segment: i } = e ?? {}, a = n || r || i, o = 14;
  return a ? /* @__PURE__ */ we.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
    n && /* @__PURE__ */ we.jsx(b, { alignItems: "start", children: /* @__PURE__ */ we.jsx(Pn, { children: /* @__PURE__ */ we.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ we.jsx(
        pe,
        {
          size: o,
          color: "red.500",
          name: "exclamation-triangle-filled"
        }
      ),
      "Blocked"
    ] }) }) }),
    r && /* @__PURE__ */ we.jsx(b, { alignItems: "start", children: /* @__PURE__ */ we.jsx(Pn, { children: /* @__PURE__ */ we.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ we.jsx(pe, { size: o, color: "green.500", name: "user" }),
      "Guest"
    ] }) }) }),
    i && /* @__PURE__ */ we.jsx(b, { alignItems: "start", children: /* @__PURE__ */ we.jsx(We, { content: "Insights segment", children: /* @__PURE__ */ we.jsx(Pn, { children: /* @__PURE__ */ we.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ we.jsx(pe, { size: o, color: "green.500", name: "team" }),
      i
    ] }) }) }) })
  ] }) : null;
}, mL = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = hn(), { track: i } = _n(), [a, o] = le(null), { customer: s } = e, {
    showCustomerSummary: l,
    showTags: d,
    showPointsBalance: m,
    showAvailableRewards: u
  } = n, f = !l && !d && !m && !u, {
    loading: h,
    error: g,
    data: C,
    refetch: S
  } = r(H2, {
    skip: !s?.email,
    variables: {
      email: s?.email ?? ""
    }
  });
  return He(() => {
    if (C && !h) {
      const N = (C?.LoyaltyLion?.getCustomers).customers;
      N && N.length > 0 && (o(N[0]), i("loyaltylion:customer:received"));
    }
  }, [C, h]), s?.email ? g ? vo({
    errors: g.graphQLErrors
  }) ? /* @__PURE__ */ we.jsxs(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      className: oa.notificationText,
      children: [
        "No user found for email: ",
        s?.email
      ]
    }
  ) : /* @__PURE__ */ we.jsx(Fn, { error: g }) : h ? /* @__PURE__ */ we.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ we.jsx(un, {}) }) : f ? /* @__PURE__ */ we.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-feature-enabled-message",
      children: "All features toggles in the integration settings are disabled"
    }
  ) : /* @__PURE__ */ we.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: a ? /* @__PURE__ */ we.jsxs(we.Fragment, { children: [
        l && /* @__PURE__ */ we.jsx(J2, { customer: a }),
        d && /* @__PURE__ */ we.jsx(uL, { customer: a }),
        m && /* @__PURE__ */ we.jsx(
          oL,
          {
            customer: a,
            refetchCustomerData: S
          }
        ),
        u && /* @__PURE__ */ we.jsx(dL, { customer: a })
      ] }) : /* @__PURE__ */ we.jsx(b, { justifyContent: "center", padding: "200", children: "Nothing found" })
    }
  ) : /* @__PURE__ */ we.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-email-message",
      children: "We can only search LoyaltyLion with an email and there seems to be no email in this conversation"
    }
  );
}, pL = [
  {
    key: "basicAuthorization",
    label: "LoyaltyLion authorization",
    required: !0,
    secret: !0,
    type: "basicAuthInput",
    defaultValue: "",
    additionalProperties: {
      username: {
        label: "Token"
      },
      password: {
        label: "Secret"
      }
    }
  },
  {
    key: "showCustomerSummary",
    label: "Show customer summary",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showTags",
    label: "Show tags",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showPointsBalance",
    label: "Show points balance",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showAvailableRewards",
    label: "Show available rewards",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], mk = [
  {
    key: "basicAuthorization",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "showCustomerSummary",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showTags",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showPointsBalance",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showAvailableRewards",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], pk = "LOYALTYLION", fL = {
  enabled: !1,
  name: "",
  basicAuthorization: "",
  showCustomerSummary: !0,
  showTags: !0,
  showPointsBalance: !0,
  showAvailableRewards: !0
}, hL = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = _t({
    mode: "onChange",
    defaultValues: fL
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: g
  } = ji({
    integrationId: e,
    integrationType: pk,
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: C,
    error: S,
    isWidgetUnknown: N,
    refetch: w,
    widgetConfiguration: y
  } = wi({
    integrationId: e,
    fieldDefinitions: mk,
    form: s,
    onMisconfigured: g
  }), { renderConditions: z, setRenderConditions: $, renderConditionsForSubmit: I } = Ci({
    integrationId: e,
    widgetConfiguration: y,
    renderConditionsEditor: a
  }), T = (Q) => Ii(Q, {
    fieldDefinitions: mk,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: I
  }), U = s.watch("name");
  return /* @__PURE__ */ we.jsxs(
    Fi,
    {
      form: s,
      integrationId: e,
      onValidSubmit: T,
      error: S ?? f,
      onRetry: S ? w : void 0,
      isLoading: u || C,
      isWidgetUnknown: N,
      children: [
        h && /* @__PURE__ */ we.jsx(Ei, { cause: h }),
        /* @__PURE__ */ we.jsxs(st, { children: [
          /* @__PURE__ */ we.jsx(be, { children: /* @__PURE__ */ we.jsx(ln, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ we.jsx(
            Jn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ we.jsx(be, { span: 3, children: /* @__PURE__ */ we.jsx(
            tt,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ we.jsx(be, { span: 3 }),
          /* @__PURE__ */ we.jsx(be, { span: 3, children: /* @__PURE__ */ we.jsx(
            g0,
            {
              name: "basicAuthorization",
              label: "LoyaltyLion authorization",
              control: s.control,
              isCreationMode: o,
              rules: { required: "Please insert a value for both fields" },
              usernameLabel: "Token",
              passwordLabel: "Secret",
              usernamePlaceholder: "Insert your token",
              passwordPlaceholder: "Insert your secret"
            }
          ) }),
          /* @__PURE__ */ we.jsx(be, { span: 3 }),
          /* @__PURE__ */ we.jsx(be, { span: 3, children: /* @__PURE__ */ we.jsx(ln, { label: "Show customer summary", children: /* @__PURE__ */ we.jsx(
            Jn,
            {
              name: "showCustomerSummary",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ we.jsx(be, { span: 3 }),
          /* @__PURE__ */ we.jsx(be, { span: 3, children: /* @__PURE__ */ we.jsx(ln, { label: "Show tags", children: /* @__PURE__ */ we.jsx(
            Jn,
            {
              name: "showTags",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ we.jsx(be, { span: 3 }),
          /* @__PURE__ */ we.jsx(be, { span: 3, children: /* @__PURE__ */ we.jsx(ln, { label: "Show points balance", children: /* @__PURE__ */ we.jsx(
            Jn,
            {
              name: "showPointsBalance",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ we.jsx(be, { span: 3 }),
          /* @__PURE__ */ we.jsx(be, { span: 3, children: /* @__PURE__ */ we.jsx(ln, { label: "Show available rewards", children: /* @__PURE__ */ we.jsx(
            Jn,
            {
              name: "showAvailableRewards",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ we.jsx(be, { span: 3 }),
          a && z !== null && /* @__PURE__ */ we.jsx(be, { children: a({
            value: z,
            onChange: $,
            configurationKey: y?.id
          }) })
        ] }),
        /* @__PURE__ */ we.jsx(
          Ti,
          {
            integrationType: pk,
            integrationId: e,
            widgetName: U,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._messageContainer_1rxr4_1{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid}._chip_1rxr4_7{color:var(--dixa-typography-color-secondary)}._chipLabel_1rxr4_10{font-weight:var(--dixa-typography-weight-semibold)}._chipValue_1rxr4_13{font-weight:var(--dixa-typography-weight-normal)}._conversation_1draa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._conversation_1draa_1:hover{border-color:var(--dixa-color-neutral-400)}._conversationSubLine_1draa_9{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._modal_1draa_14{width:800px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Du = { exports: {} }, Pa = {}, fk;
function yL() {
  if (fk) return Pa;
  fk = 1;
  var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return Pa.Fragment = r, Pa.jsx = s, Pa.jsxs = s, Pa;
}
var Yo = {}, hk;
function gL() {
  return hk || (hk = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        z("error", t, p);
      }
    }
    function z(t, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, A = v.getStackAddendum();
        A !== "" && (c += "%s", p = p.concat([A]));
        var L = p.map(function(F) {
          return String(F);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, I = !1, T = !1, U = !1, Q = !1, J;
    J = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === u || U || t === g || $ || I || T || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function X(t, c, p) {
      var v = t.displayName;
      if (v)
        return v;
      var A = c.displayName || c.name || "";
      return A !== "" ? p + "(" + A + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return X(t, t.render, "ForwardRef");
          case f:
            var v = t.displayName || null;
            return v !== null ? v : O(t.type) || "Memo";
          case h: {
            var A = t, L = A._payload, F = A._init;
            try {
              return O(F(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, ue, ce, fe, W, xe, Ie;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ve = console.log, ue = console.info, ce = console.warn, fe = console.error, W = console.group, xe = console.groupCollapsed, Ie = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: ue
            }),
            warn: q({}, t, {
              value: ce
            }),
            error: q({}, t, {
              value: fe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: xe
            }),
            groupEnd: q({}, t, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Me;
    function $e(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (A) {
            var v = A.stack.trim().match(/\n( *(at )?)/);
            Me = v && v[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var ze = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(t, c) {
      if (!t || ze)
        return "";
      {
        var p = Re.get(t);
        if (p !== void 0)
          return p;
      }
      var v;
      ze = !0;
      var A = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, qe();
      try {
        if (c) {
          var F = function() {
            throw Error();
          };
          if (Object.defineProperty(F.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(F, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(t, [], F);
          } else {
            try {
              F.call();
            } catch (ne) {
              v = ne;
            }
            t.call(F.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), G = j.length - 1, _ = te.length - 1; G >= 1 && _ >= 0 && j[G] !== te[_]; )
            _--;
          for (; G >= 1 && _ >= 0; G--, _--)
            if (j[G] !== te[_]) {
              if (G !== 1 || _ !== 1)
                do
                  if (G--, _--, _ < 0 || j[G] !== te[_]) {
                    var Z = `
` + j[G].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (G >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Oe.current = L, Be(), Error.prepareStackTrace = A;
      }
      var de = t ? t.displayName || t.name : "", Se = de ? $e(de) : "";
      return typeof t == "function" && Re.set(t, Se), Se;
    }
    function Ge(t, c, p) {
      return Ee(t, !1);
    }
    function Qe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function he(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Qe(t));
      if (typeof t == "string")
        return $e(t);
      switch (t) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ge(t.render);
          case f:
            return he(t.type, c, p);
          case h: {
            var v = t, A = v._payload, L = v._init;
            try {
              return he(L(A), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, De = {}, Le = w.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = he(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(t, c, p, v, A) {
      {
        var L = Function.call.bind(ge);
        for (var F in t)
          if (L(t, F)) {
            var j = void 0;
            try {
              if (typeof t[F] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + F + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[F] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[F](c, F, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (G) {
              j = G;
            }
            j && !(j instanceof Error) && (Ae(A), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, F, typeof j), Ae(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Ae(A), y("Failed %s type: %s", p, j.message), Ae(null));
          }
      }
    }
    var E = Array.isArray;
    function x(t) {
      return E(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var V = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, me, Ne;
    function nn(t) {
      if (ge.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function fn(t) {
      if (ge.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && V.current;
    }
    function cn(t, c) {
      {
        var p = function() {
          me || (me = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(t, c, p, v, A, L, F) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: F,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: A
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, v, A) {
      {
        var L, F = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), fn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ge.call(c, L) && !ie.hasOwnProperty(L) && (F[L] = c[L]);
        if (t && t.defaultProps) {
          var G = t.defaultProps;
          for (L in G)
            F[L] === void 0 && (F[L] = G[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && cn(F, _), te && pn(F, _);
        }
        return dn(t, j, te, A, v, V.current, F);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = he(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var t = O(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        t && t._owner && t._owner !== en.current && (v = " It was passed a child from " + O(t._owner.type) + "."), Pe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Pe(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var v = t[p];
            sn(v) && gn(v, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var A = N(t);
          if (typeof A == "function" && A !== t.entries)
            for (var L = A.call(t), F; !(F = L.next()).done; )
              sn(F.value) && gn(F.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          mn(p, t.props, "prop", v, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var A = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", A || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Pe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Pe(null);
            break;
          }
        }
        t.ref !== null && (Pe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Pe(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, v, A, L) {
      {
        var F = ae(t);
        if (!F) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var G;
          t === null ? G = "null" : x(t) ? G = "array" : t !== void 0 && t.$$typeof === n ? (G = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : G = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", G, j);
        }
        var _ = xn(t, c, p, A, L);
        if (_ == null)
          return _;
        if (F) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var de = 0; de < Z.length; de++)
                  Cn(Z[de], t);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, t);
        }
        if (ge.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, Se, $n, Se), Sn[Se + Ke] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Yo.Fragment = i, Yo.jsx = Rn, Yo.jsxs = Mn;
  })()), Yo;
}
var yk;
function vL() {
  return yk || (yk = 1, process.env.NODE_ENV === "production" ? Du.exports = yL() : Du.exports = gL()), Du.exports;
}
var rn = vL();
const kL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "conversationsQuery" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Miuros" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findTickets" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "page_size" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "labels" } }, { kind: "Field", name: { kind: "Name", value: "subject" } }, { kind: "Field", name: { kind: "Name", value: "messages" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "direction" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "agent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }] } }] } }] } }] }, bL = {
  "\n  query conversationsQuery($query: String) {\n    Miuros {\n      findTickets(query: $query, page_size: 10) {\n        data {\n          id\n          labels\n          subject\n          messages {\n            direction\n            body\n            agent {\n              email\n              name\n            }\n            created_at\n          }\n          custom_fields {\n            additionalProperties {\n              key\n              value {\n                value\n              }\n            }\n          }\n          created_at\n        }\n      }\n    }\n  }\n": kL
};
function xL(e) {
  return bL[e] ?? {};
}
const {
  entries: mS,
  setPrototypeOf: gk,
  isFrozen: _L,
  getPrototypeOf: SL,
  getOwnPropertyDescriptor: NL
} = Object;
let {
  freeze: Gt,
  seal: fr,
  create: Ki
} = Object, {
  apply: Im,
  construct: Em
} = typeof Reflect < "u" && Reflect;
Gt || (Gt = function(e) {
  return e;
});
fr || (fr = function(e) {
  return e;
});
Im || (Im = function(e, n) {
  for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++)
    i[a - 2] = arguments[a];
  return e.apply(n, i);
});
Em || (Em = function(e) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    r[i - 1] = arguments[i];
  return new e(...r);
});
const La = gt(Array.prototype.forEach), jL = gt(Array.prototype.lastIndexOf), vk = gt(Array.prototype.pop), Va = gt(Array.prototype.push), wL = gt(Array.prototype.splice), Vt = Array.isArray, eo = gt(String.prototype.toLowerCase), Ru = gt(String.prototype.toString), kk = gt(String.prototype.match), Bi = gt(String.prototype.replace), bk = gt(String.prototype.indexOf), CL = gt(String.prototype.trim), FL = gt(Number.prototype.toString), IL = gt(Boolean.prototype.toString), xk = typeof BigInt > "u" ? null : gt(BigInt.prototype.toString), _k = typeof Symbol > "u" ? null : gt(Symbol.prototype.toString), at = gt(Object.prototype.hasOwnProperty), za = gt(Object.prototype.toString), jt = gt(RegExp.prototype.test), Qo = EL(TypeError);
function gt(e) {
  return function(n) {
    n instanceof RegExp && (n.lastIndex = 0);
    for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
      i[a - 1] = arguments[a];
    return Im(e, n, i);
  };
}
function EL(e) {
  return function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return Em(e, r);
  };
}
function En(e, n) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : eo;
  if (gk && gk(e, null), !Vt(n))
    return e;
  let i = n.length;
  for (; i--; ) {
    let a = n[i];
    if (typeof a == "string") {
      const o = r(a);
      o !== a && (_L(n) || (n[i] = o), a = o);
    }
    e[a] = !0;
  }
  return e;
}
function TL(e) {
  for (let n = 0; n < e.length; n++)
    at(e, n) || (e[n] = null);
  return e;
}
function Qt(e) {
  const n = Ki(null);
  for (const [r, i] of mS(e))
    at(e, r) && (Vt(i) ? n[r] = TL(i) : i && typeof i == "object" && i.constructor === Object ? n[r] = Qt(i) : n[r] = i);
  return n;
}
function $L(e) {
  switch (typeof e) {
    case "string":
      return e;
    case "number":
      return FL(e);
    case "boolean":
      return IL(e);
    case "bigint":
      return xk ? xk(e) : "0";
    case "symbol":
      return _k ? _k(e) : "Symbol()";
    case "undefined":
      return za(e);
    case "function":
    case "object": {
      if (e === null)
        return za(e);
      const n = e, r = Yi(n, "toString");
      if (typeof r == "function") {
        const i = r(n);
        return typeof i == "string" ? i : za(i);
      }
      return za(e);
    }
    default:
      return za(e);
  }
}
function Yi(e, n) {
  for (; e !== null; ) {
    const i = NL(e, n);
    if (i) {
      if (i.get)
        return gt(i.get);
      if (typeof i.value == "function")
        return gt(i.value);
    }
    e = SL(e);
  }
  function r() {
    return null;
  }
  return r;
}
function DL(e) {
  try {
    return jt(e, ""), !0;
  } catch {
    return !1;
  }
}
const Sk = Gt(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Ou = Gt(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Au = Gt(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), RL = Gt(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Pu = Gt(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), OL = Gt(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), Nk = Gt(["#text"]), jk = Gt(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns"]), Lu = Gt(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), wk = Gt(["accent", "accentunder", "align", "bevelled", "close", "columnalign", "columnlines", "columnspacing", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lquote", "lspace", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), Jo = Gt(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), AL = fr(/\{\{[\w\W]*|[\w\W]*\}\}/gm), PL = fr(/<%[\w\W]*|[\w\W]*%>/gm), LL = fr(/\$\{[\w\W]*/gm), VL = fr(/^data-[\-\w.\u00B7-\uFFFF]+$/), zL = fr(/^aria-[\-\w]+$/), pS = fr(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), UL = fr(/^(?:\w+script|data):/i), ML = fr(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), fS = fr(/^html$/i), BL = fr(/^[a-z][.\w]*(-[.\w]+)+$/i);
var Ck = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: zL,
  ATTR_WHITESPACE: ML,
  CUSTOM_ELEMENT: BL,
  DATA_ATTR: VL,
  DOCTYPE_NAME: fS,
  ERB_EXPR: PL,
  IS_ALLOWED_URI: pS,
  IS_SCRIPT_OR_DATA: UL,
  MUSTACHE_EXPR: AL,
  TMPLIT_EXPR: LL
});
const Ua = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, qL = function() {
  return typeof window > "u" ? null : window;
}, HL = function(e, n) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let r = null;
  const i = "data-tt-policy-suffix";
  n && n.hasAttribute(i) && (r = n.getAttribute(i));
  const a = "dompurify" + (r ? "#" + r : "");
  try {
    return e.createPolicy(a, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + a + " could not be created."), null;
  }
}, Fk = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function hS() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : qL();
  const n = (_) => hS(_);
  if (n.version = "3.4.2", n.removed = [], !e || !e.document || e.document.nodeType !== Ua.document || !e.Element)
    return n.isSupported = !1, n;
  let {
    document: r
  } = e;
  const i = r, a = i.currentScript, {
    DocumentFragment: o,
    HTMLTemplateElement: s,
    Node: l,
    Element: d,
    NodeFilter: m,
    NamedNodeMap: u = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: f,
    DOMParser: h,
    trustedTypes: g
  } = e, C = d.prototype, S = Yi(C, "cloneNode"), N = Yi(C, "remove"), w = Yi(C, "nextSibling"), y = Yi(C, "childNodes"), z = Yi(C, "parentNode");
  if (typeof s == "function") {
    const _ = r.createElement("template");
    _.content && _.content.ownerDocument && (r = _.content.ownerDocument);
  }
  let $, I = "";
  const {
    implementation: T,
    createNodeIterator: U,
    createDocumentFragment: Q,
    getElementsByTagName: J
  } = r, {
    importNode: ae
  } = i;
  let X = Fk();
  n.isSupported = typeof mS == "function" && typeof z == "function" && T && T.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: B,
    ERB_EXPR: O,
    TMPLIT_EXPR: q,
    DATA_ATTR: ee,
    ARIA_ATTR: ve,
    IS_SCRIPT_OR_DATA: ue,
    ATTR_WHITESPACE: ce,
    CUSTOM_ELEMENT: fe
  } = Ck;
  let {
    IS_ALLOWED_URI: W
  } = Ck, xe = null;
  const Ie = En({}, [...Sk, ...Ou, ...Au, ...Pu, ...Nk]);
  let K = null;
  const qe = En({}, [...jk, ...Lu, ...wk, ...Jo]);
  let Be = Object.seal(Ki(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), Oe = null, Me = null;
  const $e = Object.seal(Ki(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let ze = !0, Re = !0, an = !1, Ee = !0, Ge = !1, Qe = !0, he = !1, ge = !1, De = !1, Le = !1, Ae = !1, mn = !1, E = !0, x = !1;
  const D = "user-content-";
  let H = !0, Y = !1, R = {}, V = null;
  const ie = En({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let me = null;
  const Ne = En({}, ["audio", "video", "img", "source", "image", "track"]);
  let nn = null;
  const fn = En({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), tn = "http://www.w3.org/1998/Math/MathML", cn = "http://www.w3.org/2000/svg", pn = "http://www.w3.org/1999/xhtml";
  let dn = pn, xn = !1, en = null;
  const jn = En({}, [tn, cn, pn], Ru);
  let Pe = En({}, ["mi", "mo", "mn", "ms", "mtext"]), on = En({}, ["annotation-xml"]);
  const sn = En({}, ["title", "style", "font", "a", "script"]);
  let vn = null;
  const qn = ["application/xhtml+xml", "text/html"], wn = "text/html";
  let kn = null, gn = null;
  const Cn = r.createElement("form"), Un = function(_) {
    return _ instanceof RegExp || _ instanceof Function;
  }, Vn = function() {
    let _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (gn && gn === _)
      return;
    (!_ || typeof _ != "object") && (_ = {}), _ = Qt(_), vn = // eslint-disable-next-line unicorn/prefer-includes
    qn.indexOf(_.PARSER_MEDIA_TYPE) === -1 ? wn : _.PARSER_MEDIA_TYPE, kn = vn === "application/xhtml+xml" ? Ru : eo, xe = at(_, "ALLOWED_TAGS") && Vt(_.ALLOWED_TAGS) ? En({}, _.ALLOWED_TAGS, kn) : Ie, K = at(_, "ALLOWED_ATTR") && Vt(_.ALLOWED_ATTR) ? En({}, _.ALLOWED_ATTR, kn) : qe, en = at(_, "ALLOWED_NAMESPACES") && Vt(_.ALLOWED_NAMESPACES) ? En({}, _.ALLOWED_NAMESPACES, Ru) : jn, nn = at(_, "ADD_URI_SAFE_ATTR") && Vt(_.ADD_URI_SAFE_ATTR) ? En(Qt(fn), _.ADD_URI_SAFE_ATTR, kn) : fn, me = at(_, "ADD_DATA_URI_TAGS") && Vt(_.ADD_DATA_URI_TAGS) ? En(Qt(Ne), _.ADD_DATA_URI_TAGS, kn) : Ne, V = at(_, "FORBID_CONTENTS") && Vt(_.FORBID_CONTENTS) ? En({}, _.FORBID_CONTENTS, kn) : ie, Oe = at(_, "FORBID_TAGS") && Vt(_.FORBID_TAGS) ? En({}, _.FORBID_TAGS, kn) : Qt({}), Me = at(_, "FORBID_ATTR") && Vt(_.FORBID_ATTR) ? En({}, _.FORBID_ATTR, kn) : Qt({}), R = at(_, "USE_PROFILES") ? _.USE_PROFILES && typeof _.USE_PROFILES == "object" ? Qt(_.USE_PROFILES) : _.USE_PROFILES : !1, ze = _.ALLOW_ARIA_ATTR !== !1, Re = _.ALLOW_DATA_ATTR !== !1, an = _.ALLOW_UNKNOWN_PROTOCOLS || !1, Ee = _.ALLOW_SELF_CLOSE_IN_ATTR !== !1, Ge = _.SAFE_FOR_TEMPLATES || !1, Qe = _.SAFE_FOR_XML !== !1, he = _.WHOLE_DOCUMENT || !1, Le = _.RETURN_DOM || !1, Ae = _.RETURN_DOM_FRAGMENT || !1, mn = _.RETURN_TRUSTED_TYPE || !1, De = _.FORCE_BODY || !1, E = _.SANITIZE_DOM !== !1, x = _.SANITIZE_NAMED_PROPS || !1, H = _.KEEP_CONTENT !== !1, Y = _.IN_PLACE || !1, W = DL(_.ALLOWED_URI_REGEXP) ? _.ALLOWED_URI_REGEXP : pS, dn = typeof _.NAMESPACE == "string" ? _.NAMESPACE : pn, Pe = at(_, "MATHML_TEXT_INTEGRATION_POINTS") && _.MATHML_TEXT_INTEGRATION_POINTS && typeof _.MATHML_TEXT_INTEGRATION_POINTS == "object" ? Qt(_.MATHML_TEXT_INTEGRATION_POINTS) : En({}, ["mi", "mo", "mn", "ms", "mtext"]), on = at(_, "HTML_INTEGRATION_POINTS") && _.HTML_INTEGRATION_POINTS && typeof _.HTML_INTEGRATION_POINTS == "object" ? Qt(_.HTML_INTEGRATION_POINTS) : En({}, ["annotation-xml"]);
    const Z = at(_, "CUSTOM_ELEMENT_HANDLING") && _.CUSTOM_ELEMENT_HANDLING && typeof _.CUSTOM_ELEMENT_HANDLING == "object" ? Qt(_.CUSTOM_ELEMENT_HANDLING) : Ki(null);
    if (Be = Ki(null), at(Z, "tagNameCheck") && Un(Z.tagNameCheck) && (Be.tagNameCheck = Z.tagNameCheck), at(Z, "attributeNameCheck") && Un(Z.attributeNameCheck) && (Be.attributeNameCheck = Z.attributeNameCheck), at(Z, "allowCustomizedBuiltInElements") && typeof Z.allowCustomizedBuiltInElements == "boolean" && (Be.allowCustomizedBuiltInElements = Z.allowCustomizedBuiltInElements), Ge && (Re = !1), Ae && (Le = !0), R && (xe = En({}, Nk), K = Ki(null), R.html === !0 && (En(xe, Sk), En(K, jk)), R.svg === !0 && (En(xe, Ou), En(K, Lu), En(K, Jo)), R.svgFilters === !0 && (En(xe, Au), En(K, Lu), En(K, Jo)), R.mathMl === !0 && (En(xe, Pu), En(K, wk), En(K, Jo))), $e.tagCheck = null, $e.attributeCheck = null, at(_, "ADD_TAGS") && (typeof _.ADD_TAGS == "function" ? $e.tagCheck = _.ADD_TAGS : Vt(_.ADD_TAGS) && (xe === Ie && (xe = Qt(xe)), En(xe, _.ADD_TAGS, kn))), at(_, "ADD_ATTR") && (typeof _.ADD_ATTR == "function" ? $e.attributeCheck = _.ADD_ATTR : Vt(_.ADD_ATTR) && (K === qe && (K = Qt(K)), En(K, _.ADD_ATTR, kn))), at(_, "ADD_URI_SAFE_ATTR") && Vt(_.ADD_URI_SAFE_ATTR) && En(nn, _.ADD_URI_SAFE_ATTR, kn), at(_, "FORBID_CONTENTS") && Vt(_.FORBID_CONTENTS) && (V === ie && (V = Qt(V)), En(V, _.FORBID_CONTENTS, kn)), at(_, "ADD_FORBID_CONTENTS") && Vt(_.ADD_FORBID_CONTENTS) && (V === ie && (V = Qt(V)), En(V, _.ADD_FORBID_CONTENTS, kn)), H && (xe["#text"] = !0), he && En(xe, ["html", "head", "body"]), xe.table && (En(xe, ["tbody"]), delete Oe.tbody), _.TRUSTED_TYPES_POLICY) {
      if (typeof _.TRUSTED_TYPES_POLICY.createHTML != "function")
        throw Qo('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      if (typeof _.TRUSTED_TYPES_POLICY.createScriptURL != "function")
        throw Qo('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      $ = _.TRUSTED_TYPES_POLICY, I = $.createHTML("");
    } else
      $ === void 0 && ($ = HL(g, a)), $ !== null && typeof I == "string" && (I = $.createHTML(""));
    Gt && Gt(_), gn = _;
  }, Sn = En({}, [...Ou, ...Au, ...RL]), Nn = En({}, [...Pu, ...OL]), Hn = function(_) {
    let Z = z(_);
    (!Z || !Z.tagName) && (Z = {
      namespaceURI: dn,
      tagName: "template"
    });
    const de = eo(_.tagName), Se = eo(Z.tagName);
    return en[_.namespaceURI] ? _.namespaceURI === cn ? Z.namespaceURI === pn ? de === "svg" : Z.namespaceURI === tn ? de === "svg" && (Se === "annotation-xml" || Pe[Se]) : !!Sn[de] : _.namespaceURI === tn ? Z.namespaceURI === pn ? de === "math" : Z.namespaceURI === cn ? de === "math" && on[Se] : !!Nn[de] : _.namespaceURI === pn ? Z.namespaceURI === cn && !on[Se] || Z.namespaceURI === tn && !Pe[Se] ? !1 : !Nn[de] && (sn[de] || !Sn[de]) : !!(vn === "application/xhtml+xml" && en[_.namespaceURI]) : !1;
  }, Dn = function(_) {
    Va(n.removed, {
      element: _
    });
    try {
      z(_).removeChild(_);
    } catch {
      N(_);
    }
  }, Rn = function(_, Z) {
    try {
      Va(n.removed, {
        attribute: Z.getAttributeNode(_),
        from: Z
      });
    } catch {
      Va(n.removed, {
        attribute: null,
        from: Z
      });
    }
    if (Z.removeAttribute(_), _ === "is")
      if (Le || Ae)
        try {
          Dn(Z);
        } catch {
        }
      else
        try {
          Z.setAttribute(_, "");
        } catch {
        }
  }, Mn = function(_) {
    let Z = null, de = null;
    if (De)
      _ = "<remove></remove>" + _;
    else {
      const Ke = kk(_, /^[\r\n\t ]+/);
      de = Ke && Ke[0];
    }
    vn === "application/xhtml+xml" && dn === pn && (_ = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + _ + "</body></html>");
    const Se = $ ? $.createHTML(_) : _;
    if (dn === pn)
      try {
        Z = new h().parseFromString(Se, vn);
      } catch {
      }
    if (!Z || !Z.documentElement) {
      Z = T.createDocument(dn, "template", null);
      try {
        Z.documentElement.innerHTML = xn ? I : Se;
      } catch {
      }
    }
    const ne = Z.body || Z.documentElement;
    return _ && de && ne.insertBefore(r.createTextNode(de), ne.childNodes[0] || null), dn === pn ? J.call(Z, he ? "html" : "body")[0] : he ? Z.documentElement : ne;
  }, t = function(_) {
    return U.call(
      _.ownerDocument || _,
      _,
      // eslint-disable-next-line no-bitwise
      m.SHOW_ELEMENT | m.SHOW_COMMENT | m.SHOW_TEXT | m.SHOW_PROCESSING_INSTRUCTION | m.SHOW_CDATA_SECTION,
      null
    );
  }, c = function(_) {
    return _ instanceof f && (typeof _.nodeName != "string" || typeof _.textContent != "string" || typeof _.removeChild != "function" || !(_.attributes instanceof u) || typeof _.removeAttribute != "function" || typeof _.setAttribute != "function" || typeof _.namespaceURI != "string" || typeof _.insertBefore != "function" || typeof _.hasChildNodes != "function");
  }, p = function(_) {
    return typeof l == "function" && _ instanceof l;
  };
  function v(_, Z, de) {
    La(_, (Se) => {
      Se.call(n, Z, de, gn);
    });
  }
  const A = function(_) {
    let Z = null;
    if (v(X.beforeSanitizeElements, _, null), c(_))
      return Dn(_), !0;
    const de = kn(_.nodeName);
    if (v(X.uponSanitizeElement, _, {
      tagName: de,
      allowedTags: xe
    }), Qe && _.hasChildNodes() && !p(_.firstElementChild) && jt(/<[/\w!]/g, _.innerHTML) && jt(/<[/\w!]/g, _.textContent) || Qe && _.namespaceURI === pn && de === "style" && p(_.firstElementChild) || _.nodeType === Ua.progressingInstruction || Qe && _.nodeType === Ua.comment && jt(/<[/\w]/g, _.data))
      return Dn(_), !0;
    if (Oe[de] || !($e.tagCheck instanceof Function && $e.tagCheck(de)) && !xe[de]) {
      if (!Oe[de] && j(de) && (Be.tagNameCheck instanceof RegExp && jt(Be.tagNameCheck, de) || Be.tagNameCheck instanceof Function && Be.tagNameCheck(de)))
        return !1;
      if (H && !V[de]) {
        const Se = z(_) || _.parentNode, ne = y(_) || _.childNodes;
        if (ne && Se) {
          const Ke = ne.length;
          for (let $n = Ke - 1; $n >= 0; --$n) {
            const Tn = S(ne[$n], !0);
            Se.insertBefore(Tn, w(_));
          }
        }
      }
      return Dn(_), !0;
    }
    return _ instanceof d && !Hn(_) || (de === "noscript" || de === "noembed" || de === "noframes") && jt(/<\/no(script|embed|frames)/i, _.innerHTML) ? (Dn(_), !0) : (Ge && _.nodeType === Ua.text && (Z = _.textContent, La([B, O, q], (Se) => {
      Z = Bi(Z, Se, " ");
    }), _.textContent !== Z && (Va(n.removed, {
      element: _.cloneNode()
    }), _.textContent = Z)), v(X.afterSanitizeElements, _, null), !1);
  }, L = function(_, Z, de) {
    if (Me[Z] || E && (Z === "id" || Z === "name") && (de in r || de in Cn))
      return !1;
    const Se = K[Z] || $e.attributeCheck instanceof Function && $e.attributeCheck(Z, _);
    if (!(Re && !Me[Z] && jt(ee, Z)) && !(ze && jt(ve, Z))) {
      if (!Se || Me[Z]) {
        if (
          // First condition does a very basic check if a) it's basically a valid custom element tagname AND
          // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
          !(j(_) && (Be.tagNameCheck instanceof RegExp && jt(Be.tagNameCheck, _) || Be.tagNameCheck instanceof Function && Be.tagNameCheck(_)) && (Be.attributeNameCheck instanceof RegExp && jt(Be.attributeNameCheck, Z) || Be.attributeNameCheck instanceof Function && Be.attributeNameCheck(Z, _)) || // Alternative, second condition checks if it's an `is`-attribute, AND
          // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          Z === "is" && Be.allowCustomizedBuiltInElements && (Be.tagNameCheck instanceof RegExp && jt(Be.tagNameCheck, de) || Be.tagNameCheck instanceof Function && Be.tagNameCheck(de)))
        ) return !1;
      } else if (!nn[Z] && !jt(W, Bi(de, ce, "")) && !((Z === "src" || Z === "xlink:href" || Z === "href") && _ !== "script" && bk(de, "data:") === 0 && me[_]) && !(an && !jt(ue, Bi(de, ce, ""))) && de)
        return !1;
    }
    return !0;
  }, F = En({}, ["annotation-xml", "color-profile", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "missing-glyph"]), j = function(_) {
    return !F[eo(_)] && jt(fe, _);
  }, te = function(_) {
    v(X.beforeSanitizeAttributes, _, null);
    const {
      attributes: Z
    } = _;
    if (!Z || c(_))
      return;
    const de = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: K,
      forceKeepAttr: void 0
    };
    let Se = Z.length;
    for (; Se--; ) {
      const ne = Z[Se], {
        name: Ke,
        namespaceURI: $n,
        value: Tn
      } = ne, Lt = kn(Ke), Xr = Tn;
      let St = Ke === "value" ? Xr : CL(Xr);
      if (de.attrName = Lt, de.attrValue = St, de.keepAttr = !0, de.forceKeepAttr = void 0, v(X.uponSanitizeAttribute, _, de), St = de.attrValue, x && (Lt === "id" || Lt === "name") && bk(St, D) !== 0 && (Rn(Ke, _), St = D + St), Qe && jt(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, St)) {
        Rn(Ke, _);
        continue;
      }
      if (Lt === "attributename" && kk(St, "href")) {
        Rn(Ke, _);
        continue;
      }
      if (de.forceKeepAttr)
        continue;
      if (!de.keepAttr) {
        Rn(Ke, _);
        continue;
      }
      if (!Ee && jt(/\/>/i, St)) {
        Rn(Ke, _);
        continue;
      }
      Ge && La([B, O, q], (i0) => {
        St = Bi(St, i0, " ");
      });
      const lf = kn(_.nodeName);
      if (!L(lf, Lt, St)) {
        Rn(Ke, _);
        continue;
      }
      if ($ && typeof g == "object" && typeof g.getAttributeType == "function" && !$n)
        switch (g.getAttributeType(lf, Lt)) {
          case "TrustedHTML": {
            St = $.createHTML(St);
            break;
          }
          case "TrustedScriptURL": {
            St = $.createScriptURL(St);
            break;
          }
        }
      if (St !== Xr)
        try {
          $n ? _.setAttributeNS($n, Ke, St) : _.setAttribute(Ke, St), c(_) ? Dn(_) : vk(n.removed);
        } catch {
          Rn(Ke, _);
        }
    }
    v(X.afterSanitizeAttributes, _, null);
  }, G = function(_) {
    let Z = null;
    const de = t(_);
    for (v(X.beforeSanitizeShadowDOM, _, null); Z = de.nextNode(); )
      v(X.uponSanitizeShadowNode, Z, null), A(Z), te(Z), Z.content instanceof o && G(Z.content);
    v(X.afterSanitizeShadowDOM, _, null);
  };
  return n.sanitize = function(_) {
    let Z = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, de = null, Se = null, ne = null, Ke = null;
    if (xn = !_, xn && (_ = "<!-->"), typeof _ != "string" && !p(_) && (_ = $L(_), typeof _ != "string"))
      throw Qo("dirty is not a string, aborting");
    if (!n.isSupported)
      return _;
    if (ge || Vn(Z), n.removed = [], typeof _ == "string" && (Y = !1), Y) {
      const Lt = _.nodeName;
      if (typeof Lt == "string") {
        const Xr = kn(Lt);
        if (!xe[Xr] || Oe[Xr])
          throw Qo("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (_ instanceof l)
      de = Mn("<!---->"), Se = de.ownerDocument.importNode(_, !0), Se.nodeType === Ua.element && Se.nodeName === "BODY" || Se.nodeName === "HTML" ? de = Se : de.appendChild(Se);
    else {
      if (!Le && !Ge && !he && // eslint-disable-next-line unicorn/prefer-includes
      _.indexOf("<") === -1)
        return $ && mn ? $.createHTML(_) : _;
      if (de = Mn(_), !de)
        return Le ? null : mn ? I : "";
    }
    de && De && Dn(de.firstChild);
    const $n = t(Y ? _ : de);
    for (; ne = $n.nextNode(); )
      A(ne), te(ne), ne.content instanceof o && G(ne.content);
    if (Y)
      return _;
    if (Le) {
      if (Ge) {
        de.normalize();
        let Lt = de.innerHTML;
        La([B, O, q], (Xr) => {
          Lt = Bi(Lt, Xr, " ");
        }), de.innerHTML = Lt;
      }
      if (Ae)
        for (Ke = Q.call(de.ownerDocument); de.firstChild; )
          Ke.appendChild(de.firstChild);
      else
        Ke = de;
      return (K.shadowroot || K.shadowrootmode) && (Ke = ae.call(i, Ke, !0)), Ke;
    }
    let Tn = he ? de.outerHTML : de.innerHTML;
    return he && xe["!doctype"] && de.ownerDocument && de.ownerDocument.doctype && de.ownerDocument.doctype.name && jt(fS, de.ownerDocument.doctype.name) && (Tn = "<!DOCTYPE " + de.ownerDocument.doctype.name + `>
` + Tn), Ge && La([B, O, q], (Lt) => {
      Tn = Bi(Tn, Lt, " ");
    }), $ && mn ? $.createHTML(Tn) : Tn;
  }, n.setConfig = function() {
    let _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Vn(_), ge = !0;
  }, n.clearConfig = function() {
    gn = null, ge = !1;
  }, n.isValidAttribute = function(_, Z, de) {
    gn || Vn({});
    const Se = kn(_), ne = kn(Z);
    return L(Se, ne, de);
  }, n.addHook = function(_, Z) {
    typeof Z == "function" && Va(X[_], Z);
  }, n.removeHook = function(_, Z) {
    if (Z !== void 0) {
      const de = jL(X[_], Z);
      return de === -1 ? void 0 : wL(X[_], de, 1)[0];
    }
    return vk(X[_]);
  }, n.removeHooks = function(_) {
    X[_] = [];
  }, n.removeAllHooks = function() {
    X = Fk();
  }, n;
}
var WL = hS();
const GL = "_messageContainer_1rxr4_1", KL = "_chip_1rxr4_7", YL = "_chipLabel_1rxr4_10", QL = "_chipValue_1rxr4_13", Xo = {
  messageContainer: GL,
  chip: KL,
  chipLabel: YL,
  chipValue: QL
}, Ik = {
  INBOUND: {
    background: "var(--dixa-color-neutral-000)",
    borderColor: "var(--dixa-color-neutral-100)"
  },
  OUTBOUND: {
    background: "var(--dixa-color-neutral-100)",
    borderColor: "var(--dixa-color-neutral-200)"
  },
  INTERNAL: {
    background: "var(--dixa-color-orange-100)",
    borderColor: "var(--dixa-color-orange-200)"
  }
}, JL = ({
  messages: e,
  customFields: n,
  attachments: r,
  conversationContext: i
}) => {
  He(() => {
    document.getElementById("endOfConversationAnchor") && document.getElementById("endOfConversationAnchor")?.scrollIntoView({ behavior: "smooth" });
  }, [e]);
  const a = () => {
    const o = "Contact";
    if (!i?.customer)
      return o;
    const {
      name: s,
      given_name: l,
      family_name: d,
      email: m,
      phone_number: u
    } = i.customer;
    return s ?? l ?? d ?? m ?? u ?? o;
  };
  return /* @__PURE__ */ rn.jsxs(b, { flexDirection: "column", gap: "200", children: [
    /* @__PURE__ */ rn.jsx(b, { flexDirection: "row", flexWrap: "wrap", margin: "0 0 300", children: !!n?.length && /* @__PURE__ */ rn.jsxs(b, { gap: "100", children: [
      /* @__PURE__ */ rn.jsx(We, { content: "Conversation Attributes", children: /* @__PURE__ */ rn.jsx(
        Hm,
        {
          icon: "input",
          color: {
            contentColor: "var(--dixa-color-neutral-700)",
            backgroundColor: "var(--dixa-color-neutral-200)"
          }
        }
      ) }),
      n.map((o, s) => /* @__PURE__ */ rn.jsx(b, { alignItems: "center", children: /* @__PURE__ */ rn.jsx(Pn, { className: Xo.chip, children: /* @__PURE__ */ rn.jsxs(b, { gap: "100", children: [
        /* @__PURE__ */ rn.jsxs(et, { className: Xo.chipLabel, children: [
          o.name,
          ":"
        ] }),
        /* @__PURE__ */ rn.jsx(et, { className: Xo.chipValue, children: o.value })
      ] }) }) }, `${s}-${o.name}`))
    ] }) }),
    e?.map((o) => /* @__PURE__ */ rn.jsx(
      b,
      {
        className: Xo.messageContainer,
        gap: "200",
        style: {
          backgroundColor: o?.direction ? Ik[o.direction].background : "var(--dixa-color-neutral-000)",
          borderColor: o?.direction ? Ik[o.direction].borderColor : "var(--dixa-color-neutral-100)"
        },
        children: /* @__PURE__ */ rn.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
          /* @__PURE__ */ rn.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
            /* @__PURE__ */ rn.jsx(P.Heading, { variant: "heading-3", children: o?.direction == "INBOUND" ? a() : o?.agent?.name }),
            /* @__PURE__ */ rn.jsx(P.Paragraph, { variant: "4", children: /* @__PURE__ */ rn.jsx(D0, { relative: !0, time: o?.created_at }) })
          ] }),
          /* @__PURE__ */ rn.jsx(
            "div",
            {
              dangerouslySetInnerHTML: {
                __html: WL.sanitize(
                  o?.body?.replaceAll(/\r\n?|\n/g, "<br />") || ""
                )
              }
            }
          )
        ] })
      },
      o?.created_at
    )),
    r && /* @__PURE__ */ rn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", margin: "300 0 0", children: r.map((o, s) => /* @__PURE__ */ rn.jsx(
      R0,
      {
        fileName: o.url,
        label: o.label,
        onDownload: () => {
          window.open(o.url, "_blank")?.focus();
        }
      },
      `${s}-${o.url}`
    )) }),
    /* @__PURE__ */ rn.jsx("div", { id: "endOfConversationAnchor", children: " " })
  ] });
}, XL = "_conversation_1draa_1", ZL = "_conversationSubLine_1draa_9", eV = "_modal_1draa_14", Vu = {
  conversation: XL,
  conversationSubLine: ZL,
  modal: eV
}, nV = (e) => (e && JSON.parse(e) || []).map((n) => ({
  url: n.URL__c,
  label: n.Name,
  type: n.File_Type__c
})), tV = (e) => Object.entries(e || {}).filter(([n]) => n.endsWith("__c")).map(([n, r]) => ({
  name: n.replace("__c", "").replaceAll("_", " "),
  // transform key into readable name
  value: r?.value ? r.value.toString() : ""
})), rV = ({
  conversation: e,
  conversationContext: n
}) => {
  const [r, i] = le(!1), a = e?.created_at, o = e?.custom_fields, s = o && "attachments" in o;
  return /* @__PURE__ */ rn.jsxs(b, { className: Vu.conversation, gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ rn.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ rn.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ rn.jsxs(b, { flexDirection: "row", gap: "100", children: [
          /* @__PURE__ */ rn.jsx(P.Heading, { variant: "heading-4", children: e?.id }),
          a && /* @__PURE__ */ rn.jsx(An, { size: "small", variant: "info", children: Ln(e?.created_at).format("DD MMM YYYY @ HH:mm") })
        ] }),
        /* @__PURE__ */ rn.jsx(
          P.Heading,
          {
            variant: "heading-4",
            className: Vu.conversationSubLine,
            children: e?.subject
          }
        ),
        !!e?.labels?.length && /* @__PURE__ */ rn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [...new Set(e.labels)].map((l) => /* @__PURE__ */ rn.jsx(Pn, { children: l }, `${e.id}-${l}`)) })
      ] }),
      /* @__PURE__ */ rn.jsx(We, { content: "Show conversation preview", children: /* @__PURE__ */ rn.jsx(
        nr,
        {
          variant: "secondary",
          icon: "eye",
          onClick: () => i(!0),
          "data-testid": "open-messages-preview"
        }
      ) })
    ] }),
    /* @__PURE__ */ rn.jsxs(
      Tt,
      {
        isOpen: r,
        allowEscClose: !0,
        onClose: () => i(!1),
        className: Vu.modal,
        children: [
          /* @__PURE__ */ rn.jsx(
            $t,
            {
              title: "Conversation preview",
              onClose: () => i(!1)
            }
          ),
          /* @__PURE__ */ rn.jsx(Dt, { children: /* @__PURE__ */ rn.jsx(
            JL,
            {
              messages: e?.messages || [],
              ...s && {
                attachments: nV(
                  o?.attachments?.value
                )
              },
              conversationContext: n,
              customFields: tV(
                e?.custom_fields
              )
            }
          ) })
        ]
      }
    )
  ] });
}, iV = ({
  conversations: e,
  conversationContext: n,
  conversationsToShow: r
}) => {
  const [i, a] = le(!1), o = r > 0 ? r : 1, s = e?.length > o, l = Bn(
    () => e?.sort((d, m) => m?.created_at.localeCompare(d?.created_at)).slice(
      0,
      i ? e.length : o
    ),
    [e, i, o]
  );
  return /* @__PURE__ */ rn.jsxs(b, { flexDirection: "column", gap: "200", margin: "200 0 300 0", children: [
    l.map((d, m) => /* @__PURE__ */ rn.jsx(
      rV,
      {
        conversation: d,
        conversationContext: n
      },
      `${m}-${d?.id}`
    )),
    s && /* @__PURE__ */ rn.jsxs(
      Gn,
      {
        variant: "secondary",
        onClick: () => a(!i),
        children: [
          "Show ",
          i ? "less" : "all"
        ]
      }
    )
  ] });
}, aV = xL(
  /* GraphQL*/
  `
  query conversationsQuery($query: String) {
    Miuros {
      findTickets(query: $query, page_size: 10) {
        data {
          id
          labels
          subject
          messages {
            direction
            body
            agent {
              email
              name
            }
            created_at
          }
          custom_fields {
            additionalProperties {
              key
              value {
                value
              }
            }
          }
          created_at
        }
      }
    }
  }
`
), oV = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = le([]), a = Number.parseInt(n?.amountOfConversationsToShow) || 1, o = [
    e.customer?.email,
    e.customer?.phone_number
  ].filter((u) => !!u).map((u) => `'${u}'`).join(","), { useQuery: s } = hn(), { data: l, loading: d, error: m } = s(aV, {
    skip: o.length === 0,
    variables: {
      query: `requester_id=in=(${o})`
    }
  });
  return He(() => {
    if (l?.Miuros) {
      const u = l?.Miuros?.findTickets?.data;
      u && i(u);
    }
  }, [l]), m ? /* @__PURE__ */ rn.jsx(Fn, { error: m }) : d ? /* @__PURE__ */ rn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ rn.jsx(un, {}) }) : r?.length === 0 ? /* @__PURE__ */ rn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: "No conversations found for this customer" }) : /* @__PURE__ */ rn.jsx(
    iV,
    {
      "data-testid": "conversation-list",
      conversationsToShow: a,
      conversations: r,
      conversationContext: e
    }
  );
}, sV = [
  {
    key: "miurosClientId",
    label: "Authorization: Client ID",
    placeholder: "Insert client ID",
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "miurosClientSecret",
    label: "Authorization: Client Secret",
    placeholder: "Insert client secret",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Lr
  },
  {
    key: "amountOfConversationsToShow",
    label: "Number of conversation to show before the fold",
    placeholder: "Enter number",
    required: !0,
    defaultValue: "1",
    secret: !1,
    type: "input",
    customValidation: (e) => isNaN(Number.parseInt(e)) ? "Please enter a number" : void 0
  }
], Ek = [
  {
    key: "miurosClientId",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "miurosClientSecret",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "amountOfConversationsToShow",
    type: "string",
    secret: !1,
    defaultValue: "1"
  }
], zu = "MIUROS", lV = {
  enabled: !1,
  name: "",
  miurosClientId: "",
  miurosClientSecret: "",
  amountOfConversationsToShow: "1"
}, cV = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = _t({
    mode: "onChange",
    defaultValues: lV
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: g,
    setMisconfigurationCause: C
  } = ji({
    integrationId: e,
    integrationType: zu,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: S,
    error: N,
    isWidgetUnknown: w,
    refetch: y,
    widgetConfiguration: z
  } = wi({
    integrationId: e,
    fieldDefinitions: Ek,
    form: l,
    onMisconfigured: C
  }), { renderConditions: $, setRenderConditions: I, renderConditionsForSubmit: T } = Ci({
    integrationId: e,
    widgetConfiguration: z,
    renderConditionsEditor: o
  }), U = (J) => Ii(J, {
    fieldDefinitions: Ek,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: T
  }), Q = l.watch("name");
  return /* @__PURE__ */ rn.jsxs(
    Fi,
    {
      form: l,
      integrationId: e,
      onValidSubmit: U,
      error: N ?? h,
      onRetry: N ? y : void 0,
      isLoading: f || S,
      isWidgetUnknown: w,
      children: [
        g && /* @__PURE__ */ rn.jsx(Ei, { cause: g }),
        /* @__PURE__ */ rn.jsxs(st, { children: [
          /* @__PURE__ */ rn.jsx(be, { children: /* @__PURE__ */ rn.jsx(ln, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ rn.jsx(
            Jn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ rn.jsx(be, { span: 3, children: /* @__PURE__ */ rn.jsx(
            tt,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ rn.jsx(be, { span: 3 }),
          /* @__PURE__ */ rn.jsx(be, { span: 3, children: /* @__PURE__ */ rn.jsx(
            tt,
            {
              name: "miurosClientId",
              label: "Authorization: Client ID",
              control: l.control,
              rules: { required: "Client ID is required" },
              componentProps: {
                placeholder: "Insert client ID",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ rn.jsx(be, { span: 3 }),
          /* @__PURE__ */ rn.jsx(be, { span: 3, children: /* @__PURE__ */ rn.jsx(
            Mm,
            {
              name: "miurosClientSecret",
              label: "Authorization: Client secret",
              control: l.control,
              isCreationMode: s,
              rules: { required: "Client secret is required" },
              componentProps: {
                placeholder: "Insert client secret",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ rn.jsx(be, { span: 3 }),
          /* @__PURE__ */ rn.jsx(be, { span: 3, children: /* @__PURE__ */ rn.jsx(
            tt,
            {
              name: "amountOfConversationsToShow",
              label: "Number of conversation to show before the fold",
              control: l.control,
              rules: {
                required: "Please enter a number",
                validate: (J) => !Number.isNaN(Number.parseInt(J, 10)) || "Please enter a number"
              },
              componentProps: {
                placeholder: "Enter number",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ rn.jsx(be, { span: 3 }),
          !s && e && /* @__PURE__ */ rn.jsx(
            Lr,
            {
              configuration: n,
              integrationId: e,
              integrationType: zu,
              label: "Authorize"
            }
          ),
          o && $ !== null && /* @__PURE__ */ rn.jsx(be, { children: o({
            value: $,
            onChange: I,
            configurationKey: z?.id
          }) })
        ] }),
        /* @__PURE__ */ rn.jsx(
          Ti,
          {
            integrationType: zu,
            integrationId: e,
            widgetName: Q,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_2c4dq_1{padding:0}._listItem_2c4dq_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_2c4dq_4:last-child{border-bottom:none}._copyIcon_2c4dq_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1nher_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._order_1dlaa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_1dlaa_1:hover,._orderIsOpen_1dlaa_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_1dlaa_12{cursor:pointer}._note_1dlaa_16{border:var(--dixa-size-border-100) dashed var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-200);max-height:100px;overflow-y:auto}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Uu = { exports: {} }, Ma = {}, Tk;
function dV() {
  if (Tk) return Ma;
  Tk = 1;
  var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return Ma.Fragment = r, Ma.jsx = s, Ma.jsxs = s, Ma;
}
var Zo = {}, $k;
function uV() {
  return $k || ($k = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        z("error", t, p);
      }
    }
    function z(t, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, A = v.getStackAddendum();
        A !== "" && (c += "%s", p = p.concat([A]));
        var L = p.map(function(F) {
          return String(F);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, I = !1, T = !1, U = !1, Q = !1, J;
    J = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === u || U || t === g || $ || I || T || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function X(t, c, p) {
      var v = t.displayName;
      if (v)
        return v;
      var A = c.displayName || c.name || "";
      return A !== "" ? p + "(" + A + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return X(t, t.render, "ForwardRef");
          case f:
            var v = t.displayName || null;
            return v !== null ? v : O(t.type) || "Memo";
          case h: {
            var A = t, L = A._payload, F = A._init;
            try {
              return O(F(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, ue, ce, fe, W, xe, Ie;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ve = console.log, ue = console.info, ce = console.warn, fe = console.error, W = console.group, xe = console.groupCollapsed, Ie = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: ue
            }),
            warn: q({}, t, {
              value: ce
            }),
            error: q({}, t, {
              value: fe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: xe
            }),
            groupEnd: q({}, t, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Me;
    function $e(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (A) {
            var v = A.stack.trim().match(/\n( *(at )?)/);
            Me = v && v[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var ze = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(t, c) {
      if (!t || ze)
        return "";
      {
        var p = Re.get(t);
        if (p !== void 0)
          return p;
      }
      var v;
      ze = !0;
      var A = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, qe();
      try {
        if (c) {
          var F = function() {
            throw Error();
          };
          if (Object.defineProperty(F.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(F, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(t, [], F);
          } else {
            try {
              F.call();
            } catch (ne) {
              v = ne;
            }
            t.call(F.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), G = j.length - 1, _ = te.length - 1; G >= 1 && _ >= 0 && j[G] !== te[_]; )
            _--;
          for (; G >= 1 && _ >= 0; G--, _--)
            if (j[G] !== te[_]) {
              if (G !== 1 || _ !== 1)
                do
                  if (G--, _--, _ < 0 || j[G] !== te[_]) {
                    var Z = `
` + j[G].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (G >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Oe.current = L, Be(), Error.prepareStackTrace = A;
      }
      var de = t ? t.displayName || t.name : "", Se = de ? $e(de) : "";
      return typeof t == "function" && Re.set(t, Se), Se;
    }
    function Ge(t, c, p) {
      return Ee(t, !1);
    }
    function Qe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function he(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Qe(t));
      if (typeof t == "string")
        return $e(t);
      switch (t) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ge(t.render);
          case f:
            return he(t.type, c, p);
          case h: {
            var v = t, A = v._payload, L = v._init;
            try {
              return he(L(A), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, De = {}, Le = w.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = he(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(t, c, p, v, A) {
      {
        var L = Function.call.bind(ge);
        for (var F in t)
          if (L(t, F)) {
            var j = void 0;
            try {
              if (typeof t[F] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + F + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[F] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[F](c, F, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (G) {
              j = G;
            }
            j && !(j instanceof Error) && (Ae(A), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, F, typeof j), Ae(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Ae(A), y("Failed %s type: %s", p, j.message), Ae(null));
          }
      }
    }
    var E = Array.isArray;
    function x(t) {
      return E(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var V = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, me, Ne;
    function nn(t) {
      if (ge.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function fn(t) {
      if (ge.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && V.current;
    }
    function cn(t, c) {
      {
        var p = function() {
          me || (me = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(t, c, p, v, A, L, F) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: F,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: A
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, v, A) {
      {
        var L, F = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), fn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ge.call(c, L) && !ie.hasOwnProperty(L) && (F[L] = c[L]);
        if (t && t.defaultProps) {
          var G = t.defaultProps;
          for (L in G)
            F[L] === void 0 && (F[L] = G[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && cn(F, _), te && pn(F, _);
        }
        return dn(t, j, te, A, v, V.current, F);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = he(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var t = O(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        t && t._owner && t._owner !== en.current && (v = " It was passed a child from " + O(t._owner.type) + "."), Pe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Pe(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var v = t[p];
            sn(v) && gn(v, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var A = N(t);
          if (typeof A == "function" && A !== t.entries)
            for (var L = A.call(t), F; !(F = L.next()).done; )
              sn(F.value) && gn(F.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          mn(p, t.props, "prop", v, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var A = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", A || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Pe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Pe(null);
            break;
          }
        }
        t.ref !== null && (Pe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Pe(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, v, A, L) {
      {
        var F = ae(t);
        if (!F) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var G;
          t === null ? G = "null" : x(t) ? G = "array" : t !== void 0 && t.$$typeof === n ? (G = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : G = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", G, j);
        }
        var _ = xn(t, c, p, A, L);
        if (_ == null)
          return _;
        if (F) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var de = 0; de < Z.length; de++)
                  Cn(Z[de], t);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, t);
        }
        if (ge.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, Se, $n, Se), Sn[Se + Ke] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    Zo.Fragment = i, Zo.jsx = Rn, Zo.jsxs = Mn;
  })()), Zo;
}
var Dk;
function mV() {
  return Dk || (Dk = 1, process.env.NODE_ENV === "production" ? Uu.exports = dV() : Uu.exports = uV()), Uu.exports;
}
var je = mV();
const pV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getAddresses" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAddresses" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Addresses" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "addresses" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "payment_method_id" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "customer_id" } }, { kind: "Field", name: { kind: "Name", value: "discounts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "value_type" } }] } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "order_attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "value" } }] } }, { kind: "Field", name: { kind: "Name", value: "order_note" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "presentment_currency" } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_conserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_override" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] }, fV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getStore" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Store" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "store" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }, { kind: "Field", name: { kind: "Name", value: "customer_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "merchant_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "checkout_platform" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "external_customer_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ecommerce" } }] } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_active_count" } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_total_count" } }, { kind: "Field", name: { kind: "Name", value: "has_valid_payment_method" } }, { kind: "Field", name: { kind: "Name", value: "hash" } }] } }] } }] } }] } }] } }] }, hV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "addressId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "address_id" }, value: { kind: "Variable", name: { kind: "Name", value: "addressId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Orders" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "is_prepaid" } }, { kind: "Field", name: { kind: "Name", value: "note" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "subtotal_price" } }, { kind: "Field", name: { kind: "Name", value: "total_discounts" } }, { kind: "Field", name: { kind: "Name", value: "total_duties" } }, { kind: "Field", name: { kind: "Name", value: "total_line_items_price" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "total_refunds" } }, { kind: "Field", name: { kind: "Name", value: "total_tax" } }, { kind: "Field", name: { kind: "Name", value: "total_weight_grams" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "charge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_transaction_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "payment_processor" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billing_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] } }] }, yV = {
  "\n  query getAddresses($customerId: String) {\n    Recharge {\n      getAddresses(customer_id: $customerId) {\n        ... on Recharge_Addresses {\n          addresses {\n            id\n            payment_method_id\n            address1\n            address2\n            city\n            company\n            country_code\n            created_at\n            customer_id\n            discounts {\n              id\n              code\n              value\n              value_type\n            }\n            first_name\n            last_name\n            order_attributes {\n              name\n              value\n            }\n            order_note\n            phone\n            presentment_currency\n            shipping_lines_conserved {\n              code\n              title\n              price\n            }\n            shipping_lines_override {\n              code\n              title\n              price\n            }\n            updated_at\n            zip\n          }\n        }\n      }\n    }\n  }\n": pV,
  "\n  query getCustomerDetails($email: String) {\n    Recharge {\n      getStore {\n        ... on Recharge_Store {\n          store {\n            id\n            name\n            external_platform\n            customer_portal_base_url\n            merchant_portal_base_url\n            identifier\n            checkout_platform\n            external_platform\n          }\n        }\n      }\n      getCustomers(email: $email) {\n        ... on Recharge_Customers {\n          customers {\n            id\n            email\n            phone\n            first_name\n            last_name\n            created_at\n            updated_at\n            external_customer_id {\n              ecommerce\n            }\n            subscriptions_active_count\n            subscriptions_total_count\n            has_valid_payment_method\n            hash\n          }\n        }\n      }\n    }\n  }\n": fV,
  "\n  query getOrders($customerId: String, $limit: String, $addressId: String) {\n    Recharge {\n      getOrders(\n        customer_id: $customerId\n        limit: $limit\n        address_id: $addressId\n      ) {\n        ... on Recharge_Orders {\n          orders {\n            id\n            created_at\n            currency\n            is_prepaid\n            note\n            status\n            subtotal_price\n            total_discounts\n            total_duties\n            total_line_items_price\n            total_price\n            total_refunds\n            total_tax\n            total_weight_grams\n            type\n            charge {\n              external_transaction_id {\n                payment_processor\n              }\n            }\n            billing_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n            shipping_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n          }\n        }\n      }\n    }\n  }\n": hV
};
function Bp(e) {
  return yV[e] ?? {};
}
const gV = Bp(
  /* GraphQL */
  `
  query getCustomerDetails($email: String) {
    Recharge {
      getStore {
        ... on Recharge_Store {
          store {
            id
            name
            external_platform
            customer_portal_base_url
            merchant_portal_base_url
            identifier
            checkout_platform
            external_platform
          }
        }
      }
      getCustomers(email: $email) {
        ... on Recharge_Customers {
          customers {
            id
            email
            phone
            first_name
            last_name
            created_at
            updated_at
            external_customer_id {
              ecommerce
            }
            subscriptions_active_count
            subscriptions_total_count
            has_valid_payment_method
            hash
          }
        }
      }
    }
  }
`
), vV = Bp(
  /* GraphQL */
  `
  query getAddresses($customerId: String) {
    Recharge {
      getAddresses(customer_id: $customerId) {
        ... on Recharge_Addresses {
          addresses {
            id
            payment_method_id
            address1
            address2
            city
            company
            country_code
            created_at
            customer_id
            discounts {
              id
              code
              value
              value_type
            }
            first_name
            last_name
            order_attributes {
              name
              value
            }
            order_note
            phone
            presentment_currency
            shipping_lines_conserved {
              code
              title
              price
            }
            shipping_lines_override {
              code
              title
              price
            }
            updated_at
            zip
          }
        }
      }
    }
  }
`
), kV = Bp(
  /* GraphQL */
  `
  query getOrders($customerId: String, $limit: String, $addressId: String) {
    Recharge {
      getOrders(
        customer_id: $customerId
        limit: $limit
        address_id: $addressId
      ) {
        ... on Recharge_Orders {
          orders {
            id
            created_at
            currency
            is_prepaid
            note
            status
            subtotal_price
            total_discounts
            total_duties
            total_line_items_price
            total_price
            total_refunds
            total_tax
            total_weight_grams
            type
            charge {
              external_transaction_id {
                payment_processor
              }
            }
            billing_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
            shipping_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
          }
        }
      }
    }
  }
`
);
function Tm(e = !1, n) {
  const [r, i] = le(e);
  return He(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const bV = (e) => `${e.charAt(0).toUpperCase()}${e.slice(1).toLowerCase()}`, yS = "DD MMM YYYY @ HH:mm", xV = "_list_2c4dq_1", _V = "_listItem_2c4dq_4", SV = "_copyIcon_2c4dq_12", _i = {
  list: xV,
  listItem: _V,
  copyIcon: SV
}, $m = ({
  address: e,
  icon: n,
  title: r,
  isLoading: i = !1,
  hasMultipleAddresses: a = !1
}) => {
  const { isCopied: o, copy: s } = Tm(), l = 14, {
    first_name: d,
    last_name: m,
    address1: u,
    address2: f,
    city: h,
    zip: g,
    country_code: C
  } = e ?? {}, S = `${d} ${m}`.trim() || void 0, N = `${h} ${g}`.trim() || void 0, w = [S, u, f, N, C].filter(
    Boolean
  );
  return /* @__PURE__ */ je.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
    /* @__PURE__ */ je.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ je.jsx(pe, { size: l, name: n }),
      i ? /* @__PURE__ */ je.jsx(un, { size: l }) : /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "column", children: [
        r && /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "3", children: r }),
        /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", children: w.map((y, z) => /* @__PURE__ */ je.jsx(et, { children: y }, z)) })
      ] })
    ] }),
    !i && /* @__PURE__ */ je.jsxs(b, { gap: "100", children: [
      a && /* @__PURE__ */ je.jsx(We, { content: "The customer has multiple addresses, showing only the first here.", children: /* @__PURE__ */ je.jsx(
        pe,
        {
          size: l,
          name: "exclamation",
          className: _i.copyIcon
        }
      ) }),
      /* @__PURE__ */ je.jsx(We, { content: `Copy ${r ? r.toLowerCase() : "address"}`, children: /* @__PURE__ */ je.jsx(
        pe,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(w.join(", ")),
          className: _i.copyIcon
        }
      ) })
    ] })
  ] });
}, NV = "_wrapper_1nher_1", jV = {
  wrapper: NV
}, wV = ({
  customer: e,
  store: n
}) => {
  const { track: r } = _n(), { isCopied: i, copy: a } = Tm(), { isCopied: o, copy: s } = Tm(), { useQuery: l } = hn(), d = e?.id, {
    loading: m,
    error: u,
    data: f
  } = l(vV, {
    skip: !d,
    variables: {
      customerId: d?.toString()
    }
  }), h = f?.Recharge?.getAddresses, g = !m && h?.addresses?.[0] ? h.addresses[0] : void 0, C = (h?.addresses?.length ?? 0) > 1;
  if (He(() => {
    g && r("recharge:profile:received");
  }, [g, r]), u)
    return /* @__PURE__ */ je.jsx(Fn, { error: u });
  if (!e)
    return null;
  const {
    id: S,
    phone: N,
    email: w,
    first_name: y,
    last_name: z,
    created_at: $,
    has_valid_payment_method: I
  } = e, T = 14, U = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/customers/${S}` : null, Q = `${y || ""} ${z || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ je.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ je.jsxs(b, { className: jV.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ je.jsx(P.Heading, { variant: "heading-2", children: Q }),
    $ && /* @__PURE__ */ je.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", children: Ln($).format(yS) })
    ] }),
    w && /* @__PURE__ */ je.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ je.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ je.jsx(pe, { size: T, name: "mail" }),
        /* @__PURE__ */ je.jsx(P.ExternalLink, { href: `mailto:${w}`, children: w })
      ] }),
      /* @__PURE__ */ je.jsx(We, { content: "Copy email", children: /* @__PURE__ */ je.jsx(
        pe,
        {
          size: T,
          name: i ? "done" : "copy",
          onClick: () => a(w),
          className: _i.copyIcon
        }
      ) })
    ] }),
    N && /* @__PURE__ */ je.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ je.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ je.jsx(pe, { size: T, name: "phone" }),
        /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", children: N })
      ] }),
      /* @__PURE__ */ je.jsx(We, { content: "Copy phone number", children: /* @__PURE__ */ je.jsx(
        pe,
        {
          size: T,
          name: o ? "done" : "copy",
          onClick: () => s(N),
          className: _i.copyIcon
        }
      ) })
    ] }),
    /* @__PURE__ */ je.jsx(
      $m,
      {
        address: g,
        icon: "home",
        isLoading: m,
        hasMultipleAddresses: C
      }
    ),
    /* @__PURE__ */ je.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ je.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ je.jsx(pe, { size: T, name: "credit-card" }),
        /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", children: "Has valid payment method" })
      ] }),
      /* @__PURE__ */ je.jsx(
        pe,
        {
          size: T,
          name: I ? "check-circle" : "close-circle-filled",
          color: I ? "green.500" : "red.500"
        }
      )
    ] }),
    U && /* @__PURE__ */ je.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ je.jsx(pe, { size: T, name: "external-link" }),
      /* @__PURE__ */ je.jsx(
        P.ExternalLink,
        {
          href: U,
          target: "_blank",
          rel: "noreferrer",
          onClick: () => r("recharge:external:customer:overview:opened"),
          children: "View customer in Recharge"
        }
      )
    ] })
  ] }) });
}, CV = "_order_1dlaa_1", FV = "_orderIsOpen_1dlaa_9", IV = "_orderHeader_1dlaa_12", EV = "_note_1dlaa_16", es = {
  order: CV,
  orderIsOpen: FV,
  orderHeader: IV,
  note: EV
}, TV = ({
  order: e,
  isOpenByDefault: n,
  store: r
}) => {
  const { track: i } = _n(), [a, o] = le(n), {
    id: s,
    status: l,
    charge: d,
    currency: m,
    note: u,
    created_at: f,
    billing_address: h,
    shipping_address: g,
    total_price: C,
    is_prepaid: S
  } = e, N = 14, w = r ? `https://${r.identifier}.admin.rechargeapps.com/merchant/orders/${s}` : null, y = d?.external_transaction_id?.payment_processor || void 0;
  return /* @__PURE__ */ je.jsxs(
    b,
    {
      className: it(es.order, {
        [es.orderIsOpen]: a
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ je.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: es.orderHeader,
            onClick: () => o(!a),
            children: [
              /* @__PURE__ */ je.jsxs(b, { gap: "100", flexDirection: "column", children: [
                f && /* @__PURE__ */ je.jsx(b, { alignItems: "center", children: /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", children: Ln(f).format(yS) }) }),
                /* @__PURE__ */ je.jsxs(P.Paragraph, { variant: "1", children: [
                  "Order #",
                  s
                ] })
              ] }),
              /* @__PURE__ */ je.jsx(
                nr,
                {
                  variant: "tertiary",
                  icon: a ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        a && /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          u && /* @__PURE__ */ je.jsx(We, { content: "Note", children: /* @__PURE__ */ je.jsx(
            P.Paragraph,
            {
              variant: "4",
              color: "secondary",
              className: es.note,
              children: u
            }
          ) }),
          l && /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ je.jsx(pe, { size: N, name: "activity" }),
            /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "3", children: "Status" }),
              /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", children: bV(l) })
            ] })
          ] }),
          /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ je.jsx(pe, { size: N, name: "credit-card" }),
            /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "3", children: "Prepaid" }),
              /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", children: S ? "Yes" : "No" })
            ] })
          ] }),
          y && /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ je.jsx(pe, { size: N, name: "cog" }),
            /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "3", children: "Payment processor" }),
              /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", children: y })
            ] })
          ] }),
          /* @__PURE__ */ je.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ je.jsx(pe, { size: N, name: "chart-bar" }),
            /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ je.jsxs(P.Paragraph, { variant: "4", children: [
                C,
                " ",
                m
              ] })
            ] })
          ] }),
          /* @__PURE__ */ je.jsx(
            $m,
            {
              address: h,
              icon: "home",
              title: "Billing address"
            }
          ),
          /* @__PURE__ */ je.jsx(
            $m,
            {
              address: g,
              icon: "map-pin",
              title: "Shipping address"
            }
          ),
          w && /* @__PURE__ */ je.jsx(
            Et,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(w, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ je.jsx(pe, { name: "external-link" }),
              onClick: () => i("recharge:external:order:opened"),
              children: "View order in Recharge"
            }
          )
        ] })
      ]
    }
  );
}, $V = ({
  customerId: e,
  store: n
}) => {
  const { track: r } = _n(), { useQuery: i } = hn(), {
    loading: a,
    error: o,
    data: s
  } = i(kV, {
    skip: !e,
    variables: {
      customerId: e?.toString(),
      limit: "5"
    }
  }), l = s?.Recharge?.getOrders, d = !a && l?.orders && l.orders.length > 0 ? l.orders : [];
  if (!e)
    return null;
  if (o)
    return /* @__PURE__ */ je.jsx(Fn, { error: o });
  const m = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/orders/processed?limit=25` : null;
  return /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ je.jsx(P.Heading, { variant: "heading-3", children: "Customer orders" }),
      !a && /* @__PURE__ */ je.jsx(An, { variant: "success", size: "small", children: d.length })
    ] }),
    /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "column", children: [
      a && /* @__PURE__ */ je.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ je.jsx(un, {}) }),
      !a && d.length === 0 && /* @__PURE__ */ je.jsx(
        b,
        {
          justifyContent: "center",
          margin: "200 0 300 0",
          "data-testid": "widget-no-orders",
          children: /* @__PURE__ */ je.jsx(P.Paragraph, { color: "tertiary", children: "No orders found" })
        }
      ),
      !a && d.length > 0 && /* @__PURE__ */ je.jsx(b, { gap: "200", flexDirection: "column", children: d.map((u, f) => /* @__PURE__ */ je.jsx(
        TV,
        {
          order: u,
          isOpenByDefault: f === 0,
          store: n
        },
        `${f}-${u.id}`
      )) }),
      m && /* @__PURE__ */ je.jsx(
        Et,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(m, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ je.jsx(pe, { name: "external-link" }),
          onClick: () => r("recharge:external:orders:list:opened"),
          children: "View all orders in Recharge"
        }
      )
    ] })
  ] });
}, DV = ({
  customer: e
}) => {
  if (!e)
    return null;
  const {
    subscriptions_active_count: n,
    subscriptions_total_count: r
  } = e, i = r ?? 0, a = n ?? 0;
  return /* @__PURE__ */ je.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ je.jsx(P.Heading, { variant: "heading-3", children: "Subscriptions overview" }),
    /* @__PURE__ */ je.jsxs(Ye, { className: _i.list, children: [
      /* @__PURE__ */ je.jsx(Ye.Text, { variant: "dense", className: _i.listItem, children: /* @__PURE__ */ je.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", children: "Total subscriptions" }),
        /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", children: i })
      ] }) }),
      /* @__PURE__ */ je.jsx(Ye.Text, { variant: "dense", className: _i.listItem, children: /* @__PURE__ */ je.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", children: "Active subscriptions" }),
        /* @__PURE__ */ je.jsx(P.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] });
}, RV = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = hn(), i = e?.customer?.email, a = n.displayCustomerDetails ?? !1, o = n.displaysubscriptionOverview ?? !1, s = n.displayOrders ?? !1, l = !a && !o && !s, {
    loading: d,
    error: m,
    data: u
  } = r(gV, {
    skip: !i,
    variables: {
      email: i
    }
  }), f = !d && u ? u?.Recharge?.getCustomers?.customers?.[0] : void 0, h = !d && u ? u?.Recharge?.getStore?.store ?? void 0 : void 0;
  if (m) {
    const g = m.graphQLErrors;
    return Vm({ errors: g }) ? /* @__PURE__ */ je.jsx(
      P.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : zm({ errors: g }) ? /* @__PURE__ */ je.jsx(
      P.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Recharge. Please contact your administrator."
      }
    ) : /* @__PURE__ */ je.jsx(Fn, { error: m });
  }
  return d ? /* @__PURE__ */ je.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ je.jsx(un, {}) }) : f ? l ? /* @__PURE__ */ je.jsx(
    P.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : /* @__PURE__ */ je.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        a && /* @__PURE__ */ je.jsx(wV, { customer: f, store: h }),
        o && /* @__PURE__ */ je.jsx(DV, { customer: f }),
        s && /* @__PURE__ */ je.jsx($V, { customerId: f.id, store: h })
      ]
    }
  ) : /* @__PURE__ */ je.jsx(
    P.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-customer-not-found",
      children: "No data found for this customer in Recharge."
    }
  );
}, OV = [
  {
    key: "rechargeAccessToken",
    label: "API token",
    placeholder: "Insert the Admin API token for Recharge",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "displayCustomerDetails",
    label: "Displays details of a customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displaysubscriptionOverview",
    label: "Displays the subscription overview",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayOrders",
    label: "Displays the last 5 orders",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], Rk = [
  {
    key: "rechargeAccessToken",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "displayCustomerDetails",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displaysubscriptionOverview",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayOrders",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], AV = {
  enabled: !1,
  name: "",
  rechargeAccessToken: "",
  displayCustomerDetails: !0,
  displaysubscriptionOverview: !0,
  displayOrders: !0
}, PV = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = _t({
    mode: "onChange",
    defaultValues: AV
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: g
  } = ji({
    integrationId: e,
    integrationType: "RECHARGE",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: C,
    error: S,
    isWidgetUnknown: N,
    refetch: w,
    widgetConfiguration: y
  } = wi({
    integrationId: e,
    fieldDefinitions: Rk,
    form: s,
    onMisconfigured: g
  }), { renderConditions: z, setRenderConditions: $, renderConditionsForSubmit: I } = Ci({
    integrationId: e,
    widgetConfiguration: y,
    renderConditionsEditor: a
  }), T = (Q) => Ii(Q, {
    fieldDefinitions: Rk,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: I
  }), U = s.watch("name");
  return /* @__PURE__ */ je.jsxs(
    Fi,
    {
      form: s,
      integrationId: e,
      onValidSubmit: T,
      error: S ?? f,
      onRetry: S ? w : void 0,
      isLoading: u || C,
      isWidgetUnknown: N,
      children: [
        h && /* @__PURE__ */ je.jsx(Ei, { cause: h }),
        /* @__PURE__ */ je.jsxs(st, { children: [
          /* @__PURE__ */ je.jsx(be, { children: /* @__PURE__ */ je.jsx(ln, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ je.jsx(
            Jn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ je.jsx(be, { span: 3, children: /* @__PURE__ */ je.jsx(
            tt,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ je.jsx(be, { span: 3 }),
          /* @__PURE__ */ je.jsx(be, { span: 3, children: /* @__PURE__ */ je.jsx(
            Mm,
            {
              name: "rechargeAccessToken",
              label: "API token",
              control: s.control,
              isCreationMode: o,
              rules: { required: "API token is required" },
              componentProps: {
                placeholder: "Insert the Admin API token for Recharge",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ je.jsx(be, { span: 3 }),
          /* @__PURE__ */ je.jsx(be, { span: 3, children: /* @__PURE__ */ je.jsx(ln, { label: "Displays details of a customer", children: /* @__PURE__ */ je.jsx(
            Jn,
            {
              name: "displayCustomerDetails",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ je.jsx(be, { span: 3 }),
          /* @__PURE__ */ je.jsx(be, { span: 3, children: /* @__PURE__ */ je.jsx(ln, { label: "Displays the subscription overview", children: /* @__PURE__ */ je.jsx(
            Jn,
            {
              name: "displaysubscriptionOverview",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ je.jsx(be, { span: 3 }),
          /* @__PURE__ */ je.jsx(be, { span: 3, children: /* @__PURE__ */ je.jsx(ln, { label: "Displays the last 5 orders", children: /* @__PURE__ */ je.jsx(
            Jn,
            {
              name: "displayOrders",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ je.jsx(be, { span: 3 }),
          a && z !== null && /* @__PURE__ */ je.jsx(be, { children: a({
            value: z,
            onChange: $,
            configurationKey: y?.id
          }) })
        ] }),
        /* @__PURE__ */ je.jsx(
          Ti,
          {
            integrationType: "RECHARGE",
            integrationId: e,
            widgetName: U,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._banner_d9pot_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-400)}._list_d9pot_8{margin:var(--dixa-size-spacer-200) 0;padding-left:var(--dixa-size-spacer-500)}._list_d9pot_8 li{margin-bottom:var(--dixa-size-spacer-200)}._list_d9pot_8 li:last-child{margin-bottom:0}._list_alvh6_1{padding:0}._listItem_alvh6_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_alvh6_4:last-child{border-bottom:none}._listItemEdit_alvh6_11{cursor:pointer}._fullWidth_alvh6_15{width:100%}._boxWrapper_alvh6_19{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._modal_1vkwz_1{width:800px}._disabled_1vkwz_5 input{color:var(--dixa-typography-color-tertiary);background-color:var(--dixa-color-neutral-100);pointer-events:none}._wrapper_10fld_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300) var(--dixa-size-spacer-300) var(--dixa-size-spacer-250);background-color:var(--dixa-color-neutral-100)}._copyIcon_10fld_7{cursor:pointer;color:var(--dixa-typography-color-secondary)}._creationModal_pbe64_1{width:800px}._detailsModal_pbe64_5{width:600px}._percentageSuffix_pbe64_9{background-color:var(--dixa-color-neutral-100);padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-250)}._modal_11d6e_1{width:600px}._modalBody_11d6e_4{max-height:500px;overflow-y:auto}._codeContainer_11d6e_9{margin:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100) 0 0;padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._modal_1wlra_1{width:800px}._clickableIcon_33mqm_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._productTableHeader_6h6pl_1>tr>th{height:var(--dixa-size-spacer-300)}._productImage_6h6pl_5{width:50px;height:50px}._modal_1mprq_1{width:900px}._copyIcon_1dlzg_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._modal_21e62_1{max-width:900px}._modal_al73g_1{width:600px}._editIcon_1yp2k_1,._copyIcon_1yp2k_2,._icon_cddi1_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._link_cddi1_6{font-size:var(--dixa-typography-size-200)}._copyIcon_yc0fe_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._order_yc0fe_6{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_yc0fe_6:hover,._orderIsOpen_yc0fe_14{border-color:var(--dixa-color-neutral-400)}._orderHeader_yc0fe_17{cursor:pointer}._segmentName_1dkhk_1{overflow:hidden;white-space:nowrap}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Mu = { exports: {} }, Ba = {}, Ok;
function LV() {
  if (Ok) return Ba;
  Ok = 1;
  var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return Ba.Fragment = r, Ba.jsx = s, Ba.jsxs = s, Ba;
}
var ns = {}, Ak;
function VV() {
  return Ak || (Ak = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        z("error", t, p);
      }
    }
    function z(t, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, A = v.getStackAddendum();
        A !== "" && (c += "%s", p = p.concat([A]));
        var L = p.map(function(F) {
          return String(F);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, I = !1, T = !1, U = !1, Q = !1, J;
    J = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === u || U || t === g || $ || I || T || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function X(t, c, p) {
      var v = t.displayName;
      if (v)
        return v;
      var A = c.displayName || c.name || "";
      return A !== "" ? p + "(" + A + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return X(t, t.render, "ForwardRef");
          case f:
            var v = t.displayName || null;
            return v !== null ? v : O(t.type) || "Memo";
          case h: {
            var A = t, L = A._payload, F = A._init;
            try {
              return O(F(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, ue, ce, fe, W, xe, Ie;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ve = console.log, ue = console.info, ce = console.warn, fe = console.error, W = console.group, xe = console.groupCollapsed, Ie = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: ue
            }),
            warn: q({}, t, {
              value: ce
            }),
            error: q({}, t, {
              value: fe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: xe
            }),
            groupEnd: q({}, t, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Me;
    function $e(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (A) {
            var v = A.stack.trim().match(/\n( *(at )?)/);
            Me = v && v[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var ze = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(t, c) {
      if (!t || ze)
        return "";
      {
        var p = Re.get(t);
        if (p !== void 0)
          return p;
      }
      var v;
      ze = !0;
      var A = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, qe();
      try {
        if (c) {
          var F = function() {
            throw Error();
          };
          if (Object.defineProperty(F.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(F, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(t, [], F);
          } else {
            try {
              F.call();
            } catch (ne) {
              v = ne;
            }
            t.call(F.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), G = j.length - 1, _ = te.length - 1; G >= 1 && _ >= 0 && j[G] !== te[_]; )
            _--;
          for (; G >= 1 && _ >= 0; G--, _--)
            if (j[G] !== te[_]) {
              if (G !== 1 || _ !== 1)
                do
                  if (G--, _--, _ < 0 || j[G] !== te[_]) {
                    var Z = `
` + j[G].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (G >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Oe.current = L, Be(), Error.prepareStackTrace = A;
      }
      var de = t ? t.displayName || t.name : "", Se = de ? $e(de) : "";
      return typeof t == "function" && Re.set(t, Se), Se;
    }
    function Ge(t, c, p) {
      return Ee(t, !1);
    }
    function Qe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function he(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Qe(t));
      if (typeof t == "string")
        return $e(t);
      switch (t) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ge(t.render);
          case f:
            return he(t.type, c, p);
          case h: {
            var v = t, A = v._payload, L = v._init;
            try {
              return he(L(A), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, De = {}, Le = w.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = he(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(t, c, p, v, A) {
      {
        var L = Function.call.bind(ge);
        for (var F in t)
          if (L(t, F)) {
            var j = void 0;
            try {
              if (typeof t[F] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + F + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[F] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[F](c, F, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (G) {
              j = G;
            }
            j && !(j instanceof Error) && (Ae(A), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, F, typeof j), Ae(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Ae(A), y("Failed %s type: %s", p, j.message), Ae(null));
          }
      }
    }
    var E = Array.isArray;
    function x(t) {
      return E(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var V = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, me, Ne;
    function nn(t) {
      if (ge.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function fn(t) {
      if (ge.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && V.current;
    }
    function cn(t, c) {
      {
        var p = function() {
          me || (me = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(t, c, p, v, A, L, F) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: F,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: A
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, v, A) {
      {
        var L, F = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), fn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ge.call(c, L) && !ie.hasOwnProperty(L) && (F[L] = c[L]);
        if (t && t.defaultProps) {
          var G = t.defaultProps;
          for (L in G)
            F[L] === void 0 && (F[L] = G[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && cn(F, _), te && pn(F, _);
        }
        return dn(t, j, te, A, v, V.current, F);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = he(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var t = O(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        t && t._owner && t._owner !== en.current && (v = " It was passed a child from " + O(t._owner.type) + "."), Pe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Pe(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var v = t[p];
            sn(v) && gn(v, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var A = N(t);
          if (typeof A == "function" && A !== t.entries)
            for (var L = A.call(t), F; !(F = L.next()).done; )
              sn(F.value) && gn(F.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          mn(p, t.props, "prop", v, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var A = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", A || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Pe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Pe(null);
            break;
          }
        }
        t.ref !== null && (Pe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Pe(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, v, A, L) {
      {
        var F = ae(t);
        if (!F) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var G;
          t === null ? G = "null" : x(t) ? G = "array" : t !== void 0 && t.$$typeof === n ? (G = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : G = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", G, j);
        }
        var _ = xn(t, c, p, A, L);
        if (_ == null)
          return _;
        if (F) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var de = 0; de < Z.length; de++)
                  Cn(Z[de], t);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, t);
        }
        if (ge.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, Se, $n, Se), Sn[Se + Ke] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    ns.Fragment = i, ns.jsx = Rn, ns.jsxs = Mn;
  })()), ns;
}
var Pk;
function zV() {
  return Pk || (Pk = 1, process.env.NODE_ENV === "production" ? Mu.exports = LV() : Mu.exports = VV()), Mu.exports;
}
var k = zV();
const Lk = "__PairingContext__", UV = () => globalThis[Lk] ?? (() => {
  const e = Qb({});
  return globalThis[Lk] = e, e;
})(), MV = UV(), BV = () => Bm(MV), qV = "_banner_d9pot_1", HV = "_list_d9pot_8", Vk = {
  banner: qV,
  list: HV
}, zk = "https://apps.shopify.com/dixa-dashboard", WV = {
  install: {
    description: "Connect your Shopify store to Dixa with just a few clicks.",
    listHeading: "How it works:",
    listType: "ol",
    listItems: [
      'Click "Install Dixa app in Shopify" below to start the connection',
      "You'll be redirected to the Shopify App Store to install the Dixa app",
      "After installing, the connection is set up automatically",
      "Return to the Settings > Integrations overview to see your newly connected Shopify integration"
    ],
    buttonText: "Install Dixa app in Shopify",
    buttonVariant: "primary"
  },
  migration: {
    description: "This integration uses a legacy connection method. We recommend upgrading to the Dixa Shopify app for a simpler, more reliable connection that doesn't require manual credential management.",
    listHeading: "Benefits of upgrading:",
    listType: "ul",
    listItems: [
      "No need to manage Client ID and Client Secret",
      "Automatic token refresh handled by the app",
      "Easier setup for new stores"
    ],
    buttonText: "Upgrade via Shopify App Store",
    buttonVariant: "primary"
  }
}, gS = ({
  label: e,
  bannerVariant: n = "install"
}) => {
  const { initiateFromDixa: r } = BV(), [i, a] = le(!1), [o, s] = le(null), l = WV[n], d = async () => {
    if (n === "install" && r) {
      a(!0), s(null);
      try {
        const u = await r();
        window.open(
          u ?? zk,
          "_blank",
          "noopener,noreferrer"
        );
      } catch {
        s("Failed to start the connection. Please try again.");
      } finally {
        a(!1);
      }
      return;
    }
    window.open(zk, "_blank", "noopener,noreferrer");
  }, m = l.listType === "ol" ? "ol" : "ul";
  return /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", className: Vk.banner, children: [
    /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-2", children: e }),
    /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ k.jsx(b, { children: /* @__PURE__ */ k.jsx(pe, { size: 30, name: "shopify", color: "green.500" }) }),
      /* @__PURE__ */ k.jsx(P.Paragraph, { children: l.description })
    ] }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: l.listHeading }),
      /* @__PURE__ */ k.jsx(P.Paragraph, { as: "div", children: /* @__PURE__ */ k.jsx(m, { className: Vk.list, children: l.listItems.map((u, f) => /* @__PURE__ */ k.jsx("li", { children: u }, f)) }) })
    ] }),
    o && /* @__PURE__ */ k.jsx(P.Paragraph, { color: "danger", children: o }),
    /* @__PURE__ */ k.jsx(b, { margin: "200 0 0 0", children: /* @__PURE__ */ k.jsx(
      Gn,
      {
        onClick: d,
        icon: "external-link",
        variant: l.buttonVariant,
        disabled: i,
        children: i ? /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(un, { size: 16 }),
          "Connecting…"
        ] }) : l.buttonText
      }
    ) })
  ] }) });
}, GV = (e) => /* @__PURE__ */ k.jsx(gS, { ...e, bannerVariant: "install" }), KV = (e) => /* @__PURE__ */ k.jsx(gS, { ...e, bannerVariant: "migration" }), YV = [
  {
    key: "shopifyClientId",
    label: "Client ID",
    placeholder: "Client ID from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "shopifyClientSecret",
    label: "Client Secret",
    placeholder: "Client Secret from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], QV = [
  {
    key: "apiAccessToken",
    label: "API Access Token",
    placeholder: "API access token from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], JV = [
  {
    key: "marketplaceInstallBanner",
    label: "Connect your Shopify store",
    secret: !1,
    type: "custom",
    component: GV
  }
], XV = [
  {
    key: "apiHostName",
    label: "Connected Shopify store",
    placeholder: "",
    required: !1,
    secret: !1,
    type: "input",
    prefix: "https://",
    readOnly: !0
  }
], Uk = [
  {
    key: "migrationBanner",
    label: "Upgrade to simplified connection",
    secret: !1,
    type: "custom",
    component: KV,
    additionalProperties: { renderAboveForm: !0 }
  }
], vS = [
  {
    key: "displayRefundOrder",
    label: "Display the refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "displayPartialRefundOrder",
    label: "Displays the partial refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCancelOrder",
    label: "Displays the cancel order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableEditShippingAddress",
    label: 'Enable the "edit shipping address" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayOrdersOverview",
    label: "Displays short orders overview",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    // We keep the key name to the first version which only showed marketing
    // consent for email in order to not change the existing integration setting
    // for customers. The current version shows both email and phone marketing consent.
    key: "displayEmailMarketingConsent",
    label: "Displays the email and phone marketing consent status of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displaySegmentMembership",
    label: "Displays the segment memberships of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodes",
    label: "Displays available discount codes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodeCreation",
    label: "Displays the discount code creation button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateOrder",
    label: "Displays the create order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateDraftOrder",
    label: "Displays the create draft order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDuplicateOrder",
    label: "Displays the duplicate order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], Mk = [
  {
    key: "apiHostName",
    label: "API host name",
    placeholder: 'Host name of your shop, e.g. "my-webshop.myshopify.com"',
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => Hb(e)
  },
  ...vS
];
var Qi = /* @__PURE__ */ ((e) => (e.Invalid = "INVALID", e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(Qi || {}), Si = /* @__PURE__ */ ((e) => (e.ConfirmedOptIn = "CONFIRMED_OPT_IN", e.SingleOptIn = "SINGLE_OPT_IN", e.Unknown = "UNKNOWN", e))(Si || {}), $r = /* @__PURE__ */ ((e) => (e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Redacted = "REDACTED", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))($r || {}), kS = /* @__PURE__ */ ((e) => (e.All = "ALL", e))(kS || {}), fi = /* @__PURE__ */ ((e) => (e.Customer = "CUSTOMER", e.Declined = "DECLINED", e.Fraud = "FRAUD", e.Inventory = "INVENTORY", e.Other = "OTHER", e.Staff = "STAFF", e))(fi || {}), Gr = /* @__PURE__ */ ((e) => (e.Authorized = "AUTHORIZED", e.Expired = "EXPIRED", e.Paid = "PAID", e.PartiallyPaid = "PARTIALLY_PAID", e.PartiallyRefunded = "PARTIALLY_REFUNDED", e.Pending = "PENDING", e.Refunded = "REFUNDED", e.Voided = "VOIDED", e))(Gr || {}), bs = /* @__PURE__ */ ((e) => (e.Fulfilled = "FULFILLED", e.Partial = "PARTIAL", e.Restocked = "RESTOCKED", e))(bs || {}), bS = /* @__PURE__ */ ((e) => (e.Authorization = "AUTHORIZATION", e.Capture = "CAPTURE", e.Change = "CHANGE", e.EmvAuthorization = "EMV_AUTHORIZATION", e.Refund = "REFUND", e.Sale = "SALE", e.SuggestedRefund = "SUGGESTED_REFUND", e.Void = "VOID", e))(bS || {});
const ZV = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refundCreate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, ez = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, nz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderCancel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "orderId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reason" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelReason" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelRefundMethodInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "restock" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "staffNote" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCancel" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "notifyCustomer" }, value: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } } }, { kind: "Argument", name: { kind: "Name", value: "orderId" }, value: { kind: "Variable", name: { kind: "Name", value: "orderId" } } }, { kind: "Argument", name: { kind: "Name", value: "reason" }, value: { kind: "Variable", name: { kind: "Name", value: "reason" } } }, { kind: "Argument", name: { kind: "Name", value: "refundMethod" }, value: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } } }, { kind: "Argument", name: { kind: "Name", value: "restock" }, value: { kind: "Variable", name: { kind: "Name", value: "restock" } } }, { kind: "Argument", name: { kind: "Name", value: "staffNote" }, value: { kind: "Variable", name: { kind: "Name", value: "staffNote" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "job" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "done" } }] } }, { kind: "Field", name: { kind: "Name", value: "orderCancelUserErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, tz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createCustomer" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_CustomerInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "Field", name: { kind: "Name", value: "customer" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }] } }, { kind: "Field", name: { kind: "Name", value: "taxExempt" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] }, rz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "order" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOrderInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "options" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOptionsInput" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "order" }, value: { kind: "Variable", name: { kind: "Name", value: "order" } } }, { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, iz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDraftOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DraftOrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrder" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, az = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDiscountCode" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasicInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountCodeBasicCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "basicCodeDiscount" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNode" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "startsAt" } }, { kind: "Field", name: { kind: "Name", value: "endsAt" } }, { kind: "Field", name: { kind: "Name", value: "usageLimit" } }, { kind: "Field", name: { kind: "Name", value: "appliesOncePerCustomer" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, oz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refuncLineItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refund" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, sz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }] } }] } }] } }] } }] }, lz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "segments" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, cz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "customerSegmentMembership" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } }, type: { kind: "NonNullType", type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerSegmentMembership" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customerId" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "segmentIds" }, value: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "memberships" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segmentId" } }, { kind: "Field", name: { kind: "Name", value: "isMember" } }] } }] } }] } }] } }] }, dz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countriesInShippingZones" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countryCodes" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "customers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "numberOfOrders" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "verifiedEmail" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }] } }] } }] } }] } }] } }] } }] }, uz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "sortKey" }, value: { kind: "EnumValue", value: "CREATED_AT" } }, { kind: "Argument", name: { kind: "Name", value: "reverse" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "cancelledAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "netPaymentSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedRefund" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "suggestFullRefund" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedTransactions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountNumber" } }, { kind: "Field", name: { kind: "Name", value: "gateway" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "parentTransaction" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingLines" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "discountedPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "fulfillments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "2" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "trackingInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "15" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "variantTitle" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "product" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountedUnitPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refunds" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalRefunded" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "250" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentTotalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] } }] } }] }, mz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "readDiscountCodes" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNodes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeApp" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBxgy" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeFreeShipping" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, pz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchProducts" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "productCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "products" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "productCount" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "onlineStoreUrl" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "totalInventory" } }, { kind: "Field", name: { kind: "Name", value: "priceRangeV2" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "maxVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "minVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "media" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alt" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "mediaContentType" } }, { kind: "Field", name: { kind: "Name", value: "preview" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "altText" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, fz = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "test" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "description" } }] } }] } }] } }] }, hz = {
  "\n  mutation refundCreate($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": ZV,
  "\n  mutation orderUpdate($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          shippingAddress {\n            firstName\n            lastName\n            company\n            address1\n            address2\n            city\n            countryCodeV2\n            provinceCode\n            zip\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": ez,
  "\n  mutation orderCancel(\n    $notifyCustomer: Boolean\n    $orderId: ID!\n    $reason: Shopify_OrderCancelReason!\n    $refundMethod: Shopify_OrderCancelRefundMethodInput!\n    $restock: Boolean!\n    $staffNote: String!\n  ) {\n    Shopify {\n      orderCancel(\n        notifyCustomer: $notifyCustomer\n        orderId: $orderId\n        reason: $reason\n        refundMethod: $refundMethod\n        restock: $restock\n        staffNote: $staffNote\n      ) {\n        job {\n          id\n          done\n        }\n        orderCancelUserErrors {\n          code\n          field\n          message\n        }\n      }\n    }\n  }\n": nz,
  "\n  mutation createCustomer($input: Shopify_CustomerInput!) {\n    Shopify {\n      customerCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n        customer {\n          id\n          defaultEmailAddress {\n            emailAddress\n          }\n          defaultPhoneNumber {\n            phoneNumber\n            marketingState\n            marketingOptInLevel\n          }\n          taxExempt\n          firstName\n          lastName\n          amountSpent {\n            amount\n            currencyCode\n          }\n        }\n      }\n    }\n  }\n": tz,
  "\n  mutation createOrder(\n    $order: Shopify_OrderCreateOrderInput!\n    $options: Shopify_OrderCreateOptionsInput\n  ) {\n    Shopify {\n      orderCreate(order: $order, options: $options) {\n        order {\n          id\n          name\n          createdAt\n          displayFulfillmentStatus\n          displayFinancialStatus\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": rz,
  "\n  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {\n    Shopify {\n      draftOrderCreate(input: $input) {\n        draftOrder {\n          id\n          name\n          createdAt\n          tags\n          status\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": iz,
  "\n  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {\n    Shopify {\n      discountCodeBasicCreate(basicCodeDiscount: $input) {\n        codeDiscountNode {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeBasic {\n              codes(first: 1) {\n                nodes {\n                  code\n                }\n              }\n              title\n              status\n              startsAt\n              endsAt\n              usageLimit\n              appliesOncePerCustomer\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": az,
  "\n  mutation refuncLineItems($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        refund {\n          id\n          totalRefundedSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": oz,
  "\n  mutation updateOrder($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          id\n          tags\n        }\n      }\n    }\n  }\n": sz,
  "\n  query segments($first: Int!) {\n    Shopify {\n      segments(first: $first) {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n": lz,
  "\n  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {\n    Shopify {\n      customerSegmentMembership(\n        customerId: $customerId\n        segmentIds: $segmentIds\n      ) {\n        memberships {\n          segmentId\n          isMember\n        }\n      }\n    }\n  }\n": cz,
  "\n  query shopifyCustomerData($query: String!) {\n    Shopify {\n      shop {\n        countriesInShippingZones {\n          countryCodes\n        }\n      }\n\n      customers(first: 1, query: $query) {\n        edges {\n          node {\n            id\n            displayName\n            firstName\n            lastName\n            defaultEmailAddress {\n              emailAddress\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            defaultPhoneNumber {\n              phoneNumber\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            numberOfOrders\n            tags\n            verifiedEmail\n            amountSpent {\n              amount\n              currencyCode\n            }\n            defaultAddress {\n              firstName\n              lastName\n              address1\n              address2\n              city\n              country\n              zip\n              phone\n              provinceCode\n              countryCodeV2\n            }\n          }\n        }\n      }\n    }\n  }\n": dz,
  "\n  query shopifyCustomerOrders($query: String!) {\n    Shopify {\n      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {\n        edges {\n          node {\n            id\n            name\n            createdAt\n            displayFulfillmentStatus\n            displayFinancialStatus\n            cancelledAt\n            tags\n            netPaymentSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            totalRefundedSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            billingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            shippingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            suggestedRefund(suggestFullRefund: true) {\n              amountSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              suggestedTransactions {\n                accountNumber\n                gateway\n                kind\n                parentTransaction {\n                  id\n                }\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              refundLineItems {\n                lineItem {\n                  id\n                  quantity\n                }\n              }\n            }\n            shippingLines(first: 5) {\n              edges {\n                node {\n                  title\n                  code\n                  source\n                  discountedPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            fulfillments(first: 2) {\n              trackingInfo {\n                company\n                number\n                url\n              }\n            }\n            lineItems(first: 15) {\n              edges {\n                node {\n                  id\n                  title\n                  quantity\n                  variantTitle\n                  sku\n                  image {\n                    url\n                  }\n                  product {\n                    id\n                  }\n                  discountedUnitPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            refunds {\n              totalRefunded {\n                amount\n                currencyCode\n              }\n              refundLineItems(first: 250) {\n                edges {\n                  node {\n                    id\n                    quantity\n                    lineItem {\n                      id\n                      title\n                    }\n                  }\n                }\n              }\n            }\n            currentTotalPriceSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n              shopMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": uz,
  "\n  query readDiscountCodes($first: Int) {\n    Shopify {\n      codeDiscountNodes(first: $first) {\n        nodes {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeApp {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBasic {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBxgy {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeFreeShipping {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": mz,
  "\n  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {\n    Shopify {\n      products(first: $productCount, query: $query) {\n        nodes {\n          id\n          title\n          description\n          onlineStoreUrl\n          status\n          tags\n          title\n          totalInventory\n          priceRangeV2 {\n            maxVariantPrice {\n              amount\n              currencyCode\n            }\n            minVariantPrice {\n              amount\n              currencyCode\n            }\n          }\n          media(first: $mediaCount) {\n            nodes {\n              alt\n              id\n              status\n              mediaContentType\n              preview {\n                image {\n                  id\n                  altText\n                  url\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": pz,
  "\n  query test {\n    Shopify {\n      shop {\n        name\n        email\n        description\n      }\n    }\n  }\n": fz
};
function yr(e) {
  return hz[e] ?? {};
}
const yz = yr(
  /* GraphQL */
  `
  query shopifyCustomerData($query: String!) {
    Shopify {
      shop {
        countriesInShippingZones {
          countryCodes
        }
      }

      customers(first: 1, query: $query) {
        edges {
          node {
            id
            displayName
            firstName
            lastName
            defaultEmailAddress {
              emailAddress
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            defaultPhoneNumber {
              phoneNumber
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            numberOfOrders
            tags
            verifiedEmail
            amountSpent {
              amount
              currencyCode
            }
            defaultAddress {
              firstName
              lastName
              address1
              address2
              city
              country
              zip
              phone
              provinceCode
              countryCodeV2
            }
          }
        }
      }
    }
  }
`
), gz = yr(
  /* GraphQL */
  `
  query shopifyCustomerOrders($query: String!) {
    Shopify {
      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {
        edges {
          node {
            id
            name
            createdAt
            displayFulfillmentStatus
            displayFinancialStatus
            cancelledAt
            tags
            netPaymentSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            totalRefundedSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            billingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
              phone
            }
            shippingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
              phone
            }
            suggestedRefund(suggestFullRefund: true) {
              amountSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
              }
              suggestedTransactions {
                accountNumber
                gateway
                kind
                parentTransaction {
                  id
                }
                amountSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
              }
              refundLineItems {
                lineItem {
                  id
                  quantity
                }
              }
            }
            shippingLines(first: 5) {
              edges {
                node {
                  title
                  code
                  source
                  discountedPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            fulfillments(first: 2) {
              trackingInfo {
                company
                number
                url
              }
            }
            lineItems(first: 15) {
              edges {
                node {
                  id
                  title
                  quantity
                  variantTitle
                  sku
                  image {
                    url
                  }
                  product {
                    id
                  }
                  discountedUnitPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            refunds {
              totalRefunded {
                amount
                currencyCode
              }
              refundLineItems(first: 250) {
                edges {
                  node {
                    id
                    quantity
                    lineItem {
                      id
                      title
                    }
                  }
                }
              }
            }
            currentTotalPriceSet {
              presentmentMoney {
                amount
                currencyCode
              }
              shopMoney {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  }
`
), vz = yr(
  /* GraphQL */
  `
  query segments($first: Int!) {
    Shopify {
      segments(first: $first) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`
), kz = yr(
  /* GraphQL */
  `
  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {
    Shopify {
      customerSegmentMembership(
        customerId: $customerId
        segmentIds: $segmentIds
      ) {
        memberships {
          segmentId
          isMember
        }
      }
    }
  }
`
), qp = yr(
  /* GraphQL */
  `
  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {
    Shopify {
      products(first: $productCount, query: $query) {
        nodes {
          id
          title
          description
          onlineStoreUrl
          status
          tags
          title
          totalInventory
          priceRangeV2 {
            maxVariantPrice {
              amount
              currencyCode
            }
            minVariantPrice {
              amount
              currencyCode
            }
          }
          media(first: $mediaCount) {
            nodes {
              alt
              id
              status
              mediaContentType
              preview {
                image {
                  id
                  altText
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`
), bz = yr(
  /* GraphQL */
  `
  query readDiscountCodes($first: Int) {
    Shopify {
      codeDiscountNodes(first: $first) {
        nodes {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeApp {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBasic {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBxgy {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeFreeShipping {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }
          }
        }
      }
    }
  }
`
), xz = yr(
  /* GraphQL */
  `
  mutation orderUpdate($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          shippingAddress {
            firstName
            lastName
            company
            address1
            address2
            city
            countryCodeV2
            provinceCode
            zip
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), _z = yr(
  /* GraphQL */
  `
  mutation refundCreate($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        userErrors {
          field
          message
        }
      }
    }
  }
`
), Sz = yr(
  /* GraphQL */
  `
  mutation orderCancel(
    $notifyCustomer: Boolean
    $orderId: ID!
    $reason: Shopify_OrderCancelReason!
    $refundMethod: Shopify_OrderCancelRefundMethodInput!
    $restock: Boolean!
    $staffNote: String!
  ) {
    Shopify {
      orderCancel(
        notifyCustomer: $notifyCustomer
        orderId: $orderId
        reason: $reason
        refundMethod: $refundMethod
        restock: $restock
        staffNote: $staffNote
      ) {
        job {
          id
          done
        }
        orderCancelUserErrors {
          code
          field
          message
        }
      }
    }
  }
`
), Nz = yr(
  /* GraphQL */
  `
  mutation updateOrder($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          id
          tags
        }
      }
    }
  }
`
), jz = yr(
  /* GraphQL */
  `
  mutation createCustomer($input: Shopify_CustomerInput!) {
    Shopify {
      customerCreate(input: $input) {
        userErrors {
          field
          message
        }
        customer {
          id
          defaultEmailAddress {
            emailAddress
          }
          defaultPhoneNumber {
            phoneNumber
            marketingState
            marketingOptInLevel
          }
          taxExempt
          firstName
          lastName
          amountSpent {
            amount
            currencyCode
          }
        }
      }
    }
  }
`
), wz = yr(
  /* GraphQL */
  `
  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {
    Shopify {
      discountCodeBasicCreate(basicCodeDiscount: $input) {
        codeDiscountNode {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeBasic {
              codes(first: 1) {
                nodes {
                  code
                }
              }
              title
              status
              startsAt
              endsAt
              usageLimit
              appliesOncePerCustomer
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), xS = Ks`
  mutation createOrder(
    $order: Shopify_OrderCreateOrderInput!
    $options: Shopify_OrderCreateOptionsInput
  ) {
    Shopify {
      orderCreate(order: $order, options: $options) {
        order {
          id
          name
          createdAt
          displayFulfillmentStatus
          displayFinancialStatus
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, Cz = Ks`
  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {
    Shopify {
      draftOrderCreate(input: $input) {
        draftOrder {
          id
          name
          createdAt
          tags
          status
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, Fz = ({
  conversationContext: e
}) => {
  const { useQuery: n } = hn(), r = e.customer?.email, i = e.customer?.phone_number, a = r ? `email:"${r}"` : null, o = i ? `phone:"${i}"` : null, s = a ?? o ?? null, {
    loading: l,
    error: d,
    data: m,
    refetch: u,
    networkStatus: f
  } = n(yz, {
    skip: !s,
    variables: {
      query: s
    },
    notifyOnNetworkStatusChange: !0
  });
  return {
    isCustomerLoading: l,
    customerError: d,
    customerData: m,
    refetchCustomer: u,
    customerNetworkStatus: f
  };
}, Iz = () => {
  const { useLazyQuery: e } = hn(), [
    n,
    {
      loading: r,
      error: i,
      data: a,
      refetch: o
    }
  ] = e(gz);
  return {
    getCustomerOrders: n,
    isCustomerOrdersLoading: r,
    customerOrdersError: i,
    customerOrders: a,
    refetchCustomerOrders: o
  };
};
function Ar(e = !1, n) {
  const [r, i] = le(e);
  return He(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const Ez = "_list_alvh6_1", Tz = "_listItem_alvh6_4", $z = "_fullWidth_alvh6_15", Dz = "_boxWrapper_alvh6_19", Ot = {
  list: Ez,
  listItem: Tz,
  fullWidth: $z,
  boxWrapper: Dz
}, Rz = "_modal_1vkwz_1", Oz = "_disabled_1vkwz_5", Bu = {
  modal: Rz,
  disabled: Oz
}, Bk = [
  {
    label: "Single Opt-In",
    description: "After providing their information, the customer receives marketing information without any intermediate steps.",
    value: Si.SingleOptIn
  },
  {
    label: "Confirmed Opt-In",
    description: "After providing their information, the customer receives a confirmation and is required to perform a intermediate step before receiving marketing information.",
    value: Si.ConfirmedOptIn
  },
  {
    label: "Unknown",
    description: "The customer receives marketing information but how they were opted in is unknown.",
    value: Si.Unknown
  }
], qk = [
  {
    label: "Not Subscribed",
    description: "The customer hasn’t subscribed to SMS marketing.",
    value: $r.NotSubscribed
  },
  {
    label: "Pending",
    description: "The customer is in the process of subscribing to SMS marketing.",
    value: $r.Pending
  },
  {
    label: "Redacted",
    description: "The customer’s personal data is erased. This value is internally-set and read-only.",
    value: $r.Redacted
  },
  {
    label: "Subscribed",
    description: "The customer is subscribed to SMS marketing.",
    value: $r.Subscribed
  },
  {
    label: "Unsubscribed",
    description: "The customer isn’t currently subscribed to SMS marketing but was previously subscribed.",
    value: $r.Unsubscribed
  }
], Az = ({
  conversationContext: e,
  isOpen: n,
  setIsOpen: r,
  isMutationLoading: i,
  setIsMutationLoading: a,
  refetchCustomer: o
}) => {
  const { track: s } = _n(), { useMutation: l, showNotification: d } = hn(), [m, u] = le(), [f, h] = le(), [g, C] = qf(!0), [S, N] = qf(!0), w = !!m, y = e.customer?.email, z = e.customer?.phone_number, $ = e.customer?.given_name, I = e.customer?.family_name, T = {
    email: y ?? "",
    phone: z ?? "",
    firstName: $ ?? "",
    lastName: I ?? "",
    smsMarketingState: null,
    smsMarketingOptInLevel: null
  }, U = _t({
    defaultValues: T
  });
  He(() => {
    f?.forEach((O) => {
      const q = O?.field?.[0];
      q && (U.setError(q, {
        type: "server",
        message: O.message
      }), U.setFocus(q));
    });
  }, [f, U]);
  const [Q, { error: J, reset: ae }] = l(jz, {
    onError: (O) => {
      u(O.message), a(!1), d({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: async (O) => {
      const q = O?.Shopify?.customerCreate?.userErrors || [];
      q.length > 0 ? (h(q), a(!1), d({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      })) : (setTimeout(async () => {
        await o(), a(!1);
      }, 3e3), d({
        title: "Success",
        text: "The customer creation was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), s("shopify:profile:created"), r(!1));
    }
  }), X = ot(
    (O) => {
      a(!0), u(void 0), Q({
        variables: {
          input: {
            firstName: O.firstName,
            lastName: O.lastName,
            ...g && { email: O.email },
            ...S && { phone: O.phone },
            ...O.smsMarketingState && {
              smsMarketingConsent: {
                marketingState: O.smsMarketingState,
                marketingOptInLevel: O.smsMarketingOptInLevel
              }
            }
          }
        }
      });
    },
    [Q, a, S, g]
  ), B = () => {
    r(!1), ae(), u(void 0), U.reset(T);
  };
  return /* @__PURE__ */ k.jsxs(Tt, { isOpen: n, onClose: B, className: Bu.modal, children: [
    /* @__PURE__ */ k.jsx($t, { title: "Create new customer", onClose: B }),
    /* @__PURE__ */ k.jsx(Dt, { children: /* @__PURE__ */ k.jsxs(st, { children: [
      /* @__PURE__ */ k.jsx(be, { span: 3, children: /* @__PURE__ */ k.jsx(
        tt,
        {
          label: "First name",
          name: "firstName",
          control: U.control,
          rules: {
            required: "First name is required"
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(be, { span: 3, children: /* @__PURE__ */ k.jsx(
        tt,
        {
          label: "Last name",
          name: "lastName",
          control: U.control,
          rules: {
            required: "Last name is required"
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsx(
        tt,
        {
          label: "Email",
          name: "email",
          control: U.control,
          rules: {
            required: g ? "Email is required" : void 0
          },
          componentProps: {
            className: it({
              [Bu.disabled]: !g
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ k.jsx(
                im,
                {
                  disabled: !S,
                  name: "hasEmail",
                  value: "email",
                  checked: g,
                  onChange: () => C()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsx(
        tt,
        {
          label: "Phone",
          name: "phone",
          control: U.control,
          rules: {
            required: S ? "Phone is required" : void 0
          },
          componentProps: {
            className: it({
              [Bu.disabled]: !S
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ k.jsx(
                im,
                {
                  disabled: !g,
                  name: "hasPhone",
                  value: "phone",
                  checked: S,
                  onChange: () => N()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsx(
        jr,
        {
          control: U.control,
          label: "SMS marketing state",
          name: "smsMarketingState",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing state"
            }
          },
          componentProps: {
            placeholder: "Select a marketing state",
            equalityFn: (O, q) => O === q,
            getItemTitleByValue: (O) => {
              const q = qk.find(
                (ee) => ee.value === O
              );
              return /* @__PURE__ */ k.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: q.label }),
                    /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: q.description })
                  ]
                }
              );
            }
          },
          children: qk.map((O) => /* @__PURE__ */ k.jsx(ut.Item, { value: O.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: O.label }),
            /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: O.description })
          ] }) }, O.value))
        }
      ) }),
      /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsx(
        jr,
        {
          control: U.control,
          label: "SMS marketing opt-in level",
          name: "smsMarketingOptInLevel",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing opt-in level"
            }
          },
          componentProps: {
            placeholder: "Select a marketing opt-in level",
            equalityFn: (O, q) => O === q,
            getItemTitleByValue: (O) => {
              const q = Bk.find(
                (ee) => ee.value === O
              );
              return /* @__PURE__ */ k.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: q.label }),
                    /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: q.description })
                  ]
                }
              );
            }
          },
          children: Bk.map((O) => /* @__PURE__ */ k.jsx(ut.Item, { value: O.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: O.label }),
            /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: O.description })
          ] }) }, O.value))
        }
      ) }),
      w && /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(pe, { name: "close-circle-filled", color: "red.500" }),
        /* @__PURE__ */ k.jsx(P.Paragraph, { children: m })
      ] }) })
    ] }) }),
    /* @__PURE__ */ k.jsx(
      At,
      {
        confirmProps: {
          disabled: !(U.formState.isValid && U.formState.isDirty),
          isLoading: i,
          loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 })
        },
        confirmOnClick: U.handleSubmit(X),
        cancelOnClick: B,
        confirmName: J ? "Close" : "Save",
        cancelName: J ? void 0 : "Cancel"
      }
    )
  ] });
}, Pz = ({
  conversationContext: e,
  refetchCustomer: n
}) => {
  const [r, i] = le(!1), [a, o] = le(!1);
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsx(
      Gn,
      {
        variant: "secondary",
        onClick: () => i(!0),
        isLoading: a,
        loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 }),
        slotStart: /* @__PURE__ */ k.jsx(pe, { size: 14, name: "user-plus", color: "green.500" }),
        className: Ot.fullWidth,
        children: "Create new Shopify profile"
      }
    ),
    /* @__PURE__ */ k.jsx(
      Az,
      {
        isOpen: r,
        setIsOpen: i,
        isMutationLoading: a,
        setIsMutationLoading: o,
        conversationContext: e,
        refetchCustomer: n
      }
    )
  ] });
}, Hp = (e) => {
  const n = e?.match(/shopify\/\w+\/(\d+)/);
  return n ? n[1] : null;
}, Dm = "DD MMM YYYY @ HH:mm", Lz = "_wrapper_10fld_1", Vz = "_copyIcon_10fld_7", ts = {
  wrapper: Lz,
  copyIcon: Vz
}, zz = ({
  customer: e,
  shopifyDomain: n,
  refresh: r,
  loading: i,
  networkStatus: a
}) => {
  const { isCopied: o, copy: s } = Ar(), { isCopied: l, copy: d } = Ar(), { track: m } = _n();
  if (!e)
    return null;
  const {
    id: u,
    displayName: f,
    defaultEmailAddress: h,
    defaultPhoneNumber: g,
    tags: C = [],
    verifiedEmail: S
  } = e, N = h?.emailAddress, w = g?.phoneNumber, y = Hp(u), z = `https://${n}/admin/customers/${y ?? ""}`, $ = i && a === er.refetch, I = 14;
  return /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { className: ts.wrapper, gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: f }),
        $ ? /* @__PURE__ */ k.jsx(un, { size: I }) : /* @__PURE__ */ k.jsx(We, { content: "Reload customer", children: /* @__PURE__ */ k.jsx(
          pe,
          {
            size: I,
            name: "sync",
            onClick: () => {
              m("shopify:refreshed", { shopifyId: u }), r();
            },
            className: ts.copyIcon
          }
        ) })
      ] }),
      N && /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(pe, { size: I, name: "mail" }),
          /* @__PURE__ */ k.jsx(P.ExternalLink, { href: `mailto:${N}`, children: N }),
          /* @__PURE__ */ k.jsx(
            We,
            {
              content: S ? "Verified email" : "Email is not verified",
              children: /* @__PURE__ */ k.jsx(b, { alignItems: "center", children: /* @__PURE__ */ k.jsx(
                pe,
                {
                  size: I,
                  color: S ? "green.500" : "red.500",
                  name: S ? "check-circle" : "exclamation"
                }
              ) })
            }
          )
        ] }),
        /* @__PURE__ */ k.jsx(We, { content: "Copy Email", children: /* @__PURE__ */ k.jsx(
          pe,
          {
            size: I,
            name: o ? "done" : "copy",
            onClick: () => s(N),
            className: ts.copyIcon
          }
        ) })
      ] }),
      w && /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ k.jsx(pe, { size: I, name: "phone" }),
          /* @__PURE__ */ k.jsx(P.ExternalLink, { href: `tel:${w}`, children: w })
        ] }),
        /* @__PURE__ */ k.jsx(We, { content: "Copy phone number", children: /* @__PURE__ */ k.jsx(
          pe,
          {
            size: I,
            name: l ? "done" : "copy",
            onClick: () => d(w),
            className: ts.copyIcon
          }
        ) })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ k.jsx(pe, { size: I, name: "external-link" }),
        /* @__PURE__ */ k.jsx(
          P.ExternalLink,
          {
            href: z,
            target: "_blank",
            rel: "noreferrer",
            children: "View customer in Shopify"
          }
        )
      ] })
    ] }),
    C.length > 0 && /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
      /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: "Tags" }),
      /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: C.map((T) => /* @__PURE__ */ k.jsx(Pn, { children: T }, `${u}-${T}`)) })
    ] })
  ] });
}, Uz = "_creationModal_pbe64_1", Mz = "_detailsModal_pbe64_5", Bz = "_percentageSuffix_pbe64_9", qu = {
  creationModal: Uz,
  detailsModal: Mz,
  percentageSuffix: Bz
}, qz = () => {
  const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  return Array.from(
    { length: 12 },
    () => e.charAt(Math.floor(Math.random() * e.length))
  ).join("");
}, Hz = (e) => {
  const n = e.customerGetsOption === "percentage" ? e.customerGets / 100 : e.customerGets, r = (() => {
    switch (e.minimumRequirementOption) {
      case "quantity":
        return "greaterThanOrEqualToQuantity";
      case "subtotal":
        return "greaterThanOrEqualToSubtotal";
      case "none":
      default:
        return null;
    }
  })(), i = e.maximumUsage;
  return {
    code: e.code,
    title: e.title,
    usageLimit: i === "only-once" ? 1 : null,
    appliesOncePerCustomer: i === "once-per-customer",
    customerGets: {
      value: {
        [e.customerGetsOption]: e.customerGetsOption === "discountAmount" ? { amount: n } : n
      },
      items: {
        all: !0
      }
    },
    context: {
      all: kS.All
    },
    ...r && {
      minimumRequirement: {
        [e.minimumRequirementOption]: {
          [r]: e.minimumRequirementOption === "quantity" ? e.minimumRequirementValue?.toString() : e.minimumRequirementValue
        }
      }
    },
    startsAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}, Hk = [
  {
    label: "Percentage",
    description: "The percentage value of the discount.",
    value: "percentage"
  },
  {
    label: "Amount",
    description: "The value of the discount.",
    value: "discountAmount"
  }
], Wk = [
  {
    label: "None",
    description: "No minimum requirements.",
    value: "none"
  },
  {
    label: "Quantity",
    description: "Minimum required quantity of items.",
    value: "quantity"
  },
  {
    label: "Subtotal",
    description: "Minimum required order subtotal.",
    value: "subtotal"
  }
], Gk = [
  {
    label: "No limit",
    value: "no-limit",
    description: "The discount code can be used unlimited times."
  },
  {
    label: "Only once",
    value: "only-once",
    description: "The discount code can only be used once."
  },
  {
    label: "Once per customer",
    value: "once-per-customer",
    description: "The discount code can be used once per customer."
  }
], Wz = ({
  codeDiscount: e
}) => {
  const n = e?.codes?.nodes?.[0]?.code, { isCopied: r, copy: i } = or(), a = e?.usageLimit ? `${e?.usageLimit} uses remaining` : "No limit";
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "400", children: [
    /* @__PURE__ */ k.jsxs(Ye, { children: [
      /* @__PURE__ */ k.jsx(Ye.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "1", children: "Title" }),
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "2", color: "secondary", children: e?.title })
      ] }) }),
      /* @__PURE__ */ k.jsx(Ye.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "1", children: "Status" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ k.jsx(
            pe,
            {
              name: e?.status === "ACTIVE" ? "check-circle-filled" : "circle-filled",
              color: e?.status === "ACTIVE" ? "green.500" : "neutral.500"
            }
          ),
          /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "2", color: "secondary", children: e?.status })
        ] })
      ] }) }),
      /* @__PURE__ */ k.jsx(Ye.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "1", children: "Usage limit" }),
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "2", color: "secondary", children: a })
      ] }) }),
      /* @__PURE__ */ k.jsx(Ye.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "1", children: "Applies once per customer" }),
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "2", color: "secondary", children: e?.appliesOncePerCustomer ? "Yes" : "No" })
      ] }) }),
      /* @__PURE__ */ k.jsx(Ye.Text, { children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "1", children: "Starts at" }),
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "2", color: "secondary", children: Ln(e?.startsAt).format(xt) })
      ] }) })
    ] }),
    /* @__PURE__ */ k.jsx(ln, { label: "Discount code", children: /* @__PURE__ */ k.jsx(
      Nr,
      {
        readOnly: !0,
        value: n,
        suffix: {
          type: "button",
          button: {
            icon: r ? "done" : "copy",
            onClick: () => {
              i(n);
            }
          }
        }
      }
    ) })
  ] });
}, Gz = "shopify-discount-code-form", Kk = {
  title: "",
  code: "",
  customerGets: void 0,
  customerGetsOption: "percentage",
  minimumRequirementOption: "none",
  minimumRequirementValue: void 0,
  maximumUsage: "only-once"
}, Kz = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { track: r } = _n(), { useMutation: i, showNotification: a } = hn(), [o, s] = le(
    []
  ), [l, d] = le(), m = _t({
    mode: "all",
    defaultValues: Kk
  });
  He(() => {
    o?.forEach((I) => {
      const T = I?.field?.[1];
      T && m.setError(T, {
        type: "server",
        message: I.message
      });
    });
  }, [o, m]);
  const u = !!l, f = m.watch("minimumRequirementOption"), h = m.watch("customerGetsOption"), g = Bn(() => {
    switch (f) {
      case "quantity":
        return "Minimum quantity";
      case "subtotal":
        return "Minimum subtotal";
      case "none":
      default:
        return "";
    }
  }, [f]), [
    C,
    {
      loading: S,
      error: N,
      reset: w
    }
  ] = i(wz, {
    onError: () => {
      a({
        title: "Something went wrong",
        text: "The discount code creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (I) => {
      const T = I?.Shopify?.discountCodeBasicCreate?.userErrors;
      if (T && T.length > 0)
        s(T);
      else {
        const U = I?.Shopify?.discountCodeBasicCreate?.codeDiscountNode?.codeDiscount;
        U && "codes" in U && d(U), a({
          title: "Success",
          text: "The discount code was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), r("shopify:discount:code:created"), s([]);
      }
    }
  }), y = () => {
    m.setValue("code", qz(), {
      shouldDirty: !0,
      shouldValidate: !0,
      shouldTouch: !0
    });
  }, z = (I) => {
    C({
      variables: {
        input: Hz(I)
      }
    });
  }, $ = () => {
    m.reset(Kk), s([]), w(), d(void 0), n(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    Tt,
    {
      isOpen: e,
      onClose: $,
      className: it({
        [qu.creationModal]: !u,
        [qu.detailsModal]: u
      }),
      children: [
        /* @__PURE__ */ k.jsx(
          $t,
          {
            title: u ? "Discount code details" : "Create new discount code",
            onClose: $
          }
        ),
        /* @__PURE__ */ k.jsxs(Dt, { children: [
          u && /* @__PURE__ */ k.jsx(Wz, { codeDiscount: l }),
          !u && /* @__PURE__ */ k.jsxs("form", { noValidate: !0, id: Gz, onSubmit: m.handleSubmit(z), children: [
            /* @__PURE__ */ k.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ k.jsx(
              Gs,
              {
                variant: "info",
                description: /* @__PURE__ */ k.jsx(P.Paragraph, { children: "This code will be eligible for all customers." })
              }
            ) }),
            /* @__PURE__ */ k.jsxs(st, { children: [
              /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsx(
                tt,
                {
                  label: "Title",
                  name: "title",
                  control: m.control,
                  rules: {
                    required: "Please enter a title"
                  },
                  componentProps: {
                    placeholder: "Enter a title"
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(be, { span: 3, children: /* @__PURE__ */ k.jsx(
                jr,
                {
                  control: m.control,
                  label: "Discount type",
                  name: "customerGetsOption",
                  rules: {
                    required: "Please select a discount type"
                  },
                  componentProps: {
                    placeholder: "Select a discount type",
                    equalityFn: (I, T) => I === T,
                    onChange: () => {
                      m.setValue("customerGets", void 0), m.clearErrors("customerGets");
                    },
                    getItemTitleByValue: (I) => {
                      const T = Hk.find(
                        (U) => U.value === I
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: T?.label }) });
                    }
                  },
                  children: Hk.map((I) => /* @__PURE__ */ k.jsx(ut.Item, { value: I.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: I.label }),
                    /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: I.description })
                  ] }) }, I.value))
                }
              ) }),
              /* @__PURE__ */ k.jsx(be, { span: 3, children: /* @__PURE__ */ k.jsx(
                tt,
                {
                  label: "Discount value",
                  name: "customerGets",
                  control: m.control,
                  rules: {
                    required: "Please enter a value",
                    validate: (I) => {
                      if (I) {
                        if (h === "percentage" && (I < 0 || I > 100))
                          return "Percentage must be between 0 and 100";
                        if (h === "discountAmount" && I < 0)
                          return "Discount amount must be greater than 0";
                      }
                    }
                  },
                  componentProps: {
                    placeholder: "Enter a value",
                    type: "number",
                    ...h === "percentage" && {
                      suffix: {
                        type: "custom",
                        noWrap: !0,
                        value: /* @__PURE__ */ k.jsx(
                          b,
                          {
                            alignItems: "center",
                            className: qu.percentageSuffix,
                            children: "%"
                          }
                        )
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsx(
                tt,
                {
                  label: "Code",
                  name: "code",
                  control: m.control,
                  rules: {
                    required: "Please enter a code"
                  },
                  componentProps: {
                    placeholder: "Enter a code or click to the right to generate",
                    suffix: {
                      type: "button",
                      button: {
                        icon: "sync",
                        onClick: y
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(be, { span: 3, children: /* @__PURE__ */ k.jsx(
                jr,
                {
                  control: m.control,
                  label: "Minimum purchase requirements",
                  name: "minimumRequirementOption",
                  rules: {
                    required: "Please select a minimum requirement option"
                  },
                  componentProps: {
                    placeholder: "Select a minimum purchase requirement",
                    equalityFn: (I, T) => I === T,
                    onChange: () => {
                      m.setValue("minimumRequirementValue", void 0), m.clearErrors("minimumRequirementValue");
                    },
                    getItemTitleByValue: (I) => {
                      const T = Wk.find(
                        (U) => U.value === I
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: T?.label }) });
                    }
                  },
                  children: Wk.map((I) => /* @__PURE__ */ k.jsx(ut.Item, { value: I.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: I.label }),
                    /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: I.description })
                  ] }) }, I.value))
                }
              ) }),
              /* @__PURE__ */ k.jsx(be, { span: 3, children: /* @__PURE__ */ k.jsx(
                tt,
                {
                  name: "minimumRequirementValue",
                  label: g,
                  control: m.control,
                  disabled: f === "none",
                  rules: {
                    required: {
                      value: f !== "none",
                      message: "Please enter a value"
                    },
                    validate: (I) => {
                      if (I && f !== "none" && I < 0)
                        return `Minimum ${f} must be greater than 0`;
                    }
                  },
                  componentProps: {
                    type: "number",
                    placeholder: "Enter a value"
                  }
                }
              ) }),
              /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsx(
                jr,
                {
                  name: "maximumUsage",
                  label: "Maximum usage",
                  control: m.control,
                  componentProps: {
                    placeholder: "Select a maximum usage",
                    equalityFn: (I, T) => I === T,
                    getItemTitleByValue: (I) => {
                      const T = Gk.find(
                        (U) => U.value === I
                      );
                      return /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: T?.label }) });
                    }
                  },
                  children: Gk.map((I) => /* @__PURE__ */ k.jsx(ut.Item, { value: I.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: I.label }),
                    /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: I.description })
                  ] }) }, I.value))
                }
              ) })
            ] })
          ] }),
          N && /* @__PURE__ */ k.jsx(Fn, { error: N })
        ] }),
        /* @__PURE__ */ k.jsx(
          At,
          {
            confirmProps: {
              disabled: !u && !(m.formState.isValid && m.formState.isDirty),
              isLoading: S,
              loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 })
            },
            confirmName: u ? "Close" : "Save",
            confirmOnClick: u ? $ : m.handleSubmit(z),
            cancelOnClick: u ? void 0 : $
          }
        )
      ]
    }
  );
}, Yz = ({ code: e }) => {
  const { isCopied: n, copy: r } = Ar();
  return /* @__PURE__ */ k.jsxs(
    b,
    {
      justifyContent: "space-between",
      alignItems: "center",
      gap: "200",
      width: "100%",
      children: [
        /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ k.jsx(pe, { size: 12, name: "shopify", color: "green.500" }),
          /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", children: e })
        ] }),
        /* @__PURE__ */ k.jsx(
          nr,
          {
            icon: n ? "done" : "copy",
            onClick: () => r(e),
            variant: "secondary"
          }
        )
      ]
    }
  );
}, Qz = ({
  discountCode: e
}) => {
  const { codeDiscount: n } = e;
  if (!("codes" in n))
    return null;
  const r = "summary" in n, i = n?.codes?.nodes ?? [];
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
    /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: n.title }),
    r && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", color: "tertiary", children: n.summary }),
    /* @__PURE__ */ k.jsx(Ye, { children: i.map((a) => /* @__PURE__ */ k.jsx(Ye.Item, { className: Ot.listItem, children: /* @__PURE__ */ k.jsx(Yz, { code: a.code }, a.id) }, a.id)) })
  ] });
}, Jz = "_modal_11d6e_1", Xz = "_modalBody_11d6e_4", Zz = "_codeContainer_11d6e_9", Hu = {
  modal: Jz,
  modalBody: Xz,
  codeContainer: Zz
}, e3 = [50, 100, 250], _S = 50, n3 = {
  maxNumberOfCodesToDisplay: _S
}, t3 = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { useQuery: r } = hn(), [i, a] = le(
    _S
  ), [o, s] = le([]), l = o.length === 0, d = o.length > i, m = _t({
    mode: "all",
    defaultValues: n3
  }), { loading: u, error: f } = r(bz, {
    variables: {
      first: i
    },
    onCompleted: (g) => {
      const C = g?.Shopify?.codeDiscountNodes?.nodes ?? [];
      C && C.length > 0 && s(C);
    }
  }), h = () => {
    n(!1);
  };
  return /* @__PURE__ */ k.jsxs(Tt, { isOpen: e, onClose: h, className: Hu.modal, children: [
    /* @__PURE__ */ k.jsx($t, { title: "Discount codes", onClose: h }),
    /* @__PURE__ */ k.jsxs(Dt, { className: Hu.modalBody, children: [
      d && /* @__PURE__ */ k.jsx(st, { children: /* @__PURE__ */ k.jsx(be, { span: 3, children: /* @__PURE__ */ k.jsx(
        jr,
        {
          control: m.control,
          label: "Number of codes to display",
          name: "maxNumberOfCodesToDisplay",
          componentProps: {
            placeholder: "Select a number of codes to display",
            onChange: (g) => {
              a(g.selectedValues[0]);
            },
            getItemTitleByValue: (g) => /* @__PURE__ */ k.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: g }) })
          },
          children: e3.map((g) => /* @__PURE__ */ k.jsx(ut.Item, { value: g, children: /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: g }) }, g))
        }
      ) }) }),
      u && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(un, {}) }),
      f && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(P.Paragraph, { children: "Something went wrong while fetching discount codes." }) }),
      !u && l && /* @__PURE__ */ k.jsx(
        Ns,
        {
          title: "No discount codes found.",
          description: "There are no discount codes to display. You can create a new discount code with the 'Create new' button in our integration."
        }
      ),
      !u && !f && !l && o.map((g) => /* @__PURE__ */ k.jsx("div", { className: Hu.codeContainer, children: /* @__PURE__ */ k.jsx(Qz, { discountCode: g }) }, g.id))
    ] }),
    /* @__PURE__ */ k.jsx(At, { confirmName: "Close", confirmOnClick: h })
  ] });
}, r3 = ({
  displayDiscountCodeCreation: e
}) => {
  const [n, r] = le(!1), [i, a] = le(!1);
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: "Discount codes" }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", width: "100%", children: [
        /* @__PURE__ */ k.jsx(b, { flex: "1", children: /* @__PURE__ */ k.jsx(
          Gn,
          {
            variant: "secondary",
            icon: "gift",
            onClick: () => a(!0),
            style: { width: "100%" },
            children: "View discount codes"
          }
        ) }),
        e && /* @__PURE__ */ k.jsx(b, { flex: "1", children: /* @__PURE__ */ k.jsx(
          Gn,
          {
            variant: "secondary",
            icon: "plus",
            onClick: () => r(!0),
            style: { width: "100%" },
            children: "Create new"
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsx(
      t3,
      {
        isOpen: i,
        setIsOpen: a
      }
    ),
    /* @__PURE__ */ k.jsx(
      Kz,
      {
        isOpen: n,
        setIsOpen: r
      }
    )
  ] });
}, i3 = ({
  customer: e
}) => {
  if (!e)
    return null;
  const { defaultEmailAddress: n, defaultPhoneNumber: r } = e, i = (h) => h ? Gb(h.replaceAll("_", " ")) : "No state available", a = (h) => {
    switch (h) {
      case Qi.Invalid:
      case Qi.NotSubscribed:
      case $r.NotSubscribed:
        return "red.500";
      case Qi.Pending:
      case $r.Pending:
      case Qi.Unsubscribed:
      case $r.Unsubscribed:
        return "orange.500";
      case Qi.Subscribed:
      case $r.Subscribed:
        return "green.500";
      default:
        return "neutral.500";
    }
  }, o = (h) => {
    switch (h) {
      case Si.SingleOptIn:
      case Si.ConfirmedOptIn:
        return "green.500";
      case Si.Unknown:
      default:
        return "neutral.200";
    }
  }, {
    marketingState: s,
    marketingUpdatedAt: l,
    marketingOptInLevel: d
  } = n ?? {}, {
    marketingState: m,
    marketingUpdatedAt: u,
    marketingOptInLevel: f
  } = r ?? {};
  return /* @__PURE__ */ k.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: "Marketing consent" }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(pe, { name: "mail", color: "neutral.500" }),
        /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-4", children: "Email" })
      ] }),
      l && /* @__PURE__ */ k.jsx(We, { content: "Last updated at", children: /* @__PURE__ */ k.jsx(An, { size: "small", variant: "info", children: Ln(l).format(Dm) }) }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(We, { content: "Opt-In state", children: /* @__PURE__ */ k.jsx(Pn, { color: o(d), children: i(d) }) }),
        /* @__PURE__ */ k.jsx(We, { content: "Marketing state", children: /* @__PURE__ */ k.jsx(Pn, { color: a(s), children: i(s) }) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
        /* @__PURE__ */ k.jsx(pe, { name: "phone", color: "neutral.500" }),
        /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-4", children: "Phone" })
      ] }),
      u && /* @__PURE__ */ k.jsx(We, { content: "Last updated at", children: /* @__PURE__ */ k.jsx(An, { size: "small", variant: "info", children: Ln(u).format(Dm) }) }),
      /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(We, { content: "Opt-In state", children: /* @__PURE__ */ k.jsx(Pn, { color: o(f), children: i(f) }) }),
        /* @__PURE__ */ k.jsx(We, { content: "Marketing state", children: /* @__PURE__ */ k.jsx(Pn, { color: a(m), children: i(m) }) })
      ] })
    ] })
  ] });
}, a3 = ({
  ordersData: e
}) => {
  const n = (r) => r?.fulfillments?.length > 0 ? r.fulfillments[0].trackingInfo : [];
  return e.map(({ node: r }) => ({
    id: r.id,
    name: r.name,
    createdAt: new Date(r.createdAt),
    cancelledAt: r.cancelledAt ? new Date(r.cancelledAt) : void 0,
    status: `${r.displayFulfillmentStatus?.toLowerCase()}, ${r.displayFinancialStatus?.toLowerCase()}${r.cancelledAt ? ", cancelled" : ""}`,
    displayFinancialStatus: r.displayFinancialStatus,
    currentTotalPriceSet: r.currentTotalPriceSet,
    value: r.netPaymentSet?.presentmentMoney?.amount,
    currencyCode: r.netPaymentSet?.presentmentMoney?.currencyCode,
    shippingAddress: r.shippingAddress,
    billingAddress: r.billingAddress,
    lineItems: r.lineItems?.edges?.map(({ node: i }) => i),
    suggestedRefund: {
      orderId: r.id,
      amount: r.suggestedRefund?.amountSet?.presentmentMoney?.amount,
      currency: r.suggestedRefund?.amountSet?.presentmentMoney?.currencyCode,
      notify: !0,
      refundLineItems: r.suggestedRefund?.refundLineItems.map(
        ({ lineItem: i }) => ({
          lineItemId: i.id,
          quantity: i.quantity
        })
      ),
      transactions: r.suggestedRefund?.suggestedTransactions?.map(
        ({ amountSet: i, gateway: a, parentTransaction: o }) => ({
          amount: i?.presentmentMoney?.amount || "0.00",
          gateway: a ?? "",
          kind: bS.Refund,
          orderId: r.id,
          parentId: o?.id
        })
      ),
      shipping: {
        fullRefund: !0
      }
    },
    trackingInfos: n(r),
    shippingLines: r.shippingLines?.edges?.map(({ node: i }) => i),
    tags: r.tags,
    refunds: r.refunds
  }));
}, Yk = [
  {
    value: Gr.Pending,
    label: "Pending",
    description: "The payment is pending"
  },
  {
    value: Gr.Authorized,
    label: "Authorized",
    description: "The payment has been authorized but not captured"
  },
  {
    value: Gr.Paid,
    label: "Paid",
    description: "The payment has been completed"
  },
  {
    value: Gr.PartiallyPaid,
    label: "Partially Paid",
    description: "The payment has been partially completed"
  },
  {
    value: Gr.Refunded,
    label: "Refunded",
    description: "The payment has been refunded"
  },
  {
    value: Gr.Voided,
    label: "Voided",
    description: "The payment has been voided"
  },
  {
    value: Gr.PartiallyRefunded,
    label: "Partially Refunded",
    description: "The payment has been partially refunded"
  }
], Qk = [
  {
    value: bs.Fulfilled,
    label: "Fulfilled",
    description: "Every line item in the order has been fulfilled"
  },
  {
    value: bs.Partial,
    label: "Partial",
    description: "At least one line item in the order has been fulfilled"
  },
  {
    value: bs.Restocked,
    label: "Restocked",
    description: "Every line item in the order has been restocked and the order canceled"
  }
], SS = (e) => e.length === 0 ? "" : e.map((n) => `id:${n.split("/").pop()}`).join(" OR "), Ji = (e) => o3(s3(e)), o3 = (e) => Object.fromEntries(
  Object.entries(e ?? {}).filter(([, n]) => n != null)
), s3 = (e) => {
  const n = e;
  if (typeof n == "object" && "countryCodeV2" in n) {
    const { countryCodeV2: r, ...i } = n;
    return {
      ...i,
      ...r && { countryCode: r }
    };
  }
  return e;
}, ui = ({
  control: e,
  name: n,
  label: r,
  placeholder: i,
  required: a = !1,
  apiUserError: o
}) => /* @__PURE__ */ k.jsx(
  Wt,
  {
    name: n,
    control: e,
    rules: {
      required: a ? {
        value: !0,
        message: "This field is required"
      } : !1
    },
    render: ({ field: s, fieldState: l }) => /* @__PURE__ */ k.jsx(
      pr,
      {
        required: a,
        label: r,
        input: s,
        placeholder: i,
        meta: {
          warning: l?.error?.message,
          error: l?.error?.message || o?.[s.name]
        }
      }
    )
  }
), l3 = "_modal_1wlra_1", c3 = {
  modal: l3
};
function Jk(e) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      e.toUpperCase()
    ) ?? e;
  } catch {
    return e;
  }
}
const Xk = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], Zk = "shopify-shiping-address-form", d3 = ({
  title: e,
  address: n,
  isOpen: r,
  setIsOpen: i,
  orderId: a,
  shopifyId: o,
  shippingCountryCodes: s,
  onChange: l,
  refetchOrders: d
}) => {
  const { useMutation: m, showNotification: u } = hn(), { track: f } = _n(), [h, g] = le(!1), [C, S] = le({}), N = !l, [
    w,
    { error: y, reset: z }
  ] = m(xz, {
    onError: () => {
      g(!1), u({
        title: "Something went wrong",
        text: "The address change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (X) => {
      g(!1);
      const B = X?.Shopify?.orderUpdate?.userErrors;
      if (B != null && B.length > 0) {
        const O = B.reduce(
          (q, ee) => {
            const ve = ee.field;
            if (ve == null || ve.length === 0)
              return q;
            const ue = ve[ve.length - 1];
            return ue != null && (q[ue] = ee.message), q;
          },
          {}
        );
        S(O);
      } else
        u({
          title: "Success",
          text: "The address change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), d(), ae();
    }
  }), $ = ot(
    () => ({
      firstName: n?.firstName || "",
      lastName: n?.lastName || "",
      company: n?.company || "",
      address1: n?.address1 || "",
      address2: n?.address2 || "",
      city: n?.city || "",
      countryCodeV2: Xk.find(
        (X) => X === n?.countryCodeV2
      ),
      provinceCode: n?.province || "",
      zip: n?.zip || ""
    }),
    [n]
  ), { control: I, handleSubmit: T, formState: U, reset: Q } = _t({
    mode: "all",
    defaultValues: $()
  }), J = T((X) => {
    if (N) {
      if (g(!0), !o || !a) {
        g(!1);
        return;
      }
      f("shopify:order:edit:shipping:address:modal:submitted", {
        shopifyId: o,
        orderId: a
      });
      const { countryCodeV2: B, ...O } = X, q = {
        ...O,
        countryCode: B
      };
      w({
        variables: {
          input: {
            id: a,
            shippingAddress: q
          }
        }
      });
    } else
      l(X), ae();
  });
  He(() => {
    r && Q($());
  }, [r, n, Q, $]);
  const ae = () => {
    Q($()), S({}), z(), i(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    Tt,
    {
      isOpen: r,
      onClose: ae,
      className: c3.modal,
      "data-testid": "edit-shipping-address-modal",
      children: [
        /* @__PURE__ */ k.jsx($t, { title: e, onClose: () => ae() }),
        /* @__PURE__ */ k.jsx(Dt, { children: /* @__PURE__ */ k.jsxs("form", { noValidate: !0, id: Zk, onSubmit: J, children: [
          y && /* @__PURE__ */ k.jsx(Fn, { error: y }),
          /* @__PURE__ */ k.jsxs(st, { children: [
            /* @__PURE__ */ k.jsx(be, { span: 3, children: /* @__PURE__ */ k.jsx(
              ui,
              {
                required: !0,
                control: I,
                name: "firstName",
                label: "First name",
                placeholder: "Insert your first name",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ k.jsx(be, { span: 3, children: /* @__PURE__ */ k.jsx(
              ui,
              {
                required: !0,
                control: I,
                name: "lastName",
                label: "Last name",
                placeholder: "Insert your last name",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ k.jsx(be, { span: 6, children: /* @__PURE__ */ k.jsx(
              ui,
              {
                control: I,
                name: "company",
                label: "Company",
                placeholder: "Insert your company name"
              }
            ) }),
            /* @__PURE__ */ k.jsx(be, { span: 6, children: /* @__PURE__ */ k.jsx(
              ui,
              {
                required: !0,
                control: I,
                name: "address1",
                label: "Address",
                placeholder: "Insert your address",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ k.jsx(be, { span: 6, children: /* @__PURE__ */ k.jsx(
              ui,
              {
                control: I,
                name: "address2",
                label: "Additional address details",
                placeholder: "Insert more address details"
              }
            ) }),
            /* @__PURE__ */ k.jsx(be, { span: 3, children: /* @__PURE__ */ k.jsx(
              ui,
              {
                required: !0,
                control: I,
                name: "zip",
                label: "Zip / postal code",
                placeholder: "Insert your zip / postal code",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ k.jsx(be, { span: 3, children: /* @__PURE__ */ k.jsx(
              ui,
              {
                required: !0,
                control: I,
                name: "city",
                label: "City",
                placeholder: "Insert your city",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ k.jsx(be, { span: 6, children: /* @__PURE__ */ k.jsx(
              jr,
              {
                name: "countryCodeV2",
                control: I,
                label: "Country",
                rules: {
                  required: {
                    value: !0,
                    message: "Please select a country"
                  }
                },
                componentProps: {
                  placeholder: "Select your country",
                  getItemTitleByValue: (X) => X ? Jk(X) : ""
                },
                children: Xk.filter((X) => s.includes(X)).map((X) => /* @__PURE__ */ k.jsx(ut.Item, { value: X, children: /* @__PURE__ */ k.jsx(P.Paragraph, { children: Jk(X) }) }, X))
              }
            ) })
          ] })
        ] }) }),
        /* @__PURE__ */ k.jsx(
          At,
          {
            confirmProps: {
              disabled: !(U.isValid && U.isDirty),
              type: "submit",
              form: Zk,
              isLoading: h,
              loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 })
            },
            confirmOnClick: () => {
              y && ae();
            },
            cancelOnClick: () => {
              o && a && !y && f("shopify:order:edit:shipping:address:modal:canceled", {
                shopifyId: o,
                orderId: a
              }), ae();
            },
            confirmName: y ? "Close" : "Save",
            cancelName: y ? void 0 : "Cancel"
          }
        )
      ]
    }
  );
}, u3 = "_clickableIcon_33mqm_1", Wu = {
  clickableIcon: u3
}, eb = ({
  formFieldName: e,
  ...n
}) => {
  const r = Vr(), { field: i } = sp({
    control: r.control,
    name: e
  });
  return /* @__PURE__ */ k.jsx(
    Rm,
    {
      enableEditAddress: !0,
      openByDefault: !0,
      onChange: i.onChange,
      ...n
    }
  );
}, Rm = ({
  labelText: e,
  address: n,
  orderId: r,
  shopifyId: i,
  shippingCountryCodes: a,
  enableEditAddress: o,
  icon: s = "home",
  onChange: l,
  refetchOrders: d,
  openByDefault: m = !1
}) => {
  const [u, f] = le(!1), [h, g] = le(m), { isCopied: C, copy: S } = Ar(), { track: N } = _n(), w = 14, y = o && (!!r || !!l), z = [n?.zip || "", n?.city || ""].filter(Boolean).join(" "), $ = [n?.firstName || "", n?.lastName || ""].filter(Boolean).join(" "), I = n?.countryCodeV2 && v0(n.countryCodeV2), T = ot(() => [
    $,
    n?.company,
    n?.address1,
    n?.address2,
    z,
    n?.province,
    I
  ].filter(Boolean).join(`
`), [n, $, z, I]);
  if (!n)
    return null;
  const U = () => {
    i && r && N("shopify:order:edit:shipping:address:modal:opened", {
      shopifyId: i,
      orderId: r
    }), f(!0);
  };
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(pe, { size: w, name: s, color: "green.500" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "row",
              onClick: () => g(!h),
              className: Wu.clickableIcon,
              alignItems: "center",
              children: [
                /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", children: e }),
                /* @__PURE__ */ k.jsx(
                  pe,
                  {
                    size: w,
                    name: h ? "angle-down" : "angle-right"
                  }
                )
              ]
            }
          ),
          h && /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
            $ && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: $ }),
            n?.company && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: n.company }),
            n?.address1 && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: n.address1 }),
            n?.address2 && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: n.address2 }),
            z && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: z }),
            n?.province && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: n.province }),
            I && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: I })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        y && /* @__PURE__ */ k.jsx(We, { content: `Edit ${e.toLowerCase()}`, children: /* @__PURE__ */ k.jsx(
          pe,
          {
            size: w,
            name: "pen",
            onClick: () => U(),
            className: Wu.clickableIcon
          }
        ) }),
        /* @__PURE__ */ k.jsx(We, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ k.jsx(
          pe,
          {
            size: w,
            name: C ? "done" : "copy",
            onClick: () => S(T()),
            className: Wu.clickableIcon
          }
        ) })
      ] })
    ] }),
    y && /* @__PURE__ */ k.jsx(
      d3,
      {
        title: `Edit ${e}`,
        address: n,
        isOpen: u,
        setIsOpen: f,
        orderId: r,
        shopifyId: i,
        shippingCountryCodes: a,
        onChange: l,
        refetchOrders: d
      }
    )
  ] });
}, Wp = ({
  withAddresses: e = !0,
  selectedProductIds: n
}) => {
  const r = Vr(), i = fs({ control: r.control, name: "lineItems" }), a = fs({
    control: r.control,
    name: "billingAddress"
  }), o = fs({
    control: r.control,
    name: "shippingAddress"
  }), s = Bn(() => n ? n.length === 0 ? [] : (i || []).filter(
    (m) => n.includes(m.id)
  ) : i, [i, n]), l = Bn(() => !s || s.length === 0 ? 0 : s.reduce((m, u) => {
    const f = u.priceRangeV2?.minVariantPrice?.amount || 0, h = u.quantity || 0;
    return m + f * h;
  }, 0), [s]), d = s?.[0]?.priceRangeV2?.minVariantPrice?.currencyCode || "";
  return /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
    e && /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
      /* @__PURE__ */ k.jsxs(P.Paragraph, { variant: "3", children: [
        a?.firstName,
        " ",
        a?.lastName
      ] }),
      /* @__PURE__ */ k.jsx(
        eb,
        {
          formFieldName: "billingAddress",
          address: a,
          labelText: "Billing address",
          shippingCountryCodes: [],
          refetchOrders: () => Promise.resolve({})
        }
      ),
      /* @__PURE__ */ k.jsx(
        eb,
        {
          formFieldName: "shippingAddress",
          address: o,
          labelText: "Shipping address",
          shippingCountryCodes: [],
          icon: "map-pin",
          refetchOrders: () => Promise.resolve({})
        }
      )
    ] }),
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: "Subtotal" }),
      /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: `${l.toFixed(2)} ${d}` })
    ] }),
    /* @__PURE__ */ k.jsx(P.Paragraph, { color: "tertiary", variant: "5", children: "Tax and shipping will be calculated by Shopify based on customer address and store settings." })
  ] });
}, m3 = "_productTableHeader_6h6pl_1", p3 = "_productImage_6h6pl_5", oo = {
  productTableHeader: m3,
  productImage: p3
}, Gp = (e) => e.media?.nodes?.[0]?.preview?.image?.url || null, f3 = ({
  product: e,
  index: n,
  onRemove: r
}) => {
  const i = Vr(), a = e.priceRangeV2.minVariantPrice.amount, o = e.priceRangeV2.minVariantPrice.currencyCode, s = `lineItems.${n}.quantity`, l = i.watch(s), d = Gp(e);
  return /* @__PURE__ */ k.jsxs(Xn.Tr, { children: [
    /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
      d && /* @__PURE__ */ k.jsx(
        la,
        {
          src: d,
          alt: e.title,
          className: oo.productImage
        }
      ),
      /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: e.title })
    ] }) }),
    /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: e.totalInventory }) }),
    /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: `${a} ${o}` }) }),
    /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(
      tt,
      {
        noLabel: !0,
        noAlert: !0,
        name: s,
        control: i.control,
        componentProps: {
          type: "number",
          min: 1,
          max: e.totalInventory,
          tabIndex: 0
        }
      },
      `${s}-${l}`
    ) }),
    /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: `${a * l} ${o}` }) }),
    /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ k.jsx(nr, { icon: "trash", variant: "secondary", onClick: r }) }) })
  ] });
}, h3 = 300, qa = 2, y3 = 25, g3 = ({
  onProductSelected: e
}) => {
  const { useLazyQuery: n, showNotification: r } = hn(), [i, a] = le(""), [o, s] = le([]), l = Vr(), d = l.watch("selectedProductId"), [m, { loading: u, networkStatus: f }] = n(qp, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (S) => {
      const N = S?.Shopify?.products?.nodes || [];
      s(
        N.filter((w) => !!w).sort((w, y) => w.title.localeCompare(y.title))
      );
    },
    onError: () => {
      s([]), r({
        title: "Something went wrong",
        text: "Could not search for products. Please try again.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  });
  $i(
    () => {
      i.trim().length >= qa && !u && f === er.ready ? m({
        variables: {
          query: i.trim(),
          productCount: y3,
          mediaCount: 1
        }
      }) : i.trim().length < qa && s([]);
    },
    h3,
    [i]
  ), He(() => {
    if (!d) return;
    const S = o.find(
      (N) => N.id === d
    );
    S && e(S), l.setValue("selectedProductId", void 0);
  }, [d, o, l, e]);
  const h = u && f !== er.ready, g = i.trim().length >= qa, C = !o.length && !h && g;
  return /* @__PURE__ */ k.jsx(
    jr,
    {
      noAlert: !0,
      label: "Product selection",
      control: l.control,
      name: "selectedProductId",
      componentProps: {
        placeholder: `Search products (min. ${qa} characters)`,
        tabIndex: 0,
        getItemTitleByValue: (S) => {
          const N = o.find(
            (w) => w.id === S
          );
          return N ? /* @__PURE__ */ k.jsx(P.Paragraph, { children: N.title }) : null;
        },
        filter: {
          value: i,
          onChange: (S) => {
            a(S.target.value);
          }
        },
        onToggleDropdown: (S) => {
          !S && i !== "" && a("");
        }
      },
      children: /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
        h && /* @__PURE__ */ k.jsx(ut.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(b, { justifyContent: "center", padding: "300", children: /* @__PURE__ */ k.jsx(un, {}) }) }),
        !h && o.map((S) => {
          const N = S.totalInventory <= 0, w = Gp(S);
          return /* @__PURE__ */ k.jsx(
            ut.Item,
            {
              value: S.id,
              isDisabled: N,
              children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
                  w && /* @__PURE__ */ k.jsx(
                    la,
                    {
                      src: w,
                      alt: S.title,
                      className: oo.productImage
                    }
                  ),
                  i ? /* @__PURE__ */ k.jsx(
                    O0,
                    {
                      text: S.title,
                      highlight: i
                    }
                  ) : /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: S.title })
                ] }),
                /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "5", children: N ? "Out of stock" : `${S.totalInventory} in stock` })
              ] })
            },
            S.id
          );
        }),
        C && /* @__PURE__ */ k.jsx(ut.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(
          Ns,
          {
            title: "No products found",
            description: "Try changing your search criteria."
          }
        ) }),
        !g && !h && /* @__PURE__ */ k.jsx(ut.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ k.jsx(
          Ns,
          {
            title: "Search for products",
            description: `Type at least ${qa} characters to search.`
          }
        ) })
      ] })
    }
  );
}, Kp = ({
  loading: e = !1,
  selectionMode: n = !1,
  hideDeleteButton: r = !1,
  hideProductSelect: i = !1,
  selectedProductIds: a = [],
  disabledProductIds: o = [],
  maxQuantities: s,
  onToggleSelect: l,
  onToggleSelectAll: d
}) => {
  const m = Vr(), u = m.watch("lineItems"), f = !!u?.length, h = n && f ? u.filter(
    (N) => !o.includes(N?.id)
  ) : [], g = h.length > 0 && h.every(
    (N) => a.includes(N?.id)
  ), C = h.some(
    (N) => a.includes(N?.id)
  ) && !g, S = ot(
    (N) => {
      const w = m.getValues("lineItems"), y = w.findIndex(
        (z) => z?.id === N.id
      );
      if (y > -1) {
        const z = m.getValues(`lineItems.${y}.quantity`) || 0, $ = [...w];
        $[y] = {
          ...$[y],
          quantity: z + 1
        }, m.setValue("lineItems", $);
      } else
        m.setValue("lineItems", [
          ...w,
          { ...N, quantity: 1 }
        ]);
    },
    [m]
  );
  return /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    !i && /* @__PURE__ */ k.jsx(g3, { onProductSelected: S }),
    !f && e && /* @__PURE__ */ k.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        padding: "300",
        className: Ot.boxWrapper,
        children: /* @__PURE__ */ k.jsx(un, {})
      }
    ),
    !f && !e && /* @__PURE__ */ k.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        className: Ot.boxWrapper,
        children: /* @__PURE__ */ k.jsx(
          Ns,
          {
            title: "No products selected",
            description: "Select a product above for your new order"
          }
        )
      }
    ),
    f && /* @__PURE__ */ k.jsx(b, { margin: "300 0", children: /* @__PURE__ */ k.jsxs(
      Xn,
      {
        hoverable: !0,
        framed: !1,
        headerWithBackground: !1,
        className: oo.productTable,
        children: [
          /* @__PURE__ */ k.jsx(Xn.Thead, { className: oo.productTableHeader, children: /* @__PURE__ */ k.jsxs(Xn.Tr, { children: [
            n && /* @__PURE__ */ k.jsx(Xn.Th, { children: /* @__PURE__ */ k.jsx(
              cf,
              {
                checked: g,
                indeterminate: C,
                onChange: () => d?.(!g)
              }
            ) }),
            /* @__PURE__ */ k.jsx(Xn.Th, { children: "Product" }),
            /* @__PURE__ */ k.jsx(Xn.Th, { children: "In stock" }),
            /* @__PURE__ */ k.jsx(Xn.Th, { children: "Price" }),
            /* @__PURE__ */ k.jsx(Xn.Th, { children: "Quantity" }),
            /* @__PURE__ */ k.jsx(Xn.Th, { children: "Total" }),
            !r && /* @__PURE__ */ k.jsx(Xn.Th, {})
          ] }) }),
          /* @__PURE__ */ k.jsx(Xn.Tbody, { children: u?.map((N, w) => {
            if (!n)
              return /* @__PURE__ */ k.jsx(
                f3,
                {
                  product: N,
                  index: w,
                  onRemove: () => {
                    const B = u.filter(
                      (O, q) => q !== w
                    );
                    m.setValue("lineItems", B);
                  }
                },
                `${N?.id}-${w}`
              );
            const y = N, z = y.priceRangeV2.minVariantPrice.amount, $ = y.priceRangeV2.minVariantPrice.currencyCode, I = `lineItems.${w}.quantity`, T = m.watch(I) || 0, U = z * T, Q = Gp(y), J = a.includes(y.id), ae = o.includes(y.id), X = s?.[y.id] ?? y.totalInventory;
            return /* @__PURE__ */ k.jsxs(
              Xn.Tr,
              {
                style: ae ? { opacity: 0.5 } : void 0,
                children: [
                  /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(
                    cf,
                    {
                      checked: J,
                      disabled: ae,
                      onChange: () => l?.(y.id, !J)
                    }
                  ) }),
                  /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", children: [
                    Q && /* @__PURE__ */ k.jsx(
                      la,
                      {
                        src: Q,
                        alt: y.title,
                        className: oo.productImage
                      }
                    ),
                    /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", children: [
                      /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: y.title }),
                      ae && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "5", children: "Already refunded" })
                    ] })
                  ] }) }),
                  /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: y.totalInventory }) }),
                  /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: `${z} ${$}` }) }),
                  /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(
                    tt,
                    {
                      noLabel: !0,
                      noAlert: !0,
                      disabled: ae || X <= 1,
                      name: I,
                      control: m.control,
                      componentProps: {
                        type: "number",
                        min: 1,
                        max: X,
                        tabIndex: 0
                      }
                    },
                    `${I}-${m.watch(I)}`
                  ) }),
                  /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: `${U} ${$}` }) }),
                  !r && /* @__PURE__ */ k.jsx(Xn.Td, { children: /* @__PURE__ */ k.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ k.jsx(
                    nr,
                    {
                      icon: "trash",
                      variant: "secondary",
                      onClick: () => {
                        const B = u.filter(
                          (O, q) => q !== w
                        );
                        m.setValue("lineItems", B), J && l?.(y.id, !1);
                      }
                    }
                  ) }) })
                ]
              },
              `${y.id}-${w}`
            );
          }) })
        ]
      }
    ) })
  ] });
}, NS = ({
  previousOrderStatus: e
} = {}) => {
  const n = Vr();
  return /* @__PURE__ */ k.jsx(
    jr,
    {
      label: "Payment Status",
      name: "financialStatus",
      control: n.control,
      rules: {
        required: {
          value: !0,
          message: "Please select a payment status"
        }
      },
      componentProps: {
        placeholder: "Select payment status",
        tabIndex: 0,
        getItemTitleByValue: (r) => {
          const i = Yk.find(
            (a) => a.value === r
          );
          return i ? /* @__PURE__ */ k.jsxs(
            b,
            {
              flexDirection: "row",
              gap: "200",
              alignItems: "center",
              margin: "0 0 100 0",
              children: [
                /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: i.label }),
                /* @__PURE__ */ k.jsxs(P.Paragraph, { variant: "5", color: "secondary", children: [
                  "(",
                  i.description,
                  ")"
                ] })
              ]
            }
          ) : null;
        }
      },
      children: Yk.map((r) => {
        const i = e && r.value === e;
        return /* @__PURE__ */ k.jsx(ut.Item, { value: r.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
          /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: r.label }),
            i && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "5", color: "secondary", children: "(previous order status)" })
          ] }),
          /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "5", color: "secondary", children: r.description })
        ] }) }, r.value);
      })
    }
  );
}, jS = () => {
  const e = Vr();
  return /* @__PURE__ */ k.jsx(
    jr,
    {
      label: "Fulfillment Status",
      helpIcon: {
        text: "Defaults to 'unfulfilled' if nothing is selected"
      },
      name: "fulfillmentStatus",
      control: e.control,
      componentProps: {
        clearable: !0,
        placeholder: "Select fulfillment status",
        tabIndex: 0,
        getItemTitleByValue: (n) => {
          const r = Qk.find(
            (i) => i.value === n
          );
          return r ? /* @__PURE__ */ k.jsxs(b, { gap: "200", alignItems: "center", margin: "0 0 100 0", children: [
            /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: r.label }),
            /* @__PURE__ */ k.jsxs(P.Paragraph, { variant: "5", color: "secondary", children: [
              "(",
              r.description,
              ")"
            ] })
          ] }) : null;
        }
      },
      children: Qk.map((n) => /* @__PURE__ */ k.jsx(ut.Item, { value: n.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: n.label }),
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "5", color: "secondary", children: n.description })
      ] }) }, n.value))
    }
  );
}, v3 = "_modal_1mprq_1", k3 = {
  modal: v3
}, Gu = "create-shopify-order-form", b3 = ({
  isOpen: e,
  shopifyCustomer: n,
  displayCreateDraftOrder: r,
  setIsOpen: i,
  refetchCustomerOrders: a
}) => {
  const { useMutation: o, showNotification: s } = hn(), { track: l } = _n(), [d, m] = le(!1), [
    u,
    f
  ] = le(!1), h = {
    firstName: n.defaultAddress?.firstName,
    lastName: n.defaultAddress?.lastName,
    address1: n.defaultAddress?.address1,
    address2: n.defaultAddress?.address2,
    city: n.defaultAddress?.city,
    zip: n.defaultAddress?.zip,
    countryCodeV2: n.defaultAddress?.countryCodeV2,
    phone: n.defaultAddress?.phone
  }, g = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: [],
    billingAddress: h,
    shippingAddress: h,
    financialStatus: Gr.Pending,
    fulfillmentStatus: void 0
  }, [C, S] = le([]), N = _t({
    mode: "all",
    defaultValues: g
  }), w = N.watch("lineItems").length > 0, y = () => {
    N.reset(g), S([]), i(!1);
  };
  He(() => {
    C.length > 0 && N.setValue("tags", C, { shouldDirty: !0 });
  }, [C, N]);
  const [z, { error: $ }] = o(
    xS,
    {
      onError: () => {
        m(!1), s({
          title: "Something went wrong",
          text: "The order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:failed"), y();
      },
      onCompleted: () => {
        a(), m(!1), s({
          title: "Success",
          text: "The tags change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:succeeded"), y();
      }
    }
  ), [I, { error: T }] = o(
    Cz,
    {
      onError: () => {
        f(!1), s({
          title: "Something went wrong",
          text: "The draft order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:draft:failed"), y();
      },
      onCompleted: () => {
        a(), f(!1), s({
          title: "Success",
          text: "The draft order creation was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:draft:succeeded"), y();
      }
    }
  ), U = (J) => {
    const ae = J.lineItems.map((O) => ({
      productId: O.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: O.priceRangeV2.maxVariantPrice.amount,
          currencyCode: O.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: O.quantity
    }));
    m(!0);
    const X = Ji(J?.billingAddress), B = Ji(
      J?.shippingAddress
    );
    z({
      variables: {
        order: {
          lineItems: ae,
          customer: {
            toAssociate: {
              id: n?.id
            }
          },
          note: J.customNote,
          tags: J.tags,
          financialStatus: J.financialStatus,
          fulfillmentStatus: J.fulfillmentStatus,
          shippingAddress: B,
          billingAddress: X
        }
      }
    });
  }, Q = (J) => {
    const ae = J.lineItems.map((O) => ({
      title: O.title,
      requiresShipping: !0,
      originalUnitPriceWithCurrency: {
        amount: O.priceRangeV2.maxVariantPrice.amount,
        currencyCode: O.priceRangeV2.maxVariantPrice.currencyCode
      },
      quantity: O.quantity
    }));
    f(!0);
    const X = Ji(J?.billingAddress), B = Ji(
      J?.shippingAddress
    );
    I({
      variables: {
        input: {
          email: n.defaultEmailAddress?.emailAddress,
          note: J.customNote,
          tags: J.tags,
          lineItems: ae,
          shippingAddress: B,
          billingAddress: X
        }
      }
    });
  };
  return /* @__PURE__ */ k.jsxs(
    Tt,
    {
      isOpen: e,
      onClose: y,
      className: k3.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ k.jsx($t, { title: "Create new order", onClose: y }),
        /* @__PURE__ */ k.jsxs(Dt, { children: [
          /* @__PURE__ */ k.jsx(op, { ...N, children: /* @__PURE__ */ k.jsx("form", { id: Gu, children: /* @__PURE__ */ k.jsxs(st, { children: [
            /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsx(Kp, {}) }),
            /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsx(
              Wt,
              {
                name: "tags",
                render: ({ fieldState: { error: J } }) => /* @__PURE__ */ k.jsx(
                  ln,
                  {
                    label: "Tags",
                    meta: {
                      error: J?.message
                    },
                    children: /* @__PURE__ */ k.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (ae) => {
                          ae.key === "Enter" && (ae.preventDefault(), ae.stopPropagation());
                        },
                        children: /* @__PURE__ */ k.jsx(
                          Ws,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: C,
                            onChange: (ae) => {
                              S(ae);
                            }
                          },
                          `tags-input-${e}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ k.jsx(be, { span: 4, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ k.jsx(NS, {}),
              /* @__PURE__ */ k.jsx(jS, {}),
              /* @__PURE__ */ k.jsx(
                tt,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ k.jsx(be, { span: 2, children: /* @__PURE__ */ k.jsx(ln, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: Ot.boxWrapper,
                children: /* @__PURE__ */ k.jsx(Wp, {})
              }
            ) }) })
          ] }) }) }),
          ($ || T) && /* @__PURE__ */ k.jsx(Fn, { error: $ || T })
        ] }),
        /* @__PURE__ */ k.jsx(
          At,
          {
            confirmProps: {
              type: "submit",
              form: Gu,
              disabled: !w || d,
              isLoading: d,
              loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: N.handleSubmit(U),
            ...r && {
              confirmSecondaryName: "Create draft order",
              confirmSecondaryOnClick: () => {
                N.handleSubmit(Q)();
              },
              confirmSecondaryProps: {
                type: "submit",
                form: Gu,
                disabled: !w || u,
                isLoading: u,
                loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 }),
                tabIndex: 0
              }
            }
          }
        )
      ]
    }
  );
}, x3 = "_modal_al73g_1", _3 = {
  modal: x3
}, nb = [
  {
    label: "Customer",
    value: fi.Customer,
    description: "The customer wanted to cancel the order."
  },
  {
    label: "Declined",
    value: fi.Declined,
    description: "Payment was declined."
  },
  {
    label: "Fraud",
    value: fi.Fraud,
    description: "The order was fraudulent."
  },
  {
    label: "Inventory",
    value: fi.Inventory,
    description: "There was insufficient inventory."
  },
  {
    label: "Other",
    value: fi.Other,
    description: "The order was canceled for an unlisted reason."
  },
  {
    label: "Staff",
    value: fi.Staff,
    description: "Staff made an error."
  }
], S3 = ({
  orderId: e,
  isOpen: n,
  orderName: r,
  setIsOpen: i,
  isMutationLoading: a,
  setIsMutationLoading: o,
  refetchOrders: s
}) => {
  const { track: l } = _n(), { useMutation: d, showNotification: m } = hn(), [u, f] = le([]), h = u.length > 0, g = {
    orderId: e,
    reason: null,
    refundMethod: {
      originalPaymentMethodsRefund: !0
    },
    restock: !0,
    notifyCustomer: !1,
    staffNote: ""
  }, C = _t({
    defaultValues: g
  }), [S, { error: N, reset: w }] = d(Sz, {
    onError: () => {
      o(!1), m({
        title: "Something went wrong",
        text: "Could not cancel the order.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async ($) => {
      const I = $.Shopify?.orderCancel?.orderCancelUserErrors || [];
      if (I.length > 0)
        o(!1), f(I), m({
          title: "Something went wrong",
          text: "Could not cancel the order.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      else {
        const T = $.Shopify?.orderCancel?.job?.done;
        setTimeout(async () => {
          await s().finally(() => o(!1));
        }, T ? 0 : 4e3), m({
          title: "Success",
          text: `${T ? "The order got cancelled" : "The order is being cancelled. It might take some time until it is reflected in the order details."}`,
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:cancelled"), i(!1);
      }
    }
  }), y = ot(
    ($) => {
      $.reason != null && (o(!0), S({
        variables: {
          orderId: $.orderId,
          reason: $.reason,
          refundMethod: $.refundMethod,
          restock: $.restock,
          notifyCustomer: $.notifyCustomer,
          staffNote: $.staffNote ?? ""
        }
      }));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e]
  ), z = () => {
    i(!1), w(), f([]), C.reset(g);
  };
  return /* @__PURE__ */ k.jsxs(Tt, { isOpen: n, onClose: z, className: _3.modal, children: [
    /* @__PURE__ */ k.jsx($t, { title: `Cancel order ${r}`, onClose: z }),
    /* @__PURE__ */ k.jsx(Dt, { children: /* @__PURE__ */ k.jsxs(st, { children: [
      /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsx(
        jr,
        {
          control: C.control,
          label: "Reason",
          name: "reason",
          rules: {
            required: {
              value: !0,
              message: "Please select a reason"
            }
          },
          componentProps: {
            placeholder: "Select a reason",
            equalityFn: ($, I) => $ === I,
            getItemTitleByValue: ($) => {
              if (!$)
                return "";
              const I = nb.find(
                (T) => T.value === $
              );
              return /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
                /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: I.label }),
                /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: I.description })
              ] });
            }
          },
          children: nb.map(($) => /* @__PURE__ */ k.jsx(ut.Item, { value: $.value, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: $.label }),
            /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: $.description })
          ] }) }, $.value))
        }
      ) }),
      /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsx(ln, { label: "Refund order", children: /* @__PURE__ */ k.jsx(
        Jn,
        {
          control: C.control,
          name: "refundMethod.originalPaymentMethodsRefund"
        }
      ) }) }),
      /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsx(ln, { label: "Restock items", children: /* @__PURE__ */ k.jsx(Jn, { control: C.control, name: "restock" }) }) }),
      /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsx(ln, { label: "Notify the customer", children: /* @__PURE__ */ k.jsx(Jn, { control: C.control, name: "notifyCustomer" }) }) }),
      /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsx(
        tt,
        {
          name: "staffNote",
          label: "Staff note",
          control: C.control
        }
      ) }),
      h && /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "column", children: u.map(($) => /* @__PURE__ */ k.jsxs(
        b,
        {
          flexDirection: "row",
          gap: "200",
          alignItems: "center",
          children: [
            /* @__PURE__ */ k.jsx(pe, { name: "close-circle-filled", color: "red.500" }),
            /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: $.code }),
            /* @__PURE__ */ k.jsxs(P.Paragraph, { children: [
              "(",
              $.field?.join(","),
              ") ",
              $.message
            ] })
          ]
        },
        $.code
      )) }) })
    ] }) }),
    /* @__PURE__ */ k.jsx(
      At,
      {
        confirmProps: {
          disabled: !(C.formState.isValid && C.formState.isDirty),
          isLoading: a,
          loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 })
        },
        confirmOnClick: C.handleSubmit(y),
        cancelOnClick: z,
        confirmName: N ? "Close" : "Cancel order",
        cancelName: N ? void 0 : "Cancel"
      }
    )
  ] });
}, N3 = ({
  orderId: e,
  orderName: n,
  refetchOrders: r,
  disabled: i
}) => {
  const [a, o] = le(!1), [s, l] = le(!1);
  return /* @__PURE__ */ k.jsxs(b, { width: "100%", children: [
    /* @__PURE__ */ k.jsx(
      Gn,
      {
        variant: "secondary",
        onClick: () => o(!0),
        isLoading: s,
        loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 }),
        disabled: i,
        slotStart: /* @__PURE__ */ k.jsx(
          pe,
          {
            size: 14,
            name: "close-circle-filled",
            color: "red.500"
          }
        ),
        className: Ot.fullWidth,
        children: "Cancel"
      }
    ),
    /* @__PURE__ */ k.jsx(
      S3,
      {
        orderId: e,
        orderName: n,
        isOpen: a,
        setIsOpen: o,
        isMutationLoading: s,
        setIsMutationLoading: l,
        refetchOrders: r
      }
    )
  ] });
}, j3 = "_modal_1mprq_1", w3 = {
  modal: j3
}, C3 = ({
  order: e,
  orderName: n,
  isOpen: r,
  shopifyId: i,
  setIsOpen: a,
  refetchOrders: o
}) => {
  const { useMutation: s, showNotification: l, useQuery: d } = hn(), { track: m } = _n(), [u, f] = le(!1), [h, g] = le(e?.tags || []), C = "duplicate-shopify-order-form", S = (B) => ({
    firstName: B?.firstName,
    lastName: B?.lastName,
    company: B?.company,
    address1: B?.address1,
    address2: B?.address2,
    city: B?.city,
    provinceCode: B?.provinceCode,
    zip: B?.zip,
    countryCode: B?.countryCodeV2,
    phone: B?.phone
  }), N = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: e?.tags || [],
    billingAddress: S(
      e?.billingAddress ?? e?.shippingAddress
    ),
    shippingAddress: S(e?.shippingAddress),
    financialStatus: void 0,
    fulfillmentStatus: void 0
  }, w = _t({
    mode: "all",
    defaultValues: N
  }), y = w.watch("lineItems").length > 0, z = Bn(
    () => (e?.lineItems || []).map((B) => B.product?.id).filter((B) => !!B),
    [e]
  ), $ = Bn(
    () => SS(z),
    [z]
  ), {
    data: I,
    loading: T,
    error: U
  } = d(qp, {
    skip: !$,
    variables: {
      query: $,
      productCount: z.length,
      mediaCount: 1
    }
  });
  He(() => {
    U && l({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [U, l]), He(() => {
    if (!r || T || !I || w.getValues("lineItems")?.length)
      return;
    const B = I?.Shopify?.products?.nodes || [], O = [];
    e?.lineItems?.forEach((q) => {
      const ee = B.find(
        (ve) => ve.id === q.product?.id
      );
      ee && O.push({
        ...ee,
        quantity: q.quantity || 1,
        sku: q.sku,
        discountedUnitPrice: q.discountedUnitPriceSet?.shopMoney
      });
    }), O.length > 0 && w.setValue("lineItems", O, { shouldDirty: !0 });
  }, [r, I, T, e, w]), He(() => {
    (h.length > 0 || (w.getValues("tags") || []).length > 0) && w.setValue("tags", h, { shouldDirty: !0 });
  }, [h, w]);
  const [Q, { error: J }] = s(
    xS,
    {
      onError: () => {
        f(!1), l({
          title: "Something went wrong",
          text: "The order duplication was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), m("shopify:order:duplicate:failed"), X();
      },
      onCompleted: () => {
        o(), f(!1), l({
          title: "Success",
          text: "The order was duplicated successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), m("shopify:order:duplicate:succeeded"), X();
      }
    }
  ), ae = (B) => {
    const O = B.lineItems.map((ee) => ({
      productId: ee.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: ee.discountedUnitPrice?.amount ?? ee.priceRangeV2.maxVariantPrice.amount,
          currencyCode: ee.discountedUnitPrice?.currencyCode ?? ee.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: ee.quantity,
      sku: ee.sku
    })), q = (e?.shippingLines ?? []).map(
      (ee) => ({
        title: ee.title,
        code: ee.code,
        source: ee.source,
        priceSet: {
          shopMoney: {
            amount: ee.discountedPriceSet?.shopMoney?.amount ?? "0.00",
            currencyCode: ee.discountedPriceSet?.shopMoney?.currencyCode ?? "USD"
          }
        }
      })
    );
    f(!0), Q({
      variables: {
        order: {
          customer: {
            toAssociate: {
              id: i
            }
          },
          lineItems: O,
          shippingLines: q,
          note: B.customNote,
          tags: B.tags,
          financialStatus: B.financialStatus,
          fulfillmentStatus: B.fulfillmentStatus,
          shippingAddress: Ji(B?.shippingAddress),
          billingAddress: Ji(B?.billingAddress)
        }
      }
    });
  }, X = () => {
    w.reset(N), g(e?.tags || []), a(!1);
  };
  return /* @__PURE__ */ k.jsxs(
    Tt,
    {
      isOpen: r,
      onClose: X,
      className: w3.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ k.jsx($t, { title: `Duplicate order ${n}`, onClose: X }),
        /* @__PURE__ */ k.jsxs(Dt, { children: [
          /* @__PURE__ */ k.jsx(op, { ...w, children: /* @__PURE__ */ k.jsx("form", { id: C, children: /* @__PURE__ */ k.jsxs(st, { children: [
            /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsx(Kp, { loading: T }) }),
            /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsx(
              Wt,
              {
                name: "tags",
                render: ({ fieldState: { error: B } }) => /* @__PURE__ */ k.jsx(
                  ln,
                  {
                    label: "Tags",
                    meta: {
                      error: B?.message
                    },
                    children: /* @__PURE__ */ k.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (O) => {
                          O.key === "Enter" && (O.preventDefault(), O.stopPropagation());
                        },
                        children: /* @__PURE__ */ k.jsx(
                          Ws,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: h,
                            onChange: (O) => {
                              g(O);
                            }
                          },
                          `tags-input-${r}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ k.jsx(be, { span: 4, children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ k.jsx(
                NS,
                {
                  previousOrderStatus: e?.displayFinancialStatus
                }
              ),
              /* @__PURE__ */ k.jsx(jS, {}),
              /* @__PURE__ */ k.jsx(
                tt,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ k.jsx(be, { span: 2, children: /* @__PURE__ */ k.jsx(ln, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: Ot.boxWrapper,
                children: /* @__PURE__ */ k.jsx(Wp, {})
              }
            ) }) })
          ] }) }) }),
          J && /* @__PURE__ */ k.jsx(Fn, { error: J })
        ] }),
        /* @__PURE__ */ k.jsx(
          At,
          {
            confirmProps: {
              type: "submit",
              form: C,
              disabled: !y || u || T,
              isLoading: u || T,
              loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: w.handleSubmit(ae)
          }
        )
      ]
    }
  );
}, F3 = "_copyIcon_1dlzg_1", I3 = {
  copyIcon: F3
}, E3 = ({
  orderId: e,
  lineItems: n,
  refundedQuantities: r = {}
}) => {
  const { isCopied: i, copy: a } = Ar();
  if (!n || n?.length === 0)
    return null;
  const o = Object.values(r).some(
    (l) => l > 0
  ), s = n.map(
    ({ title: l, quantity: d, variantTitle: m }) => m ? `${d}x ${l} (${m})` : `${d}x ${l}`
  ).join(`
`);
  return /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(
      b,
      {
        gap: "250",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        children: [
          /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "center", children: [
            /* @__PURE__ */ k.jsx(pe, { size: 14, name: "shopify", color: "green.500" }),
            /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", children: "Line items" })
          ] }),
          /* @__PURE__ */ k.jsx(We, { content: "Copy line items", children: /* @__PURE__ */ k.jsx(
            pe,
            {
              size: 14,
              name: i ? "done" : "copy",
              onClick: () => a(s),
              className: I3.copyIcon
            }
          ) })
        ]
      }
    ),
    o && /* @__PURE__ */ k.jsx(
      b,
      {
        gap: "100",
        flexDirection: "row",
        margin: "200 0 0",
        justifyContent: "center",
        children: /* @__PURE__ */ k.jsx(Pn, { color: "red.500", children: "Order has refunded items" })
      }
    ),
    /* @__PURE__ */ k.jsx(Ye, { children: n.map(({ id: l, title: d, quantity: m, variantTitle: u, image: f }) => {
      const h = r[l], g = h > 0, C = h > 1 ? `Refunded (${h} items)` : "Refunded";
      return /* @__PURE__ */ k.jsx(
        Ye.Item,
        {
          contentLeft: /* @__PURE__ */ k.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ k.jsx(P.Paragraph, { children: m }),
            /* @__PURE__ */ k.jsx(P.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ k.jsxs(P.Paragraph, { variant: "4", children: [
            d,
            " ",
            u && `(${u})`,
            g && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", color: "red.500", children: C })
          ] }),
          contentRight: f?.url && /* @__PURE__ */ k.jsx(la, { src: `${f?.url}&height=48`, alt: d })
        },
        `list-${e}-${l}`
      );
    }) })
  ] });
}, T3 = Ks`
  mutation refuncLineItems($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        refund {
          id
          totalRefundedSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, $3 = (e) => {
  const n = [];
  return e.refunds.forEach((r) => {
    const i = r.refundLineItems.edges.filter(
      (a) => a.node.id !== null
    );
    i.length > 0 && n.push({
      ...r,
      refundLineItems: {
        ...r.refundLineItems,
        edges: i
      }
    });
  }), n;
}, wS = (e) => {
  const n = {}, r = $3(e);
  return e.lineItems?.forEach((i) => {
    n[i.id] = 0;
  }), r.forEach((i) => {
    i.refundLineItems.edges.forEach((a) => {
      const o = a.node;
      if (o.id !== null) {
        const s = o.lineItem.id;
        n[s] += o.quantity;
      }
    });
  }), n;
}, D3 = "_modal_21e62_1", R3 = {
  modal: D3
}, tb = "partial-refund-shopify-order-form", O3 = ({
  order: e,
  orderName: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { useMutation: o, showNotification: s } = hn(), { track: l } = _n(), { useQuery: d } = hn(), [m, u] = le(!1), [f, h] = le([]), g = Bn(
    () => e?.refunds ? wS(e) : {},
    [e]
  ), C = Bn(
    () => (e?.lineItems || []).filter((B) => (g[B.id] || 0) >= (B.quantity || 0)).map((B) => B.product?.id).filter((B) => !!B),
    [e, g]
  ), S = Bn(() => {
    const B = {};
    return (e?.lineItems || []).forEach((O) => {
      if (O.product?.id) {
        const q = g[O.id] || 0, ee = Math.max(
          0,
          (O.quantity || 0) - q
        );
        B[O.product.id] = ee;
      }
    }), B;
  }, [e, g]), N = Bn(
    () => (e?.lineItems || []).map((B) => B.product?.id).filter((B) => !!B),
    [e]
  ), w = Bn(
    () => SS(N),
    [N]
  ), {
    data: y,
    loading: z,
    error: $
  } = d(qp, {
    skip: !w,
    variables: {
      query: w,
      productCount: N.length,
      mediaCount: 1
    }
  });
  He(() => {
    $ && s({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [$, s]);
  const I = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: ""
  }, T = _t({
    mode: "all",
    defaultValues: I
  }), U = f.length > 0, [Q, { error: J }] = o(
    T3,
    {
      onError: () => {
        s({
          title: "Something went wrong",
          text: "The partial refund was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:partial:refund:failed"), X();
      },
      onCompleted: () => {
        a(), s({
          title: "Success",
          text: "The partial refund was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:partial:refund:succeeded"), X();
      }
    }
  );
  He(() => {
    if (!r || z || !y || T.getValues("lineItems")?.length)
      return;
    const B = y?.Shopify?.products?.nodes || [], O = [];
    e?.lineItems?.forEach((q) => {
      const ee = B.find(
        (ve) => ve.id === q.product?.id
      );
      if (ee) {
        const ve = g[q.id] || 0, ue = (q.quantity || 1) - ve;
        O.push({
          ...ee,
          quantity: ue > 0 ? ue : q.quantity || 1
        });
      }
    }), O.length > 0 && (T.setValue("lineItems", O, { shouldDirty: !0 }), h([]));
  }, [
    r,
    y,
    z,
    e,
    T,
    g
  ]);
  const ae = (B) => {
    u(!0);
    const O = (B.lineItems || []).filter(
      (q) => f.includes(q.id)
    ).map((q) => {
      const ee = e?.lineItems?.find(
        (fe) => fe.product?.id === q.id
      ), ve = g[ee?.id || ""] || 0, ue = (ee?.quantity || 0) - ve, ce = Math.max(
        0,
        Math.min(ue, q.quantity || 0)
      );
      return ee && ce > 0 ? { lineItemId: ee.id, quantity: ce } : void 0;
    }).filter((q) => !!q);
    Q({
      variables: {
        input: {
          orderId: e.id,
          refundLineItems: O,
          note: B.customNote || void 0,
          notify: !0
        }
      }
    });
  }, X = () => {
    T.reset(I), u(!1), i(!1);
  };
  return /* @__PURE__ */ k.jsxs(Tt, { isOpen: r, onClose: X, className: R3.modal, children: [
    /* @__PURE__ */ k.jsx($t, { title: `Refund order ${n}`, onClose: X }),
    /* @__PURE__ */ k.jsxs(Dt, { children: [
      /* @__PURE__ */ k.jsx(op, { ...T, children: /* @__PURE__ */ k.jsx("form", { id: tb, children: /* @__PURE__ */ k.jsxs(st, { children: [
        /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsx(
          Kp,
          {
            loading: z,
            selectionMode: !0,
            hideDeleteButton: !0,
            hideProductSelect: !0,
            selectedProductIds: f,
            disabledProductIds: C,
            maxQuantities: S,
            onToggleSelect: (B, O) => {
              h((q) => O ? Array.from(/* @__PURE__ */ new Set([...q, B])) : q.filter((ee) => ee !== B));
            },
            onToggleSelectAll: (B) => {
              const O = (T.getValues("lineItems") || []).map((q) => q.id).filter((q) => !C.includes(q));
              h(B ? O : []);
            }
          }
        ) }),
        /* @__PURE__ */ k.jsx(be, { span: 4, children: /* @__PURE__ */ k.jsx(b, { flexDirection: "column", gap: "300", children: /* @__PURE__ */ k.jsx(
          tt,
          {
            label: "Custom note",
            name: "customNote",
            componentProps: {
              placeholder: "Enter custom note (optional)",
              tabIndex: 0
            }
          }
        ) }) }),
        /* @__PURE__ */ k.jsx(be, { span: 2, children: /* @__PURE__ */ k.jsx(ln, { label: "Details", noAlert: !0, children: /* @__PURE__ */ k.jsx(
          b,
          {
            flexDirection: "column",
            gap: "200",
            justifyContent: "end",
            className: Ot.boxWrapper,
            children: /* @__PURE__ */ k.jsx(
              Wp,
              {
                withAddresses: !1,
                selectedProductIds: f
              }
            )
          }
        ) }) })
      ] }) }) }),
      J && /* @__PURE__ */ k.jsx(Fn, { error: J })
    ] }),
    /* @__PURE__ */ k.jsx(
      At,
      {
        confirmProps: {
          type: "submit",
          form: tb,
          disabled: !U || m || z,
          isLoading: m || z,
          loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 }),
          tabIndex: 0
        },
        confirmName: "Refund selected",
        confirmOnClick: T.handleSubmit(ae)
      }
    )
  ] });
}, A3 = ({
  order: e,
  shopifyId: n,
  orderLink: r,
  refetchOrders: i
}) => {
  const { useMutation: a, showNotification: o, showModal: s } = hn(), { track: l } = _n(), { suggestedRefund: d, currencyCode: m, id: u, name: f } = e, h = parseFloat(String(d?.amount)), g = !isNaN(h) && h > 0, [C] = a(_z, {
    onError: (w) => {
      setTimeout(() => N(w), 500);
    },
    onCompleted: (w) => {
      const y = w.Shopify?.refundCreate?.userErrors;
      y && y.length > 0 ? N(
        new nx({
          graphQLErrors: y.map((z) => ({
            message: z.message
          }))
        })
      ) : (o({
        title: "Order refunded",
        text: `You refunded order ${f}`,
        icon: "check-circle-filled",
        severity: "success"
      }), i());
    }
  }), S = ot(() => {
    l("shopify:order:refund:requested", { shopifyId: n, orderId: u });
    const { amount: w, ...y } = d;
    s(g ? {
      headline: `Refund Order ${f}?`,
      children: /* @__PURE__ */ k.jsxs(P.Paragraph, { children: [
        "You are about to refund ",
        w,
        " ",
        m,
        " to the customer. Are you sure you want to refund the order?"
      ] }),
      confirmLabel: "Confirm order refund",
      confirmVariant: "primary",
      cancelLabel: "Cancel",
      cancelVariant: "secondary",
      onConfirm: () => {
        l("shopify:order:refund:confirmed", { shopifyId: n, orderId: u }), C({
          variables: {
            input: y
          }
        });
      },
      onCancel: () => l("shopify:order:refund:canceled", { shopifyId: n, orderId: u })
    } : {
      headline: `Refund Order ${f}`,
      children: /* @__PURE__ */ k.jsx(P.Paragraph, { children: "No refund can be issued because no payment has been captured for this order. The order's financial status is currently pending." }),
      confirmLabel: "Close",
      confirmVariant: "secondary",
      onConfirm: () => {
      }
    });
  }, [
    n,
    u,
    f,
    m,
    d,
    g,
    s,
    C,
    l
  ]), N = ot(
    (w) => {
      s({
        headline: "Something went wrong",
        text: "It looks like something went wrong when trying to refund the order. Please create the refund in Shopify directly.",
        confirmLabel: "Close",
        children: /* @__PURE__ */ k.jsxs(b, { flexDirection: "column", children: [
          /* @__PURE__ */ k.jsx(Fn, { error: w }),
          /* @__PURE__ */ k.jsx(
            Et,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(r, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ k.jsx(pe, { name: "external-link" }),
              children: "View order in Shopify"
            }
          )
        ] }),
        onConfirm: () => {
        }
      });
    },
    [r]
  );
  return /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
    Gn,
    {
      variant: "secondary",
      onClick: S,
      disabled: d?.refundLineItems?.length === 0 || !g,
      slotStart: /* @__PURE__ */ k.jsx(pe, { size: 14, name: "undo" }),
      className: Ot.fullWidth,
      children: "Full refund"
    }
  ) });
}, P3 = "_modal_al73g_1", L3 = {
  modal: P3
}, V3 = ({
  orderId: e,
  tags: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { track: o } = _n(), { useMutation: s, showNotification: l } = hn(), [d, m] = le(n), [u, f] = le(!1), h = _t({
    defaultValues: {
      tags: n
    }
  });
  He(() => {
    d && h.setValue("tags", d, { shouldDirty: !0 });
  }, [d]);
  const [g, { error: C, reset: S }] = s(Nz, {
    onError: () => {
      f(!1), l({
        title: "Something went wrong",
        text: "The tags change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async () => {
      await a(), f(!1), l({
        title: "Success",
        text: "The tags change was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), o("shopify:order:tags:updated"), i(!1);
    }
  }), N = ot(
    (y) => {
      f(!0), g({
        variables: {
          input: {
            id: e,
            tags: y.tags
          }
        }
      }).then((z) => {
        const $ = z.data?.Shopify?.orderUpdate?.order?.tags ?? y.tags;
        h.reset({ tags: $ });
      });
    },
    [e, h, g]
  ), w = () => {
    i(!1), S();
  };
  return /* @__PURE__ */ k.jsxs(Tt, { isOpen: r, onClose: w, className: L3.modal, children: [
    /* @__PURE__ */ k.jsx($t, { title: "Manage tags for order", onClose: w }),
    /* @__PURE__ */ k.jsxs(Dt, { children: [
      /* @__PURE__ */ k.jsx(st, { children: /* @__PURE__ */ k.jsx(be, { children: /* @__PURE__ */ k.jsx(
        Wt,
        {
          control: h.control,
          name: "tags",
          render: ({ fieldState: { error: y } }) => /* @__PURE__ */ k.jsx(
            ln,
            {
              label: "Tags",
              meta: {
                error: y?.message
              },
              children: /* @__PURE__ */ k.jsx(
                Ws,
                {
                  placeholder: "Add tags here",
                  selectedTags: n,
                  onChange: (z) => m(z)
                }
              )
            }
          )
        }
      ) }) }),
      C && /* @__PURE__ */ k.jsx(Fn, { error: C })
    ] }),
    /* @__PURE__ */ k.jsx(
      At,
      {
        confirmProps: {
          disabled: !(h.formState.isValid && h.formState.isDirty),
          isLoading: u,
          loadingIndicator: /* @__PURE__ */ k.jsx(un, { size: 16 })
        },
        confirmOnClick: h.handleSubmit(N),
        cancelOnClick: w,
        confirmName: C ? "Close" : "Save",
        cancelName: C ? void 0 : "Cancel"
      }
    )
  ] });
}, z3 = "_editIcon_1yp2k_1", U3 = "_copyIcon_1yp2k_2", rb = {
  editIcon: z3,
  copyIcon: U3
}, M3 = ({
  orderId: e,
  tags: n,
  refetchOrders: r
}) => {
  const [i, a] = le(!1), { isCopied: o, copy: s } = Ar(), l = 14, d = n.length > 0;
  return /* @__PURE__ */ k.jsxs(k.Fragment, { children: [
    /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(pe, { size: l, name: "tag", color: "green.500" }),
        /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", children: "Tags" }),
          /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
            !d && /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", color: "tertiary", children: "No tags here yet" }),
            d && n.map((m, u) => /* @__PURE__ */ k.jsx(An, { size: "small", variant: "primary", children: m }, u))
          ] })
        ] })
      ] }),
      /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ k.jsx(We, { content: "Edit tags", children: /* @__PURE__ */ k.jsx(
          pe,
          {
            size: l,
            name: "pen",
            className: rb.editIcon,
            onClick: () => a(!0)
          }
        ) }),
        d && /* @__PURE__ */ k.jsx(We, { content: "Copy tags", children: /* @__PURE__ */ k.jsx(
          pe,
          {
            size: l,
            name: o ? "done" : "copy",
            className: rb.copyIcon,
            onClick: () => s(n.join(", "))
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ k.jsx(
      V3,
      {
        orderId: e,
        tags: n,
        isOpen: i,
        setIsOpen: a,
        refetchOrders: r
      }
    )
  ] });
}, B3 = "_icon_cddi1_1", q3 = "_link_cddi1_6", ib = {
  icon: B3,
  link: q3
}, H3 = ({ trackingInfo: e }) => {
  const { isCopied: n, copy: r } = Ar(), { company: i, number: a, url: o } = e;
  return /* @__PURE__ */ k.jsx(
    Ye.Item,
    {
      contentLeft: /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", children: a }),
      title: /* @__PURE__ */ k.jsx(
        P.ExternalLink,
        {
          href: o,
          target: "_blank",
          rel: "noreferrer",
          className: ib.link,
          children: i
        }
      ),
      contentRight: a && /* @__PURE__ */ k.jsx(We, { content: "Copy tracking code", children: /* @__PURE__ */ k.jsx(
        pe,
        {
          size: 14,
          name: n ? "done" : "copy",
          onClick: () => r(a.toString()),
          className: ib.icon
        }
      ) })
    }
  );
}, W3 = ({
  trackingInfos: e
}) => !e || e?.length === 0 ? null : /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ k.jsx(pe, { size: 14, name: "eye", color: "green.500" }),
    /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", children: "Tracking" })
  ] }),
  /* @__PURE__ */ k.jsx(Ye, { children: e.map((n) => /* @__PURE__ */ k.jsx(H3, { trackingInfo: n }, n.number)) })
] }), G3 = "_copyIcon_yc0fe_1", K3 = "_order_yc0fe_6", Y3 = "_orderIsOpen_yc0fe_14", Q3 = "_orderHeader_yc0fe_17", qi = {
  copyIcon: G3,
  order: K3,
  orderIsOpen: Y3,
  orderHeader: Q3
}, J3 = ({
  order: e,
  shopifyId: n,
  openByDefault: r,
  customerCountryCodes: i,
  enableEditShippingAddress: a,
  displayRefund: o,
  displayCancel: s,
  shopifyDomain: l,
  displayDuplicateOrder: d,
  displayPartialRefundOrder: m,
  refetchOrders: u
}) => {
  const { track: f } = _n(), { isCopied: h, copy: g } = Ar(), { isCopied: C, copy: S } = Ar(), { isCopied: N, copy: w } = Ar(), [y, z] = le(!1), [$, I] = le(!1), [T, U] = le(r), {
    id: Q,
    name: J,
    createdAt: ae,
    status: X,
    currentTotalPriceSet: B,
    currencyCode: O,
    lineItems: q,
    billingAddress: ee,
    shippingAddress: ve,
    trackingInfos: ue,
    tags: ce
  } = e, fe = !!ve, W = Hp(Q), xe = `https://${l}/admin/orders/${W ?? ""}`, Ie = B?.shopMoney?.amount ?? 0, K = X.includes("cancelled"), qe = new Intl.NumberFormat(void 0, {
    style: "currency",
    currency: O
  }).format(Ie), Be = e?.refunds ? wS(e) : {}, Oe = !!q?.length && q.every((Me) => (Be[Me.id] || 0) >= (Me.quantity || 0));
  return /* @__PURE__ */ k.jsxs(
    b,
    {
      className: it(qi.order, {
        [qi.orderIsOpen]: T
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ k.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: qi.orderHeader,
            onClick: () => U(!T),
            children: [
              /* @__PURE__ */ k.jsxs(b, { gap: "100", flexDirection: "column", children: [
                ae && /* @__PURE__ */ k.jsx(b, { alignItems: "center", children: /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: Ln(ae).format(Dm) }) }),
                /* @__PURE__ */ k.jsxs(P.Paragraph, { variant: "1", children: [
                  "Order ",
                  J
                ] })
              ] }),
              /* @__PURE__ */ k.jsx(
                nr,
                {
                  variant: "tertiary",
                  icon: T ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        T && /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ k.jsx(pe, { size: 14, name: "info", color: "green.500" }),
                  /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", children: "Order number" }),
                    /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: J.replace("#", "") })
                  ] })
                ] }),
                /* @__PURE__ */ k.jsx(We, { content: "Copy order number", children: /* @__PURE__ */ k.jsx(
                  pe,
                  {
                    size: 14,
                    name: h ? "done" : "copy",
                    onClick: () => g(J.replace("#", "")),
                    className: qi.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ k.jsx(pe, { size: 14, name: "activity", color: "green.500" }),
                  /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", children: "Order status" }),
                    /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: X })
                  ] })
                ] }),
                /* @__PURE__ */ k.jsx(We, { content: "Copy order status", children: /* @__PURE__ */ k.jsx(
                  pe,
                  {
                    size: 14,
                    name: N ? "done" : "copy",
                    onClick: () => w(X),
                    className: qi.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ k.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ k.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ k.jsx(pe, { size: 14, name: "chart-bar", color: "green.500" }),
                  /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "3", children: "Order value" }),
                    /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: qe })
                  ] })
                ] }),
                /* @__PURE__ */ k.jsx(We, { content: "Copy order value", children: /* @__PURE__ */ k.jsx(
                  pe,
                  {
                    size: 14,
                    name: C ? "done" : "copy",
                    onClick: () => S(Ie),
                    className: qi.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ k.jsx(
            M3,
            {
              orderId: Q,
              tags: ce,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ k.jsx(
            Rm,
            {
              openByDefault: !fe,
              labelText: "Billing address",
              address: ee,
              shippingCountryCodes: i,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ k.jsx(
            Rm,
            {
              openByDefault: fe,
              shopifyId: n,
              orderId: Q,
              icon: "map-pin",
              labelText: "Shipping address",
              address: ve,
              shippingCountryCodes: i,
              enableEditAddress: a,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ k.jsx(
            E3,
            {
              orderId: Q,
              lineItems: q,
              refundedQuantities: Be
            }
          ),
          /* @__PURE__ */ k.jsx(W3, { trackingInfos: ue }),
          (o || m) && /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            o && /* @__PURE__ */ k.jsx(
              A3,
              {
                order: e,
                shopifyId: n,
                refetchOrders: u,
                orderLink: xe
              }
            ),
            m && /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
              Gn,
              {
                variant: "secondary",
                icon: "undo",
                onClick: () => I(!0),
                className: Ot.fullWidth,
                disabled: K || Oe,
                children: "Partial refund"
              }
            ) })
          ] }),
          (d || s) && /* @__PURE__ */ k.jsxs(b, { flexDirection: "row", gap: "200", children: [
            d && /* @__PURE__ */ k.jsx(b, { width: "100%", children: /* @__PURE__ */ k.jsx(
              Gn,
              {
                variant: "secondary",
                icon: "plus",
                onClick: () => z(!0),
                className: Ot.fullWidth,
                children: "Duplicate"
              }
            ) }),
            s && /* @__PURE__ */ k.jsx(
              N3,
              {
                orderId: Q,
                orderName: J,
                disabled: K,
                refetchOrders: u
              }
            )
          ] }),
          /* @__PURE__ */ k.jsx(
            Et,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(xe, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ k.jsx(pe, { name: "external-link" }),
              onClick: () => f("shopify:view:order:clicked", {
                shopifyId: n,
                orderId: Q
              }),
              children: "View order in Shopify"
            }
          )
        ] }),
        y && /* @__PURE__ */ k.jsx(
          C3,
          {
            order: e,
            shopifyId: n,
            orderName: J,
            isOpen: y,
            setIsOpen: z,
            refetchOrders: u
          }
        ),
        $ && /* @__PURE__ */ k.jsx(
          O3,
          {
            order: e,
            orderName: J,
            isOpen: $,
            setIsOpen: I,
            refetchOrders: () => {
              u();
            }
          }
        )
      ]
    }
  );
}, X3 = ({
  customerCountryCodes: e,
  shopifyDomain: n,
  displayRefund: r,
  displayCancel: i,
  displayCreateOrder: a,
  displayCreateDraftOrder: o,
  displayDuplicateOrder: s,
  displayPartialRefundOrder: l,
  enableEditShippingAddress: d,
  shopifyCustomer: m
}) => {
  const { track: u } = _n(), [f, h] = le([]), [g, C] = le(!1), S = Hp(m?.id), N = `https://${n}/admin/orders?customer_id=${S ?? ""}`, {
    getCustomerOrders: w,
    isCustomerOrdersLoading: y,
    customerOrdersError: z,
    customerOrders: $,
    refetchCustomerOrders: I
  } = Iz();
  return He(() => {
    !y && S && w({
      variables: {
        query: `customer_id:${S}`
      }
    });
  }, [S]), He(() => {
    const T = $?.Shopify?.orders?.edges;
    T && h(a3({ ordersData: T }));
  }, [$]), m ? z ? /* @__PURE__ */ k.jsx(Fn, { error: z }) : /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: "Customer orders" }),
      !y && /* @__PURE__ */ k.jsx(An, { variant: "success", size: "small", children: f.length })
    ] }),
    a && /* @__PURE__ */ k.jsx(
      Gn,
      {
        variant: "secondary",
        icon: "plus",
        onClick: () => C(!0),
        children: "Create new order"
      }
    ),
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
      y && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(un, {}) }),
      !y && f.length === 0 && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ k.jsx(P.Paragraph, { color: "tertiary", children: "No orders found" }) }),
      !y && f.length > 0 && /* @__PURE__ */ k.jsx(b, { gap: "200", flexDirection: "column", children: f.map((T, U) => /* @__PURE__ */ k.jsx(
        J3,
        {
          order: T,
          openByDefault: U === 0,
          shopifyId: m?.id,
          displayRefund: r,
          displayCancel: i,
          enableEditShippingAddress: d,
          customerCountryCodes: e,
          refetchOrders: I,
          shopifyDomain: n,
          displayDuplicateOrder: s,
          displayPartialRefundOrder: l
        },
        `${U}-${T.id}`
      )) }),
      /* @__PURE__ */ k.jsx(
        Et,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(N, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ k.jsx(pe, { name: "external-link" }),
          onClick: () => u("shopify:view:all:orders:clicked", {
            shopifyId: m?.id
          }),
          children: "View all orders in Shopify"
        }
      )
    ] }),
    a && /* @__PURE__ */ k.jsx(
      b3,
      {
        isOpen: g,
        setIsOpen: C,
        shopifyCustomer: m,
        refetchCustomerOrders: I,
        displayCreateDraftOrder: o
      }
    )
  ] }) : null;
}, Z3 = ({
  totalOrders: e,
  amountSpent: n
}) => {
  const r = n?.amount ?? 0, i = n?.currencyCode ?? "", a = `${Number.parseFloat(r).toFixed(
    2
  )} ${i}`;
  return /* @__PURE__ */ k.jsx(k.Fragment, { children: /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: "Orders overview" }),
    /* @__PURE__ */ k.jsxs(Ye, { className: Ot.list, children: [
      /* @__PURE__ */ k.jsx(Ye.Text, { variant: "dense", className: Ot.listItem, children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: "Total orders" }),
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: e })
      ] }) }),
      /* @__PURE__ */ k.jsx(Ye.Text, { variant: "dense", className: Ot.listItem, children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: "Total revenue" }),
        /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] }) });
}, eU = "_segmentName_1dkhk_1", nU = {
  segmentName: eU
}, tU = 100, rs = 10, rU = ({
  shopifyId: e
}) => {
  const { useQuery: n, useLazyQuery: r } = hn(), [i, a] = le([]), [o, s] = le(rs), [l, d] = le(!1), m = Bn(
    () => i.filter((S) => S.isMember).length,
    [i]
  ), { loading: u, error: f } = n(
    vz,
    {
      skip: !e,
      variables: {
        first: tU
      },
      onCompleted: (S) => {
        const N = S?.Shopify?.segments?.edges;
        if (N && N.length > 0) {
          const w = N.map(({ node: y }) => ({
            ...y,
            isMember: !1
          })).sort((y, z) => y.name.localeCompare(z.name));
          a(w), h({
            variables: {
              customerId: e,
              segmentIds: w.map((y) => y.id)
            }
          });
        }
      }
    }
  ), [
    h,
    { loading: g, error: C }
  ] = r(kz, {
    onCompleted: (S) => {
      const N = S?.Shopify?.customerSegmentMembership?.memberships;
      if (N && N.length > 0) {
        const w = i.map((y) => {
          const z = N.find(
            ($) => $.segmentId === y.id
          );
          return {
            ...y,
            ...z?.isMember && { isMember: z.isMember }
          };
        }).sort(
          (y, z) => y.isMember === z.isMember ? 0 : y.isMember ? -1 : 1
        );
        a(w);
      }
    }
  });
  return He(() => {
    s(l ? i.length : rs);
  }, [l]), e ? /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ k.jsx(P.Heading, { variant: "heading-3", children: "Segment membership" }),
      !u && /* @__PURE__ */ k.jsx(An, { variant: "success", size: "small", children: m })
    ] }),
    u && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ k.jsx(un, {}) }),
    !u && i.length === 0 && /* @__PURE__ */ k.jsx(P.Paragraph, { color: "tertiary", margin: "200 0 300 0", align: "center", children: "No segments found" }),
    f && /* @__PURE__ */ k.jsx(Fn, { error: f }),
    C && /* @__PURE__ */ k.jsx(Fn, { error: C }),
    !u && i.length > 0 && /* @__PURE__ */ k.jsxs(Ye, { className: Ot.list, children: [
      i.slice(0, o).map(({ id: S, name: N, isMember: w }) => /* @__PURE__ */ k.jsx(Ye.Text, { className: Ot.listItem, children: /* @__PURE__ */ k.jsx(
        We,
        {
          content: `${w ? "Member of" : "Not a member of"} ${N}`,
          children: /* @__PURE__ */ k.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ k.jsx(P.Paragraph, { variant: "4", className: nU.segmentName, children: N }),
            g && /* @__PURE__ */ k.jsx(un, { size: 12 }),
            !g && /* @__PURE__ */ k.jsx(b, { children: /* @__PURE__ */ k.jsx(
              pe,
              {
                color: w ? "green.500" : "neutral.300",
                name: "shopify"
              }
            ) })
          ] })
        }
      ) }, S)),
      i.length > rs && /* @__PURE__ */ k.jsx(b, { justifyContent: "center", margin: "200 0 0", children: /* @__PURE__ */ k.jsx(
        Gn,
        {
          variant: "secondary",
          onClick: () => d(!l),
          icon: l ? "angle-up" : "angle-down",
          children: l ? "Show less" : `Show ${i.length - rs} more`
        }
      ) })
    ] })
  ] }) : null;
}, iU = ({
  conversationContext: e,
  settings: n
}) => {
  const {
    isCustomerLoading: r,
    customerError: i,
    customerData: a,
    refetchCustomer: o,
    customerNetworkStatus: s
  } = Fz({ conversationContext: e }), [l, d] = le(), [m, u] = le(
    []
  ), f = n.apiHostName, h = n.displayRefundOrder ?? !1, g = n.displayCancelOrder ?? !1, C = n.enableEditShippingAddress ?? !1, S = n.displayEmailMarketingConsent ?? !1, N = n.displayOrdersOverview ?? !1, w = n.displaySegmentMembership ?? !1, y = n.displayDiscountCodeCreation ?? !1, z = n.displayDiscountCodes ?? !1, $ = n.displayCreateOrder ?? !1, I = n.displayDuplicateOrder ?? !1, T = n.displayCreateDraftOrder ?? !1, U = n.displayPartialRefundOrder ?? !1;
  if (He(() => {
    const Q = a?.Shopify?.customers?.edges[0]?.node;
    Q && !r ? (u(
      a?.Shopify?.shop?.countriesInShippingZones?.countryCodes || []
    ), d(Q)) : d(void 0);
  }, [a]), !r && i)
    return /* @__PURE__ */ k.jsx(Fn, { error: i, retry: o });
  if (!r && !i && !l) {
    const Q = `https://${f}/admin/customers?search=${e.customer?.name || ""}`;
    return /* @__PURE__ */ k.jsxs(
      b,
      {
        margin: "200 0 300",
        gap: "300",
        flexDirection: "column",
        "data-testid": "widget-customer-not-found",
        children: [
          /* @__PURE__ */ k.jsx(P.Paragraph, { color: "secondary", children: "We cannot find the customer in Shopify." }),
          /* @__PURE__ */ k.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ k.jsx(
              Pz,
              {
                refetchCustomer: o,
                conversationContext: e
              }
            ),
            /* @__PURE__ */ k.jsx(
              Et,
              {
                variant: "secondary",
                style: {
                  color: "var(--dixa-typography-color-link)",
                  padding: "var(--dixa-size-spacer-100)"
                },
                navigate: () => window.open(Q, "_blank")?.focus(),
                slotStart: /* @__PURE__ */ k.jsx(pe, { name: "external-link" }),
                children: "Search customers in Shopify"
              }
            )
          ] })
        ]
      }
    );
  }
  return r && s !== er.refetch ? /* @__PURE__ */ k.jsx(b, { margin: "200 0 300", justifyContent: "center", children: /* @__PURE__ */ k.jsx(un, {}) }) : /* @__PURE__ */ k.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ k.jsx(
          zz,
          {
            customer: l,
            shopifyDomain: f,
            refresh: o,
            loading: r,
            networkStatus: s
          }
        ),
        N && /* @__PURE__ */ k.jsx(
          Z3,
          {
            totalOrders: l?.numberOfOrders,
            amountSpent: l?.amountSpent
          }
        ),
        w && /* @__PURE__ */ k.jsx(rU, { shopifyId: l?.id }),
        S && /* @__PURE__ */ k.jsx(i3, { customer: l }),
        z && /* @__PURE__ */ k.jsx(
          r3,
          {
            displayDiscountCodeCreation: y
          }
        ),
        /* @__PURE__ */ k.jsx(
          X3,
          {
            shopifyCustomer: l,
            shopifyDomain: f,
            displayRefund: h,
            displayCancel: g,
            displayCreateOrder: $,
            displayCreateDraftOrder: T,
            enableEditShippingAddress: C,
            customerCountryCodes: m,
            displayDuplicateOrder: I,
            displayPartialRefundOrder: U
          }
        )
      ]
    }
  );
}, wt = [];
for (let e = 0; e < 256; ++e)
  wt.push((e + 256).toString(16).slice(1));
function aU(e, n = 0) {
  return (wt[e[n + 0]] + wt[e[n + 1]] + wt[e[n + 2]] + wt[e[n + 3]] + "-" + wt[e[n + 4]] + wt[e[n + 5]] + "-" + wt[e[n + 6]] + wt[e[n + 7]] + "-" + wt[e[n + 8]] + wt[e[n + 9]] + "-" + wt[e[n + 10]] + wt[e[n + 11]] + wt[e[n + 12]] + wt[e[n + 13]] + wt[e[n + 14]] + wt[e[n + 15]]).toLowerCase();
}
const oU = new Uint8Array(16);
function sU() {
  return crypto.getRandomValues(oU);
}
function lU(e, n, r) {
  return crypto.randomUUID ? crypto.randomUUID() : cU(e);
}
function cU(e, n, r) {
  e = e || {};
  const i = e.random ?? e.rng?.() ?? sU();
  if (i.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, aU(i);
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._pointer_ls8kj_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_ls8kj_53{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_ls8kj_63{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ls8kj_63:last-child{border-bottom:none}._modalBody_1clhs_1{width:400px}._wrapper_1ge6c_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_1ge6c_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._block_1ge6c_12{margin-bottom:var(--dixa-size-spacer-250)}._wrapper_yud4a_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._list_yud4a_7{padding:0}._listItem_yud4a_11{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItemTooltip_yud4a_15{cursor:pointer}._listItemTimestamp_yud4a_18{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._listItem_yud4a_11:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._list_zu4s7_1{padding:var(--dixa-size-spacer-100)}._listItem_zu4s7_4{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100)}._listSum_zu4s7_7{margin-top:var(--dixa-size-spacer-200);border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-400)}._transaction_1kr8d_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._transaction_1kr8d_1:hover,._transactionIsOpen_1kr8d_9{border-color:var(--dixa-color-neutral-400)}._transactionHeader_1kr8d_12{cursor:pointer}._transactionHeaderSubLine_1kr8d_15{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._transactionHeaderAlignItemRight_1kr8d_19{margin-left:auto;margin-right:var(--dixa-size-spacer-200)}._message_unsvt_48{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._message_unsvt_48:hover,._messageIsOpen_unsvt_56{border-color:var(--dixa-color-neutral-400)}._messageHeader_unsvt_60{cursor:pointer}._messageText_unsvt_64{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:hidden;overflow-y:auto;overflow-x:auto}._messageText_unsvt_64::-webkit-scrollbar{width:7px;height:7px}._messageText_unsvt_64::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-200)}._messageText_unsvt_64::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:5px}._buttonLink_unsvt_86{color:var(--dixa-typography-color-link)}._order_19t4p_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_19t4p_1:hover,._orderIsOpen_19t4p_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_19t4p_12{cursor:pointer}._orderIconColor_19t4p_15{color:var(--dixa-color-green-500)}._delivery_1m9nb_1{word-break:break-all}._deliveryCode_1m9nb_4{font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-tertiary)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Ku = { exports: {} }, Ha = {}, ab;
function dU() {
  if (ab) return Ha;
  ab = 1;
  var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return Ha.Fragment = r, Ha.jsx = s, Ha.jsxs = s, Ha;
}
var is = {}, ob;
function uU() {
  return ob || (ob = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        z("error", t, p);
      }
    }
    function z(t, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, A = v.getStackAddendum();
        A !== "" && (c += "%s", p = p.concat([A]));
        var L = p.map(function(F) {
          return String(F);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, I = !1, T = !1, U = !1, Q = !1, J;
    J = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === u || U || t === g || $ || I || T || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function X(t, c, p) {
      var v = t.displayName;
      if (v)
        return v;
      var A = c.displayName || c.name || "";
      return A !== "" ? p + "(" + A + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return X(t, t.render, "ForwardRef");
          case f:
            var v = t.displayName || null;
            return v !== null ? v : O(t.type) || "Memo";
          case h: {
            var A = t, L = A._payload, F = A._init;
            try {
              return O(F(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, ue, ce, fe, W, xe, Ie;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ve = console.log, ue = console.info, ce = console.warn, fe = console.error, W = console.group, xe = console.groupCollapsed, Ie = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: ue
            }),
            warn: q({}, t, {
              value: ce
            }),
            error: q({}, t, {
              value: fe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: xe
            }),
            groupEnd: q({}, t, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Me;
    function $e(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (A) {
            var v = A.stack.trim().match(/\n( *(at )?)/);
            Me = v && v[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var ze = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(t, c) {
      if (!t || ze)
        return "";
      {
        var p = Re.get(t);
        if (p !== void 0)
          return p;
      }
      var v;
      ze = !0;
      var A = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, qe();
      try {
        if (c) {
          var F = function() {
            throw Error();
          };
          if (Object.defineProperty(F.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(F, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(t, [], F);
          } else {
            try {
              F.call();
            } catch (ne) {
              v = ne;
            }
            t.call(F.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), G = j.length - 1, _ = te.length - 1; G >= 1 && _ >= 0 && j[G] !== te[_]; )
            _--;
          for (; G >= 1 && _ >= 0; G--, _--)
            if (j[G] !== te[_]) {
              if (G !== 1 || _ !== 1)
                do
                  if (G--, _--, _ < 0 || j[G] !== te[_]) {
                    var Z = `
` + j[G].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (G >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Oe.current = L, Be(), Error.prepareStackTrace = A;
      }
      var de = t ? t.displayName || t.name : "", Se = de ? $e(de) : "";
      return typeof t == "function" && Re.set(t, Se), Se;
    }
    function Ge(t, c, p) {
      return Ee(t, !1);
    }
    function Qe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function he(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Qe(t));
      if (typeof t == "string")
        return $e(t);
      switch (t) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ge(t.render);
          case f:
            return he(t.type, c, p);
          case h: {
            var v = t, A = v._payload, L = v._init;
            try {
              return he(L(A), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, De = {}, Le = w.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = he(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(t, c, p, v, A) {
      {
        var L = Function.call.bind(ge);
        for (var F in t)
          if (L(t, F)) {
            var j = void 0;
            try {
              if (typeof t[F] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + F + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[F] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[F](c, F, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (G) {
              j = G;
            }
            j && !(j instanceof Error) && (Ae(A), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, F, typeof j), Ae(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Ae(A), y("Failed %s type: %s", p, j.message), Ae(null));
          }
      }
    }
    var E = Array.isArray;
    function x(t) {
      return E(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var V = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, me, Ne;
    function nn(t) {
      if (ge.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function fn(t) {
      if (ge.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && V.current;
    }
    function cn(t, c) {
      {
        var p = function() {
          me || (me = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(t, c, p, v, A, L, F) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: F,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: A
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, v, A) {
      {
        var L, F = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), fn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ge.call(c, L) && !ie.hasOwnProperty(L) && (F[L] = c[L]);
        if (t && t.defaultProps) {
          var G = t.defaultProps;
          for (L in G)
            F[L] === void 0 && (F[L] = G[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && cn(F, _), te && pn(F, _);
        }
        return dn(t, j, te, A, v, V.current, F);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = he(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var t = O(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        t && t._owner && t._owner !== en.current && (v = " It was passed a child from " + O(t._owner.type) + "."), Pe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Pe(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var v = t[p];
            sn(v) && gn(v, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var A = N(t);
          if (typeof A == "function" && A !== t.entries)
            for (var L = A.call(t), F; !(F = L.next()).done; )
              sn(F.value) && gn(F.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          mn(p, t.props, "prop", v, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var A = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", A || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Pe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Pe(null);
            break;
          }
        }
        t.ref !== null && (Pe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Pe(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, v, A, L) {
      {
        var F = ae(t);
        if (!F) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var G;
          t === null ? G = "null" : x(t) ? G = "array" : t !== void 0 && t.$$typeof === n ? (G = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : G = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", G, j);
        }
        var _ = xn(t, c, p, A, L);
        if (_ == null)
          return _;
        if (F) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var de = 0; de < Z.length; de++)
                  Cn(Z[de], t);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, t);
        }
        if (ge.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, Se, $n, Se), Sn[Se + Ke] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    is.Fragment = i, is.jsx = Rn, is.jsxs = Mn;
  })()), is;
}
var sb;
function mU() {
  return sb || (sb = 1, process.env.NODE_ENV === "production" ? Ku.exports = dU() : Ku.exports = uU()), Ku.exports;
}
var M = mU(), CS = /* @__PURE__ */ ((e) => (e.Adjustment = "Adjustment", e.Automation = "Automation", e.BonusBalanceAdjustment = "BonusBalanceAdjustment", e.BonusPromotion = "BonusPromotion", e.BonusPromotionReturn = "BonusPromotionReturn", e.Manual = "Manual", e.PointTransactionCancellation = "PointTransactionCancellation", e.Purchase = "Purchase", e.ReceiptAdjustment = "ReceiptAdjustment", e.Return = "Return", e.RewardVoucher = "RewardVoucher", e.UpdateBalance = "UpdateBalance", e))(CS || {}), Om = /* @__PURE__ */ ((e) => (e.Addition = "Addition", e.Cancellation = "Cancellation", e.Deduction = "Deduction", e.Expiry = "Expiry", e))(Om || {});
const pU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePreferences" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_contactAttributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_ContactPatch" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }] } }] }, fU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_AddPointTransactionRequestModel_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointTransaction_AddPointTransacion" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }] }] } }] } }] }, hU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_GetContactById" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "meta" } }, { kind: "Field", name: { kind: "Name", value: "preferences" } }, { kind: "Field", name: { kind: "Name", value: "consents" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "comment" } }] } }] } }] } }] } }] }, yU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactOverviewById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactOverviewAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }] }] } }] } }] }, gU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactIdAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "mobilePhone" }, value: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ContactOverview_GetContactIdAsync_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_String_container" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "String" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ApiExceptionMultipleMatchesResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorCode" } }, { kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "requestId" } }, { kind: "Field", name: { kind: "Name", value: "messageDetails" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "multipleMatchesFound" } }] } }] } }] } }] } }] } }] } }] }, vU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getLatestMessagesByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactMessage_GetSmsMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetPostalMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetEmailMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }] } }] } }] }, kU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerTransactions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Transactions_GetTransactionsWithArticlesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "createdDate" } }, { kind: "Field", name: { kind: "Name", value: "transactionNumber" } }, { kind: "Field", name: { kind: "Name", value: "storeName" } }, { kind: "Field", name: { kind: "Name", value: "numberOfItems" } }, { kind: "Field", name: { kind: "Name", value: "netPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localNetPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localCurrency" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "localPrice" } }, { kind: "Field", name: { kind: "Name", value: "type" } }] } }] } }] } }] } }] } }] }, bU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrdersByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Orders_GetAllByContact" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderId" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "lastChangedAt" } }, { kind: "Field", name: { kind: "Name", value: "channel" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "externalStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "imageUri" } }, { kind: "Field", name: { kind: "Name", value: "targetUri" } }] } }] } }] } }] } }] } }] } }] } }] }, xU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointAccountV_GetPointAccounts" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_PointAccountModelV3" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "balance" } }] } }] } }] } }] } }] }, _U = {
  "\n  mutation updatePreferences(\n    $contactId: Voyado_UUID!\n    $input: Voyado_contactAttributes_Input!\n  ) {\n    Voyado {\n      ContactsV_ContactPatch(contactId: $contactId, input: $input) {\n        id\n      }\n    }\n  }\n": pU,
  "\n  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {\n    Voyado {\n      PointTransaction_AddPointTransacion(input: $input)\n    }\n  }\n": fU,
  "\n  query getContactById($contactId: Voyado_UUID!) {\n    Voyado {\n      ContactsV_GetContactById(contactId: $contactId) {\n        id\n        attributes\n        meta\n        preferences\n        consents {\n          id\n          date\n          value\n          source\n          comment\n        }\n      }\n    }\n  }\n": hU,
  "\n  query getContactOverviewById($contactId: String!) {\n    Voyado {\n      ContactOverview_GetContactOverviewAsync(contactId: $contactId)\n    }\n  }\n": yU,
  "\n  query getContactId($email: String!, $mobilePhone: String!) {\n    Voyado {\n      ContactOverview_GetContactIdAsync(\n        email: $email\n        mobilePhone: $mobilePhone\n      ) {\n        ... on Voyado_ContactOverview_GetContactIdAsync_response {\n          ... on Voyado_String_container {\n            String\n          }\n          ... on Voyado_ApiExceptionMultipleMatchesResponse {\n            errorCode\n            message\n            requestId\n            messageDetails {\n              multipleMatchesFound\n            }\n          }\n        }\n      }\n    }\n  }\n": gU,
  "\n  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {\n    Voyado {\n      ContactMessage_GetSmsMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetPostalMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetEmailMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n    }\n  }\n": vU,
  "\n  query getCustomerTransactions(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Transactions_GetTransactionsWithArticlesByContactId(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        count\n        totalCount\n        items {\n          id\n          createdDate\n          transactionNumber\n          storeName\n          numberOfItems\n          netPriceSum\n          localNetPriceSum\n          localCurrency\n          lineItems {\n            quantity\n            article {\n              name\n            }\n            localPrice\n            type\n          }\n        }\n      }\n    }\n  }\n": kU,
  "\n  query getOrdersByContactId(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Orders_GetAllByContact(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        totalCount\n        items {\n          orderId\n          createdAt\n          lastChangedAt\n          channel\n          status\n          externalStatus\n          totalPrice\n          currencyCode\n          lineItems {\n            items {\n              id\n              quantity\n              totalPrice\n              article {\n                sku\n                name\n                description\n                imageUri\n                targetUri\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": bU,
  "\n  query getPoints($contactId: Voyado_UUID!) {\n    Voyado {\n      PointAccountV_GetPointAccounts(contactId: $contactId) {\n        ... on Voyado_PointAccountModelV3 {\n          id\n          balance\n        }\n      }\n    }\n  }\n": xU
};
function Jr(e) {
  return _U[e] ?? {};
}
const SU = Jr(
  /* GraphQL */
  `
  query getContactById($contactId: Voyado_UUID!) {
    Voyado {
      ContactsV_GetContactById(contactId: $contactId) {
        id
        attributes
        meta
        preferences
        consents {
          id
          date
          value
          source
          comment
        }
      }
    }
  }
`
), NU = Jr(
  /* GraphQL */
  `
  query getContactOverviewById($contactId: String!) {
    Voyado {
      ContactOverview_GetContactOverviewAsync(contactId: $contactId)
    }
  }
`
), jU = Jr(
  /* GraphQL */
  `
  query getContactId($email: String!, $mobilePhone: String!) {
    Voyado {
      ContactOverview_GetContactIdAsync(
        email: $email
        mobilePhone: $mobilePhone
      ) {
        ... on Voyado_ContactOverview_GetContactIdAsync_response {
          ... on Voyado_String_container {
            String
          }
          ... on Voyado_ApiExceptionMultipleMatchesResponse {
            errorCode
            message
            requestId
            messageDetails {
              multipleMatchesFound
            }
          }
        }
      }
    }
  }
`
), wU = Jr(
  /* GraphQL */
  `
  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {
    Voyado {
      ContactMessage_GetSmsMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetPostalMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetEmailMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
    }
  }
`
), CU = Jr(
  /* GraphQL */
  `
  query getCustomerTransactions(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Transactions_GetTransactionsWithArticlesByContactId(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        count
        totalCount
        items {
          id
          createdDate
          transactionNumber
          storeName
          numberOfItems
          netPriceSum
          localNetPriceSum
          localCurrency
          lineItems {
            quantity
            article {
              name
            }
            localPrice
            type
          }
        }
      }
    }
  }
`
), FU = Jr(
  /* GraphQL */
  `
  query getOrdersByContactId(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Orders_GetAllByContact(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        totalCount
        items {
          orderId
          createdAt
          lastChangedAt
          channel
          status
          externalStatus
          totalPrice
          currencyCode
          lineItems {
            items {
              id
              quantity
              totalPrice
              article {
                sku
                name
                description
                imageUri
                targetUri
              }
            }
          }
        }
      }
    }
  }
`
), IU = Jr(
  /* GraphQL */
  `
  query getPoints($contactId: Voyado_UUID!) {
    Voyado {
      PointAccountV_GetPointAccounts(contactId: $contactId) {
        ... on Voyado_PointAccountModelV3 {
          id
          balance
        }
      }
    }
  }
`
), EU = Jr(
  /* GraphQL */
  `
  mutation updatePreferences(
    $contactId: Voyado_UUID!
    $input: Voyado_contactAttributes_Input!
  ) {
    Voyado {
      ContactsV_ContactPatch(contactId: $contactId, input: $input) {
        id
      }
    }
  }
`
), TU = Jr(
  /* GraphQL */
  `
  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {
    Voyado {
      PointTransaction_AddPointTransacion(input: $input)
    }
  }
`
), $U = ({
  contactId: e
}) => {
  const { useQuery: n } = hn(), { track: r } = _n(), [i, a] = le(), [o, s] = le(), [l, d] = le(), {
    loading: m,
    error: u,
    data: f,
    refetch: h
  } = n(SU, {
    skip: !e,
    variables: { contactId: e }
  });
  return He(() => {
    const g = f?.Voyado?.ContactsV_GetContactById;
    !m && g && typeof g == "object" && ("id" in g && r("voyado:profile:received", { hasProfile: !0 }), "attributes" in g && a(g.attributes), "preferences" in g && s(g.preferences), "consents" in g && d(
      g?.consents?.filter(
        (C) => C !== null
      ) || void 0
    )), !m && (!g || typeof g != "object") && r("voyado:profile:received", { hasProfile: !1 });
  }, [f?.Voyado, m]), Bn(
    () => ({
      isLoading: m,
      error: u,
      refetch: h,
      attributes: i,
      preferences: o,
      consents: l
    }),
    [u, i, o, l]
  );
};
function xs(e = !1, n) {
  const [r, i] = le(e);
  return He(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const DU = {
  count: 0,
  items: []
}, RU = ({
  contactId: e
}) => {
  const { useQuery: n } = hn(), { track: r } = _n(), [i, a] = le(DU), {
    loading: o,
    error: s,
    data: l
  } = n(wU, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return He(() => {
    if (!o && (l?.Voyado?.ContactMessage_GetSmsMessagesByContactId || l?.Voyado?.ContactMessage_GetPostalMessagesByContactId || l?.Voyado?.ContactMessage_GetEmailMessagesByContactId)) {
      const d = l?.Voyado?.ContactMessage_GetEmailMessagesByContactId, m = l?.Voyado?.ContactMessage_GetSmsMessagesByContactId, u = l?.Voyado?.ContactMessage_GetPostalMessagesByContactId, f = {
        count: (m?.count ?? 0) + (u?.count ?? 0) + (d?.count ?? 0),
        items: [
          ...m.items ?? [],
          ...d.items ?? [],
          ...u.items ?? []
        ]
      };
      a(f), r("voyado:messages:received", {
        emailsReceived: d.count ?? 0,
        smsReceived: m.count ?? 0,
        postalReceived: u.count ?? 0,
        total: f.count ?? 0
      });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    lastMessages: i
  };
}, OU = {
  count: 0,
  totalCount: 0,
  items: []
}, AU = ({
  contactId: e
}) => {
  const { useQuery: n } = hn(), { track: r } = _n(), [i, a] = le(
    OU
  ), {
    loading: o,
    error: s,
    data: l
  } = n(CU, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return He(() => {
    const d = l?.Voyado?.Transactions_GetTransactionsWithArticlesByContactId;
    if (!o && d) {
      a(
        d
      );
      const { count: m } = d;
      m && r("voyado:transactions:received", { count: m });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    transactions: i
  };
}, PU = ({
  conversationContext: e
}) => {
  const { useQuery: n } = hn(), [r, i] = le(void 0), [a, o] = le(!1), { customer: s } = e, l = !!s?.email || !!s?.phone_number, {
    loading: d,
    error: m,
    data: u,
    refetch: f
  } = n(jU, {
    skip: !l,
    variables: {
      email: s?.email ?? "",
      mobilePhone: s?.phone_number ?? ""
    }
  });
  return He(() => {
    const h = u?.Voyado?.ContactOverview_GetContactIdAsync;
    h?.__typename === "Voyado_ApiExceptionMultipleMatchesResponse" && h?.messageDetails?.multipleMatchesFound && h?.messageDetails?.multipleMatchesFound.length > 0 && (o(!0), i(void 0)), h?.__typename === "Voyado_String_container" && h?.String && (o(!1), i(h.String));
  }, [u?.Voyado, d]), {
    isLoading: d,
    contactId: r,
    hasMultipleContacts: a,
    error: m,
    refetch: f
  };
}, LU = ({
  contactId: e,
  skip: n
}) => {
  const { useQuery: r } = hn(), [i, a] = le(
    void 0
  ), {
    loading: o,
    error: s,
    data: l,
    refetch: d
  } = r(NU, {
    skip: !e || n,
    variables: { contactId: e }
  });
  return He(() => {
    const m = l?.Voyado?.ContactOverview_GetContactOverviewAsync;
    if (!o && m && Object.hasOwn(m, "memberlevel")) {
      const u = m?.memberlevel;
      a({
        levelName: u?.levelName,
        remainingToUpgrade: u?.remainingToUpgrade,
        basedOnRewardPoints: u?.basedOnRewardPoints,
        levelId: u?.levelId,
        latestChange: u?.latestChange,
        expires: u?.expires
      });
    } else
      a(void 0);
  }, [l?.Voyado, o]), Bn(
    () => ({
      isLoading: o,
      error: s,
      memberLevel: i,
      refetch: d
    }),
    [o, s, i, d]
  );
}, VU = "_pointer_ls8kj_48", zU = "_list_ls8kj_53", UU = "_listItem_ls8kj_63", rt = {
  pointer: VU,
  list: zU,
  listItem: UU
};
var Eo = (e) => e.type === "checkbox", gi = (e) => e instanceof Date, qt = (e) => e == null;
const FS = (e) => typeof e == "object";
var pt = (e) => !qt(e) && !Array.isArray(e) && FS(e) && !gi(e), IS = (e) => pt(e) && e.target ? Eo(e.target) ? e.target.checked : e.target.value : e, MU = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, ES = (e, n) => e.has(MU(n)), BU = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return pt(n) && n.hasOwnProperty("isPrototypeOf");
}, Yp = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Ft(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Yp && (e instanceof Blob || i)) && (r || pt(e)))
    if (n = r ? [] : {}, !r && !BU(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = Ft(e[a]));
  else
    return e;
  return n;
}
var pl = (e) => Array.isArray(e) ? e.filter(Boolean) : [], ct = (e) => e === void 0, Xe = (e, n, r) => {
  if (!n || !pt(e))
    return r;
  const i = pl(n.split(/[,[\].]+?/)).reduce((a, o) => qt(a) ? a : a[o], e);
  return ct(i) || i === e ? ct(e[n]) ? r : e[n] : i;
}, ir = (e) => typeof e == "boolean", Qp = (e) => /^\w*$/.test(e), TS = (e) => pl(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Yn = (e, n, r) => {
  let i = -1;
  const a = Qp(n) ? [n] : TS(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = pt(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const Ls = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, br = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Hr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, qU = Fe.createContext(null), Jp = () => Fe.useContext(qU);
var $S = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== br.all && (n._proxyFormState[s] = !i || br.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function HU(e) {
  const n = Jp(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = Fe.useState(r._formState), d = Fe.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = Fe.useRef(a);
  return m.current = a, Fe.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), Fe.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), Fe.useMemo(() => $S(s, r, d.current, !1), [s, r]);
}
var Rr = (e) => typeof e == "string", DS = (e, n, r, i, a) => Rr(e) ? (i && n.watch.add(e), Xe(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Xe(r, o))) : (i && (n.watchAll = !0), r);
function RS(e) {
  const n = Jp(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = Fe.useRef(i), d = Fe.useRef(a);
  l.current = i, Fe.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(DS(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = Fe.useState(r._getWatch(i, a));
  return Fe.useEffect(() => r._removeUnmounted()), m;
}
function WU(e) {
  const n = Jp(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = ES(a._names.array, r), l = RS({
    control: a,
    name: r,
    defaultValue: Xe(a._formValues, r, Xe(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = HU({
    control: a,
    name: r,
    exact: !0
  }), m = Fe.useRef(e), u = Fe.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...ir(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Fe.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Xe(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Xe(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Xe(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Xe(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => Xe(d.errors, r)
    }
  }), [d, r]), h = Fe.useCallback((N) => u.current.onChange({
    target: {
      value: IS(N),
      name: r
    },
    type: Ls.CHANGE
  }), [r]), g = Fe.useCallback(() => u.current.onBlur({
    target: {
      value: Xe(a._formValues, r),
      name: r
    },
    type: Ls.BLUR
  }), [r, a._formValues]), C = Fe.useCallback((N) => {
    const w = Xe(a._fields, r);
    w && N && (w._f.ref = {
      focus: () => N.focus(),
      select: () => N.select(),
      setCustomValidity: (y) => N.setCustomValidity(y),
      reportValidity: () => N.reportValidity()
    });
  }, [a._fields, r]), S = Fe.useMemo(() => ({
    name: r,
    value: l,
    ...ir(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: g,
    ref: C
  }), [r, i, d.disabled, h, g, C, l]);
  return Fe.useEffect(() => {
    const N = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...ir(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const w = (y, z) => {
      const $ = Xe(a._fields, y);
      $ && $._f && ($._f.mount = z);
    };
    if (w(r, !0), N) {
      const y = Ft(Xe(a._options.defaultValues, r));
      Yn(a._defaultValues, r, y), ct(Xe(a._formValues, r)) && Yn(a._formValues, r, y);
    }
    return !s && a.register(r), () => {
      (s ? N && !a._state.action : N) ? a.unregister(r) : w(r, !1);
    };
  }, [r, a, s, o]), Fe.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), Fe.useMemo(() => ({
    field: S,
    formState: d,
    fieldState: f
  }), [S, d, f]);
}
const lb = (e) => e.render(WU(e));
var GU = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, so = (e) => Array.isArray(e) ? e : [e], cb = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const r of e)
        r.next && r.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((r) => r !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, Am = (e) => qt(e) || !FS(e);
function ri(e, n) {
  if (Am(e) || Am(n))
    return e === n;
  if (gi(e) && gi(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (gi(o) && gi(s) || pt(o) && pt(s) || Array.isArray(o) && Array.isArray(s) ? !ri(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Ut = (e) => pt(e) && !Object.keys(e).length, Xp = (e) => e.type === "file", xr = (e) => typeof e == "function", Vs = (e) => {
  if (!Yp)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, OS = (e) => e.type === "select-multiple", Zp = (e) => e.type === "radio", KU = (e) => Zp(e) || Eo(e), Yu = (e) => Vs(e) && e.isConnected;
function YU(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = ct(e) ? i++ : e[n[i++]];
  return e;
}
function QU(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !ct(e[n]))
      return !1;
  return !0;
}
function kt(e, n) {
  const r = Array.isArray(n) ? n : Qp(n) ? [n] : TS(n), i = r.length === 1 ? e : YU(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (pt(i) && Ut(i) || Array.isArray(i) && QU(i)) && kt(e, r.slice(0, -1)), e;
}
var AS = (e) => {
  for (const n in e)
    if (xr(e[n]))
      return !0;
  return !1;
};
function zs(e, n = {}) {
  const r = Array.isArray(e);
  if (pt(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || pt(e[i]) && !AS(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, zs(e[i], n[i])) : qt(e[i]) || (n[i] = !0);
  return n;
}
function PS(e, n, r) {
  const i = Array.isArray(e);
  if (pt(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || pt(e[a]) && !AS(e[a]) ? ct(n) || Am(r[a]) ? r[a] = Array.isArray(e[a]) ? zs(e[a], []) : { ...zs(e[a]) } : PS(e[a], qt(n) ? {} : n[a], r[a]) : r[a] = !ri(e[a], n[a]);
  return r;
}
var Wa = (e, n) => PS(e, n, zs(n));
const db = {
  value: !1,
  isValid: !1
}, ub = { value: !0, isValid: !0 };
var LS = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !ct(e[0].attributes.value) ? ct(e[0].value) || e[0].value === "" ? ub : { value: e[0].value, isValid: !0 } : ub
    ) : db;
  }
  return db;
}, VS = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => ct(e) ? e : n ? e === "" ? NaN : e && +e : r && Rr(e) ? new Date(e) : i ? i(e) : e;
const mb = {
  isValid: !1,
  value: null
};
var zS = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, mb) : mb;
function pb(e) {
  const n = e.ref;
  return Xp(n) ? n.files : Zp(n) ? zS(e.refs).value : OS(n) ? [...n.selectedOptions].map(({ value: r }) => r) : Eo(n) ? LS(e.refs).value : VS(ct(n.value) ? e.ref.value : n.value, e);
}
var JU = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = Xe(n, o);
    s && Yn(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, Us = (e) => e instanceof RegExp, Ga = (e) => ct(e) ? e : Us(e) ? e.source : pt(e) ? Us(e.value) ? e.value.source : e.value : e, fb = (e) => ({
  isOnSubmit: !e || e === br.onSubmit,
  isOnBlur: e === br.onBlur,
  isOnChange: e === br.onChange,
  isOnAll: e === br.all,
  isOnTouch: e === br.onTouched
});
const hb = "AsyncFunction";
var XU = (e) => !!e && !!e.validate && !!(xr(e.validate) && e.validate.constructor.name === hb || pt(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === hb)), ZU = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), yb = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const lo = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = Xe(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (lo(l, n))
          break;
      } else if (pt(l) && lo(l, n))
        break;
    }
  }
};
function gb(e, n, r) {
  const i = Xe(e, r);
  if (i || Qp(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Xe(n, o), l = Xe(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var eM = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Ut(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || br.all));
}, nM = (e, n, r) => !e || !n || e === n || so(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), tM = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, rM = (e, n) => !pl(Xe(e, n)).length && kt(e, n), iM = (e, n, r) => {
  const i = so(Xe(e, r));
  return Yn(i, "root", n[r]), Yn(e, r, i), e;
}, _s = (e) => Rr(e);
function vb(e, n, r = "validate") {
  if (_s(e) || Array.isArray(e) && e.every(_s) || ir(e) && !e)
    return {
      type: r,
      message: _s(e) ? e : "",
      ref: n
    };
}
var Hi = (e) => pt(e) && !Us(e) ? e : {
  value: e,
  message: ""
}, kb = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: g, validate: C, name: S, valueAsNumber: N, mount: w } = e._f, y = Xe(r, S);
  if (!w || n.has(S))
    return {};
  const z = l ? l[0] : s, $ = (B) => {
    a && z.reportValidity && (z.setCustomValidity(ir(B) ? "" : B || ""), z.reportValidity());
  }, I = {}, T = Zp(s), U = Eo(s), Q = T || U, J = (N || Xp(s)) && ct(s.value) && ct(y) || Vs(s) && s.value === "" || y === "" || Array.isArray(y) && !y.length, ae = GU.bind(null, S, i, I), X = (B, O, q, ee = Hr.maxLength, ve = Hr.minLength) => {
    const ue = B ? O : q;
    I[S] = {
      type: B ? ee : ve,
      message: ue,
      ref: s,
      ...ae(B ? ee : ve, ue)
    };
  };
  if (o ? !Array.isArray(y) || !y.length : d && (!Q && (J || qt(y)) || ir(y) && !y || U && !LS(l).isValid || T && !zS(l).isValid)) {
    const { value: B, message: O } = _s(d) ? { value: !!d, message: d } : Hi(d);
    if (B && (I[S] = {
      type: Hr.required,
      message: O,
      ref: z,
      ...ae(Hr.required, O)
    }, !i))
      return $(O), I;
  }
  if (!J && (!qt(f) || !qt(h))) {
    let B, O;
    const q = Hi(h), ee = Hi(f);
    if (!qt(y) && !isNaN(y)) {
      const ve = s.valueAsNumber || y && +y;
      qt(q.value) || (B = ve > q.value), qt(ee.value) || (O = ve < ee.value);
    } else {
      const ve = s.valueAsDate || new Date(y), ue = (W) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + W), ce = s.type == "time", fe = s.type == "week";
      Rr(q.value) && y && (B = ce ? ue(y) > ue(q.value) : fe ? y > q.value : ve > new Date(q.value)), Rr(ee.value) && y && (O = ce ? ue(y) < ue(ee.value) : fe ? y < ee.value : ve < new Date(ee.value));
    }
    if ((B || O) && (X(!!B, q.message, ee.message, Hr.max, Hr.min), !i))
      return $(I[S].message), I;
  }
  if ((m || u) && !J && (Rr(y) || o && Array.isArray(y))) {
    const B = Hi(m), O = Hi(u), q = !qt(B.value) && y.length > +B.value, ee = !qt(O.value) && y.length < +O.value;
    if ((q || ee) && (X(q, B.message, O.message), !i))
      return $(I[S].message), I;
  }
  if (g && !J && Rr(y)) {
    const { value: B, message: O } = Hi(g);
    if (Us(B) && !y.match(B) && (I[S] = {
      type: Hr.pattern,
      message: O,
      ref: s,
      ...ae(Hr.pattern, O)
    }, !i))
      return $(O), I;
  }
  if (C) {
    if (xr(C)) {
      const B = await C(y, r), O = vb(B, z);
      if (O && (I[S] = {
        ...O,
        ...ae(Hr.validate, O.message)
      }, !i))
        return $(O.message), I;
    } else if (pt(C)) {
      let B = {};
      for (const O in C) {
        if (!Ut(B) && !i)
          break;
        const q = vb(await C[O](y, r), z, O);
        q && (B = {
          ...q,
          ...ae(O, q.message)
        }, $(q.message), i && (I[S] = B));
      }
      if (!Ut(B) && (I[S] = {
        ref: z,
        ...B
      }, !i))
        return I;
    }
  }
  return $(!0), I;
};
const aM = {
  mode: br.onSubmit,
  reValidateMode: br.onChange,
  shouldFocusError: !0
};
function oM(e = {}) {
  let n = {
    ...aM,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: xr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = pt(n.defaultValues) || pt(n.values) ? Ft(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : Ft(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: cb(),
    state: cb()
  }, g = fb(n.mode), C = fb(n.reValidateMode), S = n.criteriaMode === br.all, N = (E) => (x) => {
    clearTimeout(m), m = setTimeout(E, x);
  }, w = async (E) => {
    if (!n.disabled && (u.isValid || f.isValid || E)) {
      const x = n.resolver ? Ut((await J()).errors) : await X(i, !0);
      x !== r.isValid && h.state.next({
        isValid: x
      });
    }
  }, y = (E, x) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((E || Array.from(l.mount)).forEach((D) => {
      D && (x ? Yn(r.validatingFields, D, x) : kt(r.validatingFields, D));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Ut(r.validatingFields)
    }));
  }, z = (E, x = [], D, H, Y = !0, R = !0) => {
    if (H && D && !n.disabled) {
      if (s.action = !0, R && Array.isArray(Xe(i, E))) {
        const V = D(Xe(i, E), H.argA, H.argB);
        Y && Yn(i, E, V);
      }
      if (R && Array.isArray(Xe(r.errors, E))) {
        const V = D(Xe(r.errors, E), H.argA, H.argB);
        Y && Yn(r.errors, E, V), rM(r.errors, E);
      }
      if ((u.touchedFields || f.touchedFields) && R && Array.isArray(Xe(r.touchedFields, E))) {
        const V = D(Xe(r.touchedFields, E), H.argA, H.argB);
        Y && Yn(r.touchedFields, E, V);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = Wa(a, o)), h.state.next({
        name: E,
        isDirty: O(E, x),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Yn(o, E, x);
  }, $ = (E, x) => {
    Yn(r.errors, E, x), h.state.next({
      errors: r.errors
    });
  }, I = (E) => {
    r.errors = E, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, T = (E, x, D, H) => {
    const Y = Xe(i, E);
    if (Y) {
      const R = Xe(o, E, ct(D) ? Xe(a, E) : D);
      ct(R) || H && H.defaultChecked || x ? Yn(o, E, x ? R : pb(Y._f)) : ve(E, R), s.mount && w();
    }
  }, U = (E, x, D, H, Y) => {
    let R = !1, V = !1;
    const ie = {
      name: E
    };
    if (!n.disabled) {
      if (!D || H) {
        (u.isDirty || f.isDirty) && (V = r.isDirty, r.isDirty = ie.isDirty = O(), R = V !== ie.isDirty);
        const me = ri(Xe(a, E), x);
        V = !!Xe(r.dirtyFields, E), me ? kt(r.dirtyFields, E) : Yn(r.dirtyFields, E, !0), ie.dirtyFields = r.dirtyFields, R = R || (u.dirtyFields || f.dirtyFields) && V !== !me;
      }
      if (D) {
        const me = Xe(r.touchedFields, E);
        me || (Yn(r.touchedFields, E, D), ie.touchedFields = r.touchedFields, R = R || (u.touchedFields || f.touchedFields) && me !== D);
      }
      R && Y && h.state.next(ie);
    }
    return R ? ie : {};
  }, Q = (E, x, D, H) => {
    const Y = Xe(r.errors, E), R = (u.isValid || f.isValid) && ir(x) && r.isValid !== x;
    if (n.delayError && D ? (d = N(() => $(E, D)), d(n.delayError)) : (clearTimeout(m), d = null, D ? Yn(r.errors, E, D) : kt(r.errors, E)), (D ? !ri(Y, D) : Y) || !Ut(H) || R) {
      const V = {
        ...H,
        ...R && ir(x) ? { isValid: x } : {},
        errors: r.errors,
        name: E
      };
      r = {
        ...r,
        ...V
      }, h.state.next(V);
    }
  }, J = async (E) => {
    y(E, !0);
    const x = await n.resolver(o, n.context, JU(E || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return y(E), x;
  }, ae = async (E) => {
    const { errors: x } = await J(E);
    if (E)
      for (const D of E) {
        const H = Xe(x, D);
        H ? Yn(r.errors, D, H) : kt(r.errors, D);
      }
    else
      r.errors = x;
    return x;
  }, X = async (E, x, D = {
    valid: !0
  }) => {
    for (const H in E) {
      const Y = E[H];
      if (Y) {
        const { _f: R, ...V } = Y;
        if (R) {
          const ie = l.array.has(R.name), me = Y._f && XU(Y._f);
          me && u.validatingFields && y([H], !0);
          const Ne = await kb(Y, l.disabled, o, S, n.shouldUseNativeValidation && !x, ie);
          if (me && u.validatingFields && y([H]), Ne[R.name] && (D.valid = !1, x))
            break;
          !x && (Xe(Ne, R.name) ? ie ? iM(r.errors, Ne, R.name) : Yn(r.errors, R.name, Ne[R.name]) : kt(r.errors, R.name));
        }
        !Ut(V) && await X(V, x, D);
      }
    }
    return D.valid;
  }, B = () => {
    for (const E of l.unMount) {
      const x = Xe(i, E);
      x && (x._f.refs ? x._f.refs.every((D) => !Yu(D)) : !Yu(x._f.ref)) && ze(E);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, O = (E, x) => !n.disabled && (E && x && Yn(o, E, x), !ri(Ie(), a)), q = (E, x, D) => DS(E, l, {
    ...s.mount ? o : ct(x) ? a : Rr(E) ? { [E]: x } : x
  }, D, x), ee = (E) => pl(Xe(s.mount ? o : a, E, n.shouldUnregister ? Xe(a, E, []) : [])), ve = (E, x, D = {}) => {
    const H = Xe(i, E);
    let Y = x;
    if (H) {
      const R = H._f;
      R && (!R.disabled && Yn(o, E, VS(x, R)), Y = Vs(R.ref) && qt(x) ? "" : x, OS(R.ref) ? [...R.ref.options].forEach((V) => V.selected = Y.includes(V.value)) : R.refs ? Eo(R.ref) ? R.refs.length > 1 ? R.refs.forEach((V) => (!V.defaultChecked || !V.disabled) && (V.checked = Array.isArray(Y) ? !!Y.find((ie) => ie === V.value) : Y === V.value)) : R.refs[0] && (R.refs[0].checked = !!Y) : R.refs.forEach((V) => V.checked = V.value === Y) : Xp(R.ref) ? R.ref.value = "" : (R.ref.value = Y, R.ref.type || h.state.next({
        name: E,
        values: Ft(o)
      })));
    }
    (D.shouldDirty || D.shouldTouch) && U(E, Y, D.shouldTouch, D.shouldDirty, !0), D.shouldValidate && xe(E);
  }, ue = (E, x, D) => {
    for (const H in x) {
      const Y = x[H], R = `${E}.${H}`, V = Xe(i, R);
      (l.array.has(E) || pt(Y) || V && !V._f) && !gi(Y) ? ue(R, Y, D) : ve(R, Y, D);
    }
  }, ce = (E, x, D = {}) => {
    const H = Xe(i, E), Y = l.array.has(E), R = Ft(x);
    Yn(o, E, R), Y ? (h.array.next({
      name: E,
      values: Ft(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && D.shouldDirty && h.state.next({
      name: E,
      dirtyFields: Wa(a, o),
      isDirty: O(E, R)
    })) : H && !H._f && !qt(R) ? ue(E, R, D) : ve(E, R, D), yb(E, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? E : void 0,
      values: Ft(o)
    });
  }, fe = async (E) => {
    s.mount = !0;
    const x = E.target;
    let D = x.name, H = !0;
    const Y = Xe(i, D), R = (V) => {
      H = Number.isNaN(V) || gi(V) && isNaN(V.getTime()) || ri(V, Xe(o, D, V));
    };
    if (Y) {
      let V, ie;
      const me = x.type ? pb(Y._f) : IS(E), Ne = E.type === Ls.BLUR || E.type === Ls.FOCUS_OUT, nn = !ZU(Y._f) && !n.resolver && !Xe(r.errors, D) && !Y._f.deps || tM(Ne, Xe(r.touchedFields, D), r.isSubmitted, C, g), fn = yb(D, l, Ne);
      Yn(o, D, me), Ne ? (Y._f.onBlur && Y._f.onBlur(E), d && d(0)) : Y._f.onChange && Y._f.onChange(E);
      const tn = U(D, me, Ne), cn = !Ut(tn) || fn;
      if (!Ne && h.state.next({
        name: D,
        type: E.type,
        values: Ft(o)
      }), nn)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? Ne && w() : Ne || w()), cn && h.state.next({ name: D, ...fn ? {} : tn });
      if (!Ne && fn && h.state.next({ ...r }), n.resolver) {
        const { errors: pn } = await J([D]);
        if (R(me), H) {
          const dn = gb(r.errors, i, D), xn = gb(pn, i, dn.name || D);
          V = xn.error, D = xn.name, ie = Ut(pn);
        }
      } else
        y([D], !0), V = (await kb(Y, l.disabled, o, S, n.shouldUseNativeValidation))[D], y([D]), R(me), H && (V ? ie = !1 : (u.isValid || f.isValid) && (ie = await X(i, !0)));
      H && (Y._f.deps && xe(Y._f.deps), Q(D, ie, V, tn));
    }
  }, W = (E, x) => {
    if (Xe(r.errors, x) && E.focus)
      return E.focus(), 1;
  }, xe = async (E, x = {}) => {
    let D, H;
    const Y = so(E);
    if (n.resolver) {
      const R = await ae(ct(E) ? E : Y);
      D = Ut(R), H = E ? !Y.some((V) => Xe(R, V)) : D;
    } else E ? (H = (await Promise.all(Y.map(async (R) => {
      const V = Xe(i, R);
      return await X(V && V._f ? { [R]: V } : V);
    }))).every(Boolean), !(!H && !r.isValid) && w()) : H = D = await X(i);
    return h.state.next({
      ...!Rr(E) || (u.isValid || f.isValid) && D !== r.isValid ? {} : { name: E },
      ...n.resolver || !E ? { isValid: D } : {},
      errors: r.errors
    }), x.shouldFocus && !H && lo(i, W, E ? Y : l.mount), H;
  }, Ie = (E) => {
    const x = {
      ...s.mount ? o : a
    };
    return ct(E) ? x : Rr(E) ? Xe(x, E) : E.map((D) => Xe(x, D));
  }, K = (E, x) => ({
    invalid: !!Xe((x || r).errors, E),
    isDirty: !!Xe((x || r).dirtyFields, E),
    error: Xe((x || r).errors, E),
    isValidating: !!Xe(r.validatingFields, E),
    isTouched: !!Xe((x || r).touchedFields, E)
  }), qe = (E) => {
    E && so(E).forEach((x) => kt(r.errors, x)), h.state.next({
      errors: E ? r.errors : {}
    });
  }, Be = (E, x, D) => {
    const H = (Xe(i, E, { _f: {} })._f || {}).ref, Y = Xe(r.errors, E) || {}, { ref: R, message: V, type: ie, ...me } = Y;
    Yn(r.errors, E, {
      ...me,
      ...x,
      ref: H
    }), h.state.next({
      name: E,
      errors: r.errors,
      isValid: !1
    }), D && D.shouldFocus && H && H.focus && H.focus();
  }, Oe = (E, x) => xr(E) ? h.state.subscribe({
    next: (D) => E(q(void 0, x), D)
  }) : q(E, x, !0), Me = (E) => h.state.subscribe({
    next: (x) => {
      nM(E.name, x.name, E.exact) && eM(x, E.formState || u, Ae, E.reRenderRoot) && E.callback({
        values: { ...o },
        ...r,
        ...x
      });
    }
  }).unsubscribe, $e = (E) => (s.mount = !0, f = {
    ...f,
    ...E.formState
  }, Me({
    ...E,
    formState: f
  })), ze = (E, x = {}) => {
    for (const D of E ? so(E) : l.mount)
      l.mount.delete(D), l.array.delete(D), x.keepValue || (kt(i, D), kt(o, D)), !x.keepError && kt(r.errors, D), !x.keepDirty && kt(r.dirtyFields, D), !x.keepTouched && kt(r.touchedFields, D), !x.keepIsValidating && kt(r.validatingFields, D), !n.shouldUnregister && !x.keepDefaultValue && kt(a, D);
    h.state.next({
      values: Ft(o)
    }), h.state.next({
      ...r,
      ...x.keepDirty ? { isDirty: O() } : {}
    }), !x.keepIsValid && w();
  }, Re = ({ disabled: E, name: x }) => {
    (ir(E) && s.mount || E || l.disabled.has(x)) && (E ? l.disabled.add(x) : l.disabled.delete(x));
  }, an = (E, x = {}) => {
    let D = Xe(i, E);
    const H = ir(x.disabled) || ir(n.disabled);
    return Yn(i, E, {
      ...D || {},
      _f: {
        ...D && D._f ? D._f : { ref: { name: E } },
        name: E,
        mount: !0,
        ...x
      }
    }), l.mount.add(E), D ? Re({
      disabled: ir(x.disabled) ? x.disabled : n.disabled,
      name: E
    }) : T(E, !0, x.value), {
      ...H ? { disabled: x.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!x.required,
        min: Ga(x.min),
        max: Ga(x.max),
        minLength: Ga(x.minLength),
        maxLength: Ga(x.maxLength),
        pattern: Ga(x.pattern)
      } : {},
      name: E,
      onChange: fe,
      onBlur: fe,
      ref: (Y) => {
        if (Y) {
          an(E, x), D = Xe(i, E);
          const R = ct(Y.value) && Y.querySelectorAll && Y.querySelectorAll("input,select,textarea")[0] || Y, V = KU(R), ie = D._f.refs || [];
          if (V ? ie.find((me) => me === R) : R === D._f.ref)
            return;
          Yn(i, E, {
            _f: {
              ...D._f,
              ...V ? {
                refs: [
                  ...ie.filter(Yu),
                  R,
                  ...Array.isArray(Xe(a, E)) ? [{}] : []
                ],
                ref: { type: R.type, name: E }
              } : { ref: R }
            }
          }), T(E, !1, void 0, R);
        } else
          D = Xe(i, E, {}), D._f && (D._f.mount = !1), (n.shouldUnregister || x.shouldUnregister) && !(ES(l.array, E) && s.action) && l.unMount.add(E);
      }
    };
  }, Ee = () => n.shouldFocusError && lo(i, W, l.mount), Ge = (E) => {
    ir(E) && (h.state.next({ disabled: E }), lo(i, (x, D) => {
      const H = Xe(i, D);
      H && (x.disabled = H._f.disabled || E, Array.isArray(H._f.refs) && H._f.refs.forEach((Y) => {
        Y.disabled = H._f.disabled || E;
      }));
    }, 0, !1));
  }, Qe = (E, x) => async (D) => {
    let H;
    D && (D.preventDefault && D.preventDefault(), D.persist && D.persist());
    let Y = Ft(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: R, values: V } = await J();
      r.errors = R, Y = V;
    } else
      await X(i);
    if (l.disabled.size)
      for (const R of l.disabled)
        Yn(Y, R, void 0);
    if (kt(r.errors, "root"), Ut(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await E(Y, D);
      } catch (R) {
        H = R;
      }
    } else
      x && await x({ ...r.errors }, D), Ee(), setTimeout(Ee);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Ut(r.errors) && !H,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), H)
      throw H;
  }, he = (E, x = {}) => {
    Xe(i, E) && (ct(x.defaultValue) ? ce(E, Ft(Xe(a, E))) : (ce(E, x.defaultValue), Yn(a, E, Ft(x.defaultValue))), x.keepTouched || kt(r.touchedFields, E), x.keepDirty || (kt(r.dirtyFields, E), r.isDirty = x.defaultValue ? O(E, Ft(Xe(a, E))) : O()), x.keepError || (kt(r.errors, E), u.isValid && w()), h.state.next({ ...r }));
  }, ge = (E, x = {}) => {
    const D = E ? Ft(E) : a, H = Ft(D), Y = Ut(E), R = Y ? a : H;
    if (x.keepDefaultValues || (a = D), !x.keepValues) {
      if (x.keepDirtyValues) {
        const V = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(Wa(a, o))
        ]);
        for (const ie of Array.from(V))
          Xe(r.dirtyFields, ie) ? Yn(R, ie, Xe(o, ie)) : ce(ie, Xe(R, ie));
      } else {
        if (Yp && ct(E))
          for (const V of l.mount) {
            const ie = Xe(i, V);
            if (ie && ie._f) {
              const me = Array.isArray(ie._f.refs) ? ie._f.refs[0] : ie._f.ref;
              if (Vs(me)) {
                const Ne = me.closest("form");
                if (Ne) {
                  Ne.reset();
                  break;
                }
              }
            }
          }
        for (const V of l.mount)
          ce(V, Xe(R, V));
      }
      o = Ft(R), h.array.next({
        values: { ...R }
      }), h.state.next({
        values: { ...R }
      });
    }
    l = {
      mount: x.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!x.keepIsValid || !!x.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: x.keepSubmitCount ? r.submitCount : 0,
      isDirty: Y ? !1 : x.keepDirty ? r.isDirty : !!(x.keepDefaultValues && !ri(E, a)),
      isSubmitted: x.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: Y ? {} : x.keepDirtyValues ? x.keepDefaultValues && o ? Wa(a, o) : r.dirtyFields : x.keepDefaultValues && E ? Wa(a, E) : x.keepDirty ? r.dirtyFields : {},
      touchedFields: x.keepTouched ? r.touchedFields : {},
      errors: x.keepErrors ? r.errors : {},
      isSubmitSuccessful: x.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, De = (E, x) => ge(xr(E) ? E(o) : E, x), Le = (E, x = {}) => {
    const D = Xe(i, E), H = D && D._f;
    if (H) {
      const Y = H.refs ? H.refs[0] : H.ref;
      Y.focus && (Y.focus(), x.shouldSelect && xr(Y.select) && Y.select());
    }
  }, Ae = (E) => {
    r = {
      ...r,
      ...E
    };
  }, mn = {
    control: {
      register: an,
      unregister: ze,
      getFieldState: K,
      handleSubmit: Qe,
      setError: Be,
      _subscribe: Me,
      _runSchema: J,
      _getWatch: q,
      _getDirty: O,
      _setValid: w,
      _setFieldArray: z,
      _setDisabledField: Re,
      _setErrors: I,
      _getFieldArray: ee,
      _reset: ge,
      _resetDefaultValues: () => xr(n.defaultValues) && n.defaultValues().then((E) => {
        De(E, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: B,
      _disableForm: Ge,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(E) {
        s = E;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(E) {
        l = E;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(E) {
        n = {
          ...n,
          ...E
        };
      }
    },
    subscribe: $e,
    trigger: xe,
    register: an,
    handleSubmit: Qe,
    watch: Oe,
    setValue: ce,
    getValues: Ie,
    reset: De,
    resetField: he,
    clearErrors: qe,
    unregister: ze,
    setError: Be,
    setFocus: Le,
    getFieldState: K
  };
  return {
    ...mn,
    formControl: mn
  };
}
function sM(e = {}) {
  const n = Fe.useRef(void 0), r = Fe.useRef(void 0), [i, a] = Fe.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: xr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: xr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : oM(e),
    formState: i
  }, e.formControl && e.defaultValues && !xr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, Fe.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), Fe.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Fe.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), Fe.useEffect(() => {
    e.values && !ri(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), Fe.useEffect(() => {
    e.errors && !Ut(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), Fe.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Fe.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = $S(i, o), n.current;
}
const lM = "_modalBody_1clhs_1", cM = {
  modalBody: lM
}, dM = ({
  isOpen: e,
  onClose: n,
  pointsAccount: r,
  setHasPointsBeenUpdated: i,
  refetchPointsQuery: a
}) => {
  const { useMutation: o, showNotification: s } = hn(), { track: l } = _n(), d = r?.id, m = r?.balance ?? 0, u = {
    balance: m?.toString() ?? "0",
    description: "",
    transactionType: null
  }, { control: f, setValue: h, reset: g } = sM({
    defaultValues: u,
    mode: "onChange"
  }), C = RS({ control: f }), S = parseInt(C?.balance ?? "0", 10), N = m === S, w = N ? "Change the value to update the points" : "", y = S < 0, z = y ? "Points can not be negative" : "", $ = C.description === "", I = $ ? "Description can not be empty" : "";
  He(() => {
    S > m ? h(
      "transactionType",
      Om.Addition
    ) : S < m && h(
      "transactionType",
      Om.Deduction
    );
  }, [m, S, h]);
  const [T, { loading: U, error: Q, reset: J }] = o(TU, {
    onCompleted: () => {
      s({
        title: "Success",
        text: "Points updated successfully",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), ae = () => {
    if (d) {
      const B = lU();
      T({
        variables: {
          input: {
            accountId: d,
            transactionId: B,
            amount: Math.abs(S - m),
            transactionType: C.transactionType,
            description: C.description,
            source: CS.UpdateBalance
          }
        }
      }).then(async (O) => {
        O?.errors ? l("voyado:update:points:failed") : (l("voyado:update:points:succeeded"), i(!0), await a(), X());
      }).catch(() => {
        l("voyado:update:points:failed");
      });
    }
  }, X = () => {
    g(u), J(), n();
  };
  return /* @__PURE__ */ M.jsxs(
    Tt,
    {
      isOpen: e,
      onClose: X,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ M.jsx($t, { title: "Update points balance", onClose: X }),
        /* @__PURE__ */ M.jsxs(Dt, { className: cM.modalBody, children: [
          /* @__PURE__ */ M.jsxs(st, { children: [
            /* @__PURE__ */ M.jsx(be, { span: 6, children: /* @__PURE__ */ M.jsx(
              lb,
              {
                name: "balance",
                control: f,
                render: ({ field: B }) => /* @__PURE__ */ M.jsx(
                  pr,
                  {
                    label: "New points balance",
                    type: "number",
                    placeholder: "Insert new points",
                    min: 0,
                    max: 1e5,
                    meta: {
                      warning: w || z
                    },
                    input: {
                      ...B,
                      value: B.value.toString(),
                      onChange: (O) => B.onChange(O)
                    }
                  }
                )
              }
            ) }),
            /* @__PURE__ */ M.jsx(be, { span: 6, children: /* @__PURE__ */ M.jsx(
              lb,
              {
                name: "description",
                control: f,
                render: ({ field: B }) => /* @__PURE__ */ M.jsx(
                  pr,
                  {
                    required: !0,
                    label: "Description",
                    placeholder: "Insert a description",
                    input: B,
                    meta: {
                      warning: I
                    }
                  }
                )
              }
            ) })
          ] }),
          Q && /* @__PURE__ */ M.jsx(Fn, { error: Q })
        ] }),
        /* @__PURE__ */ M.jsx(
          At,
          {
            confirmName: "Save",
            confirmOnClick: () => ae(),
            confirmProps: {
              isLoading: U,
              disabled: N || y || $,
              loadingIndicator: /* @__PURE__ */ M.jsx(un, { size: 16 })
            },
            cancelOnClick: X
          }
        )
      ]
    }
  );
}, uM = "_wrapper_1ge6c_1", mM = "_block_1ge6c_12", bb = {
  wrapper: uM,
  block: mM
}, pM = ({
  contactAttributes: e,
  contactId: n
}) => {
  const { useQuery: r } = hn(), { isCopied: i, copy: a } = xs(), { isCopied: o, copy: s } = xs(), { isCopied: l, copy: d } = xs(), [m, u] = le(!1), [f, h] = le(), [g, C] = le(!1), {
    loading: S,
    data: N,
    refetch: w
  } = r(IU, {
    variables: {
      contactId: n
    },
    skip: !n
  });
  He(() => {
    if (N) {
      const ee = N?.Voyado?.PointAccountV_GetPointAccounts;
      ee && ee?.length > 0 && h(ee[0]);
    }
  }, [N]);
  const y = !!f?.id, z = f?.balance ?? 0;
  if (!e)
    return null;
  const {
    firstName: $,
    lastName: I,
    street: T,
    zipCode: U,
    city: Q,
    country: J,
    isRegistrationCompleted: ae,
    email: X,
    mobilePhone: B
  } = e, O = 14, q = `${$ || ""} ${I || ""}`.trim() || "Anonymous";
  return /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", className: bb.wrapper, children: [
    /* @__PURE__ */ M.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: bb.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ M.jsx(P.Heading, { variant: "heading-2", children: q }),
          S && /* @__PURE__ */ M.jsx(un, { size: 12 }),
          y && !S && /* @__PURE__ */ M.jsxs(b, { gap: "100", alignItems: "center", children: [
            /* @__PURE__ */ M.jsxs(An, { size: "small", variant: "warning", children: [
              z,
              " points"
            ] }),
            /* @__PURE__ */ M.jsx(We, { content: "Update points balance", children: /* @__PURE__ */ M.jsx(
              pe,
              {
                name: "pen",
                size: 12,
                onClick: () => u(!0),
                className: rt.pointer
              }
            ) }),
            g && /* @__PURE__ */ M.jsx(We, { content: "It might take a while until the updated points are available. Please refresh the integration by collapsing and expanding the widget in the sidebar.", children: /* @__PURE__ */ M.jsx(
              pe,
              {
                name: "info",
                size: 12,
                className: rt.pointer
              }
            ) })
          ] })
        ]
      }
    ),
    (T || Q || U || J || B || X) && /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
      B && /* @__PURE__ */ M.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ M.jsx(pe, { size: O, name: "phone" }),
          /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", children: B })
        ] }),
        /* @__PURE__ */ M.jsx(
          pe,
          {
            size: O,
            name: o ? "done" : "copy",
            onClick: () => s(B),
            className: rt.pointer
          }
        )
      ] }),
      X && /* @__PURE__ */ M.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ M.jsx(pe, { size: O, name: "mail" }),
          /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", children: X })
        ] }),
        /* @__PURE__ */ M.jsx(
          pe,
          {
            size: O,
            name: i ? "done" : "copy",
            onClick: () => a(X),
            className: rt.pointer
          }
        )
      ] }),
      (T || Q || U || J) && /* @__PURE__ */ M.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ M.jsx(pe, { size: O, name: "home" }),
          /* @__PURE__ */ M.jsxs(P.Paragraph, { variant: "4", color: "secondary", children: [
            /* @__PURE__ */ M.jsx(et, { children: T }),
            /* @__PURE__ */ M.jsxs(et, { children: [
              U,
              " ",
              Q
            ] }),
            /* @__PURE__ */ M.jsx(et, { children: J })
          ] })
        ] }),
        /* @__PURE__ */ M.jsx(
          pe,
          {
            size: O,
            name: l ? "done" : "copy",
            onClick: () => d(`${T}, ${U} ${Q}, ${J}`),
            className: rt.pointer
          }
        )
      ] }),
      /* @__PURE__ */ M.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ M.jsx(pe, { size: O, name: "sign-in" }),
          /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", children: "Is registration completed" })
        ] }),
        /* @__PURE__ */ M.jsx(
          pe,
          {
            name: ae ? "check-circle-filled" : "close-circle-filled",
            color: ae ? "green.500" : "neutral.500"
          }
        )
      ] })
    ] }),
    y && /* @__PURE__ */ M.jsx(
      dM,
      {
        isOpen: m,
        pointsAccount: f,
        onClose: () => u(!1),
        setHasPointsBeenUpdated: C,
        refetchPointsQuery: w
      }
    )
  ] });
}, fM = "_list_yud4a_7", hM = "_listItem_yud4a_11", yM = "_listItemTooltip_yud4a_15", gM = "_listItemTimestamp_yud4a_18", as = {
  list: fM,
  listItem: hM,
  listItemTooltip: yM,
  listItemTimestamp: gM
}, vM = ({
  contactConsents: e
}) => !e || e.length === 0 ? null : /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ M.jsx(P.Heading, { variant: "heading-3", children: "Consents" }),
  /* @__PURE__ */ M.jsx(Ye, { className: as.list, children: e.map((n, r) => /* @__PURE__ */ M.jsx(Ye.Text, { variant: "dense", className: as.listItem, children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ M.jsx(We, { content: n?.comment, children: /* @__PURE__ */ M.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: it({
          [as.listItemTooltip]: n?.comment
        }),
        children: [
          /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", children: n.id }),
          /* @__PURE__ */ M.jsx(P.Paragraph, { className: as.listItemTimestamp, children: Ln(n.date).format(xt) }),
          n?.comment && /* @__PURE__ */ M.jsx(pe, { name: "info", color: "neutral.400" })
        ]
      }
    ) }),
    /* @__PURE__ */ M.jsx(
      pe,
      {
        name: n.value ? "check-circle-filled" : "close-circle-filled",
        color: n.value ? "green.500" : "red.500"
      }
    )
  ] }) }, r)) })
] }), kM = ({
  memberLevel: e
}) => {
  const n = e?.levelName ?? null, r = e?.remainingToUpgrade ?? null, i = e?.basedOnRewardPoints ?? null, a = e?.latestChange ? Ln(e.latestChange).format(xt) : null, o = e?.expires ? `${Ln(e.expires).fromNow()} (${Ln(e.expires).format(xt)})` : null, s = !n && !a && !r && !i && !o;
  return /* @__PURE__ */ M.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { alignItems: "center", gap: "100", children: [
      /* @__PURE__ */ M.jsx(P.Heading, { variant: "heading-3", children: "Member level" }),
      /* @__PURE__ */ M.jsx(We, { content: "Voyado updates the member level data in a nightly batch process", children: /* @__PURE__ */ M.jsx(
        pe,
        {
          name: "question",
          size: 14,
          className: rt.pointer
        }
      ) })
    ] }),
    /* @__PURE__ */ M.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ M.jsxs(Ye, { className: rt.list, children: [
      s && /* @__PURE__ */ M.jsx(Ye.Text, { variant: "dense", className: rt.listItem, children: /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No member level properties found" }) }),
      n && /* @__PURE__ */ M.jsx(Ye.Text, { variant: "dense", className: rt.listItem, children: /* @__PURE__ */ M.jsx(We, { content: "", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", children: "Level" }),
        /* @__PURE__ */ M.jsx(An, { variant: "info", size: "small", children: e?.levelName ?? "" })
      ] }) }) }),
      i && /* @__PURE__ */ M.jsx(Ye.Text, { variant: "dense", className: rt.listItem, children: /* @__PURE__ */ M.jsx(We, { content: "Voyado updates the member level data once a day in a nightly job", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", children: "Based on reward points" }),
        /* @__PURE__ */ M.jsx(An, { variant: "success", size: "small", children: i })
      ] }) }) }),
      r && /* @__PURE__ */ M.jsx(Ye.Text, { variant: "dense", className: rt.listItem, children: /* @__PURE__ */ M.jsx(We, { content: "", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", children: "Remaining to upgrade" }),
        /* @__PURE__ */ M.jsx(An, { variant: "success", size: "small", children: r })
      ] }) }) }),
      a && /* @__PURE__ */ M.jsx(Ye.Text, { variant: "dense", className: rt.listItem, children: /* @__PURE__ */ M.jsx(We, { content: "", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", children: "Latest change" }),
        /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "5", color: "secondary", children: a })
      ] }) }) }),
      o && /* @__PURE__ */ M.jsx(Ye.Text, { variant: "dense", className: rt.listItem, children: /* @__PURE__ */ M.jsx(We, { content: "", children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", children: "Expires" }),
        /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "5", color: "secondary", children: o })
      ] }) }) })
    ] }) })
  ] }) });
}, bM = "_tagHover_kzbzk_1", xM = "_channelUnsubscribed_kzbzk_6", xb = {
  tagHover: bM,
  channelUnsubscribed: xM
}, Qu = ({
  isSubscribed: e,
  channelName: n,
  channelIcon: r,
  contactId: i,
  contactPreferences: a,
  refetchContact: o
}) => {
  const { track: s } = _n(), { useMutation: l } = hn(), [d, m] = le(!1), [u, { loading: f }] = l(EU), h = async ({
    newPreference: C,
    isSubscribed: S,
    channelType: N
  }) => {
    m(!0), (await u({
      variables: {
        contactId: i,
        input: {
          preferences: {
            ...a,
            ...C
          }
        }
      }
    }))?.data?.Voyado.ContactsV_ContactPatch?.id ? S ? s("voyado:channel:unsubscribe:succeeded", { channel: N }) : s("voyado:channel:subscribe:succeeded", { channel: N }) : S ? s("voyado:channel:unsubscribe:failed", { channel: N }) : s("voyado:channel:subscribe:failed", { channel: N }), setTimeout(async () => {
      await o().finally(() => m(!1));
    }, 1e3);
  }, g = d || f;
  return /* @__PURE__ */ M.jsx(We, { content: e ? "Unsubscribe" : "Subscribe", children: /* @__PURE__ */ M.jsx(
    Pn,
    {
      className: xb.tagHover,
      color: e ? "green.500" : "neutral.200",
      children: /* @__PURE__ */ M.jsxs(
        b,
        {
          "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
          gap: "200",
          alignItems: "center",
          className: it({
            [xb.channelUnsubscribed]: !e
          }),
          onClick: () => {
            e ? s("voyado:channel:unsubscribe:clicked", {
              channel: n.toUpperCase()
            }) : s("voyado:channel:subscribe:clicked", {
              channel: n.toUpperCase()
            }), h({
              newPreference: { [`accepts${n}`]: !e },
              isSubscribed: e,
              channelType: n.toUpperCase()
            });
          },
          children: [
            g ? /* @__PURE__ */ M.jsx(un, { size: 16 }) : /* @__PURE__ */ M.jsx(pe, { size: 16, name: r }),
            n
          ]
        }
      )
    }
  ) });
}, _M = ({
  contactPreferences: e,
  contactId: n,
  refetchContact: r
}) => {
  if (!e || !n)
    return null;
  const { acceptsEmail: i, acceptsPostal: a, acceptsSms: o } = e;
  return /* @__PURE__ */ M.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsx(P.Heading, { variant: "heading-3", children: "Subscriptions" }),
    /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(
        Qu,
        {
          channelName: "Email",
          channelIcon: "mail",
          isSubscribed: i,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ M.jsx(
        Qu,
        {
          channelName: "Sms",
          channelIcon: "sms",
          isSubscribed: o,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ M.jsx(
        Qu,
        {
          channelName: "Postal",
          channelIcon: "paper-plane",
          isSubscribed: a,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      )
    ] })
  ] }) });
}, SM = ({
  contactId: e,
  settings: n
}) => {
  const {
    showCustomerAttributes: r,
    showPreferences: i,
    showAudiences: a,
    showConsents: o,
    showMemberLevel: s
  } = n, {
    isLoading: l,
    error: d,
    refetch: m,
    attributes: u,
    preferences: f,
    consents: h
  } = $U({ contactId: e }), {
    isLoading: g,
    error: C,
    memberLevel: S
  } = LU({ contactId: e, skip: !s }), N = g || l, w = Bn(
    () => h?.filter(
      (y) => y !== null
    ),
    [h]
  );
  return d || C ? vo({
    errors: d?.graphQLErrors || C?.graphQLErrors || []
  }) ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ M.jsx(P.Paragraph, { color: "secondary", children: "No contact informations found" }) }) : /* @__PURE__ */ M.jsx(Fn, { error: d || C }) : !r && !i && !a && !o && !s ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ M.jsx(P.Paragraph, { color: "secondary", children: "All contact related features in the settings are disabled." }) }) : N ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ M.jsx(un, {}) }) : /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
    r && /* @__PURE__ */ M.jsx(
      pM,
      {
        contactAttributes: u,
        contactId: e
      }
    ),
    s && /* @__PURE__ */ M.jsx(kM, { memberLevel: S }),
    i && /* @__PURE__ */ M.jsx(
      _M,
      {
        refetchContact: m,
        contactPreferences: f,
        contactId: e
      }
    ),
    o && /* @__PURE__ */ M.jsx(vM, { contactConsents: w })
  ] });
}, Pm = (e, n) => `${e ? e.toFixed(2) : "0.00"} ${n}`, NM = "_list_zu4s7_1", jM = "_listItem_zu4s7_4", wM = "_listSum_zu4s7_7", os = {
  list: NM,
  listItem: jM,
  listSum: wM
}, CM = ({
  lineItems: e,
  localCurrency: n,
  localNetPriceSum: r
}) => /* @__PURE__ */ M.jsxs(Ye, { className: os.list, children: [
  e?.map(({ quantity: i, article: a, localPrice: o, type: s }, l) => /* @__PURE__ */ M.jsx(Ye.Text, { variant: "dense", className: os.listItem, children: /* @__PURE__ */ M.jsx(We, { content: s, children: /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", gap: "200", children: [
    /* @__PURE__ */ M.jsxs(b, { flex: "0 0 auto", gap: "200", children: [
      /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", children: i }),
      /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", children: "×" })
    ] }),
    /* @__PURE__ */ M.jsx(b, { flex: "auto", children: /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", children: a?.name }) }),
    o && n && /* @__PURE__ */ M.jsx(b, { flex: "0 0 auto", gap: "100", children: /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", children: Pm(o, n) }) })
  ] }) }) }, l)),
  /* @__PURE__ */ M.jsx(
    Ye.Text,
    {
      variant: "dense",
      className: it(os.listItem, os.listSum),
      children: /* @__PURE__ */ M.jsxs(b, { gap: "100", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "3", children: "Sum" }),
        /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "3", children: Pm(r, n) })
      ] })
    },
    "theSumOfItAll"
  )
] }), FM = "_transaction_1kr8d_1", IM = "_transactionIsOpen_1kr8d_9", EM = "_transactionHeader_1kr8d_12", TM = "_transactionHeaderSubLine_1kr8d_15", $M = "_transactionHeaderAlignItemRight_1kr8d_19", Wi = {
  transaction: FM,
  transactionIsOpen: IM,
  transactionHeader: EM,
  transactionHeaderSubLine: TM,
  transactionHeaderAlignItemRight: $M
}, DM = ({
  transaction: e,
  openByDefault: n
}) => {
  const [r, i] = le(n), {
    transactionNumber: a,
    createdDate: o,
    storeName: s,
    numberOfItems: l,
    storeType: d,
    lineItems: m,
    localCurrency: u,
    localNetPriceSum: f
  } = e, h = u ?? "", g = f ?? 0, C = m?.length ? m : [];
  return /* @__PURE__ */ M.jsxs(
    b,
    {
      className: it(Wi.transaction, {
        [Wi.transactionIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ M.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Wi.transactionHeader,
            onClick: () => i(!r),
            "data-testid": "contact-transaction-header",
            children: [
              /* @__PURE__ */ M.jsxs(b, { style: { flexGrow: 1 }, children: [
                /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  o && /* @__PURE__ */ M.jsx(An, { size: "small", variant: "info", children: Ln(o).format(xt) }),
                  /* @__PURE__ */ M.jsxs(
                    P.Heading,
                    {
                      variant: "heading-4",
                      className: Wi.transactionHeaderSubLine,
                      children: [
                        "ID: ",
                        a
                      ]
                    }
                  )
                ] }),
                /* @__PURE__ */ M.jsxs(
                  b,
                  {
                    flexDirection: "column",
                    gap: "100",
                    className: Wi.transactionHeaderAlignItemRight,
                    children: [
                      /* @__PURE__ */ M.jsx(P.Heading, { variant: "heading-4", children: Pm(g, h) }),
                      /* @__PURE__ */ M.jsxs(
                        P.Heading,
                        {
                          variant: "heading-4",
                          className: Wi.transactionHeaderSubLine,
                          children: [
                            l,
                            " line ",
                            `${l === 1 ? "item" : "items"}`
                          ]
                        }
                      )
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ M.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ M.jsx(
                nr,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              ) })
            ]
          }
        ),
        r && /* @__PURE__ */ M.jsxs(
          b,
          {
            gap: "300",
            flexDirection: "column",
            "data-testid": "contact-transaction-content",
            children: [
              /* @__PURE__ */ M.jsx(qm, {}),
              /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
                s && /* @__PURE__ */ M.jsx(P.Heading, { variant: "heading-2", children: s }),
                d && /* @__PURE__ */ M.jsx(Pn, { children: /* @__PURE__ */ M.jsx(b, { alignItems: "center", children: d }) }),
                /* @__PURE__ */ M.jsx(
                  CM,
                  {
                    lineItems: C,
                    localCurrency: h,
                    localNetPriceSum: g
                  }
                )
              ] })
            ]
          }
        )
      ]
    }
  );
}, RM = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    transactions: i
  } = AU({ contactId: e });
  if (!e)
    return null;
  const { items: a, totalCount: o } = i, s = o ?? 0;
  return r ? /* @__PURE__ */ M.jsx(Fn, { error: r }) : /* @__PURE__ */ M.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "column",
      "data-testid": "contact-transactions-wrapper",
      children: [
        /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
          /* @__PURE__ */ M.jsx(P.Heading, { variant: "heading-3", children: "Transactions" }),
          !n && s > 0 && /* @__PURE__ */ M.jsx(An, { size: "small", variant: "success", children: s })
        ] }),
        n ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ M.jsx(un, {}) }) : /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
          s === 0 && /* @__PURE__ */ M.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "There are no transactions for this contact" }) }),
          s > 0 && a?.map((l, d) => /* @__PURE__ */ M.jsx(
            DM,
            {
              transaction: l,
              openByDefault: d === 0
            },
            d
          ))
        ] })
      ]
    }
  );
}, OM = "_message_unsvt_48", AM = "_messageIsOpen_unsvt_56", PM = "_messageHeader_unsvt_60", LM = "_messageText_unsvt_64", VM = "_buttonLink_unsvt_86", Ka = {
  message: OM,
  messageIsOpen: AM,
  messageHeader: PM,
  messageText: LM,
  buttonLink: VM
}, Ju = {
  status: {
    Delivered: "check-circle",
    Waiting: "clock",
    Hardbounce: "close-circle-filled",
    Softbounce: "close"
  },
  type: {
    EmailMessage: "mail",
    SmsMessage: "sms",
    PostalMessage: "paper-plane"
  },
  source: {
    Automation: "chat-bot",
    Manual: "user",
    System: "eye"
  }
}, Xu = (e, n) => n && e in Ju && n in Ju[e] ? Ju[e][n] : null, zM = ({
  message: e,
  openByDefault: n
}) => {
  const [r, i] = le(n), { track: a } = _n();
  if (!e)
    return null;
  const {
    name: o,
    sendDateTime: s,
    type: l,
    source: d,
    isTransactional: m,
    status: u,
    messageLink: f,
    messageText: h
  } = e, g = l ? Xu("type", l) : null, C = d ? Xu("source", d) : null, S = u ? Xu("status", u) : null, N = l?.replace("Message", "");
  return /* @__PURE__ */ M.jsxs(
    b,
    {
      className: it(Ka.message, {
        [Ka.messageIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ M.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Ka.messageHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ M.jsxs(b, { gap: "200", alignItems: "center", children: [
                  g && /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
                    /* @__PURE__ */ M.jsx(pe, { name: g, size: 16 }),
                    " ",
                    N
                  ] }),
                  s && /* @__PURE__ */ M.jsx(An, { size: "small", variant: "info", children: Ln(s).format(xt) })
                ] }),
                o
              ] }),
              /* @__PURE__ */ M.jsx(
                nr,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ M.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ M.jsx(qm, {}),
          /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
            S && /* @__PURE__ */ M.jsx(Pn, { children: /* @__PURE__ */ M.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ M.jsx(pe, { name: S }),
              " ",
              u
            ] }) }),
            C && /* @__PURE__ */ M.jsx(Pn, { children: /* @__PURE__ */ M.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ M.jsx(pe, { name: C }),
              " ",
              d
            ] }) }),
            m && /* @__PURE__ */ M.jsx(Pn, { children: /* @__PURE__ */ M.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ M.jsx(pe, { name: "exchange" }),
              " Transactional"
            ] }) })
          ] }),
          /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "Message text" }),
            /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", className: Ka.messageText, children: h })
          ] }),
          f && /* @__PURE__ */ M.jsx(
            Et,
            {
              slotEnd: /* @__PURE__ */ M.jsx(pe, { name: "external-link" }),
              variant: "tertiary",
              className: Ka.buttonLink,
              navigate: () => {
                N && a("voyado:message:external-link:opened", {
                  channel: N.toUpperCase()
                }), window.open(f, "_blank")?.focus();
              },
              children: "Open message in new tab"
            }
          )
        ] })
      ]
    }
  );
}, UM = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    lastMessages: i
  } = RU({ contactId: e });
  if (!e)
    return null;
  if (r)
    return /* @__PURE__ */ M.jsx(Fn, { error: r });
  const { count: a, items: o } = i, s = (a && a) ?? 0, l = s > 0;
  return /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ M.jsx(P.Heading, { variant: "heading-3", children: "Last Messages" }),
      !n && l && /* @__PURE__ */ M.jsx(An, { variant: "success", size: "small", children: s })
    ] }),
    /* @__PURE__ */ M.jsx(b, { gap: "200", flexDirection: "column", children: n ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ M.jsx(un, {}) }) : /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
      l && o?.map((d, m) => /* @__PURE__ */ M.jsx(
        zM,
        {
          message: d || void 0,
          openByDefault: m === 0
        },
        m
      )),
      !l && /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "200", children: /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No messages available" }) })
    ] }) })
  ] });
}, fl = ({
  value: e,
  currencyCode: n
}) => `${Number.parseFloat((e ?? 0).toString()).toFixed(2)} ${n ?? ""}`, _b = ({
  labelText: e,
  address: n,
  icon: r = "home"
}) => {
  const { isCopied: i, copy: a } = xs(), o = [n?.title, n?.firstname, n?.lastname].filter(Boolean).join(" "), s = ot(() => [
    o,
    n?.streetAddress,
    n?.streetAddress2,
    n?.postalCode,
    n?.region,
    n?.city,
    n?.country
  ].filter(Boolean).join(`
`), [n, o]);
  if (!n)
    return null;
  const l = 14;
  return /* @__PURE__ */ M.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(pe, { size: l, name: r, color: "green.500" }),
      /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "3", children: e }),
        /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
          o && /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", children: o }),
          n?.streetAddress && /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", children: n.streetAddress }),
          n?.streetAddress2 && /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", children: n.streetAddress2 }),
          n?.postalCode && /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", children: n?.postalCode }),
          n?.region && /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", children: n.region }),
          n?.city && /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", children: n.city }),
          n?.country && /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", children: n.country })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ M.jsx(We, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ M.jsx(
      pe,
      {
        size: l,
        name: i ? "done" : "copy",
        onClick: () => a(s()),
        className: rt.pointer
      }
    ) })
  ] });
}, MM = "_order_19t4p_1", BM = "_orderIsOpen_19t4p_9", qM = "_orderHeader_19t4p_12", HM = "_orderIconColor_19t4p_15", Er = {
  order: MM,
  orderIsOpen: BM,
  orderHeader: qM,
  orderIconColor: HM
}, WM = "_delivery_1m9nb_1", GM = "_deliveryCode_1m9nb_4", Zu = {
  delivery: WM,
  deliveryCode: GM
}, KM = ({
  delivery: e
}) => {
  const { isCopied: n, copy: r } = or();
  if (!e)
    return null;
  const { method: i, trackingNumber: a, trackingUri: o, deliveryDate: s } = e, l = 14;
  return /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ M.jsx(
      pe,
      {
        size: l,
        name: "eye",
        className: Er.orderIconColor
      }
    ),
    /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
      /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "3", children: "Delivery" }),
      /* @__PURE__ */ M.jsx(
        We,
        {
          content: /* @__PURE__ */ M.jsxs(P.Paragraph, { variant: "4", color: "inherit", children: [
            "Arrives: ",
            Ln(s).format(xt)
          ] }),
          children: /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
            o ? /* @__PURE__ */ M.jsx(
              P.ExternalLink,
              {
                href: o,
                target: "_blank",
                rel: "noreferrer",
                children: /* @__PURE__ */ M.jsxs(
                  b,
                  {
                    gap: "100",
                    alignItems: "center",
                    className: Zu.delivery,
                    children: [
                      /* @__PURE__ */ M.jsx(pe, { name: "external-link", size: l }),
                      i
                    ]
                  }
                )
              }
            ) : i,
            /* @__PURE__ */ M.jsx(
              P.Paragraph,
              {
                variant: "4",
                className: it(Zu.delivery, Zu.deliveryCode),
                children: a
              }
            )
          ] })
        }
      )
    ] }),
    a && /* @__PURE__ */ M.jsx(We, { content: "Copy tracking code", children: /* @__PURE__ */ M.jsx(
      pe,
      {
        size: l,
        name: n ? "done" : "copy",
        onClick: () => r(a.toString()),
        className: rt.pointer
      }
    ) })
  ] });
}, YM = ({
  fees: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(
        pe,
        {
          size: 14,
          name: "file-text",
          className: Er.orderIconColor
        }
      ),
      /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "3", children: "Fees" })
    ] }),
    /* @__PURE__ */ M.jsx(Ye, { className: rt.list, children: r?.map((i, a) => /* @__PURE__ */ M.jsx(Ye.Item, { className: rt.listItem, children: /* @__PURE__ */ M.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        children: [
          /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "5", children: i?.type }),
            /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", children: i?.description })
          ] }),
          /* @__PURE__ */ M.jsx(b, { flexDirection: "column", gap: "100", children: i?.taxes?.items?.map((o, s) => /* @__PURE__ */ M.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "column",
              className: rt.listItemAlignRight,
              children: [
                /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "5", children: `${o?.description} ${o?.percent}%` }),
                /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", children: fl({ value: o?.amount, currencyCode: n }) })
              ]
            },
            `tax-${s}`
          )) })
        ]
      }
    ) }, `fees-${a}`)) })
  ] });
}, QM = ({
  lineItems: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(
        pe,
        {
          size: 14,
          name: "tag",
          className: Er.orderIconColor
        }
      ),
      /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "3", children: "Line items" })
    ] }),
    /* @__PURE__ */ M.jsx(Ye, { className: rt.list, children: r?.map((i) => /* @__PURE__ */ M.jsx(
      Ye.Item,
      {
        className: rt.listItem,
        contentLeft: /* @__PURE__ */ M.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", children: i?.quantity }),
          /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", children: "×" })
        ] }),
        title: /* @__PURE__ */ M.jsx(
          We,
          {
            content: /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "3", color: "inherit", children: i?.article?.sku }),
            children: /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", children: i?.article?.name }),
              /* @__PURE__ */ M.jsx(b, { children: /* @__PURE__ */ M.jsx(An, { size: "small", variant: "info", children: fl({
                value: i?.totalPrice,
                currencyCode: n
              }) }) })
            ] })
          }
        ),
        contentRight: i?.article?.imageUri && /* @__PURE__ */ M.jsx(
          la,
          {
            src: i?.article?.imageUri,
            alt: i?.article?.name,
            style: { height: "48px" }
          }
        )
      },
      `list-${i?.id}`
    )) })
  ] });
}, JM = ({
  payments: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(
        pe,
        {
          size: 14,
          name: "credit-card",
          className: Er.orderIconColor
        }
      ),
      /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "3", children: "Payment methods" })
    ] }),
    /* @__PURE__ */ M.jsx(Ye, { className: rt.list, children: r?.map((i, a) => /* @__PURE__ */ M.jsx(
      Ye.Item,
      {
        className: rt.listItem,
        children: /* @__PURE__ */ M.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            children: [
              /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "100", children: [
                /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "5", children: i?.description }),
                /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", children: i?.method })
              ] }),
              /* @__PURE__ */ M.jsxs(
                b,
                {
                  gap: "100",
                  flexDirection: "column",
                  className: rt.listItemAlignRight,
                  children: [
                    /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "5", children: Ln(i?.paidAt).format(xt) }),
                    /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", children: fl({ value: i?.amount, currencyCode: n }) })
                  ]
                }
              )
            ]
          }
        )
      },
      `payments-${a}`
    )) })
  ] });
}, XM = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = le(n);
  if (!e)
    return null;
  const {
    orderId: a,
    status: o,
    externalStatus: s,
    currencyCode: l,
    channel: d,
    createdAt: m,
    lastChangedAt: u,
    lineItems: f,
    billingAddress: h,
    deliveryAddress: g,
    totalPrice: C
  } = e, S = 14;
  return /* @__PURE__ */ M.jsxs(
    b,
    {
      className: it(Er.order, {
        [Er.orderIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ M.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Er.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ M.jsxs(b, { gap: "100", flexDirection: "column", children: [
                m && /* @__PURE__ */ M.jsx(b, { alignItems: "center", children: /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", children: Ln(m).format(xt) }) }),
                /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "1", children: a })
              ] }),
              /* @__PURE__ */ M.jsx(
                nr,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ M.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ M.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ M.jsx(
              pe,
              {
                size: S,
                name: "activity",
                className: Er.orderIconColor
              }
            ),
            /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "3", children: "Order status" }),
              /* @__PURE__ */ M.jsxs(b, { gap: "100", alignItems: "center", flexWrap: "wrap", children: [
                o && /* @__PURE__ */ M.jsx(We, { content: "Internal status", children: /* @__PURE__ */ M.jsx(An, { size: "small", variant: "info", children: /* @__PURE__ */ M.jsx(M.Fragment, { children: o }) }) }),
                s && /* @__PURE__ */ M.jsx(We, { content: "External status", children: /* @__PURE__ */ M.jsx(An, { size: "small", variant: "info", children: /* @__PURE__ */ M.jsx(M.Fragment, { children: s }) }) }),
                /* @__PURE__ */ M.jsx(We, { content: "Last updated at", children: /* @__PURE__ */ M.jsx(P.Paragraph, { as: "span", variant: "5", children: Ln(u).format(xt) }) })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ M.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ M.jsx(
              pe,
              {
                size: S,
                name: "chart-bar",
                className: Er.orderIconColor
              }
            ),
            /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", children: fl({
                value: C,
                currencyCode: l
              }) })
            ] })
          ] }),
          d && /* @__PURE__ */ M.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ M.jsx(
              pe,
              {
                size: S,
                name: "channels",
                className: Er.orderIconColor
              }
            ),
            /* @__PURE__ */ M.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "3", children: "Channel" }),
              /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", children: /* @__PURE__ */ M.jsx(An, { size: "small", variant: "info", children: /* @__PURE__ */ M.jsx(M.Fragment, { children: d }) }) })
            ] })
          ] }),
          /* @__PURE__ */ M.jsx(_b, { labelText: "Billing address", address: h }),
          /* @__PURE__ */ M.jsx(
            _b,
            {
              icon: "map-pin",
              labelText: "Delivery address",
              address: g
            }
          ),
          /* @__PURE__ */ M.jsx(KM, { delivery: e.delivery }),
          /* @__PURE__ */ M.jsx(QM, { lineItems: f, currencyCode: l }),
          /* @__PURE__ */ M.jsx(YM, { fees: e.fees, currencyCode: l }),
          /* @__PURE__ */ M.jsx(
            JM,
            {
              payments: e.payments,
              currencyCode: l
            }
          )
        ] })
      ]
    }
  );
}, ZM = ({
  error: e,
  itemCount: n,
  children: r
}) => e ? n === 0 || vo({
  errors: e.graphQLErrors
}) ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "There are no orders for this contact" }) }) : /* @__PURE__ */ M.jsx(Fn, { error: e }) : /* @__PURE__ */ M.jsx(M.Fragment, { children: r }), e4 = ({
  contactId: e
}) => {
  const { useQuery: n } = hn(), [r, i] = le([]), { track: a } = _n(), {
    loading: o,
    error: s,
    data: l
  } = n(FU, {
    skip: !e,
    variables: {
      contactId: e
    }
  });
  return He(() => {
    if (l?.Voyado) {
      const d = l?.Voyado.Orders_GetAllByContact;
      if (!o && d?.items) {
        i(d.items);
        const { totalCount: m } = d;
        m && a("voyado:orders:received", { count: m });
      }
    }
  }, [l?.Voyado]), e ? /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 300 0", children: [
    /* @__PURE__ */ M.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ M.jsx(P.Heading, { variant: "heading-3", children: "Orders" }),
      r.length > 0 && /* @__PURE__ */ M.jsx(An, { size: "small", variant: "success", children: r.length })
    ] }),
    o ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ M.jsx(un, {}) }) : /* @__PURE__ */ M.jsx(ZM, { error: s, itemCount: r.length, children: r.map((d, m) => /* @__PURE__ */ M.jsx(
      XM,
      {
        order: d,
        openByDefault: m === 0
      },
      m
    )) })
  ] }) : null;
}, n4 = ({
  conversationContext: e,
  settings: n
}) => {
  const { isLoading: r, contactId: i, hasMultipleContacts: a, error: o } = PU({
    conversationContext: e
  }), s = !e?.customer?.email && !e?.customer?.phone_number, l = !!i, {
    showCustomerAttributes: d,
    showPreferences: m,
    showAudiences: u,
    showConsents: f,
    showLastMessages: h,
    showCustomerTransactions: g,
    showOrders: C
  } = n;
  return s ? /* @__PURE__ */ M.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "widget-no-contact-message",
      children: /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
    }
  ) : a ? /* @__PURE__ */ M.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "multiple-contacts-found-message",
      children: /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "We found multiple profile IDs that match your email or phone number. To display customer informations, we need a unique profile id. Please make sure that the customers data is normalized." })
    }
  ) : o ? vo({
    errors: o.graphQLErrors
  }) ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No profile found" }) }) : /* @__PURE__ */ M.jsx(Fn, { error: o }) : !d && !m && !u && !f && !h && !g ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." }) }) : r ? /* @__PURE__ */ M.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ M.jsx(un, {}) }) : /* @__PURE__ */ M.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ M.jsx(SM, { contactId: i, settings: n }),
        h && /* @__PURE__ */ M.jsx(UM, { contactId: i }),
        g && /* @__PURE__ */ M.jsx(RM, { contactId: i }),
        C && /* @__PURE__ */ M.jsx(e4, { contactId: i }),
        !l && /* @__PURE__ */ M.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ M.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No contact found." }) })
      ]
    }
  );
}, t4 = [
  {
    key: "voyadoApiKey",
    label: "API key",
    placeholder: "API key from Voyado",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "apiHostName",
    label: "API URL",
    placeholder: "The URL of the Voyado API",
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://"
  },
  {
    key: "showCustomerAttributes",
    label: "Show the customer attributes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showPreferences",
    label: "Show preferences",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showAudiences",
    label: "Show audiences",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showConsents",
    label: "Show consents",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showLastMessages",
    label: "Show the last 5 messages",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showCustomerTransactions",
    label: "Show customer transactions",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showOrders",
    label: "Show orders by contact",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showMemberLevel",
    label: "Show member level",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._copyIcon_11mz1_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_11mz1_53{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_11mz1_63{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200)}._listItem_11mz1_63:last-child{box-shadow:none}._listItemHighlighted_11mz1_72{border-left:8px solid var(--dixa-color-orange-300)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._settingsWrapper_1ycvy_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);margin-bottom:var(--dixa-size-spacer-300)}._settingsWrapperHeader_1ycvy_6{cursor:pointer;padding:var(--dixa-size-spacer-300)}._settingsWrapperContent_1ycvy_10{border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);padding:var(--dixa-size-spacer-300);line-height:var(--dixa-typography-line-height-400)}._settingsWrapperContent_1ycvy_10 ol{margin-bottom:0}._settingsWrapperContentCode_1ycvy_18{background-color:var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);font-family:var(--dixa-typography-family-code);font-size:var(--dixa-typography-size-200)}._settingsWrapperContentCURL_1ycvy_26{overflow:auto;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-300);font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-secondary);background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var em = { exports: {} }, Ya = {}, Sb;
function r4() {
  if (Sb) return Ya;
  Sb = 1;
  var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, g = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (g = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: g, props: f, _owner: a.current };
  }
  return Ya.Fragment = r, Ya.jsx = s, Ya.jsxs = s, Ya;
}
var ss = {}, Nb;
function i4() {
  return Nb || (Nb = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = Fe, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), d = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), C = Symbol.iterator, S = "@@iterator";
    function N(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[S];
      return typeof c == "function" ? c : null;
    }
    var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), v = 1; v < c; v++)
          p[v - 1] = arguments[v];
        z("error", t, p);
      }
    }
    function z(t, c, p) {
      {
        var v = w.ReactDebugCurrentFrame, A = v.getStackAddendum();
        A !== "" && (c += "%s", p = p.concat([A]));
        var L = p.map(function(F) {
          return String(F);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, L);
      }
    }
    var $ = !1, I = !1, T = !1, U = !1, Q = !1, J;
    J = Symbol.for("react.module.reference");
    function ae(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || Q || t === a || t === m || t === u || U || t === g || $ || I || T || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function X(t, c, p) {
      var v = t.displayName;
      if (v)
        return v;
      var A = c.displayName || c.name || "";
      return A !== "" ? p + "(" + A + ")" : p;
    }
    function B(t) {
      return t.displayName || "Context";
    }
    function O(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return B(c) + ".Consumer";
          case s:
            var p = t;
            return B(p._context) + ".Provider";
          case d:
            return X(t, t.render, "ForwardRef");
          case f:
            var v = t.displayName || null;
            return v !== null ? v : O(t.type) || "Memo";
          case h: {
            var A = t, L = A._payload, F = A._init;
            try {
              return O(F(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var q = Object.assign, ee = 0, ve, ue, ce, fe, W, xe, Ie;
    function K() {
    }
    K.__reactDisabledLog = !0;
    function qe() {
      {
        if (ee === 0) {
          ve = console.log, ue = console.info, ce = console.warn, fe = console.error, W = console.group, xe = console.groupCollapsed, Ie = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: K,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Be() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: q({}, t, {
              value: ve
            }),
            info: q({}, t, {
              value: ue
            }),
            warn: q({}, t, {
              value: ce
            }),
            error: q({}, t, {
              value: fe
            }),
            group: q({}, t, {
              value: W
            }),
            groupCollapsed: q({}, t, {
              value: xe
            }),
            groupEnd: q({}, t, {
              value: Ie
            })
          });
        }
        ee < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = w.ReactCurrentDispatcher, Me;
    function $e(t, c, p) {
      {
        if (Me === void 0)
          try {
            throw Error();
          } catch (A) {
            var v = A.stack.trim().match(/\n( *(at )?)/);
            Me = v && v[1] || "";
          }
        return `
` + Me + t;
      }
    }
    var ze = !1, Re;
    {
      var an = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new an();
    }
    function Ee(t, c) {
      if (!t || ze)
        return "";
      {
        var p = Re.get(t);
        if (p !== void 0)
          return p;
      }
      var v;
      ze = !0;
      var A = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = Oe.current, Oe.current = null, qe();
      try {
        if (c) {
          var F = function() {
            throw Error();
          };
          if (Object.defineProperty(F.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(F, []);
            } catch (ne) {
              v = ne;
            }
            Reflect.construct(t, [], F);
          } else {
            try {
              F.call();
            } catch (ne) {
              v = ne;
            }
            t.call(F.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            v = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && v && typeof ne.stack == "string") {
          for (var j = ne.stack.split(`
`), te = v.stack.split(`
`), G = j.length - 1, _ = te.length - 1; G >= 1 && _ >= 0 && j[G] !== te[_]; )
            _--;
          for (; G >= 1 && _ >= 0; G--, _--)
            if (j[G] !== te[_]) {
              if (G !== 1 || _ !== 1)
                do
                  if (G--, _--, _ < 0 || j[G] !== te[_]) {
                    var Z = `
` + j[G].replace(" at new ", " at ");
                    return t.displayName && Z.includes("<anonymous>") && (Z = Z.replace("<anonymous>", t.displayName)), typeof t == "function" && Re.set(t, Z), Z;
                  }
                while (G >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        ze = !1, Oe.current = L, Be(), Error.prepareStackTrace = A;
      }
      var de = t ? t.displayName || t.name : "", Se = de ? $e(de) : "";
      return typeof t == "function" && Re.set(t, Se), Se;
    }
    function Ge(t, c, p) {
      return Ee(t, !1);
    }
    function Qe(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function he(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return Ee(t, Qe(t));
      if (typeof t == "string")
        return $e(t);
      switch (t) {
        case m:
          return $e("Suspense");
        case u:
          return $e("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Ge(t.render);
          case f:
            return he(t.type, c, p);
          case h: {
            var v = t, A = v._payload, L = v._init;
            try {
              return he(L(A), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var ge = Object.prototype.hasOwnProperty, De = {}, Le = w.ReactDebugCurrentFrame;
    function Ae(t) {
      if (t) {
        var c = t._owner, p = he(t.type, t._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function mn(t, c, p, v, A) {
      {
        var L = Function.call.bind(ge);
        for (var F in t)
          if (L(t, F)) {
            var j = void 0;
            try {
              if (typeof t[F] != "function") {
                var te = Error((v || "React class") + ": " + p + " type `" + F + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[F] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw te.name = "Invariant Violation", te;
              }
              j = t[F](c, F, v, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (G) {
              j = G;
            }
            j && !(j instanceof Error) && (Ae(A), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", v || "React class", p, F, typeof j), Ae(null)), j instanceof Error && !(j.message in De) && (De[j.message] = !0, Ae(A), y("Failed %s type: %s", p, j.message), Ae(null));
          }
      }
    }
    var E = Array.isArray;
    function x(t) {
      return E(t);
    }
    function D(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function H(t) {
      try {
        return Y(t), !1;
      } catch {
        return !0;
      }
    }
    function Y(t) {
      return "" + t;
    }
    function R(t) {
      if (H(t))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", D(t)), Y(t);
    }
    var V = w.ReactCurrentOwner, ie = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, me, Ne;
    function nn(t) {
      if (ge.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function fn(t) {
      if (ge.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function tn(t, c) {
      typeof t.ref == "string" && V.current;
    }
    function cn(t, c) {
      {
        var p = function() {
          me || (me = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function pn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var dn = function(t, c, p, v, A, L, F) {
      var j = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: F,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return j._store = {}, Object.defineProperty(j._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(j, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: v
      }), Object.defineProperty(j, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: A
      }), Object.freeze && (Object.freeze(j.props), Object.freeze(j)), j;
    };
    function xn(t, c, p, v, A) {
      {
        var L, F = {}, j = null, te = null;
        p !== void 0 && (R(p), j = "" + p), fn(c) && (R(c.key), j = "" + c.key), nn(c) && (te = c.ref, tn(c));
        for (L in c)
          ge.call(c, L) && !ie.hasOwnProperty(L) && (F[L] = c[L]);
        if (t && t.defaultProps) {
          var G = t.defaultProps;
          for (L in G)
            F[L] === void 0 && (F[L] = G[L]);
        }
        if (j || te) {
          var _ = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          j && cn(F, _), te && pn(F, _);
        }
        return dn(t, j, te, A, v, V.current, F);
      }
    }
    var en = w.ReactCurrentOwner, jn = w.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = he(t.type, t._source, c ? c.type : null);
        jn.setExtraStackFrame(p);
      } else
        jn.setExtraStackFrame(null);
    }
    var on;
    on = !1;
    function sn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function vn() {
      {
        if (en.current) {
          var t = O(en.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function qn(t) {
      return "";
    }
    var wn = {};
    function kn(t) {
      {
        var c = vn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = kn(c);
        if (wn[p])
          return;
        wn[p] = !0;
        var v = "";
        t && t._owner && t._owner !== en.current && (v = " It was passed a child from " + O(t._owner.type) + "."), Pe(t), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, v), Pe(null);
      }
    }
    function Cn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (x(t))
          for (var p = 0; p < t.length; p++) {
            var v = t[p];
            sn(v) && gn(v, c);
          }
        else if (sn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var A = N(t);
          if (typeof A == "function" && A !== t.entries)
            for (var L = A.call(t), F; !(F = L.next()).done; )
              sn(F.value) && gn(F.value, c);
        }
      }
    }
    function Un(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var v = O(c);
          mn(p, t.props, "prop", v, t);
        } else if (c.PropTypes !== void 0 && !on) {
          on = !0;
          var A = O(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", A || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Vn(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var v = c[p];
          if (v !== "children" && v !== "key") {
            Pe(t), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", v), Pe(null);
            break;
          }
        }
        t.ref !== null && (Pe(t), y("Invalid attribute `ref` supplied to `React.Fragment`."), Pe(null));
      }
    }
    var Sn = {};
    function Nn(t, c, p, v, A, L) {
      {
        var F = ae(t);
        if (!F) {
          var j = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (j += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var te = qn();
          te ? j += te : j += vn();
          var G;
          t === null ? G = "null" : x(t) ? G = "array" : t !== void 0 && t.$$typeof === n ? (G = "<" + (O(t.type) || "Unknown") + " />", j = " Did you accidentally export a JSX literal instead of a component?") : G = typeof t, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", G, j);
        }
        var _ = xn(t, c, p, A, L);
        if (_ == null)
          return _;
        if (F) {
          var Z = c.children;
          if (Z !== void 0)
            if (v)
              if (x(Z)) {
                for (var de = 0; de < Z.length; de++)
                  Cn(Z[de], t);
                Object.freeze && Object.freeze(Z);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cn(Z, t);
        }
        if (ge.call(c, "key")) {
          var Se = O(t), ne = Object.keys(c).filter(function(Tn) {
            return Tn !== "key";
          }), Ke = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Ke]) {
            var $n = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ke, Se, $n, Se), Sn[Se + Ke] = !0;
          }
        }
        return t === i ? Vn(_) : Un(_), _;
      }
    }
    function Hn(t, c, p) {
      return Nn(t, c, p, !0);
    }
    function Dn(t, c, p) {
      return Nn(t, c, p, !1);
    }
    var Rn = Dn, Mn = Hn;
    ss.Fragment = i, ss.jsx = Rn, ss.jsxs = Mn;
  })()), ss;
}
var jb;
function a4() {
  return jb || (jb = 1, process.env.NODE_ENV === "production" ? em.exports = r4() : em.exports = i4()), em.exports;
}
var Te = a4();
const o4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phone" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "externalIds" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "storeId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "expand" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Yotpo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "phone_number" }, value: { kind: "Variable", name: { kind: "Name", value: "phone" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "external_ids" }, value: { kind: "Variable", name: { kind: "Name", value: "externalIds" } } }, { kind: "Argument", name: { kind: "Name", value: "store_id" }, value: { kind: "Variable", name: { kind: "Name", value: "storeId" } } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "Variable", name: { kind: "Name", value: "expand" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone_number" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "gender" } }, { kind: "Field", name: { kind: "Name", value: "account_created_at" } }, { kind: "Field", name: { kind: "Name", value: "account_updated_at" } }, { kind: "Field", name: { kind: "Name", value: "default_language" } }, { kind: "Field", name: { kind: "Name", value: "dafault_currency" } }, { kind: "Field", name: { kind: "Name", value: "lists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "since" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_ugc" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "total_reviews" } }, { kind: "Field", name: { kind: "Name", value: "avg_product_rating" } }, { kind: "Field", name: { kind: "Name", value: "avg_site_rating" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_rating" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_product" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_site" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_sentiment" } }, { kind: "Field", name: { kind: "Name", value: "top_topics" } }, { kind: "Field", name: { kind: "Name", value: "last_star_rating" } }, { kind: "Field", name: { kind: "Name", value: "last_review_date" } }, { kind: "Field", name: { kind: "Name", value: "last_sentiment" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_loyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "points_earned" } }, { kind: "Field", name: { kind: "Name", value: "points_balance" } }, { kind: "Field", name: { kind: "Name", value: "last_seen_at" } }, { kind: "Field", name: { kind: "Name", value: "total_redemptions" } }, { kind: "Field", name: { kind: "Name", value: "total_points_redeemed" } }, { kind: "Field", name: { kind: "Name", value: "vip_tier_name" } }, { kind: "Field", name: { kind: "Name", value: "successful_referrals" } }, { kind: "Field", name: { kind: "Name", value: "referrals_made_and_clicked" } }, { kind: "Field", name: { kind: "Name", value: "is_referred_by_other_customer" } }, { kind: "Field", name: { kind: "Name", value: "points_expire_date" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_amount" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_customer_currency" } }, { kind: "Field", name: { kind: "Name", value: "is_opt_in" } }, { kind: "Field", name: { kind: "Name", value: "opt_in_date" } }, { kind: "Field", name: { kind: "Name", value: "opt_out_date" } }, { kind: "Field", name: { kind: "Name", value: "has_store_account" } }, { kind: "Field", name: { kind: "Name", value: "referred_by_customer" } }, { kind: "Field", name: { kind: "Name", value: "vip_entry_date" } }, { kind: "Field", name: { kind: "Name", value: "vip_expiration_date" } }, { kind: "Field", name: { kind: "Name", value: "next_points_expire_on" } }, { kind: "Field", name: { kind: "Name", value: "next_points_expire_amount" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "active_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "paused_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "failed_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "expired_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, s4 = {
  "\n  query getCustomerDetails(\n    $email: String\n    $phone: String\n    $limit: Int\n    $externalIds: String\n    $storeId: String!\n    $expand: String\n  ) {\n    Yotpo {\n      getCustomers(\n        email: $email\n        phone_number: $phone\n        limit: $limit\n        external_ids: $externalIds\n        store_id: $storeId\n        expand: $expand\n      ) {\n        ... on Yotpo_getCustomers_response {\n          ... on Yotpo_Customers {\n            customers {\n              external_id\n              email\n              phone_number\n              first_name\n              last_name\n              gender\n              account_created_at\n              account_updated_at\n              default_language\n              dafault_currency\n              lists {\n                id\n                since\n              }\n              yotpo_ugc {\n                total_reviews\n                avg_product_rating\n                avg_site_rating\n                total_avg_rating\n                sentiment_avg_product\n                sentiment_avg_site\n                total_avg_sentiment\n                top_topics\n                last_star_rating\n                last_review_date\n                last_sentiment\n              }\n              yotpo_loyalty {\n                points_earned\n                points_balance\n                last_seen_at\n                total_redemptions\n                total_points_redeemed\n                vip_tier_name\n                successful_referrals\n                referrals_made_and_clicked\n                is_referred_by_other_customer\n                points_expire_date\n                credit_balance_amount\n                credit_balance_customer_currency\n                is_opt_in\n                opt_in_date\n                opt_out_date\n                has_store_account\n                referred_by_customer\n                vip_entry_date\n                vip_expiration_date\n                next_points_expire_on\n                next_points_expire_amount\n              }\n              yotpo_subscriptions {\n                active_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                paused_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                failed_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                expired_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                canceled_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": o4
};
function l4(e) {
  return s4[e] ?? {};
}
const c4 = l4(
  /* GraphQL */
  `
  query getCustomerDetails(
    $email: String
    $phone: String
    $limit: Int
    $externalIds: String
    $storeId: String!
    $expand: String
  ) {
    Yotpo {
      getCustomers(
        email: $email
        phone_number: $phone
        limit: $limit
        external_ids: $externalIds
        store_id: $storeId
        expand: $expand
      ) {
        ... on Yotpo_getCustomers_response {
          ... on Yotpo_Customers {
            customers {
              external_id
              email
              phone_number
              first_name
              last_name
              gender
              account_created_at
              account_updated_at
              default_language
              dafault_currency
              lists {
                id
                since
              }
              yotpo_ugc {
                total_reviews
                avg_product_rating
                avg_site_rating
                total_avg_rating
                sentiment_avg_product
                sentiment_avg_site
                total_avg_sentiment
                top_topics
                last_star_rating
                last_review_date
                last_sentiment
              }
              yotpo_loyalty {
                points_earned
                points_balance
                last_seen_at
                total_redemptions
                total_points_redeemed
                vip_tier_name
                successful_referrals
                referrals_made_and_clicked
                is_referred_by_other_customer
                points_expire_date
                credit_balance_amount
                credit_balance_customer_currency
                is_opt_in
                opt_in_date
                opt_out_date
                has_store_account
                referred_by_customer
                vip_entry_date
                vip_expiration_date
                next_points_expire_on
                next_points_expire_amount
              }
              yotpo_subscriptions {
                active_subscriptions {
                  externalProductId
                  externalVariantId
                }
                paused_subscriptions {
                  externalProductId
                  externalVariantId
                }
                failed_subscriptions {
                  externalProductId
                  externalVariantId
                }
                expired_subscriptions {
                  externalProductId
                  externalVariantId
                }
                canceled_subscriptions {
                  externalProductId
                  externalVariantId
                }
              }
            }
          }
        }
      }
    }
  }
`
), d4 = "_copyIcon_11mz1_48", u4 = "_list_11mz1_53", m4 = "_listItem_11mz1_63", p4 = "_listItemHighlighted_11mz1_72", sa = {
  copyIcon: d4,
  list: u4,
  listItem: m4,
  listItemHighlighted: p4
}, f4 = "_wrapper_1xucg_1", h4 = "_externalLink_1xucg_7", nm = {
  wrapper: f4,
  externalLink: h4
}, y4 = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = or(), { isCopied: i, copy: a } = or();
  if (!e)
    return null;
  const {
    first_name: o,
    last_name: s,
    email: l,
    phone_number: d,
    account_created_at: m
  } = e, u = 14, f = `${o || ""} ${s || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ Te.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Te.jsxs(b, { className: nm.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Te.jsx(
      b,
      {
        justifyContent: "space-between",
        className: nm.block,
        alignItems: "center",
        children: /* @__PURE__ */ Te.jsx(P.Heading, { variant: "heading-2", children: f })
      }
    ),
    m && /* @__PURE__ */ Te.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ Te.jsx(P.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ Te.jsx(P.Paragraph, { variant: "4", children: Ln(m).format(xt) })
    ] }),
    l && /* @__PURE__ */ Te.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Te.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Te.jsx(pe, { size: u, name: "mail" }),
        /* @__PURE__ */ Te.jsx("span", { className: nm.externalLink, children: l })
      ] }),
      /* @__PURE__ */ Te.jsx(We, { content: "Copy email", children: /* @__PURE__ */ Te.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Te.jsx(
        pe,
        {
          size: u,
          name: n ? "done" : "copy",
          onClick: () => r(l),
          className: sa.copyIcon
        }
      ) }) })
    ] }),
    d && /* @__PURE__ */ Te.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Te.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Te.jsx(pe, { size: u, name: "phone" }),
        /* @__PURE__ */ Te.jsx(P.Paragraph, { variant: "4", children: d })
      ] }),
      /* @__PURE__ */ Te.jsx(We, { content: "Copy phone number", children: /* @__PURE__ */ Te.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Te.jsx(
        pe,
        {
          size: u,
          name: i ? "done" : "copy",
          onClick: () => a(d),
          className: sa.copyIcon
        }
      ) }) })
    ] })
  ] }) });
}, Wn = ({
  description: e,
  content: n,
  tooltip: r,
  isHighlighted: i = !1
}) => {
  if (n == null)
    return null;
  const a = w0(n);
  return /* @__PURE__ */ Te.jsx(
    Ye.Text,
    {
      variant: "dense",
      className: it(sa.listItem, {
        [sa.listItemHighlighted]: i
      }),
      children: /* @__PURE__ */ Te.jsx(We, { content: r, children: /* @__PURE__ */ Te.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ Te.jsx(P.Paragraph, { variant: "4", children: e }),
        a ? n : po(n)
      ] }) })
    }
  );
}, g4 = ({
  loyalty: e
}) => /* @__PURE__ */ Te.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ Te.jsx(P.Heading, { variant: "heading-3", children: "Loyalty" }),
  !e && /* @__PURE__ */ Te.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ Te.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No loyalty data available" }) }),
  e && /* @__PURE__ */ Te.jsxs(Ye, { className: sa.list, children: [
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        isHighlighted: !0,
        description: "Successful referrals",
        tooltip: "The total number of successful referrals made by the customer.",
        content: e.successful_referrals
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        isHighlighted: !0,
        description: "Referrals made and clicked",
        tooltip: "The total number of referrals made by the customer and clicked on by others.",
        content: e.referrals_made_and_clicked
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Points earned",
        tooltip: "The total number of loyalty points earned by the customer.",
        content: e.points_earned
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Points balance",
        tooltip: "The current balance of loyalty points for the customer.",
        content: e.points_balance
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Last seen",
        tooltip: "The timestamp when the customer was last seen or engaged with the loyalty program.",
        content: e.last_seen_at
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Total redemptions",
        tooltip: "The total number of times the customer has redeemed loyalty points.",
        content: e.total_redemptions
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Total points redeemed",
        tooltip: "The total number of loyalty points redeemed by the customer.",
        content: e.total_points_redeemed
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "VIP tier",
        tooltip: "The name of the customer's current VIP tier status.",
        content: e.vip_tier_name
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Referred by other customer",
        tooltip: "Indicates whether the customer was referred by another customer.",
        content: e.is_referred_by_other_customer
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Points expiry date",
        tooltip: "The timestamp when the customer's loyalty points are set to expire.",
        content: e.next_points_expire_on || e.points_expire_date
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Points expiry amount",
        tooltip: "The number of points that are about to expire",
        content: e.next_points_expire_amount
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Credit balance amount",
        tooltip: "The amount of store credit available to the customer in the default currency of the store.",
        content: e.credit_balance_amount
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Credit balance customer currency",
        tooltip: "The store credit amount in the customer's preferred currency.",
        content: e.credit_balance_customer_currency
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Opt in",
        tooltip: "Indicates whether the customer has opted into the loyalty program.",
        content: e.is_opt_in
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Opt in date",
        tooltip: "The timestamp for when the customer opted into the loyalty program.",
        content: e.opt_in_date
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Opt out date",
        tooltip: "The timestamp for when the customer opted out of the loyalty program.",
        content: e.opt_out_date
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Has store account",
        tooltip: "Indicates whether the customer has a store account.",
        content: e.has_store_account
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Referred by customer",
        tooltip: "The email address of the customer who referred this customer to the loyalty program.",
        content: e.referred_by_customer
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "VIP entry date",
        tooltip: "The timestamp for when the customer entered the VIP tier.",
        content: e.vip_entry_date
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "VIP expiration date",
        tooltip: "The timestamp for when the customer's VIP tier membership is set to expire.",
        content: e.vip_expiration_date
      }
    )
  ] })
] }), v4 = 0.8, k4 = 0.4, wb = (e) => {
  if (e != null)
    return e >= v4 ? /* @__PURE__ */ Te.jsx(An, { variant: "success", size: "small", children: "Positive" }) : e <= k4 ? /* @__PURE__ */ Te.jsx(An, { variant: "error", size: "small", children: "Negative" }) : /* @__PURE__ */ Te.jsx(An, { variant: "warning", size: "small", children: "Neutral" });
}, b4 = ({
  userGeneratedContent: e
}) => /* @__PURE__ */ Te.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ Te.jsx(P.Heading, { variant: "heading-3", children: "User generated content" }),
  !e && /* @__PURE__ */ Te.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ Te.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No user generated content available" }) }),
  e && /* @__PURE__ */ Te.jsxs(Ye, { className: sa.list, children: [
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        isHighlighted: !0,
        description: "Total reviews",
        tooltip: "The total number of reviews submitted by the customer.",
        content: e.total_reviews
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        isHighlighted: !0,
        description: "Total average rating",
        tooltip: "The total average rating given by the customer (combining products and site/store ratings).",
        content: e.total_avg_rating?.toFixed(2)
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        isHighlighted: !0,
        description: "Total average sentiment score",
        tooltip: "The total average sentiment score given by the customer (combining products and site/store scores).",
        content: wb(e.total_avg_sentiment)
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Average product rating",
        tooltip: "The average product rating given by the customer.",
        content: e.avg_product_rating
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Average site rating",
        tooltip: "The average rating of the site/store given by the customer.",
        content: e.avg_site_rating?.toFixed(2)
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Last sentiment",
        tooltip: "The sentiment score of the customer's last review.",
        content: wb(e.last_sentiment)
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Last star rating",
        tooltip: "The star rating of the customer's last review.",
        content: e.last_star_rating
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Last review date",
        tooltip: "The timestamp for when the customer last submitted a review.",
        content: Ln(e.last_review_date).format(
          xt
        )
      }
    ),
    /* @__PURE__ */ Te.jsx(
      Wn,
      {
        description: "Topics",
        tooltip: "An list of top topics (themes) mentioned in all of the customer's reviews.",
        content: /* @__PURE__ */ Te.jsx(
          b,
          {
            gap: "100",
            width: "80%",
            flexWrap: "wrap",
            justifyContent: "flex-end",
            children: e.top_topics?.map((n, r) => /* @__PURE__ */ Te.jsx(An, { variant: "info", size: "small", children: /* @__PURE__ */ Te.jsx(Te.Fragment, { children: n }) }, r))
          }
        )
      }
    )
  ] })
] }), x4 = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = hn(), { track: i } = _n(), [a, o] = le(), [s, l] = le(!1), d = e?.customer?.email, m = e?.customer?.phone_number, u = !d && !m, f = n?.yotpoStoreId, h = n?.showCustomerDetails ?? !1, g = n?.showUserGeneratedContent ?? !1, C = n?.displayLoyalty ?? !1, S = n?.displaySubscriptions ?? !1, N = !f, w = !h && !g && !C && !S, {
    loading: y,
    error: z,
    data: $
  } = r(c4, {
    skip: u || N,
    variables: {
      ...d && { email: d },
      ...!d && m && { phone: m },
      storeId: f,
      expand: "all"
    }
  });
  if (He(() => {
    const I = $?.Yotpo?.getCustomers?.customers?.[0];
    I ? (o(I), l(!1), i("yotpo:customer:received")) : l(!0);
  }, [$?.Yotpo, y]), N)
    return /* @__PURE__ */ Te.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Te.jsx(
      Fn,
      {
        error: new nx({
          graphQLErrors: [
            {
              message: "Integration needs to be re-/authorized in the settings."
            }
          ]
        }),
        hideCopyButton: !0
      }
    ) });
  if (u)
    return /* @__PURE__ */ Te.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-contact-message",
        children: /* @__PURE__ */ Te.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
      }
    );
  if (w)
    return /* @__PURE__ */ Te.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-features",
        children: /* @__PURE__ */ Te.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." })
      }
    );
  if (y)
    return /* @__PURE__ */ Te.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Te.jsx(un, {}) });
  if (s)
    return /* @__PURE__ */ Te.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Te.jsx(P.Paragraph, { variant: "4", color: "secondary", children: "No customer profile found." }) });
  if (z) {
    const I = z.graphQLErrors;
    return Vm({ errors: I }) ? /* @__PURE__ */ Te.jsx(
      P.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : zm({ errors: I }) ? /* @__PURE__ */ Te.jsx(
      P.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Yotpo. Please contact your administrator."
      }
    ) : /* @__PURE__ */ Te.jsx(Fn, { error: z });
  }
  return /* @__PURE__ */ Te.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ Te.jsx(y4, { customerDetails: a }),
        g && /* @__PURE__ */ Te.jsx(
          b4,
          {
            userGeneratedContent: a?.yotpo_ugc
          }
        ),
        C && /* @__PURE__ */ Te.jsx(g4, { loyalty: a?.yotpo_loyalty })
      ]
    }
  );
};
var To = (e) => e.type === "checkbox", vi = (e) => e instanceof Date, Ht = (e) => e == null;
const US = (e) => typeof e == "object";
var ft = (e) => !Ht(e) && !Array.isArray(e) && US(e) && !vi(e), MS = (e) => ft(e) && e.target ? To(e.target) ? e.target.checked : e.target.value : e, _4 = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, BS = (e, n) => e.has(_4(n)), S4 = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return ft(n) && n.hasOwnProperty("isPrototypeOf");
}, ef = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function It(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(ef && (e instanceof Blob || i)) && (r || ft(e)))
    if (n = r ? [] : {}, !r && !S4(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = It(e[a]));
  else
    return e;
  return n;
}
var hl = (e) => Array.isArray(e) ? e.filter(Boolean) : [], dt = (e) => e === void 0, Ze = (e, n, r) => {
  if (!n || !ft(e))
    return r;
  const i = hl(n.split(/[,[\].]+?/)).reduce((a, o) => Ht(a) ? a : a[o], e);
  return dt(i) || i === e ? dt(e[n]) ? r : e[n] : i;
}, ar = (e) => typeof e == "boolean", nf = (e) => /^\w*$/.test(e), qS = (e) => hl(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Qn = (e, n, r) => {
  let i = -1;
  const a = nf(n) ? [n] : qS(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = ft(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const Ms = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, _r = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Wr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, N4 = Fe.createContext(null), tf = () => Fe.useContext(N4);
var HS = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== _r.all && (n._proxyFormState[s] = !i || _r.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function j4(e) {
  const n = tf(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = Fe.useState(r._formState), d = Fe.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = Fe.useRef(a);
  return m.current = a, Fe.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), Fe.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), Fe.useMemo(() => HS(s, r, d.current, !1), [s, r]);
}
var Or = (e) => typeof e == "string", WS = (e, n, r, i, a) => Or(e) ? (i && n.watch.add(e), Ze(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Ze(r, o))) : (i && (n.watchAll = !0), r);
function GS(e) {
  const n = tf(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = Fe.useRef(i), d = Fe.useRef(a);
  l.current = i, Fe.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(WS(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = Fe.useState(r._getWatch(i, a));
  return Fe.useEffect(() => r._removeUnmounted()), m;
}
function w4(e) {
  const n = tf(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = BS(a._names.array, r), l = GS({
    control: a,
    name: r,
    defaultValue: Ze(a._formValues, r, Ze(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = j4({
    control: a,
    name: r,
    exact: !0
  }), m = Fe.useRef(e), u = Fe.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...ar(e.disabled) ? { disabled: e.disabled } : {}
  })), f = Fe.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Ze(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Ze(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Ze(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Ze(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => Ze(d.errors, r)
    }
  }), [d, r]), h = Fe.useCallback((N) => u.current.onChange({
    target: {
      value: MS(N),
      name: r
    },
    type: Ms.CHANGE
  }), [r]), g = Fe.useCallback(() => u.current.onBlur({
    target: {
      value: Ze(a._formValues, r),
      name: r
    },
    type: Ms.BLUR
  }), [r, a._formValues]), C = Fe.useCallback((N) => {
    const w = Ze(a._fields, r);
    w && N && (w._f.ref = {
      focus: () => N.focus(),
      select: () => N.select(),
      setCustomValidity: (y) => N.setCustomValidity(y),
      reportValidity: () => N.reportValidity()
    });
  }, [a._fields, r]), S = Fe.useMemo(() => ({
    name: r,
    value: l,
    ...ar(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: g,
    ref: C
  }), [r, i, d.disabled, h, g, C, l]);
  return Fe.useEffect(() => {
    const N = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...ar(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const w = (y, z) => {
      const $ = Ze(a._fields, y);
      $ && $._f && ($._f.mount = z);
    };
    if (w(r, !0), N) {
      const y = It(Ze(a._options.defaultValues, r));
      Qn(a._defaultValues, r, y), dt(Ze(a._formValues, r)) && Qn(a._formValues, r, y);
    }
    return !s && a.register(r), () => {
      (s ? N && !a._state.action : N) ? a.unregister(r) : w(r, !1);
    };
  }, [r, a, s, o]), Fe.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), Fe.useMemo(() => ({
    field: S,
    formState: d,
    fieldState: f
  }), [S, d, f]);
}
const Cb = (e) => e.render(w4(e));
var C4 = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, co = (e) => Array.isArray(e) ? e : [e], Fb = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const r of e)
        r.next && r.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((r) => r !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, Lm = (e) => Ht(e) || !US(e);
function ii(e, n) {
  if (Lm(e) || Lm(n))
    return e === n;
  if (vi(e) && vi(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (vi(o) && vi(s) || ft(o) && ft(s) || Array.isArray(o) && Array.isArray(s) ? !ii(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Mt = (e) => ft(e) && !Object.keys(e).length, rf = (e) => e.type === "file", Sr = (e) => typeof e == "function", Bs = (e) => {
  if (!ef)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, KS = (e) => e.type === "select-multiple", af = (e) => e.type === "radio", F4 = (e) => af(e) || To(e), tm = (e) => Bs(e) && e.isConnected;
function I4(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = dt(e) ? i++ : e[n[i++]];
  return e;
}
function E4(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !dt(e[n]))
      return !1;
  return !0;
}
function bt(e, n) {
  const r = Array.isArray(n) ? n : nf(n) ? [n] : qS(n), i = r.length === 1 ? e : I4(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (ft(i) && Mt(i) || Array.isArray(i) && E4(i)) && bt(e, r.slice(0, -1)), e;
}
var YS = (e) => {
  for (const n in e)
    if (Sr(e[n]))
      return !0;
  return !1;
};
function qs(e, n = {}) {
  const r = Array.isArray(e);
  if (ft(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || ft(e[i]) && !YS(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, qs(e[i], n[i])) : Ht(e[i]) || (n[i] = !0);
  return n;
}
function QS(e, n, r) {
  const i = Array.isArray(e);
  if (ft(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || ft(e[a]) && !YS(e[a]) ? dt(n) || Lm(r[a]) ? r[a] = Array.isArray(e[a]) ? qs(e[a], []) : { ...qs(e[a]) } : QS(e[a], Ht(n) ? {} : n[a], r[a]) : r[a] = !ii(e[a], n[a]);
  return r;
}
var Qa = (e, n) => QS(e, n, qs(n));
const Ib = {
  value: !1,
  isValid: !1
}, Eb = { value: !0, isValid: !0 };
var JS = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !dt(e[0].attributes.value) ? dt(e[0].value) || e[0].value === "" ? Eb : { value: e[0].value, isValid: !0 } : Eb
    ) : Ib;
  }
  return Ib;
}, XS = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => dt(e) ? e : n ? e === "" ? NaN : e && +e : r && Or(e) ? new Date(e) : i ? i(e) : e;
const Tb = {
  isValid: !1,
  value: null
};
var ZS = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, Tb) : Tb;
function $b(e) {
  const n = e.ref;
  return rf(n) ? n.files : af(n) ? ZS(e.refs).value : KS(n) ? [...n.selectedOptions].map(({ value: r }) => r) : To(n) ? JS(e.refs).value : XS(dt(n.value) ? e.ref.value : n.value, e);
}
var T4 = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = Ze(n, o);
    s && Qn(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, Hs = (e) => e instanceof RegExp, Ja = (e) => dt(e) ? e : Hs(e) ? e.source : ft(e) ? Hs(e.value) ? e.value.source : e.value : e, Db = (e) => ({
  isOnSubmit: !e || e === _r.onSubmit,
  isOnBlur: e === _r.onBlur,
  isOnChange: e === _r.onChange,
  isOnAll: e === _r.all,
  isOnTouch: e === _r.onTouched
});
const Rb = "AsyncFunction";
var $4 = (e) => !!e && !!e.validate && !!(Sr(e.validate) && e.validate.constructor.name === Rb || ft(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === Rb)), D4 = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), Ob = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const uo = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = Ze(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (uo(l, n))
          break;
      } else if (ft(l) && uo(l, n))
        break;
    }
  }
};
function Ab(e, n, r) {
  const i = Ze(e, r);
  if (i || nf(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Ze(n, o), l = Ze(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var R4 = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Mt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || _r.all));
}, O4 = (e, n, r) => !e || !n || e === n || co(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), A4 = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, P4 = (e, n) => !hl(Ze(e, n)).length && bt(e, n), L4 = (e, n, r) => {
  const i = co(Ze(e, r));
  return Qn(i, "root", n[r]), Qn(e, r, i), e;
}, Ss = (e) => Or(e);
function Pb(e, n, r = "validate") {
  if (Ss(e) || Array.isArray(e) && e.every(Ss) || ar(e) && !e)
    return {
      type: r,
      message: Ss(e) ? e : "",
      ref: n
    };
}
var Gi = (e) => ft(e) && !Hs(e) ? e : {
  value: e,
  message: ""
}, Lb = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: g, validate: C, name: S, valueAsNumber: N, mount: w } = e._f, y = Ze(r, S);
  if (!w || n.has(S))
    return {};
  const z = l ? l[0] : s, $ = (B) => {
    a && z.reportValidity && (z.setCustomValidity(ar(B) ? "" : B || ""), z.reportValidity());
  }, I = {}, T = af(s), U = To(s), Q = T || U, J = (N || rf(s)) && dt(s.value) && dt(y) || Bs(s) && s.value === "" || y === "" || Array.isArray(y) && !y.length, ae = C4.bind(null, S, i, I), X = (B, O, q, ee = Wr.maxLength, ve = Wr.minLength) => {
    const ue = B ? O : q;
    I[S] = {
      type: B ? ee : ve,
      message: ue,
      ref: s,
      ...ae(B ? ee : ve, ue)
    };
  };
  if (o ? !Array.isArray(y) || !y.length : d && (!Q && (J || Ht(y)) || ar(y) && !y || U && !JS(l).isValid || T && !ZS(l).isValid)) {
    const { value: B, message: O } = Ss(d) ? { value: !!d, message: d } : Gi(d);
    if (B && (I[S] = {
      type: Wr.required,
      message: O,
      ref: z,
      ...ae(Wr.required, O)
    }, !i))
      return $(O), I;
  }
  if (!J && (!Ht(f) || !Ht(h))) {
    let B, O;
    const q = Gi(h), ee = Gi(f);
    if (!Ht(y) && !isNaN(y)) {
      const ve = s.valueAsNumber || y && +y;
      Ht(q.value) || (B = ve > q.value), Ht(ee.value) || (O = ve < ee.value);
    } else {
      const ve = s.valueAsDate || new Date(y), ue = (W) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + W), ce = s.type == "time", fe = s.type == "week";
      Or(q.value) && y && (B = ce ? ue(y) > ue(q.value) : fe ? y > q.value : ve > new Date(q.value)), Or(ee.value) && y && (O = ce ? ue(y) < ue(ee.value) : fe ? y < ee.value : ve < new Date(ee.value));
    }
    if ((B || O) && (X(!!B, q.message, ee.message, Wr.max, Wr.min), !i))
      return $(I[S].message), I;
  }
  if ((m || u) && !J && (Or(y) || o && Array.isArray(y))) {
    const B = Gi(m), O = Gi(u), q = !Ht(B.value) && y.length > +B.value, ee = !Ht(O.value) && y.length < +O.value;
    if ((q || ee) && (X(q, B.message, O.message), !i))
      return $(I[S].message), I;
  }
  if (g && !J && Or(y)) {
    const { value: B, message: O } = Gi(g);
    if (Hs(B) && !y.match(B) && (I[S] = {
      type: Wr.pattern,
      message: O,
      ref: s,
      ...ae(Wr.pattern, O)
    }, !i))
      return $(O), I;
  }
  if (C) {
    if (Sr(C)) {
      const B = await C(y, r), O = Pb(B, z);
      if (O && (I[S] = {
        ...O,
        ...ae(Wr.validate, O.message)
      }, !i))
        return $(O.message), I;
    } else if (ft(C)) {
      let B = {};
      for (const O in C) {
        if (!Mt(B) && !i)
          break;
        const q = Pb(await C[O](y, r), z, O);
        q && (B = {
          ...q,
          ...ae(O, q.message)
        }, $(q.message), i && (I[S] = B));
      }
      if (!Mt(B) && (I[S] = {
        ref: z,
        ...B
      }, !i))
        return I;
    }
  }
  return $(!0), I;
};
const V4 = {
  mode: _r.onSubmit,
  reValidateMode: _r.onChange,
  shouldFocusError: !0
};
function z4(e = {}) {
  let n = {
    ...V4,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: Sr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = ft(n.defaultValues) || ft(n.values) ? It(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : It(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: Fb(),
    state: Fb()
  }, g = Db(n.mode), C = Db(n.reValidateMode), S = n.criteriaMode === _r.all, N = (E) => (x) => {
    clearTimeout(m), m = setTimeout(E, x);
  }, w = async (E) => {
    if (!n.disabled && (u.isValid || f.isValid || E)) {
      const x = n.resolver ? Mt((await J()).errors) : await X(i, !0);
      x !== r.isValid && h.state.next({
        isValid: x
      });
    }
  }, y = (E, x) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((E || Array.from(l.mount)).forEach((D) => {
      D && (x ? Qn(r.validatingFields, D, x) : bt(r.validatingFields, D));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Mt(r.validatingFields)
    }));
  }, z = (E, x = [], D, H, Y = !0, R = !0) => {
    if (H && D && !n.disabled) {
      if (s.action = !0, R && Array.isArray(Ze(i, E))) {
        const V = D(Ze(i, E), H.argA, H.argB);
        Y && Qn(i, E, V);
      }
      if (R && Array.isArray(Ze(r.errors, E))) {
        const V = D(Ze(r.errors, E), H.argA, H.argB);
        Y && Qn(r.errors, E, V), P4(r.errors, E);
      }
      if ((u.touchedFields || f.touchedFields) && R && Array.isArray(Ze(r.touchedFields, E))) {
        const V = D(Ze(r.touchedFields, E), H.argA, H.argB);
        Y && Qn(r.touchedFields, E, V);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = Qa(a, o)), h.state.next({
        name: E,
        isDirty: O(E, x),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      Qn(o, E, x);
  }, $ = (E, x) => {
    Qn(r.errors, E, x), h.state.next({
      errors: r.errors
    });
  }, I = (E) => {
    r.errors = E, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, T = (E, x, D, H) => {
    const Y = Ze(i, E);
    if (Y) {
      const R = Ze(o, E, dt(D) ? Ze(a, E) : D);
      dt(R) || H && H.defaultChecked || x ? Qn(o, E, x ? R : $b(Y._f)) : ve(E, R), s.mount && w();
    }
  }, U = (E, x, D, H, Y) => {
    let R = !1, V = !1;
    const ie = {
      name: E
    };
    if (!n.disabled) {
      if (!D || H) {
        (u.isDirty || f.isDirty) && (V = r.isDirty, r.isDirty = ie.isDirty = O(), R = V !== ie.isDirty);
        const me = ii(Ze(a, E), x);
        V = !!Ze(r.dirtyFields, E), me ? bt(r.dirtyFields, E) : Qn(r.dirtyFields, E, !0), ie.dirtyFields = r.dirtyFields, R = R || (u.dirtyFields || f.dirtyFields) && V !== !me;
      }
      if (D) {
        const me = Ze(r.touchedFields, E);
        me || (Qn(r.touchedFields, E, D), ie.touchedFields = r.touchedFields, R = R || (u.touchedFields || f.touchedFields) && me !== D);
      }
      R && Y && h.state.next(ie);
    }
    return R ? ie : {};
  }, Q = (E, x, D, H) => {
    const Y = Ze(r.errors, E), R = (u.isValid || f.isValid) && ar(x) && r.isValid !== x;
    if (n.delayError && D ? (d = N(() => $(E, D)), d(n.delayError)) : (clearTimeout(m), d = null, D ? Qn(r.errors, E, D) : bt(r.errors, E)), (D ? !ii(Y, D) : Y) || !Mt(H) || R) {
      const V = {
        ...H,
        ...R && ar(x) ? { isValid: x } : {},
        errors: r.errors,
        name: E
      };
      r = {
        ...r,
        ...V
      }, h.state.next(V);
    }
  }, J = async (E) => {
    y(E, !0);
    const x = await n.resolver(o, n.context, T4(E || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return y(E), x;
  }, ae = async (E) => {
    const { errors: x } = await J(E);
    if (E)
      for (const D of E) {
        const H = Ze(x, D);
        H ? Qn(r.errors, D, H) : bt(r.errors, D);
      }
    else
      r.errors = x;
    return x;
  }, X = async (E, x, D = {
    valid: !0
  }) => {
    for (const H in E) {
      const Y = E[H];
      if (Y) {
        const { _f: R, ...V } = Y;
        if (R) {
          const ie = l.array.has(R.name), me = Y._f && $4(Y._f);
          me && u.validatingFields && y([H], !0);
          const Ne = await Lb(Y, l.disabled, o, S, n.shouldUseNativeValidation && !x, ie);
          if (me && u.validatingFields && y([H]), Ne[R.name] && (D.valid = !1, x))
            break;
          !x && (Ze(Ne, R.name) ? ie ? L4(r.errors, Ne, R.name) : Qn(r.errors, R.name, Ne[R.name]) : bt(r.errors, R.name));
        }
        !Mt(V) && await X(V, x, D);
      }
    }
    return D.valid;
  }, B = () => {
    for (const E of l.unMount) {
      const x = Ze(i, E);
      x && (x._f.refs ? x._f.refs.every((D) => !tm(D)) : !tm(x._f.ref)) && ze(E);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, O = (E, x) => !n.disabled && (E && x && Qn(o, E, x), !ii(Ie(), a)), q = (E, x, D) => WS(E, l, {
    ...s.mount ? o : dt(x) ? a : Or(E) ? { [E]: x } : x
  }, D, x), ee = (E) => hl(Ze(s.mount ? o : a, E, n.shouldUnregister ? Ze(a, E, []) : [])), ve = (E, x, D = {}) => {
    const H = Ze(i, E);
    let Y = x;
    if (H) {
      const R = H._f;
      R && (!R.disabled && Qn(o, E, XS(x, R)), Y = Bs(R.ref) && Ht(x) ? "" : x, KS(R.ref) ? [...R.ref.options].forEach((V) => V.selected = Y.includes(V.value)) : R.refs ? To(R.ref) ? R.refs.length > 1 ? R.refs.forEach((V) => (!V.defaultChecked || !V.disabled) && (V.checked = Array.isArray(Y) ? !!Y.find((ie) => ie === V.value) : Y === V.value)) : R.refs[0] && (R.refs[0].checked = !!Y) : R.refs.forEach((V) => V.checked = V.value === Y) : rf(R.ref) ? R.ref.value = "" : (R.ref.value = Y, R.ref.type || h.state.next({
        name: E,
        values: It(o)
      })));
    }
    (D.shouldDirty || D.shouldTouch) && U(E, Y, D.shouldTouch, D.shouldDirty, !0), D.shouldValidate && xe(E);
  }, ue = (E, x, D) => {
    for (const H in x) {
      const Y = x[H], R = `${E}.${H}`, V = Ze(i, R);
      (l.array.has(E) || ft(Y) || V && !V._f) && !vi(Y) ? ue(R, Y, D) : ve(R, Y, D);
    }
  }, ce = (E, x, D = {}) => {
    const H = Ze(i, E), Y = l.array.has(E), R = It(x);
    Qn(o, E, R), Y ? (h.array.next({
      name: E,
      values: It(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && D.shouldDirty && h.state.next({
      name: E,
      dirtyFields: Qa(a, o),
      isDirty: O(E, R)
    })) : H && !H._f && !Ht(R) ? ue(E, R, D) : ve(E, R, D), Ob(E, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? E : void 0,
      values: It(o)
    });
  }, fe = async (E) => {
    s.mount = !0;
    const x = E.target;
    let D = x.name, H = !0;
    const Y = Ze(i, D), R = (V) => {
      H = Number.isNaN(V) || vi(V) && isNaN(V.getTime()) || ii(V, Ze(o, D, V));
    };
    if (Y) {
      let V, ie;
      const me = x.type ? $b(Y._f) : MS(E), Ne = E.type === Ms.BLUR || E.type === Ms.FOCUS_OUT, nn = !D4(Y._f) && !n.resolver && !Ze(r.errors, D) && !Y._f.deps || A4(Ne, Ze(r.touchedFields, D), r.isSubmitted, C, g), fn = Ob(D, l, Ne);
      Qn(o, D, me), Ne ? (Y._f.onBlur && Y._f.onBlur(E), d && d(0)) : Y._f.onChange && Y._f.onChange(E);
      const tn = U(D, me, Ne), cn = !Mt(tn) || fn;
      if (!Ne && h.state.next({
        name: D,
        type: E.type,
        values: It(o)
      }), nn)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? Ne && w() : Ne || w()), cn && h.state.next({ name: D, ...fn ? {} : tn });
      if (!Ne && fn && h.state.next({ ...r }), n.resolver) {
        const { errors: pn } = await J([D]);
        if (R(me), H) {
          const dn = Ab(r.errors, i, D), xn = Ab(pn, i, dn.name || D);
          V = xn.error, D = xn.name, ie = Mt(pn);
        }
      } else
        y([D], !0), V = (await Lb(Y, l.disabled, o, S, n.shouldUseNativeValidation))[D], y([D]), R(me), H && (V ? ie = !1 : (u.isValid || f.isValid) && (ie = await X(i, !0)));
      H && (Y._f.deps && xe(Y._f.deps), Q(D, ie, V, tn));
    }
  }, W = (E, x) => {
    if (Ze(r.errors, x) && E.focus)
      return E.focus(), 1;
  }, xe = async (E, x = {}) => {
    let D, H;
    const Y = co(E);
    if (n.resolver) {
      const R = await ae(dt(E) ? E : Y);
      D = Mt(R), H = E ? !Y.some((V) => Ze(R, V)) : D;
    } else E ? (H = (await Promise.all(Y.map(async (R) => {
      const V = Ze(i, R);
      return await X(V && V._f ? { [R]: V } : V);
    }))).every(Boolean), !(!H && !r.isValid) && w()) : H = D = await X(i);
    return h.state.next({
      ...!Or(E) || (u.isValid || f.isValid) && D !== r.isValid ? {} : { name: E },
      ...n.resolver || !E ? { isValid: D } : {},
      errors: r.errors
    }), x.shouldFocus && !H && uo(i, W, E ? Y : l.mount), H;
  }, Ie = (E) => {
    const x = {
      ...s.mount ? o : a
    };
    return dt(E) ? x : Or(E) ? Ze(x, E) : E.map((D) => Ze(x, D));
  }, K = (E, x) => ({
    invalid: !!Ze((x || r).errors, E),
    isDirty: !!Ze((x || r).dirtyFields, E),
    error: Ze((x || r).errors, E),
    isValidating: !!Ze(r.validatingFields, E),
    isTouched: !!Ze((x || r).touchedFields, E)
  }), qe = (E) => {
    E && co(E).forEach((x) => bt(r.errors, x)), h.state.next({
      errors: E ? r.errors : {}
    });
  }, Be = (E, x, D) => {
    const H = (Ze(i, E, { _f: {} })._f || {}).ref, Y = Ze(r.errors, E) || {}, { ref: R, message: V, type: ie, ...me } = Y;
    Qn(r.errors, E, {
      ...me,
      ...x,
      ref: H
    }), h.state.next({
      name: E,
      errors: r.errors,
      isValid: !1
    }), D && D.shouldFocus && H && H.focus && H.focus();
  }, Oe = (E, x) => Sr(E) ? h.state.subscribe({
    next: (D) => E(q(void 0, x), D)
  }) : q(E, x, !0), Me = (E) => h.state.subscribe({
    next: (x) => {
      O4(E.name, x.name, E.exact) && R4(x, E.formState || u, Ae, E.reRenderRoot) && E.callback({
        values: { ...o },
        ...r,
        ...x
      });
    }
  }).unsubscribe, $e = (E) => (s.mount = !0, f = {
    ...f,
    ...E.formState
  }, Me({
    ...E,
    formState: f
  })), ze = (E, x = {}) => {
    for (const D of E ? co(E) : l.mount)
      l.mount.delete(D), l.array.delete(D), x.keepValue || (bt(i, D), bt(o, D)), !x.keepError && bt(r.errors, D), !x.keepDirty && bt(r.dirtyFields, D), !x.keepTouched && bt(r.touchedFields, D), !x.keepIsValidating && bt(r.validatingFields, D), !n.shouldUnregister && !x.keepDefaultValue && bt(a, D);
    h.state.next({
      values: It(o)
    }), h.state.next({
      ...r,
      ...x.keepDirty ? { isDirty: O() } : {}
    }), !x.keepIsValid && w();
  }, Re = ({ disabled: E, name: x }) => {
    (ar(E) && s.mount || E || l.disabled.has(x)) && (E ? l.disabled.add(x) : l.disabled.delete(x));
  }, an = (E, x = {}) => {
    let D = Ze(i, E);
    const H = ar(x.disabled) || ar(n.disabled);
    return Qn(i, E, {
      ...D || {},
      _f: {
        ...D && D._f ? D._f : { ref: { name: E } },
        name: E,
        mount: !0,
        ...x
      }
    }), l.mount.add(E), D ? Re({
      disabled: ar(x.disabled) ? x.disabled : n.disabled,
      name: E
    }) : T(E, !0, x.value), {
      ...H ? { disabled: x.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!x.required,
        min: Ja(x.min),
        max: Ja(x.max),
        minLength: Ja(x.minLength),
        maxLength: Ja(x.maxLength),
        pattern: Ja(x.pattern)
      } : {},
      name: E,
      onChange: fe,
      onBlur: fe,
      ref: (Y) => {
        if (Y) {
          an(E, x), D = Ze(i, E);
          const R = dt(Y.value) && Y.querySelectorAll && Y.querySelectorAll("input,select,textarea")[0] || Y, V = F4(R), ie = D._f.refs || [];
          if (V ? ie.find((me) => me === R) : R === D._f.ref)
            return;
          Qn(i, E, {
            _f: {
              ...D._f,
              ...V ? {
                refs: [
                  ...ie.filter(tm),
                  R,
                  ...Array.isArray(Ze(a, E)) ? [{}] : []
                ],
                ref: { type: R.type, name: E }
              } : { ref: R }
            }
          }), T(E, !1, void 0, R);
        } else
          D = Ze(i, E, {}), D._f && (D._f.mount = !1), (n.shouldUnregister || x.shouldUnregister) && !(BS(l.array, E) && s.action) && l.unMount.add(E);
      }
    };
  }, Ee = () => n.shouldFocusError && uo(i, W, l.mount), Ge = (E) => {
    ar(E) && (h.state.next({ disabled: E }), uo(i, (x, D) => {
      const H = Ze(i, D);
      H && (x.disabled = H._f.disabled || E, Array.isArray(H._f.refs) && H._f.refs.forEach((Y) => {
        Y.disabled = H._f.disabled || E;
      }));
    }, 0, !1));
  }, Qe = (E, x) => async (D) => {
    let H;
    D && (D.preventDefault && D.preventDefault(), D.persist && D.persist());
    let Y = It(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: R, values: V } = await J();
      r.errors = R, Y = V;
    } else
      await X(i);
    if (l.disabled.size)
      for (const R of l.disabled)
        Qn(Y, R, void 0);
    if (bt(r.errors, "root"), Mt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await E(Y, D);
      } catch (R) {
        H = R;
      }
    } else
      x && await x({ ...r.errors }, D), Ee(), setTimeout(Ee);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Mt(r.errors) && !H,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), H)
      throw H;
  }, he = (E, x = {}) => {
    Ze(i, E) && (dt(x.defaultValue) ? ce(E, It(Ze(a, E))) : (ce(E, x.defaultValue), Qn(a, E, It(x.defaultValue))), x.keepTouched || bt(r.touchedFields, E), x.keepDirty || (bt(r.dirtyFields, E), r.isDirty = x.defaultValue ? O(E, It(Ze(a, E))) : O()), x.keepError || (bt(r.errors, E), u.isValid && w()), h.state.next({ ...r }));
  }, ge = (E, x = {}) => {
    const D = E ? It(E) : a, H = It(D), Y = Mt(E), R = Y ? a : H;
    if (x.keepDefaultValues || (a = D), !x.keepValues) {
      if (x.keepDirtyValues) {
        const V = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(Qa(a, o))
        ]);
        for (const ie of Array.from(V))
          Ze(r.dirtyFields, ie) ? Qn(R, ie, Ze(o, ie)) : ce(ie, Ze(R, ie));
      } else {
        if (ef && dt(E))
          for (const V of l.mount) {
            const ie = Ze(i, V);
            if (ie && ie._f) {
              const me = Array.isArray(ie._f.refs) ? ie._f.refs[0] : ie._f.ref;
              if (Bs(me)) {
                const Ne = me.closest("form");
                if (Ne) {
                  Ne.reset();
                  break;
                }
              }
            }
          }
        for (const V of l.mount)
          ce(V, Ze(R, V));
      }
      o = It(R), h.array.next({
        values: { ...R }
      }), h.state.next({
        values: { ...R }
      });
    }
    l = {
      mount: x.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!x.keepIsValid || !!x.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: x.keepSubmitCount ? r.submitCount : 0,
      isDirty: Y ? !1 : x.keepDirty ? r.isDirty : !!(x.keepDefaultValues && !ii(E, a)),
      isSubmitted: x.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: Y ? {} : x.keepDirtyValues ? x.keepDefaultValues && o ? Qa(a, o) : r.dirtyFields : x.keepDefaultValues && E ? Qa(a, E) : x.keepDirty ? r.dirtyFields : {},
      touchedFields: x.keepTouched ? r.touchedFields : {},
      errors: x.keepErrors ? r.errors : {},
      isSubmitSuccessful: x.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, De = (E, x) => ge(Sr(E) ? E(o) : E, x), Le = (E, x = {}) => {
    const D = Ze(i, E), H = D && D._f;
    if (H) {
      const Y = H.refs ? H.refs[0] : H.ref;
      Y.focus && (Y.focus(), x.shouldSelect && Sr(Y.select) && Y.select());
    }
  }, Ae = (E) => {
    r = {
      ...r,
      ...E
    };
  }, mn = {
    control: {
      register: an,
      unregister: ze,
      getFieldState: K,
      handleSubmit: Qe,
      setError: Be,
      _subscribe: Me,
      _runSchema: J,
      _getWatch: q,
      _getDirty: O,
      _setValid: w,
      _setFieldArray: z,
      _setDisabledField: Re,
      _setErrors: I,
      _getFieldArray: ee,
      _reset: ge,
      _resetDefaultValues: () => Sr(n.defaultValues) && n.defaultValues().then((E) => {
        De(E, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: B,
      _disableForm: Ge,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(E) {
        s = E;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(E) {
        l = E;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(E) {
        n = {
          ...n,
          ...E
        };
      }
    },
    subscribe: $e,
    trigger: xe,
    register: an,
    handleSubmit: Qe,
    watch: Oe,
    setValue: ce,
    getValues: Ie,
    reset: De,
    resetField: he,
    clearErrors: qe,
    unregister: ze,
    setError: Be,
    setFocus: Le,
    getFieldState: K
  };
  return {
    ...mn,
    formControl: mn
  };
}
function U4(e = {}) {
  const n = Fe.useRef(void 0), r = Fe.useRef(void 0), [i, a] = Fe.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Sr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: Sr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : z4(e),
    formState: i
  }, e.formControl && e.defaultValues && !Sr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, Fe.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), Fe.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), Fe.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), Fe.useEffect(() => {
    e.values && !ii(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), Fe.useEffect(() => {
    e.errors && !Mt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), Fe.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), Fe.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = HS(i, o), n.current;
}
const M4 = "_settingsWrapper_1ycvy_1", B4 = "_settingsWrapperHeader_1ycvy_6", q4 = "_settingsWrapperContent_1ycvy_10", H4 = "_settingsWrapperContentCode_1ycvy_18", W4 = "_settingsWrapperContentCURL_1ycvy_26", Xa = {
  settingsWrapper: M4,
  settingsWrapperHeader: B4,
  settingsWrapperContent: q4,
  settingsWrapperContentCode: H4,
  settingsWrapperContentCURL: W4
}, G4 = ({
  handleChangeText: e
}) => {
  const [n, r] = le(!1), { isCopied: i, copy: a } = or(), { control: o } = U4({
    defaultValues: {
      storeId: "",
      secret: ""
    },
    mode: "onChange"
  }), s = GS({
    control: o
  }), l = s.storeId !== "" && s.secret !== "", d = ot(() => {
    const m = s.storeId, u = s.secret;
    return `curl --request POST \\
  --url https://api.yotpo.com/core/v3/stores/${m || "store_id"}/access_tokens \\
  --header 'Content-Type: application/json' \\
  --header 'accept: application/json'${u ? ` \\
  --data '{"secret":"${u}"}'` : ""}`;
  }, [s.storeId, s.secret]);
  return /* @__PURE__ */ Te.jsx(Te.Fragment, { children: /* @__PURE__ */ Te.jsx(be, { span: 6, children: /* @__PURE__ */ Te.jsxs(b, { flexDirection: "column", className: Xa.settingsWrapper, children: [
    /* @__PURE__ */ Te.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: Xa.settingsWrapperHeader,
        onClick: () => r(!n),
        children: [
          /* @__PURE__ */ Te.jsx(P.Heading, { variant: "heading-3", children: "How to get the Yotpo access token" }),
          /* @__PURE__ */ Te.jsx(pe, { name: n ? "angle-down" : "angle-right" })
        ]
      }
    ),
    n && /* @__PURE__ */ Te.jsxs(
      b,
      {
        flexDirection: "column",
        className: Xa.settingsWrapperContent,
        children: [
          /* @__PURE__ */ Te.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ Te.jsx(
            Gs,
            {
              variant: "announcement",
              headline: "In order to get the Yotpo access token, you have to follow the steps below",
              description: /* @__PURE__ */ Te.jsxs("ol", { children: [
                /* @__PURE__ */ Te.jsx("li", { children: "Insert the Yotpo store ID and secret below in the input fields" }),
                /* @__PURE__ */ Te.jsx("li", { children: "Once the fields are filled in, the CURL command will appear below and you can copy and run it in your terminal" }),
                /* @__PURE__ */ Te.jsxs("li", { children: [
                  "The response should look like this",
                  " ",
                  /* @__PURE__ */ Te.jsx("span", { className: Xa.settingsWrapperContentCode, children: '{ "access_token": "this-is-your-token" }' })
                ] }),
                /* @__PURE__ */ Te.jsxs("li", { children: [
                  "Copy the token without quotes and paste it in the",
                  " ",
                  /* @__PURE__ */ Te.jsx("i", { children: "Yotpo access token" }),
                  " input field below"
                ] }),
                /* @__PURE__ */ Te.jsx("li", { children: "Click the save button" })
              ] })
            }
          ) }),
          /* @__PURE__ */ Te.jsx(
            Cb,
            {
              name: "storeId",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ Te.jsx(
                pr,
                {
                  label: "Yotpo store ID",
                  placeholder: "Please insert the store ID",
                  input: {
                    ...m,
                    onChange: (u) => {
                      m.onChange(u), e({
                        target: {
                          name: "yotpoStoreId",
                          value: u?.target.value ?? ""
                        }
                      });
                    }
                  }
                }
              )
            }
          ),
          /* @__PURE__ */ Te.jsx(
            Cb,
            {
              name: "secret",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ Te.jsx(
                pr,
                {
                  label: "Yotpo secret",
                  placeholder: "Please insert the secret",
                  input: m
                }
              )
            }
          ),
          l && /* @__PURE__ */ Te.jsxs(Te.Fragment, { children: [
            /* @__PURE__ */ Te.jsx(ln, { label: "Generated CURL command", noAlert: !0, children: /* @__PURE__ */ Te.jsx(
              b,
              {
                as: "pre",
                gap: "200",
                margin: "100 0 250",
                className: Xa.settingsWrapperContentCURL,
                children: d()
              }
            ) }),
            /* @__PURE__ */ Te.jsx(b, { alignContent: "start", children: /* @__PURE__ */ Te.jsx(
              We,
              {
                content: i ? "Copied!" : "Copy CURL command",
                children: /* @__PURE__ */ Te.jsx(
                  Gn,
                  {
                    variant: "secondary",
                    icon: i ? "check-circle" : "copy",
                    onClick: () => a(d()),
                    children: "Copy CURL"
                  }
                )
              }
            ) })
          ] })
        ]
      }
    )
  ] }) }) });
}, K4 = [
  {
    key: "showCustomerDetails",
    label: "Show customer details",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showUserGeneratedContent",
    label: "Show user generated content",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayLoyalty",
    label: "Show loyalty data",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], Y4 = [
  /**
   * The store ID will be fetched through the OAuth flow, so there's no real
   * reason to show it
   */
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: "",
    readOnly: !0,
    required: !1,
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: Lr
  }
], Q4 = [
  {
    key: "accessTokenComponent",
    label: "Retrieve Yotpo access token",
    secret: !1,
    type: "custom",
    component: G4
  },
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: 'See "How to get the Yotpo access token" above.',
    readOnly: !0,
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "yotpoAccessToken",
    label: "Yotpo access token",
    placeholder: "Insert the Yotpo access token",
    required: !0,
    secret: !0,
    type: "input"
  }
], J4 = (e) => {
  switch (e) {
    case "input":
    case "hidden":
      return "";
    case "switch":
      return !1;
    default:
      return;
  }
}, X4 = (e, n) => {
  switch (n) {
    case "input":
    case "hidden":
    case "select":
      return e;
    case "switch":
      return e === "true" ? !0 : e === "false" ? !1 : void 0;
    default:
      return;
  }
}, Z4 = ({
  hasShopifyOAuth: e = !1,
  isShopifyMarketplaceApp: n = !1,
  isCreationMode: r = !1
}) => r ? {
  authSettings: JV,
  featureSettings: []
} : n ? {
  authSettings: XV,
  featureSettings: [...vS]
} : e ? {
  authSettings: [
    ...Uk,
    ...YV
  ],
  featureSettings: [...Mk]
} : {
  authSettings: [
    ...Uk,
    ...QV
  ],
  featureSettings: [...Mk]
}, e0 = (e, n) => ({
  hasOAuth: r = !1,
  isCreationMode: i = !1
}) => r || i ? e : n, eB = e0(
  Y4,
  Q4
), nB = e0(
  oD,
  sD
), n0 = ({
  key: e,
  configuration: n,
  settingType: r,
  settingDefault: i
}) => {
  const a = n?.find(
    (l) => l.key === e
  ), o = X4(a?.value, r), s = i !== void 0 ? i : J4(
    r
  );
  return o !== void 0 ? o : s;
}, of = (e = {
  SHOPIFY: {},
  YOTPO: {},
  KLAVIYO: {}
}) => {
  const { SHOPIFY: n, YOTPO: r, KLAVIYO: i } = e, {
    authSettings: a,
    featureSettings: o
  } = Z4(n), s = eB(r), l = nB(i);
  return {
    SHOPIFY: {
      widget: iU,
      icon: "shopify",
      iconColors: {
        contentColor: "rgb(148, 190, 69)",
        backgroundColor: "rgba(148, 190, 69, 0.1)"
      },
      settingsConfiguration: [
        ...a,
        ...o
      ]
    },
    JIRA: {
      widget: DT,
      icon: "jira",
      iconColors: {
        contentColor: "rgb(38, 132, 255)",
        backgroundColor: "rgba(38, 132, 255, 0.075)"
      },
      settingsConfiguration: [
        ...uv ? [...uv] : []
      ],
      WidgetSettings: AT
    },
    GITHUB: {
      widget: RI,
      icon: "github",
      iconColors: {
        contentColor: "rgb(87, 96, 106)",
        backgroundColor: "rgba(221, 244, 255, 0.75)"
      },
      settingsConfiguration: [...OI],
      WidgetSettings: PI
    },
    MIUROS: {
      widget: oV,
      icon: "miuros",
      iconColors: {
        contentColor: "rgb(246, 135, 179)",
        backgroundColor: "rgba(246, 135, 179, 0.15)"
      },
      settingsConfiguration: [...sV],
      WidgetSettings: cV
    },
    KLAVIYO: {
      widget: iD,
      icon: "klaviyo",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      settingsConfiguration: [...l, ...aD]
    },
    LINEAR: {
      widget: $2,
      icon: "linear",
      iconColors: {
        contentColor: "rgb(94, 106, 210)",
        backgroundColor: "rgba(94, 106, 210, 0.15)"
      },
      settingsConfiguration: [...D2],
      WidgetSettings: O2
    },
    VOYADO: {
      widget: n4,
      icon: "voyado",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      settingsConfiguration: [...t4]
    },
    LOYALTYLION: {
      widget: mL,
      icon: "loyaltylion",
      iconColors: {
        contentColor: "rgb(36, 31, 79)",
        backgroundColor: "rgba(36, 31, 79, 0.075)"
      },
      settingsConfiguration: [...pL],
      WidgetSettings: hL
    },
    RECHARGE: {
      widget: RV,
      icon: "recharge",
      iconColors: {
        contentColor: "rgb(57, 1, 241)",
        backgroundColor: "rgba(57, 1, 241, 0.075)"
      },
      settingsConfiguration: [...OV],
      WidgetSettings: PV
    },
    BRAZE: {
      widget: Qw,
      icon: "braze",
      iconColors: {
        contentColor: "rgb(48, 2, 102)",
        backgroundColor: "rgba(48, 2, 102, 0.075)"
      },
      settingsConfiguration: [...Jw]
    },
    YOTPO: {
      widget: x4,
      icon: "yotpo",
      iconColors: {
        contentColor: "rgb(0, 66, 228)",
        backgroundColor: "rgba(0, 66, 228, 0.075)"
      },
      settingsConfiguration: [...s, ...K4]
    },
    INGRID: {
      widget: dE,
      icon: "ingrid",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      settingsConfiguration: [...uE],
      WidgetSettings: pE
    }
  };
}, tB = (e) => {
  const n = of();
  return e.map(
    ({
      id: r,
      type: i,
      name: a,
      settings: o,
      misconfigured: s,
      renderConditions: l,
      integrationKey: d
    }) => {
      const u = n[i], { settingsConfiguration: f } = u, h = f?.filter(({ secret: g }) => !g)?.map(
        ({
          key: g,
          type: C,
          defaultValue: S
        }) => ({
          key: g,
          value: n0({
            key: g,
            configuration: o,
            settingType: C,
            settingDefault: S
          })
        })
      );
      return {
        id: r,
        type: i,
        name: a,
        settings: h,
        misconfigured: s,
        renderConditions: l,
        icon: u.icon,
        iconColors: u.iconColors,
        widget: u.widget,
        integrationKey: d
      };
    }
  );
}, JB = ({
  widgets: e,
  configuration: n,
  conversationContext: r,
  showNotification: i,
  onToggleFn: a,
  isOpenFn: o,
  isMinimized: s,
  renderVisibilityToggleElement: l,
  renderDragElement: d,
  renderConditionMatchedIndicator: m,
  widgetAnnotations: u
}) => {
  const f = ki(
    {}
  ), h = (T) => (f.current[T] || (f.current[T] = { current: null }), f.current[T]), { track: g } = _n(), C = Bn(
    () => tB(e),
    [e]
  ), S = {
    headline: "",
    text: "",
    onConfirm: () => I(),
    confirmLabel: "Confirm",
    confirmVariant: "primary"
  }, [N, w] = le(S), [y, z] = le(!1), $ = (T) => {
    z(!0), w(T);
  }, I = () => {
    z(!1), w(S);
  };
  return /* @__PURE__ */ Ve.jsxs(Ve.Fragment, { children: [
    C.map(
      ({
        id: T,
        name: U,
        type: Q,
        widget: J,
        settings: ae,
        misconfigured: X,
        renderConditions: B,
        icon: O,
        iconColors: q,
        integrationKey: ee
      }, ve) => {
        const ue = `partner-integration-${Q}`, ce = u?.get(T) === !1, fe = /* @__PURE__ */ Ve.jsx(Hm, { icon: O, color: q }), W = ae?.reduce(
          (xe, Ie) => (xe[Ie.key] = Ie.value, xe),
          {}
        );
        return s ? /* @__PURE__ */ Ve.jsx("div", { className: "icon-holder", children: fe }, `partner-icon-${T}`) : /* @__PURE__ */ Ve.jsxs(
          mr,
          {
            onToggle: () => {
              g(
                o(ee) ? "widget:collapse:closed" : "widget:collapse:opened",
                {
                  widgetId: T,
                  widgetType: Q.toLowerCase()
                }
              ), a(ee);
            },
            isOpen: o(ee),
            className: ue,
            containerRef: (xe) => {
              h(ee).current = xe;
            },
            children: [
              /* @__PURE__ */ Ve.jsx(
                mr.Header,
                {
                  className: it({
                    [_w.unmatchedHeader]: ce
                  }),
                  wrap: "normal",
                  avatar: fe,
                  slotBeforeTitle: d?.(
                    ee,
                    ve,
                    h(ee)
                  ),
                  slotAfterTitle: /* @__PURE__ */ Ve.jsx(Ve.Fragment, { children: l?.(ee) }),
                  children: /* @__PURE__ */ Ve.jsxs(b, { alignItems: "center", flexDirection: "row", gap: "200", children: [
                    U,
                    m?.(
                      B ?? [],
                      T
                    )
                  ] })
                }
              ),
              /* @__PURE__ */ Ve.jsx(mr.Content, { children: X ? /* @__PURE__ */ Ve.jsx(Fn, { isMisconfigured: !0 }) : /* @__PURE__ */ Ve.jsx(
                Jb.Provider,
                {
                  value: {
                    onError: (xe, Ie) => console.warn(
                      `Something went wrong with a partner widget of type '${Q}' and id '${T}'`,
                      xe,
                      Ie
                    )
                  },
                  children: /* @__PURE__ */ Ve.jsx(
                    Tx,
                    {
                      integrationId: T,
                      type: Q,
                      configuration: n,
                      showNotification: i,
                      showModal: $,
                      children: C0(J, {
                        conversationContext: r,
                        settings: W
                      })
                    }
                  )
                }
              ) })
            ]
          },
          ee
        );
      }
    ),
    /* @__PURE__ */ Ve.jsx(
      Yb,
      {
        isOpen: y,
        setIsOpen: z,
        headline: N.headline,
        text: N.text,
        confirmLabel: N.confirmLabel,
        confirmVariant: N.confirmVariant,
        cancelLabel: N.cancelLabel,
        cancelVariant: N.cancelVariant,
        onConfirm: N.onConfirm ? () => {
          try {
            N.onConfirm && N.onConfirm();
          } finally {
            z(!1), w(S);
          }
        } : void 0,
        onCancel: N.onCancel ? () => {
          try {
            N.onCancel && N.onCancel();
          } finally {
            z(!1), w(S);
          }
        } : void 0,
        children: N.children
      }
    )
  ] });
}, rB = Ks`
  query getWidgetConfigurations {
    Management {
      widgetConfigurations {
        id
        type
        enabled
        name
        misconfigured
        renderConditions
        settings {
          key
          value
        }
      }
    }
  }
`;
function XB(e, { skip: n = !1 } = {}) {
  const [r, i] = le([]), [a, o] = le(!1);
  return He(() => {
    if (n) {
      o(!1);
      return;
    }
    let s = !1;
    return o(!0), Ex(e).query({
      query: rB
    }).then(({ data: l }) => {
      s || (i(
        (l?.Management?.widgetConfigurations ?? []).filter(
          (d) => d != null
        ).map((d) => ({
          ...d,
          integrationKey: `partner-integration-${d.id}`
        }))
      ), o(!1));
    }).catch(() => {
      s || o(!1);
    }), () => {
      s = !0;
    };
  }, [e, n]), {
    isLoading: a,
    widgets: r
  };
}
const iB = ({
  widgetConfiguration: e
}) => {
  const n = Bn(() => (e?.additionalProperties ?? {}).isUsingOAuth ?? !1, [e]), r = Bn(() => (e?.additionalProperties ?? {}).tokenSource === "marketplace_app", [e]);
  return {
    hasShopifyWidgetOAuth: n,
    isShopifyMarketplaceApp: r,
    initialValuesForShopify: []
  };
}, aB = "FULL_ACCESS", oB = "2", sB = ({
  type: e,
  baseUrl: n
}) => {
  const r = `${e}-partner-widget-${Date.now().toString()}`, i = n.replace("partner-integrations", "api"), a = () => {
    let l;
    try {
      l = JSON.parse(localStorage.authData);
    } catch {
    }
    return l?.access_token || "";
  };
  return {
    deleteDixaApiToken: (l) => fetch(`${i}/v1/auth/api-tokens/${l}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      }
    }).then((d) => d.json()),
    createDixaApiToken: () => fetch(`${i}/v1/auth/api-tokens-v2`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      },
      body: JSON.stringify({
        name: r,
        scopes: [aB],
        version: oB
      })
    }).then((l) => l.json())
  };
}, lB = "dixaApiToken", sf = "dixaApiTokenId", t0 = "dixaApiTokenName", Vb = (e) => [sf, t0].every(
  (r) => e.find((i) => i?.key === r)
);
function cB({
  token: e,
  settings: n
}) {
  if (n.length === 0)
    return [];
  const r = dB(e), i = (o, s) => o?.find((l) => l?.key === s);
  return n.map((o) => {
    const s = o && i(r, o.key);
    return i(n, o?.key) && s ? s : o;
  });
}
const dB = (e) => [
  {
    key: lB,
    value: e.value,
    secret: !0
  },
  {
    key: sf,
    value: e.id,
    secret: !1
  },
  {
    key: t0,
    value: e.name,
    secret: !1
  }
], uB = "_wrapper_1lmim_1", mB = "_wrapperBox_1lmim_4", pB = "_wrapperBoxErrorBorder_1lmim_9", rm = {
  wrapper: uB,
  wrapperBox: mB,
  wrapperBoxErrorBorder: pB
}, fB = ({
  required: e,
  readOnly: n,
  isSecret: r,
  isCreationMode: i,
  label: a,
  settings: o,
  widgetSettingsKey: s,
  meta: l,
  handleEditSecret: d,
  handleChangeText: m
}) => {
  const f = o?.find(
    (z) => z.type === "basicAuthInput"
  )?.additionalProperties, { username: h, password: g } = f, C = `Insert your ${h.label.toLowerCase()}`, S = `Insert your ${g.label.toLowerCase()}`, [N, w] = le({
    username: "",
    password: ""
  }), y = ot(
    (z) => {
      m({
        target: {
          name: s,
          value: z
        }
      });
    },
    [s, m]
  );
  return He(() => {
    y(
      N.username !== "" && N.password !== "" ? window.btoa(`${N.username}:${N.password}`) : ""
    );
  }, [N]), /* @__PURE__ */ Ve.jsx(
    ln,
    {
      required: e,
      label: a,
      meta: l,
      className: rm.wrapper,
      children: /* @__PURE__ */ Ve.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          className: it(rm.wrapperBox, {
            [rm.wrapperBoxErrorBorder]: !!l?.error
          }),
          children: [
            /* @__PURE__ */ Ve.jsx(
              pr,
              {
                noAlert: !0,
                required: e,
                label: h.label,
                readOnly: n,
                placeholder: C,
                input: {
                  name: s,
                  value: N.username,
                  onChange: (z) => w({
                    username: z?.target.value ?? "",
                    password: N.password
                  })
                },
                ...r && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => d(!1, s)
                    }
                  }
                }
              }
            ),
            /* @__PURE__ */ Ve.jsx(
              pr,
              {
                noAlert: !0,
                required: e,
                label: g.label,
                readOnly: n,
                placeholder: S,
                input: {
                  name: s,
                  value: N.password,
                  onChange: (z) => w({
                    username: N.username,
                    password: z?.target.value ?? ""
                  })
                },
                ...r && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => d(!1, s)
                    }
                  }
                }
              }
            )
          ]
        }
      )
    }
  );
};
function zb({
  isSecret: e,
  widgetSettingsKey: n,
  label: r,
  required: i,
  readOnly: a,
  placeholder: o,
  handleChangeText: s,
  handleChangeBoolean: l,
  handleChangeSelect: d,
  handleEditSecret: m,
  getValueByKey: u,
  isEditingField: f,
  errors: h,
  type: g,
  isCreationMode: C,
  prefix: S,
  integrationId: N,
  integrationType: w,
  configuration: y,
  settings: z,
  otherProps: $
}) {
  const I = g === "custom" && $?.component, T = u(n)?.value;
  return I ? /* @__PURE__ */ Ve.jsx(
    I,
    {
      configuration: y,
      integrationId: N,
      integrationType: w,
      label: r,
      settings: z,
      getValueByKey: u,
      widgetSettingsKey: n,
      handleChangeSelect: d,
      handleChangeText: s,
      handleChangeBoolean: l
    }
  ) : /* @__PURE__ */ Ve.jsxs(Ve.Fragment, { children: [
    /* @__PURE__ */ Ve.jsx(be, { span: 3, children: /* @__PURE__ */ Ve.jsx(
      hB,
      {
        widgetSettingsKey: n,
        label: r,
        isEditingField: f,
        handleEditSecret: m,
        isCreationMode: C,
        children: g === "input" ? /* @__PURE__ */ Ve.jsx(
          pr,
          {
            required: i,
            readOnly: a,
            label: r,
            placeholder: o,
            input: {
              name: n,
              value: T,
              onChange: s
            },
            meta: { error: h[n] },
            prefix: S,
            ...e && !C && {
              prefix: {
                type: "button",
                button: {
                  icon: "close",
                  onClick: () => m(!1, n)
                }
              }
            }
          }
        ) : g === "basicAuthInput" ? /* @__PURE__ */ Ve.jsx(
          fB,
          {
            required: i,
            readOnly: a,
            isSecret: e,
            isCreationMode: C,
            label: r,
            widgetSettingsKey: n,
            settings: z,
            meta: { error: h[n] },
            handleEditSecret: m,
            handleChangeText: s
          }
        ) : g === "switch" ? /* @__PURE__ */ Ve.jsx(ln, { label: r, children: /* @__PURE__ */ Ve.jsx(
          Xb,
          {
            input: {
              name: n,
              value: "",
              checked: T,
              onChange: l
            }
          }
        ) }) : g === "select" ? /* @__PURE__ */ Ve.jsx(ln, { label: r, children: /* @__PURE__ */ Ve.jsx(
          ni,
          {
            required: i,
            clearable: !0,
            placeholder: o,
            readOnly: a,
            onChange: (U) => d(n, U),
            getItemTitleByValue: (U) => U ? /* @__PURE__ */ Ve.jsx(P.Paragraph, { children: U.label }) : /* @__PURE__ */ Ve.jsx(Ve.Fragment, {}),
            value: T ? [
              {
                label: ($?.selectItems || []).find(
                  (U) => U.value === T
                )?.label,
                value: T
              }
            ] : [],
            equalityFn: (U, Q) => U.value === Q.value,
            children: ($?.selectItems || []).map((U) => /* @__PURE__ */ Ve.jsx(ut.Item, { value: U, children: U.label }, U.value))
          }
        ) }) : /* @__PURE__ */ Ve.jsx(Ve.Fragment, {})
      }
    ) }),
    /* @__PURE__ */ Ve.jsx(be, { span: 3 })
  ] });
}
function hB({
  widgetSettingsKey: e,
  label: n,
  isEditingField: r,
  handleEditSecret: i,
  children: a,
  isCreationMode: o
}) {
  return r || o ? a : /* @__PURE__ */ Ve.jsx(ln, { label: n, children: /* @__PURE__ */ Ve.jsxs(
    Gn,
    {
      "data-testid": `secret-field-button-${e}`,
      variant: "secondary",
      icon: "pen",
      onClick: () => i(!0, e),
      children: [
        "Update ",
        n
      ]
    }
  ) });
}
const mo = "partner-integrations-widget-name-form-field", Ub = ({
  settingsFromBackend: e,
  settingsConfiguration: n,
  creating: r = !1
}) => n.filter(({ type: i }) => i !== "custom").map(
  ({
    key: i,
    required: a,
    secret: o,
    type: s,
    defaultValue: l,
    customValidation: d
  }) => ({
    key: i,
    value: n0({
      key: i,
      configuration: e,
      settingType: s,
      settingDefault: l
    }),
    required: a,
    secret: o,
    // The property `isEditing` is used in order to show/hide the input field in
    // case it is a secret setting. However, when we create a widget we _always_
    // want to show the input field because it will be the first time that the user
    // enters a value for it.
    //
    // We have two scenarios here:
    // 1) When initializing
    //   - the setting is secret=true so we set isEditing=false and hide the input.
    //   - the setting is secret=false, so we set isEditing=true and show the input.
    // 2) We create a widget (creating=true), so we set isEditing=true in
    //    order to show the input.
    isEditing: r ? !0 : !o,
    type: s,
    ...d && { customValidation: d }
  })
), yB = ({
  initialValues: e,
  onSubmit: n
}) => {
  const [r, i] = le(
    e || {
      enabled: !1,
      name: "",
      settings: []
    }
  ), [a, o] = le({}), s = ($) => i($), l = ($) => !$ || $ === "", d = ($) => {
    const { [$]: I, ...T } = a;
    o(T);
  }, m = ($) => ({
    ...$,
    settings: $.settings.filter(({ isEditing: I }) => I).map(({ key: I, value: T, secret: U }) => ({
      key: I,
      value: T,
      secret: U
    }))
  }), u = {
    input: "This can not be empty",
    basicAuthInput: "Please insert a value for both fields"
  }, f = ($) => {
    if (!$)
      return;
    const {
      target: { name: I, value: T }
    } = $;
    a[I] && !l(T) && d(I), i({
      ...r,
      settings: r.settings.map(
        (U) => U.key === I ? { ...U, value: T } : U
      )
    });
  }, h = ($) => {
    if (!$)
      return;
    const {
      target: { name: I, checked: T }
    } = $;
    i({
      ...r,
      settings: r.settings.map(
        (U) => U.key === I ? { ...U, value: T } : U
      )
    });
  }, g = ($, I) => {
    if (!I)
      return;
    const { selectedValues: T } = I, U = T?.[0];
    if (U) {
      const Q = r.settings.map(
        (J) => J.key === $ ? { ...J, value: U?.value } : J
      );
      i({
        ...r,
        settings: Q
      });
    } else {
      const Q = r.settings.filter(
        (J) => J.key !== $
      );
      i({
        ...r,
        settings: Q
      });
    }
  }, C = ($) => {
    i({
      ...r,
      enabled: $
    });
  }, S = ($) => {
    if (!$)
      return;
    const {
      target: { value: I }
    } = $;
    a[mo] && !l(I) && d(mo), i({
      ...r,
      name: I
    });
  }, N = ($, I) => {
    const { settings: T } = r, U = T.map((Q) => Q.key === I ? {
      ...Q,
      isEditing: $,
      ...!$ && { value: "" }
    } : Q);
    a[I] && !$ && d(I), i({
      ...r,
      settings: U
    });
  }, w = ($) => r.settings.find(
    (I) => I.key === $
  ), y = async ($) => {
    $.preventDefault(), z() && n(m(r));
  }, z = () => {
    const $ = {}, { name: I, settings: T } = r;
    return l(I) && ($[mo] = u.input), T.forEach(
      ({ key: U, value: Q, required: J, isEditing: ae, type: X, customValidation: B }) => {
        if (J && ae)
          if (B) {
            const O = B(Q);
            typeof O == "string" && ($[U] = O);
          } else
            typeof Q == "string" && l(Q) && ($[U] = u[X]);
      }
    ), o($), !Object.keys($)?.length;
  };
  return {
    formData: r,
    errors: a,
    handleIsEnabled: C,
    handleChangeText: f,
    handleChangeBoolean: h,
    handleChangeSelect: g,
    handleEditSecret: N,
    handleChangeName: S,
    handleSubmit: y,
    getSettingValueByKey: w,
    initializeFormData: s,
    validate: z
  };
}, gB = [
  "GITHUB",
  "JIRA",
  "LINEAR"
], Mb = "The configuration of the integration is not correct. Please check the settings.", vB = (e) => {
  const n = of()[e.type]?.WidgetSettings;
  return n ? /* @__PURE__ */ Ve.jsx(n, { ...e }) : /* @__PURE__ */ Ve.jsx(kB, { ...e });
}, kB = ({
  integrationId: e,
  type: n,
  handleRedirect: r,
  showNotification: i,
  configuration: a,
  automationCouplingState: o,
  renderConditionsEditor: s
}) => {
  const { track: l } = _n(), { deleteDixaApiToken: d, createDixaApiToken: m } = sB({
    type: n,
    baseUrl: a.baseUrl
  }), f = H0().pathname.match(
    /^\/settings\/integrations\/partner-widget\/[a-zA-Z0-9]*\/create$/
  ), h = !e && !!n && !!f, g = gB.includes(n), [C, S] = le(), [N, w] = le(!1), [y, z] = le(!1), [$, I] = le(!1), [T, U] = le(null), [Q, J] = le(), [ae, X] = le(h ? [] : null);
  He(() => {
    X(h ? [] : null);
  }, [e, h]), He(() => {
    Q && ae === null && X(Q.renderConditions ?? []);
  }, [Q, ae]);
  const { isInboundOAuth: B } = k0(), O = B && h ? "Submit & Authorize" : "Submit", {
    hasShopifyWidgetOAuth: q,
    isShopifyMarketplaceApp: ee,
    initialValuesForShopify: ve
  } = iB({
    featureFlags: a.featureFlags,
    widgetConfiguration: Q
  }), ue = n === "YOTPO" && !!Q?.additionalProperties?.isUsingOAuth, ce = n === "KLAVIYO" && !!Q?.additionalProperties?.isUsingOAuth, fe = h && n === "SHOPIFY", Ie = of({
    SHOPIFY: {
      hasShopifyOAuth: q,
      isShopifyMarketplaceApp: ee,
      isCreationMode: h
    },
    YOTPO: {
      hasOAuth: ue,
      isCreationMode: h
    },
    KLAVIYO: {
      hasOAuth: ce,
      isCreationMode: h
    }
  })[n].settingsConfiguration, K = Ie.filter(({ type: H }) => H !== "hidden").filter(({ hideOnCreate: H }) => h ? !H : !0), qe = K.filter(
    ({ additionalProperties: H }) => H?.renderAboveForm === !0
  ), Be = K.filter(
    ({ additionalProperties: H }) => H?.renderAboveForm !== !0
  ), {
    error: Oe,
    loading: Me,
    refetch: $e
  } = M0(b0, {
    variables: {
      id: e
    },
    // skip wants either `true` to literally skip the query,
    // or `undefined` to run the query. A simple `false` will
    // still run the query, therefore checking here for the
    // negated `integrationId` instead.
    skip: !e,
    onCompleted: (H) => {
      if (Object.keys(H).length === 0)
        I(!0);
      else {
        I(!1);
        const Y = H?.Management?.widgetConfigurations?.[0];
        Y && J({
          ...Y,
          // Not needed here, just to satisfy the type
          integrationKey: `partner-integration-${Y.id}`,
          additionalProperties: Y.additionalProperties ?? void 0
        });
      }
    }
  }), [ze, { error: Re }] = df(
    h ? x0 : _0,
    {
      onError: (H) => {
        S(H), w(!1), i({
          title: "Something went wrong",
          text: `The ${h ? "creation" : "update"} of the widget was not successful.`,
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (H) => {
        if (w(!1), Object.keys(H).length !== 0) {
          if (h && r(
            H.Management?.createWidgetConfiguration?.id
          ), !h) {
            const R = H.Management?.updateWidgetConfiguration;
            R?.misconfigured ? U(
              R.misconfigurationCause ?? Mb
            ) : U(null);
          }
          i({
            title: `${h ? "Creating" : "Updating"} was successful`,
            text: `${h ? "Creating" : "Updating"} the widget was successful.`,
            icon: "check-circle-filled",
            severity: "success"
          });
        } else
          i({
            title: "Something went wrong",
            text: `The ${h ? "creation" : "update"} of the widget was not successful.`,
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
      }
    }
  ), [an] = df(S0, {
    onError: (H) => {
      S(H), w(!1), i({
        title: "Something went wrong",
        text: "The deletion of the widget was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: () => {
      w(!1), r(), i({
        title: "Deletion was successful",
        text: "The deletion of the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), {
    formData: Ee,
    handleIsEnabled: Ge,
    errors: Qe,
    handleChangeText: he,
    handleChangeBoolean: ge,
    handleChangeSelect: De,
    handleEditSecret: Le,
    handleChangeName: Ae,
    handleSubmit: mn,
    getSettingValueByKey: E,
    initializeFormData: x
  } = yB({
    onSubmit: async (H) => {
      h ? l("settings:create:submitted", { widgetType: n }) : e && l("settings:view:change:submitted", {
        widgetId: e,
        widgetType: n
      }), w(!0);
      const Y = H.settings.map(
        (me) => typeof me.value == "boolean" ? { ...me, value: me.value.toString() } : me
      ), R = Vb(Y) && h;
      let V = [];
      if (R) {
        const me = await m().catch(
          (Ne) => {
            w(!1), console.warn("API-Token (creation) error resonse", Ne), i({
              title: "Something went wrong",
              text: "The creation of the API-Token was not successful and therefore the widget creation was aborted. Please try again later.",
              icon: "exclamation-triangle-filled",
              severity: "warning"
            });
          }
        );
        me?.data && (V = cB({
          token: me.data,
          settings: Y
        }));
      }
      const ie = {
        ...H,
        settings: [
          ...V.length > 0 ? V : Y
        ]
      };
      (R && V.length > 1 || !R && V.length === 0) && (ze({
        variables: {
          ...!h && { id: e },
          ...h && { type: n },
          ...ie,
          ...(h || !!s) && ae !== null && { renderConditions: ae }
        }
      }), Y.forEach(
        (Ne) => Ne.secret && Le(!1, Ne.key)
      ));
    },
    ...h && {
      initialValues: {
        enabled: !1,
        name: "",
        settings: Ub({
          settingsFromBackend: ve,
          settingsConfiguration: Ie,
          creating: !0
        })
      }
    }
  });
  He(() => {
    if (Q) {
      const H = Ub({
        settingsFromBackend: Q.settings,
        settingsConfiguration: Ie
      });
      x({
        enabled: !!Q.enabled,
        name: Q.name,
        settings: H
      }), Q.misconfigured ? U(
        Q?.misconfigurationCause ?? Mb
      ) : U(null);
    }
  }, [Q]);
  const D = Bn(() => o ? !o.isCoupled : !0, [o]);
  return Oe || Re || C ? /* @__PURE__ */ Ve.jsx(
    Fn,
    {
      error: Oe || C,
      retry: Oe ? $e : void 0
    }
  ) : N || Me ? /* @__PURE__ */ Ve.jsx(un, { "data-testid": "widget-settings-loading" }) : $ ? /* @__PURE__ */ Ve.jsxs(P.Paragraph, { children: [
    "A widget with the id ",
    /* @__PURE__ */ Ve.jsx(Pn, { children: e }),
    " does not exist."
  ] }) : /* @__PURE__ */ Ve.jsxs("form", { children: [
    T && /* @__PURE__ */ Ve.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ Ve.jsx(
      Gs,
      {
        variant: "fail",
        headline: "This integration is misconfigured",
        description: /* @__PURE__ */ Ve.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ Ve.jsx(P.Paragraph, { children: T }),
          /* @__PURE__ */ Ve.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ Ve.jsx(P.Heading, { variant: "heading-3", children: "Additional information" }),
            /* @__PURE__ */ Ve.jsx(P.Paragraph, { children: "While the integration is in a misconfigured state, its content is not shown in the sidebar. Instead, we show a message that hints the agent to get in touch with the administrator." })
          ] })
        ] })
      }
    ) }),
    /* @__PURE__ */ Ve.jsxs(
      st,
      {
        "data-testid": `widget-settings-form-${e ?? "create-new"}`,
        children: [
          qe.map(
            ({ key: H, label: Y, ...R }) => /* @__PURE__ */ Ve.jsx(
              zb,
              {
                widgetSettingsKey: H,
                isEditingField: !1,
                handleEditSecret: () => {
                },
                handleChangeText: () => {
                },
                handleChangeBoolean: () => {
                },
                handleChangeSelect: () => {
                },
                getValueByKey: E,
                isSecret: !1,
                label: Y,
                placeholder: "",
                required: !1,
                errors: Qe,
                type: "custom",
                isCreationMode: h,
                integrationId: e,
                integrationType: n,
                configuration: a,
                settings: Ie,
                otherProps: R
              },
              H
            )
          ),
          !fe && /* @__PURE__ */ Ve.jsxs(Ve.Fragment, { children: [
            /* @__PURE__ */ Ve.jsx(be, { children: /* @__PURE__ */ Ve.jsx(ln, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Ve.jsx(
              Xb,
              {
                input: {
                  name: "enabled",
                  checked: Ee.enabled,
                  value: "dummy",
                  onChange: (H) => Ge(H.target.checked)
                }
              }
            ) }) }),
            /* @__PURE__ */ Ve.jsx(be, { span: 3, children: /* @__PURE__ */ Ve.jsx(
              pr,
              {
                required: !0,
                label: "Widget name",
                placeholder: "Insert the name of the widget",
                input: {
                  name: mo,
                  value: Ee.name,
                  onChange: Ae
                },
                meta: {
                  error: Qe[mo]
                }
              }
            ) }),
            /* @__PURE__ */ Ve.jsx(be, { span: 3 })
          ] }),
          !fe && s && ae !== null && /* @__PURE__ */ Ve.jsx(be, { children: s({
            value: ae,
            onChange: X,
            configurationKey: Q?.id
          }) }),
          Be?.map(
            ({
              key: H,
              secret: Y,
              label: R,
              placeholder: V = "",
              required: ie = !1,
              type: me,
              prefix: Ne,
              readOnly: nn,
              ...fn
            }) => {
              const { settings: tn } = Ee, cn = tn.find(
                (pn) => pn.key === H
              );
              return /* @__PURE__ */ Ve.jsx(F0, { children: /* @__PURE__ */ Ve.jsx(
                zb,
                {
                  widgetSettingsKey: H,
                  isEditingField: !!cn?.isEditing,
                  handleEditSecret: Le,
                  handleChangeText: he,
                  handleChangeBoolean: ge,
                  handleChangeSelect: De,
                  getValueByKey: E,
                  isSecret: Y,
                  label: R,
                  placeholder: V,
                  required: ie,
                  errors: Qe,
                  type: me,
                  isCreationMode: h,
                  prefix: Ne,
                  integrationId: e,
                  integrationType: n,
                  configuration: a,
                  readOnly: nn,
                  settings: Ie,
                  otherProps: fn
                }
              ) }, H);
            }
          )
        ]
      }
    ),
    !fe && /* @__PURE__ */ Ve.jsxs(b, { margin: "300 0 0 0", children: [
      /* @__PURE__ */ Ve.jsx(Gn, { onClick: mn, children: O }),
      !h && /* @__PURE__ */ Ve.jsx(
        We,
        {
          content: "The widget is used in automations",
          disabled: D,
          children: /* @__PURE__ */ Ve.jsx(
            Gn,
            {
              style: { marginLeft: 20 },
              icon: "trash",
              variant: "secondary",
              onClick: () => {
                e && l("settings:view:delete:requested", {
                  widgetId: e,
                  widgetType: n
                }), z(!0);
              },
              disabled: !D,
              isLoading: o?.isLoading,
              children: "Delete"
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ Ve.jsx(
      Yb,
      {
        isOpen: y,
        setIsOpen: z,
        confirmVariant: g ? "danger" : "primary",
        confirmLabel: "Yes",
        cancelLabel: "No",
        onCancel: () => {
          e && l("settings:view:delete:canceled", {
            widgetId: e,
            widgetType: n
          });
        },
        onConfirm: () => {
          if (e && l("settings:view:delete:confirmed", {
            widgetId: e,
            widgetType: n
          }), Vb(Ee.settings)) {
            const H = Ee.settings.find(
              ({ key: Y }) => Y === sf
            )?.value;
            H && d(H).catch((Y) => {
              console.warn("API-Token (deletion) error response", Y), i({
                title: "Something went wrong",
                text: "The deletion of the API-Token was not successful. Please have a look in Settings > Integrations > Api-Tokens to find your token and remove it manually.",
                icon: "exclamation-triangle-filled",
                severity: "warning"
              });
            });
          }
          an({
            variables: {
              id: e
            }
          });
        },
        children: /* @__PURE__ */ Ve.jsx(b, { children: g ? /* @__PURE__ */ Ve.jsxs(b, { gap: "400", children: [
          /* @__PURE__ */ Ve.jsx(
            pe,
            {
              size: 24,
              name: "exclamation-triangle-filled",
              color: "red.500"
            }
          ),
          /* @__PURE__ */ Ve.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ Ve.jsxs(P.Heading, { withMarginBottom: !0, children: [
              "By deleting the ",
              n,
              " integration, all links between Dixa and ",
              n,
              " are also deleted."
            ] }),
            /* @__PURE__ */ Ve.jsxs(P.Paragraph, { children: [
              "All data in ",
              n,
              " stays untouched."
            ] }),
            /* @__PURE__ */ Ve.jsxs(P.Paragraph, { children: [
              "Are you sure you want to delete the ",
              n,
              " ",
              'integration "',
              Ee.name,
              '"?'
            ] })
          ] })
        ] }) : /* @__PURE__ */ Ve.jsxs(Ve.Fragment, { children: [
          "Are you sure you want to delete the ",
          n,
          ' integration "',
          Ee.name,
          '"?'
        ] }) })
      }
    )
  ] });
}, ZB = ({
  configuration: e,
  integrationId: n,
  type: r,
  handleRedirect: i,
  showNotification: a,
  automationCouplingState: o,
  renderConditionsEditor: s
}) => /* @__PURE__ */ Ve.jsx(
  Jb.Provider,
  {
    value: {
      onError: (l, d) => console.warn(
        `Something went wrong with the partner widget settings of type ${r} and id ${n}`,
        l,
        d
      )
    },
    children: /* @__PURE__ */ Ve.jsx(
      Tx,
      {
        integrationId: n,
        type: r,
        configuration: e,
        showNotification: a,
        children: /* @__PURE__ */ Ve.jsx(
          vB,
          {
            configuration: e,
            integrationId: n,
            type: r,
            handleRedirect: i,
            showNotification: a,
            automationCouplingState: o,
            renderConditionsEditor: s
          }
        )
      }
    )
  }
), Bb = "__PairingContext__", r0 = globalThis[Bb] ?? (() => {
  const e = Qb({});
  return globalThis[Bb] = e, e;
})(), e5 = () => Bm(r0), n5 = ({
  value: e,
  children: n
}) => /* @__PURE__ */ Ve.jsx(r0.Provider, { value: e, children: n });
var ls = { exports: {} }, qb;
function bB() {
  if (qb) return ls.exports;
  qb = 1;
  var e = typeof Reflect == "object" ? Reflect : null, n = e && typeof e.apply == "function" ? e.apply : function(I, T, U) {
    return Function.prototype.apply.call(I, T, U);
  }, r;
  e && typeof e.ownKeys == "function" ? r = e.ownKeys : Object.getOwnPropertySymbols ? r = function(I) {
    return Object.getOwnPropertyNames(I).concat(Object.getOwnPropertySymbols(I));
  } : r = function(I) {
    return Object.getOwnPropertyNames(I);
  };
  function i($) {
    console && console.warn && console.warn($);
  }
  var a = Number.isNaN || function(I) {
    return I !== I;
  };
  function o() {
    o.init.call(this);
  }
  ls.exports = o, ls.exports.once = w, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._eventsCount = 0, o.prototype._maxListeners = void 0;
  var s = 10;
  function l($) {
    if (typeof $ != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof $);
  }
  Object.defineProperty(o, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return s;
    },
    set: function($) {
      if (typeof $ != "number" || $ < 0 || a($))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + $ + ".");
      s = $;
    }
  }), o.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, o.prototype.setMaxListeners = function(I) {
    if (typeof I != "number" || I < 0 || a(I))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + I + ".");
    return this._maxListeners = I, this;
  };
  function d($) {
    return $._maxListeners === void 0 ? o.defaultMaxListeners : $._maxListeners;
  }
  o.prototype.getMaxListeners = function() {
    return d(this);
  }, o.prototype.emit = function(I) {
    for (var T = [], U = 1; U < arguments.length; U++) T.push(arguments[U]);
    var Q = I === "error", J = this._events;
    if (J !== void 0)
      Q = Q && J.error === void 0;
    else if (!Q)
      return !1;
    if (Q) {
      var ae;
      if (T.length > 0 && (ae = T[0]), ae instanceof Error)
        throw ae;
      var X = new Error("Unhandled error." + (ae ? " (" + ae.message + ")" : ""));
      throw X.context = ae, X;
    }
    var B = J[I];
    if (B === void 0)
      return !1;
    if (typeof B == "function")
      n(B, this, T);
    else
      for (var O = B.length, q = C(B, O), U = 0; U < O; ++U)
        n(q[U], this, T);
    return !0;
  };
  function m($, I, T, U) {
    var Q, J, ae;
    if (l(T), J = $._events, J === void 0 ? (J = $._events = /* @__PURE__ */ Object.create(null), $._eventsCount = 0) : (J.newListener !== void 0 && ($.emit(
      "newListener",
      I,
      T.listener ? T.listener : T
    ), J = $._events), ae = J[I]), ae === void 0)
      ae = J[I] = T, ++$._eventsCount;
    else if (typeof ae == "function" ? ae = J[I] = U ? [T, ae] : [ae, T] : U ? ae.unshift(T) : ae.push(T), Q = d($), Q > 0 && ae.length > Q && !ae.warned) {
      ae.warned = !0;
      var X = new Error("Possible EventEmitter memory leak detected. " + ae.length + " " + String(I) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      X.name = "MaxListenersExceededWarning", X.emitter = $, X.type = I, X.count = ae.length, i(X);
    }
    return $;
  }
  o.prototype.addListener = function(I, T) {
    return m(this, I, T, !1);
  }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function(I, T) {
    return m(this, I, T, !0);
  };
  function u() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function f($, I, T) {
    var U = { fired: !1, wrapFn: void 0, target: $, type: I, listener: T }, Q = u.bind(U);
    return Q.listener = T, U.wrapFn = Q, Q;
  }
  o.prototype.once = function(I, T) {
    return l(T), this.on(I, f(this, I, T)), this;
  }, o.prototype.prependOnceListener = function(I, T) {
    return l(T), this.prependListener(I, f(this, I, T)), this;
  }, o.prototype.removeListener = function(I, T) {
    var U, Q, J, ae, X;
    if (l(T), Q = this._events, Q === void 0)
      return this;
    if (U = Q[I], U === void 0)
      return this;
    if (U === T || U.listener === T)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete Q[I], Q.removeListener && this.emit("removeListener", I, U.listener || T));
    else if (typeof U != "function") {
      for (J = -1, ae = U.length - 1; ae >= 0; ae--)
        if (U[ae] === T || U[ae].listener === T) {
          X = U[ae].listener, J = ae;
          break;
        }
      if (J < 0)
        return this;
      J === 0 ? U.shift() : S(U, J), U.length === 1 && (Q[I] = U[0]), Q.removeListener !== void 0 && this.emit("removeListener", I, X || T);
    }
    return this;
  }, o.prototype.off = o.prototype.removeListener, o.prototype.removeAllListeners = function(I) {
    var T, U, Q;
    if (U = this._events, U === void 0)
      return this;
    if (U.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : U[I] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete U[I]), this;
    if (arguments.length === 0) {
      var J = Object.keys(U), ae;
      for (Q = 0; Q < J.length; ++Q)
        ae = J[Q], ae !== "removeListener" && this.removeAllListeners(ae);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (T = U[I], typeof T == "function")
      this.removeListener(I, T);
    else if (T !== void 0)
      for (Q = T.length - 1; Q >= 0; Q--)
        this.removeListener(I, T[Q]);
    return this;
  };
  function h($, I, T) {
    var U = $._events;
    if (U === void 0)
      return [];
    var Q = U[I];
    return Q === void 0 ? [] : typeof Q == "function" ? T ? [Q.listener || Q] : [Q] : T ? N(Q) : C(Q, Q.length);
  }
  o.prototype.listeners = function(I) {
    return h(this, I, !0);
  }, o.prototype.rawListeners = function(I) {
    return h(this, I, !1);
  }, o.listenerCount = function($, I) {
    return typeof $.listenerCount == "function" ? $.listenerCount(I) : g.call($, I);
  }, o.prototype.listenerCount = g;
  function g($) {
    var I = this._events;
    if (I !== void 0) {
      var T = I[$];
      if (typeof T == "function")
        return 1;
      if (T !== void 0)
        return T.length;
    }
    return 0;
  }
  o.prototype.eventNames = function() {
    return this._eventsCount > 0 ? r(this._events) : [];
  };
  function C($, I) {
    for (var T = new Array(I), U = 0; U < I; ++U)
      T[U] = $[U];
    return T;
  }
  function S($, I) {
    for (; I + 1 < $.length; I++)
      $[I] = $[I + 1];
    $.pop();
  }
  function N($) {
    for (var I = new Array($.length), T = 0; T < I.length; ++T)
      I[T] = $[T].listener || $[T];
    return I;
  }
  function w($, I) {
    return new Promise(function(T, U) {
      function Q(ae) {
        $.removeListener(I, J), U(ae);
      }
      function J() {
        typeof $.removeListener == "function" && $.removeListener("error", Q), T([].slice.call(arguments));
      }
      z($, I, J, { once: !0 }), I !== "error" && y($, Q, { once: !0 });
    });
  }
  function y($, I, T) {
    typeof $.on == "function" && z($, "error", I, T);
  }
  function z($, I, T, U) {
    if (typeof $.on == "function")
      U.once ? $.once(I, T) : $.on(I, T);
    else if (typeof $.addEventListener == "function")
      $.addEventListener(I, function Q(J) {
        U.once && $.removeEventListener(I, Q), T(J);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof $);
  }
  return ls.exports;
}
var xB = bB();
function t5() {
  const e = new xB.EventEmitter();
  return e && typeof window < "u" ? window._partner = {
    events: e
  } : console.warn(
    "Initialization of partner-integration events was not successfull."
  ), e;
}
export {
  gw as GraphQLClientProvider,
  r0 as PairingContext,
  n5 as PairingProvider,
  JB as PartnerIntegrations,
  ZB as PartnerIntegrationsSettings,
  of as getWidgetDefinitions,
  t5 as initializePartnerEventEmitter,
  e5 as usePairing,
  XB as usePartnerIntegrationWidgetConfigurations,
  iB as useShopifyConfiguration
};
